// GENERATED FILE:
export default {
  "ab": {
    "CONTROL_FOREVER": "инагӡалатәуп еснагь",
    "CONTROL_REPEAT": "инагӡалатәуп %1 - нтә",
    "CONTROL_IF": "%1 акәзар",
    "CONTROL_ELSE": "акәымзар",
    "CONTROL_STOP": "иаанкылатәуп",
    "CONTROL_STOP_ALL": "зегьы",
    "CONTROL_STOP_THIS": "ари апрограмма",
    "CONTROL_STOP_OTHER": "анагӡаҩ егьырҭ ипрограммақәа",
    "CONTROL_WAIT": "иԥштәуп %1 секундк",
    "CONTROL_WAITUNTIL": "иԥштәуп %1 -нӡа",
    "CONTROL_REPEATUNTIL": "инагӡалатәуп %1 акәымзар",
    "CONTROL_WHILE": "%1 иашанаҵ",
    "CONTROL_FOREACH": "рыцԥхьаӡа %1 рзы %2 аҟны",
    "CONTROL_STARTASCLONE": "сара аклон ҳасабла саналаго",
    "CONTROL_CREATECLONEOF": "иаԥҵатәуп аклон %1",
    "CONTROL_CREATECLONEOF_MYSELF": "анагӡаҩ иеиԥшу",
    "CONTROL_DELETETHISCLONE": "ианыхтәуп ари аклон",
    "CONTROL_COUNTER": "аԥхьаӡага",
    "CONTROL_INCRCOUNTER": "аԥхьаӡага иазырҳатәуп",
    "CONTROL_CLEARCOUNTER": "ирыцқьатәуп аԥхьаӡага",
    "CONTROL_ALLATONCE": "зегьы иаразнак",
    "DATA_SETVARIABLETO": "%1 иаҭатәуп %2 ",
    "DATA_CHANGEVARIABLEBY": "иԥсахтәуп %1 %2 ала",
    "DATA_SHOWVARIABLE": "иаарԥштәуп аҽеиҭак %1",
    "DATA_HIDEVARIABLE": "иҵәахтәуп аҽеиҭак %1",
    "DATA_ADDTOLIST": "иацҵатәуп %1 %2 ахь  ",
    "DATA_DELETEOFLIST": "ианыхтәуп %1 %2 аҟынтәи ",
    "DATA_DELETEALLOFLIST": "ианыхтәуп зегьы %1 аҟынтәи ",
    "DATA_INSERTATLIST": "%3 аҟны ибжьаргылатәуп %1 %2 аҭыԥан  ",
    "DATA_REPLACEITEMOFLIST": "%2 аҟны иԥсахтәуп аелемент %1 %3 ала  ",
    "DATA_ITEMOFLIST": "аелемент %1 %2 аҟны",
    "DATA_ITEMNUMOFLIST": "аелемент %1 № %2 аҟны",
    "DATA_LENGTHOFLIST": "асиа %1 аура",
    "DATA_LISTCONTAINSITEM": "%1 иаҵанакуама %2?",
    "DATA_SHOWLIST": "иаарԥштәуп асиа %1",
    "DATA_HIDELIST": "иҵәахтәуп асиа %1",
    "DATA_INDEX_ALL": "зегьы",
    "DATA_INDEX_LAST": "аҵыхәтәантәи",
    "DATA_INDEX_RANDOM": "иарбанзаалакь",
    "EVENT_WHENFLAGCLICKED": "%1 ҳанақәыӷәӷәалакь",
    "EVENT_WHENTHISSPRITECLICKED": "анагӡаҩ ҳаниқәыӷәӷәалакь",
    "EVENT_WHENSTAGECLICKED": "асцена ҳанақәыӷәӷәалакь",
    "EVENT_WHENTOUCHINGOBJECT": "ари анагӡаҩ %1 данадкьысло",
    "EVENT_WHENBROADCASTRECEIVED": " %1 аус арура",
    "EVENT_WHENBACKDROPSWITCHESTO": "аҿаԥшыра %1 ала аҽанаԥсахлакь",
    "EVENT_WHENGREATERTHAN": "%1 > %2 анакәу",
    "EVENT_WHENGREATERTHAN_TIMER": "атаимер",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "абжьы адура",
    "EVENT_BROADCAST": "идәықәҵатәуп %1  ",
    "EVENT_BROADCASTANDWAIT": "идәықәҵатәуп %1 нас иԥштәуп",
    "EVENT_WHENKEYPRESSED": "аклавиша %1 ҳанақәыӷәӷәалакь",
    "EVENT_WHENKEYPRESSED_SPACE": "абжьажьга",
    "EVENT_WHENKEYPRESSED_LEFT": "ахыц арӷьарахь",
    "EVENT_WHENKEYPRESSED_RIGHT": "ахыц армарахь",
    "EVENT_WHENKEYPRESSED_DOWN": "ахыц алада",
    "EVENT_WHENKEYPRESSED_UP": "ахыц аҩада",
    "EVENT_WHENKEYPRESSED_ANY": "иарбанзаалакь",
    "LOOKS_SAYFORSECS": "иҳәалатәуп %1 %2 секундк  ",
    "LOOKS_SAY": "иҳәатәуп %1 ",
    "LOOKS_HELLO": "Салам!",
    "LOOKS_THINKFORSECS": "ахәыцра %1 %2  секундк ",
    "LOOKS_THINK": "ахәыцра %1 ",
    "LOOKS_HMM": "М-м-м...",
    "LOOKS_SHOW": "ацәырҵра",
    "LOOKS_HIDE": "аҽыҵәахра",
    "LOOKS_HIDEALLSPRITES": "иҵәахтәуп анагӡаҩцәа зегьы",
    "LOOKS_EFFECT_COLOR": "аԥштәы",
    "LOOKS_EFFECT_FISHEYE": "аԥсыӡ аблақәа",
    "LOOKS_EFFECT_WHIRL": "акьаҳәхара",
    "LOOKS_EFFECT_PIXELATE": "апиксельқәа рыԥсахра",
    "LOOKS_EFFECT_MOSAIC": "амозаика",
    "LOOKS_EFFECT_BRIGHTNESS": "ажжара",
    "LOOKS_EFFECT_GHOST": "алаԥшҵашәара",
    "LOOKS_CHANGEEFFECTBY": "иԥсахтәуп аеффект %1  %2 ала  ",
    "LOOKS_SETEFFECTTO": "иқәыргылатәуп аеффект %1 %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "иқәгатәуп аграфикатә еффектқәа",
    "LOOKS_CHANGESIZEBY": "иԥсахтәуп ашәагаа %1 ала",
    "LOOKS_SETSIZETO": "иқәыргылатәуп ашәагаа  %1 % ",
    "LOOKS_SIZE": "ашәагаа",
    "LOOKS_CHANGESTRETCHBY": "иԥсахтәуп арххара %1 ала ",
    "LOOKS_SETSTRETCHTO": "иқәыргылатәуп арххара %1",
    "LOOKS_SWITCHCOSTUMETO": "иԥсахтәуп акостиум %1 ала",
    "LOOKS_NEXTCOSTUME": "анаҩстәи акостиум",
    "LOOKS_SWITCHBACKDROPTO": "иԥсахтәуп аҿаԥшыра %1 ала",
    "LOOKS_GOTOFRONTBACK": "ииастәуп %1 аҿыгҳара ахь ",
    "LOOKS_GOTOFRONTBACK_FRONT": "аԥхьаҟатәи",
    "LOOKS_GOTOFRONTBACK_BACK": "ашьҭахьҟатәи",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ииастәуп %1 %2 ҿыгҳарак ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ԥхьаҟа",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "шьҭахьҟа",
    "LOOKS_BACKDROPNUMBERNAME": "аҿаԥшыра %1 ",
    "LOOKS_COSTUMENUMBERNAME": "акостиум %1",
    "LOOKS_NUMBERNAME_NUMBER": "аномер",
    "LOOKS_NUMBERNAME_NAME": "ахьӡ",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "иԥсахтәуп аҿаԥшыра %1 ала  нас иԥштәуп ",
    "LOOKS_NEXTBACKDROP_BLOCK": "анаҩстәи аҿаԥшыра",
    "LOOKS_NEXTBACKDROP": "анаҩстәи аҿаԥшыра",
    "LOOKS_PREVIOUSBACKDROP": "аԥхьатәи аҿаԥшыра",
    "LOOKS_RANDOMBACKDROP": "иарбанзаалакь аҿаԥшыра",
    "MOTION_MOVESTEPS": "ицатәуп %1 шьаҿак",
    "MOTION_TURNLEFT": "иргьежьтәуп  %1 %2 градус рыла ",
    "MOTION_TURNRIGHT": "иргьежьтәуп %1 %2 градус рыла ",
    "MOTION_POINTINDIRECTION": "инарҳәтәуп %1 ахь",
    "MOTION_POINTTOWARDS": "%1 ахь инаҳәтәуп",
    "MOTION_POINTTOWARDS_POINTER": "аҳәынаԥ арбага",
    "MOTION_POINTTOWARDS_RANDOM": "машәыршақәтәи ахырхарҭа",
    "MOTION_GOTO": "ииастәуп %1 ахь",
    "MOTION_GOTO_POINTER": "аҳәынаԥ арбага",
    "MOTION_GOTO_RANDOM": "иарбанзаалакь апозициа",
    "MOTION_GOTOXY": "ииастәуп x: %1 y: %2 ахь ",
    "MOTION_GLIDESECSTOXY": "иқәҵәраатәуп x: %2 y: %3 ахь %1 секундк ",
    "MOTION_GLIDETO": "иқәҵәраатәуп %2 ахь %1 секундк  ",
    "MOTION_GLIDETO_POINTER": "аҳәынаԥ арбага",
    "MOTION_GLIDETO_RANDOM": "иарбанзаалакь апозициа",
    "MOTION_CHANGEXBY": "иԥсахтәуп x %1 ала   ",
    "MOTION_SETX": "иқәыргылатәуп x %1 аҟны  ",
    "MOTION_CHANGEYBY": "иԥсахтәуп y %1 ала ",
    "MOTION_SETY": "иқәыргылатәуп y %1 аҟны ",
    "MOTION_IFONEDGEBOUNCE": "аҵкар иадкьыслозар, иадԥатәуп",
    "MOTION_SETROTATIONSTYLE": "иқәыргылатәуп аргьежьра астиль %1 ",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "армарахь-арӷьарахь",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "иргьежьтәӡам",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "иргьежьтәуп",
    "MOTION_XPOSITION": "x апозициа",
    "MOTION_YPOSITION": "y апозициа",
    "MOTION_DIRECTION": "ахырхарҭа",
    "MOTION_SCROLLRIGHT": "иҭаргежьтәуп арӷьарахь %1",
    "MOTION_SCROLLUP": "иҭаргежьтәуп хыхь %1",
    "MOTION_ALIGNSCENE": "еиҟаратәтәуп асцена %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ҵаҟа-армарахьтәи",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ҵаҟа-арӷьарахьтәи",
    "MOTION_ALIGNSCENE_MIDDLE": "агәҭа",
    "MOTION_ALIGNSCENE_TOPLEFT": "хыхьтәи-армарахьтәи",
    "MOTION_ALIGNSCENE_TOPRIGHT": "хыхьтәи-арӷьарахьтәи",
    "MOTION_XSCROLL": "x ала аҭаргьежьра",
    "MOTION_YSCROLL": "y ала аҭаргьежьра",
    "MOTION_STAGE_SELECTED": "Асцена алхуп: иҟам аиҭаҵратә блокқәа",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "иарбанзаалакь %1 -и %2 -и рыбжьара  ",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 - еи  %2 - еи",
    "OPERATORS_OR": "%1 ма %2",
    "OPERATORS_NOT": "%1 акәӡам",
    "OPERATORS_JOIN": "еиԥшьтәуп %1 %2 ",
    "OPERATORS_JOIN_APPLE": "аҵәа",
    "OPERATORS_JOIN_BANANA": "абанан",
    "OPERATORS_LETTEROF": "асимвол %1 %2 аҟны",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "%1 аура",
    "OPERATORS_CONTAINS": "%1 иаҵанакуама %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "ихаргьежьтәуп %1 ",
    "OPERATORS_MATHOP": "%1 %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "еиҵоу еибгоу",
    "OPERATORS_MATHOP_CEILING": "еиҳау еибгоу",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "еиҿкаатәуп %1",
    "SENSING_TOUCHINGOBJECT": "%1 иадкьыслома?  ",
    "SENSING_TOUCHINGOBJECT_POINTER": "аҳәынаԥ арбага",
    "SENSING_TOUCHINGOBJECT_EDGE": "аҵкар",
    "SENSING_TOUCHINGCOLOR": "иадкьыслома аԥштәы %1? ",
    "SENSING_COLORISTOUCHINGCOLOR": "аԥштәы %1 иадкьыслома %2?  ",
    "SENSING_DISTANCETO": "%1 аҟынӡа ибжьоу",
    "SENSING_DISTANCETO_POINTER": "аҳәынаԥ арбага",
    "SENSING_ASKANDWAIT": "иазҵаатәуп %1 нас иԥштәуп ",
    "SENSING_ASK_TEXT": "Ишәыхьӡуи шәара?",
    "SENSING_ANSWER": "аҭак",
    "SENSING_KEYPRESSED": "аклавиша %1  иақәыӷәӷәома? ",
    "SENSING_MOUSEDOWN": "аҳәынаԥ иақәыӷәӷәома?",
    "SENSING_MOUSEX": "аҳәынаԥ x ала",
    "SENSING_MOUSEY": "аҳәынаԥ y ала",
    "SENSING_SETDRAGMODE": "иқәыргылатәуп аиагара арежим %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "иауеит",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "иауам",
    "SENSING_LOUDNESS": "абжьы адура",
    "SENSING_LOUD": "абжьы дуума?",
    "SENSING_TIMER": "атаимер",
    "SENSING_RESETTIMER": "атаимер рҿыцтәуп",
    "SENSING_OF": "%1  %2 аҟынтәи",
    "SENSING_OF_XPOSITION": "x аҭыԥ",
    "SENSING_OF_YPOSITION": "y аҭыԥ",
    "SENSING_OF_DIRECTION": "ахырхарҭа",
    "SENSING_OF_COSTUMENUMBER": "акостиум №",
    "SENSING_OF_COSTUMENAME": "акостиум ахьӡ",
    "SENSING_OF_SIZE": "ашәагаа",
    "SENSING_OF_VOLUME": "абжьы адура",
    "SENSING_OF_BACKDROPNUMBER": "аҿаԥшыра №",
    "SENSING_OF_BACKDROPNAME": "аҿаԥшыра ахьӡ",
    "SENSING_OF_STAGE": "Асцена",
    "SENSING_CURRENT": "уажәтәи %1 ",
    "SENSING_CURRENT_YEAR": "ашықәс",
    "SENSING_CURRENT_MONTH": "амза",
    "SENSING_CURRENT_DATE": "арыцхә",
    "SENSING_CURRENT_DAYOFWEEK": "амчыбжь амш",
    "SENSING_CURRENT_HOUR": "асааҭ",
    "SENSING_CURRENT_MINUTE": "аминуҭ",
    "SENSING_CURRENT_SECOND": "асекунд",
    "SENSING_DAYSSINCE2000": "амшқәа 2000 ш. инаркны ",
    "SENSING_USERNAME": "ахархәаҩ ихьӡ",
    "SENSING_USERID": "Ахархәаҩ ID",
    "SOUND_PLAY": "иаҿактәуп абжьы %1",
    "SOUND_PLAYUNTILDONE": "иргатәуп абжьы %1 инҵәаанӡа ",
    "SOUND_STOPALLSOUNDS": "иаанкылатәуп абжьқәа зегьы",
    "SOUND_SETEFFECTO": "иқәыргылатәуп аеффект %1  %2 аҟны  ",
    "SOUND_CHANGEEFFECTBY": "иԥсахтәуп  %1 аеффект %2 ала  ",
    "SOUND_CLEAREFFECTS": "иқәгатәуп абжьы аеффектқәа",
    "SOUND_EFFECTS_PITCH": "атемп",
    "SOUND_EFFECTS_PAN": "абжьгара армарахь/арӷьарахь",
    "SOUND_CHANGEVOLUMEBY": "иԥсахтәуп абжьы %1 ала ",
    "SOUND_SETVOLUMETO": "иқәыргылатәуп абжьы адура %1%",
    "SOUND_VOLUME": "абжьы адура",
    "SOUND_RECORD": "аҭаҩра...",
    "CATEGORY_MOTION": "Аиҭаҵра",
    "CATEGORY_LOOKS": "Аԥшра-асахьа",
    "CATEGORY_SOUND": "Абжьы",
    "CATEGORY_EVENTS": "Ахҭысқәа",
    "CATEGORY_CONTROL": "Аконтроль",
    "CATEGORY_SENSING": "Асенсорқәа",
    "CATEGORY_OPERATORS": "Аоператорқәа",
    "CATEGORY_VARIABLES": "Аҽеиҭакқәа",
    "CATEGORY_MYBLOCKS": "Сара сблокқәа",
    "DUPLICATE": "Адубликат",
    "DELETE": "Ианыхтәуп",
    "ADD_COMMENT": "Иацҵатәуп акомментари",
    "REMOVE_COMMENT": "Ианыхтәуп акомментари",
    "DELETE_BLOCK": "Ианыхтәуп аблок",
    "DELETE_X_BLOCKS": "Ианыхтәуп %1 блокк ",
    "DELETE_ALL_BLOCKS": "Ианыхтәума аблокқәа %1 зегьы?",
    "CLEAN_UP": "Ирыцқьатәуп аблокқәа",
    "HELP": "Ацхыраара",
    "UNDO": "Иаҟәыхтәуп",
    "REDO": "Ирхынҳәтәуп",
    "EDIT_PROCEDURE": "Аредакциазура",
    "SHOW_PROCEDURE_DEFINITION": "Ииастәуп аиқәыршәарахь",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Иҳәатәуп џьара акы...",
    "COLOUR_HUE_LABEL": "Аԥштәы",
    "COLOUR_SATURATION_LABEL": "Аԥштәылгазаара",
    "COLOUR_BRIGHTNESS_LABEL": "Ажжара",
    "CHANGE_VALUE_TITLE": "Иԥсахтәуп аҵакы:",
    "RENAME_VARIABLE": "Аҽеиҭак ахьӡ ԥсахтәуп",
    "RENAME_VARIABLE_TITLE": "Аҽеиҭакқәа \"%1\" зегь рыхьӡ ԥсахтәуп аҟны:",
    "RENAME_VARIABLE_MODAL_TITLE": "Аҽеиҭак ахьӡ ԥсахтәуп",
    "NEW_VARIABLE": "Иаԥҵатәуп аҽеиҭак",
    "NEW_VARIABLE_TITLE": "Аҽеиҭак ҿыц ахьӡ:",
    "VARIABLE_MODAL_TITLE": "Аҽеиҭак ҿыц",
    "VARIABLE_ALREADY_EXISTS": "Аҽеиҭак  ахьӡ \"%1\" змоу ыҟоуп.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Аҽеиҭак ахьӡ \"%1\" змоу ыҟоуп аҽеиҭакқәа ртип \"%2\" аҟны.  ",
    "DELETE_VARIABLE_CONFIRMATION": "Ианыхтәума алахәрақәа %1  аҽеиҭак \"%2\" азы?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Иауам аҽеиҭак \"%1\" аныхра, избанзар иара афункциа \"%2\" ашьақәыргылара иахәҭакуп ",
    "DELETE_VARIABLE": "Ианыхтәуп аҽеиҭак \"%1\"",
    "NEW_PROCEDURE": "Иаԥҵатәуп аблок",
    "PROCEDURE_ALREADY_EXISTS": "Апроцедура ахьӡ \"%1\" змоу ыҟоуп.",
    "PROCEDURE_DEFAULT_NAME": "аблок ахьӡ",
    "PROCEDURE_USED": "Аблок анышәхаанӡа, ианышәх иара ахархәара ахьамаз аблокқәа зегьы.",
    "NEW_LIST": "Иаԥҵатәуп асиа",
    "NEW_LIST_TITLE": "Асиа ҿыц ахьӡ:",
    "LIST_MODAL_TITLE": "Асиа ҿыц",
    "LIST_ALREADY_EXISTS": "Асиа ахьӡ \"%1\" змоу ыҟоуп.",
    "RENAME_LIST_TITLE": "Асиақәа \"%1\" зегьы рыхьӡ ԥсахтәуп аҟны:",
    "RENAME_LIST_MODAL_TITLE": "Асиа ахьӡ ԥсахтәуп",
    "DEFAULT_LIST_ITEM": "џьара акы",
    "DELETE_LIST": "Ианыхтәуп асиа \"%1\"",
    "RENAME_LIST": "Асиа ахьӡ ԥсахтәуп",
    "NEW_BROADCAST_MESSAGE": "Ацҳамҭа ҿыц",
    "NEW_BROADCAST_MESSAGE_TITLE": "Ацҳамҭа ахьӡ ҿыц:",
    "BROADCAST_MODAL_TITLE": "Ацҳамҭа ҿыц",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "ацҳамҭа1"
  },
  "af": {
    "CONTROL_FOREVER": "vir ewig",
    "CONTROL_REPEAT": "herhaal %1 keer",
    "CONTROL_IF": "indien %1 dan",
    "CONTROL_ELSE": "anders",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "al",
    "CONTROL_STOP_THIS": "hierdie skrip",
    "CONTROL_STOP_OTHER": "ander skripte in sprite",
    "CONTROL_WAIT": "wag %1 sekondes",
    "CONTROL_WAITUNTIL": "wag totdat %1",
    "CONTROL_REPEATUNTIL": "herhaal totdat %1",
    "CONTROL_WHILE": "terwyl %1",
    "CONTROL_FOREACH": "vir elke %1 in %2 ",
    "CONTROL_STARTASCLONE": "wanneer ek as 'n kloon begin",
    "CONTROL_CREATECLONEOF": "skep kloon van %1",
    "CONTROL_CREATECLONEOF_MYSELF": "myself",
    "CONTROL_DELETETHISCLONE": "skrap hierdie kloon ",
    "CONTROL_COUNTER": "teller",
    "CONTROL_INCRCOUNTER": "inkrement teller",
    "CONTROL_CLEARCOUNTER": "herstel teller",
    "CONTROL_ALLATONCE": "alles op een slag",
    "DATA_SETVARIABLETO": "stel %1 op %2",
    "DATA_CHANGEVARIABLEBY": "verander %1 met %2",
    "DATA_SHOWVARIABLE": "vertoon veranderlike %1",
    "DATA_HIDEVARIABLE": "verberg veranderlike %1 ",
    "DATA_ADDTOLIST": "voeg %1 by %2",
    "DATA_DELETEOFLIST": "skrap %1 van %2",
    "DATA_DELETEALLOFLIST": "skrap alles van %1",
    "DATA_INSERTATLIST": "voeg %1 in by %2 van %3",
    "DATA_REPLACEITEMOFLIST": "vervang item %1 van %2 met %3",
    "DATA_ITEMOFLIST": "item %1 van %2",
    "DATA_ITEMNUMOFLIST": "item # van %1 in %2",
    "DATA_LENGTHOFLIST": "lengte van %1",
    "DATA_LISTCONTAINSITEM": "%1 bevat %2?",
    "DATA_SHOWLIST": "vertoon lys %1",
    "DATA_HIDELIST": "verberg lys %1",
    "DATA_INDEX_ALL": "al",
    "DATA_INDEX_LAST": "laaste",
    "DATA_INDEX_RANDOM": "ewekansig",
    "EVENT_WHENFLAGCLICKED": "wanneer %1 gekliek is",
    "EVENT_WHENTHISSPRITECLICKED": "wanneer hierdie sprite gekliek is",
    "EVENT_WHENSTAGECLICKED": "wanneer verhoog gekliek is",
    "EVENT_WHENTOUCHINGOBJECT": "wanneer hierdie sprite %1 raak",
    "EVENT_WHENBROADCASTRECEIVED": "wanneer ek %1 ontvang",
    "EVENT_WHENBACKDROPSWITCHESTO": "wanneer agtergrond na %1 verander",
    "EVENT_WHENGREATERTHAN": "wanneer %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "tydhouer",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "luidheid",
    "EVENT_BROADCAST": "saai %1 uit",
    "EVENT_BROADCASTANDWAIT": "saai %1 uit en wag",
    "EVENT_WHENKEYPRESSED": "wanneer %1 sleutel gedruk is",
    "EVENT_WHENKEYPRESSED_SPACE": "spasie",
    "EVENT_WHENKEYPRESSED_LEFT": "linkerpyl",
    "EVENT_WHENKEYPRESSED_RIGHT": "regterpyl",
    "EVENT_WHENKEYPRESSED_DOWN": "afwaartsepyl",
    "EVENT_WHENKEYPRESSED_UP": "opwaartsepyl",
    "EVENT_WHENKEYPRESSED_ANY": "enige",
    "LOOKS_SAYFORSECS": "sê %1 vir %2 sekondes",
    "LOOKS_SAY": "sê %1",
    "LOOKS_HELLO": "Hallo!",
    "LOOKS_THINKFORSECS": "dink %1 vir %2 sekondes",
    "LOOKS_THINK": "dink %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "vertoon",
    "LOOKS_HIDE": "verberg",
    "LOOKS_HIDEALLSPRITES": "verberg al sprites",
    "LOOKS_EFFECT_COLOR": "kleur",
    "LOOKS_EFFECT_FISHEYE": "visoog",
    "LOOKS_EFFECT_WHIRL": "dwarrel",
    "LOOKS_EFFECT_PIXELATE": "verdeel in beeldelemente",
    "LOOKS_EFFECT_MOSAIC": "mosaïek",
    "LOOKS_EFFECT_BRIGHTNESS": "helderheid",
    "LOOKS_EFFECT_GHOST": "spook",
    "LOOKS_CHANGEEFFECTBY": "verander %1 effek met %2",
    "LOOKS_SETEFFECTTO": "stel %1 effek op %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "verwyder grafiese effekte",
    "LOOKS_CHANGESIZEBY": "verander grootte met %1",
    "LOOKS_SETSIZETO": "stel grootte op %1 %",
    "LOOKS_SIZE": "grootte",
    "LOOKS_CHANGESTRETCHBY": "verander strek met %1",
    "LOOKS_SETSTRETCHTO": "stel strek op %1 %",
    "LOOKS_SWITCHCOSTUMETO": "ruil kostuum na %1",
    "LOOKS_NEXTCOSTUME": "volgende kostuum",
    "LOOKS_SWITCHBACKDROPTO": "ruil agtergrond na %1",
    "LOOKS_GOTOFRONTBACK": "gaan na %1 laag",
    "LOOKS_GOTOFRONTBACK_FRONT": "voorkant",
    "LOOKS_GOTOFRONTBACK_BACK": "agterkant",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "gaan %1 %2 lae",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "vorentoe",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "agtertoe",
    "LOOKS_BACKDROPNUMBERNAME": "agtergrond %1",
    "LOOKS_COSTUMENUMBERNAME": "kostuum %1",
    "LOOKS_NUMBERNAME_NUMBER": "nommer",
    "LOOKS_NUMBERNAME_NAME": "naam",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "ruil agtergrond na %1 en wag",
    "LOOKS_NEXTBACKDROP_BLOCK": "volgende agtergrond",
    "LOOKS_NEXTBACKDROP": "volgende agtergrond",
    "LOOKS_PREVIOUSBACKDROP": "vorige agtergrond",
    "LOOKS_RANDOMBACKDROP": "ewekansige agtergrond",
    "MOTION_MOVESTEPS": "beweeg %1 tree",
    "MOTION_TURNLEFT": "draai %1 %2 grade",
    "MOTION_TURNRIGHT": "draai %1 %2 grade",
    "MOTION_POINTINDIRECTION": "wys na rigting %1",
    "MOTION_POINTTOWARDS": "wys na %1",
    "MOTION_POINTTOWARDS_POINTER": "muiswyser",
    "MOTION_POINTTOWARDS_RANDOM": "ewekansige rigting",
    "MOTION_GOTO": "gaan na %1",
    "MOTION_GOTO_POINTER": "muiswyser",
    "MOTION_GOTO_RANDOM": "ewekansige posisie",
    "MOTION_GOTOXY": "gaan na x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "gly %1 sekondes na x: %2 y: %3",
    "MOTION_GLIDETO": "gly %1 sekondes na %2",
    "MOTION_GLIDETO_POINTER": "muiswyser",
    "MOTION_GLIDETO_RANDOM": "ewekansige posisie",
    "MOTION_CHANGEXBY": "verander x met %1",
    "MOTION_SETX": "stel x op %1",
    "MOTION_CHANGEYBY": "verander y met %1",
    "MOTION_SETY": "stel y op %1",
    "MOTION_IFONEDGEBOUNCE": "as rand bereik is, bons",
    "MOTION_SETROTATIONSTYLE": "stel rotasiestyl %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "links-regs",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "moenie draai nie",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "rondom",
    "MOTION_XPOSITION": "x posisie",
    "MOTION_YPOSITION": "y posisie",
    "MOTION_DIRECTION": "rigting",
    "MOTION_SCROLLRIGHT": "rol regs %1",
    "MOTION_SCROLLUP": "rol op %1",
    "MOTION_ALIGNSCENE": "belyn toneel %1 ",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "links onder",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "regs onder",
    "MOTION_ALIGNSCENE_MIDDLE": "middel",
    "MOTION_ALIGNSCENE_TOPLEFT": "links bo",
    "MOTION_ALIGNSCENE_TOPRIGHT": "regs bo",
    "MOTION_XSCROLL": "x rol",
    "MOTION_YSCROLL": "y rol",
    "MOTION_STAGE_SELECTED": "Geselekteerde verhoog: geen bewegingsblokke ",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "kies ewekansige %1 tot %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 en %2",
    "OPERATORS_OR": "%1 of %2",
    "OPERATORS_NOT": "nie %1",
    "OPERATORS_JOIN": "verbind %1 %2 ",
    "OPERATORS_JOIN_APPLE": "appel",
    "OPERATORS_JOIN_BANANA": "piesang",
    "OPERATORS_LETTEROF": "letter %1 van %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "lengte van %1",
    "OPERATORS_CONTAINS": "%1 bevat %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "rond %1 af",
    "OPERATORS_MATHOP": "%1 van %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "afrond",
    "OPERATORS_MATHOP_CEILING": "oprond",
    "OPERATORS_MATHOP_SQRT": "vierkantswortel",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definieer %1",
    "SENSING_TOUCHINGOBJECT": "raak %1",
    "SENSING_TOUCHINGOBJECT_POINTER": "muiswyser",
    "SENSING_TOUCHINGOBJECT_EDGE": "rand",
    "SENSING_TOUCHINGCOLOR": "raak kleur %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "kleur %1 raak aan %2",
    "SENSING_DISTANCETO": "afstand na %1",
    "SENSING_DISTANCETO_POINTER": "muiswyser",
    "SENSING_ASKANDWAIT": "vra %1 en wag",
    "SENSING_ASK_TEXT": "Wat is jou naam?",
    "SENSING_ANSWER": "antwoord",
    "SENSING_KEYPRESSED": "sleutel %1 gedruk?",
    "SENSING_MOUSEDOWN": "muis af?",
    "SENSING_MOUSEX": "muis x",
    "SENSING_MOUSEY": "muis y",
    "SENSING_SETDRAGMODE": "stel sleep modus %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "sleepbaar",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "nie sleepbaar",
    "SENSING_LOUDNESS": "luidheid",
    "SENSING_LOUD": "hard?",
    "SENSING_TIMER": "tydhouer",
    "SENSING_RESETTIMER": "herstel tydhouer",
    "SENSING_OF": "%1 van %2",
    "SENSING_OF_XPOSITION": "x posisie",
    "SENSING_OF_YPOSITION": "y posisie",
    "SENSING_OF_DIRECTION": "rigting",
    "SENSING_OF_COSTUMENUMBER": "kostuum #",
    "SENSING_OF_COSTUMENAME": "kostuumnaam",
    "SENSING_OF_SIZE": "grootte",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "agtergrond #",
    "SENSING_OF_BACKDROPNAME": "agtergrondnaam",
    "SENSING_OF_STAGE": "Verhoog",
    "SENSING_CURRENT": "huidige %1",
    "SENSING_CURRENT_YEAR": "jaar",
    "SENSING_CURRENT_MONTH": "maand",
    "SENSING_CURRENT_DATE": "datum",
    "SENSING_CURRENT_DAYOFWEEK": "dag van die week",
    "SENSING_CURRENT_HOUR": "uur",
    "SENSING_CURRENT_MINUTE": "minuut",
    "SENSING_CURRENT_SECOND": "sekonde",
    "SENSING_DAYSSINCE2000": "dae sedert 2000",
    "SENSING_USERNAME": "gebruikersnaam",
    "SENSING_USERID": "gebruikers id",
    "SOUND_PLAY": "begin klank %1",
    "SOUND_PLAYUNTILDONE": "speel klank %1 tot voltooi",
    "SOUND_STOPALLSOUNDS": "stop alle klanke",
    "SOUND_SETEFFECTO": "stel %1 effek op %2",
    "SOUND_CHANGEEFFECTBY": "verander %1 effek met %2",
    "SOUND_CLEAREFFECTS": "verwyder klank effekte",
    "SOUND_EFFECTS_PITCH": "toonhoogte",
    "SOUND_EFFECTS_PAN": "swenk links/regs",
    "SOUND_CHANGEVOLUMEBY": "verander volume met %1",
    "SOUND_SETVOLUMETO": "stel volume op %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "neem op...",
    "CATEGORY_MOTION": "Beweging",
    "CATEGORY_LOOKS": "Voorkoms",
    "CATEGORY_SOUND": "Klank",
    "CATEGORY_EVENTS": "Gebeurtenisse",
    "CATEGORY_CONTROL": "Beheer",
    "CATEGORY_SENSING": "Aanvoeling",
    "CATEGORY_OPERATORS": "Operateurs",
    "CATEGORY_VARIABLES": "Veranderlikes",
    "CATEGORY_MYBLOCKS": "My Blokke",
    "DUPLICATE": "Dupliseer",
    "DELETE": "Skrap",
    "ADD_COMMENT": "Voeg Kommentaar By",
    "REMOVE_COMMENT": "Verwyder Kommentaar",
    "DELETE_BLOCK": "Skrap Blok",
    "DELETE_X_BLOCKS": "Skrap %1 Blokke",
    "DELETE_ALL_BLOCKS": "Skrap al %1 blokke?",
    "CLEAN_UP": "Maak Blokke skoon",
    "HELP": "Help",
    "UNDO": "Ontdoen",
    "REDO": "Herdoen",
    "EDIT_PROCEDURE": "Redigeer",
    "SHOW_PROCEDURE_DEFINITION": "Gaan na definisie",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Sê iets...",
    "COLOUR_HUE_LABEL": "Kleur",
    "COLOUR_SATURATION_LABEL": "Versadiging",
    "COLOUR_BRIGHTNESS_LABEL": "Helderheid",
    "CHANGE_VALUE_TITLE": "Verander waarde:",
    "RENAME_VARIABLE": "Hernoem veranderlike",
    "RENAME_VARIABLE_TITLE": "Hernoem al \"%1\" veranderlikes na:",
    "RENAME_VARIABLE_MODAL_TITLE": "Hernoem Veranderlike",
    "NEW_VARIABLE": "Skep ’n Veranderlike",
    "NEW_VARIABLE_TITLE": "Nuwe veranderlike naam:",
    "VARIABLE_MODAL_TITLE": "Nuwe veranderlike",
    "VARIABLE_ALREADY_EXISTS": "'n Veranderlike met die naam \"%1\" bestaan reeds.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "'n Veranderlike met die naam \"%1\" bestaan reeds vir 'n ander veranderlike van tipe \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Skrap %1 gebruike van die \"%2\" veranderlike?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Kan nie die veranderlike \"%1\" skrap nie want dit is deel van die definisie van die funksie \"%2\"",
    "DELETE_VARIABLE": "Skrap die \"%1\" veranderlike",
    "NEW_PROCEDURE": "Skep ’n Blok",
    "PROCEDURE_ALREADY_EXISTS": "'n Prosedure genaamd \"%1\" bestaan reeds.",
    "PROCEDURE_DEFAULT_NAME": "bloknaam",
    "PROCEDURE_USED": "Om 'n blok definisie te skrap, verwyder eers al die gebruike van die blok",
    "NEW_LIST": "Skep ’n Lys",
    "NEW_LIST_TITLE": "Nuwe lysnaam:",
    "LIST_MODAL_TITLE": "Nuwe Lys",
    "LIST_ALREADY_EXISTS": "'n Lys met die naam \"%1\" bestaan reeds.",
    "RENAME_LIST_TITLE": "Hernoem alle \"%1\" lyste na:",
    "RENAME_LIST_MODAL_TITLE": "Hernoem Lys",
    "DEFAULT_LIST_ITEM": "voorwerp",
    "DELETE_LIST": "Skrap die \"%1\" lys",
    "RENAME_LIST": "Hernoem lys",
    "NEW_BROADCAST_MESSAGE": "Nuwe boodskap",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nuwe boodskapnaam:",
    "BROADCAST_MODAL_TITLE": "Nuwe Boodskap",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "boodskap1"
  },
  "ar": {
    "CONTROL_FOREVER": "كرِّر باستمرار",
    "CONTROL_REPEAT": "كرِّر %1 مرة",
    "CONTROL_IF": "إذا %1",
    "CONTROL_ELSE": "وإلا",
    "CONTROL_STOP": "أوقف",
    "CONTROL_STOP_ALL": "الكل",
    "CONTROL_STOP_THIS": "المقطع البرمجي الحالي",
    "CONTROL_STOP_OTHER": "المقاطع الأخرى في الكائن",
    "CONTROL_WAIT": "انتظر %1 ثانية",
    "CONTROL_WAITUNTIL": "انتظر حتى %1",
    "CONTROL_REPEATUNTIL": "كرِّر حتى %1",
    "CONTROL_WHILE": "طالما %1",
    "CONTROL_FOREACH": "من أجل %1 من %2",
    "CONTROL_STARTASCLONE": "عندما تبدأ نسخةً مني",
    "CONTROL_CREATECLONEOF": "أنشئ نسخةً من %1",
    "CONTROL_CREATECLONEOF_MYSELF": "نفسي",
    "CONTROL_DELETETHISCLONE": "احذف هذه النسخة",
    "CONTROL_COUNTER": "عداد",
    "CONTROL_INCRCOUNTER": "زد العداد",
    "CONTROL_CLEARCOUNTER": "صفِّر العداد",
    "CONTROL_ALLATONCE": "الكل مرة واحدة",
    "DATA_SETVARIABLETO": "اجعل %1 مساويًا %2",
    "DATA_CHANGEVARIABLEBY": "غيّر %1 بمقدار %2",
    "DATA_SHOWVARIABLE": "أظهر المتغير %1",
    "DATA_HIDEVARIABLE": "أخفِ المتغير %1",
    "DATA_ADDTOLIST": "أضف %1 إلى %2",
    "DATA_DELETEOFLIST": "احذف %1 من %2",
    "DATA_DELETEALLOFLIST": "احذف كل العناصر في %1",
    "DATA_INSERTATLIST": "أدرج %1 في الموقع %2 من %3",
    "DATA_REPLACEITEMOFLIST": "استبدل %3 بالعنصر %1 من %2",
    "DATA_ITEMOFLIST": "العنصر %1 من %2",
    "DATA_ITEMNUMOFLIST": "رقم العنصر ذي القيمة %1 في %2",
    "DATA_LENGTHOFLIST": "طول %1",
    "DATA_LISTCONTAINSITEM": "%1 تحتوي %2؟",
    "DATA_SHOWLIST": "أظهر اللائحة %1",
    "DATA_HIDELIST": "أخفِ اللائحة %1",
    "DATA_INDEX_ALL": "الكل",
    "DATA_INDEX_LAST": "الأخير",
    "DATA_INDEX_RANDOM": "عشوائي",
    "EVENT_WHENFLAGCLICKED": "عند نقر %1",
    "EVENT_WHENTHISSPRITECLICKED": "عند نقر هذا الكائن",
    "EVENT_WHENSTAGECLICKED": "عند نقر المنصة",
    "EVENT_WHENTOUCHINGOBJECT": "عندما يلامس هذا الكائن %1",
    "EVENT_WHENBROADCASTRECEIVED": "عندما أتلقى %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "عندما تتبدل الخلفية إلى %1",
    "EVENT_WHENGREATERTHAN": "عندما %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "المؤقت",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "الضجيج",
    "EVENT_BROADCAST": "بث %1",
    "EVENT_BROADCASTANDWAIT": "بث %1 وانتظر",
    "EVENT_WHENKEYPRESSED": "عند ضغط مفتاح %1",
    "EVENT_WHENKEYPRESSED_SPACE": "المسافة",
    "EVENT_WHENKEYPRESSED_LEFT": "السهم الأيسر",
    "EVENT_WHENKEYPRESSED_RIGHT": "السهم الأيمن",
    "EVENT_WHENKEYPRESSED_DOWN": "السهم السفلي",
    "EVENT_WHENKEYPRESSED_UP": "السهم العلوي",
    "EVENT_WHENKEYPRESSED_ANY": "أي مفتاح",
    "LOOKS_SAYFORSECS": "قل %1 لمدة %2 ثانية",
    "LOOKS_SAY": "قل %1",
    "LOOKS_HELLO": "السلام عليكم!",
    "LOOKS_THINKFORSECS": "فكِّر %1 لمدة %2 ثانية",
    "LOOKS_THINK": "فكِّر %1",
    "LOOKS_HMM": "هممم...",
    "LOOKS_SHOW": "اظهر",
    "LOOKS_HIDE": "اختفِ",
    "LOOKS_HIDEALLSPRITES": "أخفِ كل الكائنات",
    "LOOKS_EFFECT_COLOR": "اللون",
    "LOOKS_EFFECT_FISHEYE": "عين السمكة",
    "LOOKS_EFFECT_WHIRL": "الدوامة",
    "LOOKS_EFFECT_PIXELATE": "البكسلة",
    "LOOKS_EFFECT_MOSAIC": "الموزاييك",
    "LOOKS_EFFECT_BRIGHTNESS": "شدة الإضاءة",
    "LOOKS_EFFECT_GHOST": "الشبح",
    "LOOKS_CHANGEEFFECTBY": "غيّر مؤثر %1 بمقدار %2",
    "LOOKS_SETEFFECTTO": "اجعل مؤثر %1 مساويًا %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "أزل المؤثرات الرسومية",
    "LOOKS_CHANGESIZEBY": "غيّر الحجم بمقدار %1",
    "LOOKS_SETSIZETO": "اجعل الحجم مساويًا %1 ٪",
    "LOOKS_SIZE": "الحجم",
    "LOOKS_CHANGESTRETCHBY": "غيّر المط بمقدار %1",
    "LOOKS_SETSTRETCHTO": "اجعل المط مساويًا %1 ٪",
    "LOOKS_SWITCHCOSTUMETO": "غيِّر المظهر إلى %1",
    "LOOKS_NEXTCOSTUME": "المظهر التالي",
    "LOOKS_SWITCHBACKDROPTO": "غيِّر الخلفية إلى %1",
    "LOOKS_GOTOFRONTBACK": "انتقل إلى الطبقة %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "الأولى",
    "LOOKS_GOTOFRONTBACK_BACK": "الأخيرة",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "انتقل إلى %1 %2 طبقة",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "الأمام",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "الخلف",
    "LOOKS_BACKDROPNUMBERNAME": "%1 الخلفية",
    "LOOKS_COSTUMENUMBERNAME": "%1 المظهر",
    "LOOKS_NUMBERNAME_NUMBER": "رقم",
    "LOOKS_NUMBERNAME_NAME": "اسم",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "غيِّر الخلفية إلى %1 وانتظر",
    "LOOKS_NEXTBACKDROP_BLOCK": "الخلفية التالية",
    "LOOKS_NEXTBACKDROP": "الخلفية التالية",
    "LOOKS_PREVIOUSBACKDROP": "الخلفية السابقة",
    "LOOKS_RANDOMBACKDROP": "خلفية عشوائية",
    "MOTION_MOVESTEPS": "تحرك %1 خطوة",
    "MOTION_TURNLEFT": "استدر %1 %2 درجة",
    "MOTION_TURNRIGHT": "استدر %1 %2 درجة",
    "MOTION_POINTINDIRECTION": "اتجه نحو الاتجاه %1",
    "MOTION_POINTTOWARDS": "اتجه نحو %1",
    "MOTION_POINTTOWARDS_POINTER": "مؤشر الفأرة",
    "MOTION_POINTTOWARDS_RANDOM": "اتجاه عشوائي",
    "MOTION_GOTO": "اذهب إلى %1",
    "MOTION_GOTO_POINTER": "مؤشر الفأرة",
    "MOTION_GOTO_RANDOM": "موضع عشوائي",
    "MOTION_GOTOXY": "اذهب إلى الموضع س: %1 ص: %2",
    "MOTION_GLIDESECSTOXY": "انزلق خلال %1 ثانية إلى الموضع س: %2 ص: %3",
    "MOTION_GLIDETO": "انزلق خلال %1 ثانية إلى %2",
    "MOTION_GLIDETO_POINTER": "مؤشر الفأرة",
    "MOTION_GLIDETO_RANDOM": "موضع عشوائي",
    "MOTION_CHANGEXBY": "غيّر الموضع س بمقدار %1",
    "MOTION_SETX": "اجعل الموضع س مساويًا %1",
    "MOTION_CHANGEYBY": "غيّر الموضع ص بمقدار %1",
    "MOTION_SETY": "اجعل الموضع ص مساويًا %1",
    "MOTION_IFONEDGEBOUNCE": "ارتد إذا كنت عند الحافة",
    "MOTION_SETROTATIONSTYLE": "اجعل نمط الدوران %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "يمين - يسار",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "لا دوران",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "في جميع الاتجاهات",
    "MOTION_XPOSITION": "الموضع س",
    "MOTION_YPOSITION": "الموضع ص",
    "MOTION_DIRECTION": "الاتجاه",
    "MOTION_SCROLLRIGHT": "انزلق يمينًا %1",
    "MOTION_SCROLLUP": "انزلق للأعلى %1",
    "MOTION_ALIGNSCENE": "حاذِ المشهد %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "أسفل اليسار",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "أسفل اليمين",
    "MOTION_ALIGNSCENE_MIDDLE": "المنتصف",
    "MOTION_ALIGNSCENE_TOPLEFT": "أعلى اليسار",
    "MOTION_ALIGNSCENE_TOPRIGHT": "أعلى اليمين",
    "MOTION_XSCROLL": "تمرير  على محور س",
    "MOTION_YSCROLL": "تمرير على محور ص",
    "MOTION_STAGE_SELECTED": "المنصة محددة: لا توجد لبنات للحركة",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 × %2",
    "OPERATORS_DIVIDE": "%1 ÷ %2",
    "OPERATORS_RANDOM": "عدد عشوائي بين %1 و %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 و %2",
    "OPERATORS_OR": "%1 أو %2",
    "OPERATORS_NOT": "ليس %1",
    "OPERATORS_JOIN": "اربط %1 %2",
    "OPERATORS_JOIN_APPLE": "تفاحة",
    "OPERATORS_JOIN_BANANA": "موزة",
    "OPERATORS_LETTEROF": "الحرف %1 من %2",
    "OPERATORS_LETTEROF_APPLE": "ت",
    "OPERATORS_LENGTH": "طول %1",
    "OPERATORS_CONTAINS": "%1 تحتوي %2؟",
    "OPERATORS_MOD": " باقي قسمة %1 على %2",
    "OPERATORS_ROUND": "تقريب %1",
    "OPERATORS_MATHOP": "%1 للقيمة %2",
    "OPERATORS_MATHOP_ABS": "القيمة المطلقة",
    "OPERATORS_MATHOP_FLOOR": "الجزء الصحيح ",
    "OPERATORS_MATHOP_CEILING": "السقف",
    "OPERATORS_MATHOP_SQRT": "الجذر التربيعي",
    "OPERATORS_MATHOP_SIN": "الجيب (sin)",
    "OPERATORS_MATHOP_COS": "جيب التمام (cos)",
    "OPERATORS_MATHOP_TAN": "الظل (tan)",
    "OPERATORS_MATHOP_ASIN": "الجيب العكسي (asin)",
    "OPERATORS_MATHOP_ACOS": "جيب التمام العكسي (acos)",
    "OPERATORS_MATHOP_ATAN": "الظل العكسي (atan)",
    "OPERATORS_MATHOP_LN": "اللوغارتم الطبيعي",
    "OPERATORS_MATHOP_LOG": "اللوغارتم العشري",
    "OPERATORS_MATHOP_EEXP": "هـ^",
    "OPERATORS_MATHOP_10EXP": "10^",
    "PROCEDURES_DEFINITION": "عرِّف %1",
    "SENSING_TOUCHINGOBJECT": "ملامس لـ %1؟",
    "SENSING_TOUCHINGOBJECT_POINTER": "مؤشر الفأرة",
    "SENSING_TOUCHINGOBJECT_EDGE": "الحافة",
    "SENSING_TOUCHINGCOLOR": "ملامس للون %1؟",
    "SENSING_COLORISTOUCHINGCOLOR": "اللون %1 ملامس للون %2؟",
    "SENSING_DISTANCETO": "المسافة إلى %1",
    "SENSING_DISTANCETO_POINTER": "مؤشر الفأرة",
    "SENSING_ASKANDWAIT": "اسأل %1 وانتظر",
    "SENSING_ASK_TEXT": "ما اسمك؟",
    "SENSING_ANSWER": "الإجابة",
    "SENSING_KEYPRESSED": "مفتاح %1 مضغوط؟",
    "SENSING_MOUSEDOWN": "زر الفأرة مضغوط؟",
    "SENSING_MOUSEX": "الموضع س للفأرة",
    "SENSING_MOUSEY": "الموضع ص للفأرة",
    "SENSING_SETDRAGMODE": "اجعل السحب %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ممكنًا",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "غير ممكن",
    "SENSING_LOUDNESS": "الضجيج",
    "SENSING_LOUD": "الصوت مرتفع؟",
    "SENSING_TIMER": "المؤقت",
    "SENSING_RESETTIMER": "صفِّر المؤقت",
    "SENSING_OF": "%1 الخاص بـ %2",
    "SENSING_OF_XPOSITION": "الموضع س",
    "SENSING_OF_YPOSITION": "الموضع ص",
    "SENSING_OF_DIRECTION": "الاتجاه",
    "SENSING_OF_COSTUMENUMBER": "رقم المظهر",
    "SENSING_OF_COSTUMENAME": "اسم المظهر",
    "SENSING_OF_SIZE": "الحجم",
    "SENSING_OF_VOLUME": "شدة الصوت",
    "SENSING_OF_BACKDROPNUMBER": "رقم الخلفية",
    "SENSING_OF_BACKDROPNAME": "اسم الخلفية",
    "SENSING_OF_STAGE": "المنصة",
    "SENSING_CURRENT": "%1 الآن",
    "SENSING_CURRENT_YEAR": "السنة",
    "SENSING_CURRENT_MONTH": "الشهر",
    "SENSING_CURRENT_DATE": "تاريخ اليوم",
    "SENSING_CURRENT_DAYOFWEEK": "يوم الأسبوع",
    "SENSING_CURRENT_HOUR": "الساعة",
    "SENSING_CURRENT_MINUTE": "الدقيقة",
    "SENSING_CURRENT_SECOND": "الثانية",
    "SENSING_DAYSSINCE2000": "الأيام منذ عام 2000",
    "SENSING_USERNAME": "اسم المستخدم",
    "SENSING_USERID": "رقم المستخدم",
    "SOUND_PLAY": "شغِّل الصوت %1",
    "SOUND_PLAYUNTILDONE": "شغِّل الصوت %1 وانتظر انتهاءه",
    "SOUND_STOPALLSOUNDS": "أوقف كل الأصوات",
    "SOUND_SETEFFECTO": "اجعل مؤثر %1 مساويًا %2",
    "SOUND_CHANGEEFFECTBY": "غيّر مؤثر %1 بمقدار %2",
    "SOUND_CLEAREFFECTS": "أزل المؤثرات الصوتية",
    "SOUND_EFFECTS_PITCH": "طبقة الصوت",
    "SOUND_EFFECTS_PAN": "توزيع الصوت يسار/يمين",
    "SOUND_CHANGEVOLUMEBY": "غيّر شدة الصوت بمقدار %1",
    "SOUND_SETVOLUMETO": "اجعل شدة الصوت مساويةً %1%",
    "SOUND_VOLUME": "شدة الصوت",
    "SOUND_RECORD": "سجِّل...",
    "CATEGORY_MOTION": "الحركة",
    "CATEGORY_LOOKS": "الهيئة",
    "CATEGORY_SOUND": "الصوت",
    "CATEGORY_EVENTS": "الأحداث",
    "CATEGORY_CONTROL": "التحكم",
    "CATEGORY_SENSING": "الاستشعار",
    "CATEGORY_OPERATORS": "العمليات",
    "CATEGORY_VARIABLES": "المتغيرات",
    "CATEGORY_MYBLOCKS": "لبناتي",
    "DUPLICATE": "مضاعفة",
    "DELETE": "حذف",
    "ADD_COMMENT": "إضافة تعليق",
    "REMOVE_COMMENT": "حذف التعليق",
    "DELETE_BLOCK": "حذف اللبنة",
    "DELETE_X_BLOCKS": "حذف اللبنات الـ%1",
    "DELETE_ALL_BLOCKS": "حذف اللبنات الـ%1 كلها؟",
    "CLEAN_UP": "ترتيب اللبنات",
    "HELP": "مساعدة",
    "UNDO": "تراجع",
    "REDO": "إعادة",
    "EDIT_PROCEDURE": "تعديل",
    "SHOW_PROCEDURE_DEFINITION": "اذهب إلى التعريف",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "قل شيئًا...",
    "COLOUR_HUE_LABEL": "اللون",
    "COLOUR_SATURATION_LABEL": "الإشباع",
    "COLOUR_BRIGHTNESS_LABEL": "السطوع",
    "CHANGE_VALUE_TITLE": "غيّر القيمة:",
    "RENAME_VARIABLE": "إعادة تسمية المتغير",
    "RENAME_VARIABLE_TITLE": "إعادة تسمية جميع المتغيرات \"%1\" إلى:",
    "RENAME_VARIABLE_MODAL_TITLE": "إعادة تسمية المتغير",
    "NEW_VARIABLE": "إنشاء متغير",
    "NEW_VARIABLE_TITLE": "اسم المتغير الجديد:",
    "VARIABLE_MODAL_TITLE": "متغير جديد",
    "VARIABLE_ALREADY_EXISTS": "يوجد مسبقًا متغير بالاسم \"%1\".",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "اسم المتغير \"%1\" مستخدم مسبقًا في متغير آخر من النوع \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "احذف الاستخدامات الـ%1 للمتغير \"%2\"؟",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "لا يمكن حذف المتغير \"%1\" لأنه جزء من تعريف الدالة \"%2\"",
    "DELETE_VARIABLE": "حذف المتغير \"%1\"",
    "NEW_PROCEDURE": "إنشاء لبنة",
    "PROCEDURE_ALREADY_EXISTS": "يوجد مسبقًا إجراء بالاسم \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "اسم اللبنة",
    "PROCEDURE_USED": "لحذف تعريف لبنة، احذف أولًا كل استخدامات هذه اللبنة",
    "NEW_LIST": "إنشاء لائحة",
    "NEW_LIST_TITLE": "اسم اللائحة الجديدة:",
    "LIST_MODAL_TITLE": "لائحة جديدة",
    "LIST_ALREADY_EXISTS": "توجد مسبقًا لائحة بالاسم \"%1\".",
    "RENAME_LIST_TITLE": "إعادة تسمية جميع اللوائح \"%1\" إلى:",
    "RENAME_LIST_MODAL_TITLE": "إعادة تسمية اللائحة",
    "DEFAULT_LIST_ITEM": "غرض",
    "DELETE_LIST": "حذف اللائحة \"%1\"",
    "RENAME_LIST": "إعادة تسمية اللائحة",
    "NEW_BROADCAST_MESSAGE": "رسالة جديدة",
    "NEW_BROADCAST_MESSAGE_TITLE": "اسم الرسالة الجديدة:",
    "BROADCAST_MODAL_TITLE": "رسالة جديدة",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "الرسالة 1"
  },
  "am": {
    "CONTROL_FOREVER": "ለዘላለም",
    "CONTROL_REPEAT": "%1ን ድገም",
    "CONTROL_IF": "%1 ከሆነ",
    "CONTROL_ELSE": "ካልሆነ",
    "CONTROL_STOP": "አቁም",
    "CONTROL_STOP_ALL": "ሁሉም",
    "CONTROL_STOP_THIS": "ይሄ ስክሪፕት",
    "CONTROL_STOP_OTHER": "ሌሎች በስፕራይት ላይ ያሉ ስክሪፕቶች",
    "CONTROL_WAIT": "ጠብቅ ለ%1 ሰከንድ",
    "CONTROL_WAITUNTIL": "ጠብቅ እስከ %1",
    "CONTROL_REPEATUNTIL": "ድገም እስከ %1",
    "CONTROL_WHILE": "%1 ያለ",
    "CONTROL_FOREACH": "ለያንዳንድ %1 በ%2 ውስጥ",
    "CONTROL_STARTASCLONE": "እንደ አምሳያ ስጀምር",
    "CONTROL_CREATECLONEOF": "የ%1 አምሳያ ፍጠር",
    "CONTROL_CREATECLONEOF_MYSELF": "ራሴ",
    "CONTROL_DELETETHISCLONE": "ይህንን አምሳያ አጥፋ",
    "CONTROL_COUNTER": "ቆጣሪ",
    "CONTROL_INCRCOUNTER": "ቆጣሪውን ጨምር",
    "CONTROL_CLEARCOUNTER": "ቆጣሪውን አጽዳ",
    "CONTROL_ALLATONCE": "ሁሉም በአንድ ግዜ",
    "DATA_SETVARIABLETO": "%1 ወደ %2 ለውጥ",
    "DATA_CHANGEVARIABLEBY": "%1 በ%2 ቀይር",
    "DATA_SHOWVARIABLE": "%1ን ተለዋዋጭ አሳይ",
    "DATA_HIDEVARIABLE": "%1ን ተለዋዋጭ ደብቅ",
    "DATA_ADDTOLIST": "%1 ጨምር በ%2",
    "DATA_DELETEOFLIST": "%1 ሰርዝ ከ%2",
    "DATA_DELETEALLOFLIST": "%1 ሁሉ ሰርዝ",
    "DATA_INSERTATLIST": "%1 አስገባ በ%2 ላይ %3 ውስጥ",
    "DATA_REPLACEITEMOFLIST": "%1 ከ%2 ቀይር ወደ %3",
    "DATA_ITEMOFLIST": "%1 ከ%2",
    "DATA_ITEMNUMOFLIST": "item # of %1 in %2",
    "DATA_LENGTHOFLIST": "%1 ርዝመት",
    "DATA_LISTCONTAINSITEM": "%2 %1 አለበት?",
    "DATA_SHOWLIST": "%1ን ዝርዝር አሳይ",
    "DATA_HIDELIST": "%1ን ዝርዝር ደብቅ",
    "DATA_INDEX_ALL": "ሁሉም",
    "DATA_INDEX_LAST": "መጨረሻ",
    "DATA_INDEX_RANDOM": "የማይታወቅ",
    "EVENT_WHENFLAGCLICKED": "%1 ጠቅ ሲደረግ",
    "EVENT_WHENTHISSPRITECLICKED": "ይህ ስፕራይት ሲነካ",
    "EVENT_WHENSTAGECLICKED": "መድረኩ ጠቅ ሲደረግ",
    "EVENT_WHENTOUCHINGOBJECT": "ይህ ስፕራይት %1ን ሲነካ",
    "EVENT_WHENBROADCASTRECEIVED": "%1ን ስቀበል",
    "EVENT_WHENBACKDROPSWITCHESTO": "የጀርባ ምስል ወደ %1 ሲቀየር",
    "EVENT_WHENGREATERTHAN": "%1 > %2 ሲሆን",
    "EVENT_WHENGREATERTHAN_TIMER": "የጊዜ ቆጣሪ",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ጮክታ",
    "EVENT_BROADCAST": "%1ን አሰራጭ",
    "EVENT_BROADCASTANDWAIT": "%1ን አሰራጭና ጠብቅ",
    "EVENT_WHENKEYPRESSED": "%1ን ቁልፍ ጫን ሲደረግ",
    "EVENT_WHENKEYPRESSED_SPACE": "ቦታ",
    "EVENT_WHENKEYPRESSED_LEFT": "ወደ ግራ ጠቋሚ ቀስት",
    "EVENT_WHENKEYPRESSED_RIGHT": "የቀኝ አቅጣጫ ጠቋሚ ቀስት",
    "EVENT_WHENKEYPRESSED_DOWN": "ወደታች ጠቋሚ ቀስት",
    "EVENT_WHENKEYPRESSED_UP": "ወደ ላይ አቅጣጫ ጠቋሚ ቀስት",
    "EVENT_WHENKEYPRESSED_ANY": "የቱም",
    "LOOKS_SAYFORSECS": "%1ን በል ለ%2 ሰከንድ",
    "LOOKS_SAY": "%1ን በል",
    "LOOKS_HELLO": "ሰላም!",
    "LOOKS_THINKFORSECS": "%1ን አስብ ለ%2 ሰከንድ",
    "LOOKS_THINK": "%1ን አስብ",
    "LOOKS_HMM": "እ...",
    "LOOKS_SHOW": "አሳይ",
    "LOOKS_HIDE": "ደብቅ",
    "LOOKS_HIDEALLSPRITES": "ሁሉም ስፕራይቶች ደብቅ",
    "LOOKS_EFFECT_COLOR": "ቀለም",
    "LOOKS_EFFECT_FISHEYE": "fisheye",
    "LOOKS_EFFECT_WHIRL": "መሽከርከር",
    "LOOKS_EFFECT_PIXELATE": "ፒክሰሌት",
    "LOOKS_EFFECT_MOSAIC": "ሞዚያክ",
    "LOOKS_EFFECT_BRIGHTNESS": "የብርሀን መጠን",
    "LOOKS_EFFECT_GHOST": "መንፈስ",
    "LOOKS_CHANGEEFFECTBY": "%1ን ተጽኖ በ%2 ለውጥ",
    "LOOKS_SETEFFECTTO": "%1ን ተጽኖ ወደ %2 ለውጥ",
    "LOOKS_CLEARGRAPHICEFFECTS": "የምስል ማስዋብያዎቹን አጥፋ",
    "LOOKS_CHANGESIZEBY": "ልክን ቀይር በ%1",
    "LOOKS_SETSIZETO": "ልክን ወደ %1 ቀይር",
    "LOOKS_SIZE": "መጠን",
    "LOOKS_CHANGESTRETCHBY": "ዝርጋት በ%1 ቀይር",
    "LOOKS_SETSTRETCHTO": "ዝርጋት ወደ %1 ቀይር",
    "LOOKS_SWITCHCOSTUMETO": "ልብስ ወደ %1 ለውጥ",
    "LOOKS_NEXTCOSTUME": "ቀጣይ አልባስ",
    "LOOKS_SWITCHBACKDROPTO": "የጀርባ ምስል ወደ %1 ለውጥ",
    "LOOKS_GOTOFRONTBACK": "ወደ %1 ተደራቢ ሂድ",
    "LOOKS_GOTOFRONTBACK_FRONT": "ፊት",
    "LOOKS_GOTOFRONTBACK_BACK": "ኋላ",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ወደ %1ና %2 ተደራቢዎች ሂድ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ወደፊት",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "ወደኋላ",
    "LOOKS_BACKDROPNUMBERNAME": "የጀርባ ምስል %1",
    "LOOKS_COSTUMENUMBERNAME": "ልብስ %1",
    "LOOKS_NUMBERNAME_NUMBER": "ቁጥር",
    "LOOKS_NUMBERNAME_NAME": "ስም",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "የጀርባ ምስል ወደ %1 ለውጥና ጠብቅ",
    "LOOKS_NEXTBACKDROP_BLOCK": "ቀጣይ የጀርባ ምስል",
    "LOOKS_NEXTBACKDROP": "ቀጣይ የጀርባ ምስል",
    "LOOKS_PREVIOUSBACKDROP": "ቀድሞ የነበረው የጀርባ ምስል",
    "LOOKS_RANDOMBACKDROP": "ራንደም የጀርባ ምስል",
    "MOTION_MOVESTEPS": "%1 እርምጃዎች ተንቀሳቀስ",
    "MOTION_TURNLEFT": "ዙር %1 %2 ድግሪዎች",
    "MOTION_TURNRIGHT": "ዙር %1 %2 ድግሪዎች",
    "MOTION_POINTINDIRECTION": "ወደ %1 አቅጣጫ ደግን",
    "MOTION_POINTTOWARDS": "ወደ %1 ደግን",
    "MOTION_POINTTOWARDS_POINTER": "የማውሱ መጠቆሚያ",
    "MOTION_POINTTOWARDS_RANDOM": "random direction",
    "MOTION_GOTO": "ወደ %1 ሂድ",
    "MOTION_GOTO_POINTER": "የማውሱ መጠቆሚያ",
    "MOTION_GOTO_RANDOM": "የማይታወቅ ቦታ",
    "MOTION_GOTOXY": "ወደ x: %1 y: %2 ሂድ",
    "MOTION_GLIDESECSTOXY": "ተንሸራተት %1 ሰከንድ ወደ x: %2 y: %3",
    "MOTION_GLIDETO": "ተንሸራተት %1 ሰከንድ ወደ %2",
    "MOTION_GLIDETO_POINTER": "የማውሱ መጠቆሚያ",
    "MOTION_GLIDETO_RANDOM": "የማይታወቅ ቦታ",
    "MOTION_CHANGEXBY": "xን ቀይር በ%1",
    "MOTION_SETX": "xን ወደ %1 ለውጥ",
    "MOTION_CHANGEYBY": "yን ቀይር በ%1",
    "MOTION_SETY": "yን ወደ %1 ለውጥ",
    "MOTION_IFONEDGEBOUNCE": "ጠርዝ ላይ ነጥረህ ተመለስ",
    "MOTION_SETROTATIONSTYLE": "የዙር ዘዴ ወደ %1 ለውጥ",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "ግራ-ቀኝ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "አትሽከርከር",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "በአካባቢው በሙሉ",
    "MOTION_XPOSITION": "x ቦታ",
    "MOTION_YPOSITION": "y ቦታ",
    "MOTION_DIRECTION": "አቅጣጫ",
    "MOTION_SCROLLRIGHT": "ሸብልል %1 ወደ ቀኝ",
    "MOTION_SCROLLUP": "ሸብልል %1 ወደ ላይ",
    "MOTION_ALIGNSCENE": "%1ን ሥፍራ ገባበር ",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ታች-ግራ",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ታች-ቀኝ",
    "MOTION_ALIGNSCENE_MIDDLE": "መሃከል",
    "MOTION_ALIGNSCENE_TOPLEFT": "ላይ-ግራ",
    "MOTION_ALIGNSCENE_TOPRIGHT": "ላይ-ቀኝ",
    "MOTION_XSCROLL": "xን ሸብልል",
    "MOTION_YSCROLL": "yን ሸብልል",
    "MOTION_STAGE_SELECTED": "መድረክ ተመርጧል፡ ተንቀሳቃሽ ጥምሮች የሉም",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 እስከ %2 በራንደም ምረጥ",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1ና %2",
    "OPERATORS_OR": "%1 ወይስ %2",
    "OPERATORS_NOT": "%1 አይደለም",
    "OPERATORS_JOIN": "%1 %2 አገናኝ",
    "OPERATORS_JOIN_APPLE": "ፖም",
    "OPERATORS_JOIN_BANANA": "ሙዝ",
    "OPERATORS_LETTEROF": "ፊደል %1 ከ%2",
    "OPERATORS_LETTEROF_APPLE": "አንድ",
    "OPERATORS_LENGTH": "%1 ርዝመት",
    "OPERATORS_CONTAINS": "%2 %1 አለበት?",
    "OPERATORS_MOD": "%1 ሞዱሎ %2",
    "OPERATORS_ROUND": "%1ን አጠጋጋ",
    "OPERATORS_MATHOP": "%1 ከ%2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "መሬት",
    "OPERATORS_MATHOP_CEILING": "ጣራ",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ውስጥ",
    "OPERATORS_MATHOP_LOG": "ግባ",
    "OPERATORS_MATHOP_EEXP": "e^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "%1ን ደንግግ",
    "SENSING_TOUCHINGOBJECT": "%1ን የነካ ነው?",
    "SENSING_TOUCHINGOBJECT_POINTER": "የማውሱ መጠቆሚያ",
    "SENSING_TOUCHINGOBJECT_EDGE": "ዳር",
    "SENSING_TOUCHINGCOLOR": "%1ን ቀለም የነካ ነው?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 ቀለም %2ን የነካ ነው?",
    "SENSING_DISTANCETO": "ርቀት እስከ %1",
    "SENSING_DISTANCETO_POINTER": "የማውሱ መጠቆሚያ",
    "SENSING_ASKANDWAIT": "%1 ጠይቅና ጠብቅ",
    "SENSING_ASK_TEXT": "ስምህ ማን ነው?",
    "SENSING_ANSWER": "መልስ",
    "SENSING_KEYPRESSED": "ቁልፍ %1 ጫን ተብሏል?",
    "SENSING_MOUSEDOWN": "መዳፊት ወደታች?",
    "SENSING_MOUSEX": "መዳፊት x",
    "SENSING_MOUSEY": "መዳፊት y",
    "SENSING_SETDRAGMODE": "የጉትት ሞድ ወደ %1 ለውጥ",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ይጎተታል",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "አይጎተትም",
    "SENSING_LOUDNESS": "ጮክታ",
    "SENSING_LOUD": "ጮክ ነው?",
    "SENSING_TIMER": "የጊዜ ቆጣሪ",
    "SENSING_RESETTIMER": "ጊዜ ቆጣሪውን ከዜሮ ጀምር",
    "SENSING_OF": "%1 ከ%2",
    "SENSING_OF_XPOSITION": "x ቦታ",
    "SENSING_OF_YPOSITION": "y ቦታ",
    "SENSING_OF_DIRECTION": "አቅጣጫ",
    "SENSING_OF_COSTUMENUMBER": "ልብስ ቁጥር",
    "SENSING_OF_COSTUMENAME": "የአልባሳት ስም",
    "SENSING_OF_SIZE": "መጠን",
    "SENSING_OF_VOLUME": "የድምጽ መጠን",
    "SENSING_OF_BACKDROPNUMBER": "የጀርባ ምስል #",
    "SENSING_OF_BACKDROPNAME": "የጀርባ ምስል ስም",
    "SENSING_OF_STAGE": "መድረክ",
    "SENSING_CURRENT": "ያሁኑ %1",
    "SENSING_CURRENT_YEAR": "አመት",
    "SENSING_CURRENT_MONTH": "ወር",
    "SENSING_CURRENT_DATE": "ቀን",
    "SENSING_CURRENT_DAYOFWEEK": "የሳምንቱ ቀን",
    "SENSING_CURRENT_HOUR": "ሰዓት",
    "SENSING_CURRENT_MINUTE": "ደቂቃ",
    "SENSING_CURRENT_SECOND": "ሁለተኛ",
    "SENSING_DAYSSINCE2000": "ከ2000 ጀምሮ ያሉ ቀናት",
    "SENSING_USERNAME": "የተጠቃሚ ስም",
    "SENSING_USERID": "የተጠቃሚ መታወቂያ",
    "SOUND_PLAY": "%1ን ድምጽ ጀምር",
    "SOUND_PLAYUNTILDONE": "%1ን ድምጽ ተጫወት እስከሚያልቅ",
    "SOUND_STOPALLSOUNDS": "ሁሉንም ድምጾች አቁም",
    "SOUND_SETEFFECTO": "%1ን ተጽኖ ወደ %2 ለውጥ",
    "SOUND_CHANGEEFFECTBY": "%1ን ተጽኖ በ%2 ለውጥ",
    "SOUND_CLEAREFFECTS": "የድምጽ ተጽኖዎች አጽዳ",
    "SOUND_EFFECTS_PITCH": "ፒች",
    "SOUND_EFFECTS_PAN": "ሸብልል ወደ ግራ/ቀኝ",
    "SOUND_CHANGEVOLUMEBY": "ድምጽ ቀይር በ%1",
    "SOUND_SETVOLUMETO": "ድምጽ ወደ %1% ለውጥ",
    "SOUND_VOLUME": "የድምጽ መጠን",
    "SOUND_RECORD": "record...",
    "CATEGORY_MOTION": "እንቅስቃሴ",
    "CATEGORY_LOOKS": "ገጽታ",
    "CATEGORY_SOUND": "ድምጽ",
    "CATEGORY_EVENTS": "ክስተት",
    "CATEGORY_CONTROL": "ቁጥጥር",
    "CATEGORY_SENSING": "ስሜት",
    "CATEGORY_OPERATORS": "ስሌቶች",
    "CATEGORY_VARIABLES": "ተለዋዋጮች",
    "CATEGORY_MYBLOCKS": "የኔ ጥምሮች",
    "DUPLICATE": "ቅጂ አድርገህ ገልብጥ",
    "DELETE": "አጥፋ",
    "ADD_COMMENT": "አስተያየት ጨምር",
    "REMOVE_COMMENT": "አስተያየት አውጣ",
    "DELETE_BLOCK": "ጥምር ሰርዝ",
    "DELETE_X_BLOCKS": "%1 ጥምሮች ሰርዝ",
    "DELETE_ALL_BLOCKS": "ሁሉም %1 ጥምሮች ሰርዝ?",
    "CLEAN_UP": "ጥምሮች አጽዳ",
    "HELP": "እርዳታ",
    "UNDO": "መልስ",
    "REDO": "ድጋሜ አድርግ",
    "EDIT_PROCEDURE": "ቀይር",
    "SHOW_PROCEDURE_DEFINITION": "ወደ ትርጓሜ ሂድ",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "አንድ ነገር በል...",
    "COLOUR_HUE_LABEL": "ቀለም",
    "COLOUR_SATURATION_LABEL": "ርኬት",
    "COLOUR_BRIGHTNESS_LABEL": "ብሩህነት",
    "CHANGE_VALUE_TITLE": "እሴት ቀይር",
    "RENAME_VARIABLE": "ተለዋዋጭ ደግመህ ሰይም",
    "RENAME_VARIABLE_TITLE": "ሁሉም \"%1\" ተለዋዋጮች ደግመህ ሰይም ወደ፡",
    "RENAME_VARIABLE_MODAL_TITLE": "ተለዋዋጭ ደግመህ ሰይም",
    "NEW_VARIABLE": "ተለዋጭ ፍጠር",
    "NEW_VARIABLE_TITLE": "አዲስ ተለዋዋጭ ስም",
    "VARIABLE_MODAL_TITLE": "አዲስ ተለዋዋጭ",
    "VARIABLE_ALREADY_EXISTS": "የተሰየመ ተለዋዋጭ \"%1\" አስቀድሞ አለ",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "አንድ ተለዋዋጭ \"%1\" የተሰየመ አስቀድሞ ይኖራል ለሌ ተለዋዋጭ በ\"%2\" ዓይነት.",
    "DELETE_VARIABLE_CONFIRMATION": "የ%1 ጥቅሞች በ%2 ተለዋዋጭ ይሰረዙ?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "%1ን ተለዋዋጭ መሰረዝ አይቻልም የ%2ን ተግባር አባል ስለሆነ",
    "DELETE_VARIABLE": "%1ን ተለዋዋጭ ይሰረዝ?",
    "NEW_PROCEDURE": "ጡብ ፍጠር",
    "PROCEDURE_ALREADY_EXISTS": "አንድ \"%1\" የተሰየመ ተግባር አስቀድሞ አለ",
    "PROCEDURE_DEFAULT_NAME": "የጥምር ስም",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "ዝርዝር ፍጠር",
    "NEW_LIST_TITLE": "አዲስ ዝርዝር ስም",
    "LIST_MODAL_TITLE": "አዲስ ዝርዝር",
    "LIST_ALREADY_EXISTS": "አንድ \"%1\" የተሰየመ ዝርዝር አስቀድሞ አለ",
    "RENAME_LIST_TITLE": "ሁሉም \"%1\" ዝርዝሮች ደግሞ ይሰየሙ ወደ፡ ",
    "RENAME_LIST_MODAL_TITLE": "ዝርዝር ደግመህ ሰይም",
    "DEFAULT_LIST_ITEM": "ነገር",
    "DELETE_LIST": "Delete the \"%1\" list",
    "RENAME_LIST": "Rename list",
    "NEW_BROADCAST_MESSAGE": "አዲስ መልዕክት",
    "NEW_BROADCAST_MESSAGE_TITLE": "አዲስ የመልዕክት ስም፡",
    "BROADCAST_MODAL_TITLE": "አዲስ መልእክት",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "መልእክት1"
  },
  "an": {
    "CONTROL_FOREVER": "pa cutio",
    "CONTROL_REPEAT": "repetir %1",
    "CONTROL_IF": "si %1 allora",
    "CONTROL_ELSE": "si no",
    "CONTROL_STOP": "aturar",
    "CONTROL_STOP_ALL": "totz",
    "CONTROL_STOP_THIS": "este programa",
    "CONTROL_STOP_OTHER": "atros programas en l'obchecto",
    "CONTROL_WAIT": "aguardar %1 segundos",
    "CONTROL_WAITUNTIL": "aguardar dica que %1",
    "CONTROL_REPEATUNTIL": "repetir dica que %1",
    "CONTROL_WHILE": "mientres %1",
    "CONTROL_FOREACH": "pa cada %1 de %2",
    "CONTROL_STARTASCLONE": "en prencipiar como replica",
    "CONTROL_CREATECLONEOF": "crear replica de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "yo mesmo",
    "CONTROL_DELETETHISCLONE": "eliminar esta replica",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "incrementar contador",
    "CONTROL_CLEARCOUNTER": "borrar contador",
    "CONTROL_ALLATONCE": "tot d'una vegada",
    "DATA_SETVARIABLETO": "dar a %1 la valor %2",
    "DATA_CHANGEVARIABLEBY": "sumar %2 a %1",
    "DATA_SHOWVARIABLE": "amostrar variable %1",
    "DATA_HIDEVARIABLE": "amagar variable %1",
    "DATA_ADDTOLIST": "anyadir %1 a %2",
    "DATA_DELETEOFLIST": "eliminar %1 de %2",
    "DATA_DELETEALLOFLIST": "eliminar totz de %1",
    "DATA_INSERTATLIST": "clavar %1 en a posición %2 de %3",
    "DATA_REPLACEITEMOFLIST": "reemplazar elemento %1 de %2 con %3",
    "DATA_ITEMOFLIST": "elemento %1 de %2",
    "DATA_ITEMNUMOFLIST": "# d'elementos de %1 en %2",
    "DATA_LENGTHOFLIST": "longaria de %1",
    "DATA_LISTCONTAINSITEM": "%2 ye en %1?",
    "DATA_SHOWLIST": "amostrar la lista %1",
    "DATA_HIDELIST": "amagar la lista %1",
    "DATA_INDEX_ALL": "totz",
    "DATA_INDEX_LAST": "zaguero",
    "DATA_INDEX_RANDOM": "a l'azar",
    "EVENT_WHENFLAGCLICKED": "en fer clic en %1",
    "EVENT_WHENTHISSPRITECLICKED": "en fer clic en este obchecto",
    "EVENT_WHENSTAGECLICKED": "en fer clic en o scenario",
    "EVENT_WHENTOUCHINGOBJECT": "quan l'obchecto toque %1",
    "EVENT_WHENBROADCASTRECEIVED": "en recibir %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "quan lo fondo cambie a %1",
    "EVENT_WHENGREATERTHAN": "quan %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronometro",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "volumen d'o son",
    "EVENT_BROADCAST": "ninviar %1",
    "EVENT_BROADCASTANDWAIT": "ninviar %1 y aguardar",
    "EVENT_WHENKEYPRESSED": "en pretar la tecla %1",
    "EVENT_WHENKEYPRESSED_SPACE": "espacio",
    "EVENT_WHENKEYPRESSED_LEFT": "flecha enta la zurda",
    "EVENT_WHENKEYPRESSED_RIGHT": "flecha enta la dreita",
    "EVENT_WHENKEYPRESSED_DOWN": "flecha enta abaixo",
    "EVENT_WHENKEYPRESSED_UP": "flecha enta alto",
    "EVENT_WHENKEYPRESSED_ANY": "qualsequiera",
    "LOOKS_SAYFORSECS": "decir %1 per %2 segundos",
    "LOOKS_SAY": "decir %1",
    "LOOKS_HELLO": "Ola!",
    "LOOKS_THINKFORSECS": "pensar %1 per %2 segundos",
    "LOOKS_THINK": "pensar %1",
    "LOOKS_HMM": "Umm...",
    "LOOKS_SHOW": "amostrar",
    "LOOKS_HIDE": "amagar",
    "LOOKS_HIDEALLSPRITES": "amagar totz los obchectos",
    "LOOKS_EFFECT_COLOR": "color",
    "LOOKS_EFFECT_FISHEYE": "uello de peix",
    "LOOKS_EFFECT_WHIRL": "revolvín",
    "LOOKS_EFFECT_PIXELATE": "pixelar",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "brilo",
    "LOOKS_EFFECT_GHOST": "transparent",
    "LOOKS_CHANGEEFFECTBY": "sumar %2 a l'efecto %1 ",
    "LOOKS_SETEFFECTTO": "dar a l'efecto %1 la valor %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "borrar los efectos graficos",
    "LOOKS_CHANGESIZEBY": "cambiar grandaria per %1",
    "LOOKS_SETSIZETO": "fixar grandaria a lo %1 %",
    "LOOKS_SIZE": "grandaria",
    "LOOKS_CHANGESTRETCHBY": "sumar %1 a lo estiramiento",
    "LOOKS_SETSTRETCHTO": "fixar estiramiento en o %1 %",
    "LOOKS_SWITCHCOSTUMETO": "cambiar vestiu a %1",
    "LOOKS_NEXTCOSTUME": "siguient vestiu",
    "LOOKS_SWITCHBACKDROPTO": "cambiar fondo a %1",
    "LOOKS_GOTOFRONTBACK": "ir a capa %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "debant",
    "LOOKS_GOTOFRONTBACK_BACK": "dezaga",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ir %2 capas enta %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "enta debant",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "enta zaga",
    "LOOKS_BACKDROPNUMBERNAME": "%1 de fondo",
    "LOOKS_COSTUMENUMBERNAME": "%1 de vestiu",
    "LOOKS_NUMBERNAME_NUMBER": "numero",
    "LOOKS_NUMBERNAME_NAME": "nombre",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "cambiar fondo a %1 y aguardar",
    "LOOKS_NEXTBACKDROP_BLOCK": "siguient fondo",
    "LOOKS_NEXTBACKDROP": "siguient fondo",
    "LOOKS_PREVIOUSBACKDROP": "fondo anterior",
    "LOOKS_RANDOMBACKDROP": "fondo aleatorio",
    "MOTION_MOVESTEPS": "mover %1 pasos",
    "MOTION_TURNLEFT": "chirar %1 %2 graus",
    "MOTION_TURNRIGHT": "chirar %1 %2 graus",
    "MOTION_POINTINDIRECTION": "apuntar enta la dirección %1",
    "MOTION_POINTTOWARDS": "apuntar enta %1",
    "MOTION_POINTTOWARDS_POINTER": "puntero d'o ratet",
    "MOTION_POINTTOWARDS_RANDOM": "dirección aleatoria",
    "MOTION_GOTO": "ir ta %1",
    "MOTION_GOTO_POINTER": "puntero d'o ratet",
    "MOTION_GOTO_RANDOM": "posición aleatoria",
    "MOTION_GOTOXY": "ir ta x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "eslizar en %1 segs enta x: %2 y: %3",
    "MOTION_GLIDETO": "eslizar en %1 segs enta %2",
    "MOTION_GLIDETO_POINTER": "puntero d'o rato",
    "MOTION_GLIDETO_RANDOM": "posición aleatoria",
    "MOTION_CHANGEXBY": "sumar %1 a x",
    "MOTION_SETX": "dar a x la valor %1",
    "MOTION_CHANGEYBY": "sumar %1 a y",
    "MOTION_SETY": "dar a y la valor %1",
    "MOTION_IFONEDGEBOUNCE": "si toca un canto, recutir",
    "MOTION_SETROTATIONSTYLE": "fixar estilo de rotación a %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "zurda-dreita",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "no rotar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "tot alredor",
    "MOTION_XPOSITION": "posición en x",
    "MOTION_YPOSITION": "posición en y",
    "MOTION_DIRECTION": "dirección",
    "MOTION_SCROLLRIGHT": "desplazar enta la dreita %1",
    "MOTION_SCROLLUP": "desplazar enta alto %1",
    "MOTION_ALIGNSCENE": "aliniar scena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "abaixo a la zurda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "abaixo a la dreita",
    "MOTION_ALIGNSCENE_MIDDLE": "en o bell meyo",
    "MOTION_ALIGNSCENE_TOPLEFT": "alto a la zurda",
    "MOTION_ALIGNSCENE_TOPRIGHT": "alto a la dreita",
    "MOTION_XSCROLL": "desplazamiento en x",
    "MOTION_YSCROLL": "desplazamiento en y",
    "MOTION_STAGE_SELECTED": "Scenario trigau: sin bloques de movimiento",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "numero aleatorio entre %1 y %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 y %2",
    "OPERATORS_OR": "%1 u %2",
    "OPERATORS_NOT": "no %1",
    "OPERATORS_JOIN": "unir %1 %2",
    "OPERATORS_JOIN_APPLE": "mazana",
    "OPERATORS_JOIN_BANANA": "platano",
    "OPERATORS_LETTEROF": "letra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "longaria de %1",
    "OPERATORS_CONTAINS": "%2 ye en %1?",
    "OPERATORS_MOD": "%1 modulo %2",
    "OPERATORS_ROUND": "redondiar %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "valor absoluta",
    "OPERATORS_MATHOP_FLOOR": "suelo",
    "OPERATORS_MATHOP_CEILING": "teito",
    "OPERATORS_MATHOP_SQRT": "radiz quadrada",
    "OPERATORS_MATHOP_SIN": "sen",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsen",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definir %1",
    "SENSING_TOUCHINGOBJECT": "tocando %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "puntero d'o ratet",
    "SENSING_TOUCHINGOBJECT_EDGE": "canto",
    "SENSING_TOUCHINGCOLOR": "tocando la color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "color %1 tocando %2?",
    "SENSING_DISTANCETO": "distancia a %1",
    "SENSING_DISTANCETO_POINTER": "puntero d'o ratet",
    "SENSING_ASKANDWAIT": "preguntar %1 y aguardar",
    "SENSING_ASK_TEXT": "Cómo te dices?",
    "SENSING_ANSWER": "respuesta",
    "SENSING_KEYPRESSED": "tecla %1 pretada?",
    "SENSING_MOUSEDOWN": "ratet pretau?",
    "SENSING_MOUSEX": "posición x d'o ratet",
    "SENSING_MOUSEY": "posición y d'o ratet",
    "SENSING_SETDRAGMODE": "fixar modo d'arrociegue a %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrocegable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "no arrocegable",
    "SENSING_LOUDNESS": "volumen d'o son",
    "SENSING_LOUD": "masiau alto?",
    "SENSING_TIMER": "cronometro",
    "SENSING_RESETTIMER": "reiniciar cronometro",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posición en x",
    "SENSING_OF_YPOSITION": "posición en y",
    "SENSING_OF_DIRECTION": "dirección",
    "SENSING_OF_COSTUMENUMBER": "# de vestiu",
    "SENSING_OF_COSTUMENAME": "nombre de vestiu",
    "SENSING_OF_SIZE": "grandaria",
    "SENSING_OF_VOLUME": "volumen",
    "SENSING_OF_BACKDROPNUMBER": "# de fondo",
    "SENSING_OF_BACKDROPNAME": "nombre de fondo",
    "SENSING_OF_STAGE": "Scenario",
    "SENSING_CURRENT": "%1 actual",
    "SENSING_CURRENT_YEAR": "anyo",
    "SENSING_CURRENT_MONTH": "mes",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "día d'a semana",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "segundo",
    "SENSING_DAYSSINCE2000": "días dende lo 2000",
    "SENSING_USERNAME": "nombre d'usuario",
    "SENSING_USERID": "identificación d'usuario",
    "SOUND_PLAY": "iniciar son %1",
    "SOUND_PLAYUNTILDONE": "tanyer son %1 dica que remate",
    "SOUND_STOPALLSOUNDS": "aturar totz los sons",
    "SOUND_SETEFFECTO": "dar a l'efecto %1 la valor %2",
    "SOUND_CHANGEEFFECTBY": "sumar %2 a l'efecto %1",
    "SOUND_CLEAREFFECTS": "sacar efectos de son",
    "SOUND_EFFECTS_PITCH": "tono",
    "SOUND_EFFECTS_PAN": "balanz zurda/dreita",
    "SOUND_CHANGEVOLUMEBY": "cambiar volumen per %1",
    "SOUND_SETVOLUMETO": "fixar volumen a %1%",
    "SOUND_VOLUME": "volumen",
    "SOUND_RECORD": "gravar...",
    "CATEGORY_MOTION": "Movimiento",
    "CATEGORY_LOOKS": "Apariencia",
    "CATEGORY_SOUND": "Son",
    "CATEGORY_EVENTS": "Eventos",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensors",
    "CATEGORY_OPERATORS": "Operadors",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "Los míos bloques",
    "DUPLICATE": "Duplicar",
    "DELETE": "Borrar",
    "ADD_COMMENT": "Anyadir comentario",
    "REMOVE_COMMENT": "Eliminar comentario",
    "DELETE_BLOCK": "Borrar bloque",
    "DELETE_X_BLOCKS": "Borrar %1 bloques",
    "DELETE_ALL_BLOCKS": "Borrar los %1 bloques?",
    "CLEAN_UP": "Ordenar bloques",
    "HELP": "Aduya",
    "UNDO": "Desfer",
    "REDO": "Refer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Ir a definición",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Decir bella cosa",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturación",
    "COLOUR_BRIGHTNESS_LABEL": "Brilo",
    "CHANGE_VALUE_TITLE": "Cambiar valor:",
    "RENAME_VARIABLE": "Renombrar variable",
    "RENAME_VARIABLE_TITLE": "Renombrar totas las variables \"%1\" a:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renombrar variable",
    "NEW_VARIABLE": "Crear una variable",
    "NEW_VARIABLE_TITLE": "Nombre d'a variable:",
    "VARIABLE_MODAL_TITLE": "Nueva variable",
    "VARIABLE_ALREADY_EXISTS": "Ya existe una variable clamada \"%1\".",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Ya existe una variable clamada \"%1\" pa belatra variable de tipo \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Eliminar %1 usos d'a variable \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "No se puede borrar la variable \"%1\" perque ye parte d'a definición d'a función \"%2\"",
    "DELETE_VARIABLE": "Borrar la variable \"%1\"",
    "NEW_PROCEDURE": "Crear un bloque",
    "PROCEDURE_ALREADY_EXISTS": "Ya existe un procedimiento clamau \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "nombre d'o bloque",
    "PROCEDURE_USED": "Antes d'eliminar la definición d'o bloque has d'eliminar totz los suyos usos",
    "NEW_LIST": "Crear una lista",
    "NEW_LIST_TITLE": "Nombre d'a lista:",
    "LIST_MODAL_TITLE": "Nueva lista",
    "LIST_ALREADY_EXISTS": "Ya existe una lista clamada \"%1\".",
    "RENAME_LIST_TITLE": "Renombrar totas las listas \"%1\" como:",
    "RENAME_LIST_MODAL_TITLE": "Renombrar lista",
    "DEFAULT_LIST_ITEM": "cosa",
    "DELETE_LIST": "Borrar la lista \"%1\"",
    "RENAME_LIST": "Renombrar lista",
    "NEW_BROADCAST_MESSAGE": "Nuevo mensache",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nombre d'o nuevo mensache:",
    "BROADCAST_MODAL_TITLE": "Nuevo Mensache",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mensache1"
  },
  "ast": {
    "CONTROL_FOREVER": "pa siempres",
    "CONTROL_REPEAT": "repetir %1",
    "CONTROL_IF": "si %1 entós",
    "CONTROL_ELSE": "sinón",
    "CONTROL_STOP": "parar",
    "CONTROL_STOP_ALL": "too",
    "CONTROL_STOP_THIS": "esti script",
    "CONTROL_STOP_OTHER": "otros scripts nel personaxe",
    "CONTROL_WAIT": "esperar %1 segundos",
    "CONTROL_WAITUNTIL": "esperar hasta %1",
    "CONTROL_REPEATUNTIL": "repetir hasta %1",
    "CONTROL_WHILE": "mentanto %1",
    "CONTROL_FOREACH": "pa cada %1 de %2",
    "CONTROL_STARTASCLONE": "cuando principie como clon",
    "CONTROL_CREATECLONEOF": "crear clon de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "yo mesmu",
    "CONTROL_DELETETHISCLONE": "desaniciar esti clon",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "contador incremental",
    "CONTROL_CLEARCOUNTER": "esborrar contador",
    "CONTROL_ALLATONCE": "toos a la vez",
    "DATA_SETVARIABLETO": "poner %1 a %2",
    "DATA_CHANGEVARIABLEBY": "cambiar %1 por %2",
    "DATA_SHOWVARIABLE": "amosar variable %1",
    "DATA_HIDEVARIABLE": "anubrir variable %1",
    "DATA_ADDTOLIST": "amestar %1 a %2",
    "DATA_DELETEOFLIST": "esborrar %1 de %2",
    "DATA_DELETEALLOFLIST": "esborrar too de %1",
    "DATA_INSERTATLIST": "inxertar %1 en %2 de %3",
    "DATA_REPLACEITEMOFLIST": "sustituyir item %1 de %2 con %3",
    "DATA_ITEMOFLIST": "item %1 de %2",
    "DATA_ITEMNUMOFLIST": "item # de %1 en %2",
    "DATA_LENGTHOFLIST": "llonxitú de %1",
    "DATA_LISTCONTAINSITEM": "%1 contién %2?",
    "DATA_SHOWLIST": "amosar llista %1",
    "DATA_HIDELIST": "anubrir llista %1",
    "DATA_INDEX_ALL": "too",
    "DATA_INDEX_LAST": "postrer",
    "DATA_INDEX_RANDOM": "al debalu",
    "EVENT_WHENFLAGCLICKED": "cuando se calca en %1",
    "EVENT_WHENTHISSPRITECLICKED": "cuando se calque nesti personaxe",
    "EVENT_WHENSTAGECLICKED": "cuando se calque nel escenariu",
    "EVENT_WHENTOUCHINGOBJECT": "cuando esti personaxe toque %1",
    "EVENT_WHENBROADCASTRECEIVED": "cuando reciba %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "cuando'l fondu cambie a %1",
    "EVENT_WHENGREATERTHAN": "cuando %1>%2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronómetru",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "volume del soníu",
    "EVENT_BROADCAST": "tresmitir %1",
    "EVENT_BROADCASTANDWAIT": "tresmitir %1 y esperar",
    "EVENT_WHENKEYPRESSED": "cuando se calca la tecla %1",
    "EVENT_WHENKEYPRESSED_SPACE": "espaciu",
    "EVENT_WHENKEYPRESSED_LEFT": "flecha izquierda",
    "EVENT_WHENKEYPRESSED_RIGHT": "flecha drecha",
    "EVENT_WHENKEYPRESSED_DOWN": "flecha abaxo",
    "EVENT_WHENKEYPRESSED_UP": "flecha arriba",
    "EVENT_WHENKEYPRESSED_ANY": "cualisquier",
    "LOOKS_SAYFORSECS": "dicir %1 durante %2 segundos",
    "LOOKS_SAY": "dicir %1",
    "LOOKS_HELLO": "¡Hola!",
    "LOOKS_THINKFORSECS": "pensar %1 durante %2 segundos",
    "LOOKS_THINK": "pensar %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "amosar",
    "LOOKS_HIDE": "anubrir",
    "LOOKS_HIDEALLSPRITES": "anubrir tolos personaxes",
    "LOOKS_EFFECT_COLOR": "color",
    "LOOKS_EFFECT_FISHEYE": "güeyu de pexe",
    "LOOKS_EFFECT_WHIRL": "torbolín",
    "LOOKS_EFFECT_PIXELATE": "pixelar",
    "LOOKS_EFFECT_MOSAIC": "mosaicu",
    "LOOKS_EFFECT_BRIGHTNESS": "brillu",
    "LOOKS_EFFECT_GHOST": "pantasma",
    "LOOKS_CHANGEEFFECTBY": "cambiar l'efectu %1 por %2",
    "LOOKS_SETEFFECTTO": "poner l'efectu %1 a %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "llimpiar efeutos gráficos",
    "LOOKS_CHANGESIZEBY": "cambiar tamañu por %1",
    "LOOKS_SETSIZETO": "poner tamañu a %1",
    "LOOKS_SIZE": "tamañu",
    "LOOKS_CHANGESTRETCHBY": "cambiar tramu po %1",
    "LOOKS_SETSTRETCHTO": "poner tramu a %1 %",
    "LOOKS_SWITCHCOSTUMETO": "cambiar disfraz a %1",
    "LOOKS_NEXTCOSTUME": "siguiente disfraz",
    "LOOKS_SWITCHBACKDROPTO": "cambiar fondu a %1",
    "LOOKS_GOTOFRONTBACK": "dir a la capa %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "frente",
    "LOOKS_GOTOFRONTBACK_BACK": "atrás",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "dir %1 %2 caoes",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "p'alantre",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "p'atrás",
    "LOOKS_BACKDROPNUMBERNAME": "fondu %1",
    "LOOKS_COSTUMENUMBERNAME": "disfraz %1",
    "LOOKS_NUMBERNAME_NUMBER": "númberu",
    "LOOKS_NUMBERNAME_NAME": "nome",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "cambiar fondu a %1 y esperar",
    "LOOKS_NEXTBACKDROP_BLOCK": "siguiente fondu",
    "LOOKS_NEXTBACKDROP": "siguiente fondu",
    "LOOKS_PREVIOUSBACKDROP": "fondu anterior",
    "LOOKS_RANDOMBACKDROP": "fondu al debalu",
    "MOTION_MOVESTEPS": "mover %1 pasos",
    "MOTION_TURNLEFT": "xirar %1 %2 graos",
    "MOTION_TURNRIGHT": "xirar %1 %2 graos",
    "MOTION_POINTINDIRECTION": "apuntar en direicion %1",
    "MOTION_POINTTOWARDS": "apuntar a %1",
    "MOTION_POINTTOWARDS_POINTER": "punteru del mur",
    "MOTION_POINTTOWARDS_RANDOM": "direición al debalu",
    "MOTION_GOTO": "dir a %1",
    "MOTION_GOTO_POINTER": "punteru del mur",
    "MOTION_GOTO_RANDOM": "posición al debalu",
    "MOTION_GOTOXY": "dir a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "eslizar %1 seg. a x: %2 y: %3",
    "MOTION_GLIDETO": "eslizar en %1 segundos a %2",
    "MOTION_GLIDETO_POINTER": "punteru del mur",
    "MOTION_GLIDETO_RANDOM": "posición al debalu",
    "MOTION_CHANGEXBY": "cambiar x por %1",
    "MOTION_SETX": "poner x a %1",
    "MOTION_CHANGEYBY": "cambiar y por %1",
    "MOTION_SETY": "poner y a %1",
    "MOTION_IFONEDGEBOUNCE": "si ta na llende, rebotar",
    "MOTION_SETROTATIONSTYLE": "poner estilu de xiru %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "izquierda-drecha",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "nun xirar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "alredor",
    "MOTION_XPOSITION": "posición x",
    "MOTION_YPOSITION": "posición y",
    "MOTION_DIRECTION": "direición",
    "MOTION_SCROLLRIGHT": "desplazar a la drecha %1",
    "MOTION_SCROLLUP": "desplazar arriba %1",
    "MOTION_ALIGNSCENE": "alliniar escena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "abaxo izquierda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "abaxo drecha",
    "MOTION_ALIGNSCENE_MIDDLE": "metá",
    "MOTION_ALIGNSCENE_TOPLEFT": "arriba izquierda",
    "MOTION_ALIGNSCENE_TOPRIGHT": "arriba drecha",
    "MOTION_XSCROLL": "scroll x",
    "MOTION_YSCROLL": "scroll y",
    "MOTION_STAGE_SELECTED": "Escenariu seleicionáu: nun hai bloques de movimientu",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "al debalu de %1 a %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 y %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "non %1",
    "OPERATORS_JOIN": "xuntar %1 %2",
    "OPERATORS_JOIN_APPLE": "mazana",
    "OPERATORS_JOIN_BANANA": "plátanu",
    "OPERATORS_LETTEROF": "lletra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "llonxitú de %1",
    "OPERATORS_CONTAINS": "%1 contién %2?",
    "OPERATORS_MOD": "%1 restu %2",
    "OPERATORS_ROUND": "redondiar %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "suelu",
    "OPERATORS_MATHOP_CEILING": "techu",
    "OPERATORS_MATHOP_SQRT": "raíz",
    "OPERATORS_MATHOP_SIN": "sen",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definir %1",
    "SENSING_TOUCHINGOBJECT": "¿tocando %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "punteru del mur",
    "SENSING_TOUCHINGOBJECT_EDGE": "borde",
    "SENSING_TOUCHINGCOLOR": "¿tocando'l color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "¿el color %1 ta tocando %2?",
    "SENSING_DISTANCETO": "distancia a %1",
    "SENSING_DISTANCETO_POINTER": "punteru del mur",
    "SENSING_ASKANDWAIT": "Entrugar %1 y esperar",
    "SENSING_ASK_TEXT": "¿Cómo te llames?",
    "SENSING_ANSWER": "respuesta",
    "SENSING_KEYPRESSED": "¿ta calcada la tecla %1?",
    "SENSING_MOUSEDOWN": "¿tá'l mur calcáu?",
    "SENSING_MOUSEX": "x del mur",
    "SENSING_MOUSEY": "y del mur",
    "SENSING_SETDRAGMODE": "poner el mou d'arrastre %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastrable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "non arrastrable",
    "SENSING_LOUDNESS": "volume del soníu",
    "SENSING_LOUD": "¿ruidosu?",
    "SENSING_TIMER": "cronómetru",
    "SENSING_RESETTIMER": "reaniciar el cronómetru",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posición x",
    "SENSING_OF_YPOSITION": "posición y",
    "SENSING_OF_DIRECTION": "direición",
    "SENSING_OF_COSTUMENUMBER": "núm. de disfraz",
    "SENSING_OF_COSTUMENAME": "nome del disfraz",
    "SENSING_OF_SIZE": "tamañu",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "núm. de fondu",
    "SENSING_OF_BACKDROPNAME": "nombre de fondu",
    "SENSING_OF_STAGE": "Escenariu",
    "SENSING_CURRENT": "actual %1",
    "SENSING_CURRENT_YEAR": "añu",
    "SENSING_CURRENT_MONTH": "mes",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "día de la selman",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minutu",
    "SENSING_CURRENT_SECOND": "segundu",
    "SENSING_DAYSSINCE2000": "díes dende 2000",
    "SENSING_USERNAME": "nome d'usuariu",
    "SENSING_USERID": "id d'usuariu",
    "SOUND_PLAY": "tocar el soníu %1",
    "SOUND_PLAYUNTILDONE": "tocar el soníu %1 hasta qu'acabe",
    "SOUND_STOPALLSOUNDS": "parar tolos soníos",
    "SOUND_SETEFFECTO": "poner l'efectu %1 a %2",
    "SOUND_CHANGEEFFECTBY": "cambiar l'efectu %1 por %2",
    "SOUND_CLEAREFFECTS": "esborrar efeutos de soníu",
    "SOUND_EFFECTS_PITCH": "tonu",
    "SOUND_EFFECTS_PAN": "panéu izquierda/drecha",
    "SOUND_CHANGEVOLUMEBY": "cambiar volume por %1",
    "SOUND_SETVOLUMETO": "poner volume a %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "grabar...",
    "CATEGORY_MOTION": "Movimientu",
    "CATEGORY_LOOKS": "Aspeutu",
    "CATEGORY_SOUND": "Soníu",
    "CATEGORY_EVENTS": "Socesos",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensores",
    "CATEGORY_OPERATORS": "Operadores",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "Los Mios Bloques",
    "DUPLICATE": "Duplicar",
    "DELETE": "Esborrar",
    "ADD_COMMENT": "Amestar comentariu",
    "REMOVE_COMMENT": "Esborrar Comentariu",
    "DELETE_BLOCK": "Esborrar Bloque",
    "DELETE_X_BLOCKS": "Esborrar Bloques %1",
    "DELETE_ALL_BLOCKS": "¿Esborrar tolos bloques %1?",
    "CLEAN_UP": "Llimpiar Bloques",
    "HELP": "Ayuda",
    "UNDO": "Desfacer",
    "REDO": "Refacer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Dir a la definición",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Dicir dalgo...",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturación",
    "COLOUR_BRIGHTNESS_LABEL": "Brillu",
    "CHANGE_VALUE_TITLE": "Cambiar valor:",
    "RENAME_VARIABLE": "Renomar variable",
    "RENAME_VARIABLE_TITLE": "Renomar toles variables \"%1\" a:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renomar Variable",
    "NEW_VARIABLE": "Crear una Variable",
    "NEW_VARIABLE_TITLE": "Nome de la nueva variable:",
    "VARIABLE_MODAL_TITLE": "Variable Nueva",
    "VARIABLE_ALREADY_EXISTS": "Yá hai una variable llamada \"%1\".",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Yá hai una variable llamada \"%1\" para otra variable de tipu \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "¿Esborrar usos \"%1\" de la variable \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Nun se pue esborrar la variable \"%1\" porque ye parte de la definición de la función \"%2\"",
    "DELETE_VARIABLE": "Esborrar la variable \"%1\"",
    "NEW_PROCEDURE": "Crear un Bloque",
    "PROCEDURE_ALREADY_EXISTS": "Yá hai un procedimientu llamáu \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "nome del bloque",
    "PROCEDURE_USED": "Pa esborrar una definición de bloque, primerto tienes d'esborrar tolos usos del bloque",
    "NEW_LIST": "Crear una Llista",
    "NEW_LIST_TITLE": "Nome de la llista nueva:",
    "LIST_MODAL_TITLE": "Llista Nueva",
    "LIST_ALREADY_EXISTS": "Yá hai una llista llamada \"%1\".",
    "RENAME_LIST_TITLE": "Renomar toles llistes \"%1\" a:",
    "RENAME_LIST_MODAL_TITLE": "Renomar llista",
    "DEFAULT_LIST_ITEM": "cosa",
    "DELETE_LIST": "Esborrar la llista \"%1\"",
    "RENAME_LIST": "Renomar llista",
    "NEW_BROADCAST_MESSAGE": "Mensaxe nuevu",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nome del nuevu mensaxe:",
    "BROADCAST_MODAL_TITLE": "Mensaxe Nuevu",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mensaxe1"
  },
  "az": {
    "CONTROL_FOREVER": "həmişə",
    "CONTROL_REPEAT": "təkrarla %1 dəfə",
    "CONTROL_IF": "əgər %1, onda",
    "CONTROL_ELSE": "əks halda",
    "CONTROL_STOP": "dayandır",
    "CONTROL_STOP_ALL": "hamısı",
    "CONTROL_STOP_THIS": "bu skript",
    "CONTROL_STOP_OTHER": "spraytın digər skriptləri",
    "CONTROL_WAIT": "%1 saniyə gözlə",
    "CONTROL_WAITUNTIL": "%1 qədər gözlə",
    "CONTROL_REPEATUNTIL": "təkrarla nə qədər ki, %1 deyil",
    "CONTROL_WHILE": "təkrarla nə qədər ki, %1 ",
    "CONTROL_FOREACH": "hər bir %1 üçün %2 -də",
    "CONTROL_STARTASCLONE": "mən klon kimi başlayanda",
    "CONTROL_CREATECLONEOF": "%1 klonunu yarat",
    "CONTROL_CREATECLONEOF_MYSELF": "özümün",
    "CONTROL_DELETETHISCLONE": "bu klonu sil",
    "CONTROL_COUNTER": "sayğac",
    "CONTROL_INCRCOUNTER": "sayğacın göstəricisini artır",
    "CONTROL_CLEARCOUNTER": "sayğacı təmizlə",
    "CONTROL_ALLATONCE": "hamısı birlikdə",
    "DATA_SETVARIABLETO": "%1 təyin et: %2",
    "DATA_CHANGEVARIABLEBY": "%1 -i %2 qədər dəyiş",
    "DATA_SHOWVARIABLE": "%1 dəyişənini göstər",
    "DATA_HIDEVARIABLE": "%1 dəyişənini gizlət",
    "DATA_ADDTOLIST": "%1 -i %2 siyahısına əlavə et",
    "DATA_DELETEOFLIST": "%1 elementini %2 siyahısından sil",
    "DATA_DELETEALLOFLIST": "%1 siyahısının bütün elementlərini sil",
    "DATA_INSERTATLIST": "%1 elementini %2 mövqeyində %3 siyahısına daxil et",
    "DATA_REPLACEITEMOFLIST": "%1 elementini %2 siyahısında %3 ilə əvəz et",
    "DATA_ITEMOFLIST": "%1 elementi %2 siyahısından",
    "DATA_ITEMNUMOFLIST": "item # of %1 in %2",
    "DATA_LENGTHOFLIST": "%1 siyahısının uzunluğu",
    "DATA_LISTCONTAINSITEM": "%1 tərkibində %2 var?",
    "DATA_SHOWLIST": "%1 siyahısını göstər",
    "DATA_HIDELIST": "%1 siyahısını gizlət",
    "DATA_INDEX_ALL": "bütün",
    "DATA_INDEX_LAST": "son",
    "DATA_INDEX_RANDOM": "təsadüfi",
    "EVENT_WHENFLAGCLICKED": "%1 kliklənəndə",
    "EVENT_WHENTHISSPRITECLICKED": "sprayt kliklənəndə",
    "EVENT_WHENSTAGECLICKED": "səhnə kliklənəndə",
    "EVENT_WHENTOUCHINGOBJECT": "sprayt %1 toxunanda",
    "EVENT_WHENBROADCASTRECEIVED": "mən %1 qəbul edəndə",
    "EVENT_WHENBACKDROPSWITCHESTO": "fon %1 fonuna dəyişdiriləndə",
    "EVENT_WHENGREATERTHAN": "%1 > %2 olduqda",
    "EVENT_WHENGREATERTHAN_TIMER": "taymer",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "səs ucalığı",
    "EVENT_BROADCAST": "%1 ötür",
    "EVENT_BROADCASTANDWAIT": "%1 ötür və gözlə",
    "EVENT_WHENKEYPRESSED": "%1 düyməsinə basdıqda",
    "EVENT_WHENKEYPRESSED_SPACE": "boşluq",
    "EVENT_WHENKEYPRESSED_LEFT": "sol ox",
    "EVENT_WHENKEYPRESSED_RIGHT": "sağ ox",
    "EVENT_WHENKEYPRESSED_DOWN": "aşağı ox",
    "EVENT_WHENKEYPRESSED_UP": "yuxarı ox",
    "EVENT_WHENKEYPRESSED_ANY": "hər hansı",
    "LOOKS_SAYFORSECS": "%1 de %2 saniyə",
    "LOOKS_SAY": "%1 de",
    "LOOKS_HELLO": "Salam!",
    "LOOKS_THINKFORSECS": "%1 düşün %2 saniyə",
    "LOOKS_THINK": "%1 düşün",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "görün",
    "LOOKS_HIDE": "gizlən",
    "LOOKS_HIDEALLSPRITES": "bütün spraytları gizlət",
    "LOOKS_EFFECT_COLOR": "rəng",
    "LOOKS_EFFECT_FISHEYE": "qabarma",
    "LOOKS_EFFECT_WHIRL": "burulma",
    "LOOKS_EFFECT_PIXELATE": "piksel",
    "LOOKS_EFFECT_MOSAIC": "mozaika",
    "LOOKS_EFFECT_BRIGHTNESS": "parlaqlıq",
    "LOOKS_EFFECT_GHOST": "ruh",
    "LOOKS_CHANGEEFFECTBY": "%1 effektini %2 qədər dəyiş",
    "LOOKS_SETEFFECTTO": "%1 effektini %2 təyin et",
    "LOOKS_CLEARGRAPHICEFFECTS": "qrafik effektləri sil",
    "LOOKS_CHANGESIZEBY": "ölçünü %1 qədər dəyiş",
    "LOOKS_SETSIZETO": "ölçünü %1 % təyin et",
    "LOOKS_SIZE": "ölçü",
    "LOOKS_CHANGESTRETCHBY": "uzunluğu %1 qədər dəyiş",
    "LOOKS_SETSTRETCHTO": "uzunluğu %1 % təyin et",
    "LOOKS_SWITCHCOSTUMETO": "%1 libasına dəyiş",
    "LOOKS_NEXTCOSTUME": "növbəti libas",
    "LOOKS_SWITCHBACKDROPTO": "%1 fonuna dəyiş",
    "LOOKS_GOTOFRONTBACK": "%1 fonuna keç",
    "LOOKS_GOTOFRONTBACK_FRONT": "ön",
    "LOOKS_GOTOFRONTBACK_BACK": "arxa",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 fonuna keç",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "irəli",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "geri",
    "LOOKS_BACKDROPNUMBERNAME": "%1 fonu",
    "LOOKS_COSTUMENUMBERNAME": "%1 libası",
    "LOOKS_NUMBERNAME_NUMBER": "rəqəm",
    "LOOKS_NUMBERNAME_NAME": "ad",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "fonu %1 fonuna dəyiş və gözlə",
    "LOOKS_NEXTBACKDROP_BLOCK": "növbəti fon",
    "LOOKS_NEXTBACKDROP": "növbəti fon",
    "LOOKS_PREVIOUSBACKDROP": "əvvəlki fon",
    "LOOKS_RANDOMBACKDROP": "təsadüfi fon",
    "MOTION_MOVESTEPS": "%1 addım at",
    "MOTION_TURNLEFT": "dön %1 %2 dərəcə",
    "MOTION_TURNRIGHT": "dön %1 %2 dərəcə",
    "MOTION_POINTINDIRECTION": "%1 istiqamətində dön",
    "MOTION_POINTTOWARDS": "%1 tərəfinə dön",
    "MOTION_POINTTOWARDS_POINTER": "siçanın göstəricisi",
    "MOTION_POINTTOWARDS_RANDOM": "random direction",
    "MOTION_GOTO": "keç: %1",
    "MOTION_GOTO_POINTER": "siçanın göstəricisi",
    "MOTION_GOTO_RANDOM": "təsadüfi mövqe",
    "MOTION_GOTOXY": "keç: x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "%1 saniyə x: %2 y: %3 nöqtəsinə üz",
    "MOTION_GLIDETO": "%1 saniyə %2 tərəfə üz",
    "MOTION_GLIDETO_POINTER": "siçanın göstəricisi",
    "MOTION_GLIDETO_RANDOM": "təsadüfi mövqe",
    "MOTION_CHANGEXBY": "x-i %1 qədər dəyiş",
    "MOTION_SETX": "x-i %1 təyin et",
    "MOTION_CHANGEYBY": "y-i %1 qədər dəyiş",
    "MOTION_SETY": "y-i %1 təyin et",
    "MOTION_IFONEDGEBOUNCE": "kənara çatdınsa, geri çəkil",
    "MOTION_SETROTATIONSTYLE": "dönmə istiqamətini %1 təyin et",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "sol-sağ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "dönməmək",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "hər tərəfə",
    "MOTION_XPOSITION": "x mövqeyi",
    "MOTION_YPOSITION": "y mövqeyi",
    "MOTION_DIRECTION": "istiqamət",
    "MOTION_SCROLLRIGHT": "sağa doğru %1 qədər sürüş",
    "MOTION_SCROLLUP": "yuxarı doğru %1 qədər sürüş",
    "MOTION_ALIGNSCENE": "%1 istiqamətdən səhnəni düzləndir",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "aşağı-sol",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "aşağı-sağ",
    "MOTION_ALIGNSCENE_MIDDLE": "orta",
    "MOTION_ALIGNSCENE_TOPLEFT": "yuxarı-sol",
    "MOTION_ALIGNSCENE_TOPRIGHT": "yuxarı-sağ",
    "MOTION_XSCROLL": "x oxu üzrə sürüşdür",
    "MOTION_YSCROLL": "y oxu üzrə sürüşdür",
    "MOTION_STAGE_SELECTED": "Səhnə seçilmişdir: Hərəkət blokları yoxdur",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 və %2 arasında təsadüfi seç",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 və %2",
    "OPERATORS_OR": "%1 və ya %2",
    "OPERATORS_NOT": "%1 deyil ",
    "OPERATORS_JOIN": "birləşdir: %1 və %2",
    "OPERATORS_JOIN_APPLE": "alma",
    "OPERATORS_JOIN_BANANA": "banan",
    "OPERATORS_LETTEROF": "hərf %1 %2-də",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "%1 sözünün uzunluğu",
    "OPERATORS_CONTAINS": "%1 sözünün tərkibində %2 hərfi var?",
    "OPERATORS_MOD": "%1 ədədinin %2 ədədinə bölünməsindən qalıq",
    "OPERATORS_ROUND": "%1 yuvarlaqlaşdır",
    "OPERATORS_MATHOP": "%1 %2",
    "OPERATORS_MATHOP_ABS": "modul",
    "OPERATORS_MATHOP_FLOOR": "aşağı yuvarlaqlaşdır",
    "OPERATORS_MATHOP_CEILING": "yuxarı yuvarlaqlaşdır",
    "OPERATORS_MATHOP_SQRT": "kvadrat kök",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tg",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctg",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "%1 təyin et",
    "SENSING_TOUCHINGOBJECT": "%1 toxunur?",
    "SENSING_TOUCHINGOBJECT_POINTER": "siçanın göstəricisi",
    "SENSING_TOUCHINGOBJECT_EDGE": "kənar",
    "SENSING_TOUCHINGCOLOR": "%1 rənginə toxunur?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 rəngi %2 rənginə toxunur?",
    "SENSING_DISTANCETO": "%1 qədər məsafə",
    "SENSING_DISTANCETO_POINTER": "siçanın göstəricisi",
    "SENSING_ASKANDWAIT": "%1 soruş və gözlə",
    "SENSING_ASK_TEXT": "Sənin adın nədir?",
    "SENSING_ANSWER": "cavab",
    "SENSING_KEYPRESSED": "%1 düyməsi basılıb?",
    "SENSING_MOUSEDOWN": "siçanın düyməsi basılıb?",
    "SENSING_MOUSEX": "siçanın göstəricisinin x koordinatı",
    "SENSING_MOUSEY": "siçanın göstəricisinin y koordinatı",
    "SENSING_SETDRAGMODE": "%1 daşıma rejimi təyin et",
    "SENSING_SETDRAGMODE_DRAGGABLE": "daşınabilən",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "daşınabilməyən",
    "SENSING_LOUDNESS": "səs ucalığı",
    "SENSING_LOUD": "ucadır?",
    "SENSING_TIMER": "taymer",
    "SENSING_RESETTIMER": "taymeri yenidən başlat",
    "SENSING_OF": "%1 %2-in",
    "SENSING_OF_XPOSITION": "x mövqeyi",
    "SENSING_OF_YPOSITION": "y mövqeyi",
    "SENSING_OF_DIRECTION": "istiqamət",
    "SENSING_OF_COSTUMENUMBER": "libas #",
    "SENSING_OF_COSTUMENAME": "libasın adı",
    "SENSING_OF_SIZE": "ölçü",
    "SENSING_OF_VOLUME": "səsin yüksəkliyi",
    "SENSING_OF_BACKDROPNUMBER": "fon #",
    "SENSING_OF_BACKDROPNAME": "fonun adı",
    "SENSING_OF_STAGE": "Səhnə",
    "SENSING_CURRENT": "cari %1",
    "SENSING_CURRENT_YEAR": "il",
    "SENSING_CURRENT_MONTH": "ay",
    "SENSING_CURRENT_DATE": "tarix",
    "SENSING_CURRENT_DAYOFWEEK": "həftənin günü",
    "SENSING_CURRENT_HOUR": "saat",
    "SENSING_CURRENT_MINUTE": "dəqiqə",
    "SENSING_CURRENT_SECOND": "saniyə",
    "SENSING_DAYSSINCE2000": "01.01.2000 tarixindən ötən günlərin sayı",
    "SENSING_USERNAME": "istifadəçinin adı",
    "SENSING_USERID": "istifadəçi adı",
    "SOUND_PLAY": "%1 səsini ifa et",
    "SOUND_PLAYUNTILDONE": "%1 səsini sona qədər ifa et",
    "SOUND_STOPALLSOUNDS": "bütün səsləri dayandır",
    "SOUND_SETEFFECTO": "%1 effektini %2 təyin et",
    "SOUND_CHANGEEFFECTBY": "%1 effektini %2 qədər dəyiş",
    "SOUND_CLEAREFFECTS": "səs effektlərini təmizlə",
    "SOUND_EFFECTS_PITCH": "kökləmək",
    "SOUND_EFFECTS_PAN": "tas sol/sağ",
    "SOUND_CHANGEVOLUMEBY": "səs ucalığını %1 qədər dəyiş",
    "SOUND_SETVOLUMETO": "səs ucalığını %1% təyin et",
    "SOUND_VOLUME": "səsin yüksəkliyi",
    "SOUND_RECORD": "record...",
    "CATEGORY_MOTION": "Hərəkət",
    "CATEGORY_LOOKS": "Görünüş",
    "CATEGORY_SOUND": "Səs",
    "CATEGORY_EVENTS": "Hadisələr",
    "CATEGORY_CONTROL": "İdarəetmə",
    "CATEGORY_SENSING": "Sensorlar",
    "CATEGORY_OPERATORS": "Operatorlar",
    "CATEGORY_VARIABLES": "Dəyişənlər",
    "CATEGORY_MYBLOCKS": "Mənim Bloklarım",
    "DUPLICATE": "Dublikatın yarat",
    "DELETE": "Sil",
    "ADD_COMMENT": "Şərh əlavə et",
    "REMOVE_COMMENT": "Şərhi sil",
    "DELETE_BLOCK": "Bloku sil",
    "DELETE_X_BLOCKS": "%1 bloklarını sil",
    "DELETE_ALL_BLOCKS": "bütün %1 bloklarını sil",
    "CLEAN_UP": "Blokları sil",
    "HELP": "Yardım",
    "UNDO": "Ləğv et",
    "REDO": "Yenidən",
    "EDIT_PROCEDURE": "Düzəliş et",
    "SHOW_PROCEDURE_DEFINITION": "Tərifə get",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Nəsə de ...",
    "COLOUR_HUE_LABEL": "Rəng",
    "COLOUR_SATURATION_LABEL": "Dolğunluq",
    "COLOUR_BRIGHTNESS_LABEL": "Parlaqlıq",
    "CHANGE_VALUE_TITLE": "Qiyməti dəyiş",
    "RENAME_VARIABLE": "Dəyişənin adını dəyiş",
    "RENAME_VARIABLE_TITLE": "Bütün \"%1\" dəyişənlərinin adını dəyiş:",
    "RENAME_VARIABLE_MODAL_TITLE": "Dəyişənin adını dəyiş",
    "NEW_VARIABLE": "Dəyişən yarat",
    "NEW_VARIABLE_TITLE": "Yeni dəyişənin adı:",
    "VARIABLE_MODAL_TITLE": "Yeni Dəyişən",
    "VARIABLE_ALREADY_EXISTS": "\"%1\" adlı dəyişən artıq mövcuddur.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "\"%1\" adlı dəyişən digər \"%2\" növ dəyişən üçün artıq mövcuddur.",
    "DELETE_VARIABLE_CONFIRMATION": "%1 silinsin \"%2\" dəyişənini istifadə edən?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "\"%1\" dəyişəni silinə bilmir, çünki \"%2\" funksiyasındakı tərifin bir hissəsidir",
    "DELETE_VARIABLE": "\"%1\" dəyişənini sil",
    "NEW_PROCEDURE": "Blok yarat",
    "PROCEDURE_ALREADY_EXISTS": "\"%1\" adlı prosedur artıq mövcuddur.",
    "PROCEDURE_DEFAULT_NAME": "blokun adı",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Siyahı yarat",
    "NEW_LIST_TITLE": "Yeni siyahının adı:",
    "LIST_MODAL_TITLE": "Yeni siyahı",
    "LIST_ALREADY_EXISTS": "\"%1\" adlı siyahı artıq mövcuddur.",
    "RENAME_LIST_TITLE": "Bütün \"%1\" siyahılarının adını dəyiş:",
    "RENAME_LIST_MODAL_TITLE": "Siyahının adını dəyiş",
    "DEFAULT_LIST_ITEM": "əşya",
    "DELETE_LIST": "Delete the \"%1\" list",
    "RENAME_LIST": "Rename list",
    "NEW_BROADCAST_MESSAGE": "Yeni ismarıc",
    "NEW_BROADCAST_MESSAGE_TITLE": "Yeni ismarıcın adı:",
    "BROADCAST_MODAL_TITLE": "Yeni ismarıc",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "ismarıc 1"
  },
  "id": {
    "CONTROL_FOREVER": "selamanya",
    "CONTROL_REPEAT": "ulangi %1 kali",
    "CONTROL_IF": "jika %1",
    "CONTROL_ELSE": "jika tidak",
    "CONTROL_STOP": "berhenti",
    "CONTROL_STOP_ALL": "semua",
    "CONTROL_STOP_THIS": "skrip ini",
    "CONTROL_STOP_OTHER": "skrip lain di sprite ini",
    "CONTROL_WAIT": "tunggu %1 detik",
    "CONTROL_WAITUNTIL": "tunggu sampai %1",
    "CONTROL_REPEATUNTIL": "ulangi sampai %1",
    "CONTROL_WHILE": "selama %1",
    "CONTROL_FOREACH": "untuk setiap %1 dalam %2",
    "CONTROL_STARTASCLONE": "ketika aku mulai sebagai clone",
    "CONTROL_CREATECLONEOF": "buat clone dari %1",
    "CONTROL_CREATECLONEOF_MYSELF": "diriku",
    "CONTROL_DELETETHISCLONE": "hapus clone ini",
    "CONTROL_COUNTER": "hitungan",
    "CONTROL_INCRCOUNTER": "tingkatkan hitungan",
    "CONTROL_CLEARCOUNTER": "bersihkan hitungan",
    "CONTROL_ALLATONCE": "semuanya sekaligus",
    "DATA_SETVARIABLETO": "atur %1 ke %2",
    "DATA_CHANGEVARIABLEBY": "ubah %1 sebesar %2",
    "DATA_SHOWVARIABLE": "tampilkan variabel %1",
    "DATA_HIDEVARIABLE": "sembunyikan variabel %1",
    "DATA_ADDTOLIST": "tambahkan %1 ke %2",
    "DATA_DELETEOFLIST": "hapus %1 dari %2",
    "DATA_DELETEALLOFLIST": "hapus semua dari %1",
    "DATA_INSERTATLIST": "sisipkan %1 pada %2 dari %3",
    "DATA_REPLACEITEMOFLIST": "ganti benda %1 dari %2 dengan %3",
    "DATA_ITEMOFLIST": "benda %1 dari %2",
    "DATA_ITEMNUMOFLIST": "benda # dari %1 di %2",
    "DATA_LENGTHOFLIST": "panjang dari %1",
    "DATA_LISTCONTAINSITEM": "%1 berisi %2?",
    "DATA_SHOWLIST": "tampilkan daftar %1",
    "DATA_HIDELIST": "sembunyikan daftar %1",
    "DATA_INDEX_ALL": "semua",
    "DATA_INDEX_LAST": "terakhir",
    "DATA_INDEX_RANDOM": "sembarang",
    "EVENT_WHENFLAGCLICKED": "ketika %1 diklik",
    "EVENT_WHENTHISSPRITECLICKED": "ketika sprite ini diklik",
    "EVENT_WHENSTAGECLICKED": "ketika panggung diklik",
    "EVENT_WHENTOUCHINGOBJECT": "ketika sprite ini menyentuh %1",
    "EVENT_WHENBROADCASTRECEIVED": "ketika aku menerima %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "ketika latar menjadi %1",
    "EVENT_WHENGREATERTHAN": "ketika %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "pengatur waktu",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "kenyaringan",
    "EVENT_BROADCAST": "siarkan %1",
    "EVENT_BROADCASTANDWAIT": "siarkan %1 dan tunggu",
    "EVENT_WHENKEYPRESSED": "ketika tombol %1 ditekan",
    "EVENT_WHENKEYPRESSED_SPACE": "spasi",
    "EVENT_WHENKEYPRESSED_LEFT": "panah kiri",
    "EVENT_WHENKEYPRESSED_RIGHT": "panah kanan",
    "EVENT_WHENKEYPRESSED_DOWN": "panah bawah",
    "EVENT_WHENKEYPRESSED_UP": "panah atas",
    "EVENT_WHENKEYPRESSED_ANY": "manapun",
    "LOOKS_SAYFORSECS": "katakan %1 selama %2 detik",
    "LOOKS_SAY": "katakan %1",
    "LOOKS_HELLO": "Halo!",
    "LOOKS_THINKFORSECS": "pikirkan %1 selama %2 detik",
    "LOOKS_THINK": "pikirkan %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "tampilkan",
    "LOOKS_HIDE": "sembunyikan",
    "LOOKS_HIDEALLSPRITES": "sembunyikan semua sprite",
    "LOOKS_EFFECT_COLOR": "warna",
    "LOOKS_EFFECT_FISHEYE": "mata ikan",
    "LOOKS_EFFECT_WHIRL": "pusaran",
    "LOOKS_EFFECT_PIXELATE": "pixelasi",
    "LOOKS_EFFECT_MOSAIC": "mosaik",
    "LOOKS_EFFECT_BRIGHTNESS": "kecerahan",
    "LOOKS_EFFECT_GHOST": "bayangan",
    "LOOKS_CHANGEEFFECTBY": "ubah efek %1 sebesar %2",
    "LOOKS_SETEFFECTTO": "atur efek %1 ke %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "hapus semua efek grafis",
    "LOOKS_CHANGESIZEBY": "ubah ukuran sebesar %1",
    "LOOKS_SETSIZETO": "atur ukuran ke %1 %",
    "LOOKS_SIZE": "ukuran",
    "LOOKS_CHANGESTRETCHBY": "ubah rentangan sebesar %1",
    "LOOKS_SETSTRETCHTO": "atur rentangan ke %1 %",
    "LOOKS_SWITCHCOSTUMETO": "ganti kostum ke %1",
    "LOOKS_NEXTCOSTUME": "kostum berikutnya",
    "LOOKS_SWITCHBACKDROPTO": "ganti latar ke %1",
    "LOOKS_GOTOFRONTBACK": "pergi ke lapisan %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "depan",
    "LOOKS_GOTOFRONTBACK_BACK": "belakang",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "pergi %1 %2 lapisan",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "maju",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "mundur",
    "LOOKS_BACKDROPNUMBERNAME": "latar %1",
    "LOOKS_COSTUMENUMBERNAME": "%1 kostum",
    "LOOKS_NUMBERNAME_NUMBER": "angka",
    "LOOKS_NUMBERNAME_NAME": "nama",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "ganti latar ke %1 dan tunggu",
    "LOOKS_NEXTBACKDROP_BLOCK": "latar berikutnya",
    "LOOKS_NEXTBACKDROP": "latar berikutnya",
    "LOOKS_PREVIOUSBACKDROP": "latar sebelumnya",
    "LOOKS_RANDOMBACKDROP": "latar sembarang",
    "MOTION_MOVESTEPS": "gerak %1 langkah",
    "MOTION_TURNLEFT": "putar %1 %2 derajat",
    "MOTION_TURNRIGHT": "putar %1 %2 derajat",
    "MOTION_POINTINDIRECTION": "mengarah ke arah %1",
    "MOTION_POINTTOWARDS": "mengarah ke %1",
    "MOTION_POINTTOWARDS_POINTER": "pointer-mouse",
    "MOTION_POINTTOWARDS_RANDOM": "arah sembarang",
    "MOTION_GOTO": "pergi ke %1",
    "MOTION_GOTO_POINTER": "pointer-mouse",
    "MOTION_GOTO_RANDOM": "posisi sembarang",
    "MOTION_GOTOXY": "pergi ke x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "meluncur %1 detik ke x: %2 y: %3",
    "MOTION_GLIDETO": "meluncur %1 detik ke %2",
    "MOTION_GLIDETO_POINTER": "pointer-mouse",
    "MOTION_GLIDETO_RANDOM": "posisi sembarang",
    "MOTION_CHANGEXBY": "ubah x sebesar %1",
    "MOTION_SETX": "atur x ke %1",
    "MOTION_CHANGEYBY": "ubah y sebesar %1",
    "MOTION_SETY": "atur y ke %1",
    "MOTION_IFONEDGEBOUNCE": "jika di pinggir, pantulkan",
    "MOTION_SETROTATIONSTYLE": "atur gaya rotasi %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "kiri-kanan",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "jangan berputar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "seluruh",
    "MOTION_XPOSITION": "posisi x",
    "MOTION_YPOSITION": "posisi y",
    "MOTION_DIRECTION": "arah",
    "MOTION_SCROLLRIGHT": "gulir ke kanan %1",
    "MOTION_SCROLLUP": "gulir ke atas %1",
    "MOTION_ALIGNSCENE": "luruskan pemandangan %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "kiri-bawah",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "kanan-bawah",
    "MOTION_ALIGNSCENE_MIDDLE": "tengah",
    "MOTION_ALIGNSCENE_TOPLEFT": "kiri-atas",
    "MOTION_ALIGNSCENE_TOPRIGHT": "kanan-atas",
    "MOTION_XSCROLL": "guliran x",
    "MOTION_YSCROLL": "guliran y",
    "MOTION_STAGE_SELECTED": "Panggung terpilih: tidak ada balok gerakan",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "pilih acak dari %1 hingga %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 dan %2",
    "OPERATORS_OR": "%1 atau %2",
    "OPERATORS_NOT": "tidak %1",
    "OPERATORS_JOIN": "gabungkan %1 %2",
    "OPERATORS_JOIN_APPLE": "apel",
    "OPERATORS_JOIN_BANANA": "pisang",
    "OPERATORS_LETTEROF": "huruf %1 dari %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "panjang dari %1",
    "OPERATORS_CONTAINS": "%1 berisi %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "bulatkan %1",
    "OPERATORS_MATHOP": "%1 dari %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "floor",
    "OPERATORS_MATHOP_CEILING": "ceil",
    "OPERATORS_MATHOP_SQRT": "akar kuadrat",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "artikan %1",
    "SENSING_TOUCHINGOBJECT": "menyentuh %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "pointer-mouse",
    "SENSING_TOUCHINGOBJECT_EDGE": "pinggir",
    "SENSING_TOUCHINGCOLOR": "menyentuh warna %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "warna %1 menyentuh %2?",
    "SENSING_DISTANCETO": "jarak dari %1",
    "SENSING_DISTANCETO_POINTER": "pointer-mouse",
    "SENSING_ASKANDWAIT": "tanya %1 dan tunggu",
    "SENSING_ASK_TEXT": "Apa namamu?",
    "SENSING_ANSWER": "jawaban",
    "SENSING_KEYPRESSED": "tombol %1 ditekan?",
    "SENSING_MOUSEDOWN": "mouse ditekan?",
    "SENSING_MOUSEX": "x mouse",
    "SENSING_MOUSEY": "y mouse",
    "SENSING_SETDRAGMODE": "atur mode seret %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "dapat diseret",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "tidak dapat diseret",
    "SENSING_LOUDNESS": "kenyaringan",
    "SENSING_LOUD": "nyaring?",
    "SENSING_TIMER": "pengatur waktu",
    "SENSING_RESETTIMER": "atur ulang pengatur waktu",
    "SENSING_OF": "%1 dari %2",
    "SENSING_OF_XPOSITION": "posisi x",
    "SENSING_OF_YPOSITION": "posisi y",
    "SENSING_OF_DIRECTION": "arah",
    "SENSING_OF_COSTUMENUMBER": "# kostum",
    "SENSING_OF_COSTUMENAME": "nama kostum",
    "SENSING_OF_SIZE": "ukuran",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "latar #",
    "SENSING_OF_BACKDROPNAME": "nama latar",
    "SENSING_OF_STAGE": "Panggung",
    "SENSING_CURRENT": "%1 saat ini",
    "SENSING_CURRENT_YEAR": "tahun",
    "SENSING_CURRENT_MONTH": "bulan",
    "SENSING_CURRENT_DATE": "tanggal",
    "SENSING_CURRENT_DAYOFWEEK": "nama hari",
    "SENSING_CURRENT_HOUR": "jam",
    "SENSING_CURRENT_MINUTE": "menit",
    "SENSING_CURRENT_SECOND": "detik",
    "SENSING_DAYSSINCE2000": "hari-hari sejak 2000",
    "SENSING_USERNAME": "nama pengguna",
    "SENSING_USERID": "id pengguna",
    "SOUND_PLAY": "mulai suara %1",
    "SOUND_PLAYUNTILDONE": "mainkan suara %1 sampai selesai",
    "SOUND_STOPALLSOUNDS": "hentikan semua suara",
    "SOUND_SETEFFECTO": "atur efek %1 ke %2",
    "SOUND_CHANGEEFFECTBY": "ubah efek %1 sebesar %2",
    "SOUND_CLEAREFFECTS": "hapus semua efek suara",
    "SOUND_EFFECTS_PITCH": "nada",
    "SOUND_EFFECTS_PAN": "pan kiri/kanan",
    "SOUND_CHANGEVOLUMEBY": "ubah volume sebesar %1",
    "SOUND_SETVOLUMETO": "atur volume ke %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "rekam...",
    "CATEGORY_MOTION": "Gerakan",
    "CATEGORY_LOOKS": "Tampilan",
    "CATEGORY_SOUND": "Suara",
    "CATEGORY_EVENTS": "Kejadian",
    "CATEGORY_CONTROL": "Kontrol",
    "CATEGORY_SENSING": "Sensor",
    "CATEGORY_OPERATORS": "Operator",
    "CATEGORY_VARIABLES": "Variabel",
    "CATEGORY_MYBLOCKS": "Balok Saya",
    "DUPLICATE": "Gandakan",
    "DELETE": "Hapus",
    "ADD_COMMENT": "Tambahkan Komentar",
    "REMOVE_COMMENT": "Hapus Komentar",
    "DELETE_BLOCK": "Hapus Balok",
    "DELETE_X_BLOCKS": "Hapus %1 Balok",
    "DELETE_ALL_BLOCKS": "Hapus semua %1 balok?",
    "CLEAN_UP": "Bersihkan Balok-Balok",
    "HELP": "Bantuan",
    "UNDO": "Batalkan",
    "REDO": "Ulangi",
    "EDIT_PROCEDURE": "Edit",
    "SHOW_PROCEDURE_DEFINITION": "Pergi ke pengartian",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Katakan sesuatu...",
    "COLOUR_HUE_LABEL": "Warna",
    "COLOUR_SATURATION_LABEL": "Saturasi",
    "COLOUR_BRIGHTNESS_LABEL": "Keterangan",
    "CHANGE_VALUE_TITLE": "Ubah nilai:",
    "RENAME_VARIABLE": "Namakan ulang variabel",
    "RENAME_VARIABLE_TITLE": "Namakan ulang semua variabel \"%1\" ke:",
    "RENAME_VARIABLE_MODAL_TITLE": "Namakan Ulang Variabel",
    "NEW_VARIABLE": "Buat sebuah Variabel",
    "NEW_VARIABLE_TITLE": "Nama variabel baru:",
    "VARIABLE_MODAL_TITLE": "Variabel Baru",
    "VARIABLE_ALREADY_EXISTS": "Sebuah variabel bernama \"%1\" sudah ada.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Sebuah variabel bernama \"%1\" sudah ada untuk variabel lain berjenis \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Hapus penggunaan %1 dari variabel \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Tidak bisa menghapus variabel \"%1\" karena bagian dari pengartian fungsi \"%2\"",
    "DELETE_VARIABLE": "Hapus variabel \"%1\"",
    "NEW_PROCEDURE": "Buat sebuah Balok",
    "PROCEDURE_ALREADY_EXISTS": "Sebuah prosedur bernama \"%1\" sudah ada",
    "PROCEDURE_DEFAULT_NAME": "nama balok",
    "PROCEDURE_USED": "Untuk menghapus sebuah definisi balok, pertama hapus semua penggunaan balok tersebut",
    "NEW_LIST": "Buat sebuah Daftar",
    "NEW_LIST_TITLE": "Nama daftar baru:",
    "LIST_MODAL_TITLE": "Daftar Baru",
    "LIST_ALREADY_EXISTS": "Sebuah daftar bernama \"%1\" sudah ada.",
    "RENAME_LIST_TITLE": "Namakan ulang semua daftar \"%1\" ke:",
    "RENAME_LIST_MODAL_TITLE": "Namakan Ulang Daftar:",
    "DEFAULT_LIST_ITEM": "benda",
    "DELETE_LIST": "Hapus daftar \"%1\"",
    "RENAME_LIST": "Namakan ulang daftar",
    "NEW_BROADCAST_MESSAGE": "Pesan baru",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nama pesan baru:",
    "BROADCAST_MODAL_TITLE": "Pesan Baru",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "pesan1"
  },
  "bn": {
    "CONTROL_FOREVER": "চিরকালের জন্য",
    "CONTROL_REPEAT": "পুনরাবৃত্তি %1 বার",
    "CONTROL_IF": "যদি %1 তাহলে",
    "CONTROL_ELSE": "অন্যথায়",
    "CONTROL_STOP": "থামাও",
    "CONTROL_STOP_ALL": "সব",
    "CONTROL_STOP_THIS": "এই স্ক্রিপ্ট",
    "CONTROL_STOP_OTHER": "স্প্রাইটে অন্যান্য স্ক্রিপ্টসমূহ",
    "CONTROL_WAIT": "%1 সেকেন্ড অপেক্ষা কর",
    "CONTROL_WAITUNTIL": "%1 পর্যন্ত অপেক্ষা কর",
    "CONTROL_REPEATUNTIL": "%1 পর্যন্ত পুনরাবৃত্তি কর",
    "CONTROL_WHILE": "যখন %1",
    "CONTROL_FOREACH": "%2 এর প্রতিটি %1 এর জন্য",
    "CONTROL_STARTASCLONE": "যখন আমি একটি ক্লোন হয়ে শুরু করি",
    "CONTROL_CREATECLONEOF": "%1 এর ক্লোন তৈরি কর",
    "CONTROL_CREATECLONEOF_MYSELF": "নিজ",
    "CONTROL_DELETETHISCLONE": "ক্লোনটি অপসারণ কর",
    "CONTROL_COUNTER": "কাউন্টার",
    "CONTROL_INCRCOUNTER": "বৃদ্ধি গণনাকারী",
    "CONTROL_CLEARCOUNTER": "কাউন্টার মুছে ফেল",
    "CONTROL_ALLATONCE": "সব একবারে",
    "DATA_SETVARIABLETO": "%1 %2 নির্ধারণ কর",
    "DATA_CHANGEVARIABLEBY": "%1 %2 করে পরিবর্তন কর",
    "DATA_SHOWVARIABLE": "ভ্যারিয়েবল %1 দেখাও",
    "DATA_HIDEVARIABLE": "ভ্যারিয়েবল %1 লুকাও",
    "DATA_ADDTOLIST": "%2 এর সাথে %1 যোগ কর",
    "DATA_DELETEOFLIST": "%2 এর %1 অপসারণ কর",
    "DATA_DELETEALLOFLIST": "সব %1 অপসারণ কর",
    "DATA_INSERTATLIST": "%3 এর %2 এ %1 ঢুকাও",
    "DATA_REPLACEITEMOFLIST": "%2 এর %1 আইটেমকে %3 দ্বারা প্রতিস্থাপন কর",
    "DATA_ITEMOFLIST": "%2 এর মধ্যে %1",
    "DATA_ITEMNUMOFLIST": "%2 এর মধ্যে %1 এর আইটেম #",
    "DATA_LENGTHOFLIST": "%1 শব্দের দৈর্ঘ্য",
    "DATA_LISTCONTAINSITEM": "%1 এর মধ্যে কি %2 আছে?",
    "DATA_SHOWLIST": "%1 তালিকা প্রদর্শন কর",
    "DATA_HIDELIST": "%1 তালিকা লুকাও ",
    "DATA_INDEX_ALL": "সব",
    "DATA_INDEX_LAST": "শেষ",
    "DATA_INDEX_RANDOM": "যেকোন",
    "EVENT_WHENFLAGCLICKED": "যখন %1 ক্লিক করা হয়",
    "EVENT_WHENTHISSPRITECLICKED": "যখন স্প্রাইটে ক্লিক করা হবে",
    "EVENT_WHENSTAGECLICKED": "যখন মঞ্চে ক্লিক করব",
    "EVENT_WHENTOUCHINGOBJECT": "যখন এই স্প্রাইট %1 স্পর্শ করে",
    "EVENT_WHENBROADCASTRECEIVED": "যখন আমি %1 পাই",
    "EVENT_WHENBACKDROPSWITCHESTO": "যখন ব্যাকড্রপ %1 এ পরিবর্তন হয়",
    "EVENT_WHENGREATERTHAN": "যখন %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "সময়",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "শব্দের তীব্রতা",
    "EVENT_BROADCAST": "সম্প্রচার কর %1 ",
    "EVENT_BROADCASTANDWAIT": "%1 সম্প্রচার করে অপেক্ষা কর",
    "EVENT_WHENKEYPRESSED": "যখন %1 কী চাপা হয়",
    "EVENT_WHENKEYPRESSED_SPACE": "স্পেস",
    "EVENT_WHENKEYPRESSED_LEFT": "বামমুখী অ্যারো",
    "EVENT_WHENKEYPRESSED_RIGHT": "ডানমুখী অ্যারো",
    "EVENT_WHENKEYPRESSED_DOWN": "নিম্নমুখী অ্যারো",
    "EVENT_WHENKEYPRESSED_UP": "ঊর্ধ্বমুখী অ্যারো",
    "EVENT_WHENKEYPRESSED_ANY": "যেকোন",
    "LOOKS_SAYFORSECS": "%2 সেকেন্ডের জন্য %1 বল",
    "LOOKS_SAY": "বল %1 ",
    "LOOKS_HELLO": "হ্যালো!",
    "LOOKS_THINKFORSECS": "%2 সেকেন্ডের জন্য %1 চিন্তা কর",
    "LOOKS_THINK": "%1 চিন্তা কর",
    "LOOKS_HMM": "হুম...",
    "LOOKS_SHOW": "দেখাও",
    "LOOKS_HIDE": "লুকাও",
    "LOOKS_HIDEALLSPRITES": "সব স্প্রাইটগুলো লুকিয়ে রাখ",
    "LOOKS_EFFECT_COLOR": "রঙ",
    "LOOKS_EFFECT_FISHEYE": "মাছের চোখ",
    "LOOKS_EFFECT_WHIRL": "ঘূর্ণন",
    "LOOKS_EFFECT_PIXELATE": "pixelate",
    "LOOKS_EFFECT_MOSAIC": "মোজাইক",
    "LOOKS_EFFECT_BRIGHTNESS": "উজ্জ্বলতা",
    "LOOKS_EFFECT_GHOST": "ভূত",
    "LOOKS_CHANGEEFFECTBY": "%1 এর ইফেক্ট %2 পরিবর্তন কর",
    "LOOKS_SETEFFECTTO": "%1 এর ইফেক্ট %2 নির্ধারণ কর",
    "LOOKS_CLEARGRAPHICEFFECTS": "গ্রাফিক ইফেক্ট মুছে ফেল",
    "LOOKS_CHANGESIZEBY": "%1 করে আকার পরিবর্তন কর",
    "LOOKS_SETSIZETO": "%1 % আকার নির্ধারণ কর",
    "LOOKS_SIZE": "আকার",
    "LOOKS_CHANGESTRETCHBY": "%1 করে বিস্তার পরিবর্তন কর",
    "LOOKS_SETSTRETCHTO": "বিস্তার  %1 % পর্যন্ত নির্ধারণ কর",
    "LOOKS_SWITCHCOSTUMETO": "পোশাক %1 এ পরিবর্তন কর",
    "LOOKS_NEXTCOSTUME": "পরবর্তী পোশাক",
    "LOOKS_SWITCHBACKDROPTO": "ব্যাকড্রপ %1 এ পরিবর্তন কর",
    "LOOKS_GOTOFRONTBACK": "%1 স্তরে যাও",
    "LOOKS_GOTOFRONTBACK_FRONT": "সামনে",
    "LOOKS_GOTOFRONTBACK_BACK": "পিছনে",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 স্তরে যাও",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "সামনের",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "পিছনে",
    "LOOKS_BACKDROPNUMBERNAME": "ব্যাকড্রপ %1",
    "LOOKS_COSTUMENUMBERNAME": "পোশাক %1",
    "LOOKS_NUMBERNAME_NUMBER": "সংখ্যা",
    "LOOKS_NUMBERNAME_NAME": "নাম",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "ব্যাকড্রপ %1 এ পরিবর্তন করে অপেক্ষা কর",
    "LOOKS_NEXTBACKDROP_BLOCK": "পরবর্তী ব্যাকড্রপ",
    "LOOKS_NEXTBACKDROP": "পরবর্তী ব্যাকড্রপ",
    "LOOKS_PREVIOUSBACKDROP": "পূর্ববর্তী ব্যাকড্রপ",
    "LOOKS_RANDOMBACKDROP": "যেকোন ব্যাকড্রপ",
    "MOTION_MOVESTEPS": "%1 ধাপ পরিবর্তন কর",
    "MOTION_TURNLEFT": "%1 %2 ডিগ্রী ঘুর",
    "MOTION_TURNRIGHT": "%1 %2 ডিগ্রী ঘুর",
    "MOTION_POINTINDIRECTION": "দিক %1 নির্দেশ কর",
    "MOTION_POINTTOWARDS": "%1 এর দিকে নির্দেশ কর",
    "MOTION_POINTTOWARDS_POINTER": "মাউস-পয়েন্টার",
    "MOTION_POINTTOWARDS_RANDOM": "যেকোন দিক",
    "MOTION_GOTO": "%1 যাও",
    "MOTION_GOTO_POINTER": "মাউস-পয়েন্টার",
    "MOTION_GOTO_RANDOM": "যেকোনো অবস্থানে",
    "MOTION_GOTOXY": "x: %1 y: %2 এ যাও",
    "MOTION_GLIDESECSTOXY": "গ্লাইড কর %1 সেকেন্ড x: %2 y: %3 পর্যন্ত ",
    "MOTION_GLIDETO": "গ্লাইড কর %1 সেকেন্ড %2 পর্যন্ত ",
    "MOTION_GLIDETO_POINTER": "মাউস-পয়েন্টারে",
    "MOTION_GLIDETO_RANDOM": "যেকোনো অবস্থান",
    "MOTION_CHANGEXBY": "x কে %1 করে পরিবর্তন কর",
    "MOTION_SETX": "x এর মান %1 নির্ধারণ কর",
    "MOTION_CHANGEYBY": " y কে %1 করে পরিবর্তন কর",
    "MOTION_SETY": "y এর মান %1 নির্ধারণ কর",
    "MOTION_IFONEDGEBOUNCE": "যদি কিনারে পৌঁছায়, তাহলে লাফাও",
    "MOTION_SETROTATIONSTYLE": "ঘূর্ণনের ধরন %1 ",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "বাম-ডান",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ঘুর না",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "চারদিকে",
    "MOTION_XPOSITION": "x এর অবস্থান",
    "MOTION_YPOSITION": "y এর অবস্থান",
    "MOTION_DIRECTION": "দিক",
    "MOTION_SCROLLRIGHT": "ডানে %1 স্ক্রল কর",
    "MOTION_SCROLLUP": "%1 উপরে নাও",
    "MOTION_ALIGNSCENE": "%1 সারিবদ্ধ দৃশ্য ",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "নীচে-বামে",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "নীচে-ডানে",
    "MOTION_ALIGNSCENE_MIDDLE": "মধ্য",
    "MOTION_ALIGNSCENE_TOPLEFT": "উপরে-বামে",
    "MOTION_ALIGNSCENE_TOPRIGHT": "উপরে-ডানে",
    "MOTION_XSCROLL": "x স্ক্রল",
    "MOTION_YSCROLL": "y স্ক্রল",
    "MOTION_STAGE_SELECTED": "মঞ্চ নির্বাচিণ করা হয়েছে : কোন গতি ব্লক নেই",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 থেকে %2 এর মধ্যে যেকোনটি বাছাই কর",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 এবং %2",
    "OPERATORS_OR": "%1 অথবা %2",
    "OPERATORS_NOT": "%1 না ",
    "OPERATORS_JOIN": "%1 এর সাথে %2 যুক্ত কর",
    "OPERATORS_JOIN_APPLE": "বাংলা",
    "OPERATORS_JOIN_BANANA": "দেশ",
    "OPERATORS_LETTEROF": "%2 এর %1 নম্বর অক্ষর",
    "OPERATORS_LETTEROF_APPLE": "ব",
    "OPERATORS_LENGTH": "%1 এর দৈর্ঘ্য",
    "OPERATORS_CONTAINS": "%1 এর মধ্যে কি %2 আছে?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "round %1",
    "OPERATORS_MATHOP": "%2 এর %1",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "floor",
    "OPERATORS_MATHOP_CEILING": "ceiling",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "ডিফাইন %1",
    "SENSING_TOUCHINGOBJECT": "%1 স্পর্শ করছে?",
    "SENSING_TOUCHINGOBJECT_POINTER": "মাউস-পয়েন্টার",
    "SENSING_TOUCHINGOBJECT_EDGE": "প্রান্ত ",
    "SENSING_TOUCHINGCOLOR": "%1 রঙ স্পর্শ করছে?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 রঙ %2 কে স্পর্শ করছে?",
    "SENSING_DISTANCETO": "দূরত্ব %1 পর্যন্ত ",
    "SENSING_DISTANCETO_POINTER": "মাউস-পয়েন্টারে",
    "SENSING_ASKANDWAIT": "প্রশ্ন কর %1 এবং অপেক্ষা কর",
    "SENSING_ASK_TEXT": "তোমার নাম কি?",
    "SENSING_ANSWER": "উত্তর",
    "SENSING_KEYPRESSED": "%1 কী চাপা হয়েছে?",
    "SENSING_MOUSEDOWN": "mouse down?",
    "SENSING_MOUSEX": "মাউস x",
    "SENSING_MOUSEY": "মাউস y",
    "SENSING_SETDRAGMODE": "ড্র্যাগ মোড %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "টেনে আনা যাবে",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "টেনে আনা যাবে না",
    "SENSING_LOUDNESS": "শব্দের মাত্রা",
    "SENSING_LOUD": "জোরে?",
    "SENSING_TIMER": "সময়",
    "SENSING_RESETTIMER": "সময় রিসেট কর",
    "SENSING_OF": "%2 এর %1",
    "SENSING_OF_XPOSITION": "x এর অবস্থান",
    "SENSING_OF_YPOSITION": "y এর অবস্থান",
    "SENSING_OF_DIRECTION": "দিক",
    "SENSING_OF_COSTUMENUMBER": "পোশাক #",
    "SENSING_OF_COSTUMENAME": "পোশাকের নাম",
    "SENSING_OF_SIZE": "আকার",
    "SENSING_OF_VOLUME": "শব্দের মাত্রা",
    "SENSING_OF_BACKDROPNUMBER": "ব্যাকড্রপ #",
    "SENSING_OF_BACKDROPNAME": "ব্যাকড্রপের নাম",
    "SENSING_OF_STAGE": "মঞ্চ",
    "SENSING_CURRENT": "বর্তমান %1",
    "SENSING_CURRENT_YEAR": "বছর",
    "SENSING_CURRENT_MONTH": "মাস",
    "SENSING_CURRENT_DATE": "তারিখ",
    "SENSING_CURRENT_DAYOFWEEK": "সপ্তাহের দিন",
    "SENSING_CURRENT_HOUR": "ঘন্টা",
    "SENSING_CURRENT_MINUTE": "মিনিট",
    "SENSING_CURRENT_SECOND": "সেকেন্ড",
    "SENSING_DAYSSINCE2000": "2000 সালের পরের দিনগুলো",
    "SENSING_USERNAME": "ইউজারনেম",
    "SENSING_USERID": "user id",
    "SOUND_PLAY": "শুরু কর %1 শব্দ ",
    "SOUND_PLAYUNTILDONE": "শেষ না হওয়া পর্যন্ত %1 শব্দ বাজাও",
    "SOUND_STOPALLSOUNDS": "সব শব্দ বন্ধ কর",
    "SOUND_SETEFFECTO": "%1 এর ইফেক্ট %2 নির্ধারণ কর",
    "SOUND_CHANGEEFFECTBY": "%1 এর ইফেক্ট %2 পরিবর্তন কর",
    "SOUND_CLEAREFFECTS": "শব্দ ইফেক্ট মুছে ফেল",
    "SOUND_EFFECTS_PITCH": "pitch",
    "SOUND_EFFECTS_PAN": "pan left/right",
    "SOUND_CHANGEVOLUMEBY": "শব্দের মাত্রা %1 পরিবর্তন কর",
    "SOUND_SETVOLUMETO": "শব্দের মাত্রা %1% নির্ধারণ কর",
    "SOUND_VOLUME": "শব্দের মাত্রা",
    "SOUND_RECORD": "রেকর্ড...",
    "CATEGORY_MOTION": "গতি",
    "CATEGORY_LOOKS": "চেহারা",
    "CATEGORY_SOUND": "শব্দ",
    "CATEGORY_EVENTS": "ঘটনা",
    "CATEGORY_CONTROL": "নিয়ন্ত্রণ",
    "CATEGORY_SENSING": "অনুভব কর",
    "CATEGORY_OPERATORS": "অপারেটর",
    "CATEGORY_VARIABLES": "ভ্যারিয়েবল",
    "CATEGORY_MYBLOCKS": "আমার ব্লকগুলো",
    "DUPLICATE": "অনুরূপ",
    "DELETE": "অপসারণ",
    "ADD_COMMENT": "মন্তব্য যোগ কর",
    "REMOVE_COMMENT": "মন্তব্য অপসারণ কর",
    "DELETE_BLOCK": "ব্লক অপসারণ কর",
    "DELETE_X_BLOCKS": "%1 ব্লকগুলো অপসারণ কর",
    "DELETE_ALL_BLOCKS": "সব %1 ব্লকগুলো অপসারণ করবে?",
    "CLEAN_UP": "ব্লকগুলো পরিস্কার কর",
    "HELP": "সাহায্য",
    "UNDO": "পূর্বাবস্থায় ফেরত",
    "REDO": "পুনরায় কর",
    "EDIT_PROCEDURE": "সম্পাদনা",
    "SHOW_PROCEDURE_DEFINITION": "সংজ্ঞাতে যাও",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "কিছু বল...",
    "COLOUR_HUE_LABEL": "রঙ",
    "COLOUR_SATURATION_LABEL": "সম্পৃক্ত",
    "COLOUR_BRIGHTNESS_LABEL": "উজ্জ্বলতা",
    "CHANGE_VALUE_TITLE": "মান পরিবর্তন কর:",
    "RENAME_VARIABLE": "ভ্যারিয়েবল পুনরায় নামকরণ কর",
    "RENAME_VARIABLE_TITLE": "সব \"%1\" ভ্যারিয়েবল পুনরায় নামকরণ কর:",
    "RENAME_VARIABLE_MODAL_TITLE": "ভ্যারিয়েবল পুনরায় নামকরণ কর",
    "NEW_VARIABLE": "একটি ভ্যারিয়েবল তৈরি কর",
    "NEW_VARIABLE_TITLE": "নতুন ভ্যারিয়েবল নাম:",
    "VARIABLE_MODAL_TITLE": "নতুন ভ্যারিয়েবল",
    "VARIABLE_ALREADY_EXISTS": "\"%1\" নামক একটি ভ্যারিয়েবল ইতিমধ্যেই বিদ্যমান।",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "\"%1\" নামক একটি ভ্যারিয়েবল ইতিমধ্যে \"%2\" ধরনের অন্য একটি ভ্যারিয়েবল এর জন্য বিদ্যমান।",
    "DELETE_VARIABLE_CONFIRMATION": "\"%2\" ভ্যারিয়েবল এর ব্যবহৃত %1 অপসারণ করা হবে? ",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "ভ্যারিয়েবল \"%1\" অপসারণ করতে পারবে না কারণ এটি \"%2\" ফাংশনের সংজ্ঞার অংশ",
    "DELETE_VARIABLE": "\"%1\" ভ্যারিয়েবলটি অপসারণ কর",
    "NEW_PROCEDURE": "একটি ব্লক তৈরি কর",
    "PROCEDURE_ALREADY_EXISTS": "\"%1\" নামের একটি পদ্ধতি ইতোমধ্যে বিদ্যমান।",
    "PROCEDURE_DEFAULT_NAME": "ব্লকের নাম",
    "PROCEDURE_USED": "একটি ব্লকের সংজ্ঞা অপসারণ করতে, প্রথমে ব্লকের সব ব্যবহার অপসারণ কর",
    "NEW_LIST": "তালিকা তৈরি কর",
    "NEW_LIST_TITLE": "নতুন তালিকার নাম:",
    "LIST_MODAL_TITLE": "নতুন তালিকা",
    "LIST_ALREADY_EXISTS": "\"%1\" নামের একটি তালিকা ইতোমধ্যে বিদ্যমান।",
    "RENAME_LIST_TITLE": "\"%1\" তালিকার সব পুনরায় নামকরণ কর:",
    "RENAME_LIST_MODAL_TITLE": "তালিকা পুনরায় নামকরণ কর",
    "DEFAULT_LIST_ITEM": "জিনিস",
    "DELETE_LIST": "\"%1\" তালিকাটি অপসারণ কর",
    "RENAME_LIST": "তালিকা পুনরায় নামকরণ কর",
    "NEW_BROADCAST_MESSAGE": "নতুন বার্তা",
    "NEW_BROADCAST_MESSAGE_TITLE": "নতুন বার্তার নাম:",
    "BROADCAST_MODAL_TITLE": "নতুন বার্তা",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "বার্তা1"
  },
  "be": {
    "CONTROL_FOREVER": "заўжды",
    "CONTROL_REPEAT": "паўтарыць %1",
    "CONTROL_IF": "калі %1 , то",
    "CONTROL_ELSE": "інакш",
    "CONTROL_STOP": "стоп",
    "CONTROL_STOP_ALL": "усе",
    "CONTROL_STOP_THIS": "гэты скрыпт",
    "CONTROL_STOP_OTHER": "іншыя скрыпты спрайта",
    "CONTROL_WAIT": "чакаць %1 секунд",
    "CONTROL_WAITUNTIL": "чакаць да %1",
    "CONTROL_REPEATUNTIL": "паўтараць, пакуль не %1",
    "CONTROL_WHILE": "пакуль %1",
    "CONTROL_FOREACH": "для кожнага %1 у %2",
    "CONTROL_STARTASCLONE": "калі я пачынаю як клон",
    "CONTROL_CREATECLONEOF": "стварыць клона %1",
    "CONTROL_CREATECLONEOF_MYSELF": "сябе",
    "CONTROL_DELETETHISCLONE": "выдаліць гэтага клона",
    "CONTROL_COUNTER": "лічыльнік",
    "CONTROL_INCRCOUNTER": "павялічыць лічыльнік",
    "CONTROL_CLEARCOUNTER": "ачысціць лічыльнік",
    "CONTROL_ALLATONCE": "усё адразу",
    "DATA_SETVARIABLETO": "устанавіць %1 у %2",
    "DATA_CHANGEVARIABLEBY": "змяніць %1 на %2",
    "DATA_SHOWVARIABLE": "паказаць зменную %1",
    "DATA_HIDEVARIABLE": "схаваць зменную %1",
    "DATA_ADDTOLIST": "дадаць %1 да %2",
    "DATA_DELETEOFLIST": "выдаліць %1 з %2",
    "DATA_DELETEALLOFLIST": "выдаліць усё з %1",
    "DATA_INSERTATLIST": "уставіць %1 у %2 з %3",
    "DATA_REPLACEITEMOFLIST": "замяніць элемент %1 у %2 на %3",
    "DATA_ITEMOFLIST": "элемент %1 з %2",
    "DATA_ITEMNUMOFLIST": "элемент # з %1 у %2",
    "DATA_LENGTHOFLIST": "даўжыня %1",
    "DATA_LISTCONTAINSITEM": "%1 змяшчае %2?",
    "DATA_SHOWLIST": "паказаць спіс %1",
    "DATA_HIDELIST": "схаваць спіс %1",
    "DATA_INDEX_ALL": "усе",
    "DATA_INDEX_LAST": "апошні",
    "DATA_INDEX_RANDOM": "выпадковы",
    "EVENT_WHENFLAGCLICKED": "калі %1 націснуты",
    "EVENT_WHENTHISSPRITECLICKED": "калі спрайт націснуты",
    "EVENT_WHENSTAGECLICKED": "калі клікнуць па сцэне",
    "EVENT_WHENTOUCHINGOBJECT": "калі спрайт кранаецца %1",
    "EVENT_WHENBROADCASTRECEIVED": "калі я атрымаю %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "калі фон змяняецца на %1",
    "EVENT_WHENGREATERTHAN": "калі %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "таймер",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "гучнасць",
    "EVENT_BROADCAST": "разаслаць %1",
    "EVENT_BROADCASTANDWAIT": "разаслаць %1 і чакаць",
    "EVENT_WHENKEYPRESSED": "калі клавіша %1 націснутая",
    "EVENT_WHENKEYPRESSED_SPACE": "прабел",
    "EVENT_WHENKEYPRESSED_LEFT": "стрэлка налева",
    "EVENT_WHENKEYPRESSED_RIGHT": "стрэлка направа",
    "EVENT_WHENKEYPRESSED_DOWN": "стрэлка ўніз",
    "EVENT_WHENKEYPRESSED_UP": "стрэлка ўверх",
    "EVENT_WHENKEYPRESSED_ANY": "любы",
    "LOOKS_SAYFORSECS": "казаць %1 на працягу %2 секунд",
    "LOOKS_SAY": "сказаць %1",
    "LOOKS_HELLO": "Вітаю!",
    "LOOKS_THINKFORSECS": "думаць %1 %2 секунд",
    "LOOKS_THINK": "думаць %1",
    "LOOKS_HMM": "Хм...",
    "LOOKS_SHOW": "паказацца",
    "LOOKS_HIDE": "схавацца",
    "LOOKS_HIDEALLSPRITES": "схаваць усе спрайты",
    "LOOKS_EFFECT_COLOR": "колер",
    "LOOKS_EFFECT_FISHEYE": "рыбіна вока",
    "LOOKS_EFFECT_WHIRL": "вір",
    "LOOKS_EFFECT_PIXELATE": "буйныя пікселі",
    "LOOKS_EFFECT_MOSAIC": "мазаіка",
    "LOOKS_EFFECT_BRIGHTNESS": "яркасць",
    "LOOKS_EFFECT_GHOST": "прывід",
    "LOOKS_CHANGEEFFECTBY": "змяніць %1 эфект на %2",
    "LOOKS_SETEFFECTTO": "устанавіць эфект %1 у значэнне %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "прыбраць графічныя эфекты",
    "LOOKS_CHANGESIZEBY": "змяніць памер на  %1",
    "LOOKS_SETSIZETO": "устанавіць памер %1 %",
    "LOOKS_SIZE": "памер",
    "LOOKS_CHANGESTRETCHBY": "змяніць расцягванне на %1",
    "LOOKS_SETSTRETCHTO": "устанавіць расцягванне %1 %",
    "LOOKS_SWITCHCOSTUMETO": "змяніць касцюм на %1",
    "LOOKS_NEXTCOSTUME": "наступны касцюм",
    "LOOKS_SWITCHBACKDROPTO": "змяніць фон на %1",
    "LOOKS_GOTOFRONTBACK": "перайсці ў %1 слой",
    "LOOKS_GOTOFRONTBACK_FRONT": "пярэдні",
    "LOOKS_GOTOFRONTBACK_BACK": "назад",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "перайсці %1 на %2 слоя",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "наперад",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "назад",
    "LOOKS_BACKDROPNUMBERNAME": "фон %1",
    "LOOKS_COSTUMENUMBERNAME": "касцюм %1",
    "LOOKS_NUMBERNAME_NUMBER": "нумар",
    "LOOKS_NUMBERNAME_NAME": "імя",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "змяніць фон на %1 і чакаць",
    "LOOKS_NEXTBACKDROP_BLOCK": "наступны фон",
    "LOOKS_NEXTBACKDROP": "наступны фон",
    "LOOKS_PREVIOUSBACKDROP": "папярэдні фон",
    "LOOKS_RANDOMBACKDROP": "выпадковы фон",
    "MOTION_MOVESTEPS": "рухацца %1 крокаў",
    "MOTION_TURNLEFT": "павярнуць %1 %2 градусаў",
    "MOTION_TURNRIGHT": "павярнуць %1 %2 градусаў",
    "MOTION_POINTINDIRECTION": "павярнуць у кірунку %1",
    "MOTION_POINTTOWARDS": "павярнуцца да %1",
    "MOTION_POINTTOWARDS_POINTER": "указальнік мышы",
    "MOTION_POINTTOWARDS_RANDOM": "выпадковы кірунак",
    "MOTION_GOTO": "перайсці ў %1",
    "MOTION_GOTO_POINTER": "указальнік мышы",
    "MOTION_GOTO_RANDOM": "выпадковая пазіцыя",
    "MOTION_GOTOXY": "перайсці ў x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "плысці %1 секунд да x: %2 y: %3",
    "MOTION_GLIDETO": "плысці %1 секунд да %2",
    "MOTION_GLIDETO_POINTER": "указальнік мышы",
    "MOTION_GLIDETO_RANDOM": "выпадковая пазіцыя",
    "MOTION_CHANGEXBY": "змяніць X на %1",
    "MOTION_SETX": "устанавіць X у %1",
    "MOTION_CHANGEYBY": "змяніць Y на %1",
    "MOTION_SETY": "устанавіць Y у %1",
    "MOTION_IFONEDGEBOUNCE": "калі скраю, адштурхнуцца",
    "MOTION_SETROTATIONSTYLE": "стыль вярчэння %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "налева-направа",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "не круціць",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "навокал",
    "MOTION_XPOSITION": "пазіцыя X",
    "MOTION_YPOSITION": "пазіцыя Y",
    "MOTION_DIRECTION": "кірунак",
    "MOTION_SCROLLRIGHT": "пракруціць направа %1",
    "MOTION_SCROLLUP": "пракруціць уверх %1",
    "MOTION_ALIGNSCENE": "выраўнаваць сцэну %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ніжні левы",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ніжні правы",
    "MOTION_ALIGNSCENE_MIDDLE": "сярэдзіна",
    "MOTION_ALIGNSCENE_TOPLEFT": "верхні левы",
    "MOTION_ALIGNSCENE_TOPRIGHT": "верхні правы",
    "MOTION_XSCROLL": "X пракрутка",
    "MOTION_YSCROLL": "Y пракрутка",
    "MOTION_STAGE_SELECTED": "Абрана сцэна: няма блокаў руху",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "выдаць выпадковы лік ад %1 да %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 і %2",
    "OPERATORS_OR": "%1 ці %2",
    "OPERATORS_NOT": "не %1",
    "OPERATORS_JOIN": "аб'яднаць %1 %2",
    "OPERATORS_JOIN_APPLE": "ананас",
    "OPERATORS_JOIN_BANANA": "банан",
    "OPERATORS_LETTEROF": "літара %1 у %2",
    "OPERATORS_LETTEROF_APPLE": "а",
    "OPERATORS_LENGTH": "даўжыня %1",
    "OPERATORS_CONTAINS": "%1 змяшчае %2?",
    "OPERATORS_MOD": "астача ад дзялення %1 на %2",
    "OPERATORS_ROUND": "акругліць %1",
    "OPERATORS_MATHOP": "%1 з %2",
    "OPERATORS_MATHOP_ABS": "модуль",
    "OPERATORS_MATHOP_FLOOR": "меншае цэлае",
    "OPERATORS_MATHOP_CEILING": "ліміт",
    "OPERATORS_MATHOP_SQRT": "квадратны корань",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "вызначыць %1",
    "SENSING_TOUCHINGOBJECT": "кранаецца %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "указальнік мышы",
    "SENSING_TOUCHINGOBJECT_EDGE": "мяжа",
    "SENSING_TOUCHINGCOLOR": "дакранаецца да колеру %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "колер %1 кранаецца %2?",
    "SENSING_DISTANCETO": "адлегласць да %1",
    "SENSING_DISTANCETO_POINTER": "указальнік мышы",
    "SENSING_ASKANDWAIT": "спытаць %1 і чакаць",
    "SENSING_ASK_TEXT": "Як цябе клічуць?",
    "SENSING_ANSWER": "адказ",
    "SENSING_KEYPRESSED": "клавіша %1 націснутая?",
    "SENSING_MOUSEDOWN": "мышка націснутая?",
    "SENSING_MOUSEX": "мышка па X",
    "SENSING_MOUSEY": "мышка па Y",
    "SENSING_SETDRAGMODE": "перацягваць %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "можна",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "нельга",
    "SENSING_LOUDNESS": "гучнасць",
    "SENSING_LOUD": "гучна?",
    "SENSING_TIMER": "таймер",
    "SENSING_RESETTIMER": "перазапусціць таймер",
    "SENSING_OF": "%1 з %2",
    "SENSING_OF_XPOSITION": "пазіцыя X",
    "SENSING_OF_YPOSITION": "пазіцыя Y",
    "SENSING_OF_DIRECTION": "кірунак",
    "SENSING_OF_COSTUMENUMBER": "касцюм #",
    "SENSING_OF_COSTUMENAME": "імя касцюма",
    "SENSING_OF_SIZE": "памер",
    "SENSING_OF_VOLUME": "гучнасць",
    "SENSING_OF_BACKDROPNUMBER": "фон #",
    "SENSING_OF_BACKDROPNAME": "імя фону",
    "SENSING_OF_STAGE": "Сцэна",
    "SENSING_CURRENT": "бягучы %1",
    "SENSING_CURRENT_YEAR": "год",
    "SENSING_CURRENT_MONTH": "месяц",
    "SENSING_CURRENT_DATE": "дата",
    "SENSING_CURRENT_DAYOFWEEK": "дзень тыдня",
    "SENSING_CURRENT_HOUR": "гадзіна",
    "SENSING_CURRENT_MINUTE": "хвіліна",
    "SENSING_CURRENT_SECOND": "секунда",
    "SENSING_DAYSSINCE2000": "дзён ад 2000",
    "SENSING_USERNAME": "імя карыстальніка",
    "SENSING_USERID": "id ўдзельніка",
    "SOUND_PLAY": "уключыць гук %1",
    "SOUND_PLAYUNTILDONE": "іграць гук %1 да канца",
    "SOUND_STOPALLSOUNDS": "спыніць усе гукі",
    "SOUND_SETEFFECTO": "устанавіць эфект %1 у значэнне %2",
    "SOUND_CHANGEEFFECTBY": "змяніць %1 эфект на %2",
    "SOUND_CLEAREFFECTS": "прыбраць гукавыя эфекты",
    "SOUND_EFFECTS_PITCH": "вышыня гуку",
    "SOUND_EFFECTS_PAN": "рух налева/направа",
    "SOUND_CHANGEVOLUMEBY": "змяніць гучнасць на %1",
    "SOUND_SETVOLUMETO": "устанавіць гучнасць %1%",
    "SOUND_VOLUME": "гучнасць",
    "SOUND_RECORD": "запіс...",
    "CATEGORY_MOTION": "Рух",
    "CATEGORY_LOOKS": "Выгляд",
    "CATEGORY_SOUND": "Гук",
    "CATEGORY_EVENTS": "Падзеі",
    "CATEGORY_CONTROL": "Кіраванне",
    "CATEGORY_SENSING": "Сэнсары",
    "CATEGORY_OPERATORS": "Аператары",
    "CATEGORY_VARIABLES": "Зменныя",
    "CATEGORY_MYBLOCKS": "Уласныя блокі",
    "DUPLICATE": "Падвоіць",
    "DELETE": "Выдаліць",
    "ADD_COMMENT": "Дадаць каментарый",
    "REMOVE_COMMENT": "Выдаліць каментарый",
    "DELETE_BLOCK": "Выдаліць блок",
    "DELETE_X_BLOCKS": "Выдаліць %1 блокаў",
    "DELETE_ALL_BLOCKS": "Выдаліць усе %1 блокі?",
    "CLEAN_UP": "Ачысціць блокі",
    "HELP": "Даведка",
    "UNDO": "Адмяніць",
    "REDO": "Вярнуць",
    "EDIT_PROCEDURE": "Змяніць",
    "SHOW_PROCEDURE_DEFINITION": "Перайсці да вызначэння",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Скажы што-небудзь..",
    "COLOUR_HUE_LABEL": "Колер",
    "COLOUR_SATURATION_LABEL": "Насычанасць",
    "COLOUR_BRIGHTNESS_LABEL": "Яркасць",
    "CHANGE_VALUE_TITLE": "Змяніць значэнне:",
    "RENAME_VARIABLE": "Змяніць імя зменнай",
    "RENAME_VARIABLE_TITLE": "Змяніць імёны \"%1\" зменных на:",
    "RENAME_VARIABLE_MODAL_TITLE": "Змяніць імя зменнай",
    "NEW_VARIABLE": "Стварыць зменную",
    "NEW_VARIABLE_TITLE": "Новае імя зменнай:",
    "VARIABLE_MODAL_TITLE": "Новая зменная",
    "VARIABLE_ALREADY_EXISTS": "Зменная з імем \"%1\" ужо існуе.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Зменная з імем \"%1\" ужо існуе для іншай зменнай тыпу \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "Выдаліць %1 выкарыстанняў \"%2\" зменнай?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Нельга выдаліць зменную \"%1\", бо яна частка функцыі \"%2\"",
    "DELETE_VARIABLE": "Выдаліць зменную \"%1\"",
    "NEW_PROCEDURE": "Стварыць блок",
    "PROCEDURE_ALREADY_EXISTS": "Працэдура з імем \"%1\" ужо існуе.",
    "PROCEDURE_DEFAULT_NAME": "назва блока",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Стварыць спіс",
    "NEW_LIST_TITLE": "Новае імя спіса:",
    "LIST_MODAL_TITLE": "Новы cпіс",
    "LIST_ALREADY_EXISTS": "Спіс з імем \"%1\" ужо існуе.",
    "RENAME_LIST_TITLE": "Змяніць імёны \"%1\" спісаў на:",
    "RENAME_LIST_MODAL_TITLE": "Змяніць імя cпіса",
    "DEFAULT_LIST_ITEM": "рэч",
    "DELETE_LIST": "Выдаліць спіс \"%1\"",
    "RENAME_LIST": "Змяніць імя спіса",
    "NEW_BROADCAST_MESSAGE": "Новае паведамленне",
    "NEW_BROADCAST_MESSAGE_TITLE": "Новае імя паведамлення:",
    "BROADCAST_MODAL_TITLE": "Новае паведамленне",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "паведамленне1"
  },
  "bg": {
    "CONTROL_FOREVER": "винаги",
    "CONTROL_REPEAT": "повтори %1",
    "CONTROL_IF": "ако %1 тогава",
    "CONTROL_ELSE": "иначе",
    "CONTROL_STOP": "спри",
    "CONTROL_STOP_ALL": "всички",
    "CONTROL_STOP_THIS": "този скрипт",
    "CONTROL_STOP_OTHER": "другите скриптове на спрайта",
    "CONTROL_WAIT": "изчакай %1 сек",
    "CONTROL_WAITUNTIL": "чакай докато %1",
    "CONTROL_REPEATUNTIL": "повтаряй докато %1",
    "CONTROL_WHILE": "докато %1",
    "CONTROL_FOREACH": "за всеки %1 от %2",
    "CONTROL_STARTASCLONE": "при старт като клонинг",
    "CONTROL_CREATECLONEOF": "създай клонинг на %1",
    "CONTROL_CREATECLONEOF_MYSELF": "себе си",
    "CONTROL_DELETETHISCLONE": "премахни този клонинг",
    "CONTROL_COUNTER": "брояч",
    "CONTROL_INCRCOUNTER": "нарастващ брояч",
    "CONTROL_CLEARCOUNTER": "изчисти брояча",
    "CONTROL_ALLATONCE": "всичко на веднъж",
    "DATA_SETVARIABLETO": "направи %1 на %2",
    "DATA_CHANGEVARIABLEBY": "промени %1 с %2",
    "DATA_SHOWVARIABLE": "покажи променлива %1",
    "DATA_HIDEVARIABLE": "скрий променлива %1",
    "DATA_ADDTOLIST": "добави %1 към %2",
    "DATA_DELETEOFLIST": "изтрий %1 от %2",
    "DATA_DELETEALLOFLIST": "изтрий всичко от %1",
    "DATA_INSERTATLIST": "вмъкни %1 на %2 като %3",
    "DATA_REPLACEITEMOFLIST": "замени елемент %1 от %2 с %3",
    "DATA_ITEMOFLIST": "елемент %1 от %2",
    "DATA_ITEMNUMOFLIST": "номер на елемента %1 в %2",
    "DATA_LENGTHOFLIST": "големина на %1",
    "DATA_LISTCONTAINSITEM": "%1 съдържа %2?",
    "DATA_SHOWLIST": "покажи списък %1",
    "DATA_HIDELIST": "скрий списък %1",
    "DATA_INDEX_ALL": "всички",
    "DATA_INDEX_LAST": "последен",
    "DATA_INDEX_RANDOM": "случаен",
    "EVENT_WHENFLAGCLICKED": "когато %1 е щракнато",
    "EVENT_WHENTHISSPRITECLICKED": "когато този спрайт е щракнат",
    "EVENT_WHENSTAGECLICKED": "когато е щракнато върху сцената",
    "EVENT_WHENTOUCHINGOBJECT": "когато този спрайт докосва %1",
    "EVENT_WHENBROADCASTRECEIVED": "когато получа %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "когато декорът се смени на %1",
    "EVENT_WHENGREATERTHAN": "когато %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "таймер",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ниво на звука",
    "EVENT_BROADCAST": "разпространи %1",
    "EVENT_BROADCASTANDWAIT": "разпространи %1 и чакай",
    "EVENT_WHENKEYPRESSED": "когато е натиснат клавиш %1",
    "EVENT_WHENKEYPRESSED_SPACE": "интервал",
    "EVENT_WHENKEYPRESSED_LEFT": "лява стрелка",
    "EVENT_WHENKEYPRESSED_RIGHT": "дясна стрелка",
    "EVENT_WHENKEYPRESSED_DOWN": "стрелка надолу",
    "EVENT_WHENKEYPRESSED_UP": "стрелка нагоре",
    "EVENT_WHENKEYPRESSED_ANY": "който и да е",
    "LOOKS_SAYFORSECS": "кажи %1 за %2 сек",
    "LOOKS_SAY": "кажи %1",
    "LOOKS_HELLO": "Здравей!",
    "LOOKS_THINKFORSECS": "мисли %1 за %2 сек",
    "LOOKS_THINK": "мисли %1",
    "LOOKS_HMM": "Хъмм...",
    "LOOKS_SHOW": "покажи се",
    "LOOKS_HIDE": "скрий се",
    "LOOKS_HIDEALLSPRITES": "скрий всички спрайтове",
    "LOOKS_EFFECT_COLOR": "цвят",
    "LOOKS_EFFECT_FISHEYE": "рибено-око",
    "LOOKS_EFFECT_WHIRL": "завихряне",
    "LOOKS_EFFECT_PIXELATE": "пикселизирай",
    "LOOKS_EFFECT_MOSAIC": "мозайка",
    "LOOKS_EFFECT_BRIGHTNESS": "яркост",
    "LOOKS_EFFECT_GHOST": "призрачност",
    "LOOKS_CHANGEEFFECTBY": "промени ефект %1  с %2",
    "LOOKS_SETEFFECTTO": "направи %1 ефект на %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "премахни графичните ефекти",
    "LOOKS_CHANGESIZEBY": "промени размера с %1",
    "LOOKS_SETSIZETO": "направи размера %1 %",
    "LOOKS_SIZE": "размер",
    "LOOKS_CHANGESTRETCHBY": "промени разтягането с %1",
    "LOOKS_SETSTRETCHTO": "направи разтягането на %1 %",
    "LOOKS_SWITCHCOSTUMETO": "промени костюм на %1",
    "LOOKS_NEXTCOSTUME": "следващ костюм",
    "LOOKS_SWITCHBACKDROPTO": "смени декора с %1",
    "LOOKS_GOTOFRONTBACK": "отиди до слой %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "отпред",
    "LOOKS_GOTOFRONTBACK_BACK": "отзад",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "премини %1 с %2 слой/я",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "напред",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "назад",
    "LOOKS_BACKDROPNUMBERNAME": "декор %1",
    "LOOKS_COSTUMENUMBERNAME": "костюм %1",
    "LOOKS_NUMBERNAME_NUMBER": "номер",
    "LOOKS_NUMBERNAME_NAME": "име",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "смени декора с %1 и чакай",
    "LOOKS_NEXTBACKDROP_BLOCK": "следващ декор",
    "LOOKS_NEXTBACKDROP": "следващ декор",
    "LOOKS_PREVIOUSBACKDROP": "предишен декор",
    "LOOKS_RANDOMBACKDROP": "случаен декор",
    "MOTION_MOVESTEPS": "премести се с %1 стъпки",
    "MOTION_TURNLEFT": "завърти се с %1 %2 градуса",
    "MOTION_TURNRIGHT": "завърти се с %1 %2 градуса",
    "MOTION_POINTINDIRECTION": "обърни се в посока %1",
    "MOTION_POINTTOWARDS": "обърни се към %1",
    "MOTION_POINTTOWARDS_POINTER": "показалец на мишката",
    "MOTION_POINTTOWARDS_RANDOM": "случайна посока",
    "MOTION_GOTO": "отиди до %1",
    "MOTION_GOTO_POINTER": "показалец на мишката",
    "MOTION_GOTO_RANDOM": "случайна позиция",
    "MOTION_GOTOXY": "отиди до x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "пропълзи за %1 сек до x: %2 y: %3",
    "MOTION_GLIDETO": "пропълзи за %1 сек до %2",
    "MOTION_GLIDETO_POINTER": "показалец на мишката",
    "MOTION_GLIDETO_RANDOM": "случайна позиция",
    "MOTION_CHANGEXBY": "промени х с %1",
    "MOTION_SETX": "направи x равно на %1",
    "MOTION_CHANGEYBY": "промени y с %1",
    "MOTION_SETY": "направи y равно на %1",
    "MOTION_IFONEDGEBOUNCE": "ако докосваш ръба, отблъсни се",
    "MOTION_SETROTATIONSTYLE": "избери начин на въртене %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "наляво-надясно",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "без въртене",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "във всички посоки",
    "MOTION_XPOSITION": "x позиция",
    "MOTION_YPOSITION": "y позиция",
    "MOTION_DIRECTION": "посока",
    "MOTION_SCROLLRIGHT": "превърти надясно %1",
    "MOTION_SCROLLUP": "превърти нагоре %1",
    "MOTION_ALIGNSCENE": "подравни %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "долу-ляво",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "долу-дясно",
    "MOTION_ALIGNSCENE_MIDDLE": "по средата",
    "MOTION_ALIGNSCENE_TOPLEFT": "горе-ляво",
    "MOTION_ALIGNSCENE_TOPRIGHT": "горе-дясно",
    "MOTION_XSCROLL": "хоризонтално превъртане",
    "MOTION_YSCROLL": "вертикално превъртане",
    "MOTION_STAGE_SELECTED": "Избрана е сцената: няма блокове за движение",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "избери случайно от %1 до %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 и %2",
    "OPERATORS_OR": "%1 или %2",
    "OPERATORS_NOT": "не %1",
    "OPERATORS_JOIN": "съедини %1 %2",
    "OPERATORS_JOIN_APPLE": "ябълка",
    "OPERATORS_JOIN_BANANA": "банан",
    "OPERATORS_LETTEROF": "буква %1 от %2",
    "OPERATORS_LETTEROF_APPLE": "а",
    "OPERATORS_LENGTH": "дължина на %1",
    "OPERATORS_CONTAINS": "%1 съдържа %2?",
    "OPERATORS_MOD": "остатък от %1 / %2",
    "OPERATORS_ROUND": "закръгли %1",
    "OPERATORS_MATHOP": "%1 от %2",
    "OPERATORS_MATHOP_ABS": "абсолютна стойност",
    "OPERATORS_MATHOP_FLOOR": "закръглено надолу",
    "OPERATORS_MATHOP_CEILING": "закръглено нагоре",
    "OPERATORS_MATHOP_SQRT": "квадратен корен",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "дефинирай %1",
    "SENSING_TOUCHINGOBJECT": "допира ли %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "показалец на мишката",
    "SENSING_TOUCHINGOBJECT_EDGE": "ръб",
    "SENSING_TOUCHINGCOLOR": "допира ли цвят %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "цвят %1 допира ли %2?",
    "SENSING_DISTANCETO": "разстояние до %1",
    "SENSING_DISTANCETO_POINTER": "показалец на мишката",
    "SENSING_ASKANDWAIT": "питай %1 и чакай",
    "SENSING_ASK_TEXT": "Какво е твоето име?",
    "SENSING_ANSWER": "отговор",
    "SENSING_KEYPRESSED": "клавиш %1 натиснат?",
    "SENSING_MOUSEDOWN": "мишка натисната?",
    "SENSING_MOUSEX": "мишка x",
    "SENSING_MOUSEY": "мишка y",
    "SENSING_SETDRAGMODE": "режим на теглене %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "теглене разрешено",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "теглене забранено",
    "SENSING_LOUDNESS": "сила на звука",
    "SENSING_LOUD": "шумно ли е?",
    "SENSING_TIMER": "таймер",
    "SENSING_RESETTIMER": "нулирай таймера",
    "SENSING_OF": "%1 от %2",
    "SENSING_OF_XPOSITION": "x позиция",
    "SENSING_OF_YPOSITION": "y позиция",
    "SENSING_OF_DIRECTION": "посока",
    "SENSING_OF_COSTUMENUMBER": "костюм #",
    "SENSING_OF_COSTUMENAME": "име на костюм",
    "SENSING_OF_SIZE": "размер",
    "SENSING_OF_VOLUME": "сила на звука",
    "SENSING_OF_BACKDROPNUMBER": "декор #",
    "SENSING_OF_BACKDROPNAME": "име на декор",
    "SENSING_OF_STAGE": "Сцена",
    "SENSING_CURRENT": "текущ/а %1",
    "SENSING_CURRENT_YEAR": "година",
    "SENSING_CURRENT_MONTH": "месец",
    "SENSING_CURRENT_DATE": "дата",
    "SENSING_CURRENT_DAYOFWEEK": "ден от седмицата",
    "SENSING_CURRENT_HOUR": "час",
    "SENSING_CURRENT_MINUTE": "минута",
    "SENSING_CURRENT_SECOND": "секунда",
    "SENSING_DAYSSINCE2000": "дни след 2000 година",
    "SENSING_USERNAME": "потребителско име",
    "SENSING_USERID": "потребителски идентификатор",
    "SOUND_PLAY": "пусни звук %1",
    "SOUND_PLAYUNTILDONE": "пусни звук %1 докато свърши",
    "SOUND_STOPALLSOUNDS": "спри всички звуци",
    "SOUND_SETEFFECTO": "направи %1 ефект на %2",
    "SOUND_CHANGEEFFECTBY": "промени ефект %1  с %2",
    "SOUND_CLEAREFFECTS": "премахни звуковите ефекти",
    "SOUND_EFFECTS_PITCH": "промяна на тона",
    "SOUND_EFFECTS_PAN": "ляво/дясно",
    "SOUND_CHANGEVOLUMEBY": "промени силата на звука с %1",
    "SOUND_SETVOLUMETO": "задай сила на звука %1%",
    "SOUND_VOLUME": "сила на звука",
    "SOUND_RECORD": "запис...",
    "CATEGORY_MOTION": "Движение",
    "CATEGORY_LOOKS": "Външност",
    "CATEGORY_SOUND": "Звук",
    "CATEGORY_EVENTS": "Събития",
    "CATEGORY_CONTROL": "Контрол",
    "CATEGORY_SENSING": "Сетива",
    "CATEGORY_OPERATORS": "Оператори",
    "CATEGORY_VARIABLES": "Променливи",
    "CATEGORY_MYBLOCKS": "Моите Блокове",
    "DUPLICATE": "Дублиране",
    "DELETE": "Изтриване",
    "ADD_COMMENT": "Добави Коментар",
    "REMOVE_COMMENT": "Премахни Коментар",
    "DELETE_BLOCK": "Изтрий Блок",
    "DELETE_X_BLOCKS": "Изтрий %1 блока",
    "DELETE_ALL_BLOCKS": "Изтрий всички %1 блокове",
    "CLEAN_UP": "Изтрий блоковете",
    "HELP": "Помощ",
    "UNDO": "Отмяна",
    "REDO": "Повтаряне",
    "EDIT_PROCEDURE": "Редактиране",
    "SHOW_PROCEDURE_DEFINITION": "Покажи дефиницията",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Кажи нещо...",
    "COLOUR_HUE_LABEL": "Цвят",
    "COLOUR_SATURATION_LABEL": "Наситеност",
    "COLOUR_BRIGHTNESS_LABEL": "Яркост",
    "CHANGE_VALUE_TITLE": "Промени стойността:",
    "RENAME_VARIABLE": "Преименувай променлива",
    "RENAME_VARIABLE_TITLE": "Преименувай всички \"%1\" променливи на:",
    "RENAME_VARIABLE_MODAL_TITLE": "Преименувай Променлива",
    "NEW_VARIABLE": "Създаване на Променлива",
    "NEW_VARIABLE_TITLE": "Име на новата променлива:",
    "VARIABLE_MODAL_TITLE": "Нова променлива",
    "VARIABLE_ALREADY_EXISTS": "Променлива \"%1\" вече съществува.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Променлива \"%1\" вече съществува за друга променлива от тип \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Да изтрия ли %1 блока, в които се използва променливата \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Не може да се изтрие променливата \"%1\", защото участва в дефиницията на функцията \"%2\".",
    "DELETE_VARIABLE": "Изтрий променливата \"%1\"",
    "NEW_PROCEDURE": "Създаване на блок",
    "PROCEDURE_ALREADY_EXISTS": "Процедура \"%1\" вече съществува.",
    "PROCEDURE_DEFAULT_NAME": "име на блок",
    "PROCEDURE_USED": "За да изтриете дефиниция на блок, първо премахнете използването му.",
    "NEW_LIST": "Създаване на списък",
    "NEW_LIST_TITLE": "Име на новия списък:",
    "LIST_MODAL_TITLE": "Нов списък",
    "LIST_ALREADY_EXISTS": "Списък \"%1\" вече съществува.",
    "RENAME_LIST_TITLE": "Преименувай всички \"%1\" списъци на:",
    "RENAME_LIST_MODAL_TITLE": "Преименувай списък",
    "DEFAULT_LIST_ITEM": "нещо",
    "DELETE_LIST": "Изтрий списъкът \"%1\"",
    "RENAME_LIST": "Преименувай списък",
    "NEW_BROADCAST_MESSAGE": "Ново съобщение",
    "NEW_BROADCAST_MESSAGE_TITLE": "Име на новото съобщение:",
    "BROADCAST_MODAL_TITLE": "Ново съобщение",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "съобщение1"
  },
  "ca": {
    "CONTROL_FOREVER": "per sempre",
    "CONTROL_REPEAT": "repeteix %1",
    "CONTROL_IF": "si %1 llavors",
    "CONTROL_ELSE": "si no",
    "CONTROL_STOP": "atura",
    "CONTROL_STOP_ALL": "tot",
    "CONTROL_STOP_THIS": "aquest programa",
    "CONTROL_STOP_OTHER": "altres programes del personatge",
    "CONTROL_WAIT": "espera %1 segons",
    "CONTROL_WAITUNTIL": "espera fins %1",
    "CONTROL_REPEATUNTIL": "repeteix fins %1",
    "CONTROL_WHILE": "mentre %1",
    "CONTROL_FOREACH": "per cada %1 a %2",
    "CONTROL_STARTASCLONE": "quan una còpia meva comenci",
    "CONTROL_CREATECLONEOF": "crea una còpia de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "jo mateix",
    "CONTROL_DELETETHISCLONE": "esborra aquesta còpia",
    "CONTROL_COUNTER": "comptador",
    "CONTROL_INCRCOUNTER": "augmenta comptador",
    "CONTROL_CLEARCOUNTER": "posa a zero el comptador",
    "CONTROL_ALLATONCE": "tot d'una vegada",
    "DATA_SETVARIABLETO": "assigna a %1 el valor %2",
    "DATA_CHANGEVARIABLEBY": "augmenta %1 en %2",
    "DATA_SHOWVARIABLE": "mostra la variable %1",
    "DATA_HIDEVARIABLE": "amaga la variable %1",
    "DATA_ADDTOLIST": "afegeix %1 a %2",
    "DATA_DELETEOFLIST": "esborra l'element %1 de %2",
    "DATA_DELETEALLOFLIST": "esborra-ho tot de %1",
    "DATA_INSERTATLIST": "afegeix %1 a la posició %2 de %3",
    "DATA_REPLACEITEMOFLIST": "canvia l'element %1 de %2 per %3",
    "DATA_ITEMOFLIST": "element %1 de %2",
    "DATA_ITEMNUMOFLIST": "element # de %1 en %2",
    "DATA_LENGTHOFLIST": "llargada de %1",
    "DATA_LISTCONTAINSITEM": "%1 conté %2?",
    "DATA_SHOWLIST": "mostra la llista %1",
    "DATA_HIDELIST": "amaga la llista %1",
    "DATA_INDEX_ALL": "tot",
    "DATA_INDEX_LAST": "darrer",
    "DATA_INDEX_RANDOM": "aleatori",
    "EVENT_WHENFLAGCLICKED": "quan la %1 es cliqui",
    "EVENT_WHENTHISSPRITECLICKED": "quan es cliqui aquest personatge",
    "EVENT_WHENSTAGECLICKED": "quan es cliqui l'escenari",
    "EVENT_WHENTOUCHINGOBJECT": "quan aquest objecte toqui %1",
    "EVENT_WHENBROADCASTRECEIVED": "quan rebi %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "quan l'escenari canviï al fons %1",
    "EVENT_WHENGREATERTHAN": "quan %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronòmetre",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "volum del so",
    "EVENT_BROADCAST": "envia a tots %1",
    "EVENT_BROADCASTANDWAIT": "envia a tots %1 i espera",
    "EVENT_WHENKEYPRESSED": "quan la tecla %1 es premi",
    "EVENT_WHENKEYPRESSED_SPACE": "espai",
    "EVENT_WHENKEYPRESSED_LEFT": "fletxa esquerra",
    "EVENT_WHENKEYPRESSED_RIGHT": "fletxa dreta",
    "EVENT_WHENKEYPRESSED_DOWN": "fletxa avall",
    "EVENT_WHENKEYPRESSED_UP": "fletxa amunt",
    "EVENT_WHENKEYPRESSED_ANY": "qualsevol",
    "LOOKS_SAYFORSECS": "digues %1 durant %2 segons",
    "LOOKS_SAY": "digues %1",
    "LOOKS_HELLO": "Hola!",
    "LOOKS_THINKFORSECS": "pensa %1 durant %2 segons",
    "LOOKS_THINK": "pensa %1",
    "LOOKS_HMM": "Mmm...",
    "LOOKS_SHOW": "mostra't",
    "LOOKS_HIDE": "amaga't",
    "LOOKS_HIDEALLSPRITES": "amaga tots els personatges",
    "LOOKS_EFFECT_COLOR": "color",
    "LOOKS_EFFECT_FISHEYE": "ull de peix",
    "LOOKS_EFFECT_WHIRL": "remolí",
    "LOOKS_EFFECT_PIXELATE": "pixelar",
    "LOOKS_EFFECT_MOSAIC": "mosaic",
    "LOOKS_EFFECT_BRIGHTNESS": "brillantor",
    "LOOKS_EFFECT_GHOST": "transparència",
    "LOOKS_CHANGEEFFECTBY": "augmenta l'efecte %1 en %2",
    "LOOKS_SETEFFECTTO": "fixa l'efecte %1 a %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "treu els efectes gràfics",
    "LOOKS_CHANGESIZEBY": "augmenta %1 la mida",
    "LOOKS_SETSIZETO": "fixa la mida a %1 %",
    "LOOKS_SIZE": "mida",
    "LOOKS_CHANGESTRETCHBY": "augmenta %1 l'estirament",
    "LOOKS_SETSTRETCHTO": "fixa l'estirament a %1 %",
    "LOOKS_SWITCHCOSTUMETO": "canvia el vestit a %1",
    "LOOKS_NEXTCOSTUME": "següent vestit",
    "LOOKS_SWITCHBACKDROPTO": "canvia el fons a %1",
    "LOOKS_GOTOFRONTBACK": "vés a la capa %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "front",
    "LOOKS_GOTOFRONTBACK_BACK": "darrere",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "vés %1 %2 capes",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "endavant",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "enrere",
    "LOOKS_BACKDROPNUMBERNAME": "fons %1",
    "LOOKS_COSTUMENUMBERNAME": "vestit %1",
    "LOOKS_NUMBERNAME_NUMBER": "número",
    "LOOKS_NUMBERNAME_NAME": "nom",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "canvia el fons a %1 i espera",
    "LOOKS_NEXTBACKDROP_BLOCK": "següent fons de pantalla",
    "LOOKS_NEXTBACKDROP": "següent fons de pantalla",
    "LOOKS_PREVIOUSBACKDROP": "fons anterior",
    "LOOKS_RANDOMBACKDROP": "fons a l'atzar",
    "MOTION_MOVESTEPS": "mou-te %1 passos",
    "MOTION_TURNLEFT": "gira %1 %2 graus",
    "MOTION_TURNRIGHT": "gira %1 %2 graus",
    "MOTION_POINTINDIRECTION": "apunta en direcció %1",
    "MOTION_POINTTOWARDS": "apunta cap a %1",
    "MOTION_POINTTOWARDS_POINTER": "punter del ratolí",
    "MOTION_POINTTOWARDS_RANDOM": "direcció aleatòria",
    "MOTION_GOTO": "vés a %1",
    "MOTION_GOTO_POINTER": "punter del ratolí",
    "MOTION_GOTO_RANDOM": "posició aleatòria",
    "MOTION_GOTOXY": "vés a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "llisca en %1 segons fins a x: %2 y: %3",
    "MOTION_GLIDETO": "llisca en %1 segons fins a %2",
    "MOTION_GLIDETO_POINTER": "punter del ratolí",
    "MOTION_GLIDETO_RANDOM": "posició aleatòria",
    "MOTION_CHANGEXBY": "suma %1 a x",
    "MOTION_SETX": "assigna el valor %1 a x",
    "MOTION_CHANGEYBY": "suma %1 a y",
    "MOTION_SETY": "assigna el valor %1 a y",
    "MOTION_IFONEDGEBOUNCE": "rebota en tocar una vora",
    "MOTION_SETROTATIONSTYLE": "fixa el tipus de rotació %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "esquerra-dreta",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "no giris",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "al voltant",
    "MOTION_XPOSITION": "posició x",
    "MOTION_YPOSITION": "posició y",
    "MOTION_DIRECTION": "direcció",
    "MOTION_SCROLLRIGHT": "desplaça a la dreta %1",
    "MOTION_SCROLLUP": "desplaça amunt %1",
    "MOTION_ALIGNSCENE": "alinea escena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "Baix a l'esquerra",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "Baix a la dreta",
    "MOTION_ALIGNSCENE_MIDDLE": "mig",
    "MOTION_ALIGNSCENE_TOPLEFT": "a dalt a l'esquerra",
    "MOTION_ALIGNSCENE_TOPRIGHT": "a dalt a la dreta",
    "MOTION_XSCROLL": "desplaçament x",
    "MOTION_YSCROLL": "desplaçament y",
    "MOTION_STAGE_SELECTED": "Escenari seleccionat: sense blocs de moviment",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "nombre a l'atzar entre %1 i %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 i %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "no %1",
    "OPERATORS_JOIN": "uneix %1 i %2",
    "OPERATORS_JOIN_APPLE": "poma",
    "OPERATORS_JOIN_BANANA": "plàtan",
    "OPERATORS_LETTEROF": "lletra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "llargada de %1",
    "OPERATORS_CONTAINS": "%1 conté %2?",
    "OPERATORS_MOD": "residu de dividir %1 entre %2",
    "OPERATORS_ROUND": "arrodoneix %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "part sencera",
    "OPERATORS_MATHOP_CEILING": "sostre",
    "OPERATORS_MATHOP_SQRT": "arrel quadrada",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "defineix %1",
    "SENSING_TOUCHINGOBJECT": "tocant %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "punter del ratolí",
    "SENSING_TOUCHINGOBJECT_EDGE": "vora",
    "SENSING_TOUCHINGCOLOR": "tocant el color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "color %1 sobre %2?",
    "SENSING_DISTANCETO": "distància a %1",
    "SENSING_DISTANCETO_POINTER": "punter del ratolí",
    "SENSING_ASKANDWAIT": "pregunta %1 i espera",
    "SENSING_ASK_TEXT": "Com et dius?",
    "SENSING_ANSWER": "resposta",
    "SENSING_KEYPRESSED": "tecla %1 premuda?",
    "SENSING_MOUSEDOWN": "ratolí clicat?",
    "SENSING_MOUSEX": "ratolí x",
    "SENSING_MOUSEY": "ratolí y",
    "SENSING_SETDRAGMODE": "fixa el mode d'arrossegament %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrossegable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "no arrossegable",
    "SENSING_LOUDNESS": "volum del so",
    "SENSING_LOUD": "so fort?",
    "SENSING_TIMER": "cronòmetre",
    "SENSING_RESETTIMER": "reinicia el cronòmetre",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posició x",
    "SENSING_OF_YPOSITION": "posició y",
    "SENSING_OF_DIRECTION": "direcció",
    "SENSING_OF_COSTUMENUMBER": "vestit nr",
    "SENSING_OF_COSTUMENAME": "nom del vestit",
    "SENSING_OF_SIZE": "mida",
    "SENSING_OF_VOLUME": "volum",
    "SENSING_OF_BACKDROPNUMBER": "fons nr",
    "SENSING_OF_BACKDROPNAME": "nom del fons",
    "SENSING_OF_STAGE": "Escenari",
    "SENSING_CURRENT": "actual %1",
    "SENSING_CURRENT_YEAR": "any",
    "SENSING_CURRENT_MONTH": "mes",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "dia de la setmana",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minut",
    "SENSING_CURRENT_SECOND": "segon",
    "SENSING_DAYSSINCE2000": "dies des del 2000",
    "SENSING_USERNAME": "nom d'usuari",
    "SENSING_USERID": "ID d'usuari",
    "SOUND_PLAY": "inicia el so %1",
    "SOUND_PLAYUNTILDONE": "toca el so %1 fins que acabi",
    "SOUND_STOPALLSOUNDS": "atura tots els sons",
    "SOUND_SETEFFECTO": "fixa l'efecte %1 a %2",
    "SOUND_CHANGEEFFECTBY": "augmenta l'efecte %1 en %2",
    "SOUND_CLEAREFFECTS": "treu els efectes sonors",
    "SOUND_EFFECTS_PITCH": "pitch",
    "SOUND_EFFECTS_PAN": "pan esquerra/dreta",
    "SOUND_CHANGEVOLUMEBY": "puja %1 el volum",
    "SOUND_SETVOLUMETO": "fixa el volum a %1%",
    "SOUND_VOLUME": "volum",
    "SOUND_RECORD": "enregistra...",
    "CATEGORY_MOTION": "Moviment",
    "CATEGORY_LOOKS": "Aspecte",
    "CATEGORY_SOUND": "So",
    "CATEGORY_EVENTS": "Esdeveniments",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensors",
    "CATEGORY_OPERATORS": "Operadors",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "Els meus blocs",
    "DUPLICATE": "Duplica",
    "DELETE": "Elimina",
    "ADD_COMMENT": "Afegeix un comentari",
    "REMOVE_COMMENT": "Elimina el comentari",
    "DELETE_BLOCK": "Esborra el bloc",
    "DELETE_X_BLOCKS": "Esborra %1 blocs",
    "DELETE_ALL_BLOCKS": "Eliminar tots els blocs %1 ?",
    "CLEAN_UP": "Neteja els blocs",
    "HELP": "Ajuda",
    "UNDO": "Desfés",
    "REDO": "Torna-hi",
    "EDIT_PROCEDURE": "Edita",
    "SHOW_PROCEDURE_DEFINITION": "Vés a la definició",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Digues alguna cosa...",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturació",
    "COLOUR_BRIGHTNESS_LABEL": "brillantor",
    "CHANGE_VALUE_TITLE": "Canvia el valor:",
    "RENAME_VARIABLE": "Canvia el nom de la variable",
    "RENAME_VARIABLE_TITLE": "Canvia totes les variables \"%1\" a:",
    "RENAME_VARIABLE_MODAL_TITLE": "Canvia el nom de la variable",
    "NEW_VARIABLE": "Crea una variable",
    "NEW_VARIABLE_TITLE": "Nou nom per a la variable:",
    "VARIABLE_MODAL_TITLE": "Nova Variable",
    "VARIABLE_ALREADY_EXISTS": "Ja existeix una variable amb el nom \"%1\".",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Ja existeix una variable anomenada \"%1\" per una altra variable de tipus \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Eliminar els %1 usos de la variable \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "No es pot eliminar la variable \"%1\" perquè forma part de la definició de la funció \"%2\"",
    "DELETE_VARIABLE": "Elimina la variable \"%1\"",
    "NEW_PROCEDURE": "Crea un bloc",
    "PROCEDURE_ALREADY_EXISTS": "Ja existeix un procediment anomenat \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "nom del bloc",
    "PROCEDURE_USED": "Per esborrar la definició d'un bloc, primer cal esborrar-lo de tot arreu on es faci servir",
    "NEW_LIST": "Crea una llista",
    "NEW_LIST_TITLE": "Nou nom per a la llista:",
    "LIST_MODAL_TITLE": "Nova Llista",
    "LIST_ALREADY_EXISTS": "Ja existeix una llista anomenada \"%1\".",
    "RENAME_LIST_TITLE": "Canvia totes les llistes a \"%1\":",
    "RENAME_LIST_MODAL_TITLE": "Canvia el nom de la llista",
    "DEFAULT_LIST_ITEM": "cosa",
    "DELETE_LIST": "Elimina la llista \"%1\"",
    "RENAME_LIST": "Canvia el nom de la llista",
    "NEW_BROADCAST_MESSAGE": "Nou missatge",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nou nom per al missatge:",
    "BROADCAST_MODAL_TITLE": "Missatge nou",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "missatge1"
  },
  "cs": {
    "CONTROL_FOREVER": "opakuj stále",
    "CONTROL_REPEAT": "opakuj %1 krát",
    "CONTROL_IF": "když %1 tak",
    "CONTROL_ELSE": "jinak",
    "CONTROL_STOP": "zastav",
    "CONTROL_STOP_ALL": "všechno",
    "CONTROL_STOP_THIS": "tento scénář",
    "CONTROL_STOP_OTHER": "jiné scénáře postavy",
    "CONTROL_WAIT": "čekej %1 sekund",
    "CONTROL_WAITUNTIL": "čekej dokud nenastane %1",
    "CONTROL_REPEATUNTIL": "opakuj dokud nenastane %1",
    "CONTROL_WHILE": "opakuj dokud platí %1",
    "CONTROL_FOREACH": "pro každé %1 z %2",
    "CONTROL_STARTASCLONE": "když startuje můj klon",
    "CONTROL_CREATECLONEOF": "klonuj %1",
    "CONTROL_CREATECLONEOF_MYSELF": "sebe",
    "CONTROL_DELETETHISCLONE": "zruš tento klon",
    "CONTROL_COUNTER": "čítač",
    "CONTROL_INCRCOUNTER": "zvyš čítač",
    "CONTROL_CLEARCOUNTER": "vynuluj čítač",
    "CONTROL_ALLATONCE": "vše najednou",
    "DATA_SETVARIABLETO": "nastav %1 na %2",
    "DATA_CHANGEVARIABLEBY": "změň %1 o %2",
    "DATA_SHOWVARIABLE": "ukaž proměnnou %1",
    "DATA_HIDEVARIABLE": "skryj proměnnou %1",
    "DATA_ADDTOLIST": "přidej %1 k %2",
    "DATA_DELETEOFLIST": "smaž %1 z %2",
    "DATA_DELETEALLOFLIST": "smaž všechno z %1",
    "DATA_INSERTATLIST": "vlož %1 na %2 v %3",
    "DATA_REPLACEITEMOFLIST": "nahraď %1 v %2 hodnotou %3",
    "DATA_ITEMOFLIST": "prvek %1 z %2",
    "DATA_ITEMNUMOFLIST": "pořadí %1 ve %2",
    "DATA_LENGTHOFLIST": "délka %1",
    "DATA_LISTCONTAINSITEM": "%1 obsahuje %2",
    "DATA_SHOWLIST": "ukaž seznam %1",
    "DATA_HIDELIST": "skryj seznam %1",
    "DATA_INDEX_ALL": "všechno",
    "DATA_INDEX_LAST": "poslední",
    "DATA_INDEX_RANDOM": "náhodně",
    "EVENT_WHENFLAGCLICKED": "po kliknutí na %1",
    "EVENT_WHENTHISSPRITECLICKED": "po kliknutí na mě",
    "EVENT_WHENSTAGECLICKED": "po kliknutí na scénu",
    "EVENT_WHENTOUCHINGOBJECT": "po doteku %1",
    "EVENT_WHENBROADCASTRECEIVED": "po obdržení zprávy %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "po změně pozadí na %1",
    "EVENT_WHENGREATERTHAN": "když %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "stopky",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "hlasitost",
    "EVENT_BROADCAST": "vyšli zprávu %1",
    "EVENT_BROADCASTANDWAIT": "vyšli zprávu %1 a čekej",
    "EVENT_WHENKEYPRESSED": "po stisku klávesy %1",
    "EVENT_WHENKEYPRESSED_SPACE": "mezerník",
    "EVENT_WHENKEYPRESSED_LEFT": "šipka vlevo",
    "EVENT_WHENKEYPRESSED_RIGHT": "šipka vpravo",
    "EVENT_WHENKEYPRESSED_DOWN": "šipka dolů",
    "EVENT_WHENKEYPRESSED_UP": "šipka nahoru",
    "EVENT_WHENKEYPRESSED_ANY": "libovolná",
    "LOOKS_SAYFORSECS": "bublina %1 %2 sekund",
    "LOOKS_SAY": "bublina %1",
    "LOOKS_HELLO": "Ahoj!",
    "LOOKS_THINKFORSECS": "myšlenka %1 %2 sekund",
    "LOOKS_THINK": "myšlenka %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "ukaž se",
    "LOOKS_HIDE": "skryj se",
    "LOOKS_HIDEALLSPRITES": "skryj všechny postavy",
    "LOOKS_EFFECT_COLOR": "barva",
    "LOOKS_EFFECT_FISHEYE": "rybí oko",
    "LOOKS_EFFECT_WHIRL": "víření",
    "LOOKS_EFFECT_PIXELATE": "kostičkování",
    "LOOKS_EFFECT_MOSAIC": "mozaika",
    "LOOKS_EFFECT_BRIGHTNESS": "jas",
    "LOOKS_EFFECT_GHOST": "průhlednost",
    "LOOKS_CHANGEEFFECTBY": "změň efekt %1 o %2",
    "LOOKS_SETEFFECTTO": "nastav efekt %1 na %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "zruš grafické efekty",
    "LOOKS_CHANGESIZEBY": "změň velikost o %1",
    "LOOKS_SETSIZETO": "nastav velikost na %1 %",
    "LOOKS_SIZE": "velikost",
    "LOOKS_CHANGESTRETCHBY": "změň roztažení o %1",
    "LOOKS_SETSTRETCHTO": "nastav roztažení na %1 %",
    "LOOKS_SWITCHCOSTUMETO": "změň kostým na %1",
    "LOOKS_NEXTCOSTUME": "další kostým",
    "LOOKS_SWITCHBACKDROPTO": "přepni pozadí na %1",
    "LOOKS_GOTOFRONTBACK": "přejdi na vrstvu %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "popředí",
    "LOOKS_GOTOFRONTBACK_BACK": "pozadí",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "jdi %1 o %2",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "dopředu",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "dozadu",
    "LOOKS_BACKDROPNUMBERNAME": "pozadí %1",
    "LOOKS_COSTUMENUMBERNAME": "kostým %1",
    "LOOKS_NUMBERNAME_NUMBER": "číslo",
    "LOOKS_NUMBERNAME_NAME": "název",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "změň pozadí na %1",
    "LOOKS_NEXTBACKDROP_BLOCK": "další pozadí",
    "LOOKS_NEXTBACKDROP": "další pozadí",
    "LOOKS_PREVIOUSBACKDROP": "předchozí pozadí",
    "LOOKS_RANDOMBACKDROP": "náhodné pozadí",
    "MOTION_MOVESTEPS": "dopředu o %1 kroků",
    "MOTION_TURNLEFT": "otoč se %1 o %2 stupňů",
    "MOTION_TURNRIGHT": "otoč se %1 o %2 stupňů",
    "MOTION_POINTINDIRECTION": "nastav směr %1",
    "MOTION_POINTTOWARDS": "nastav směr k %1",
    "MOTION_POINTTOWARDS_POINTER": "ukazateli myši",
    "MOTION_POINTTOWARDS_RANDOM": "náhodný směr",
    "MOTION_GOTO": "skoč na %1",
    "MOTION_GOTO_POINTER": "ukazatel myši",
    "MOTION_GOTO_RANDOM": "náhodná pozice",
    "MOTION_GOTOXY": "skoč na x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "klouzej %1 sekund na x: %2 y: %3",
    "MOTION_GLIDETO": "klouzej %1 sekund na %2",
    "MOTION_GLIDETO_POINTER": "ukazatel myši",
    "MOTION_GLIDETO_RANDOM": "náhodná pozice",
    "MOTION_CHANGEXBY": "změň x o %1",
    "MOTION_SETX": "nastav x na %1",
    "MOTION_CHANGEYBY": "změň y o %1",
    "MOTION_SETY": "nastav y na %1",
    "MOTION_IFONEDGEBOUNCE": "když narazíš na okraj, odraz se",
    "MOTION_SETROTATIONSTYLE": "nastav otáčení %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "vlevo-vpravo",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "neotáčet",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "dokola",
    "MOTION_XPOSITION": "x",
    "MOTION_YPOSITION": "y",
    "MOTION_DIRECTION": "směr",
    "MOTION_SCROLLRIGHT": "posuň se doprava %1",
    "MOTION_SCROLLUP": "posuň se nahoru %1",
    "MOTION_ALIGNSCENE": "zarovnej scénu %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "vlevo dole",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "vpravo dole",
    "MOTION_ALIGNSCENE_MIDDLE": "prostřední",
    "MOTION_ALIGNSCENE_TOPLEFT": "vlevo nahoře",
    "MOTION_ALIGNSCENE_TOPRIGHT": "vpravo nahoře",
    "MOTION_XSCROLL": "x přesouvání",
    "MOTION_YSCROLL": "y přesouvání",
    "MOTION_STAGE_SELECTED": "Scéna je zvolena: nemá bloky pohybu",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "náhodné číslo od %1 do %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 a %2",
    "OPERATORS_OR": "%1 nebo %2",
    "OPERATORS_NOT": "ne %1",
    "OPERATORS_JOIN": "spoj %1 %2",
    "OPERATORS_JOIN_APPLE": "jablko",
    "OPERATORS_JOIN_BANANA": "banán",
    "OPERATORS_LETTEROF": "písmeno %1 z %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "délka %1",
    "OPERATORS_CONTAINS": "%1 obsahuje %2?",
    "OPERATORS_MOD": "zbytek %1 děleno %2",
    "OPERATORS_ROUND": "zaokrouhli %1",
    "OPERATORS_MATHOP": "%1 %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "zaokr. dolů",
    "OPERATORS_MATHOP_CEILING": "zaokr. nahoru",
    "OPERATORS_MATHOP_SQRT": "odmocnina",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tg",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctg",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "scénář pro %1",
    "SENSING_TOUCHINGOBJECT": "dotýkáš se %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "ukazatele myši",
    "SENSING_TOUCHINGOBJECT_EDGE": "okraje",
    "SENSING_TOUCHINGCOLOR": "dotýkáš se barvy %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "barvou %1 se dotýkáš %2?",
    "SENSING_DISTANCETO": "vzdálenost k %1",
    "SENSING_DISTANCETO_POINTER": "ukazateli myši",
    "SENSING_ASKANDWAIT": "otázka %1",
    "SENSING_ASK_TEXT": "Jak se jmenuješ?",
    "SENSING_ANSWER": "odpověď",
    "SENSING_KEYPRESSED": "klávesa %1 stisknuta?",
    "SENSING_MOUSEDOWN": "myš stisknuta?",
    "SENSING_MOUSEX": "x myši",
    "SENSING_MOUSEY": "y myši",
    "SENSING_SETDRAGMODE": "povoleno přesouvat %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ano",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ne",
    "SENSING_LOUDNESS": "hlasitost",
    "SENSING_LOUD": "hlasité?",
    "SENSING_TIMER": "stopky",
    "SENSING_RESETTIMER": "vynuluj stopky",
    "SENSING_OF": "%1 z %2",
    "SENSING_OF_XPOSITION": "x",
    "SENSING_OF_YPOSITION": "y",
    "SENSING_OF_DIRECTION": "směr",
    "SENSING_OF_COSTUMENUMBER": "číslo kostýmu",
    "SENSING_OF_COSTUMENAME": "název kostýmu",
    "SENSING_OF_SIZE": "velikost",
    "SENSING_OF_VOLUME": "hlasitost",
    "SENSING_OF_BACKDROPNUMBER": "číslo pozadí",
    "SENSING_OF_BACKDROPNAME": "název pozadí",
    "SENSING_OF_STAGE": "Scéna",
    "SENSING_CURRENT": "aktuální %1",
    "SENSING_CURRENT_YEAR": "rok",
    "SENSING_CURRENT_MONTH": "měsíc",
    "SENSING_CURRENT_DATE": "den v měsíci",
    "SENSING_CURRENT_DAYOFWEEK": "den týdne",
    "SENSING_CURRENT_HOUR": "hodina",
    "SENSING_CURRENT_MINUTE": "minuta",
    "SENSING_CURRENT_SECOND": "sekunda",
    "SENSING_DAYSSINCE2000": "dnů od r. 2000",
    "SENSING_USERNAME": "jméno uživatele",
    "SENSING_USERID": "ID uživatele",
    "SOUND_PLAY": "začni hrát zvuk %1",
    "SOUND_PLAYUNTILDONE": "přehraj zvuk %1 až do konce",
    "SOUND_STOPALLSOUNDS": "zastav všechny zvuky",
    "SOUND_SETEFFECTO": "nastav efekt %1 na %2",
    "SOUND_CHANGEEFFECTBY": "změň efekt %1 o %2",
    "SOUND_CLEAREFFECTS": "zruš zvukové efekty",
    "SOUND_EFFECTS_PITCH": "poloha",
    "SOUND_EFFECTS_PAN": "stereo vlevo/vpravo",
    "SOUND_CHANGEVOLUMEBY": "změň hlasitost o %1",
    "SOUND_SETVOLUMETO": "nastav hlasitost na %1%",
    "SOUND_VOLUME": "hlasitost",
    "SOUND_RECORD": "záznam ...",
    "CATEGORY_MOTION": "Pohyb",
    "CATEGORY_LOOKS": "Vzhled",
    "CATEGORY_SOUND": "Zvuk",
    "CATEGORY_EVENTS": "Události",
    "CATEGORY_CONTROL": "Ovládání",
    "CATEGORY_SENSING": "Vnímání",
    "CATEGORY_OPERATORS": "Operátory",
    "CATEGORY_VARIABLES": "Proměnné",
    "CATEGORY_MYBLOCKS": "Moje bloky",
    "DUPLICATE": "Kopírovat",
    "DELETE": "Odstranit",
    "ADD_COMMENT": "Přidat poznámku",
    "REMOVE_COMMENT": "Odstranit poznámku",
    "DELETE_BLOCK": "Smaž blok",
    "DELETE_X_BLOCKS": "Smazat %1 bloků",
    "DELETE_ALL_BLOCKS": "Smazat všech %1 bloků?",
    "CLEAN_UP": "Ukliď bloky",
    "HELP": "Pomoc",
    "UNDO": "Vrátit",
    "REDO": "Znovu provést",
    "EDIT_PROCEDURE": "Upravit",
    "SHOW_PROCEDURE_DEFINITION": "Jdi ke scénáři",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Řekni něco ...",
    "COLOUR_HUE_LABEL": "Barva",
    "COLOUR_SATURATION_LABEL": "Sytost",
    "COLOUR_BRIGHTNESS_LABEL": "Jas",
    "CHANGE_VALUE_TITLE": "Změň hodnotu:",
    "RENAME_VARIABLE": "Přejmenovat proměnnou",
    "RENAME_VARIABLE_TITLE": "Přejmenuj všech \"%1\" proměnných na:",
    "RENAME_VARIABLE_MODAL_TITLE": "Přejmenovat proměnnou",
    "NEW_VARIABLE": "Vytvoř proměnnou",
    "NEW_VARIABLE_TITLE": "Nové jméno proměnné:",
    "VARIABLE_MODAL_TITLE": "Nová proměnná",
    "VARIABLE_ALREADY_EXISTS": "Proměnná pojmenovaná \"%1\" již existuje.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Proměnná téhož jména \"%1\" již existuje jako jiná proměnná typu \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Smazat %1 výskytů proměnné \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Nelze smazat proměnnou \"%1\", protože je součástí scénáře funkce \"%2\"",
    "DELETE_VARIABLE": "Smaž proměnnou \"%1\"",
    "NEW_PROCEDURE": "Vytvořit blok",
    "PROCEDURE_ALREADY_EXISTS": "Scénář se jménem \"%1\" již existuje.",
    "PROCEDURE_DEFAULT_NAME": "název bloku",
    "PROCEDURE_USED": "Před smazáním bloku jej nejprve odstraň ze všech míst, kde je použit.",
    "NEW_LIST": "Vytvoř seznam",
    "NEW_LIST_TITLE": "Nový název seznamu:",
    "LIST_MODAL_TITLE": "Nový seznam",
    "LIST_ALREADY_EXISTS": "Seznam \"%1\" již existuje.",
    "RENAME_LIST_TITLE": "Přejmenuj všech \"%1\" seznamů na:",
    "RENAME_LIST_MODAL_TITLE": "Přejmenuj seznam",
    "DEFAULT_LIST_ITEM": "věc",
    "DELETE_LIST": "Smaž seznam \"%1\"",
    "RENAME_LIST": "Přejmenuj seznam",
    "NEW_BROADCAST_MESSAGE": "Nová zpráva",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nový název zprávy:",
    "BROADCAST_MODAL_TITLE": "Nová zpráva",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "zpráva1"
  },
  "cy": {
    "CONTROL_FOREVER": "am byth",
    "CONTROL_REPEAT": "ailadrodd %1",
    "CONTROL_IF": "os %1 yna",
    "CONTROL_ELSE": "fel arall",
    "CONTROL_STOP": "aros",
    "CONTROL_STOP_ALL": "y cyfan",
    "CONTROL_STOP_THIS": "y sgript hon",
    "CONTROL_STOP_OTHER": "sgriptiau eraill yn y ciplun",
    "CONTROL_WAIT": "aros %1 eiliad",
    "CONTROL_WAITUNTIL": "aros hyd at %1",
    "CONTROL_REPEATUNTIL": "ailadrodd hyd at %1",
    "CONTROL_WHILE": "tra bo %1",
    "CONTROL_FOREACH": "am bob %1 yn %2",
    "CONTROL_STARTASCLONE": "pan rwy'n dechrau fel clôn",
    "CONTROL_CREATECLONEOF": "creu clôn o %1",
    "CONTROL_CREATECLONEOF_MYSELF": "fi fy hun",
    "CONTROL_DELETETHISCLONE": "dileu y clôn hwn",
    "CONTROL_COUNTER": "rhifydd",
    "CONTROL_INCRCOUNTER": "rhifydd cynyddiad",
    "CONTROL_CLEARCOUNTER": "clirio'r rhifydd",
    "CONTROL_ALLATONCE": "pob un ar unwaith",
    "DATA_SETVARIABLETO": "gosod %1 i %2",
    "DATA_CHANGEVARIABLEBY": "newid %1 gan %2",
    "DATA_SHOWVARIABLE": "dangos newidyn %1",
    "DATA_HIDEVARIABLE": "cuddio newidyn %1",
    "DATA_ADDTOLIST": "ychwanegu %1 i %2",
    "DATA_DELETEOFLIST": "dileu %1 o %2",
    "DATA_DELETEALLOFLIST": "Dileu pob un o'r %1",
    "DATA_INSERTATLIST": "mewnosod %1 yn %2 o %3",
    "DATA_REPLACEITEMOFLIST": "amnewid eitem %1 o %2 gyda %3",
    "DATA_ITEMOFLIST": "eitem %1 o %2",
    "DATA_ITEMNUMOFLIST": "eitem # %1 yn %2",
    "DATA_LENGTHOFLIST": "hyd %1",
    "DATA_LISTCONTAINSITEM": "%1 yn cynnwys %2?",
    "DATA_SHOWLIST": "dangos rhestr %1",
    "DATA_HIDELIST": "cuddio rhestr %1",
    "DATA_INDEX_ALL": "y cyfan",
    "DATA_INDEX_LAST": "olaf",
    "DATA_INDEX_RANDOM": "ar hap",
    "EVENT_WHENFLAGCLICKED": "pan fydd %1 wedi ei glicio",
    "EVENT_WHENTHISSPRITECLICKED": "pan gaiff y ciplun yma ei glicio",
    "EVENT_WHENSTAGECLICKED": "pan fydd llwyfan wedi ei glicio",
    "EVENT_WHENTOUCHINGOBJECT": "pan fydd y corlun yn cyffwrdd %1",
    "EVENT_WHENBROADCASTRECEIVED": "pan rwy'n derbyn %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "pan fydd cefndir yn newid i %1",
    "EVENT_WHENGREATERTHAN": "pan %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "amserydd",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "cryfder sain",
    "EVENT_BROADCAST": "darlledu  %1",
    "EVENT_BROADCASTANDWAIT": "darlledu %1 ac aros",
    "EVENT_WHENKEYPRESSED": "pan fo bysell %1 wedi ei wasgu",
    "EVENT_WHENKEYPRESSED_SPACE": "bwlch",
    "EVENT_WHENKEYPRESSED_LEFT": "saeth chwith",
    "EVENT_WHENKEYPRESSED_RIGHT": "saeth de",
    "EVENT_WHENKEYPRESSED_DOWN": "saeth i lawr",
    "EVENT_WHENKEYPRESSED_UP": "saeth i fyny",
    "EVENT_WHENKEYPRESSED_ANY": "unrhyw",
    "LOOKS_SAYFORSECS": "dweud %1 am %2 eiliad",
    "LOOKS_SAY": "dweud %1",
    "LOOKS_HELLO": "Helo!",
    "LOOKS_THINKFORSECS": "meddwl %1 am %2 eiliad",
    "LOOKS_THINK": "meddwl %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "dangos",
    "LOOKS_HIDE": "cuddio",
    "LOOKS_HIDEALLSPRITES": "cuddio pob ciplun",
    "LOOKS_EFFECT_COLOR": "lliw",
    "LOOKS_EFFECT_FISHEYE": "llygad pysgodyn",
    "LOOKS_EFFECT_WHIRL": "chwyrliad",
    "LOOKS_EFFECT_PIXELATE": "picseleiddio",
    "LOOKS_EFFECT_MOSAIC": "mosaig",
    "LOOKS_EFFECT_BRIGHTNESS": "disgleirdeb",
    "LOOKS_EFFECT_GHOST": "ysbryd",
    "LOOKS_CHANGEEFFECTBY": "newid effaith %1 gan %2",
    "LOOKS_SETEFFECTTO": "gosod effaith %1 effaith i %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "clirio effeithiau graffeg",
    "LOOKS_CHANGESIZEBY": "newid maint gan %1",
    "LOOKS_SETSIZETO": "gosod maint i %1 %",
    "LOOKS_SIZE": "maint",
    "LOOKS_CHANGESTRETCHBY": "newid yr ymestyn gan %1",
    "LOOKS_SETSTRETCHTO": "gosod ymestyniad gan %1 %",
    "LOOKS_SWITCHCOSTUMETO": "newid gwisg i %1",
    "LOOKS_NEXTCOSTUME": "gwisg nesaf",
    "LOOKS_SWITCHBACKDROPTO": "newid cefndir i %1",
    "LOOKS_GOTOFRONTBACK": "mynd i haen %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "blaen",
    "LOOKS_GOTOFRONTBACK_BACK": "cefn",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "mynd i haenau %1 %2",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ymlaen",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "nôl",
    "LOOKS_BACKDROPNUMBERNAME": "cefnlen %1",
    "LOOKS_COSTUMENUMBERNAME": "gwisg %1",
    "LOOKS_NUMBERNAME_NUMBER": "rhif",
    "LOOKS_NUMBERNAME_NAME": "enw",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "newid cefnlen i %1 ac aros",
    "LOOKS_NEXTBACKDROP_BLOCK": "cefnlen nesaf",
    "LOOKS_NEXTBACKDROP": "cefnlen nesaf",
    "LOOKS_PREVIOUSBACKDROP": "cefnlen flaenorol",
    "LOOKS_RANDOMBACKDROP": "cefnlen ar hap",
    "MOTION_MOVESTEPS": "symud %1 cam",
    "MOTION_TURNLEFT": "troi %1 %2 gradd",
    "MOTION_TURNRIGHT": "troi %1 %2 gradd",
    "MOTION_POINTINDIRECTION": "pwyntio i gyfeiriad %1",
    "MOTION_POINTTOWARDS": "pwyntio tuag at %1",
    "MOTION_POINTTOWARDS_POINTER": "pwyntydd llygoden",
    "MOTION_POINTTOWARDS_RANDOM": "cyfeiriad ar hap",
    "MOTION_GOTO": "mynd i %1",
    "MOTION_GOTO_POINTER": "pwyntydd llygoden",
    "MOTION_GOTO_RANDOM": "safle ar hap",
    "MOTION_GOTOXY": "mynd i x:%1 y: %2",
    "MOTION_GLIDESECSTOXY": "llithro %1 eiliad i x: %2 y: %3",
    "MOTION_GLIDETO": "llithro %1 eiliad i %2",
    "MOTION_GLIDETO_POINTER": "pwyntydd llygoden",
    "MOTION_GLIDETO_RANDOM": "safle ar hap",
    "MOTION_CHANGEXBY": "newid x gan %1",
    "MOTION_SETX": "gosod x i %1",
    "MOTION_CHANGEYBY": "newid y gan %1",
    "MOTION_SETY": "gosod y i %1",
    "MOTION_IFONEDGEBOUNCE": "os ar ymyl, bowndio",
    "MOTION_SETROTATIONSTYLE": "gosod steil cylchdroi %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "chwith-dde",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "peidio troi",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "o amgylch",
    "MOTION_XPOSITION": "safle x",
    "MOTION_YPOSITION": "safle y",
    "MOTION_DIRECTION": "cyfeiriad",
    "MOTION_SCROLLRIGHT": "sgrolio i'r dde %1",
    "MOTION_SCROLLUP": "sgrolio i fyny %1",
    "MOTION_ALIGNSCENE": "alinio golygfa %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "gwaelod chwith",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "gwaelod de",
    "MOTION_ALIGNSCENE_MIDDLE": "canol",
    "MOTION_ALIGNSCENE_TOPLEFT": "brig chwith",
    "MOTION_ALIGNSCENE_TOPRIGHT": "brig de",
    "MOTION_XSCROLL": "sgrolio x",
    "MOTION_YSCROLL": "sgrolio y",
    "MOTION_STAGE_SELECTED": "Llwyfan wedi ei ddewis: dim blociau symud",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "dewis ar hap %1 i %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 a %2",
    "OPERATORS_OR": "%1 neu %2",
    "OPERATORS_NOT": "nid %1",
    "OPERATORS_JOIN": "uno %1 %2",
    "OPERATORS_JOIN_APPLE": "afal",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "llythyren %1 o %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "hyd %1",
    "OPERATORS_CONTAINS": "%1 yn cynnwys %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "talgrynnu %1",
    "OPERATORS_MATHOP": "%1 o %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "llawr",
    "OPERATORS_MATHOP_CEILING": "nenfwd",
    "OPERATORS_MATHOP_SQRT": "ail isradd",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "Yn",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "diffinio %1",
    "SENSING_TOUCHINGOBJECT": "cyffwrdd %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "pwyntydd llygoden",
    "SENSING_TOUCHINGOBJECT_EDGE": "ymyl",
    "SENSING_TOUCHINGCOLOR": "cyffwrdd lliw %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "lliw %1 yn cyffwrdd %2?",
    "SENSING_DISTANCETO": "pellter i %1",
    "SENSING_DISTANCETO_POINTER": "pwyntydd llygoden",
    "SENSING_ASKANDWAIT": "gofyn %1 ac aros",
    "SENSING_ASK_TEXT": "Beth yw eich enw?",
    "SENSING_ANSWER": "ateb",
    "SENSING_KEYPRESSED": "bysell %1 wedi ei phwyso?",
    "SENSING_MOUSEDOWN": "llygoden i lawr?",
    "SENSING_MOUSEX": "llygoden x",
    "SENSING_MOUSEY": "llygoden y",
    "SENSING_SETDRAGMODE": "gosod y modd llusgo %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "llusgadwy",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "anllusgadwy",
    "SENSING_LOUDNESS": "cryfder sain",
    "SENSING_LOUD": "sain gref?",
    "SENSING_TIMER": "amserydd",
    "SENSING_RESETTIMER": "ailosod amserydd",
    "SENSING_OF": "%1 o %2",
    "SENSING_OF_XPOSITION": "safle x",
    "SENSING_OF_YPOSITION": "safle y",
    "SENSING_OF_DIRECTION": "cyfeiriad",
    "SENSING_OF_COSTUMENUMBER": "gwisg #",
    "SENSING_OF_COSTUMENAME": "enw'r wisg",
    "SENSING_OF_SIZE": "maint",
    "SENSING_OF_VOLUME": "lefel sain",
    "SENSING_OF_BACKDROPNUMBER": "cefnlen #",
    "SENSING_OF_BACKDROPNAME": "enw cefnlen",
    "SENSING_OF_STAGE": "Llwyfan",
    "SENSING_CURRENT": "cyfredol %1",
    "SENSING_CURRENT_YEAR": "blwyddyn",
    "SENSING_CURRENT_MONTH": "mis",
    "SENSING_CURRENT_DATE": "dyddiad",
    "SENSING_CURRENT_DAYOFWEEK": "diwrnod o'r wythnos",
    "SENSING_CURRENT_HOUR": "awr",
    "SENSING_CURRENT_MINUTE": "munud",
    "SENSING_CURRENT_SECOND": "eiliad",
    "SENSING_DAYSSINCE2000": "dyddiau ers 2000",
    "SENSING_USERNAME": "enw defnyddiwr",
    "SENSING_USERID": "id defnyddiwr",
    "SOUND_PLAY": "cychwyn sain %1",
    "SOUND_PLAYUNTILDONE": "chwarae sain %1 tan y diwedd",
    "SOUND_STOPALLSOUNDS": "atal pob sain",
    "SOUND_SETEFFECTO": "gosod effaith %1 effaith i %2",
    "SOUND_CHANGEEFFECTBY": "newid effaith %1 gan %2",
    "SOUND_CLEAREFFECTS": "clirio effeithiau sain",
    "SOUND_EFFECTS_PITCH": "traw",
    "SOUND_EFFECTS_PAN": "troi chwith/de",
    "SOUND_CHANGEVOLUMEBY": "newid uchder sain gan %1",
    "SOUND_SETVOLUMETO": "gosod lefel sain i %1%",
    "SOUND_VOLUME": "lefel sain",
    "SOUND_RECORD": "recordio...",
    "CATEGORY_MOTION": "Symudiad",
    "CATEGORY_LOOKS": "Edrychiad",
    "CATEGORY_SOUND": "Sain",
    "CATEGORY_EVENTS": "Digwyddiadau",
    "CATEGORY_CONTROL": "Rheoli",
    "CATEGORY_SENSING": "Synhwyro",
    "CATEGORY_OPERATORS": "Gweithredwyr",
    "CATEGORY_VARIABLES": "Newidynnau",
    "CATEGORY_MYBLOCKS": "Fy Mlociau",
    "DUPLICATE": "Dyblygu",
    "DELETE": "Dileu",
    "ADD_COMMENT": "Ychwanegu Sylw",
    "REMOVE_COMMENT": "Tynnu Sylw",
    "DELETE_BLOCK": "Dileu Bloc",
    "DELETE_X_BLOCKS": "Dileu %1 Bloc",
    "DELETE_ALL_BLOCKS": "Dileu pob un o'r %1 bloc?",
    "CLEAN_UP": "Glanhau'r Blociau",
    "HELP": "Cymorth",
    "UNDO": "Dadwneud",
    "REDO": "Ailwneud",
    "EDIT_PROCEDURE": "Golygu",
    "SHOW_PROCEDURE_DEFINITION": "Mynd i'r diffiniad",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Dwedwch rywbeth...",
    "COLOUR_HUE_LABEL": "Lliw",
    "COLOUR_SATURATION_LABEL": "Dirlawnder",
    "COLOUR_BRIGHTNESS_LABEL": "Disgleirdeb",
    "CHANGE_VALUE_TITLE": "Newid gwerth:",
    "RENAME_VARIABLE": "Ailenwi newidyn",
    "RENAME_VARIABLE_TITLE": "Ailenwi pob newidyn \"%1\" i:",
    "RENAME_VARIABLE_MODAL_TITLE": "Ailenwi Newidyn",
    "NEW_VARIABLE": "Creu Newidyn",
    "NEW_VARIABLE_TITLE": "Enw newidyn newydd:",
    "VARIABLE_MODAL_TITLE": "Newidyn Newydd",
    "VARIABLE_ALREADY_EXISTS": "Mae newidyn o'r enw \"%1\" yn bodoli eisoes.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Mae newidyn o'r enw \"%1\" yn bodoli eisoes ar gyfer math arall o newidyn \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Dileu'r defnydd %1 o'r newidyn \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Methu dileu newidyn \"%1\" gan ei fod yn rhan o ddiffiniad swyddogaeth \"%2\"",
    "DELETE_VARIABLE": "Dileu newidyn \"%1\"",
    "NEW_PROCEDURE": "Creu Bloc",
    "PROCEDURE_ALREADY_EXISTS": "Mae trefn o'r enw \"%1\" yn bodoli eisoes.",
    "PROCEDURE_DEFAULT_NAME": "enw bloc",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Gwneud Rhestr",
    "NEW_LIST_TITLE": "Enw rhestr newydd:",
    "LIST_MODAL_TITLE": "Rhestr Newydd",
    "LIST_ALREADY_EXISTS": "Mae rhestr o'r enw \"%1\" yn bodoli eisoes.",
    "RENAME_LIST_TITLE": "Ailenwi pob rhestr \"%1\" i:",
    "RENAME_LIST_MODAL_TITLE": "Ailenwi Rhestr",
    "DEFAULT_LIST_ITEM": "peth",
    "DELETE_LIST": "Dileu'r rhestr \"%1\" ",
    "RENAME_LIST": "Ailenwi rhestr",
    "NEW_BROADCAST_MESSAGE": "Neges newydd",
    "NEW_BROADCAST_MESSAGE_TITLE": "Enw neges newydd:",
    "BROADCAST_MODAL_TITLE": "Neges Newydd",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "neges1"
  },
  "da": {
    "CONTROL_FOREVER": "for evigt",
    "CONTROL_REPEAT": "gentag %1 gange",
    "CONTROL_IF": "hvis %1 så",
    "CONTROL_ELSE": "ellers",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "alle",
    "CONTROL_STOP_THIS": "dette script",
    "CONTROL_STOP_OTHER": "andre scripts i sprite",
    "CONTROL_WAIT": "vent %1 sekunder",
    "CONTROL_WAITUNTIL": "vent indtil %1",
    "CONTROL_REPEATUNTIL": "gentag indtil %1",
    "CONTROL_WHILE": "mens %1",
    "CONTROL_FOREACH": "for hver %1 i %2",
    "CONTROL_STARTASCLONE": "når jeg starter som klon",
    "CONTROL_CREATECLONEOF": "opret en klon af %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mig selv",
    "CONTROL_DELETETHISCLONE": "slet denne klon",
    "CONTROL_COUNTER": "tæller",
    "CONTROL_INCRCOUNTER": "tæl tæller op",
    "CONTROL_CLEARCOUNTER": "nulstil tæller",
    "CONTROL_ALLATONCE": "alle på en gang",
    "DATA_SETVARIABLETO": "sæt %1 til %2",
    "DATA_CHANGEVARIABLEBY": "ændre %1 med %2",
    "DATA_SHOWVARIABLE": "vis variabel %1",
    "DATA_HIDEVARIABLE": "skjul variabel %1",
    "DATA_ADDTOLIST": "tilføj %1 til %2",
    "DATA_DELETEOFLIST": "slet %1 af %2",
    "DATA_DELETEALLOFLIST": "slet alle %1",
    "DATA_INSERTATLIST": "indsæt %1 ved %2 af %3",
    "DATA_REPLACEITEMOFLIST": "erstat nummer %1 af %2 med %3",
    "DATA_ITEMOFLIST": "nummer %1 af %2",
    "DATA_ITEMNUMOFLIST": "nummer # af %1 i %2",
    "DATA_LENGTHOFLIST": "længden af %1",
    "DATA_LISTCONTAINSITEM": "%1 indeholder %2?",
    "DATA_SHOWLIST": "vis liste %1",
    "DATA_HIDELIST": "skjul liste %1",
    "DATA_INDEX_ALL": "alle",
    "DATA_INDEX_LAST": "sidste",
    "DATA_INDEX_RANDOM": "tilfældig",
    "EVENT_WHENFLAGCLICKED": "når der klikkes på %1 ",
    "EVENT_WHENTHISSPRITECLICKED": "når denne sprite klikkes",
    "EVENT_WHENSTAGECLICKED": "når scene er valgt",
    "EVENT_WHENTOUCHINGOBJECT": "når denne sprite berører %1",
    "EVENT_WHENBROADCASTRECEIVED": "når jeg modtager %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "når baggrund skifter til %1",
    "EVENT_WHENGREATERTHAN": "når %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "stopur",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "lydstyrke",
    "EVENT_BROADCAST": "send %1",
    "EVENT_BROADCASTANDWAIT": "send %1 og vent",
    "EVENT_WHENKEYPRESSED": "når du trykker på %1",
    "EVENT_WHENKEYPRESSED_SPACE": "mellemrum",
    "EVENT_WHENKEYPRESSED_LEFT": "venstre pil",
    "EVENT_WHENKEYPRESSED_RIGHT": "højre pil",
    "EVENT_WHENKEYPRESSED_DOWN": "pil nedad",
    "EVENT_WHENKEYPRESSED_UP": "pil opad",
    "EVENT_WHENKEYPRESSED_ANY": "vilkårlig",
    "LOOKS_SAYFORSECS": "sig %1 i %2 sekunder",
    "LOOKS_SAY": "sig %1",
    "LOOKS_HELLO": "Hej!",
    "LOOKS_THINKFORSECS": "tænk %1 i %2 sekunder",
    "LOOKS_THINK": "tænk %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "vis",
    "LOOKS_HIDE": "skjul",
    "LOOKS_HIDEALLSPRITES": "skjul alle sprites",
    "LOOKS_EFFECT_COLOR": "farve",
    "LOOKS_EFFECT_FISHEYE": "fiskeøje",
    "LOOKS_EFFECT_WHIRL": "vrid",
    "LOOKS_EFFECT_PIXELATE": "pixeler",
    "LOOKS_EFFECT_MOSAIC": "mosaik",
    "LOOKS_EFFECT_BRIGHTNESS": "lysstyrke",
    "LOOKS_EFFECT_GHOST": "spøgelse",
    "LOOKS_CHANGEEFFECTBY": "ændre effekt %1 med %2",
    "LOOKS_SETEFFECTTO": "sæt effekt %1 til %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "fjern grafiske effekter",
    "LOOKS_CHANGESIZEBY": "ændre størrelse med %1",
    "LOOKS_SETSIZETO": "sæt størrelse til %1 %",
    "LOOKS_SIZE": "størrelse",
    "LOOKS_CHANGESTRETCHBY": "ændre stræk med %1",
    "LOOKS_SETSTRETCHTO": "sæt stræk til %1 %",
    "LOOKS_SWITCHCOSTUMETO": "skift kostume til %1",
    "LOOKS_NEXTCOSTUME": "næste kostume",
    "LOOKS_SWITCHBACKDROPTO": "skift baggrund til %1",
    "LOOKS_GOTOFRONTBACK": "gå til %1 lag",
    "LOOKS_GOTOFRONTBACK_FRONT": "forreste",
    "LOOKS_GOTOFRONTBACK_BACK": "bagerste",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "gå %2 lag %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "frem",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "tilbage",
    "LOOKS_BACKDROPNUMBERNAME": "baggrund %1",
    "LOOKS_COSTUMENUMBERNAME": "kostume %1",
    "LOOKS_NUMBERNAME_NUMBER": "nummer",
    "LOOKS_NUMBERNAME_NAME": "navn",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "skift baggrund til %1 og vent",
    "LOOKS_NEXTBACKDROP_BLOCK": "næste baggrund",
    "LOOKS_NEXTBACKDROP": "næste baggrund",
    "LOOKS_PREVIOUSBACKDROP": "forrige baggrund",
    "LOOKS_RANDOMBACKDROP": "tilfældig baggrund",
    "MOTION_MOVESTEPS": "gå %1 trin",
    "MOTION_TURNLEFT": "drej %1 %2 grader",
    "MOTION_TURNRIGHT": "drej %1 %2 grader",
    "MOTION_POINTINDIRECTION": "peg i retning %1",
    "MOTION_POINTTOWARDS": "peg mod %1",
    "MOTION_POINTTOWARDS_POINTER": "musepil",
    "MOTION_POINTTOWARDS_RANDOM": "tilfældig retning",
    "MOTION_GOTO": "gå til %1",
    "MOTION_GOTO_POINTER": "musepil",
    "MOTION_GOTO_RANDOM": "tilfældig position",
    "MOTION_GOTOXY": "gå til x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glid %1 sekunder til x: %2 y: %3",
    "MOTION_GLIDETO": "glid %1 sekunder til %2",
    "MOTION_GLIDETO_POINTER": "musepil",
    "MOTION_GLIDETO_RANDOM": "tilfældig position",
    "MOTION_CHANGEXBY": "ændre x med %1",
    "MOTION_SETX": "sæt x til %1",
    "MOTION_CHANGEYBY": "ændre y med %1",
    "MOTION_SETY": "sæt y til %1",
    "MOTION_IFONEDGEBOUNCE": "hop tilbage ved kanten",
    "MOTION_SETROTATIONSTYLE": "sæt rotationsstil til %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "venstre-højre",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "drej ikke",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "alle retninger",
    "MOTION_XPOSITION": "x position",
    "MOTION_YPOSITION": "y position",
    "MOTION_DIRECTION": "retning",
    "MOTION_SCROLLRIGHT": "rul mod højre %1",
    "MOTION_SCROLLUP": "rul op %1",
    "MOTION_ALIGNSCENE": "tilpas scene %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "nederst-til-venstre",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "nederst-til-højre",
    "MOTION_ALIGNSCENE_MIDDLE": "midten",
    "MOTION_ALIGNSCENE_TOPLEFT": "øverst-til-venstre",
    "MOTION_ALIGNSCENE_TOPRIGHT": "øverst-til-højre",
    "MOTION_XSCROLL": "x rul",
    "MOTION_YSCROLL": "y rul",
    "MOTION_STAGE_SELECTED": "scene valgt: ingen bevægelses brikker",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "vælg tilfældigt mellem %1 og %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 og %2",
    "OPERATORS_OR": "%1 eller %2",
    "OPERATORS_NOT": "ikke %1",
    "OPERATORS_JOIN": "%1 tilkobles %2",
    "OPERATORS_JOIN_APPLE": "æble",
    "OPERATORS_JOIN_BANANA": "banan",
    "OPERATORS_LETTEROF": "tegn %1 af %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "længden af %1",
    "OPERATORS_CONTAINS": "%1 indeholder %2?",
    "OPERATORS_MOD": "%1 modulo %2",
    "OPERATORS_ROUND": "afrund %1",
    "OPERATORS_MATHOP": "%1 af %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "rund ned",
    "OPERATORS_MATHOP_CEILING": "rund op",
    "OPERATORS_MATHOP_SQRT": "kvrod",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definer %1",
    "SENSING_TOUCHINGOBJECT": "berører %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "musepil",
    "SENSING_TOUCHINGOBJECT_EDGE": "kant",
    "SENSING_TOUCHINGCOLOR": "berører farven %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "berører %1 farven %2?",
    "SENSING_DISTANCETO": "afstand til %1",
    "SENSING_DISTANCETO_POINTER": "musepil",
    "SENSING_ASKANDWAIT": "bed om %1 og vent",
    "SENSING_ASK_TEXT": "Hvad er dit navn?",
    "SENSING_ANSWER": "svar",
    "SENSING_KEYPRESSED": "trykket på tasten %1?",
    "SENSING_MOUSEDOWN": "trykket på musen?",
    "SENSING_MOUSEX": "musens x-position",
    "SENSING_MOUSEY": "musens y-position",
    "SENSING_SETDRAGMODE": "sæt flytbarhed til %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "kan flyttes",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "kan ikke flyttes",
    "SENSING_LOUDNESS": "lydstyrke",
    "SENSING_LOUD": "højt?",
    "SENSING_TIMER": "stopur",
    "SENSING_RESETTIMER": "nulstil stopur",
    "SENSING_OF": "%1 af %2",
    "SENSING_OF_XPOSITION": "x position",
    "SENSING_OF_YPOSITION": "y position",
    "SENSING_OF_DIRECTION": "retning",
    "SENSING_OF_COSTUMENUMBER": "kostume #",
    "SENSING_OF_COSTUMENAME": "navn på kostume",
    "SENSING_OF_SIZE": "størrelse",
    "SENSING_OF_VOLUME": "lydstyrke",
    "SENSING_OF_BACKDROPNUMBER": "baggrund #",
    "SENSING_OF_BACKDROPNAME": "navn på baggrund",
    "SENSING_OF_STAGE": "Scene",
    "SENSING_CURRENT": "nuværende %1",
    "SENSING_CURRENT_YEAR": "år",
    "SENSING_CURRENT_MONTH": "måned",
    "SENSING_CURRENT_DATE": "dato",
    "SENSING_CURRENT_DAYOFWEEK": "ugedag",
    "SENSING_CURRENT_HOUR": "time",
    "SENSING_CURRENT_MINUTE": "minut",
    "SENSING_CURRENT_SECOND": "sekund",
    "SENSING_DAYSSINCE2000": "dage siden 2000",
    "SENSING_USERNAME": "brugernavn",
    "SENSING_USERID": "bruger id",
    "SOUND_PLAY": "spil lyden %1",
    "SOUND_PLAYUNTILDONE": "spil lyden %1 indtil færdig",
    "SOUND_STOPALLSOUNDS": "stop al lyd",
    "SOUND_SETEFFECTO": "sæt effekt %1 til %2",
    "SOUND_CHANGEEFFECTBY": "ændre effekt %1 med %2",
    "SOUND_CLEAREFFECTS": "fjern lydeffekter",
    "SOUND_EFFECTS_PITCH": "tonehøjde",
    "SOUND_EFFECTS_PAN": "balance venstre/højre",
    "SOUND_CHANGEVOLUMEBY": "ændre lydstyrke med %1",
    "SOUND_SETVOLUMETO": "sæt lydstyrke til %1%",
    "SOUND_VOLUME": "lydstyrke",
    "SOUND_RECORD": "optag...",
    "CATEGORY_MOTION": "Bevægelse",
    "CATEGORY_LOOKS": "Udseende",
    "CATEGORY_SOUND": "Lyd",
    "CATEGORY_EVENTS": "Hændelser",
    "CATEGORY_CONTROL": "Kontrol",
    "CATEGORY_SENSING": "Registrering",
    "CATEGORY_OPERATORS": "Operatorer",
    "CATEGORY_VARIABLES": "Variabler",
    "CATEGORY_MYBLOCKS": "Mine brikker",
    "DUPLICATE": "Kopiér",
    "DELETE": "Slet",
    "ADD_COMMENT": "Tilføj kommentar",
    "REMOVE_COMMENT": "Slet kommentar",
    "DELETE_BLOCK": "Slet brik",
    "DELETE_X_BLOCKS": "Slet %1 brikker",
    "DELETE_ALL_BLOCKS": "Slet alle %1 brikker?",
    "CLEAN_UP": "Ryd brikkerne op",
    "HELP": "Hjælp",
    "UNDO": "Fortryd",
    "REDO": "Gør om",
    "EDIT_PROCEDURE": "Redigér",
    "SHOW_PROCEDURE_DEFINITION": "Gå til forklaring",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Sig noget...",
    "COLOUR_HUE_LABEL": "Farve",
    "COLOUR_SATURATION_LABEL": "Farvemætning",
    "COLOUR_BRIGHTNESS_LABEL": "Lysstyrke",
    "CHANGE_VALUE_TITLE": "Ændre værdien:",
    "RENAME_VARIABLE": "Omdøb variabel",
    "RENAME_VARIABLE_TITLE": "Omdøb alle \"%1\" variabler til:",
    "RENAME_VARIABLE_MODAL_TITLE": "Omdøb variabel",
    "NEW_VARIABLE": "Lav en variabel",
    "NEW_VARIABLE_TITLE": "Navn på ny variabel:",
    "VARIABLE_MODAL_TITLE": "Ny variabel",
    "VARIABLE_ALREADY_EXISTS": "Der eksisterer allerede en variabel med navnet \"%1\".",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Der eksisterer allerede en variabel med navnet \"%1\"  for en anden variabel af typen \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Slet %1 brugen af denne \"%2\" variabel?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Kan ikke slette variablen \"%1\" fordi at den er en del af forklaringen til funktionen \"%2\"",
    "DELETE_VARIABLE": "Slet \"%1\" variablen",
    "NEW_PROCEDURE": "Lav en brik",
    "PROCEDURE_ALREADY_EXISTS": "Der eksisterer allerede en procedure med navnet \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "brikkens navn",
    "PROCEDURE_USED": "Hvis du vil slette en definition af en blok, skal du først fjerne brugen af den.",
    "NEW_LIST": "Lav en liste",
    "NEW_LIST_TITLE": "Navn på ny liste:",
    "LIST_MODAL_TITLE": "Ny liste",
    "LIST_ALREADY_EXISTS": "Der eksisterer allerede en liste med navnet \"%1\".",
    "RENAME_LIST_TITLE": "Omdøb alle \"%1\" lister til:",
    "RENAME_LIST_MODAL_TITLE": "Omdøb liste",
    "DEFAULT_LIST_ITEM": "ting",
    "DELETE_LIST": "Slet \"%1\" listen",
    "RENAME_LIST": "Omdøb liste",
    "NEW_BROADCAST_MESSAGE": "Ny besked",
    "NEW_BROADCAST_MESSAGE_TITLE": "Navn på ny besked:",
    "BROADCAST_MODAL_TITLE": "Ny besked",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "besked1"
  },
  "de": {
    "CONTROL_FOREVER": "wiederhole fortlaufend",
    "CONTROL_REPEAT": "wiederhole %1 mal",
    "CONTROL_IF": "falls %1, dann",
    "CONTROL_ELSE": "sonst",
    "CONTROL_STOP": "stoppe",
    "CONTROL_STOP_ALL": "alles",
    "CONTROL_STOP_THIS": "dieses Skript",
    "CONTROL_STOP_OTHER": "andere Skripte der Figur",
    "CONTROL_WAIT": "warte %1 Sekunden",
    "CONTROL_WAITUNTIL": "warte bis %1",
    "CONTROL_REPEATUNTIL": "wiederhole bis %1",
    "CONTROL_WHILE": "wiederhole solange %1",
    "CONTROL_FOREACH": "wiederhole für jedes %1 in %2",
    "CONTROL_STARTASCLONE": "Wenn ich als Klon entstehe",
    "CONTROL_CREATECLONEOF": "erzeuge Klon von %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mir selbst",
    "CONTROL_DELETETHISCLONE": "lösche diesen Klon",
    "CONTROL_COUNTER": "Zähler",
    "CONTROL_INCRCOUNTER": "erhöhe Zähler",
    "CONTROL_CLEARCOUNTER": "lösche Zähler",
    "CONTROL_ALLATONCE": "Alle gleichzeitig",
    "DATA_SETVARIABLETO": "setze %1 auf %2",
    "DATA_CHANGEVARIABLEBY": "ändere %1 um %2",
    "DATA_SHOWVARIABLE": "zeige Variable %1",
    "DATA_HIDEVARIABLE": "verstecke Variable %1",
    "DATA_ADDTOLIST": "füge %1 zu %2 hinzu",
    "DATA_DELETEOFLIST": "lösche %1 aus %2",
    "DATA_DELETEALLOFLIST": "lösche alles aus %1",
    "DATA_INSERTATLIST": "füge %1 bei %2 in %3 ein",
    "DATA_REPLACEITEMOFLIST": "ersetze Element %1 von %2 durch %3",
    "DATA_ITEMOFLIST": "Element %1 von %2",
    "DATA_ITEMNUMOFLIST": "Nummer von %1 in %2",
    "DATA_LENGTHOFLIST": "Länge von %1",
    "DATA_LISTCONTAINSITEM": "%1 enthält %2?",
    "DATA_SHOWLIST": "zeige Liste %1",
    "DATA_HIDELIST": "verstecke Liste %1",
    "DATA_INDEX_ALL": "alles",
    "DATA_INDEX_LAST": "letztes",
    "DATA_INDEX_RANDOM": "zufälliges",
    "EVENT_WHENFLAGCLICKED": "Wenn %1 angeklickt wird",
    "EVENT_WHENTHISSPRITECLICKED": "Wenn diese Figur angeklickt wird",
    "EVENT_WHENSTAGECLICKED": "Wenn die Bühne angeklickt wird",
    "EVENT_WHENTOUCHINGOBJECT": "Wenn diese Figur %1 berührt",
    "EVENT_WHENBROADCASTRECEIVED": "Wenn ich %1 empfange",
    "EVENT_WHENBACKDROPSWITCHESTO": "Wenn das Bühnenbild zu %1 wechselt",
    "EVENT_WHENGREATERTHAN": "Wenn %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "Stoppuhr",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "Lautstärke",
    "EVENT_BROADCAST": "sende %1 an alle",
    "EVENT_BROADCASTANDWAIT": "sende %1 an alle und warte",
    "EVENT_WHENKEYPRESSED": "Wenn Taste %1 gedrückt wird",
    "EVENT_WHENKEYPRESSED_SPACE": "Leertaste",
    "EVENT_WHENKEYPRESSED_LEFT": "Pfeil nach links",
    "EVENT_WHENKEYPRESSED_RIGHT": "Pfeil nach rechts",
    "EVENT_WHENKEYPRESSED_DOWN": "Pfeil nach unten",
    "EVENT_WHENKEYPRESSED_UP": "Pfeil nach oben",
    "EVENT_WHENKEYPRESSED_ANY": "beliebiges",
    "LOOKS_SAYFORSECS": "sage %1 für %2 Sekunden",
    "LOOKS_SAY": "sage %1",
    "LOOKS_HELLO": "Hallo!",
    "LOOKS_THINKFORSECS": "denke %1 für %2 Sekunden",
    "LOOKS_THINK": "denke %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "zeige dich",
    "LOOKS_HIDE": "verstecke dich",
    "LOOKS_HIDEALLSPRITES": "Alle Figuren verbergen",
    "LOOKS_EFFECT_COLOR": "Farbe",
    "LOOKS_EFFECT_FISHEYE": "Fischauge",
    "LOOKS_EFFECT_WHIRL": "Wirbel",
    "LOOKS_EFFECT_PIXELATE": "Pixel",
    "LOOKS_EFFECT_MOSAIC": "Mosaik",
    "LOOKS_EFFECT_BRIGHTNESS": "Helligkeit",
    "LOOKS_EFFECT_GHOST": "Durchsichtigkeit",
    "LOOKS_CHANGEEFFECTBY": "ändere Effekt %1 um %2",
    "LOOKS_SETEFFECTTO": "setze Effekt %1 auf %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "schalte Grafikeffekte aus",
    "LOOKS_CHANGESIZEBY": "ändere Größe um %1",
    "LOOKS_SETSIZETO": "setze Größe auf %1",
    "LOOKS_SIZE": "Größe",
    "LOOKS_CHANGESTRETCHBY": "ändere Dehnung um %1",
    "LOOKS_SETSTRETCHTO": "setze Dehnung auf %1 %",
    "LOOKS_SWITCHCOSTUMETO": "wechsle zu Kostüm %1",
    "LOOKS_NEXTCOSTUME": "wechsle zum nächsten Kostüm",
    "LOOKS_SWITCHBACKDROPTO": "wechsle zu Bühnenbild %1",
    "LOOKS_GOTOFRONTBACK": "gehe zu %1 Ebene",
    "LOOKS_GOTOFRONTBACK_FRONT": "vorderster",
    "LOOKS_GOTOFRONTBACK_BACK": "hinterster",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "gehe %2 Ebenen %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "nach vorne",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "nach hinten",
    "LOOKS_BACKDROPNUMBERNAME": "Bühnenbild %1",
    "LOOKS_COSTUMENUMBERNAME": "Kostüm %1",
    "LOOKS_NUMBERNAME_NUMBER": "Nummer",
    "LOOKS_NUMBERNAME_NAME": "Name",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "wechsle zu Bühnenbild %1 und warte",
    "LOOKS_NEXTBACKDROP_BLOCK": "wechsle zum nächsten Bühnenbild",
    "LOOKS_NEXTBACKDROP": "nächstes Bühnenbild",
    "LOOKS_PREVIOUSBACKDROP": "vorheriges Bühnenbild",
    "LOOKS_RANDOMBACKDROP": "zufälliges Bühnenbild",
    "MOTION_MOVESTEPS": "gehe %1 er Schritt",
    "MOTION_TURNLEFT": "drehe dich %1 um %2 Grad",
    "MOTION_TURNRIGHT": "drehe dich %1 um %2 Grad",
    "MOTION_POINTINDIRECTION": "setze Richtung auf %1 Grad",
    "MOTION_POINTTOWARDS": "drehe dich zu %1",
    "MOTION_POINTTOWARDS_POINTER": "Mauszeiger",
    "MOTION_POINTTOWARDS_RANDOM": "Zufallsrichtung",
    "MOTION_GOTO": "gehe zu %1",
    "MOTION_GOTO_POINTER": "Mauszeiger",
    "MOTION_GOTO_RANDOM": "Zufallsposition",
    "MOTION_GOTOXY": "gehe zu x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "gleite in %1 Sek. zu x:%2  y:%3",
    "MOTION_GLIDETO": "gleite in %1 Sek. zu %2",
    "MOTION_GLIDETO_POINTER": "Mauszeiger",
    "MOTION_GLIDETO_RANDOM": "Zufallsposition",
    "MOTION_CHANGEXBY": "ändere x um %1",
    "MOTION_SETX": "setze x auf %1",
    "MOTION_CHANGEYBY": "ändere y um %1",
    "MOTION_SETY": "setze y auf %1",
    "MOTION_IFONEDGEBOUNCE": "pralle vom Rand ab",
    "MOTION_SETROTATIONSTYLE": "setze Drehtyp auf %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "links-rechts",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "nicht drehen",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "rundherum",
    "MOTION_XPOSITION": "x-Position",
    "MOTION_YPOSITION": "y-Position",
    "MOTION_DIRECTION": "Richtung",
    "MOTION_SCROLLRIGHT": "%1 nach rechts bewegen",
    "MOTION_SCROLLUP": "%1 nach oben bewegen",
    "MOTION_ALIGNSCENE": "Szene ausrichten %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "unten links",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "unten rechts",
    "MOTION_ALIGNSCENE_MIDDLE": "Mitte",
    "MOTION_ALIGNSCENE_TOPLEFT": "oben links",
    "MOTION_ALIGNSCENE_TOPRIGHT": "oben rechts",
    "MOTION_XSCROLL": "x-Bewegung",
    "MOTION_YSCROLL": "y-Bewegung",
    "MOTION_STAGE_SELECTED": "Bühne ausgewählt: keine Bewegungsblöcke",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "Zufallszahl von %1 bis %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 und %2",
    "OPERATORS_OR": "%1 oder %2",
    "OPERATORS_NOT": "nicht %1",
    "OPERATORS_JOIN": "verbinde %1 und %2",
    "OPERATORS_JOIN_APPLE": "Apfel",
    "OPERATORS_JOIN_BANANA": "Banane",
    "OPERATORS_LETTEROF": "Zeichen %1 von %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "Länge von %1",
    "OPERATORS_CONTAINS": "%1 enthält %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "%1 gerundet",
    "OPERATORS_MATHOP": "%1 von %2",
    "OPERATORS_MATHOP_ABS": "Betrag",
    "OPERATORS_MATHOP_FLOOR": "abrunden",
    "OPERATORS_MATHOP_CEILING": "aufrunden",
    "OPERATORS_MATHOP_SQRT": "Wurzel",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e^",
    "OPERATORS_MATHOP_10EXP": "10^",
    "PROCEDURES_DEFINITION": "Definiere %1",
    "SENSING_TOUCHINGOBJECT": "wird %1 berührt?",
    "SENSING_TOUCHINGOBJECT_POINTER": "Mauszeiger",
    "SENSING_TOUCHINGOBJECT_EDGE": "Rand",
    "SENSING_TOUCHINGCOLOR": "wird Farbe %1 berührt?",
    "SENSING_COLORISTOUCHINGCOLOR": "Farbe %1 berührt %2?",
    "SENSING_DISTANCETO": "Entfernung von %1",
    "SENSING_DISTANCETO_POINTER": "Mauszeiger",
    "SENSING_ASKANDWAIT": "frage %1 und warte",
    "SENSING_ASK_TEXT": "Wie heißt du?",
    "SENSING_ANSWER": "Antwort",
    "SENSING_KEYPRESSED": "Taste %1 gedrückt?",
    "SENSING_MOUSEDOWN": "Maustaste gedrückt?",
    "SENSING_MOUSEX": "Maus x-Position",
    "SENSING_MOUSEY": "Maus y-Position",
    "SENSING_SETDRAGMODE": "setze Ziehbarkeit auf %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ziehbar",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "nicht ziehbar",
    "SENSING_LOUDNESS": "Lautstärke",
    "SENSING_LOUD": "laut?",
    "SENSING_TIMER": "Stoppuhr",
    "SENSING_RESETTIMER": "setze Stoppuhr zurück",
    "SENSING_OF": "%1 von %2",
    "SENSING_OF_XPOSITION": "x-Position",
    "SENSING_OF_YPOSITION": "y-Position",
    "SENSING_OF_DIRECTION": "Richtung",
    "SENSING_OF_COSTUMENUMBER": "Kostümnummer",
    "SENSING_OF_COSTUMENAME": "Kostümname",
    "SENSING_OF_SIZE": "Größe",
    "SENSING_OF_VOLUME": "Lautstärke",
    "SENSING_OF_BACKDROPNUMBER": "Bühnenbildnummer",
    "SENSING_OF_BACKDROPNAME": "Bühnenbildname",
    "SENSING_OF_STAGE": "Bühne",
    "SENSING_CURRENT": "%1 im Moment",
    "SENSING_CURRENT_YEAR": "Jahr",
    "SENSING_CURRENT_MONTH": "Monat",
    "SENSING_CURRENT_DATE": "Datum",
    "SENSING_CURRENT_DAYOFWEEK": "Wochentag",
    "SENSING_CURRENT_HOUR": "Stunde",
    "SENSING_CURRENT_MINUTE": "Minute",
    "SENSING_CURRENT_SECOND": "Sekunde",
    "SENSING_DAYSSINCE2000": "Tage seit 2000",
    "SENSING_USERNAME": "Benutzername",
    "SENSING_USERID": "Benutzer-ID",
    "SOUND_PLAY": "spiele Klang %1",
    "SOUND_PLAYUNTILDONE": "spiele Klang %1 ganz",
    "SOUND_STOPALLSOUNDS": "stoppe alle Klänge",
    "SOUND_SETEFFECTO": "setze Effekt %1 auf %2",
    "SOUND_CHANGEEFFECTBY": "ändere Effekt %1 um %2",
    "SOUND_CLEAREFFECTS": "schalte Klangeffekte aus",
    "SOUND_EFFECTS_PITCH": "Höhe",
    "SOUND_EFFECTS_PAN": "Aussteuern links/rechts",
    "SOUND_CHANGEVOLUMEBY": "ändere Lautstärke um %1",
    "SOUND_SETVOLUMETO": "setze Lautstärke auf %1%",
    "SOUND_VOLUME": "Lautstärke",
    "SOUND_RECORD": "zeichne auf...",
    "CATEGORY_MOTION": "Bewegung",
    "CATEGORY_LOOKS": "Aussehen",
    "CATEGORY_SOUND": "Klang",
    "CATEGORY_EVENTS": "Ereignisse",
    "CATEGORY_CONTROL": "Steuerung",
    "CATEGORY_SENSING": "Fühlen",
    "CATEGORY_OPERATORS": "Operatoren",
    "CATEGORY_VARIABLES": "Variablen",
    "CATEGORY_MYBLOCKS": "Meine Blöcke",
    "DUPLICATE": "Duplizieren",
    "DELETE": "Löschen",
    "ADD_COMMENT": "Kommentar hinzufügen",
    "REMOVE_COMMENT": "Kommentar entfernen",
    "DELETE_BLOCK": "Lösche Block",
    "DELETE_X_BLOCKS": "Lösche %1 Blöcke",
    "DELETE_ALL_BLOCKS": "Alle %1 Blöcke löschen?",
    "CLEAN_UP": "Blöcke aufräumen",
    "HELP": "Hilfe",
    "UNDO": "Rückgängig",
    "REDO": "Wiederherstellen",
    "EDIT_PROCEDURE": "Bearbeiten",
    "SHOW_PROCEDURE_DEFINITION": "Gehe zur Definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Sag etwas...",
    "COLOUR_HUE_LABEL": "Farbe",
    "COLOUR_SATURATION_LABEL": "Sättigung",
    "COLOUR_BRIGHTNESS_LABEL": "Helligkeit",
    "CHANGE_VALUE_TITLE": "Ändere Wert",
    "RENAME_VARIABLE": "Benenne die Variable um",
    "RENAME_VARIABLE_TITLE": "Benenne alle Variablen mit Namen \"%1\" um in:",
    "RENAME_VARIABLE_MODAL_TITLE": "Variable umbenennen",
    "NEW_VARIABLE": "Neue Variable",
    "NEW_VARIABLE_TITLE": "Neuer Variablenname:",
    "VARIABLE_MODAL_TITLE": "Neue Variable",
    "VARIABLE_ALREADY_EXISTS": "Eine Variable mit dem Namen \"%1\" existiert bereits.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Eine Variable mit dem Namen \"%1\" existiert bereits als Variable des Typs \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Entferne alle %1 Nutzungen der Variable \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Die Variable \"%1\" kann nicht gelöscht werden, weil sie Teil der Definition der Funktion \"%2\" ist.",
    "DELETE_VARIABLE": "Lösche die Variable \"%1\"",
    "NEW_PROCEDURE": "Neuer Block",
    "PROCEDURE_ALREADY_EXISTS": "Eine Prozedur mit dem Namen \"%1\" existiert bereits.",
    "PROCEDURE_DEFAULT_NAME": "Blockname",
    "PROCEDURE_USED": "Bevor die Blockdefinition gelöscht werden kann, muss der Block zuerst aus allen Skripten entfernt werden, in denen er verwendet wird",
    "NEW_LIST": "Neue Liste",
    "NEW_LIST_TITLE": "Neuer Listenname:",
    "LIST_MODAL_TITLE": "Neue Liste",
    "LIST_ALREADY_EXISTS": "Eine Liste mit dem Namen \"%1\" existiert bereits",
    "RENAME_LIST_TITLE": "Benenne alle Listen mit Namen \"%1\" um in:",
    "RENAME_LIST_MODAL_TITLE": "Liste umbenennen",
    "DEFAULT_LIST_ITEM": "Ding",
    "DELETE_LIST": "Lösche die Liste \"%1\"",
    "RENAME_LIST": "Benenne die Liste um",
    "NEW_BROADCAST_MESSAGE": "Neue Nachricht",
    "NEW_BROADCAST_MESSAGE_TITLE": "Neuer Nachrichtentext:",
    "BROADCAST_MODAL_TITLE": "Neue Nachricht",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "Nachricht1"
  },
  "et": {
    "CONTROL_FOREVER": "korda lõputult",
    "CONTROL_REPEAT": "korda %1 korda",
    "CONTROL_IF": "kui %1 siis",
    "CONTROL_ELSE": "muidu",
    "CONTROL_STOP": "stopp",
    "CONTROL_STOP_ALL": "kõik",
    "CONTROL_STOP_THIS": "see skript",
    "CONTROL_STOP_OTHER": "teised spraidi skriptid",
    "CONTROL_WAIT": "oota %1 sek",
    "CONTROL_WAITUNTIL": "oota kuni %1",
    "CONTROL_REPEATUNTIL": "korda kuni %1",
    "CONTROL_WHILE": "kui %1",
    "CONTROL_FOREACH": "iga %1 jaoks %2-s",
    "CONTROL_STARTASCLONE": "kui alustan kloonina",
    "CONTROL_CREATECLONEOF": "klooni %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ennast",
    "CONTROL_DELETETHISCLONE": "eemalda see kloon",
    "CONTROL_COUNTER": "loendur",
    "CONTROL_INCRCOUNTER": "suurenda loendurit",
    "CONTROL_CLEARCOUNTER": "nulli loendur",
    "CONTROL_ALLATONCE": "kõik korraga",
    "DATA_SETVARIABLETO": "võta %1 = %2",
    "DATA_CHANGEVARIABLEBY": "muuda %1 %2 võrra",
    "DATA_SHOWVARIABLE": "näita muutujat %1",
    "DATA_HIDEVARIABLE": "peida muutuja %1",
    "DATA_ADDTOLIST": "lisa %1 loendisse %2",
    "DATA_DELETEOFLIST": "eemalda %1 loendist %2",
    "DATA_DELETEALLOFLIST": "eemalda kõik loendist %1",
    "DATA_INSERTATLIST": "sisesta %1 kohale %2 loendis %3",
    "DATA_REPLACEITEMOFLIST": "asenda väärtus %1 loendis %2 %3 -ga",
    "DATA_ITEMOFLIST": "%1 loendis %2",
    "DATA_ITEMNUMOFLIST": "%1 jrk nr loendis %2",
    "DATA_LENGTHOFLIST": "%1 pikkus",
    "DATA_LISTCONTAINSITEM": "%1 sisaldab %2?",
    "DATA_SHOWLIST": "näita loendit %1",
    "DATA_HIDELIST": "peida loend %1",
    "DATA_INDEX_ALL": "kõik",
    "DATA_INDEX_LAST": "viimane",
    "DATA_INDEX_RANDOM": "juhuslik",
    "EVENT_WHENFLAGCLICKED": "kui klõpsata %1",
    "EVENT_WHENTHISSPRITECLICKED": "kui spraiti klõpsata",
    "EVENT_WHENSTAGECLICKED": "kui lava klõpsata",
    "EVENT_WHENTOUCHINGOBJECT": "kui sprait puudutab %1",
    "EVENT_WHENBROADCASTRECEIVED": "kui saan teate %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "kui taustaks saab %1",
    "EVENT_WHENGREATERTHAN": "kui %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "taimer",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "valjus",
    "EVENT_BROADCAST": "teata %1",
    "EVENT_BROADCASTANDWAIT": "teata %1 ja oota",
    "EVENT_WHENKEYPRESSED": "kui klõpsata klahvi %1",
    "EVENT_WHENKEYPRESSED_SPACE": "tühik",
    "EVENT_WHENKEYPRESSED_LEFT": "nool vasakule",
    "EVENT_WHENKEYPRESSED_RIGHT": "nool paremale",
    "EVENT_WHENKEYPRESSED_DOWN": "nool alla",
    "EVENT_WHENKEYPRESSED_UP": "nool üles",
    "EVENT_WHENKEYPRESSED_ANY": "mõni",
    "LOOKS_SAYFORSECS": "ütle %1 %2 sek",
    "LOOKS_SAY": "ütle %1",
    "LOOKS_HELLO": "Tere!",
    "LOOKS_THINKFORSECS": "mõtle %1 %2 sek",
    "LOOKS_THINK": "mõtle %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "näita",
    "LOOKS_HIDE": "peida",
    "LOOKS_HIDEALLSPRITES": "peida kõik spraidid",
    "LOOKS_EFFECT_COLOR": "värv",
    "LOOKS_EFFECT_FISHEYE": "kalasilm",
    "LOOKS_EFFECT_WHIRL": "pööris",
    "LOOKS_EFFECT_PIXELATE": "pikseldus",
    "LOOKS_EFFECT_MOSAIC": "mosaiik",
    "LOOKS_EFFECT_BRIGHTNESS": "heledus",
    "LOOKS_EFFECT_GHOST": "kummitus",
    "LOOKS_CHANGEEFFECTBY": "muuda efekti %1 %2 võrra",
    "LOOKS_SETEFFECTTO": "pane %1 efekt %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "tühista graafikaefektid",
    "LOOKS_CHANGESIZEBY": "muuda suurust %1 võrra",
    "LOOKS_SETSIZETO": "võta suuruseks %1 %",
    "LOOKS_SIZE": "suurus",
    "LOOKS_CHANGESTRETCHBY": "muuda ulatust %1 võrra",
    "LOOKS_SETSTRETCHTO": "võta ulatuseks %1 %",
    "LOOKS_SWITCHCOSTUMETO": "võta kostüüm %1",
    "LOOKS_NEXTCOSTUME": "järgmine kostüüm",
    "LOOKS_SWITCHBACKDROPTO": "võta taust %1",
    "LOOKS_GOTOFRONTBACK": "mine kihile %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "esiplaan",
    "LOOKS_GOTOFRONTBACK_BACK": "tagaplaan",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "mine %1 %2 kihti",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ettepoole",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "tahapoole",
    "LOOKS_BACKDROPNUMBERNAME": "tausta %1",
    "LOOKS_COSTUMENUMBERNAME": "kostüümi %1",
    "LOOKS_NUMBERNAME_NUMBER": "number",
    "LOOKS_NUMBERNAME_NAME": "nimi",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "võta taust %1 ja oota",
    "LOOKS_NEXTBACKDROP_BLOCK": "järgmine taust",
    "LOOKS_NEXTBACKDROP": "järgmine taust",
    "LOOKS_PREVIOUSBACKDROP": "eelmine taust",
    "LOOKS_RANDOMBACKDROP": "juhuslik taust",
    "MOTION_MOVESTEPS": "liigu %1 punkti",
    "MOTION_TURNLEFT": "pööra %1 %2 kraadi",
    "MOTION_TURNRIGHT": "pööra %1 %2 kraadi",
    "MOTION_POINTINDIRECTION": "osuta suunas %1",
    "MOTION_POINTTOWARDS": "osuta %1-le",
    "MOTION_POINTTOWARDS_POINTER": "hiirekursor",
    "MOTION_POINTTOWARDS_RANDOM": "juhusuund",
    "MOTION_GOTO": "mine %1",
    "MOTION_GOTO_POINTER": "hiirekursor",
    "MOTION_GOTO_RANDOM": "juhuslik asukoht",
    "MOTION_GOTOXY": "mine x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "liugle %1 sekundiga x: %2 y: %3",
    "MOTION_GLIDETO": "liugle %1 sekundiga %2",
    "MOTION_GLIDETO_POINTER": "hiirekursor",
    "MOTION_GLIDETO_RANDOM": "juhuslik asukoht",
    "MOTION_CHANGEXBY": "muuda x %1 võrra",
    "MOTION_SETX": "võta x %1",
    "MOTION_CHANGEYBY": "muuda y %1 võrra",
    "MOTION_SETY": "võta y %1",
    "MOTION_IFONEDGEBOUNCE": "kui äärel, põrka",
    "MOTION_SETROTATIONSTYLE": "määra pööramisstiil %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "vasak-parem",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ei pöördu",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "suvaline",
    "MOTION_XPOSITION": "x",
    "MOTION_YPOSITION": "y",
    "MOTION_DIRECTION": "suund",
    "MOTION_SCROLLRIGHT": "keri paremale %1",
    "MOTION_SCROLLUP": "keri üles %1",
    "MOTION_ALIGNSCENE": "joonda stseen %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "alla vasakule",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "alla paremale",
    "MOTION_ALIGNSCENE_MIDDLE": "keskele",
    "MOTION_ALIGNSCENE_TOPLEFT": "üles vasakule",
    "MOTION_ALIGNSCENE_TOPRIGHT": "üles paremale",
    "MOTION_XSCROLL": "x kerimine",
    "MOTION_YSCROLL": "y kerimine",
    "MOTION_STAGE_SELECTED": "Valitud on Lava: liikumiskäsud puuduvad",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "juhuarv %1 kuni %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 ja %2",
    "OPERATORS_OR": "%1 või %2",
    "OPERATORS_NOT": "mitte %1",
    "OPERATORS_JOIN": "%1 & %2",
    "OPERATORS_JOIN_APPLE": "õun",
    "OPERATORS_JOIN_BANANA": "banaan",
    "OPERATORS_LETTEROF": "märk %1 sõnas %2",
    "OPERATORS_LETTEROF_APPLE": "õ",
    "OPERATORS_LENGTH": "%1 pikkus",
    "OPERATORS_CONTAINS": "%1 sisaldab %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "ümarda %1",
    "OPERATORS_MATHOP": "%2 %1",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "floor",
    "OPERATORS_MATHOP_CEILING": "ceiling",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "defineeri %1",
    "SENSING_TOUCHINGOBJECT": "puudutab %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "hiirekursor",
    "SENSING_TOUCHINGOBJECT_EDGE": "serv",
    "SENSING_TOUCHINGCOLOR": "puudutab värvi %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "värv %1 puudutab värvi %2?",
    "SENSING_DISTANCETO": "kaugus %1-st",
    "SENSING_DISTANCETO_POINTER": "hiirekursor",
    "SENSING_ASKANDWAIT": "küsi %1 ja oota",
    "SENSING_ASK_TEXT": "Mis Su nimi on?",
    "SENSING_ANSWER": "vastus",
    "SENSING_KEYPRESSED": "klahv %1 all?",
    "SENSING_MOUSEDOWN": "hiir all?",
    "SENSING_MOUSEX": "hiire x",
    "SENSING_MOUSEY": "hiire y",
    "SENSING_SETDRAGMODE": "võta lohistatavus = %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "lohistatav",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "pole lohistatav",
    "SENSING_LOUDNESS": "valjus",
    "SENSING_LOUD": "väga vali?",
    "SENSING_TIMER": "taimer",
    "SENSING_RESETTIMER": "nulli taimer",
    "SENSING_OF": "%2 %1",
    "SENSING_OF_XPOSITION": "x",
    "SENSING_OF_YPOSITION": "y",
    "SENSING_OF_DIRECTION": "suund",
    "SENSING_OF_COSTUMENUMBER": "kostüümi nr",
    "SENSING_OF_COSTUMENAME": "kostüümi nimi",
    "SENSING_OF_SIZE": "suurus",
    "SENSING_OF_VOLUME": "helitugevus",
    "SENSING_OF_BACKDROPNUMBER": "tausta nr",
    "SENSING_OF_BACKDROPNAME": "tausta nimi",
    "SENSING_OF_STAGE": "Lava",
    "SENSING_CURRENT": "hetke %1",
    "SENSING_CURRENT_YEAR": "aasta",
    "SENSING_CURRENT_MONTH": "kuu",
    "SENSING_CURRENT_DATE": "kuupäev",
    "SENSING_CURRENT_DAYOFWEEK": "nädalapäev",
    "SENSING_CURRENT_HOUR": "tunnid",
    "SENSING_CURRENT_MINUTE": "minutid",
    "SENSING_CURRENT_SECOND": "sekundid",
    "SENSING_DAYSSINCE2000": "päevi alates 2000",
    "SENSING_USERNAME": "kasutajanimi",
    "SENSING_USERID": "kasutaja ID",
    "SOUND_PLAY": "alusta heli %1",
    "SOUND_PLAYUNTILDONE": "mängi heli %1 kuni lõpuni",
    "SOUND_STOPALLSOUNDS": "peata kõik helid",
    "SOUND_SETEFFECTO": "pane %1 efekt %2",
    "SOUND_CHANGEEFFECTBY": "muuda efekti %1 %2 võrra",
    "SOUND_CLEAREFFECTS": "vaigista heliefektid",
    "SOUND_EFFECTS_PITCH": "helikõrgus",
    "SOUND_EFFECTS_PAN": "heli vasakul/paremal",
    "SOUND_CHANGEVOLUMEBY": "muuda helitugevust %1 võrra",
    "SOUND_SETVOLUMETO": "võta helitugevuseks %1%",
    "SOUND_VOLUME": "helitugevus",
    "SOUND_RECORD": "salvesta...",
    "CATEGORY_MOTION": "Liikumine",
    "CATEGORY_LOOKS": "Välimus",
    "CATEGORY_SOUND": "Helid",
    "CATEGORY_EVENTS": "Sündmused",
    "CATEGORY_CONTROL": "Juhtimine",
    "CATEGORY_SENSING": "Andurid",
    "CATEGORY_OPERATORS": "Tehted",
    "CATEGORY_VARIABLES": "Muutujad",
    "CATEGORY_MYBLOCKS": "Minu Plokid",
    "DUPLICATE": "Paljunda",
    "DELETE": "Kustuta",
    "ADD_COMMENT": "Lisa kommentaar",
    "REMOVE_COMMENT": "Eemalda kommentaar",
    "DELETE_BLOCK": "Eemalda plokk",
    "DELETE_X_BLOCKS": "Eemalda %1 plokki",
    "DELETE_ALL_BLOCKS": "Eemalda kõik %1 plokki?",
    "CLEAN_UP": "Korrasta plokid",
    "HELP": "Abi",
    "UNDO": "Võta tagasi",
    "REDO": "Tee uuesti",
    "EDIT_PROCEDURE": "Redigeeri",
    "SHOW_PROCEDURE_DEFINITION": "Mine definitsiooni juurde",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Ütle midagi",
    "COLOUR_HUE_LABEL": "Värv",
    "COLOUR_SATURATION_LABEL": "Küllastus",
    "COLOUR_BRIGHTNESS_LABEL": "Heledus",
    "CHANGE_VALUE_TITLE": "Muuda väärtust:",
    "RENAME_VARIABLE": "Muuda muutuja nime",
    "RENAME_VARIABLE_TITLE": "Nimeta kõik \"%1\" muutujad nimega:",
    "RENAME_VARIABLE_MODAL_TITLE": "Muuda muutuja nime",
    "NEW_VARIABLE": "Loo muutuja",
    "NEW_VARIABLE_TITLE": "Uue muutuja nimi:",
    "VARIABLE_MODAL_TITLE": "Uus muutuja",
    "VARIABLE_ALREADY_EXISTS": "Muutuja nimega \"%1\" on juba olemas.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Muutuja nimi \"%1\" on juba kasutusel \"%2\" tüüpi muutujal.",
    "DELETE_VARIABLE_CONFIRMATION": "Eemaldada %1 muutuja \"%2\" kasutamist?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Muutujat \"%1\" ei saa eemaldada, sest see on osa funktsiooni \"%2\" definitsioonist.",
    "DELETE_VARIABLE": "Eemalda muutuja \"%1\"",
    "NEW_PROCEDURE": "Loo Plokk",
    "PROCEDURE_ALREADY_EXISTS": "Protseduur nimega \"%1\" on juba olemas.",
    "PROCEDURE_DEFAULT_NAME": "ploki nimi",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Loo Loend",
    "NEW_LIST_TITLE": "Uue loendi nimi:",
    "LIST_MODAL_TITLE": "Uus loend",
    "LIST_ALREADY_EXISTS": "Loend nimega \"%1\" on juba olemas.",
    "RENAME_LIST_TITLE": "Nimeta kõik \"%1\" loendid nimega:",
    "RENAME_LIST_MODAL_TITLE": "Muuda loendi nime",
    "DEFAULT_LIST_ITEM": "asi",
    "DELETE_LIST": "Eemalda loend \"%1\"",
    "RENAME_LIST": "Muuda loendi nime",
    "NEW_BROADCAST_MESSAGE": "Uus teade",
    "NEW_BROADCAST_MESSAGE_TITLE": "Uue teate nimi:",
    "BROADCAST_MODAL_TITLE": "Uus teade",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "teade1"
  },
  "el": {
    "CONTROL_FOREVER": "για πάντα",
    "CONTROL_REPEAT": "επανάλαβε %1",
    "CONTROL_IF": "εάν %1 τότε",
    "CONTROL_ELSE": "αλλιώς",
    "CONTROL_STOP": "σταμάτησε",
    "CONTROL_STOP_ALL": "όλα",
    "CONTROL_STOP_THIS": "αυτό το σενάριο",
    "CONTROL_STOP_OTHER": "άλλα σενάρια σε αυτό το αντικείμενο",
    "CONTROL_WAIT": "περίμενε %1 δευτερόλεπτα",
    "CONTROL_WAITUNTIL": "περίμενε ώσπου %1",
    "CONTROL_REPEATUNTIL": "επανάλαβε ώσπου %1",
    "CONTROL_WHILE": "όσο %1",
    "CONTROL_FOREACH": "για κάθε %1 στο %2",
    "CONTROL_STARTASCLONE": "όταν ξεκινήσω ως κλώνος",
    "CONTROL_CREATECLONEOF": "δημιούργησε κλώνο του %1",
    "CONTROL_CREATECLONEOF_MYSELF": "εαυτού μου",
    "CONTROL_DELETETHISCLONE": "διάγραψε αυτόν τον κλώνο",
    "CONTROL_COUNTER": "μετρητής",
    "CONTROL_INCRCOUNTER": "αύξηση μετρητή",
    "CONTROL_CLEARCOUNTER": "καθαρισμός μετρητή",
    "CONTROL_ALLATONCE": "μονομιάς",
    "DATA_SETVARIABLETO": "όρισε %1 σε %2",
    "DATA_CHANGEVARIABLEBY": "άλλαξε %1 κατά %2",
    "DATA_SHOWVARIABLE": "εμφάνισε μεταβλητή %1",
    "DATA_HIDEVARIABLE": "απόκρυψε μεταβλητή %1",
    "DATA_ADDTOLIST": "πρόσθεσε %1 στη λίστα %2",
    "DATA_DELETEOFLIST": "διάγραψε %1 από λίστα %2",
    "DATA_DELETEALLOFLIST": "διαγραφή όλων από λίστα %1",
    "DATA_INSERTATLIST": "βάλε %1 στη θέση %2 λίστας %3",
    "DATA_REPLACEITEMOFLIST": "αντικατάστησε στοιχείο %1 λίστας %2 με %3",
    "DATA_ITEMOFLIST": "στοιχείο %1 λίστας %2",
    "DATA_ITEMNUMOFLIST": "# στοιχείου %1 σε %2",
    "DATA_LENGTHOFLIST": "μήκος λίστας %1",
    "DATA_LISTCONTAINSITEM": "%1 περιέχει %2;",
    "DATA_SHOWLIST": "εμφάνισε λίστα %1",
    "DATA_HIDELIST": "απόκρυψε λίστα %1",
    "DATA_INDEX_ALL": "όλα",
    "DATA_INDEX_LAST": "τελευταίο",
    "DATA_INDEX_RANDOM": "τυχαίο",
    "EVENT_WHENFLAGCLICKED": "όταν γίνει κλικ σε %1",
    "EVENT_WHENTHISSPRITECLICKED": "όταν γίνει κλικ σε αυτό το αντικείμενο",
    "EVENT_WHENSTAGECLICKED": "όταν γίνει κλικ στη σκηνή",
    "EVENT_WHENTOUCHINGOBJECT": "όταν αυτό το αντικείμενο αγγίξει το %1",
    "EVENT_WHENBROADCASTRECEIVED": "όταν λάβω %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "όταν το υπόβαθρο αλλάξει σε %1",
    "EVENT_WHENGREATERTHAN": "όταν %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "χρονομέτρο",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ένταση",
    "EVENT_BROADCAST": "μετάδωσε %1",
    "EVENT_BROADCASTANDWAIT": "μετάδωσε %1 και περίμενε",
    "EVENT_WHENKEYPRESSED": "όταν πατηθεί πλήκτρο %1",
    "EVENT_WHENKEYPRESSED_SPACE": "διάστημα",
    "EVENT_WHENKEYPRESSED_LEFT": "αριστερό βέλος",
    "EVENT_WHENKEYPRESSED_RIGHT": "δεξί βέλος",
    "EVENT_WHENKEYPRESSED_DOWN": "κάτω βέλος",
    "EVENT_WHENKEYPRESSED_UP": "πάνω βέλος",
    "EVENT_WHENKEYPRESSED_ANY": "οποιοδήποτε",
    "LOOKS_SAYFORSECS": "πες %1 για %2 δευτερόλεπτα",
    "LOOKS_SAY": "πες %1",
    "LOOKS_HELLO": "Γεια!",
    "LOOKS_THINKFORSECS": "σκέψου %1 για %2 δευτερόλεπτα",
    "LOOKS_THINK": "σκέψου %1",
    "LOOKS_HMM": "Χμμ...",
    "LOOKS_SHOW": "εμφανίσου",
    "LOOKS_HIDE": "εξαφανίσου",
    "LOOKS_HIDEALLSPRITES": "απόκρυψη όλων των αντικειμένων",
    "LOOKS_EFFECT_COLOR": "χρώματος",
    "LOOKS_EFFECT_FISHEYE": "κυρτότητας",
    "LOOKS_EFFECT_WHIRL": "δίνης",
    "LOOKS_EFFECT_PIXELATE": "εικονοστοιχειοποίησης",
    "LOOKS_EFFECT_MOSAIC": "ψηφιδωτού",
    "LOOKS_EFFECT_BRIGHTNESS": "φωτεινότητας",
    "LOOKS_EFFECT_GHOST": "φαντάσματος",
    "LOOKS_CHANGEEFFECTBY": "άλλαξε εφέ %1 κατά %2",
    "LOOKS_SETEFFECTTO": "όρισε εφέ %1 σε %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "επανάφερε εφέ γραφικών",
    "LOOKS_CHANGESIZEBY": "άλλαξε μέγεθος κατά %1",
    "LOOKS_SETSIZETO": "όρισε μέγεθος σε %1 %",
    "LOOKS_SIZE": "μέγεθος",
    "LOOKS_CHANGESTRETCHBY": "άλλαξε τέντωμα κατά %1",
    "LOOKS_SETSTRETCHTO": "όρισε τέντωμα σε %1 %",
    "LOOKS_SWITCHCOSTUMETO": "άλλαξε ενδυμασία σε %1",
    "LOOKS_NEXTCOSTUME": "επόμενη ενδυμασία",
    "LOOKS_SWITCHBACKDROPTO": "άλλαξε υπόβαθρο σε %1",
    "LOOKS_GOTOFRONTBACK": "πήγαινε σε επίπεδο %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "προσκήνιο",
    "LOOKS_GOTOFRONTBACK_BACK": "υπόβαθρο",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "πήγαινε %1 %2 επίπεδα",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "μπροστά",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "πίσω",
    "LOOKS_BACKDROPNUMBERNAME": "υπόβαθρο %1",
    "LOOKS_COSTUMENUMBERNAME": "ενδυμασία %1",
    "LOOKS_NUMBERNAME_NUMBER": "νούμερο",
    "LOOKS_NUMBERNAME_NAME": "όνομα",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "άλλαξε υπόβαθρο σε %1 και περίμενε",
    "LOOKS_NEXTBACKDROP_BLOCK": "επόμενο υπόβαθρο",
    "LOOKS_NEXTBACKDROP": "επόμενο υπόβαθρο",
    "LOOKS_PREVIOUSBACKDROP": "προηγούμενο υπόβαθρο",
    "LOOKS_RANDOMBACKDROP": "τυχαίο υπόβαθρο",
    "MOTION_MOVESTEPS": "κινήσου %1 βήματα",
    "MOTION_TURNLEFT": "στρίψε %1 %2 μοίρες",
    "MOTION_TURNRIGHT": "στρίψε %1 %2 μοίρες",
    "MOTION_POINTINDIRECTION": "δείξε προς κατεύθυνση %1",
    "MOTION_POINTTOWARDS": "δείξε προς %1",
    "MOTION_POINTTOWARDS_POINTER": "δείκτη ποντικιού",
    "MOTION_POINTTOWARDS_RANDOM": "τυχαία κατεύθυνση",
    "MOTION_GOTO": "πήγαινε σε %1",
    "MOTION_GOTO_POINTER": "δείκτη ποντικιού",
    "MOTION_GOTO_RANDOM": "τυχαία θέση",
    "MOTION_GOTOXY": "πήγαινε σε θέση x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "ολίσθησε για %1 δευτ. στη θέση x: %2 y: %3",
    "MOTION_GLIDETO": "ολίσθησε για %1 δευτ. στη θέση %2",
    "MOTION_GLIDETO_POINTER": "δείκτη ποντικιού",
    "MOTION_GLIDETO_RANDOM": "τυχαία θέση",
    "MOTION_CHANGEXBY": "άλλαξε x κατά %1",
    "MOTION_SETX": "όρισε x σε %1",
    "MOTION_CHANGEYBY": "άλλαξε y κατά %1",
    "MOTION_SETY": "όρισε y σε %1",
    "MOTION_IFONEDGEBOUNCE": "εάν σε όριο, αναπήδησε",
    "MOTION_SETROTATIONSTYLE": "όρισε τρόπο περιστροφής %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "αριστερά-δεξιά",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "μην περιστρέψεις",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "τριγύρω",
    "MOTION_XPOSITION": "θέση x",
    "MOTION_YPOSITION": "θέση y",
    "MOTION_DIRECTION": "κατεύθυνση",
    "MOTION_SCROLLRIGHT": "κύλιση δεξιά %1",
    "MOTION_SCROLLUP": "κύλιση πάνω %1",
    "MOTION_ALIGNSCENE": "ευθυγράμμιση σκηνής %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "κάτω-αριστερά",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "κάτω-δεξιά",
    "MOTION_ALIGNSCENE_MIDDLE": "μέση",
    "MOTION_ALIGNSCENE_TOPLEFT": "πάνω-αριστερά",
    "MOTION_ALIGNSCENE_TOPRIGHT": "πάνω-δεξιά",
    "MOTION_XSCROLL": "κύλιση x",
    "MOTION_YSCROLL": "κύλιση y",
    "MOTION_STAGE_SELECTED": "Σκηνή επιλεγμένη: χωρίς εντολές κίνησης",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "επίλεξε τυχαίο %1 εώς %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 και %2",
    "OPERATORS_OR": "%1 ή %2",
    "OPERATORS_NOT": "όχι %1",
    "OPERATORS_JOIN": "ένωσε %1 %2",
    "OPERATORS_JOIN_APPLE": "μήλο",
    "OPERATORS_JOIN_BANANA": "μπανάνα",
    "OPERATORS_LETTEROF": "γράμμα %1 του %2",
    "OPERATORS_LETTEROF_APPLE": "ο",
    "OPERATORS_LENGTH": "μήκος του %1",
    "OPERATORS_CONTAINS": "%1 περιλαμβάνει %2;",
    "OPERATORS_MOD": "ακέρ. υπόλ. %1 δια %2",
    "OPERATORS_ROUND": "στρογγυλ. %1",
    "OPERATORS_MATHOP": "%1 %2",
    "OPERATORS_MATHOP_ABS": "απόλυτο",
    "OPERATORS_MATHOP_FLOOR": "στρογγυλ. κάτω",
    "OPERATORS_MATHOP_CEILING": "στρογγυλ. άνω",
    "OPERATORS_MATHOP_SQRT": "τετρ. ρίζα",
    "OPERATORS_MATHOP_SIN": "ημ",
    "OPERATORS_MATHOP_COS": "συν",
    "OPERATORS_MATHOP_TAN": "εφ",
    "OPERATORS_MATHOP_ASIN": "τοξημ",
    "OPERATORS_MATHOP_ACOS": "τοξσυν",
    "OPERATORS_MATHOP_ATAN": "τοξεφ",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "ορισμός %1",
    "SENSING_TOUCHINGOBJECT": "αγγίζει %1;",
    "SENSING_TOUCHINGOBJECT_POINTER": "δείκτη ποντικιού",
    "SENSING_TOUCHINGOBJECT_EDGE": "όριο",
    "SENSING_TOUCHINGCOLOR": "αγγίζει χρώμα %1;",
    "SENSING_COLORISTOUCHINGCOLOR": "χρώμα %1 αγγίζει χρώμα %2;",
    "SENSING_DISTANCETO": "απόσταση έως %1",
    "SENSING_DISTANCETO_POINTER": "δείκτη ποντικιού",
    "SENSING_ASKANDWAIT": "ρώτησε %1 και περίμενε",
    "SENSING_ASK_TEXT": "Πώς σε λένε;",
    "SENSING_ANSWER": "απάντηση",
    "SENSING_KEYPRESSED": "πατήθηκε πλήκτρο %1;",
    "SENSING_MOUSEDOWN": "πατήθηκε πλήκτρο ποντικιού;",
    "SENSING_MOUSEX": "x ποντικιού",
    "SENSING_MOUSEY": "y ποντικιού",
    "SENSING_SETDRAGMODE": "όρισε τρόπο συρσίματος %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "συρόμενο",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "μη συρόμενο",
    "SENSING_LOUDNESS": "ένταση",
    "SENSING_LOUD": "δυνατά;",
    "SENSING_TIMER": "χρονόμετρο",
    "SENSING_RESETTIMER": "μηδένισε χρονόμετρο",
    "SENSING_OF": "%1 από %2",
    "SENSING_OF_XPOSITION": "θέση x",
    "SENSING_OF_YPOSITION": "θέση y",
    "SENSING_OF_DIRECTION": "κατεύθυνση",
    "SENSING_OF_COSTUMENUMBER": "# ενδυμασίας",
    "SENSING_OF_COSTUMENAME": "όνομα ενδυμασίας",
    "SENSING_OF_SIZE": "μέγεθος",
    "SENSING_OF_VOLUME": "ένταση",
    "SENSING_OF_BACKDROPNUMBER": "# υποβάθρου",
    "SENSING_OF_BACKDROPNAME": "όνομα υποβάθρου",
    "SENSING_OF_STAGE": "Σκηνή",
    "SENSING_CURRENT": "τρέχων %1",
    "SENSING_CURRENT_YEAR": "έτος",
    "SENSING_CURRENT_MONTH": "μήνας",
    "SENSING_CURRENT_DATE": "ημερομηνία",
    "SENSING_CURRENT_DAYOFWEEK": "μέρα της εβδομάδας",
    "SENSING_CURRENT_HOUR": "ώρα",
    "SENSING_CURRENT_MINUTE": "λεπτό",
    "SENSING_CURRENT_SECOND": "δευτερόλεπτο",
    "SENSING_DAYSSINCE2000": "ημέρες από το 2000",
    "SENSING_USERNAME": "όνομα χρήστη",
    "SENSING_USERID": "αναγνωριστικό χρήστη",
    "SOUND_PLAY": "παίξε τον ήχο %1",
    "SOUND_PLAYUNTILDONE": "παίξε ήχο %1 μέχρι τέλους",
    "SOUND_STOPALLSOUNDS": "σταμάτησε όλους τους ήχους",
    "SOUND_SETEFFECTO": "όρισε εφέ %1 σε %2",
    "SOUND_CHANGEEFFECTBY": "άλλαξε εφέ %1 κατά %2",
    "SOUND_CLEAREFFECTS": "καθάρισε ηχητικά εφέ",
    "SOUND_EFFECTS_PITCH": "τόνος",
    "SOUND_EFFECTS_PAN": "μετατόπιση αριστερά/δεξιά",
    "SOUND_CHANGEVOLUMEBY": "άλλαξε ένταση κατά %1",
    "SOUND_SETVOLUMETO": "όρισε ένταση σε %1%",
    "SOUND_VOLUME": "ένταση",
    "SOUND_RECORD": "εγγραφή...",
    "CATEGORY_MOTION": "Κίνηση",
    "CATEGORY_LOOKS": "Όψεις",
    "CATEGORY_SOUND": "Ήχος",
    "CATEGORY_EVENTS": "Συμβάντα",
    "CATEGORY_CONTROL": "Έλεγχος",
    "CATEGORY_SENSING": "Αισθητήρες",
    "CATEGORY_OPERATORS": "Τελεστές",
    "CATEGORY_VARIABLES": "Μεταβλητές",
    "CATEGORY_MYBLOCKS": "Οι Εντολές μου",
    "DUPLICATE": "Διπλασιασμός",
    "DELETE": "Διαγραφή",
    "ADD_COMMENT": "Προσθήκη σχολίου",
    "REMOVE_COMMENT": "Αφαίρεση σχολίου",
    "DELETE_BLOCK": "Διαγραφή Εντολής",
    "DELETE_X_BLOCKS": "Διαγραφή %1 Εντολών",
    "DELETE_ALL_BLOCKS": "Διαγραφή όλων των %1 εντολών;",
    "CLEAN_UP": "Τακτοποίησε Εντολές",
    "HELP": "Βοήθεια",
    "UNDO": "Αναίρεση",
    "REDO": "Επανάληψη",
    "EDIT_PROCEDURE": "Επεξεργασία",
    "SHOW_PROCEDURE_DEFINITION": "Μετάβαση σε ορισμό",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Πες κάτι...",
    "COLOUR_HUE_LABEL": "Χρώμα",
    "COLOUR_SATURATION_LABEL": "Κορεσμός",
    "COLOUR_BRIGHTNESS_LABEL": "Φωτεινότητα",
    "CHANGE_VALUE_TITLE": "Αλλαγή τιμής:",
    "RENAME_VARIABLE": "Μετονομασία μεταβλητής",
    "RENAME_VARIABLE_TITLE": "Μετονομασία όλων των \"%1\" μεταβλητών σε:",
    "RENAME_VARIABLE_MODAL_TITLE": "Μετονομασία Μεταβλητής",
    "NEW_VARIABLE": "Δημιουργία Μεταβλητής",
    "NEW_VARIABLE_TITLE": "Όνομα νέας μεταβλητής:",
    "VARIABLE_MODAL_TITLE": "Νέα Μεταβλητή",
    "VARIABLE_ALREADY_EXISTS": "Υπάρχει ήδη μια μεταβλητή με όνομα \"%1\".",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Υπάρχει ήδη μια μεταβλητή με όνομα \"%1\" για μια άλλη μεταβλητή τύπου \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Διαγραφή %1 χρήσεων της μεταβλητής \"%2\";",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Η μεταβλητή \"%1\" δεν μπορεί να διαγραφεί γιατί είναι μέρος του ορισμού της λειτουργίας \"%2\"",
    "DELETE_VARIABLE": "Διαγραφή της μεταβλητής \"%1\"",
    "NEW_PROCEDURE": "Δημιουργία Εντολής",
    "PROCEDURE_ALREADY_EXISTS": "Υπάρχει ήδη μια διαδικασία με όνομα \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "όνομα εντολής",
    "PROCEDURE_USED": "Για να διαγράψετε τον ορισμό μιας εντολής, πρώτα αφαιρέστε όλες τις χρήσεις της εντολής",
    "NEW_LIST": "Δημιουργία Λίστας",
    "NEW_LIST_TITLE": "Όνομα νέας λίστας:",
    "LIST_MODAL_TITLE": "Νέα Λίστα",
    "LIST_ALREADY_EXISTS": "Υπάρχει ήδη μια λίστα με όνομα \"%1\".",
    "RENAME_LIST_TITLE": "Μετονόμασε όλες τις λίστες \"%1\" σε:",
    "RENAME_LIST_MODAL_TITLE": "Μετονομασία Λίστας",
    "DEFAULT_LIST_ITEM": "πράγμα",
    "DELETE_LIST": "Διάγραψε τη λίστα \"%1\"",
    "RENAME_LIST": "Μετονομασία λίστας",
    "NEW_BROADCAST_MESSAGE": "Νέο μήνυμα",
    "NEW_BROADCAST_MESSAGE_TITLE": "Όνομα νέου μηνύματος:",
    "BROADCAST_MODAL_TITLE": "Νέο μήνυμα",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "μήνυμα1"
  },
  "emoji": {
    "CONTROL_FOREVER": "🔁🔁",
    "CONTROL_REPEAT": "🔁🔢 %1",
    "CONTROL_IF": "↪️ %1",
    "CONTROL_ELSE": "🙅",
    "CONTROL_STOP": "🛑",
    "CONTROL_STOP_ALL": "👥",
    "CONTROL_STOP_THIS": "👉🧱",
    "CONTROL_STOP_OTHER": "😺🧱❌👇",
    "CONTROL_WAIT": "✋🔢 %1 ⏱️",
    "CONTROL_WAITUNTIL": "✋ %1 👌",
    "CONTROL_REPEATUNTIL": "🔁 %1 👌",
    "CONTROL_WHILE": "while %1",
    "CONTROL_FOREACH": "for each %1 in %2",
    "CONTROL_STARTASCLONE": "🐇❗🏁",
    "CONTROL_CREATECLONEOF": "🐑🐑🆕 %1",
    "CONTROL_CREATECLONEOF_MYSELF": "👤",
    "CONTROL_DELETETHISCLONE": "🐑🐑🦊",
    "CONTROL_COUNTER": "counter",
    "CONTROL_INCRCOUNTER": "increment counter",
    "CONTROL_CLEARCOUNTER": "clear counter",
    "CONTROL_ALLATONCE": "all at once",
    "DATA_SETVARIABLETO": "📜 %1 ➡️🔢 %2",
    "DATA_CHANGEVARIABLEBY": "📜 %1 🔛🔢 %2",
    "DATA_SHOWVARIABLE": "😐📜 %1",
    "DATA_HIDEVARIABLE": "🫥📜 %1",
    "DATA_ADDTOLIST": "🐻 %1 📋 %2",
    "DATA_DELETEOFLIST": "🐨 %1 📋 %2",
    "DATA_DELETEALLOFLIST": "🐨👥📋 %1",
    "DATA_INSERTATLIST": "🐵 %1 #️⃣ %2 📋 %3",
    "DATA_REPLACEITEMOFLIST": "🐽 %1 📋 %2 ➡️ %3",
    "DATA_ITEMOFLIST": "🐽 %1 📋 %2",
    "DATA_ITEMNUMOFLIST": "🐽#️⃣ %1 📋 %2",
    "DATA_LENGTHOFLIST": "📏 %1",
    "DATA_LISTCONTAINSITEM": "🔎 %1 📋 %2 👌",
    "DATA_SHOWLIST": "😐📋 %1",
    "DATA_HIDELIST": "🫥📋 %1",
    "DATA_INDEX_ALL": "👥",
    "DATA_INDEX_LAST": "🐼",
    "DATA_INDEX_RANDOM": "🎲",
    "EVENT_WHENFLAGCLICKED": "❗ %1 👇",
    "EVENT_WHENTHISSPRITECLICKED": "😺❗🖱️👇",
    "EVENT_WHENSTAGECLICKED": "🌆❗🖱️👇",
    "EVENT_WHENTOUCHINGOBJECT": "when this sprite touches %1",
    "EVENT_WHENBROADCASTRECEIVED": "❗📢 %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "❗🌆➡️ %1",
    "EVENT_WHENGREATERTHAN": "❗ %1 ▶️🔢 %2",
    "EVENT_WHENGREATERTHAN_TIMER": "⏲️",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "🔊",
    "EVENT_BROADCAST": "📢 %1",
    "EVENT_BROADCASTANDWAIT": "📢 %1 ⌚",
    "EVENT_WHENKEYPRESSED": "❗⌨️ %1 👇",
    "EVENT_WHENKEYPRESSED_SPACE": "🌌",
    "EVENT_WHENKEYPRESSED_LEFT": "⬅️",
    "EVENT_WHENKEYPRESSED_RIGHT": "➡️",
    "EVENT_WHENKEYPRESSED_DOWN": "⬇️",
    "EVENT_WHENKEYPRESSED_UP": "⬆️",
    "EVENT_WHENKEYPRESSED_ANY": "❓",
    "LOOKS_SAYFORSECS": "😀 %1 🔢 %2 ⏱️",
    "LOOKS_SAY": "😀 %1",
    "LOOKS_HELLO": "👋",
    "LOOKS_THINKFORSECS": "🤔 %1 🔢 %2 ⏱️",
    "LOOKS_THINK": "🤔 %1",
    "LOOKS_HMM": "🤔",
    "LOOKS_SHOW": "😐",
    "LOOKS_HIDE": "🫥",
    "LOOKS_HIDEALLSPRITES": "hide all sprites",
    "LOOKS_EFFECT_COLOR": "🎨",
    "LOOKS_EFFECT_FISHEYE": "👁️🐟",
    "LOOKS_EFFECT_WHIRL": "🌀",
    "LOOKS_EFFECT_PIXELATE": "👾",
    "LOOKS_EFFECT_MOSAIC": "⏹️",
    "LOOKS_EFFECT_BRIGHTNESS": "☀️",
    "LOOKS_EFFECT_GHOST": "👻",
    "LOOKS_CHANGEEFFECTBY": "🪄 %1 🔛🔢 %2",
    "LOOKS_SETEFFECTTO": "🪄 %1 ➡️🔢 %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "🧼🪄",
    "LOOKS_CHANGESIZEBY": "🐘🔛🔢 %1",
    "LOOKS_SETSIZETO": "🐘➡️🔢 %1",
    "LOOKS_SIZE": "🐘",
    "LOOKS_CHANGESTRETCHBY": "change stretch by %1",
    "LOOKS_SETSTRETCHTO": "set stretch to %1 %",
    "LOOKS_SWITCHCOSTUMETO": "🎭➡️ %1",
    "LOOKS_NEXTCOSTUME": "🎭⏩",
    "LOOKS_SWITCHBACKDROPTO": "🌆➡️ %1",
    "LOOKS_GOTOFRONTBACK": "%1",
    "LOOKS_GOTOFRONTBACK_FRONT": "⬆️⬆️",
    "LOOKS_GOTOFRONTBACK_BACK": "⬇️⬇️",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 🍰",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "⬆️",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "⬇️",
    "LOOKS_BACKDROPNUMBERNAME": "🌆 %1",
    "LOOKS_COSTUMENUMBERNAME": "🎭 %1",
    "LOOKS_NUMBERNAME_NUMBER": "#️⃣",
    "LOOKS_NUMBERNAME_NAME": "🔤",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "🌆➡️ %1 ⌚",
    "LOOKS_NEXTBACKDROP_BLOCK": "🌆⏩",
    "LOOKS_NEXTBACKDROP": "🌆⏩",
    "LOOKS_PREVIOUSBACKDROP": "⏪🌆",
    "LOOKS_RANDOMBACKDROP": "🎲🌆",
    "MOTION_MOVESTEPS": "🚶 %1 ⏩",
    "MOTION_TURNLEFT": "%1 🔢 %2",
    "MOTION_TURNRIGHT": "%1 🔢 %2",
    "MOTION_POINTINDIRECTION": "🧭👉 %1",
    "MOTION_POINTTOWARDS": "🧭👉 %1",
    "MOTION_POINTTOWARDS_POINTER": "🖱️👆",
    "MOTION_POINTTOWARDS_RANDOM": "🎲🧭",
    "MOTION_GOTO": "👉 %1 👈",
    "MOTION_GOTO_POINTER": "🖱️👆",
    "MOTION_GOTO_RANDOM": "🎲🗺️",
    "MOTION_GOTOXY": "👉↔️ %1 ↕️ %2 👈",
    "MOTION_GLIDESECSTOXY": "🏂 %1 ⏱️↔️ %2 ↕️ %3",
    "MOTION_GLIDETO": "🏂 %1 ⏱️👉 %2 👈",
    "MOTION_GLIDETO_POINTER": "🖱️👆",
    "MOTION_GLIDETO_RANDOM": "🎲🗺️",
    "MOTION_CHANGEXBY": "↔️🔛🔢 %1",
    "MOTION_SETX": "↔️➡️🔢 %1",
    "MOTION_CHANGEYBY": "↕️🔛🔢 %1",
    "MOTION_SETY": "↕️➡️🔢 %1",
    "MOTION_IFONEDGEBOUNCE": "↪️🚧🎾",
    "MOTION_SETROTATIONSTYLE": "🔁😎➡️ %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "↔️",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "❌🔄️",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "👥",
    "MOTION_XPOSITION": "↔️",
    "MOTION_YPOSITION": "↕️",
    "MOTION_DIRECTION": "🧭",
    "MOTION_SCROLLRIGHT": "scroll right %1",
    "MOTION_SCROLLUP": "scroll up %1",
    "MOTION_ALIGNSCENE": "align scene %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "bottom-left",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "bottom-right",
    "MOTION_ALIGNSCENE_MIDDLE": "middle",
    "MOTION_ALIGNSCENE_TOPLEFT": "top-left",
    "MOTION_ALIGNSCENE_TOPRIGHT": "top-right",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "🌆👇🙅🧱🚶",
    "OPERATORS_ADD": "%1 ➕ %2",
    "OPERATORS_SUBTRACT": "%1 ➖ %2",
    "OPERATORS_MULTIPLY": "%1 ✖️ %2",
    "OPERATORS_DIVIDE": "%1 ➗ %2",
    "OPERATORS_RANDOM": "🎲🔢 %1 ↔️🔢 %2",
    "OPERATORS_GT": "%1 ▶️ %2",
    "OPERATORS_LT": "%1 ◀️ %2",
    "OPERATORS_EQUALS": "%1 🟰 %2",
    "OPERATORS_AND": "%1 🤝 %2",
    "OPERATORS_OR": "%1 👐 %2",
    "OPERATORS_NOT": "❎ %1",
    "OPERATORS_JOIN": "🍡 %1 🍡 %2",
    "OPERATORS_JOIN_APPLE": "🍎🍏",
    "OPERATORS_JOIN_BANANA": "🍌🍌",
    "OPERATORS_LETTEROF": "🐽🔤 %1 🔡 %2",
    "OPERATORS_LETTEROF_APPLE": "🍎",
    "OPERATORS_LENGTH": "📏 %1",
    "OPERATORS_CONTAINS": "🔎 %1 🔡 %2 👌",
    "OPERATORS_MOD": "%1 🚮 %2",
    "OPERATORS_ROUND": "🏇 %1",
    "OPERATORS_MATHOP": "%1 %2",
    "OPERATORS_MATHOP_ABS": "🏧",
    "OPERATORS_MATHOP_FLOOR": "🏇⬇️",
    "OPERATORS_MATHOP_CEILING": "🏇⬆️",
    "OPERATORS_MATHOP_SQRT": "⛷",
    "OPERATORS_MATHOP_SIN": "📓",
    "OPERATORS_MATHOP_COS": "📕",
    "OPERATORS_MATHOP_TAN": "📐",
    "OPERATORS_MATHOP_ASIN": "📔",
    "OPERATORS_MATHOP_ACOS": "📙",
    "OPERATORS_MATHOP_ATAN": "📒",
    "OPERATORS_MATHOP_LN": "📈⬇️",
    "OPERATORS_MATHOP_LOG": "🔟⬇️",
    "OPERATORS_MATHOP_EEXP": "📈⬆️",
    "OPERATORS_MATHOP_10EXP": "🔟⬆️",
    "PROCEDURES_DEFINITION": "⁉️ %1",
    "SENSING_TOUCHINGOBJECT": "🙌 %1 ❓",
    "SENSING_TOUCHINGOBJECT_POINTER": "🖱️👆",
    "SENSING_TOUCHINGOBJECT_EDGE": "🚧",
    "SENSING_TOUCHINGCOLOR": "🙌 %1 ❓",
    "SENSING_COLORISTOUCHINGCOLOR": "🌈 %1 🙌 %2 ❓",
    "SENSING_DISTANCETO": "📏➡️ %1",
    "SENSING_DISTANCETO_POINTER": "🖱️👆",
    "SENSING_ASKANDWAIT": "💬 %1 ⌚",
    "SENSING_ASK_TEXT": "📛❓",
    "SENSING_ANSWER": "💬",
    "SENSING_KEYPRESSED": "⌨️ %1 👇❓",
    "SENSING_MOUSEDOWN": "🖱️👇❓",
    "SENSING_MOUSEX": "🖱️↔️",
    "SENSING_MOUSEY": "🖱️↕️",
    "SENSING_SETDRAGMODE": "🤏👌➡️ %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "🌝",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "🌚",
    "SENSING_LOUDNESS": "🔊",
    "SENSING_LOUD": "loud?",
    "SENSING_TIMER": "⏲️",
    "SENSING_RESETTIMER": "⏲️",
    "SENSING_OF": "%1 %2",
    "SENSING_OF_XPOSITION": "↔️",
    "SENSING_OF_YPOSITION": "↕️",
    "SENSING_OF_DIRECTION": "🧭",
    "SENSING_OF_COSTUMENUMBER": "🎭#️⃣",
    "SENSING_OF_COSTUMENAME": "🎭🔤",
    "SENSING_OF_SIZE": "🐘",
    "SENSING_OF_VOLUME": "🔊",
    "SENSING_OF_BACKDROPNUMBER": "🌆#️⃣",
    "SENSING_OF_BACKDROPNAME": "🌆🔤",
    "SENSING_OF_STAGE": "🌆",
    "SENSING_CURRENT": "%1 📅❌",
    "SENSING_CURRENT_YEAR": "☀️",
    "SENSING_CURRENT_MONTH": "🌛",
    "SENSING_CURRENT_DATE": "📆",
    "SENSING_CURRENT_DAYOFWEEK": "📆7️⃣",
    "SENSING_CURRENT_HOUR": "⌛",
    "SENSING_CURRENT_MINUTE": "⏰",
    "SENSING_CURRENT_SECOND": "⏱️",
    "SENSING_DAYSSINCE2000": "📅#️⃣☀️ 2000",
    "SENSING_USERNAME": "👤📛",
    "SENSING_USERID": "user id",
    "SOUND_PLAY": "🎵▶️ %1",
    "SOUND_PLAYUNTILDONE": "🎵▶️ %1 ⌚",
    "SOUND_STOPALLSOUNDS": "🛑🔊",
    "SOUND_SETEFFECTO": "🪄 %1 ➡️🔢 %2",
    "SOUND_CHANGEEFFECTBY": "🪄 %1 🔛🔢 %2",
    "SOUND_CLEAREFFECTS": "🧼🪄",
    "SOUND_EFFECTS_PITCH": "🎼↕️",
    "SOUND_EFFECTS_PAN": "↔️",
    "SOUND_CHANGEVOLUMEBY": "🔊🔛🔢 %1",
    "SOUND_SETVOLUMETO": "🔊➡️🔢 %1",
    "SOUND_VOLUME": "🔊",
    "SOUND_RECORD": "⏺️",
    "CATEGORY_MOTION": "🚶",
    "CATEGORY_LOOKS": "🎭",
    "CATEGORY_SOUND": "🔊",
    "CATEGORY_EVENTS": "📅",
    "CATEGORY_CONTROL": "🚥",
    "CATEGORY_SENSING": "👁️",
    "CATEGORY_OPERATORS": "👨‍🔬",
    "CATEGORY_VARIABLES": "📜",
    "CATEGORY_MYBLOCKS": "👷",
    "DUPLICATE": "🐑🐑",
    "DELETE": "🗑️",
    "ADD_COMMENT": "➕💭",
    "REMOVE_COMMENT": "🗑️💭",
    "DELETE_BLOCK": "🗑️🧱",
    "DELETE_X_BLOCKS": "🗑️ %1 🧱",
    "DELETE_ALL_BLOCKS": "🗑️ %1 🧱❓",
    "CLEAN_UP": "🧹",
    "HELP": "❓",
    "UNDO": "↩️",
    "REDO": "↪️",
    "EDIT_PROCEDURE": "✍️",
    "SHOW_PROCEDURE_DEFINITION": "👉⁉️👈",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "😀💭",
    "COLOUR_HUE_LABEL": "🎨",
    "COLOUR_SATURATION_LABEL": "⚪↔🔴",
    "COLOUR_BRIGHTNESS_LABEL": "💡",
    "CHANGE_VALUE_TITLE": "Change value:",
    "RENAME_VARIABLE": "✍️📜📛",
    "RENAME_VARIABLE_TITLE": "✍️👥📜 \"%1\" ➡️📛",
    "RENAME_VARIABLE_MODAL_TITLE": "✍️📜📛",
    "NEW_VARIABLE": "🔨📜",
    "NEW_VARIABLE_TITLE": "🆕📜📛",
    "VARIABLE_MODAL_TITLE": "🆕📜",
    "VARIABLE_ALREADY_EXISTS": "2️⃣📜📛 \"%1\"",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "🗑️ %1 📜 \"%2\" ❓",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "❌🗑️📜 \"%1\" ⬅️📥⁉️ \"%2\"",
    "DELETE_VARIABLE": "🗑️📜 \"%1\"",
    "NEW_PROCEDURE": "🔨🧱",
    "PROCEDURE_ALREADY_EXISTS": "2️⃣🧱📛 \"%1\"",
    "PROCEDURE_DEFAULT_NAME": "🧱📛",
    "PROCEDURE_USED": "🗑️🧱⁉️",
    "NEW_LIST": "🔨📋",
    "NEW_LIST_TITLE": "🆕📋📛",
    "LIST_MODAL_TITLE": "🆕📋",
    "LIST_ALREADY_EXISTS": "2️⃣📋📛 \"%1\"",
    "RENAME_LIST_TITLE": "✍️👥📋 \"%1\" ➡️📛",
    "RENAME_LIST_MODAL_TITLE": "✍️📋📛",
    "DEFAULT_LIST_ITEM": "🎁",
    "DELETE_LIST": "🗑️📋 \"%1\"",
    "RENAME_LIST": "✍️📋📛",
    "NEW_BROADCAST_MESSAGE": "🆕💬",
    "NEW_BROADCAST_MESSAGE_TITLE": "🆕💬📛",
    "BROADCAST_MODAL_TITLE": "🆕💬",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "💬1"
  },
  "en": {
    "CONTROL_FOREVER": "forever",
    "CONTROL_REPEAT": "repeat %1",
    "CONTROL_IF": "if %1 then",
    "CONTROL_ELSE": "else",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "all",
    "CONTROL_STOP_THIS": "this script",
    "CONTROL_STOP_OTHER": "other scripts in sprite",
    "CONTROL_WAIT": "wait %1 seconds",
    "CONTROL_WAITUNTIL": "wait until %1",
    "CONTROL_REPEATUNTIL": "repeat until %1",
    "CONTROL_WHILE": "while %1",
    "CONTROL_FOREACH": "for each %1 in %2",
    "CONTROL_STARTASCLONE": "when I start as a clone",
    "CONTROL_CREATECLONEOF": "create clone of %1",
    "CONTROL_CREATECLONEOF_MYSELF": "myself",
    "CONTROL_DELETETHISCLONE": "delete this clone",
    "CONTROL_COUNTER": "counter",
    "CONTROL_INCRCOUNTER": "increment counter",
    "CONTROL_CLEARCOUNTER": "clear counter",
    "CONTROL_ALLATONCE": "all at once",
    "DATA_SETVARIABLETO": "set %1 to %2",
    "DATA_CHANGEVARIABLEBY": "change %1 by %2",
    "DATA_SHOWVARIABLE": "show variable %1",
    "DATA_HIDEVARIABLE": "hide variable %1",
    "DATA_ADDTOLIST": "add %1 to %2",
    "DATA_DELETEOFLIST": "delete %1 of %2",
    "DATA_DELETEALLOFLIST": "delete all of %1",
    "DATA_INSERTATLIST": "insert %1 at %2 of %3",
    "DATA_REPLACEITEMOFLIST": "replace item %1 of %2 with %3",
    "DATA_ITEMOFLIST": "item %1 of %2",
    "DATA_ITEMNUMOFLIST": "item # of %1 in %2",
    "DATA_LENGTHOFLIST": "length of %1",
    "DATA_LISTCONTAINSITEM": "%1 contains %2?",
    "DATA_SHOWLIST": "show list %1",
    "DATA_HIDELIST": "hide list %1",
    "DATA_INDEX_ALL": "all",
    "DATA_INDEX_LAST": "last",
    "DATA_INDEX_RANDOM": "random",
    "EVENT_WHENFLAGCLICKED": "when %1 clicked",
    "EVENT_WHENTHISSPRITECLICKED": "when this sprite clicked",
    "EVENT_WHENSTAGECLICKED": "when stage clicked",
    "EVENT_WHENTOUCHINGOBJECT": "when this sprite touches %1",
    "EVENT_WHENBROADCASTRECEIVED": "when I receive %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "when backdrop switches to %1",
    "EVENT_WHENGREATERTHAN": "when %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "timer",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "loudness",
    "EVENT_BROADCAST": "broadcast %1",
    "EVENT_BROADCASTANDWAIT": "broadcast %1 and wait",
    "EVENT_WHENKEYPRESSED": "when %1 key pressed",
    "EVENT_WHENKEYPRESSED_SPACE": "space",
    "EVENT_WHENKEYPRESSED_LEFT": "left arrow",
    "EVENT_WHENKEYPRESSED_RIGHT": "right arrow",
    "EVENT_WHENKEYPRESSED_DOWN": "down arrow",
    "EVENT_WHENKEYPRESSED_UP": "up arrow",
    "EVENT_WHENKEYPRESSED_ANY": "any",
    "LOOKS_SAYFORSECS": "say %1 for %2 seconds",
    "LOOKS_SAY": "say %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "think %1 for %2 seconds",
    "LOOKS_THINK": "think %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "show",
    "LOOKS_HIDE": "hide",
    "LOOKS_HIDEALLSPRITES": "hide all sprites",
    "LOOKS_EFFECT_COLOR": "color",
    "LOOKS_EFFECT_FISHEYE": "fisheye",
    "LOOKS_EFFECT_WHIRL": "whirl",
    "LOOKS_EFFECT_PIXELATE": "pixelate",
    "LOOKS_EFFECT_MOSAIC": "mosaic",
    "LOOKS_EFFECT_BRIGHTNESS": "brightness",
    "LOOKS_EFFECT_GHOST": "ghost",
    "LOOKS_CHANGEEFFECTBY": "change %1 effect by %2",
    "LOOKS_SETEFFECTTO": "set %1 effect to %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "clear graphic effects",
    "LOOKS_CHANGESIZEBY": "change size by %1",
    "LOOKS_SETSIZETO": "set size to %1 %",
    "LOOKS_SIZE": "size",
    "LOOKS_CHANGESTRETCHBY": "change stretch by %1",
    "LOOKS_SETSTRETCHTO": "set stretch to %1 %",
    "LOOKS_SWITCHCOSTUMETO": "switch costume to %1",
    "LOOKS_NEXTCOSTUME": "next costume",
    "LOOKS_SWITCHBACKDROPTO": "switch backdrop to %1",
    "LOOKS_GOTOFRONTBACK": "go to %1 layer",
    "LOOKS_GOTOFRONTBACK_FRONT": "front",
    "LOOKS_GOTOFRONTBACK_BACK": "back",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "go %1 %2 layers",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "forward",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "backward",
    "LOOKS_BACKDROPNUMBERNAME": "backdrop %1",
    "LOOKS_COSTUMENUMBERNAME": "costume %1",
    "LOOKS_NUMBERNAME_NUMBER": "number",
    "LOOKS_NUMBERNAME_NAME": "name",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "switch backdrop to %1 and wait",
    "LOOKS_NEXTBACKDROP_BLOCK": "next backdrop",
    "LOOKS_NEXTBACKDROP": "next backdrop",
    "LOOKS_PREVIOUSBACKDROP": "previous backdrop",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "move %1 steps",
    "MOTION_TURNLEFT": "turn %1 %2 degrees",
    "MOTION_TURNRIGHT": "turn %1 %2 degrees",
    "MOTION_POINTINDIRECTION": "point in direction %1",
    "MOTION_POINTTOWARDS": "point towards %1",
    "MOTION_POINTTOWARDS_POINTER": "mouse-pointer",
    "MOTION_POINTTOWARDS_RANDOM": "random direction",
    "MOTION_GOTO": "go to %1",
    "MOTION_GOTO_POINTER": "mouse-pointer",
    "MOTION_GOTO_RANDOM": "random position",
    "MOTION_GOTOXY": "go to x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glide %1 secs to x: %2 y: %3",
    "MOTION_GLIDETO": "glide %1 secs to %2",
    "MOTION_GLIDETO_POINTER": "mouse-pointer",
    "MOTION_GLIDETO_RANDOM": "random position",
    "MOTION_CHANGEXBY": "change x by %1",
    "MOTION_SETX": "set x to %1",
    "MOTION_CHANGEYBY": "change y by %1",
    "MOTION_SETY": "set y to %1",
    "MOTION_IFONEDGEBOUNCE": "if on edge, bounce",
    "MOTION_SETROTATIONSTYLE": "set rotation style %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "left-right",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "don't rotate",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "all around",
    "MOTION_XPOSITION": "x position",
    "MOTION_YPOSITION": "y position",
    "MOTION_DIRECTION": "direction",
    "MOTION_SCROLLRIGHT": "scroll right %1",
    "MOTION_SCROLLUP": "scroll up %1",
    "MOTION_ALIGNSCENE": "align scene %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "bottom-left",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "bottom-right",
    "MOTION_ALIGNSCENE_MIDDLE": "middle",
    "MOTION_ALIGNSCENE_TOPLEFT": "top-left",
    "MOTION_ALIGNSCENE_TOPRIGHT": "top-right",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "pick random %1 to %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 and %2",
    "OPERATORS_OR": "%1 or %2",
    "OPERATORS_NOT": "not %1",
    "OPERATORS_JOIN": "join %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letter %1 of %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "length of %1",
    "OPERATORS_CONTAINS": "%1 contains %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "round %1",
    "OPERATORS_MATHOP": "%1 of %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "floor",
    "OPERATORS_MATHOP_CEILING": "ceiling",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "define %1",
    "SENSING_TOUCHINGOBJECT": "touching %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "mouse-pointer",
    "SENSING_TOUCHINGOBJECT_EDGE": "edge",
    "SENSING_TOUCHINGCOLOR": "touching color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "color %1 is touching %2?",
    "SENSING_DISTANCETO": "distance to %1",
    "SENSING_DISTANCETO_POINTER": "mouse-pointer",
    "SENSING_ASKANDWAIT": "ask %1 and wait",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "answer",
    "SENSING_KEYPRESSED": "key %1 pressed?",
    "SENSING_MOUSEDOWN": "mouse down?",
    "SENSING_MOUSEX": "mouse x",
    "SENSING_MOUSEY": "mouse y",
    "SENSING_SETDRAGMODE": "set drag mode %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "draggable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "not draggable",
    "SENSING_LOUDNESS": "loudness",
    "SENSING_LOUD": "loud?",
    "SENSING_TIMER": "timer",
    "SENSING_RESETTIMER": "reset timer",
    "SENSING_OF": "%1 of %2",
    "SENSING_OF_XPOSITION": "x position",
    "SENSING_OF_YPOSITION": "y position",
    "SENSING_OF_DIRECTION": "direction",
    "SENSING_OF_COSTUMENUMBER": "costume #",
    "SENSING_OF_COSTUMENAME": "costume name",
    "SENSING_OF_SIZE": "size",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "backdrop #",
    "SENSING_OF_BACKDROPNAME": "backdrop name",
    "SENSING_OF_STAGE": "Stage",
    "SENSING_CURRENT": "current %1",
    "SENSING_CURRENT_YEAR": "year",
    "SENSING_CURRENT_MONTH": "month",
    "SENSING_CURRENT_DATE": "date",
    "SENSING_CURRENT_DAYOFWEEK": "day of week",
    "SENSING_CURRENT_HOUR": "hour",
    "SENSING_CURRENT_MINUTE": "minute",
    "SENSING_CURRENT_SECOND": "second",
    "SENSING_DAYSSINCE2000": "days since 2000",
    "SENSING_USERNAME": "username",
    "SENSING_USERID": "user id",
    "SOUND_PLAY": "start sound %1",
    "SOUND_PLAYUNTILDONE": "play sound %1 until done",
    "SOUND_STOPALLSOUNDS": "stop all sounds",
    "SOUND_SETEFFECTO": "set %1 effect to %2",
    "SOUND_CHANGEEFFECTBY": "change %1 effect by %2",
    "SOUND_CLEAREFFECTS": "clear sound effects",
    "SOUND_EFFECTS_PITCH": "pitch",
    "SOUND_EFFECTS_PAN": "pan left/right",
    "SOUND_CHANGEVOLUMEBY": "change volume by %1",
    "SOUND_SETVOLUMETO": "set volume to %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "record...",
    "CATEGORY_MOTION": "Motion",
    "CATEGORY_LOOKS": "Looks",
    "CATEGORY_SOUND": "Sound",
    "CATEGORY_EVENTS": "Events",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensing",
    "CATEGORY_OPERATORS": "Operators",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "My Blocks",
    "DUPLICATE": "Duplicate",
    "DELETE": "Delete",
    "ADD_COMMENT": "Add Comment",
    "REMOVE_COMMENT": "Remove Comment",
    "DELETE_BLOCK": "Delete Block",
    "DELETE_X_BLOCKS": "Delete %1 Blocks",
    "DELETE_ALL_BLOCKS": "Delete all %1 blocks?",
    "CLEAN_UP": "Clean up Blocks",
    "HELP": "Help",
    "UNDO": "Undo",
    "REDO": "Redo",
    "EDIT_PROCEDURE": "Edit",
    "SHOW_PROCEDURE_DEFINITION": "Go to definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Say something...",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturation",
    "COLOUR_BRIGHTNESS_LABEL": "Brightness",
    "CHANGE_VALUE_TITLE": "Change value:",
    "RENAME_VARIABLE": "Rename variable",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Rename Variable",
    "NEW_VARIABLE": "Make a Variable",
    "NEW_VARIABLE_TITLE": "New variable name:",
    "VARIABLE_MODAL_TITLE": "New Variable",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Make a Block",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "PROCEDURE_DEFAULT_NAME": "block name",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Make a List",
    "NEW_LIST_TITLE": "New list name:",
    "LIST_MODAL_TITLE": "New List",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Rename List",
    "DEFAULT_LIST_ITEM": "thing",
    "DELETE_LIST": "Delete the \"%1\" list",
    "RENAME_LIST": "Rename list",
    "NEW_BROADCAST_MESSAGE": "New message",
    "NEW_BROADCAST_MESSAGE_TITLE": "New message name:",
    "BROADCAST_MODAL_TITLE": "New Message",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "message1"
  },
  "es": {
    "CONTROL_FOREVER": "por siempre",
    "CONTROL_REPEAT": "repetir %1",
    "CONTROL_IF": "si %1 entonces",
    "CONTROL_ELSE": "si no",
    "CONTROL_STOP": "detener",
    "CONTROL_STOP_ALL": "todos",
    "CONTROL_STOP_THIS": "este programa",
    "CONTROL_STOP_OTHER": "otros programas en el objeto",
    "CONTROL_WAIT": "esperar %1 segundos",
    "CONTROL_WAITUNTIL": "esperar hasta que %1",
    "CONTROL_REPEATUNTIL": "repetir hasta que %1",
    "CONTROL_WHILE": "mientras %1",
    "CONTROL_FOREACH": "para cada %1 de %2",
    "CONTROL_STARTASCLONE": "al comenzar como clon",
    "CONTROL_CREATECLONEOF": "crear clon de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mí mismo",
    "CONTROL_DELETETHISCLONE": "eliminar este clon",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "incrementar contador",
    "CONTROL_CLEARCOUNTER": "borrar contador",
    "CONTROL_ALLATONCE": "todo de una vez",
    "DATA_SETVARIABLETO": "dar a %1 el valor %2",
    "DATA_CHANGEVARIABLEBY": "sumar a %1 %2",
    "DATA_SHOWVARIABLE": "mostrar variable %1",
    "DATA_HIDEVARIABLE": "esconder variable %1",
    "DATA_ADDTOLIST": "añadir %1 a %2",
    "DATA_DELETEOFLIST": "eliminar %1 de %2",
    "DATA_DELETEALLOFLIST": "eliminar todos de %1",
    "DATA_INSERTATLIST": "insertar %1 en %2 de %3",
    "DATA_REPLACEITEMOFLIST": "reemplazar elemento %1 de %2 con %3",
    "DATA_ITEMOFLIST": "elemento %1 de %2",
    "DATA_ITEMNUMOFLIST": "# de elemento de %1 en %2",
    "DATA_LENGTHOFLIST": "longitud de %1",
    "DATA_LISTCONTAINSITEM": "¿%2 está en %1?",
    "DATA_SHOWLIST": "mostrar lista %1",
    "DATA_HIDELIST": "esconder lista %1",
    "DATA_INDEX_ALL": "todos",
    "DATA_INDEX_LAST": "último",
    "DATA_INDEX_RANDOM": "aleatorio",
    "EVENT_WHENFLAGCLICKED": "al hacer clic en %1",
    "EVENT_WHENTHISSPRITECLICKED": "al hacer clic en este objeto",
    "EVENT_WHENSTAGECLICKED": "al hacer clic en el escenario",
    "EVENT_WHENTOUCHINGOBJECT": "cuando el objeto toque %1",
    "EVENT_WHENBROADCASTRECEIVED": "al recibir %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "cuando el fondo cambie a %1",
    "EVENT_WHENGREATERTHAN": "cuando %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronómetro",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "volumen del sonido",
    "EVENT_BROADCAST": "enviar %1",
    "EVENT_BROADCASTANDWAIT": "enviar %1 y esperar",
    "EVENT_WHENKEYPRESSED": "al presionar tecla %1",
    "EVENT_WHENKEYPRESSED_SPACE": "espacio",
    "EVENT_WHENKEYPRESSED_LEFT": "flecha izquierda",
    "EVENT_WHENKEYPRESSED_RIGHT": "flecha derecha",
    "EVENT_WHENKEYPRESSED_DOWN": "flecha abajo",
    "EVENT_WHENKEYPRESSED_UP": "flecha arriba",
    "EVENT_WHENKEYPRESSED_ANY": "cualquiera",
    "LOOKS_SAYFORSECS": "decir %1 durante %2 segundos",
    "LOOKS_SAY": "decir %1",
    "LOOKS_HELLO": "¡Hola!",
    "LOOKS_THINKFORSECS": "pensar %1 durante %2 segundos",
    "LOOKS_THINK": "pensar %1",
    "LOOKS_HMM": "Umm...",
    "LOOKS_SHOW": "mostrar",
    "LOOKS_HIDE": "esconder",
    "LOOKS_HIDEALLSPRITES": "esconder todos los objetos",
    "LOOKS_EFFECT_COLOR": "color",
    "LOOKS_EFFECT_FISHEYE": "ojo de pez",
    "LOOKS_EFFECT_WHIRL": "remolino",
    "LOOKS_EFFECT_PIXELATE": "pixelar",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "brillo",
    "LOOKS_EFFECT_GHOST": "desvanecer",
    "LOOKS_CHANGEEFFECTBY": "sumar al efecto %1 %2",
    "LOOKS_SETEFFECTTO": "dar al efecto %1 el valor %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "quitar efectos gráficos",
    "LOOKS_CHANGESIZEBY": "cambiar tamaño por %1",
    "LOOKS_SETSIZETO": "fijar tamaño al %1 %",
    "LOOKS_SIZE": "tamaño",
    "LOOKS_CHANGESTRETCHBY": "sumar al estiramiento %1",
    "LOOKS_SETSTRETCHTO": "fijar estiramiento al %1 %",
    "LOOKS_SWITCHCOSTUMETO": "cambiar disfraz a %1",
    "LOOKS_NEXTCOSTUME": "siguiente disfraz",
    "LOOKS_SWITCHBACKDROPTO": "cambiar fondo a %1",
    "LOOKS_GOTOFRONTBACK": "ir a capa %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "delantera",
    "LOOKS_GOTOFRONTBACK_BACK": "trasera",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ir %2 capas hacia %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "delante",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "atrás",
    "LOOKS_BACKDROPNUMBERNAME": "%1 de fondo",
    "LOOKS_COSTUMENUMBERNAME": "%1 de disfraz",
    "LOOKS_NUMBERNAME_NUMBER": "número",
    "LOOKS_NUMBERNAME_NAME": "nombre",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "cambiar fondo a %1 y esperar",
    "LOOKS_NEXTBACKDROP_BLOCK": "siguiente fondo",
    "LOOKS_NEXTBACKDROP": "siguiente fondo",
    "LOOKS_PREVIOUSBACKDROP": "fondo anterior",
    "LOOKS_RANDOMBACKDROP": "fondo aleatorio",
    "MOTION_MOVESTEPS": "mover %1 pasos",
    "MOTION_TURNLEFT": "girar %1 %2 grados",
    "MOTION_TURNRIGHT": "girar %1 %2 grados",
    "MOTION_POINTINDIRECTION": "apuntar en dirección %1",
    "MOTION_POINTTOWARDS": "apuntar hacia %1",
    "MOTION_POINTTOWARDS_POINTER": "puntero del ratón",
    "MOTION_POINTTOWARDS_RANDOM": "dirección aleatoria",
    "MOTION_GOTO": "ir a %1",
    "MOTION_GOTO_POINTER": "puntero del ratón",
    "MOTION_GOTO_RANDOM": "posición aleatoria",
    "MOTION_GOTOXY": "ir a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "deslizar en %1 segs a x: %2 y: %3",
    "MOTION_GLIDETO": "deslizar en %1 segs a %2",
    "MOTION_GLIDETO_POINTER": "puntero del ratón",
    "MOTION_GLIDETO_RANDOM": "posición aleatoria",
    "MOTION_CHANGEXBY": "sumar a x %1",
    "MOTION_SETX": "dar a x el valor %1",
    "MOTION_CHANGEYBY": "sumar a y %1",
    "MOTION_SETY": "dar a y el valor %1",
    "MOTION_IFONEDGEBOUNCE": "si toca un borde, rebotar",
    "MOTION_SETROTATIONSTYLE": "fijar estilo de rotación a %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "izquierda-derecha",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "no rotar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "en todas direcciones",
    "MOTION_XPOSITION": "posición en x",
    "MOTION_YPOSITION": "posición en y",
    "MOTION_DIRECTION": "dirección",
    "MOTION_SCROLLRIGHT": "desplazar a la derecha %1",
    "MOTION_SCROLLUP": "desplazar arriba %1",
    "MOTION_ALIGNSCENE": "alinear escena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "abajo a la izquierda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "abajo a la derecha",
    "MOTION_ALIGNSCENE_MIDDLE": "al centro",
    "MOTION_ALIGNSCENE_TOPLEFT": "arriba a la izquierda",
    "MOTION_ALIGNSCENE_TOPRIGHT": "arriba a la derecha",
    "MOTION_XSCROLL": "desplazamiento en x",
    "MOTION_YSCROLL": "desplazamiento en y",
    "MOTION_STAGE_SELECTED": "Escenario seleccionado: no hay bloques de movimiento",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "número aleatorio entre %1 y %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 y %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "no %1",
    "OPERATORS_JOIN": "unir %1 %2",
    "OPERATORS_JOIN_APPLE": "manzana",
    "OPERATORS_JOIN_BANANA": "plátano",
    "OPERATORS_LETTEROF": "letra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "longitud de %1",
    "OPERATORS_CONTAINS": "¿%2 está en %1?",
    "OPERATORS_MOD": "%1 módulo %2",
    "OPERATORS_ROUND": "redondear %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "valor absoluto",
    "OPERATORS_MATHOP_FLOOR": "suelo",
    "OPERATORS_MATHOP_CEILING": "techo",
    "OPERATORS_MATHOP_SQRT": "raíz cuadrada",
    "OPERATORS_MATHOP_SIN": "sen",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsen",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definir %1",
    "SENSING_TOUCHINGOBJECT": "¿tocando %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "puntero del ratón",
    "SENSING_TOUCHINGOBJECT_EDGE": "borde",
    "SENSING_TOUCHINGCOLOR": "¿tocando el color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "¿color %1 tocando %2?",
    "SENSING_DISTANCETO": "distancia a %1",
    "SENSING_DISTANCETO_POINTER": "puntero del ratón",
    "SENSING_ASKANDWAIT": "preguntar %1 y esperar",
    "SENSING_ASK_TEXT": "¿Cómo te llamas?",
    "SENSING_ANSWER": "respuesta",
    "SENSING_KEYPRESSED": "¿tecla %1 presionada?",
    "SENSING_MOUSEDOWN": "¿ratón presionado?",
    "SENSING_MOUSEX": "posición x del ratón",
    "SENSING_MOUSEY": "posición y del ratón",
    "SENSING_SETDRAGMODE": "fijar modo de arrastre a %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastrable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "no arrastrable",
    "SENSING_LOUDNESS": "volumen del sonido",
    "SENSING_LOUD": "¿ruidoso?",
    "SENSING_TIMER": "cronómetro",
    "SENSING_RESETTIMER": "reiniciar cronómetro",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posición en x",
    "SENSING_OF_YPOSITION": "posición en y",
    "SENSING_OF_DIRECTION": "dirección",
    "SENSING_OF_COSTUMENUMBER": "# de disfraz",
    "SENSING_OF_COSTUMENAME": "nombre de disfraz",
    "SENSING_OF_SIZE": "tamaño",
    "SENSING_OF_VOLUME": "volumen",
    "SENSING_OF_BACKDROPNUMBER": "# de fondo",
    "SENSING_OF_BACKDROPNAME": "nombre de fondo",
    "SENSING_OF_STAGE": "Escenario",
    "SENSING_CURRENT": "%1 actual",
    "SENSING_CURRENT_YEAR": "año",
    "SENSING_CURRENT_MONTH": "mes",
    "SENSING_CURRENT_DATE": "día",
    "SENSING_CURRENT_DAYOFWEEK": "día de la semana",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "segundo",
    "SENSING_DAYSSINCE2000": "días desde el 2000",
    "SENSING_USERNAME": "nombre de usuario",
    "SENSING_USERID": "id de usuario",
    "SOUND_PLAY": "iniciar sonido %1",
    "SOUND_PLAYUNTILDONE": "tocar sonido %1 hasta que termine",
    "SOUND_STOPALLSOUNDS": "detener todos los sonidos",
    "SOUND_SETEFFECTO": "dar al efecto %1 el valor %2",
    "SOUND_CHANGEEFFECTBY": "sumar al efecto %1 %2",
    "SOUND_CLEAREFFECTS": "quitar efectos de sonido",
    "SOUND_EFFECTS_PITCH": "altura",
    "SOUND_EFFECTS_PAN": "balance izquierda/derecha",
    "SOUND_CHANGEVOLUMEBY": "cambiar volumen por %1",
    "SOUND_SETVOLUMETO": "fijar volumen al %1%",
    "SOUND_VOLUME": "volumen",
    "SOUND_RECORD": "grabar...",
    "CATEGORY_MOTION": "Movimiento",
    "CATEGORY_LOOKS": "Apariencia",
    "CATEGORY_SOUND": "Sonido",
    "CATEGORY_EVENTS": "Eventos",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensores",
    "CATEGORY_OPERATORS": "Operadores",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "Mis bloques",
    "DUPLICATE": "Duplicar",
    "DELETE": "Eliminar",
    "ADD_COMMENT": "Añadir comentario",
    "REMOVE_COMMENT": "Eliminar comentario",
    "DELETE_BLOCK": "Eliminar bloque",
    "DELETE_X_BLOCKS": "Eliminar %1 bloques",
    "DELETE_ALL_BLOCKS": "¿Eliminar los %1 bloques?",
    "CLEAN_UP": "Ordenar bloques",
    "HELP": "Ayuda",
    "UNDO": "Deshacer",
    "REDO": "Rehacer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Ir a definición",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Di algo...",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturación",
    "COLOUR_BRIGHTNESS_LABEL": "Brillo",
    "CHANGE_VALUE_TITLE": "Cambiar valor:",
    "RENAME_VARIABLE": "Renombrar variable",
    "RENAME_VARIABLE_TITLE": "Renombrar todas las variables \"%1\" a:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renombrar variable",
    "NEW_VARIABLE": "Crear una variable",
    "NEW_VARIABLE_TITLE": "Nombre de la variable:",
    "VARIABLE_MODAL_TITLE": "Nueva variable",
    "VARIABLE_ALREADY_EXISTS": "Ya existe una variable llamada \"%1\".",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Ya existe una variable llamada \"%1\" para otra variable de tipo \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "¿Eliminar %1 usos de la variable \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "No se puede eliminar la variable \"%1\" porque es parte de la definición de la función \"%2\"",
    "DELETE_VARIABLE": "Eliminar la variable \"%1\"",
    "NEW_PROCEDURE": "Crear un bloque",
    "PROCEDURE_ALREADY_EXISTS": "Ya existe un procedimiento llamado \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "nombre del bloque",
    "PROCEDURE_USED": "Antes de eliminar la definición del bloque debes eliminar todos sus usos",
    "NEW_LIST": "Crear una lista",
    "NEW_LIST_TITLE": "Nombre de la lista:",
    "LIST_MODAL_TITLE": "Nueva lista",
    "LIST_ALREADY_EXISTS": "Ya existe una lista llamada \"%1\".",
    "RENAME_LIST_TITLE": "Renombrar todas las listas \"%1\" a:",
    "RENAME_LIST_MODAL_TITLE": "Renombrar lista",
    "DEFAULT_LIST_ITEM": "cosa",
    "DELETE_LIST": "Eliminar la lista \"%1\"",
    "RENAME_LIST": "Renombrar lista",
    "NEW_BROADCAST_MESSAGE": "Nuevo mensaje",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nombre del mensaje:",
    "BROADCAST_MODAL_TITLE": "Nuevo Mensaje",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mensaje1"
  },
  "es-419": {
    "CONTROL_FOREVER": "por siempre",
    "CONTROL_REPEAT": "repetir %1",
    "CONTROL_IF": "si %1 entonces",
    "CONTROL_ELSE": "si no",
    "CONTROL_STOP": "detener",
    "CONTROL_STOP_ALL": "todos",
    "CONTROL_STOP_THIS": "este programa",
    "CONTROL_STOP_OTHER": "otros programas en el objeto",
    "CONTROL_WAIT": "esperar %1 segundos",
    "CONTROL_WAITUNTIL": "esperar hasta que %1",
    "CONTROL_REPEATUNTIL": "repetir hasta que %1",
    "CONTROL_WHILE": "mientras %1",
    "CONTROL_FOREACH": "para cada %1 en %2",
    "CONTROL_STARTASCLONE": "al comenzar como clon",
    "CONTROL_CREATECLONEOF": "crear clon de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mí mismo",
    "CONTROL_DELETETHISCLONE": "eliminar este clon",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "incrementar contador",
    "CONTROL_CLEARCOUNTER": "borrar contador",
    "CONTROL_ALLATONCE": "todos a la vez",
    "DATA_SETVARIABLETO": "fijar %1 a %2",
    "DATA_CHANGEVARIABLEBY": "cambiar %1 en %2",
    "DATA_SHOWVARIABLE": "mostrar variable %1",
    "DATA_HIDEVARIABLE": "esconder variable %1",
    "DATA_ADDTOLIST": "añadir %1 a %2",
    "DATA_DELETEOFLIST": "eliminar %1 de %2",
    "DATA_DELETEALLOFLIST": "Eliminar todos de %1",
    "DATA_INSERTATLIST": "insertar %1 en %2 de %3",
    "DATA_REPLACEITEMOFLIST": "reemplazar elemento %1 de %2 con %3",
    "DATA_ITEMOFLIST": "elemento %1 de %2",
    "DATA_ITEMNUMOFLIST": "# de elemento de %1 en %2",
    "DATA_LENGTHOFLIST": "longitud de %1",
    "DATA_LISTCONTAINSITEM": "¿%2 está en %1?",
    "DATA_SHOWLIST": "mostrar lista %1",
    "DATA_HIDELIST": "esconder lista %1",
    "DATA_INDEX_ALL": "todos",
    "DATA_INDEX_LAST": "último",
    "DATA_INDEX_RANDOM": "al azar",
    "EVENT_WHENFLAGCLICKED": "al presionar %1",
    "EVENT_WHENTHISSPRITECLICKED": "al hacer clic en este objeto",
    "EVENT_WHENSTAGECLICKED": "al hacer clic en el escenario",
    "EVENT_WHENTOUCHINGOBJECT": "cuando este objeto toque %1",
    "EVENT_WHENBROADCASTRECEIVED": "al recibir %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "cuando el fondo cambie a %1",
    "EVENT_WHENGREATERTHAN": "cuando %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronómetro",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "volumen del sonido",
    "EVENT_BROADCAST": "enviar %1",
    "EVENT_BROADCASTANDWAIT": "enviar %1 y esperar",
    "EVENT_WHENKEYPRESSED": "al presionar tecla %1",
    "EVENT_WHENKEYPRESSED_SPACE": "espacio",
    "EVENT_WHENKEYPRESSED_LEFT": "flecha izquierda",
    "EVENT_WHENKEYPRESSED_RIGHT": "flecha derecha",
    "EVENT_WHENKEYPRESSED_DOWN": "flecha abajo",
    "EVENT_WHENKEYPRESSED_UP": "flecha arriba",
    "EVENT_WHENKEYPRESSED_ANY": "cualquiera",
    "LOOKS_SAYFORSECS": "decir %1 durante %2 segundos",
    "LOOKS_SAY": "decir %1",
    "LOOKS_HELLO": "¡Hola!",
    "LOOKS_THINKFORSECS": "pensar %1 durante %2 segundos",
    "LOOKS_THINK": "pensar %1",
    "LOOKS_HMM": "Umm...",
    "LOOKS_SHOW": "mostrar",
    "LOOKS_HIDE": "esconder",
    "LOOKS_HIDEALLSPRITES": "esconder todos los objetos",
    "LOOKS_EFFECT_COLOR": "color",
    "LOOKS_EFFECT_FISHEYE": "ojo de pez",
    "LOOKS_EFFECT_WHIRL": "remolino",
    "LOOKS_EFFECT_PIXELATE": "pixelar",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "brillo",
    "LOOKS_EFFECT_GHOST": "desvanecer",
    "LOOKS_CHANGEEFFECTBY": "cambiar el efecto %1 en %2",
    "LOOKS_SETEFFECTTO": "fijar efecto %1 a %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "quitar efectos gráficos",
    "LOOKS_CHANGESIZEBY": "cambiar tamaño en %1",
    "LOOKS_SETSIZETO": "fijar tamaño a %1 %",
    "LOOKS_SIZE": "tamaño",
    "LOOKS_CHANGESTRETCHBY": "cambiar estiramiento en %1",
    "LOOKS_SETSTRETCHTO": "fijar estiramiento a %1 %",
    "LOOKS_SWITCHCOSTUMETO": "cambiar disfraz a %1",
    "LOOKS_NEXTCOSTUME": "siguiente disfraz",
    "LOOKS_SWITCHBACKDROPTO": "cambiar fondo a %1",
    "LOOKS_GOTOFRONTBACK": "ir a la capa %1 ",
    "LOOKS_GOTOFRONTBACK_FRONT": "de adelante",
    "LOOKS_GOTOFRONTBACK_BACK": "de atrás",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ir %2 capas hacia %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "adelante",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "atrás",
    "LOOKS_BACKDROPNUMBERNAME": "fondo %1",
    "LOOKS_COSTUMENUMBERNAME": "disfraz %1",
    "LOOKS_NUMBERNAME_NUMBER": "número",
    "LOOKS_NUMBERNAME_NAME": "nombre",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "cambiar fondo a %1 y esperar",
    "LOOKS_NEXTBACKDROP_BLOCK": "siguiente fondo",
    "LOOKS_NEXTBACKDROP": "siguiente fondo",
    "LOOKS_PREVIOUSBACKDROP": "fondo anterior",
    "LOOKS_RANDOMBACKDROP": "fondo aleatorio",
    "MOTION_MOVESTEPS": "mover %1 pasos",
    "MOTION_TURNLEFT": "girar %1 %2 grados",
    "MOTION_TURNRIGHT": "girar %1 %2 grados",
    "MOTION_POINTINDIRECTION": "apuntar en dirección %1",
    "MOTION_POINTTOWARDS": "apuntar hacia %1",
    "MOTION_POINTTOWARDS_POINTER": "puntero del ratón",
    "MOTION_POINTTOWARDS_RANDOM": "dirección aleatoria",
    "MOTION_GOTO": "ir a %1",
    "MOTION_GOTO_POINTER": "puntero del ratón",
    "MOTION_GOTO_RANDOM": "posición aleatoria",
    "MOTION_GOTOXY": "ir a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "desplazar en %1 segs a x: %2 y: %3",
    "MOTION_GLIDETO": "desplazar en %1 segs a %2",
    "MOTION_GLIDETO_POINTER": "puntero del ratón",
    "MOTION_GLIDETO_RANDOM": "posición aleatoria",
    "MOTION_CHANGEXBY": "cambiar x en %1",
    "MOTION_SETX": "fijar x a %1",
    "MOTION_CHANGEYBY": "cambiar y en %1",
    "MOTION_SETY": "fijar y a %1",
    "MOTION_IFONEDGEBOUNCE": "si toca un borde, rebotar",
    "MOTION_SETROTATIONSTYLE": "fijar estilo de rotación a %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "izquierda-derecha",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "no rotar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "en todas las direcciones",
    "MOTION_XPOSITION": "posición en x",
    "MOTION_YPOSITION": "posición en y",
    "MOTION_DIRECTION": "dirección",
    "MOTION_SCROLLRIGHT": "desplazar a la derecha %1",
    "MOTION_SCROLLUP": "desplazar arriba %1",
    "MOTION_ALIGNSCENE": "alinear escena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "abajo a la izquierda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "abajo a la derecha",
    "MOTION_ALIGNSCENE_MIDDLE": "mitad",
    "MOTION_ALIGNSCENE_TOPLEFT": "arriba a la izquierda",
    "MOTION_ALIGNSCENE_TOPRIGHT": "arriba a la derecha",
    "MOTION_XSCROLL": "desplazar x",
    "MOTION_YSCROLL": "desplazar y",
    "MOTION_STAGE_SELECTED": "Escenario seleccionado: no hay bloques de movimiento",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "elegir número al azar entre %1 y %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 y %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "no %1",
    "OPERATORS_JOIN": "unir %1 %2",
    "OPERATORS_JOIN_APPLE": "manzana",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "longitud de %1",
    "OPERATORS_CONTAINS": "¿%1 contiene %2?",
    "OPERATORS_MOD": "%1 módulo %2",
    "OPERATORS_ROUND": "redondear %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "valor absoluto",
    "OPERATORS_MATHOP_FLOOR": "piso",
    "OPERATORS_MATHOP_CEILING": "techo",
    "OPERATORS_MATHOP_SQRT": "raíz cuadrada",
    "OPERATORS_MATHOP_SIN": "sen",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsen",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definir %1",
    "SENSING_TOUCHINGOBJECT": "¿tocando %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "el puntero del ratón",
    "SENSING_TOUCHINGOBJECT_EDGE": "el borde",
    "SENSING_TOUCHINGCOLOR": "¿tocando el color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "¿color %1 está tocando %2?",
    "SENSING_DISTANCETO": "distancia a %1",
    "SENSING_DISTANCETO_POINTER": "puntero del ratón",
    "SENSING_ASKANDWAIT": "preguntar %1 y esperar",
    "SENSING_ASK_TEXT": "¿Cómo te llamas?",
    "SENSING_ANSWER": "respuesta",
    "SENSING_KEYPRESSED": "¿tecla %1 presionada?",
    "SENSING_MOUSEDOWN": "¿ratón presionado?",
    "SENSING_MOUSEX": "posición x del ratón",
    "SENSING_MOUSEY": "posición y del ratón",
    "SENSING_SETDRAGMODE": "fijar modo de arrastre a %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastrable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "no arrastrable",
    "SENSING_LOUDNESS": "volumen del sonido",
    "SENSING_LOUD": "¿fuerte?",
    "SENSING_TIMER": "cronómetro",
    "SENSING_RESETTIMER": "reiniciar cronómetro",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posición en x",
    "SENSING_OF_YPOSITION": "posición en y",
    "SENSING_OF_DIRECTION": "dirección",
    "SENSING_OF_COSTUMENUMBER": "# de disfraz",
    "SENSING_OF_COSTUMENAME": "nombre del disfraz",
    "SENSING_OF_SIZE": "tamaño",
    "SENSING_OF_VOLUME": "volumen",
    "SENSING_OF_BACKDROPNUMBER": "# de fondo",
    "SENSING_OF_BACKDROPNAME": "nombre de fondo",
    "SENSING_OF_STAGE": "Escenario",
    "SENSING_CURRENT": "%1 actual",
    "SENSING_CURRENT_YEAR": "año",
    "SENSING_CURRENT_MONTH": "mes",
    "SENSING_CURRENT_DATE": "fecha",
    "SENSING_CURRENT_DAYOFWEEK": "día de la semana",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "segundo",
    "SENSING_DAYSSINCE2000": "días desde el 2000",
    "SENSING_USERNAME": "nombre de usuario",
    "SENSING_USERID": "nombre de usuario",
    "SOUND_PLAY": "iniciar sonido %1",
    "SOUND_PLAYUNTILDONE": "tocar sonido %1 hasta que termine",
    "SOUND_STOPALLSOUNDS": "detener todos los sonidos",
    "SOUND_SETEFFECTO": "fijar efecto %1 a %2",
    "SOUND_CHANGEEFFECTBY": "cambiar efecto %1 en %2",
    "SOUND_CLEAREFFECTS": "quitar efectos de sonido",
    "SOUND_EFFECTS_PITCH": "tono",
    "SOUND_EFFECTS_PAN": "paneo izquierda/derecha",
    "SOUND_CHANGEVOLUMEBY": "cambiar volumen en %1",
    "SOUND_SETVOLUMETO": "fijar volumen a %1%",
    "SOUND_VOLUME": "volumen",
    "SOUND_RECORD": "grabar...",
    "CATEGORY_MOTION": "Movimiento",
    "CATEGORY_LOOKS": "Apariencia",
    "CATEGORY_SOUND": "Sonido",
    "CATEGORY_EVENTS": "Eventos",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensores",
    "CATEGORY_OPERATORS": "Operadores",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "Mis Bloques",
    "DUPLICATE": "Duplicar",
    "DELETE": "Eliminar",
    "ADD_COMMENT": "Agregar comentario",
    "REMOVE_COMMENT": "Eliminar comentario",
    "DELETE_BLOCK": "Eliminar bloque",
    "DELETE_X_BLOCKS": "Eliminar %1 bloques",
    "DELETE_ALL_BLOCKS": "¿Eliminar los %1 bloques?",
    "CLEAN_UP": "Ordenar bloques",
    "HELP": "Ayuda",
    "UNDO": "Deshacer",
    "REDO": "Rehacer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Ir a la definición",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Decir algo...",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturación",
    "COLOUR_BRIGHTNESS_LABEL": "Brillo",
    "CHANGE_VALUE_TITLE": "Cambiar valor:",
    "RENAME_VARIABLE": "Renombrar variable",
    "RENAME_VARIABLE_TITLE": "Renombrar todas las variables \"%1\" a:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renombrar variable",
    "NEW_VARIABLE": "Crear una variable",
    "NEW_VARIABLE_TITLE": "Nuevo nombre de variable:",
    "VARIABLE_MODAL_TITLE": "Nueva variable",
    "VARIABLE_ALREADY_EXISTS": "Ya existe una variable llamada \"%1\".",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Ya existe una variable llamada \"%1\" para otra variable de tipo \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "¿Eliminar %1 usos de la variable \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "No se puede eliminar la variable \"%1\" porque es parte de la definición de la función \"%2\"",
    "DELETE_VARIABLE": "Eliminar la variable \"%1\"",
    "NEW_PROCEDURE": "Crear un bloque",
    "PROCEDURE_ALREADY_EXISTS": "Ya existe un procedimiento llamado \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "nombre del bloque",
    "PROCEDURE_USED": "Para eliminar una definición de bloque, primero borre todos sus usos",
    "NEW_LIST": "Crear una lista",
    "NEW_LIST_TITLE": "Nombre para nueva lista:",
    "LIST_MODAL_TITLE": "Nueva lista",
    "LIST_ALREADY_EXISTS": "Ya existe una lista llamada \"%1\".",
    "RENAME_LIST_TITLE": "Renombrar todas las listas \"%1\" a:",
    "RENAME_LIST_MODAL_TITLE": "Renombrar lista",
    "DEFAULT_LIST_ITEM": "cosa",
    "DELETE_LIST": "Eliminar la lista \"%1\"",
    "RENAME_LIST": "Renombrar lista",
    "NEW_BROADCAST_MESSAGE": "Nuevo mensaje",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nombre para el nuevo mensaje:",
    "BROADCAST_MODAL_TITLE": "Nuevo Mensaje",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mensaje1"
  },
  "eo": {
    "CONTROL_FOREVER": "ripeti senfine",
    "CONTROL_REPEAT": "ripeti %1-foje",
    "CONTROL_IF": "se %1 do",
    "CONTROL_ELSE": "alikaze",
    "CONTROL_STOP": "haltigi",
    "CONTROL_STOP_ALL": "ĉion",
    "CONTROL_STOP_THIS": "tiun ĉi skripton",
    "CONTROL_STOP_OTHER": "aliajn skriptojn en la rolulo",
    "CONTROL_WAIT": "atendi %1 sekundojn",
    "CONTROL_WAITUNTIL": "atendi ĝis %1",
    "CONTROL_REPEATUNTIL": "ripeti ĝis %1",
    "CONTROL_WHILE": "dum %1",
    "CONTROL_FOREACH": "por ĉiu %1 en %2",
    "CONTROL_STARTASCLONE": "kiam mi kreiĝas kiel klono",
    "CONTROL_CREATECLONEOF": "krei klonon de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mi mem",
    "CONTROL_DELETETHISCLONE": "forigi tiun ĉi klonon",
    "CONTROL_COUNTER": "nombrilo",
    "CONTROL_INCRCOUNTER": "kreska nombrilo",
    "CONTROL_CLEARCOUNTER": "restartigi nombrilon",
    "CONTROL_ALLATONCE": "ĉiuj kune",
    "DATA_SETVARIABLETO": "agordi %1 al %2",
    "DATA_CHANGEVARIABLEBY": "ŝanĝi %1 je %2",
    "DATA_SHOWVARIABLE": "montri variablon %1",
    "DATA_HIDEVARIABLE": "kaŝi variablon %1",
    "DATA_ADDTOLIST": "aldoni %1 al %2",
    "DATA_DELETEOFLIST": "forigi %1 de el %2",
    "DATA_DELETEALLOFLIST": "forigi ĉion el %1",
    "DATA_INSERTATLIST": "enmeti %1 ĉe %2 de %3",
    "DATA_REPLACEITEMOFLIST": "anstataŭigi %1-an eron de %2 per %3",
    "DATA_ITEMOFLIST": "%1-a ero de %2",
    "DATA_ITEMNUMOFLIST": "vica numero de %1 en %2",
    "DATA_LENGTHOFLIST": "longo de %1",
    "DATA_LISTCONTAINSITEM": "ĉu %1 enhavas %2?",
    "DATA_SHOWLIST": "montri liston %1",
    "DATA_HIDELIST": "kaŝi liston %1",
    "DATA_INDEX_ALL": "ĉion",
    "DATA_INDEX_LAST": "lastan",
    "DATA_INDEX_RANDOM": "hazardan",
    "EVENT_WHENFLAGCLICKED": "kiam %1 estas alklakita",
    "EVENT_WHENTHISSPRITECLICKED": "kiam tiu ĉi rolulo estas alklakita",
    "EVENT_WHENSTAGECLICKED": "kiam la scenejo estas alklakita",
    "EVENT_WHENTOUCHINGOBJECT": "kiam tiu ĉi rolulo tuŝas %1",
    "EVENT_WHENBROADCASTRECEIVED": "kiam mi ricevas %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "kiam fono ŝanĝiĝas al %1",
    "EVENT_WHENGREATERTHAN": "kiam %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "horloĝo",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "laŭto",
    "EVENT_BROADCAST": "elsendi %1",
    "EVENT_BROADCASTANDWAIT": "elsendi %1 kaj atendi",
    "EVENT_WHENKEYPRESSED": "kiam klavo %1 estas tuŝita",
    "EVENT_WHENKEYPRESSED_SPACE": "spacetklavo",
    "EVENT_WHENKEYPRESSED_LEFT": "sago maldekstra",
    "EVENT_WHENKEYPRESSED_RIGHT": "sago dekstra",
    "EVENT_WHENKEYPRESSED_DOWN": "sago malsupra",
    "EVENT_WHENKEYPRESSED_UP": "sago supra",
    "EVENT_WHENKEYPRESSED_ANY": "iu ajn",
    "LOOKS_SAYFORSECS": "diri %1 dum %2 sekundoj",
    "LOOKS_SAY": "diri %1",
    "LOOKS_HELLO": "Saluton!",
    "LOOKS_THINKFORSECS": "pensi %1 dum %2 sekundoj",
    "LOOKS_THINK": "pensi %1",
    "LOOKS_HMM": "Nu...",
    "LOOKS_SHOW": "montri",
    "LOOKS_HIDE": "kaŝi",
    "LOOKS_HIDEALLSPRITES": "kaŝi ĉiujn rolulojn",
    "LOOKS_EFFECT_COLOR": "kolora",
    "LOOKS_EFFECT_FISHEYE": "fiŝokula",
    "LOOKS_EFFECT_WHIRL": "kirla",
    "LOOKS_EFFECT_PIXELATE": "rastruma",
    "LOOKS_EFFECT_MOSAIC": "mozaika",
    "LOOKS_EFFECT_BRIGHTNESS": "heleca",
    "LOOKS_EFFECT_GHOST": "diafaneca",
    "LOOKS_CHANGEEFFECTBY": "ŝanĝi efikon %1 je %2",
    "LOOKS_SETEFFECTTO": "agordi efikon %1 al %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "forigi grafikajn efikojn",
    "LOOKS_CHANGESIZEBY": "ŝanĝi grandon je %1",
    "LOOKS_SETSIZETO": "agordi grandon al %1 %",
    "LOOKS_SIZE": "grando",
    "LOOKS_CHANGESTRETCHBY": "ŝanĝi streĉon je %1",
    "LOOKS_SETSTRETCHTO": "agordi streĉon al %1",
    "LOOKS_SWITCHCOSTUMETO": "ŝanĝi al la kostumo %1",
    "LOOKS_NEXTCOSTUME": "sekva kostumo",
    "LOOKS_SWITCHBACKDROPTO": "ŝanĝi fonon al %1",
    "LOOKS_GOTOFRONTBACK": "iri al %1 tavolo",
    "LOOKS_GOTOFRONTBACK_FRONT": "malfona",
    "LOOKS_GOTOFRONTBACK_BACK": "fona",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "iri %1 je %2 tavoloj",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "malfonen",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "fonen",
    "LOOKS_BACKDROPNUMBERNAME": "%1 de fono",
    "LOOKS_COSTUMENUMBERNAME": "%1 de kostumo",
    "LOOKS_NUMBERNAME_NUMBER": "numero",
    "LOOKS_NUMBERNAME_NAME": "nomo",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "ŝanĝi fonon al %1 kaj atendi",
    "LOOKS_NEXTBACKDROP_BLOCK": "sekva fono",
    "LOOKS_NEXTBACKDROP": "sekva fono",
    "LOOKS_PREVIOUSBACKDROP": "antaŭa fono",
    "LOOKS_RANDOMBACKDROP": "hazarda fono",
    "MOTION_MOVESTEPS": "movi %1 paŝojn",
    "MOTION_TURNLEFT": "turni %1 je %2 gradoj",
    "MOTION_TURNRIGHT": "turni %1 je %2 gradoj",
    "MOTION_POINTINDIRECTION": "agordi direkton al %1",
    "MOTION_POINTTOWARDS": "direkti al %1",
    "MOTION_POINTTOWARDS_POINTER": "musa montrilo",
    "MOTION_POINTTOWARDS_RANDOM": "hazarda direkto",
    "MOTION_GOTO": "iri al %1",
    "MOTION_GOTO_POINTER": "musa montrilo",
    "MOTION_GOTO_RANDOM": "hazarda pozicio",
    "MOTION_GOTOXY": "iri al x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "gliti dum %1 sekundoj al x: %2 y: %3",
    "MOTION_GLIDETO": "gliti dum %1 sekundoj al %2",
    "MOTION_GLIDETO_POINTER": "musa montrilo",
    "MOTION_GLIDETO_RANDOM": "hazarda pozicio",
    "MOTION_CHANGEXBY": "ŝanĝi x je %1",
    "MOTION_SETX": "agordi x al %1",
    "MOTION_CHANGEYBY": "ŝanĝi y je %1",
    "MOTION_SETY": "agordi y al %1",
    "MOTION_IFONEDGEBOUNCE": "se mi tuŝas randon, resalti",
    "MOTION_SETROTATIONSTYLE": "turniĝi tiel: %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "nur dekstre-maldekstre",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ne turniĝi",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "turniĝi libere",
    "MOTION_XPOSITION": "x-pozicio",
    "MOTION_YPOSITION": "y-pozicio",
    "MOTION_DIRECTION": "direkto",
    "MOTION_SCROLLRIGHT": "rulumi dekstren je %1",
    "MOTION_SCROLLUP": "rulumi supren je %1",
    "MOTION_ALIGNSCENE": "ĝisrandigi scenejon tiel: %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "sube-maldekstre",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "sube-dekstre",
    "MOTION_ALIGNSCENE_MIDDLE": "centre",
    "MOTION_ALIGNSCENE_TOPLEFT": "super-maldekstre",
    "MOTION_ALIGNSCENE_TOPRIGHT": "supre-dekstre",
    "MOTION_XSCROLL": "x-rulumado",
    "MOTION_YSCROLL": "y-rulumado",
    "MOTION_STAGE_SELECTED": "Scenejo elektita: neniu movo eblas",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "hazarda numero inter %1 kaj %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 kaj %2",
    "OPERATORS_OR": "%1 aŭ %2",
    "OPERATORS_NOT": "ne %1",
    "OPERATORS_JOIN": "kunigi %1 %2",
    "OPERATORS_JOIN_APPLE": "patrino",
    "OPERATORS_JOIN_BANANA": "pravas",
    "OPERATORS_LETTEROF": "%1 -a litero de %2",
    "OPERATORS_LETTEROF_APPLE": "p",
    "OPERATORS_LENGTH": "longo de %1",
    "OPERATORS_CONTAINS": "ĉu %1 enhavas %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "rondigi %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "planko",
    "OPERATORS_MATHOP_CEILING": "plafono",
    "OPERATORS_MATHOP_SQRT": "radiko",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "difini %1",
    "SENSING_TOUCHINGOBJECT": "ĉu tuŝas %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "musan montrilon",
    "SENSING_TOUCHINGOBJECT_EDGE": "randon",
    "SENSING_TOUCHINGCOLOR": "ĉu tuŝas koloron %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "ĉu koloro %1 tuŝas koloron %2?",
    "SENSING_DISTANCETO": "distanco al %1",
    "SENSING_DISTANCETO_POINTER": "musa montrilo",
    "SENSING_ASKANDWAIT": "demandi %1 kaj atendi",
    "SENSING_ASK_TEXT": "Kiel vi nomiĝas?",
    "SENSING_ANSWER": "respondo",
    "SENSING_KEYPRESSED": "ĉu klavo %1 estas tuŝita?",
    "SENSING_MOUSEDOWN": "ĉu musbutono estas premita?",
    "SENSING_MOUSEX": "musa x-pozicio",
    "SENSING_MOUSEY": "musa y-pozicio",
    "SENSING_SETDRAGMODE": "ĉu eblu treni rolulojn? %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "jes",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ne",
    "SENSING_LOUDNESS": "laŭto",
    "SENSING_LOUD": "ĉu laŭta?",
    "SENSING_TIMER": "horloĝo",
    "SENSING_RESETTIMER": "restartigi klikhorloĝon",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "x-pozicio",
    "SENSING_OF_YPOSITION": "y-pozicio",
    "SENSING_OF_DIRECTION": "direkto",
    "SENSING_OF_COSTUMENUMBER": "numero de kostumo",
    "SENSING_OF_COSTUMENAME": "nomo de kostumo",
    "SENSING_OF_SIZE": "grando",
    "SENSING_OF_VOLUME": "laŭteco",
    "SENSING_OF_BACKDROPNUMBER": "numero de la fono",
    "SENSING_OF_BACKDROPNAME": "nomo de fono",
    "SENSING_OF_STAGE": "Scenejo",
    "SENSING_CURRENT": "aktuala %1",
    "SENSING_CURRENT_YEAR": "jaro",
    "SENSING_CURRENT_MONTH": "monato",
    "SENSING_CURRENT_DATE": "dato",
    "SENSING_CURRENT_DAYOFWEEK": "tago de la semajno",
    "SENSING_CURRENT_HOUR": "horo",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "sekundo",
    "SENSING_DAYSSINCE2000": "tagoj post 2000",
    "SENSING_USERNAME": "salutnomo",
    "SENSING_USERID": "ID de uzanto",
    "SOUND_PLAY": "komenci sonon %1",
    "SOUND_PLAYUNTILDONE": "aŭdigi sonon %1 ĝis la fino",
    "SOUND_STOPALLSOUNDS": "ĉesigi ĉiujn sonojn",
    "SOUND_SETEFFECTO": "agordi efikon %1 al %2",
    "SOUND_CHANGEEFFECTBY": "ŝanĝi efikon %1 je %2",
    "SOUND_CLEAREFFECTS": "forigi sonojn",
    "SOUND_EFFECTS_PITCH": "tonalto",
    "SOUND_EFFECTS_PAN": "aŭdigi maldekstre/dekstre",
    "SOUND_CHANGEVOLUMEBY": "ŝanĝi laŭtecon je %1",
    "SOUND_SETVOLUMETO": "agordi laŭtecon al %1%",
    "SOUND_VOLUME": "laŭteco",
    "SOUND_RECORD": "registri...",
    "CATEGORY_MOTION": "Movado",
    "CATEGORY_LOOKS": "Aspekto",
    "CATEGORY_SOUND": "Sono",
    "CATEGORY_EVENTS": "Eventoj",
    "CATEGORY_CONTROL": "Stirado",
    "CATEGORY_SENSING": "Sentiloj",
    "CATEGORY_OPERATORS": "Operatoroj",
    "CATEGORY_VARIABLES": "Variabloj",
    "CATEGORY_MYBLOCKS": "Miaj Blokoj",
    "DUPLICATE": "Krei kopion",
    "DELETE": "Forigi",
    "ADD_COMMENT": "Aldoni komenton",
    "REMOVE_COMMENT": "Forigi komenton",
    "DELETE_BLOCK": "Forigi blokon",
    "DELETE_X_BLOCKS": "Forigi %1 blokojn",
    "DELETE_ALL_BLOCKS": "Ĉu forigi ĉiujn %1 blokojn?",
    "CLEAN_UP": "Ordigi blokojn",
    "HELP": "Helpo",
    "UNDO": "Malfari",
    "REDO": "Refari",
    "EDIT_PROCEDURE": "Redakti",
    "SHOW_PROCEDURE_DEFINITION": "Iri al difino",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Skribu ion...",
    "COLOUR_HUE_LABEL": "Koloro",
    "COLOUR_SATURATION_LABEL": "Satureco",
    "COLOUR_BRIGHTNESS_LABEL": "Heleco",
    "CHANGE_VALUE_TITLE": "Ŝanĝi valoron:",
    "RENAME_VARIABLE": "Renomi variablon",
    "RENAME_VARIABLE_TITLE": "Renomi ĉiujn \"%1\"-variablojn al:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renomi variablon",
    "NEW_VARIABLE": "Krei variablon",
    "NEW_VARIABLE_TITLE": "Nova nomo de variablo:",
    "VARIABLE_MODAL_TITLE": "Nova variablo",
    "VARIABLE_ALREADY_EXISTS": "Variablo nomita \"%1\" jam ekzistas.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Variablo nomita \"%1\" jam ekzistas por alia variablo de typo \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Ĉu vi volas forigi %1 uzojn de la variablo \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Ne eblas forigi la variablon \"%1\" ĉar ĝi uziĝas en la difino de la funkcio \"%2\"",
    "DELETE_VARIABLE": "Forigi la variablon \"%1\"",
    "NEW_PROCEDURE": "Krei blokon",
    "PROCEDURE_ALREADY_EXISTS": "Proceduro nomita \"%1\" jam ekzistas.",
    "PROCEDURE_DEFAULT_NAME": "nomo de bloko",
    "PROCEDURE_USED": "Antaŭ ol forigi difinon de iu bloko, vi devas unue forigi ĉiun uzon de la bloko",
    "NEW_LIST": "Krei liston",
    "NEW_LIST_TITLE": "Nomo de la nova listo:",
    "LIST_MODAL_TITLE": "Nova listo",
    "LIST_ALREADY_EXISTS": "Listo nomita \"%1\" jam ekzistas.",
    "RENAME_LIST_TITLE": "Renomi ĉiujn \"%1\"-listojn al:",
    "RENAME_LIST_MODAL_TITLE": "Renomi liston",
    "DEFAULT_LIST_ITEM": "tion ĉi",
    "DELETE_LIST": "Forigi la liston \"%1\"",
    "RENAME_LIST": "Renomi liston",
    "NEW_BROADCAST_MESSAGE": "Nova mesaĝo",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nomo de nova mesaĝo:",
    "BROADCAST_MODAL_TITLE": "Nova mesaĝo",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mesaĝo1"
  },
  "eu": {
    "CONTROL_FOREVER": "etengabe",
    "CONTROL_REPEAT": "errepikatu %1 aldiz",
    "CONTROL_IF": "baldin %1 orduan",
    "CONTROL_ELSE": "bestela",
    "CONTROL_STOP": "gelditu",
    "CONTROL_STOP_ALL": "dena",
    "CONTROL_STOP_THIS": "script hau",
    "CONTROL_STOP_OTHER": "pertsonaiaren beste script batzuk",
    "CONTROL_WAIT": "itxaron %1 segundo",
    "CONTROL_WAITUNTIL": "itxaron %1 arte ",
    "CONTROL_REPEATUNTIL": "errepikatu %1 arte",
    "CONTROL_WHILE": "%1 den bitartean",
    "CONTROL_FOREACH": "%2 ko %1 bakoitzeko ",
    "CONTROL_STARTASCLONE": "klon moduan hasten naizenean",
    "CONTROL_CREATECLONEOF": "sortu %1 ren klona",
    "CONTROL_CREATECLONEOF_MYSELF": "nire burua",
    "CONTROL_DELETETHISCLONE": "ezabatu klon hau ",
    "CONTROL_COUNTER": "kontagailua",
    "CONTROL_INCRCOUNTER": "gehitu kontagailuan",
    "CONTROL_CLEARCOUNTER": "berrabiarazi kontagailua ",
    "CONTROL_ALLATONCE": "denak batera",
    "DATA_SETVARIABLETO": "ezarri %1: %2 ",
    "DATA_CHANGEVARIABLEBY": "aldatu %1 %2 unitate",
    "DATA_SHOWVARIABLE": "erakutsi %1 aldagaia ",
    "DATA_HIDEVARIABLE": "ezkutatu %1 aldagaia",
    "DATA_ADDTOLIST": "batu %1 %2 ri",
    "DATA_DELETEOFLIST": "ezabatu %1 %2 tik",
    "DATA_DELETEALLOFLIST": "ezabatu %1-ko guztia",
    "DATA_INSERTATLIST": "txertatu %1  %3 -ren %2 -an",
    "DATA_REPLACEITEMOFLIST": "aldatu %2 -ko %1 elementua %3 -rekin ",
    "DATA_ITEMOFLIST": "%2 tik %1. elementua",
    "DATA_ITEMNUMOFLIST": "%1 tik #. elementua %2 n",
    "DATA_LENGTHOFLIST": "%1 ren luzera",
    "DATA_LISTCONTAINSITEM": "%1 k bere baitan al du %2?",
    "DATA_SHOWLIST": "erakutsi %1 zerrenda",
    "DATA_HIDELIST": "ezkutatu %1 zerrenda",
    "DATA_INDEX_ALL": "dena",
    "DATA_INDEX_LAST": "azkena",
    "DATA_INDEX_RANDOM": "ausazkoa",
    "EVENT_WHENFLAGCLICKED": "%1 klik egitean",
    "EVENT_WHENTHISSPRITECLICKED": "pertsonai honetan klik egitean",
    "EVENT_WHENSTAGECLICKED": "Eszenan klik egitean",
    "EVENT_WHENTOUCHINGOBJECT": "pertsonai honek %1 ukitzen duenean",
    "EVENT_WHENBROADCASTRECEIVED": "%1 jasotzean",
    "EVENT_WHENBACKDROPSWITCHESTO": "atzeko oihala %1 ra aldatzen denean",
    "EVENT_WHENGREATERTHAN": "%1  > %2 bada",
    "EVENT_WHENGREATERTHAN_TIMER": "kronometroa",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ozentasuna",
    "EVENT_BROADCAST": "bidali %1 guztiei",
    "EVENT_BROADCASTANDWAIT": "bidali %1 guztiei eta itxaron",
    "EVENT_WHENKEYPRESSED": "%1 tekla sakatzean",
    "EVENT_WHENKEYPRESSED_SPACE": "zuriunea",
    "EVENT_WHENKEYPRESSED_LEFT": "ezkerrera gezia",
    "EVENT_WHENKEYPRESSED_RIGHT": "eskuinera gezia",
    "EVENT_WHENKEYPRESSED_DOWN": "behera gezia",
    "EVENT_WHENKEYPRESSED_UP": "gora gezia",
    "EVENT_WHENKEYPRESSED_ANY": "edozein",
    "LOOKS_SAYFORSECS": "esan %1 %2 segundoz",
    "LOOKS_SAY": "esan %1",
    "LOOKS_HELLO": "Kaixo!",
    "LOOKS_THINKFORSECS": "pentsatu %1  %2 segundoz",
    "LOOKS_THINK": "pentsatu %1",
    "LOOKS_HMM": "Mmm...",
    "LOOKS_SHOW": "erakutsi",
    "LOOKS_HIDE": "ezkutatu",
    "LOOKS_HIDEALLSPRITES": "ezkutatu pertsonai guztiak ",
    "LOOKS_EFFECT_COLOR": "kolorea",
    "LOOKS_EFFECT_FISHEYE": "arrain-begia",
    "LOOKS_EFFECT_WHIRL": "zurrunbiloa",
    "LOOKS_EFFECT_PIXELATE": "pixelatu",
    "LOOKS_EFFECT_MOSAIC": "mosaikoa",
    "LOOKS_EFFECT_BRIGHTNESS": "distira",
    "LOOKS_EFFECT_GHOST": "mamua",
    "LOOKS_CHANGEEFFECTBY": "aldatu %1 efektua %2 unitate",
    "LOOKS_SETEFFECTTO": "ezarri %1 efektua %2 ri ",
    "LOOKS_CLEARGRAPHICEFFECTS": "kendu efektu grafikoak ",
    "LOOKS_CHANGESIZEBY": "aldatu tamaina %1 unitate",
    "LOOKS_SETSIZETO": "ezarri tamaina: % %1",
    "LOOKS_SIZE": "tamaina",
    "LOOKS_CHANGESTRETCHBY": "aldatu luzaketa %1 unitate",
    "LOOKS_SETSTRETCHTO": "ezarri luzera: % %1",
    "LOOKS_SWITCHCOSTUMETO": "aldatu tankera %1 ra ",
    "LOOKS_NEXTCOSTUME": "hurrengo tankera",
    "LOOKS_SWITCHBACKDROPTO": "aldatu atzeko oihala %1 ra ",
    "LOOKS_GOTOFRONTBACK": "joan %1 geruzara ",
    "LOOKS_GOTOFRONTBACK_FRONT": "aurrealdeko",
    "LOOKS_GOTOFRONTBACK_BACK": "atzealdeko",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "joan %1 geruza %2",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "aurrealdera",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "atzealdera",
    "LOOKS_BACKDROPNUMBERNAME": "%1 atzeko oihala",
    "LOOKS_COSTUMENUMBERNAME": "%1 tankera",
    "LOOKS_NUMBERNAME_NUMBER": "zenbakia",
    "LOOKS_NUMBERNAME_NAME": "izena",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "aldatu atzeko oihala %1 ra eta itxaron",
    "LOOKS_NEXTBACKDROP_BLOCK": "hurrengo atzeko oihala",
    "LOOKS_NEXTBACKDROP": "hurrengo atzeko oihala",
    "LOOKS_PREVIOUSBACKDROP": "aurreko atzeko oihala",
    "LOOKS_RANDOMBACKDROP": "ausazko atzeko oihala",
    "MOTION_MOVESTEPS": "mugitu %1 pausu ",
    "MOTION_TURNLEFT": "biratu %1 %2 gradu",
    "MOTION_TURNRIGHT": "biratu %1 %2 gradu",
    "MOTION_POINTINDIRECTION": "apuntatu norabidea: %1",
    "MOTION_POINTTOWARDS": "jarri hona begira: %1",
    "MOTION_POINTTOWARDS_POINTER": "saguaren erakuslea",
    "MOTION_POINTTOWARDS_RANDOM": "ausazko norabidea",
    "MOTION_GOTO": "joan hona %1",
    "MOTION_GOTO_POINTER": "saguaren erakuslea",
    "MOTION_GOTO_RANDOM": "ausazko kokapena",
    "MOTION_GOTOXY": "joan x: %1 y: %2 kokapenera ",
    "MOTION_GLIDESECSTOXY": "Irristatu %1 segundotan hona x: %2 y: %3",
    "MOTION_GLIDETO": "Irristatu %1 segundotan hona: %2",
    "MOTION_GLIDETO_POINTER": "saguaren erakuslea",
    "MOTION_GLIDETO_RANDOM": "ausazko kokapena",
    "MOTION_CHANGEXBY": "aldatu x %1 unitate",
    "MOTION_SETX": "ezarri x: %1",
    "MOTION_CHANGEYBY": "aldatu y %1 unitate",
    "MOTION_SETY": "ezarri y: %1",
    "MOTION_IFONEDGEBOUNCE": "errebotatu ertza ukitzean ",
    "MOTION_SETROTATIONSTYLE": "ezarri biraketa modua: %1 ",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "ezker-eskuin",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ez biratu",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "norabide guztietara",
    "MOTION_XPOSITION": "x kokapena",
    "MOTION_YPOSITION": "y kokapena",
    "MOTION_DIRECTION": "norabidea",
    "MOTION_SCROLLRIGHT": "korritu eskuinera %1",
    "MOTION_SCROLLUP": "korritu gora %1",
    "MOTION_ALIGNSCENE": "lerrokatu %1 eszena",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "behean ezkerrean",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "behean eskuinean",
    "MOTION_ALIGNSCENE_MIDDLE": "erdian",
    "MOTION_ALIGNSCENE_TOPLEFT": "goian ezkerrean",
    "MOTION_ALIGNSCENE_TOPRIGHT": "goian eskuinean",
    "MOTION_XSCROLL": "korritu x",
    "MOTION_YSCROLL": "korritu y",
    "MOTION_STAGE_SELECTED": "Hautatutako eszena: ez dago mugimendurako blokerik",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 eta %2 arteko ausazko balioa",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 eta %2",
    "OPERATORS_OR": "%1 edo %2",
    "OPERATORS_NOT": "%1 ez",
    "OPERATORS_JOIN": "elkartu %1 %2 rekin",
    "OPERATORS_JOIN_APPLE": "sagarra",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "%1. letra %2 tik",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "%1 ren luzera",
    "OPERATORS_CONTAINS": "%1(e)k bere baitan al du %2?",
    "OPERATORS_MOD": "%1 modulu %2",
    "OPERATORS_ROUND": "biribildu %1",
    "OPERATORS_MATHOP": " %2 tik %1",
    "OPERATORS_MATHOP_ABS": "balio absolutu",
    "OPERATORS_MATHOP_FLOOR": "zoru-funtzioa",
    "OPERATORS_MATHOP_CEILING": "sabai-funtzioa",
    "OPERATORS_MATHOP_SQRT": "erro karratua",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definitu %1",
    "SENSING_TOUCHINGOBJECT": "%1 ukitzen?",
    "SENSING_TOUCHINGOBJECT_POINTER": "saguaren erakuslea",
    "SENSING_TOUCHINGOBJECT_EDGE": "ertza",
    "SENSING_TOUCHINGCOLOR": "%1 kolorea ukitzen?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 koloreak %2 ukitzen du?",
    "SENSING_DISTANCETO": "%1 rako distantzia",
    "SENSING_DISTANCETO_POINTER": "saguaren erakuslea",
    "SENSING_ASKANDWAIT": "galdetu %1 eta itxaron",
    "SENSING_ASK_TEXT": "Nola duzu izena?",
    "SENSING_ANSWER": "erantzuna",
    "SENSING_KEYPRESSED": "%1 tekla sakatuta?",
    "SENSING_MOUSEDOWN": "sagua sakatuta?",
    "SENSING_MOUSEX": "saguaren x",
    "SENSING_MOUSEY": "saguaren y",
    "SENSING_SETDRAGMODE": "ezarri arrastea %1 moduan",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastagarria",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "arrastaezina",
    "SENSING_LOUDNESS": "ozentasuna",
    "SENSING_LOUD": "ozen?",
    "SENSING_TIMER": "kronometroa",
    "SENSING_RESETTIMER": "berrabiarazi kronometroa",
    "SENSING_OF": "%2 tik %1",
    "SENSING_OF_XPOSITION": "x kokapena",
    "SENSING_OF_YPOSITION": "y kokapena",
    "SENSING_OF_DIRECTION": "norabidea",
    "SENSING_OF_COSTUMENUMBER": "# tankera",
    "SENSING_OF_COSTUMENAME": "tankeraren izena",
    "SENSING_OF_SIZE": "tamaina",
    "SENSING_OF_VOLUME": "bolumena",
    "SENSING_OF_BACKDROPNUMBER": "# atzeko oihala",
    "SENSING_OF_BACKDROPNAME": "atzeko oihalaren izena",
    "SENSING_OF_STAGE": "Eszena",
    "SENSING_CURRENT": "oraingo %1",
    "SENSING_CURRENT_YEAR": "urtea",
    "SENSING_CURRENT_MONTH": "hilabetea",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "asteko eguna",
    "SENSING_CURRENT_HOUR": "ordua",
    "SENSING_CURRENT_MINUTE": "minutua",
    "SENSING_CURRENT_SECOND": "segundoa",
    "SENSING_DAYSSINCE2000": "2000tik geroztiko egunak",
    "SENSING_USERNAME": "erabiltzaile-izena",
    "SENSING_USERID": "erabiltzaile-id",
    "SOUND_PLAY": "hasi %1 soinua",
    "SOUND_PLAYUNTILDONE": "jo %1 soinua amaitu arte",
    "SOUND_STOPALLSOUNDS": "gelditu soinu guztiak",
    "SOUND_SETEFFECTO": "ezarri %1 efektua: %2",
    "SOUND_CHANGEEFFECTBY": "aldatu %1 efektua %2 unitate",
    "SOUND_CLEAREFFECTS": "kendu soinu-efektuak",
    "SOUND_EFFECTS_PITCH": "tonua",
    "SOUND_EFFECTS_PAN": "ezker/eskuin balantzea",
    "SOUND_CHANGEVOLUMEBY": "aldatu bolumena %1 unitate",
    "SOUND_SETVOLUMETO": "ezarri bolumena: %1%",
    "SOUND_VOLUME": "bolumena",
    "SOUND_RECORD": "grabatu...",
    "CATEGORY_MOTION": "Mugimendua",
    "CATEGORY_LOOKS": "Itxura",
    "CATEGORY_SOUND": "Soinua",
    "CATEGORY_EVENTS": "Gertaerak",
    "CATEGORY_CONTROL": "Kontrola",
    "CATEGORY_SENSING": "Sentsoreak",
    "CATEGORY_OPERATORS": "Eragileak",
    "CATEGORY_VARIABLES": "Aldagaiak",
    "CATEGORY_MYBLOCKS": "Nire blokeak",
    "DUPLICATE": "Bikoiztu",
    "DELETE": "Ezabatu",
    "ADD_COMMENT": "Gehitu iruzkina",
    "REMOVE_COMMENT": "Kendu iruzkina",
    "DELETE_BLOCK": "Ezabatu blokea",
    "DELETE_X_BLOCKS": "Ezabatu %1 bloke",
    "DELETE_ALL_BLOCKS": "Ezabatu %1 blokeak?",
    "CLEAN_UP": "Kendu blokeak",
    "HELP": "Laguntza",
    "UNDO": "Desegin",
    "REDO": "Berregin",
    "EDIT_PROCEDURE": "Editatu",
    "SHOW_PROCEDURE_DEFINITION": "Joan definiziora",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Esan zerbait...",
    "COLOUR_HUE_LABEL": "Kolorea",
    "COLOUR_SATURATION_LABEL": "Asetasuna",
    "COLOUR_BRIGHTNESS_LABEL": "Distira",
    "CHANGE_VALUE_TITLE": "Aldatu balioa:",
    "RENAME_VARIABLE": "Aldatu izena aldagaiari",
    "RENAME_VARIABLE_TITLE": "Aldatu izenak \"%1\" aldagaiei honela:",
    "RENAME_VARIABLE_MODAL_TITLE": "Aldatu izena aldagaiari",
    "NEW_VARIABLE": "Sortu aldagai bat",
    "NEW_VARIABLE_TITLE": "Aldagai berriaren izena:",
    "VARIABLE_MODAL_TITLE": "Aldagai berria",
    "VARIABLE_ALREADY_EXISTS": "\"%1\" izeneko aldagaia badago lehendik.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "\"%2\" motako beste aldagai batek badu lehendik \"%1\" izena.",
    "DELETE_VARIABLE_CONFIRMATION": "Ezabatu \"%2\" aldagaiaren %1 erabilerak?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Ezin da \"%1\" aldagaia ezabatu \"%2\" funtzioaren definizioan parte hartzen duelako.",
    "DELETE_VARIABLE": "Ezabatu \"%1\" aldagaia",
    "NEW_PROCEDURE": "Sortu bloke bat",
    "PROCEDURE_ALREADY_EXISTS": "\"%1\" izeneko prozedura badago lehendik.",
    "PROCEDURE_DEFAULT_NAME": "blokearen izena",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Sortu zerrenda bat",
    "NEW_LIST_TITLE": "Zerrenda berriaren izena:",
    "LIST_MODAL_TITLE": "Zerrenda berria",
    "LIST_ALREADY_EXISTS": "\"%1\" izeneko zerrenda badago lehendik.",
    "RENAME_LIST_TITLE": "Aldatu izenak \"%1\" zerrendei honela:",
    "RENAME_LIST_MODAL_TITLE": "Aldatu izena zerrendari",
    "DEFAULT_LIST_ITEM": "gauza",
    "DELETE_LIST": "Ezabatu \"%1\" zerrenda",
    "RENAME_LIST": "Aldatu izena zerrendari",
    "NEW_BROADCAST_MESSAGE": "Mezu berria",
    "NEW_BROADCAST_MESSAGE_TITLE": "Mezu berriaren izena:",
    "BROADCAST_MODAL_TITLE": "Mezu berria",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mezua1"
  },
  "fa": {
    "CONTROL_FOREVER": "برای همیشه",
    "CONTROL_REPEAT": "تکرار کن %1",
    "CONTROL_IF": "اگر %1 آنگاه",
    "CONTROL_ELSE": "وگرنه",
    "CONTROL_STOP": "توقف",
    "CONTROL_STOP_ALL": "همه",
    "CONTROL_STOP_THIS": "این برنامه",
    "CONTROL_STOP_OTHER": "سایر برنامه‌های این شکلک",
    "CONTROL_WAIT": "منتظر بمان %1 ثانیه",
    "CONTROL_WAITUNTIL": "منتظر بمان تا اینکه %1",
    "CONTROL_REPEATUNTIL": "تکرار کن تا اینکه %1",
    "CONTROL_WHILE": "هنگامی‌که %1 ",
    "CONTROL_FOREACH": "برای هر %1 در %2",
    "CONTROL_STARTASCLONE": "وقتی‌ به‌عنوان یک مشابه شروع کردم",
    "CONTROL_CREATECLONEOF": "مشابه %1 را بساز",
    "CONTROL_CREATECLONEOF_MYSELF": "خودم",
    "CONTROL_DELETETHISCLONE": "این مشابه را حذف کن",
    "CONTROL_COUNTER": "شمارنده",
    "CONTROL_INCRCOUNTER": "افزایش شمارنده",
    "CONTROL_CLEARCOUNTER": "شمارنده را پاک کن",
    "CONTROL_ALLATONCE": "همه در یک‌بار ",
    "DATA_SETVARIABLETO": "%1 برابر %2 شود",
    "DATA_CHANGEVARIABLEBY": "تغییر %1 به اندازه %2 تا",
    "DATA_SHOWVARIABLE": "متغیر %1 را نمایش بده",
    "DATA_HIDEVARIABLE": "متغیر %1 را پنهان کن",
    "DATA_ADDTOLIST": "افزودن  %1 به %2",
    "DATA_DELETEOFLIST": "حذف %1 از %2",
    "DATA_DELETEALLOFLIST": "حذف همه‌ از %1",
    "DATA_INSERTATLIST": "درج %1 در %2 %3",
    "DATA_REPLACEITEMOFLIST": "جایگزینی ردیف %1 %2 با %3",
    "DATA_ITEMOFLIST": "ردیف %1 در %2",
    "DATA_ITEMNUMOFLIST": "# ردیف %1 در %2",
    "DATA_LENGTHOFLIST": "طول %1",
    "DATA_LISTCONTAINSITEM": "در %1 %2 هست؟",
    "DATA_SHOWLIST": "لیست %1 را نمایش بده",
    "DATA_HIDELIST": "لیست %1 را پنهان کن",
    "DATA_INDEX_ALL": "همه",
    "DATA_INDEX_LAST": "آخرین",
    "DATA_INDEX_RANDOM": "تصادفی",
    "EVENT_WHENFLAGCLICKED": "وقتی‌ %1 کلیک شد",
    "EVENT_WHENTHISSPRITECLICKED": "وقتی‌ این شکلک کلیک شد",
    "EVENT_WHENSTAGECLICKED": "وقتی‌ صحنه کلیک شد",
    "EVENT_WHENTOUCHINGOBJECT": "وقتی‌ این شکلک به %1 خورد",
    "EVENT_WHENBROADCASTRECEIVED": "وقتی‌ %1 را دریافت کردم",
    "EVENT_WHENBACKDROPSWITCHESTO": "وقتی‌ پس‌زمینه به %1 تغییر کرد",
    "EVENT_WHENGREATERTHAN": "وقتی‌ %2 < %1 شد",
    "EVENT_WHENGREATERTHAN_TIMER": "زمان سنج",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "بلندی صدا",
    "EVENT_BROADCAST": "پخش سراسری %1",
    "EVENT_BROADCASTANDWAIT": "پخش سراسری %1 و منتظر بمان",
    "EVENT_WHENKEYPRESSED": "وقتی‌ کلید %1 فشرده شد",
    "EVENT_WHENKEYPRESSED_SPACE": "فاصله",
    "EVENT_WHENKEYPRESSED_LEFT": "جهت چپ",
    "EVENT_WHENKEYPRESSED_RIGHT": "جهت راست",
    "EVENT_WHENKEYPRESSED_DOWN": "جهت پایین",
    "EVENT_WHENKEYPRESSED_UP": "جهت بالا",
    "EVENT_WHENKEYPRESSED_ANY": "هر",
    "LOOKS_SAYFORSECS": "بگو %1 به مدت %2 ثانیه",
    "LOOKS_SAY": "بگو %1",
    "LOOKS_HELLO": "سلام",
    "LOOKS_THINKFORSECS": "فکر کن به %1 به مدت %2 ثانیه",
    "LOOKS_THINK": "فکر کن به %1",
    "LOOKS_HMM": "اوهومم",
    "LOOKS_SHOW": "ظاهر شو",
    "LOOKS_HIDE": "پنهان شو",
    "LOOKS_HIDEALLSPRITES": "همه‌ی شکلک‌ها را پنهان کن",
    "LOOKS_EFFECT_COLOR": "رنگ",
    "LOOKS_EFFECT_FISHEYE": "چشم ماهی",
    "LOOKS_EFFECT_WHIRL": "گردابی",
    "LOOKS_EFFECT_PIXELATE": "شطرنجی",
    "LOOKS_EFFECT_MOSAIC": "موزاييکی",
    "LOOKS_EFFECT_BRIGHTNESS": "روشنایی",
    "LOOKS_EFFECT_GHOST": "شبح",
    "LOOKS_CHANGEEFFECTBY": "تغییر جلوه‌ی %1 به اندازه %2 تا",
    "LOOKS_SETEFFECTTO": "جلوه‌ی %1 %2 شود",
    "LOOKS_CLEARGRAPHICEFFECTS": "جلوه‌های گرافیکی را پاک کن",
    "LOOKS_CHANGESIZEBY": "تغییر اندازه به مقدار %1 تا",
    "LOOKS_SETSIZETO": "اندازه  %  %1 شود",
    "LOOKS_SIZE": "اندازه",
    "LOOKS_CHANGESTRETCHBY": "تغییر کشیدگی به اندازه %1 تا",
    "LOOKS_SETSTRETCHTO": "کشیدگی % %1 شود",
    "LOOKS_SWITCHCOSTUMETO": "تغییر حالت به %1",
    "LOOKS_NEXTCOSTUME": "حالت بعدی",
    "LOOKS_SWITCHBACKDROPTO": "تغییر پس‌زمینه به %1",
    "LOOKS_GOTOFRONTBACK": "برو به %1 لایه",
    "LOOKS_GOTOFRONTBACK_FRONT": "اولین",
    "LOOKS_GOTOFRONTBACK_BACK": "آخرین",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "برو %2 لایه %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "جلوتر",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "عقب‌تر",
    "LOOKS_BACKDROPNUMBERNAME": " %1 پس‌زمینه‌",
    "LOOKS_COSTUMENUMBERNAME": "%1 حالت",
    "LOOKS_NUMBERNAME_NUMBER": "شماره‌ی",
    "LOOKS_NUMBERNAME_NAME": "نام",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "تغییر پس‌زمینه به %1 و منتظر بمان",
    "LOOKS_NEXTBACKDROP_BLOCK": "پس‌زمینه‌ی بعدی",
    "LOOKS_NEXTBACKDROP": "پس‌زمینه‌ی بعدی",
    "LOOKS_PREVIOUSBACKDROP": "پس‌زمینه‌ی قبلی",
    "LOOKS_RANDOMBACKDROP": "پس‌زمینه‌ی تصادفی",
    "MOTION_MOVESTEPS": "حرکت کن  %1 گام",
    "MOTION_TURNLEFT": "بچرخ %1 %2 درجه",
    "MOTION_TURNRIGHT": "بچرخ %1 %2 درجه",
    "MOTION_POINTINDIRECTION": "در جهت %1 قرار بگیر",
    "MOTION_POINTTOWARDS": "به سمت %1 قرار بگیر",
    "MOTION_POINTTOWARDS_POINTER": "اشاره‌گر ماوس",
    "MOTION_POINTTOWARDS_RANDOM": "جهت تصافی",
    "MOTION_GOTO": "برو به %1",
    "MOTION_GOTO_POINTER": "اشاره‌گر ماوس",
    "MOTION_GOTO_RANDOM": "مکان تصادفی",
    "MOTION_GOTOXY": "برو به x: %1 و y: %2 ",
    "MOTION_GLIDESECSTOXY": "سر بخور در %1 ثانیه به x: %2 و y: %3",
    "MOTION_GLIDETO": "سر بخور در %1 ثانیه به %2",
    "MOTION_GLIDETO_POINTER": "اشاره‌گر ماوس",
    "MOTION_GLIDETO_RANDOM": "مکان تصادفی",
    "MOTION_CHANGEXBY": "تغییر x به اندازه %1 تا",
    "MOTION_SETX": "x برابر %1 شود",
    "MOTION_CHANGEYBY": "تغییر y به اندازه %1 تا",
    "MOTION_SETY": "y برابر %1 شود",
    "MOTION_IFONEDGEBOUNCE": "اگر به لبه رسیدی، برگرد",
    "MOTION_SETROTATIONSTYLE": "حالت گردش %1 شود",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "چپ-راست",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "گردش ممنوع",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "همه طرف",
    "MOTION_XPOSITION": "مکان x",
    "MOTION_YPOSITION": "مکان y",
    "MOTION_DIRECTION": "جهت",
    "MOTION_SCROLLRIGHT": "%1 به راست پیمایش کن",
    "MOTION_SCROLLUP": "%1 به بالا پیمایش کن",
    "MOTION_ALIGNSCENE": "تراز کردن صحنه %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "پایین - چپ",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "پایین - راست",
    "MOTION_ALIGNSCENE_MIDDLE": "وسط",
    "MOTION_ALIGNSCENE_TOPLEFT": "بالا - چپ",
    "MOTION_ALIGNSCENE_TOPRIGHT": "بالا - راست",
    "MOTION_XSCROLL": "پیمایش x",
    "MOTION_YSCROLL": "پیمایش y",
    "MOTION_STAGE_SELECTED": "صحنه‌ انتخاب‌ شده‌ است: گروه حرکت خالی است",
    "OPERATORS_ADD": "%2 + %1",
    "OPERATORS_SUBTRACT": "%2 - %1",
    "OPERATORS_MULTIPLY": "%2 * %1",
    "OPERATORS_DIVIDE": "%2 / %1",
    "OPERATORS_RANDOM": "انتخاب تصادفی بین %1 تا %2",
    "OPERATORS_GT": "%2 < %1",
    "OPERATORS_LT": "%2 > %1",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 و %2",
    "OPERATORS_OR": "%1 یا %2",
    "OPERATORS_NOT": "چنین نیست که %1",
    "OPERATORS_JOIN": "چسباندن %1 به %2",
    "OPERATORS_JOIN_APPLE": "سیب",
    "OPERATORS_JOIN_BANANA": "موز",
    "OPERATORS_LETTEROF": "حرف %1 %2",
    "OPERATORS_LETTEROF_APPLE": "ی",
    "OPERATORS_LENGTH": "طول %1",
    "OPERATORS_CONTAINS": "در %1 %2 هست؟",
    "OPERATORS_MOD": "باقیمانده‌ی تقسیم %1 بر %2",
    "OPERATORS_ROUND": "گرد شده‌ی %1",
    "OPERATORS_MATHOP": "%1 عدد %2",
    "OPERATORS_MATHOP_ABS": "قدر مطلق",
    "OPERATORS_MATHOP_FLOOR": "جزء صحیح",
    "OPERATORS_MATHOP_CEILING": "سقف",
    "OPERATORS_MATHOP_SQRT": "جذر",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e به توان",
    "OPERATORS_MATHOP_10EXP": "۱۰ به توان",
    "PROCEDURES_DEFINITION": "تعریف %1",
    "SENSING_TOUCHINGOBJECT": "خوردی به %1 ؟",
    "SENSING_TOUCHINGOBJECT_POINTER": "اشاره‌گر ماوس",
    "SENSING_TOUCHINGOBJECT_EDGE": "لبه",
    "SENSING_TOUCHINGCOLOR": "خوردی به رنگ %1 ؟",
    "SENSING_COLORISTOUCHINGCOLOR": "رنگ %1 به %2 خورد؟",
    "SENSING_DISTANCETO": "فاصله تا %1",
    "SENSING_DISTANCETO_POINTER": "اشاره‌گر ماوس",
    "SENSING_ASKANDWAIT": "بپرس %1 و منتظر بمان",
    "SENSING_ASK_TEXT": "اسم شما چیه؟",
    "SENSING_ANSWER": "پاسخ",
    "SENSING_KEYPRESSED": "کلید %1 فشرده شده؟",
    "SENSING_MOUSEDOWN": "دکمه‌ی ماوس پایین نگه داشته شده؟",
    "SENSING_MOUSEX": "مکان x ماوس",
    "SENSING_MOUSEY": "مکان y ماوس",
    "SENSING_SETDRAGMODE": "قابل جابه‌جا کردن با ماوس  %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "باشد",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "نباشد",
    "SENSING_LOUDNESS": "بلندی صدا",
    "SENSING_LOUD": "صدا بلند است؟",
    "SENSING_TIMER": "زمان سنج",
    "SENSING_RESETTIMER": "بازنشانی زمان سنج",
    "SENSING_OF": "%1 %2",
    "SENSING_OF_XPOSITION": "مکان x",
    "SENSING_OF_YPOSITION": "مکان y",
    "SENSING_OF_DIRECTION": "جهت",
    "SENSING_OF_COSTUMENUMBER": " # حالت",
    "SENSING_OF_COSTUMENAME": "نام حالت",
    "SENSING_OF_SIZE": "اندازه‌ی",
    "SENSING_OF_VOLUME": "بلندی صدای",
    "SENSING_OF_BACKDROPNUMBER": " # پس‌زمینه‌ی",
    "SENSING_OF_BACKDROPNAME": "نام پس‌زمینه‌ی",
    "SENSING_OF_STAGE": "صحنه",
    "SENSING_CURRENT": "همین %1",
    "SENSING_CURRENT_YEAR": "سال",
    "SENSING_CURRENT_MONTH": "ماه",
    "SENSING_CURRENT_DATE": "تاریخ",
    "SENSING_CURRENT_DAYOFWEEK": "روز هفته",
    "SENSING_CURRENT_HOUR": "ساعت",
    "SENSING_CURRENT_MINUTE": "دقیقه",
    "SENSING_CURRENT_SECOND": "ثانیه",
    "SENSING_DAYSSINCE2000": "تعداد روز‌ها از سال ۲۰۰۰ میلادی تا کنون",
    "SENSING_USERNAME": "نام کاربری",
    "SENSING_USERID": "شناسه‌ی کاربر",
    "SOUND_PLAY": "شروع صدای %1",
    "SOUND_PLAYUNTILDONE": "پخش صدای %1 تا انتها",
    "SOUND_STOPALLSOUNDS": "همه‌ی صدا‌ها را متوقف کن",
    "SOUND_SETEFFECTO": "افکت %1 %2 شود",
    "SOUND_CHANGEEFFECTBY": "تغییر افکت %1 به اندازه %2 تا",
    "SOUND_CLEAREFFECTS": "افکت‌های صدا را پاک کن",
    "SOUND_EFFECTS_PITCH": "زیری یا بمی",
    "SOUND_EFFECTS_PAN": "پخش صدا از چپ/راست",
    "SOUND_CHANGEVOLUMEBY": "تغییر بلندی صدا به اندازه %1 تا",
    "SOUND_SETVOLUMETO": "بلندی صدا % %1 شود",
    "SOUND_VOLUME": "بلندی صدا",
    "SOUND_RECORD": "ضبط صدا...",
    "CATEGORY_MOTION": "حرکت",
    "CATEGORY_LOOKS": "ظاهر‌",
    "CATEGORY_SOUND": "صدا",
    "CATEGORY_EVENTS": "رویدادها",
    "CATEGORY_CONTROL": "کنترل",
    "CATEGORY_SENSING": "تشخیص",
    "CATEGORY_OPERATORS": "عملگرها",
    "CATEGORY_VARIABLES": "متغیرها",
    "CATEGORY_MYBLOCKS": "قطعه‌های من",
    "DUPLICATE": "تکثیر",
    "DELETE": "حذف",
    "ADD_COMMENT": "افزودن یادداشت",
    "REMOVE_COMMENT": "حذف یادداشت",
    "DELETE_BLOCK": "حذف قطعه",
    "DELETE_X_BLOCKS": "حذف هر %1 قطعه‌",
    "DELETE_ALL_BLOCKS": "همه‌ی %1 قطعه حذف شوند؟",
    "CLEAN_UP": "مرتب کردن قطعه‌ها",
    "HELP": "راهنما",
    "UNDO": "واگـرد",
    "REDO": "باز انجام",
    "EDIT_PROCEDURE": "ویرایش",
    "SHOW_PROCEDURE_DEFINITION": "برو به تعریف",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "چیزی بگو...",
    "COLOUR_HUE_LABEL": "رنگ",
    "COLOUR_SATURATION_LABEL": "شدت رنگ",
    "COLOUR_BRIGHTNESS_LABEL": "روشنایی",
    "CHANGE_VALUE_TITLE": "تغییر مقدار:",
    "RENAME_VARIABLE": "تغییر نام متغیر",
    "RENAME_VARIABLE_TITLE": "تغییر نام همه‌‌‌ی متغیر‌های «%1» به:",
    "RENAME_VARIABLE_MODAL_TITLE": "تغییر نام متغیر",
    "NEW_VARIABLE": "ایجاد یک متغیر",
    "NEW_VARIABLE_TITLE": "نام متغیر جدید:",
    "VARIABLE_MODAL_TITLE": "متغیر جدید",
    "VARIABLE_ALREADY_EXISTS": "متغیری با نام «%1» هم‌ اکنون وجود دارد.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "هم‌ اکنون متغیری به نام «%1» برای متغیر دیگری از نوع «%2» وجود دارد.",
    "DELETE_VARIABLE_CONFIRMATION": "آیا هر %1 موردی که از متغیر «%2» استفاده شده است، حذف شود؟",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "امکان حذف متغیر «%1» نیست. زیرا جزئی از تعریف تابع «%2» است",
    "DELETE_VARIABLE": "حذف متغیر «%1»",
    "NEW_PROCEDURE": "ایجاد یک قطعه",
    "PROCEDURE_ALREADY_EXISTS": "هم اکنون روالی به اسم «%1» وجود دارد.",
    "PROCEDURE_DEFAULT_NAME": "نام قطعه",
    "PROCEDURE_USED": "برای حذف قطعه تعریف، ابتدا باید آن را در هر جایی که استفاده شده است، حذف کنید",
    "NEW_LIST": "ایجاد یک لیست",
    "NEW_LIST_TITLE": "نام لیست جدید:",
    "LIST_MODAL_TITLE": "لیست جدید",
    "LIST_ALREADY_EXISTS": "هم اکنون لیستی به نام «%1» وجود دارد.",
    "RENAME_LIST_TITLE": "تغییر نام همه‌ی لیست‌های «%1» به:",
    "RENAME_LIST_MODAL_TITLE": "تغییر نام لیست",
    "DEFAULT_LIST_ITEM": "چیز",
    "DELETE_LIST": "حذف لیست «%1»",
    "RENAME_LIST": "تغییر نام لیست",
    "NEW_BROADCAST_MESSAGE": "پیام جدید",
    "NEW_BROADCAST_MESSAGE_TITLE": "نام پیام جدید:",
    "BROADCAST_MODAL_TITLE": "پیام جدید",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "پیام 1"
  },
  "fil": {
    "CONTROL_FOREVER": "kailanman",
    "CONTROL_REPEAT": "ulitin nang %1",
    "CONTROL_IF": "kung %1 edi",
    "CONTROL_ELSE": "kundi",
    "CONTROL_STOP": "itigil",
    "CONTROL_STOP_ALL": "lahat",
    "CONTROL_STOP_THIS": "script na ito",
    "CONTROL_STOP_OTHER": "ibang script sa sprite",
    "CONTROL_WAIT": "maghintay nang %1 (na) segundo",
    "CONTROL_WAITUNTIL": "maghintay hanggang %1",
    "CONTROL_REPEATUNTIL": "ulitin hanggang %1",
    "CONTROL_WHILE": "habang %1",
    "CONTROL_FOREACH": "sa bawat %1 sa %2",
    "CONTROL_STARTASCLONE": "kapag clone ako nagsimula",
    "CONTROL_CREATECLONEOF": "gumawa ng clone ng %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ako",
    "CONTROL_DELETETHISCLONE": "tanggalin ang clone na ito",
    "CONTROL_COUNTER": "counter",
    "CONTROL_INCRCOUNTER": "increment counter",
    "CONTROL_CLEARCOUNTER": "linisin ang counter",
    "CONTROL_ALLATONCE": "sabay-sabay",
    "DATA_SETVARIABLETO": "itakda ang %1 bilang %2",
    "DATA_CHANGEVARIABLEBY": "palitan ang %1 ng %2",
    "DATA_SHOWVARIABLE": "ipakita ang variable na %1",
    "DATA_HIDEVARIABLE": "itago ang variable na %1",
    "DATA_ADDTOLIST": "idagdag ang %1 sa %2",
    "DATA_DELETEOFLIST": "burahin ang %1 ng %2",
    "DATA_DELETEALLOFLIST": "burahin lahat ng %1",
    "DATA_INSERTATLIST": "isingit ang %1 sa %2 ng %3",
    "DATA_REPLACEITEMOFLIST": "palitan ang item na %1 ng %2 ng %3",
    "DATA_ITEMOFLIST": "item na %1 ng %2",
    "DATA_ITEMNUMOFLIST": "# ng item na %1 sa %2",
    "DATA_LENGTHOFLIST": "haba ng %1",
    "DATA_LISTCONTAINSITEM": "may %2 ang %1?",
    "DATA_SHOWLIST": "ipakita ang listahan na %1",
    "DATA_HIDELIST": "itago ang listahan na %1",
    "DATA_INDEX_ALL": "lahat",
    "DATA_INDEX_LAST": "huli",
    "DATA_INDEX_RANDOM": "kahit ano",
    "EVENT_WHENFLAGCLICKED": "kapag pinindot ang %1",
    "EVENT_WHENTHISSPRITECLICKED": "kapag pinindot ang sprite na ito",
    "EVENT_WHENSTAGECLICKED": "kapag pinindot ang stage",
    "EVENT_WHENTOUCHINGOBJECT": "kapag tumama ang sprite na ito sa %1",
    "EVENT_WHENBROADCASTRECEIVED": "kapag natanggap ko ang %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "kapag lumipat ang likod sa %1",
    "EVENT_WHENGREATERTHAN": "kapag %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "timer",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ingay",
    "EVENT_BROADCAST": "iulat ang %1",
    "EVENT_BROADCASTANDWAIT": "iulat ang %1 at maghintay",
    "EVENT_WHENKEYPRESSED": "kapag pinindot ang key na %1",
    "EVENT_WHENKEYPRESSED_SPACE": "space",
    "EVENT_WHENKEYPRESSED_LEFT": "kaliwang arrow",
    "EVENT_WHENKEYPRESSED_RIGHT": "kanang arrow",
    "EVENT_WHENKEYPRESSED_DOWN": "pababang arrow",
    "EVENT_WHENKEYPRESSED_UP": "pataas na arrow",
    "EVENT_WHENKEYPRESSED_ANY": "anuman",
    "LOOKS_SAYFORSECS": "sabihin ang %1 nang %2 (na) segundo",
    "LOOKS_SAY": "sabihin ang %1",
    "LOOKS_HELLO": "Kamusta!",
    "LOOKS_THINKFORSECS": "isipin ang %1 nang %2 (na) segundo",
    "LOOKS_THINK": "isipin ang %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "ipakita",
    "LOOKS_HIDE": "itago",
    "LOOKS_HIDEALLSPRITES": "itago lahat ng sprite",
    "LOOKS_EFFECT_COLOR": "kulay",
    "LOOKS_EFFECT_FISHEYE": "fisheye",
    "LOOKS_EFFECT_WHIRL": "ipo-ipo",
    "LOOKS_EFFECT_PIXELATE": "pixelate",
    "LOOKS_EFFECT_MOSAIC": "mosaic",
    "LOOKS_EFFECT_BRIGHTNESS": "liwanag",
    "LOOKS_EFFECT_GHOST": "multo",
    "LOOKS_CHANGEEFFECTBY": "baguhin ang epektong %1 nang %2",
    "LOOKS_SETEFFECTTO": "itakda ang epektong %1 bilang %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "tanggalin lahat ng graphic effects",
    "LOOKS_CHANGESIZEBY": "palitan ang laki nang %1",
    "LOOKS_SETSIZETO": "itakda ang laki nang %1",
    "LOOKS_SIZE": "laki",
    "LOOKS_CHANGESTRETCHBY": "palitan ang banat nang %1",
    "LOOKS_SETSTRETCHTO": "itakda ang banat nang %1 %",
    "LOOKS_SWITCHCOSTUMETO": "palitan ang costume ng %1",
    "LOOKS_NEXTCOSTUME": "susunod na costume",
    "LOOKS_SWITCHBACKDROPTO": "palitan ang likod ng %1",
    "LOOKS_GOTOFRONTBACK": "pumunta sa layer na %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "harap",
    "LOOKS_GOTOFRONTBACK_BACK": "likod",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "pumunta %1 nang %2 na layer",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "sa harap",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "sa likod",
    "LOOKS_BACKDROPNUMBERNAME": "likod na %1",
    "LOOKS_COSTUMENUMBERNAME": "costume na %1",
    "LOOKS_NUMBERNAME_NUMBER": "bilang",
    "LOOKS_NUMBERNAME_NAME": "pangalan",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "palitan ang likod ng %1 at maghintay",
    "LOOKS_NEXTBACKDROP_BLOCK": "susunod na likod",
    "LOOKS_NEXTBACKDROP": "susunod na likod",
    "LOOKS_PREVIOUSBACKDROP": "nakaraang likod",
    "LOOKS_RANDOMBACKDROP": "kahit anong likod",
    "MOTION_MOVESTEPS": "gumalaw nang %1 (na) hakbang",
    "MOTION_TURNLEFT": "umikot %1 nang %2 (na) digri",
    "MOTION_TURNRIGHT": "umikot %1 nang %2 (na) digri",
    "MOTION_POINTINDIRECTION": "humarap sa direksyong %1",
    "MOTION_POINTTOWARDS": "humarap patungong %1",
    "MOTION_POINTTOWARDS_POINTER": "mouse pointer",
    "MOTION_POINTTOWARDS_RANDOM": "kahit anong direksyon",
    "MOTION_GOTO": "pumunta sa %1",
    "MOTION_GOTO_POINTER": "mouse pointer",
    "MOTION_GOTO_RANDOM": "kahit anong direksyon",
    "MOTION_GOTOXY": "pumunta sa x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "dumulas nang %1 (na) seg. papuntang x: %2 y: %3",
    "MOTION_GLIDETO": "dumulas nang %1 (na) seg. papuntang %2",
    "MOTION_GLIDETO_POINTER": "mouse pointer",
    "MOTION_GLIDETO_RANDOM": "kahit anong direksyon",
    "MOTION_CHANGEXBY": "palitan ang x ng %1",
    "MOTION_SETX": "itakda ang x bilang %1",
    "MOTION_CHANGEYBY": "palitan ang y ng %1",
    "MOTION_SETY": "itakda ang y bilang %1",
    "MOTION_IFONEDGEBOUNCE": "kung nasa gilid, tumalbog",
    "MOTION_SETROTATIONSTYLE": "itakda ang estilo ng pag-ikot %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "kaliwa-kanan",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "wag umikot",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "lahatan",
    "MOTION_XPOSITION": "posisyong x",
    "MOTION_YPOSITION": "posisyong y",
    "MOTION_DIRECTION": "direksyon",
    "MOTION_SCROLLRIGHT": "i-scroll pakanan nang %1",
    "MOTION_SCROLLUP": "i-scroll pataas nang %1",
    "MOTION_ALIGNSCENE": "ihanay ang eksena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "babang kaliwa",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "babang kanan",
    "MOTION_ALIGNSCENE_MIDDLE": "gitna",
    "MOTION_ALIGNSCENE_TOPLEFT": "taas na kaliwa",
    "MOTION_ALIGNSCENE_TOPRIGHT": "taas na kanan",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "Napiling stage: walang motion block",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "pumili ng kahit ano mula %1 hanggang %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 at %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "hindi %1",
    "OPERATORS_JOIN": "ipagsama ang %1 %2",
    "OPERATORS_JOIN_APPLE": "mansanas",
    "OPERATORS_JOIN_BANANA": "saging",
    "OPERATORS_LETTEROF": "titik %1 ng %2",
    "OPERATORS_LETTEROF_APPLE": "m",
    "OPERATORS_LENGTH": "haba ng %1",
    "OPERATORS_CONTAINS": "may %2 ang %1?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "i-round ang %1",
    "OPERATORS_MATHOP": "%1 ng %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "floor",
    "OPERATORS_MATHOP_CEILING": "ceiling",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "i-define ang %1",
    "SENSING_TOUCHINGOBJECT": "tinatamaan ang %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "mouse pointer",
    "SENSING_TOUCHINGOBJECT_EDGE": "gilid",
    "SENSING_TOUCHINGCOLOR": "tinatamaan ang kulay %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "tinatamaan ang %2 ng kulay na %1?",
    "SENSING_DISTANCETO": "layo sa %1",
    "SENSING_DISTANCETO_POINTER": "mouse pointer",
    "SENSING_ASKANDWAIT": "magtanong ng %1 at maghintay",
    "SENSING_ASK_TEXT": "Ano ang pangalan mo?",
    "SENSING_ANSWER": "sagot",
    "SENSING_KEYPRESSED": "napindot ang key na %1?",
    "SENSING_MOUSEDOWN": "nakapindot?",
    "SENSING_MOUSEX": "mouse x",
    "SENSING_MOUSEY": "mouse y",
    "SENSING_SETDRAGMODE": "itakda ang drag mode bilang %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "nahihila",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "di-nahihila",
    "SENSING_LOUDNESS": "lakas",
    "SENSING_LOUD": "malakas?",
    "SENSING_TIMER": "timer",
    "SENSING_RESETTIMER": "i-reset ang timer",
    "SENSING_OF": "%1 ng %2",
    "SENSING_OF_XPOSITION": "posisyong x",
    "SENSING_OF_YPOSITION": "posisyong y",
    "SENSING_OF_DIRECTION": "direksyon",
    "SENSING_OF_COSTUMENUMBER": "costume #",
    "SENSING_OF_COSTUMENAME": "pangalan ng costume",
    "SENSING_OF_SIZE": "laki",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "likod #",
    "SENSING_OF_BACKDROPNAME": "pangalan ng likod",
    "SENSING_OF_STAGE": "Stage",
    "SENSING_CURRENT": "kasalukuyang %1",
    "SENSING_CURRENT_YEAR": "taon",
    "SENSING_CURRENT_MONTH": "buwan",
    "SENSING_CURRENT_DATE": "petsa",
    "SENSING_CURRENT_DAYOFWEEK": "araw ng linggo",
    "SENSING_CURRENT_HOUR": "oras",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "segundo",
    "SENSING_DAYSSINCE2000": "araw simula noong 2000",
    "SENSING_USERNAME": "username",
    "SENSING_USERID": "user id",
    "SOUND_PLAY": "simulan ang tunog na %1",
    "SOUND_PLAYUNTILDONE": "i-play ang tunog na %1 hanggang matapos",
    "SOUND_STOPALLSOUNDS": "itigil ang lahat ng tunog",
    "SOUND_SETEFFECTO": "itakda ang epektong %1 bilang %2",
    "SOUND_CHANGEEFFECTBY": "baguhin ang epektong %1 nang %2",
    "SOUND_CLEAREFFECTS": "tanggalin lahat ng sound effects",
    "SOUND_EFFECTS_PITCH": "tinis",
    "SOUND_EFFECTS_PAN": "i-pan kaliwa/kanan",
    "SOUND_CHANGEVOLUMEBY": "palitan ang volume nang %1",
    "SOUND_SETVOLUMETO": "itakda ang volume bilang %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "mag-record...",
    "CATEGORY_MOTION": "Galaw",
    "CATEGORY_LOOKS": "Hitsura",
    "CATEGORY_SOUND": "Tunog",
    "CATEGORY_EVENTS": "Pangyayari",
    "CATEGORY_CONTROL": "Kontrol",
    "CATEGORY_SENSING": "Pakiramdam",
    "CATEGORY_OPERATORS": "Mga Operator",
    "CATEGORY_VARIABLES": "Mga Variable",
    "CATEGORY_MYBLOCKS": "Mga Block Ko",
    "DUPLICATE": "Doblehin",
    "DELETE": "Burahin",
    "ADD_COMMENT": "Magkomento",
    "REMOVE_COMMENT": "Tanggalin ang Komento",
    "DELETE_BLOCK": "Tanggalin ang Block",
    "DELETE_X_BLOCKS": "Magtanggal ng %1 (na) Block",
    "DELETE_ALL_BLOCKS": "Tanggalin lahat ng %1 (na) block?",
    "CLEAN_UP": "Linisin ang mga Block",
    "HELP": "Tulong",
    "UNDO": "I-undo",
    "REDO": "I-redo",
    "EDIT_PROCEDURE": "Baguhin",
    "SHOW_PROCEDURE_DEFINITION": "Pumunta sa definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Magsalita...",
    "COLOUR_HUE_LABEL": "Kulay",
    "COLOUR_SATURATION_LABEL": "Tingkad",
    "COLOUR_BRIGHTNESS_LABEL": "Liwanag",
    "CHANGE_VALUE_TITLE": "Baguhin ang value:",
    "RENAME_VARIABLE": "I-rename ang variable",
    "RENAME_VARIABLE_TITLE": "I-rename lahat ng \"%1\" na variable sa:",
    "RENAME_VARIABLE_MODAL_TITLE": "I-rename ang Variable",
    "NEW_VARIABLE": "Gumawa ng Variable",
    "NEW_VARIABLE_TITLE": "Pangalan ng bagong variable:",
    "VARIABLE_MODAL_TITLE": "Bagong Variable",
    "VARIABLE_ALREADY_EXISTS": "Meron na'ng variable na \"%1\".",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Meron na'ng variable na \"%1\" para sa ibang variable na may type na \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Tanggalin ang %1 (na) paggamit ng \"%2\" na variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Di mabura ang variable na \"%1\" dahil parte ito ng kahulugan para sa function na \"%2\"",
    "DELETE_VARIABLE": "Burahin ang variable na \"%1\"",
    "NEW_PROCEDURE": "Gumawa ng Block",
    "PROCEDURE_ALREADY_EXISTS": "Meron na'ng procedure na \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "pangalan ng block",
    "PROCEDURE_USED": "Para burahin ang kahulugan ng isang block, tanggalin muna ang lahat ng paggamit sa naturang block.",
    "NEW_LIST": "Gumawa ng Listahan",
    "NEW_LIST_TITLE": "Pangalan ng bagong listahan:",
    "LIST_MODAL_TITLE": "Bagong Listahan",
    "LIST_ALREADY_EXISTS": "Meron na'ng listahan na \"%1\".",
    "RENAME_LIST_TITLE": "I-rename lahat ng mga listahan na \"%1\" ng:",
    "RENAME_LIST_MODAL_TITLE": "I-rename ang Listahan",
    "DEFAULT_LIST_ITEM": "bagay",
    "DELETE_LIST": "Burahin ang listahang \"%1\"",
    "RENAME_LIST": "I-rename ang listahan",
    "NEW_BROADCAST_MESSAGE": "Bagong mensahe",
    "NEW_BROADCAST_MESSAGE_TITLE": "Pangalan ng bagong mensahe:",
    "BROADCAST_MODAL_TITLE": "Bagong Mensahe",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mensahe1"
  },
  "fr": {
    "CONTROL_FOREVER": "répéter indéfiniment",
    "CONTROL_REPEAT": "répéter %1 fois",
    "CONTROL_IF": "si %1 alors",
    "CONTROL_ELSE": "sinon",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "tout",
    "CONTROL_STOP_THIS": "ce script",
    "CONTROL_STOP_OTHER": "autres scripts dans sprite",
    "CONTROL_WAIT": "attendre %1 secondes",
    "CONTROL_WAITUNTIL": "attendre jusqu'à ce que %1",
    "CONTROL_REPEATUNTIL": "répéter jusqu'à ce que %1",
    "CONTROL_WHILE": "tant que %1",
    "CONTROL_FOREACH": "pour chaque %1 dans %2",
    "CONTROL_STARTASCLONE": "quand je commence comme un clone",
    "CONTROL_CREATECLONEOF": "créer un clone de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "moi-même",
    "CONTROL_DELETETHISCLONE": "supprimer ce clone",
    "CONTROL_COUNTER": "compteur",
    "CONTROL_INCRCOUNTER": "incrémenter le compteur",
    "CONTROL_CLEARCOUNTER": "effacer le compteur",
    "CONTROL_ALLATONCE": "tous en même temps",
    "DATA_SETVARIABLETO": "mettre %1 à %2",
    "DATA_CHANGEVARIABLEBY": "ajouter %2 à %1",
    "DATA_SHOWVARIABLE": "montrer la variable %1",
    "DATA_HIDEVARIABLE": "cacher la variable %1",
    "DATA_ADDTOLIST": "ajouter %1 à %2",
    "DATA_DELETEOFLIST": "supprimer l'élément %1 de %2",
    "DATA_DELETEALLOFLIST": "supprimer tous les éléments de la liste %1",
    "DATA_INSERTATLIST": "insérer %1 en position %2 de %3",
    "DATA_REPLACEITEMOFLIST": "remplacer l'élément %1 de la liste %2 par %3",
    "DATA_ITEMOFLIST": "élément %1 de %2",
    "DATA_ITEMNUMOFLIST": "position de %1 dans %2",
    "DATA_LENGTHOFLIST": "longueur de %1",
    "DATA_LISTCONTAINSITEM": "%1 contient %2 ?",
    "DATA_SHOWLIST": "montrer la liste %1",
    "DATA_HIDELIST": "cacher la liste %1",
    "DATA_INDEX_ALL": "tout",
    "DATA_INDEX_LAST": "dernier",
    "DATA_INDEX_RANDOM": "au hasard",
    "EVENT_WHENFLAGCLICKED": "quand %1 est cliqué",
    "EVENT_WHENTHISSPRITECLICKED": "quand ce sprite est cliqué",
    "EVENT_WHENSTAGECLICKED": "quand la scène est cliquée",
    "EVENT_WHENTOUCHINGOBJECT": "quand ce sprite touche %1",
    "EVENT_WHENBROADCASTRECEIVED": "quand je reçois %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "quand l'arrière-plan bascule sur %1",
    "EVENT_WHENGREATERTHAN": "quand le %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "chronomètre",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "volume sonore",
    "EVENT_BROADCAST": "envoyer à tous %1",
    "EVENT_BROADCASTANDWAIT": "envoyer à tous %1 et attendre",
    "EVENT_WHENKEYPRESSED": "quand la touche %1 est pressée",
    "EVENT_WHENKEYPRESSED_SPACE": "espace",
    "EVENT_WHENKEYPRESSED_LEFT": "flèche gauche",
    "EVENT_WHENKEYPRESSED_RIGHT": "flèche droite",
    "EVENT_WHENKEYPRESSED_DOWN": "flèche bas",
    "EVENT_WHENKEYPRESSED_UP": "flèche haut",
    "EVENT_WHENKEYPRESSED_ANY": "n'importe laquelle",
    "LOOKS_SAYFORSECS": "dire %1 pendant %2 secondes",
    "LOOKS_SAY": "dire %1",
    "LOOKS_HELLO": "Bonjour !",
    "LOOKS_THINKFORSECS": "penser à %1 pendant %2 secondes",
    "LOOKS_THINK": "penser à %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "montrer",
    "LOOKS_HIDE": "cacher",
    "LOOKS_HIDEALLSPRITES": "cacher tous les sprites",
    "LOOKS_EFFECT_COLOR": "couleur",
    "LOOKS_EFFECT_FISHEYE": "fisheye",
    "LOOKS_EFFECT_WHIRL": "tourbillon",
    "LOOKS_EFFECT_PIXELATE": "pixeliser",
    "LOOKS_EFFECT_MOSAIC": "mosaïque",
    "LOOKS_EFFECT_BRIGHTNESS": "luminosité",
    "LOOKS_EFFECT_GHOST": "fantôme",
    "LOOKS_CHANGEEFFECTBY": "ajouter %2 à l'effet %1",
    "LOOKS_SETEFFECTTO": "mettre l'effet %1 à %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "annuler les effets graphiques",
    "LOOKS_CHANGESIZEBY": "ajouter %1 à la taille",
    "LOOKS_SETSIZETO": "mettre la taille à %1 % de la taille initiale",
    "LOOKS_SIZE": "taille",
    "LOOKS_CHANGESTRETCHBY": "ajouter %1 à l'étirement",
    "LOOKS_SETSTRETCHTO": "mettre l'étirement à %1 %",
    "LOOKS_SWITCHCOSTUMETO": "basculer sur le costume %1",
    "LOOKS_NEXTCOSTUME": "costume suivant",
    "LOOKS_SWITCHBACKDROPTO": "basculer sur l'arrière-plan %1",
    "LOOKS_GOTOFRONTBACK": "aller à l'%1 plan",
    "LOOKS_GOTOFRONTBACK_FRONT": "avant",
    "LOOKS_GOTOFRONTBACK_BACK": "arrière",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "déplacer de %2 plans vers l'%1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "avant",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "arrière",
    "LOOKS_BACKDROPNUMBERNAME": "%1 de l'arrière-plan",
    "LOOKS_COSTUMENUMBERNAME": "%1 du costume",
    "LOOKS_NUMBERNAME_NUMBER": "numéro",
    "LOOKS_NUMBERNAME_NAME": "nom",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "basculer sur l'arrière-plan %1 et attendre",
    "LOOKS_NEXTBACKDROP_BLOCK": "arrière-plan suivant",
    "LOOKS_NEXTBACKDROP": "arrière-plan suivant",
    "LOOKS_PREVIOUSBACKDROP": "arrière-plan précédent",
    "LOOKS_RANDOMBACKDROP": "arrière-plan aléatoire",
    "MOTION_MOVESTEPS": "avancer de %1 pas",
    "MOTION_TURNLEFT": "tourner %1 de %2 degrés",
    "MOTION_TURNRIGHT": "tourner %1 de %2 degrés",
    "MOTION_POINTINDIRECTION": "s'orienter à %1",
    "MOTION_POINTTOWARDS": "s'orienter vers %1",
    "MOTION_POINTTOWARDS_POINTER": "pointeur de souris",
    "MOTION_POINTTOWARDS_RANDOM": "direction aléatoire",
    "MOTION_GOTO": "aller à %1",
    "MOTION_GOTO_POINTER": "pointeur de souris",
    "MOTION_GOTO_RANDOM": "position aléatoire",
    "MOTION_GOTOXY": "aller à x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glisser en %1 secondes à x: %2 y: %3",
    "MOTION_GLIDETO": "glisser en %1 secondes à %2",
    "MOTION_GLIDETO_POINTER": "pointeur de souris",
    "MOTION_GLIDETO_RANDOM": "position aléatoire",
    "MOTION_CHANGEXBY": "ajouter %1 à x",
    "MOTION_SETX": "mettre x à %1",
    "MOTION_CHANGEYBY": "ajouter %1 à y",
    "MOTION_SETY": "mettre y à %1",
    "MOTION_IFONEDGEBOUNCE": "rebondir si le bord est atteint",
    "MOTION_SETROTATIONSTYLE": "fixer le sens de rotation %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "gauche-droite",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ne tourne pas",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "à 360°",
    "MOTION_XPOSITION": "abscisse x",
    "MOTION_YPOSITION": "ordonnée y",
    "MOTION_DIRECTION": "direction",
    "MOTION_SCROLLRIGHT": "défiler à droite de %1",
    "MOTION_SCROLLUP": "défiler en haut de %1",
    "MOTION_ALIGNSCENE": "aligner la scène %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "bas-gauche",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "bas-droite",
    "MOTION_ALIGNSCENE_MIDDLE": "milieu",
    "MOTION_ALIGNSCENE_TOPLEFT": "haut-gauche",
    "MOTION_ALIGNSCENE_TOPRIGHT": "haut-droite",
    "MOTION_XSCROLL": "défilement x",
    "MOTION_YSCROLL": "défilement y",
    "MOTION_STAGE_SELECTED": "Scène sélectionnée: pas de blocs de mouvement",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "nombre aléatoire entre %1 et %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 et %2",
    "OPERATORS_OR": "%1 ou %2",
    "OPERATORS_NOT": "non %1",
    "OPERATORS_JOIN": "regrouper %1 et %2",
    "OPERATORS_JOIN_APPLE": "pomme",
    "OPERATORS_JOIN_BANANA": "banane",
    "OPERATORS_LETTEROF": "lettre %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "p",
    "OPERATORS_LENGTH": "longueur de %1",
    "OPERATORS_CONTAINS": "%1 contient %2 ?",
    "OPERATORS_MOD": "%1 modulo %2",
    "OPERATORS_ROUND": "arrondi de %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "plancher",
    "OPERATORS_MATHOP_CEILING": "plafond",
    "OPERATORS_MATHOP_SQRT": "racine",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e^",
    "OPERATORS_MATHOP_10EXP": "10^",
    "PROCEDURES_DEFINITION": "définir %1",
    "SENSING_TOUCHINGOBJECT": "touche le %1 ?",
    "SENSING_TOUCHINGOBJECT_POINTER": "pointeur de souris",
    "SENSING_TOUCHINGOBJECT_EDGE": "bord",
    "SENSING_TOUCHINGCOLOR": "couleur %1 touchée ?",
    "SENSING_COLORISTOUCHINGCOLOR": "couleur %1 touche %2 ?",
    "SENSING_DISTANCETO": "distance de %1",
    "SENSING_DISTANCETO_POINTER": "pointeur de souris",
    "SENSING_ASKANDWAIT": "demander %1 et attendre",
    "SENSING_ASK_TEXT": "Quel est ton nom ?",
    "SENSING_ANSWER": "réponse",
    "SENSING_KEYPRESSED": "touche %1 pressée ?",
    "SENSING_MOUSEDOWN": "souris pressée ?",
    "SENSING_MOUSEX": "souris x",
    "SENSING_MOUSEY": "souris y",
    "SENSING_SETDRAGMODE": "mettre mode de glissement à %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "glissable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "non glissable",
    "SENSING_LOUDNESS": "volume sonore",
    "SENSING_LOUD": "fort ?",
    "SENSING_TIMER": "chronomètre",
    "SENSING_RESETTIMER": "réinitialiser le chronomètre",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "abscisse x",
    "SENSING_OF_YPOSITION": "ordonnée y",
    "SENSING_OF_DIRECTION": "direction",
    "SENSING_OF_COSTUMENUMBER": "numéro de costume",
    "SENSING_OF_COSTUMENAME": "nom du costume",
    "SENSING_OF_SIZE": "taille",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "numéro de l'arrière-plan",
    "SENSING_OF_BACKDROPNAME": "nom de l'arrière-plan",
    "SENSING_OF_STAGE": "la scène",
    "SENSING_CURRENT": "%1 actuelle",
    "SENSING_CURRENT_YEAR": "année",
    "SENSING_CURRENT_MONTH": "mois",
    "SENSING_CURRENT_DATE": "date",
    "SENSING_CURRENT_DAYOFWEEK": "jour de la semaine",
    "SENSING_CURRENT_HOUR": "heure",
    "SENSING_CURRENT_MINUTE": "minute",
    "SENSING_CURRENT_SECOND": "seconde",
    "SENSING_DAYSSINCE2000": "jours depuis 2000",
    "SENSING_USERNAME": "nom d'utilisateur",
    "SENSING_USERID": "id de l'utilisateur",
    "SOUND_PLAY": "jouer le son %1",
    "SOUND_PLAYUNTILDONE": "jouer le son %1 jusqu'au bout",
    "SOUND_STOPALLSOUNDS": "arrêter tous les sons",
    "SOUND_SETEFFECTO": "mettre l'effet %1 à %2",
    "SOUND_CHANGEEFFECTBY": "ajouter %2 à l'effet %1",
    "SOUND_CLEAREFFECTS": "annuler tous les effets sonores",
    "SOUND_EFFECTS_PITCH": "hauteur",
    "SOUND_EFFECTS_PAN": "stéréo gauche/droite",
    "SOUND_CHANGEVOLUMEBY": "ajouter %1 au volume",
    "SOUND_SETVOLUMETO": "mettre le volume à %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "enregistrer...",
    "CATEGORY_MOTION": "Mouvement",
    "CATEGORY_LOOKS": "Apparence",
    "CATEGORY_SOUND": "Son",
    "CATEGORY_EVENTS": "Événements",
    "CATEGORY_CONTROL": "Contrôle",
    "CATEGORY_SENSING": "Capteurs",
    "CATEGORY_OPERATORS": "Opérateurs",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "Mes Blocs",
    "DUPLICATE": "Dupliquer",
    "DELETE": "Supprimer",
    "ADD_COMMENT": "Ajouter un commentaire",
    "REMOVE_COMMENT": "Retirer le commentaire",
    "DELETE_BLOCK": "Supprimer le bloc",
    "DELETE_X_BLOCKS": "Supprimer %1 blocs",
    "DELETE_ALL_BLOCKS": "Supprimer tous les %1 blocs ?",
    "CLEAN_UP": "Nettoyer les blocs",
    "HELP": "Aide",
    "UNDO": "Restaurer",
    "REDO": "Refaire",
    "EDIT_PROCEDURE": "Modifier",
    "SHOW_PROCEDURE_DEFINITION": "Aller à la définition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Dire quelque chose...",
    "COLOUR_HUE_LABEL": "Couleur",
    "COLOUR_SATURATION_LABEL": "Saturation",
    "COLOUR_BRIGHTNESS_LABEL": "Luminosité",
    "CHANGE_VALUE_TITLE": "Changer la valeur :",
    "RENAME_VARIABLE": "Renommer la variable",
    "RENAME_VARIABLE_TITLE": "Renommer toutes les variables \"%1\" en :",
    "RENAME_VARIABLE_MODAL_TITLE": "Renommer la variable",
    "NEW_VARIABLE": "Créer une variable",
    "NEW_VARIABLE_TITLE": "Nouveau nom de la variable",
    "VARIABLE_MODAL_TITLE": "Nouvelle variable",
    "VARIABLE_ALREADY_EXISTS": "Une variable nommé \"%1\" existe déjà.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Une variable nommée \"%1\" existe déjà pour une autre variable de type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Supprimer %1 utilisations de la variable \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Impossible de supprimer la variable \"%1\" car elle fait partie de la définition de la fonction \"%2\"",
    "DELETE_VARIABLE": "Supprimer la variable \"%1\"",
    "NEW_PROCEDURE": "Créer un bloc",
    "PROCEDURE_ALREADY_EXISTS": "Une procédure nommée \"%1\" existe déjà.",
    "PROCEDURE_DEFAULT_NAME": "nom du bloc",
    "PROCEDURE_USED": "Pour supprimer la définition d'un bloc, supprimez d'abord toutes les utilisations de ce bloc",
    "NEW_LIST": "Créer une liste",
    "NEW_LIST_TITLE": "Nom de la nouvelle liste :",
    "LIST_MODAL_TITLE": "Nouvelle liste",
    "LIST_ALREADY_EXISTS": "Une liste nommée \"%1\" existe déjà.",
    "RENAME_LIST_TITLE": "Renommer toutes les listes \"%1\" en :",
    "RENAME_LIST_MODAL_TITLE": "Renommer la liste",
    "DEFAULT_LIST_ITEM": "chose",
    "DELETE_LIST": "Supprimer la liste \"%1\"",
    "RENAME_LIST": "Renommer la liste",
    "NEW_BROADCAST_MESSAGE": "Nouveau message",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nom du nouveau message :",
    "BROADCAST_MODAL_TITLE": "Nouveau message",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "message1"
  },
  "fy": {
    "CONTROL_FOREVER": "foar altyd",
    "CONTROL_REPEAT": "werhelje %1",
    "CONTROL_IF": "as %1 dan",
    "CONTROL_ELSE": "oars",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "alles",
    "CONTROL_STOP_THIS": "dit skript",
    "CONTROL_STOP_OTHER": "oare skripts yn sprite",
    "CONTROL_WAIT": "wachtsje %1 sekonden",
    "CONTROL_WAITUNTIL": "wachtsje oant %1",
    "CONTROL_REPEATUNTIL": "werhelje oant %1",
    "CONTROL_WHILE": "salang't %1",
    "CONTROL_FOREACH": "foar eltse %1 yn %2",
    "CONTROL_STARTASCLONE": "as ik begjin as in kloan",
    "CONTROL_CREATECLONEOF": "meitsje kloan fan %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mysels",
    "CONTROL_DELETETHISCLONE": "dizze kloan fuortsmite",
    "CONTROL_COUNTER": "teller",
    "CONTROL_INCRCOUNTER": "teller ferheegje",
    "CONTROL_CLEARCOUNTER": "teller opnij ynstelle",
    "CONTROL_ALLATONCE": "alles tagelyk",
    "DATA_SETVARIABLETO": "set %1 op %2",
    "DATA_CHANGEVARIABLEBY": "feroarje %1 mei %2",
    "DATA_SHOWVARIABLE": "toan fariabele %1",
    "DATA_HIDEVARIABLE": "ferstopje fariabele %1",
    "DATA_ADDTOLIST": "fergrutsje %1 nei %2",
    "DATA_DELETEOFLIST": "wiskje %1 fan %2",
    "DATA_DELETEALLOFLIST": "wiskje alles fan %1",
    "DATA_INSERTATLIST": "foegje %1 yn op %2 fan %3",
    "DATA_REPLACEITEMOFLIST": "ferfang ûnderdiel %1 fan %2 troch %3",
    "DATA_ITEMOFLIST": "ûnderdiel  %1 fan %2",
    "DATA_ITEMNUMOFLIST": "ûnderdiel # fan %1 yn %2",
    "DATA_LENGTHOFLIST": "lingte fan %1",
    "DATA_LISTCONTAINSITEM": "%1 befettet %2?",
    "DATA_SHOWLIST": "list %1 sjen litte",
    "DATA_HIDELIST": "list %1 ferbergje",
    "DATA_INDEX_ALL": "alles",
    "DATA_INDEX_LAST": "lêst",
    "DATA_INDEX_RANDOM": "willekeurich",
    "EVENT_WHENFLAGCLICKED": "as %1 klikt",
    "EVENT_WHENTHISSPRITECLICKED": "as dizze sprite klikt",
    "EVENT_WHENSTAGECLICKED": "as faze klikt",
    "EVENT_WHENTOUCHINGOBJECT": "as dizze sprite %1 oanrekket",
    "EVENT_WHENBROADCASTRECEIVED": "as ik %1 ûntfang",
    "EVENT_WHENBACKDROPSWITCHESTO": "as eftergrûn feroaret nei %1",
    "EVENT_WHENGREATERTHAN": "as %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "timer",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "lûdens",
    "EVENT_BROADCAST": "stjoer %1 út",
    "EVENT_BROADCASTANDWAIT": "stjoer %1 út en wachtsje",
    "EVENT_WHENKEYPRESSED": "as %1 toets yndrukt wurdt",
    "EVENT_WHENKEYPRESSED_SPACE": "spaasje",
    "EVENT_WHENKEYPRESSED_LEFT": "linker pylk",
    "EVENT_WHENKEYPRESSED_RIGHT": "rjochter pylk",
    "EVENT_WHENKEYPRESSED_DOWN": "pylkje nei ûnder",
    "EVENT_WHENKEYPRESSED_UP": " pylk omheech",
    "EVENT_WHENKEYPRESSED_ANY": "elk",
    "LOOKS_SAYFORSECS": "sis %1 foar %2 sekonden",
    "LOOKS_SAY": "sis %1",
    "LOOKS_HELLO": "Hoi!",
    "LOOKS_THINKFORSECS": "tink %1 foar %2 sekonden",
    "LOOKS_THINK": "tink %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "sjen litte",
    "LOOKS_HIDE": "ferstopje",
    "LOOKS_HIDEALLSPRITES": "ferstopje alle sprites",
    "LOOKS_EFFECT_COLOR": "kleur",
    "LOOKS_EFFECT_FISHEYE": "fiskeach",
    "LOOKS_EFFECT_WHIRL": "draai",
    "LOOKS_EFFECT_PIXELATE": "ferpiksel",
    "LOOKS_EFFECT_MOSAIC": "mozayk",
    "LOOKS_EFFECT_BRIGHTNESS": "helderheid",
    "LOOKS_EFFECT_GHOST": "spûk",
    "LOOKS_CHANGEEFFECTBY": "feroarje %1 effekt mei %2",
    "LOOKS_SETEFFECTTO": "stel %1 effekt yn op %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "grafyske effekten weromsette",
    "LOOKS_CHANGESIZEBY": "feroarje grutte mei %1",
    "LOOKS_SETSIZETO": "stel grutte yn op %1 %",
    "LOOKS_SIZE": "grutte",
    "LOOKS_CHANGESTRETCHBY": "wizigje rek troch %1",
    "LOOKS_SETSTRETCHTO": "stel rek yn op %1 %",
    "LOOKS_SWITCHCOSTUMETO": "wikselje kostúm nei %1",
    "LOOKS_NEXTCOSTUME": "folgjende kostúm",
    "LOOKS_SWITCHBACKDROPTO": "wikselje eftergrûn nei %1",
    "LOOKS_GOTOFRONTBACK": "gean nei %1 laach",
    "LOOKS_GOTOFRONTBACK_FRONT": "foarste",
    "LOOKS_GOTOFRONTBACK_BACK": "achterste",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "gean %1 %2 lagen",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "foarút",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "efterút",
    "LOOKS_BACKDROPNUMBERNAME": "eftergrûn %1",
    "LOOKS_COSTUMENUMBERNAME": "kostúm %1",
    "LOOKS_NUMBERNAME_NUMBER": "nûmer",
    "LOOKS_NUMBERNAME_NAME": "namme",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "wikselje dekôr nei %1 en wachtsje",
    "LOOKS_NEXTBACKDROP_BLOCK": "folgjende dekôr",
    "LOOKS_NEXTBACKDROP": "folgjende dekôr",
    "LOOKS_PREVIOUSBACKDROP": "foarige dekôr",
    "LOOKS_RANDOMBACKDROP": "willekeurige eftergrûn",
    "MOTION_MOVESTEPS": "ferpleats %1 stappen",
    "MOTION_TURNLEFT": "draai %1 %2 graden",
    "MOTION_TURNRIGHT": "draaie %1 %2 graden",
    "MOTION_POINTINDIRECTION": "wiis yn rjochting %1",
    "MOTION_POINTTOWARDS": "wiis nei %1",
    "MOTION_POINTTOWARDS_POINTER": "mûsoanwizer",
    "MOTION_POINTTOWARDS_RANDOM": "willekeurige rjochting",
    "MOTION_GOTO": "gean nei %1",
    "MOTION_GOTO_POINTER": "mûsoanwizer",
    "MOTION_GOTO_RANDOM": "willekeurige posysje",
    "MOTION_GOTOXY": "gean nei x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glydzje %1 sekonden nei x: %2 y: %3",
    "MOTION_GLIDETO": "glydzje %1 sekonden nei %2",
    "MOTION_GLIDETO_POINTER": "mûsoanwizer",
    "MOTION_GLIDETO_RANDOM": "willekeurige posysje",
    "MOTION_CHANGEXBY": "feroarje x mei %1",
    "MOTION_SETX": "stel x yn op %1",
    "MOTION_CHANGEYBY": "feroarje y mei %1",
    "MOTION_SETY": "stel y yn op %1",
    "MOTION_IFONEDGEBOUNCE": "as op 'e râne, stuiterje",
    "MOTION_SETROTATIONSTYLE": "stel rotaasjestyl %1 yn",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "links-rjochts",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "net draaie",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "oeral",
    "MOTION_XPOSITION": "x posysje",
    "MOTION_YPOSITION": "y posysje",
    "MOTION_DIRECTION": "rjochting",
    "MOTION_SCROLLRIGHT": "sko nei rjochts %1",
    "MOTION_SCROLLUP": "sko omheech %1",
    "MOTION_ALIGNSCENE": "sêne %1 lykstelle",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "linksûnder",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "rjochtsûnder",
    "MOTION_ALIGNSCENE_MIDDLE": "midden",
    "MOTION_ALIGNSCENE_TOPLEFT": "linksboppe",
    "MOTION_ALIGNSCENE_TOPRIGHT": "rjochtsboppe",
    "MOTION_XSCROLL": "x skowe",
    "MOTION_YSCROLL": "y skowe",
    "MOTION_STAGE_SELECTED": "Faze selektearre: gjin bewegingsblokken",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "kies willekeurich %1 oant %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 en %2",
    "OPERATORS_OR": "%1 of %2",
    "OPERATORS_NOT": "net %1",
    "OPERATORS_JOIN": "gearkomme mei %1 %2",
    "OPERATORS_JOIN_APPLE": "apel",
    "OPERATORS_JOIN_BANANA": "banaan",
    "OPERATORS_LETTEROF": "letter %1 fan %2",
    "OPERATORS_LETTEROF_APPLE": "in",
    "OPERATORS_LENGTH": "lingte fan %1",
    "OPERATORS_CONTAINS": "%1 befettet %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "likernôch %1",
    "OPERATORS_MATHOP": "%1 fan %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "flier",
    "OPERATORS_MATHOP_CEILING": "plafond",
    "OPERATORS_MATHOP_SQRT": "woartel",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definiearje %1",
    "SENSING_TOUCHINGOBJECT": "rekket %1 oan?",
    "SENSING_TOUCHINGOBJECT_POINTER": "mûsoanwizer",
    "SENSING_TOUCHINGOBJECT_EDGE": "râne",
    "SENSING_TOUCHINGCOLOR": "rekket kleur %1 oan?",
    "SENSING_COLORISTOUCHINGCOLOR": "kleur %1 rekket %2 oan?",
    "SENSING_DISTANCETO": "ôfstân nei %1",
    "SENSING_DISTANCETO_POINTER": "mûsoanwizer",
    "SENSING_ASKANDWAIT": "freegje %1 en wachtsje",
    "SENSING_ASK_TEXT": "Wat is dyn namme?",
    "SENSING_ANSWER": "antwurd",
    "SENSING_KEYPRESSED": "toets %1 yndrukt?",
    "SENSING_MOUSEDOWN": "mûs omleech?",
    "SENSING_MOUSEX": "mûs x",
    "SENSING_MOUSEY": "mûs y",
    "SENSING_SETDRAGMODE": "sleepmodus %1 ynstelle",
    "SENSING_SETDRAGMODE_DRAGGABLE": "sleepber",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "net sleepber",
    "SENSING_LOUDNESS": "lûdens",
    "SENSING_LOUD": "lûd?",
    "SENSING_TIMER": "timer",
    "SENSING_RESETTIMER": "weromsette timer",
    "SENSING_OF": "%1 fan %2",
    "SENSING_OF_XPOSITION": "posysje fan x",
    "SENSING_OF_YPOSITION": "posysje fan y",
    "SENSING_OF_DIRECTION": "rjochting",
    "SENSING_OF_COSTUMENUMBER": "kostúm #",
    "SENSING_OF_COSTUMENAME": "kostúmnamme",
    "SENSING_OF_SIZE": "grutte",
    "SENSING_OF_VOLUME": "folume",
    "SENSING_OF_BACKDROPNUMBER": "eftergrûn #",
    "SENSING_OF_BACKDROPNAME": "eftergrûn namme",
    "SENSING_OF_STAGE": "Faze",
    "SENSING_CURRENT": "aktueel %1",
    "SENSING_CURRENT_YEAR": "jier",
    "SENSING_CURRENT_MONTH": "moanne",
    "SENSING_CURRENT_DATE": "datum",
    "SENSING_CURRENT_DAYOFWEEK": "dei fan 'e wike",
    "SENSING_CURRENT_HOUR": "oere",
    "SENSING_CURRENT_MINUTE": "minút",
    "SENSING_CURRENT_SECOND": "sekonde",
    "SENSING_DAYSSINCE2000": "dagen sûnt 2000",
    "SENSING_USERNAME": "brûkersnamme",
    "SENSING_USERID": "brûkers-id",
    "SOUND_PLAY": "start lûd %1",
    "SOUND_PLAYUNTILDONE": "spylje lûd %1 oant ein",
    "SOUND_STOPALLSOUNDS": "stopje alle lûden",
    "SOUND_SETEFFECTO": "stel %1 effekt yn op %2",
    "SOUND_CHANGEEFFECTBY": "feroarje %1 effekt mei %2",
    "SOUND_CLEAREFFECTS": "opskjinje lûdseffekten",
    "SOUND_EFFECTS_PITCH": "toanhichte",
    "SOUND_EFFECTS_PAN": "ferskowe links/rjochts",
    "SOUND_CHANGEVOLUMEBY": "feroarje folume mei %1",
    "SOUND_SETVOLUMETO": "stel folume yn op %1%",
    "SOUND_VOLUME": "folume",
    "SOUND_RECORD": "opnimme...",
    "CATEGORY_MOTION": "Beweging",
    "CATEGORY_LOOKS": "Ferskining",
    "CATEGORY_SOUND": "Lûd",
    "CATEGORY_EVENTS": "Eveneminten",
    "CATEGORY_CONTROL": "Kontrôle",
    "CATEGORY_SENSING": "Gefoel",
    "CATEGORY_OPERATORS": "Bestjoerders",
    "CATEGORY_VARIABLES": "Fariabelen",
    "CATEGORY_MYBLOCKS": "Myn Blokken",
    "DUPLICATE": "Duplisearje",
    "DELETE": "Wiskje",
    "ADD_COMMENT": "Kommentaar tafoegje",
    "REMOVE_COMMENT": "Kommentaar fuortsmite",
    "DELETE_BLOCK": "Blok fuortsmite",
    "DELETE_X_BLOCKS": "%1 blokken wiskje",
    "DELETE_ALL_BLOCKS": "Alle %1 blokken wiskje?",
    "CLEAN_UP": "Blokken opromje",
    "HELP": "Help",
    "UNDO": "Ungedien meitsje",
    "REDO": "Op 'e nij dwaan",
    "EDIT_PROCEDURE": "Bewurkje",
    "SHOW_PROCEDURE_DEFINITION": "Gean nei definysje",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Sis wat ...",
    "COLOUR_HUE_LABEL": "Kleur",
    "COLOUR_SATURATION_LABEL": "Sêding",
    "COLOUR_BRIGHTNESS_LABEL": "Helderheid",
    "CHANGE_VALUE_TITLE": "Wizigje wearde:",
    "RENAME_VARIABLE": "Feroarje namme fan fariabele",
    "RENAME_VARIABLE_TITLE": "Feroarje de namme fan alle fariabelen \"%1\" nei:",
    "RENAME_VARIABLE_MODAL_TITLE": "Namme fan fariabele feroarje",
    "NEW_VARIABLE": "Meitsje in fariabele",
    "NEW_VARIABLE_TITLE": "Nije namme fan fariabele:",
    "VARIABLE_MODAL_TITLE": "Nije fariabele",
    "VARIABLE_ALREADY_EXISTS": "In fariabele mei de namme \"%1\" bestiet al.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "In fariabele mei de namme \"%1\" bestiet al foar in oare fariabele fan it type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "%1 ynstânsjes fan de fariabele \"%2\" fuortsmite?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Kin de fariabele \"%1\" net wiskje, om't it diel is fan 'e definysje fan' e funksje \"%2\"",
    "DELETE_VARIABLE": "Wiskje de fariabele \"%1\"",
    "NEW_PROCEDURE": "Meitsje in blok",
    "PROCEDURE_ALREADY_EXISTS": "In proseduere mei de namme \"%1\" bestiet al.",
    "PROCEDURE_DEFAULT_NAME": "bloknamme",
    "PROCEDURE_USED": "Om in blokdefinysje te wiskjen, ferwiderje earst alle gebrûk fan it blok",
    "NEW_LIST": "Meitsje in List",
    "NEW_LIST_TITLE": "Nije listnamme:",
    "LIST_MODAL_TITLE": "Nije List",
    "LIST_ALREADY_EXISTS": "In list mei de namme \"%1\" bestiet al.",
    "RENAME_LIST_TITLE": "Feroarje de namme fan alle listen \"%1\" nei:",
    "RENAME_LIST_MODAL_TITLE": "Namme fan de List feroarje",
    "DEFAULT_LIST_ITEM": "ding",
    "DELETE_LIST": "Smyt de list \"%1\" fuort",
    "RENAME_LIST": "Namme fan de List feroarje",
    "NEW_BROADCAST_MESSAGE": "Nij berjocht",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nije berjochttitel:",
    "BROADCAST_MODAL_TITLE": "Nij Berjocht",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "berjocht1"
  },
  "ga": {
    "CONTROL_FOREVER": "go deo",
    "CONTROL_REPEAT": "déan %1 uair",
    "CONTROL_IF": "más %1 ansin",
    "CONTROL_ELSE": "seachas sin",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "uile",
    "CONTROL_STOP_THIS": "an script seo",
    "CONTROL_STOP_OTHER": "scripteanna eile sa sprid",
    "CONTROL_WAIT": "fan %1 soicind",
    "CONTROL_WAITUNTIL": "fan go %1",
    "CONTROL_REPEATUNTIL": "athdhéan go %1",
    "CONTROL_WHILE": "chomh fada is %1",
    "CONTROL_FOREACH": "do gach %1 i %2",
    "CONTROL_STARTASCLONE": "nuair a thosaím mar chóip",
    "CONTROL_CREATECLONEOF": "cruthaigh cóip de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mise féin",
    "CONTROL_DELETETHISCLONE": "scrios an chóip seo",
    "CONTROL_COUNTER": "áiritheoir",
    "CONTROL_INCRCOUNTER": "incrimintigh an t-áiritheoir",
    "CONTROL_CLEARCOUNTER": "glan an t-áiritheoir",
    "CONTROL_ALLATONCE": "d'aon iarraidh",
    "DATA_SETVARIABLETO": "socraigh %1: %2",
    "DATA_CHANGEVARIABLEBY": "athraigh %1 de %2",
    "DATA_SHOWVARIABLE": "taispeáin athróg %1",
    "DATA_HIDEVARIABLE": "folaigh athróg %1",
    "DATA_ADDTOLIST": "cuir %1 le %2",
    "DATA_DELETEOFLIST": "scrios %1 as %2",
    "DATA_DELETEALLOFLIST": "scrios na %1 rud go léir",
    "DATA_INSERTATLIST": "ionsáigh %1 ag %2 i %3",
    "DATA_REPLACEITEMOFLIST": "cuir %3 in áit mír %1 i %2",
    "DATA_ITEMOFLIST": "mír %1 as %2",
    "DATA_ITEMNUMOFLIST": "mír # as %1 in %2",
    "DATA_LENGTHOFLIST": "fad %1",
    "DATA_LISTCONTAINSITEM": "%1 agus %2 ann?",
    "DATA_SHOWLIST": "taispeáin liosta %1",
    "DATA_HIDELIST": "folaigh liosta %1",
    "DATA_INDEX_ALL": "uile",
    "DATA_INDEX_LAST": "deireanach",
    "DATA_INDEX_RANDOM": "randamach",
    "EVENT_WHENFLAGCLICKED": "nuair a chliceáiltear %1",
    "EVENT_WHENTHISSPRITECLICKED": "nuair a chliceáiltear an sprid seo",
    "EVENT_WHENSTAGECLICKED": "nuair a chliceáiltear an stáitse",
    "EVENT_WHENTOUCHINGOBJECT": "nuair a theagmhaíonn an sprid seo le %1",
    "EVENT_WHENBROADCASTRECEIVED": "nuair a fhaighim %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "nuair a chuirtear %1 suas",
    "EVENT_WHENGREATERTHAN": "nuair atá %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "amadóir",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "treise",
    "EVENT_BROADCAST": "craol %1",
    "EVENT_BROADCASTANDWAIT": "craol %1 agus fan",
    "EVENT_WHENKEYPRESSED": "nuair a bhrúitear eochair %1",
    "EVENT_WHENKEYPRESSED_SPACE": "spás",
    "EVENT_WHENKEYPRESSED_LEFT": "saighead chlé",
    "EVENT_WHENKEYPRESSED_RIGHT": "saighead dheas",
    "EVENT_WHENKEYPRESSED_DOWN": "saighead síos",
    "EVENT_WHENKEYPRESSED_UP": "saighead suas",
    "EVENT_WHENKEYPRESSED_ANY": "ceann ar bith",
    "LOOKS_SAYFORSECS": "abair %1 ar feadh %2 soicind",
    "LOOKS_SAY": "abair %1",
    "LOOKS_HELLO": "Dia dhuit!",
    "LOOKS_THINKFORSECS": "smaoinigh %1 ar feadh %2 soicind",
    "LOOKS_THINK": "smaoinigh %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "taispeáin",
    "LOOKS_HIDE": "folaigh",
    "LOOKS_HIDEALLSPRITES": "folaigh gach sprid",
    "LOOKS_EFFECT_COLOR": "dath",
    "LOOKS_EFFECT_FISHEYE": "súil an éisc",
    "LOOKS_EFFECT_WHIRL": "rothlú",
    "LOOKS_EFFECT_PIXELATE": "picteilíniú",
    "LOOKS_EFFECT_MOSAIC": "mósáic",
    "LOOKS_EFFECT_BRIGHTNESS": "gile",
    "LOOKS_EFFECT_GHOST": "taibhse",
    "LOOKS_CHANGEEFFECTBY": "athraigh maisíocht %1 de %2",
    "LOOKS_SETEFFECTTO": "socraigh maisíocht %1: %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "glan na maisíochtaí grafaice",
    "LOOKS_CHANGESIZEBY": "athraigh an mhéid de %1",
    "LOOKS_SETSIZETO": "socraigh an mhéid: %1 %",
    "LOOKS_SIZE": "méid",
    "LOOKS_CHANGESTRETCHBY": "athraigh an síneadh de %1",
    "LOOKS_SETSTRETCHTO": "socraigh an síneadh: %1 %",
    "LOOKS_SWITCHCOSTUMETO": "athraigh an chulaith go %1",
    "LOOKS_NEXTCOSTUME": "an chéad chulaith eile",
    "LOOKS_SWITCHBACKDROPTO": "athraigh an cúlra go %1",
    "LOOKS_GOTOFRONTBACK": "téigh go dtí an tsraith %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "thosaigh",
    "LOOKS_GOTOFRONTBACK_BACK": "dheiridh",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "téigh %1 %2 sraith",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ar aghaidh",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "ar gcúl",
    "LOOKS_BACKDROPNUMBERNAME": "cúlra %1",
    "LOOKS_COSTUMENUMBERNAME": "culaith %1",
    "LOOKS_NUMBERNAME_NUMBER": "uimhir",
    "LOOKS_NUMBERNAME_NAME": "ainm",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "athraigh an cúlra go %1 agus fan",
    "LOOKS_NEXTBACKDROP_BLOCK": "an chéad chúlra eile",
    "LOOKS_NEXTBACKDROP": "an chéad chúlra eile",
    "LOOKS_PREVIOUSBACKDROP": "cúlra roimhe seo",
    "LOOKS_RANDOMBACKDROP": "cúlra randamach",
    "MOTION_MOVESTEPS": "bog %1 coiscéim",
    "MOTION_TURNLEFT": "rothlaigh %1 %2 céim",
    "MOTION_TURNRIGHT": "rothlaigh %1 %2 céim",
    "MOTION_POINTINDIRECTION": "tabhair aghaidh ar %1",
    "MOTION_POINTTOWARDS": "tabhair aghaidh i dtreo %1",
    "MOTION_POINTTOWARDS_POINTER": "pointeoir-luiche",
    "MOTION_POINTTOWARDS_RANDOM": "treo randamach",
    "MOTION_GOTO": "téigh go %1",
    "MOTION_GOTO_POINTER": "pointeoir-luiche",
    "MOTION_GOTO_RANDOM": "ionad randamach",
    "MOTION_GOTOXY": "téigh go x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "sleamhnaigh %1 soicind go x: %2 y: %3",
    "MOTION_GLIDETO": "sleamhnaigh %1 soicind go %2",
    "MOTION_GLIDETO_POINTER": "pointeoir-luiche",
    "MOTION_GLIDETO_RANDOM": "ionad randamach",
    "MOTION_CHANGEXBY": "athraigh x de %1",
    "MOTION_SETX": "socraigh x: %1",
    "MOTION_CHANGEYBY": "athraigh y de %1",
    "MOTION_SETY": "socraigh y: %1",
    "MOTION_IFONEDGEBOUNCE": "más ar an imeall, preab",
    "MOTION_SETROTATIONSTYLE": "socraigh an stíl rothlaithe: %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "clé-deas",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ná rothlaigh",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "timpeall ar fad",
    "MOTION_XPOSITION": "ionad x",
    "MOTION_YPOSITION": "ionad y",
    "MOTION_DIRECTION": "treo",
    "MOTION_SCROLLRIGHT": "scrollaigh ar dheis %1",
    "MOTION_SCROLLUP": "scrollaigh suas %1",
    "MOTION_ALIGNSCENE": "ailínigh radharc %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "bun ar chlé",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "bun ar dheis",
    "MOTION_ALIGNSCENE_MIDDLE": "lár",
    "MOTION_ALIGNSCENE_TOPLEFT": "barr ar chlé",
    "MOTION_ALIGNSCENE_TOPRIGHT": "barr ar dheis",
    "MOTION_XSCROLL": "scrollaigh x",
    "MOTION_YSCROLL": "scrollaigh y",
    "MOTION_STAGE_SELECTED": "Stáitse roghnaithe: gan bloic gluaiseachta",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "uimhir randamach idir %1 agus %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 agus %2",
    "OPERATORS_OR": "%1 nó %2",
    "OPERATORS_NOT": "séanadh %1",
    "OPERATORS_JOIN": "ceangail %1 %2",
    "OPERATORS_JOIN_APPLE": "úll",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "litir %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "ú",
    "OPERATORS_LENGTH": "fad %1",
    "OPERATORS_CONTAINS": "%1 agus %2 ann?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "slánaigh %1",
    "OPERATORS_MATHOP": "%1 as %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "urlár",
    "OPERATORS_MATHOP_CEILING": "síleáil",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "sainmhínigh %1",
    "SENSING_TOUCHINGOBJECT": "i dteagmháil le %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "pointeoir-luiche",
    "SENSING_TOUCHINGOBJECT_EDGE": "ciumhais",
    "SENSING_TOUCHINGCOLOR": "i dteagmháil le dath %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "dath %1 i dteagmháil le %2?",
    "SENSING_DISTANCETO": "fad go dtí %1",
    "SENSING_DISTANCETO_POINTER": "pointeoir-luiche",
    "SENSING_ASKANDWAIT": "fiafraigh %1 agus fan",
    "SENSING_ASK_TEXT": "Cén t-ainm atá ort?",
    "SENSING_ANSWER": "freagra",
    "SENSING_KEYPRESSED": "eochair %1 brúite?",
    "SENSING_MOUSEDOWN": "luchóg síos?",
    "SENSING_MOUSEX": "luchóg x",
    "SENSING_MOUSEY": "luchóg y",
    "SENSING_SETDRAGMODE": "socraigh mód tarraingthe: %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "intarraingthe",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "dotharraingthe",
    "SENSING_LOUDNESS": "treise",
    "SENSING_LOUD": "os ard?",
    "SENSING_TIMER": "amadóir",
    "SENSING_RESETTIMER": "athshocraigh an t-amadóir",
    "SENSING_OF": "%1 as %2",
    "SENSING_OF_XPOSITION": "ionad x",
    "SENSING_OF_YPOSITION": "ionad y",
    "SENSING_OF_DIRECTION": "treo",
    "SENSING_OF_COSTUMENUMBER": "culaith #",
    "SENSING_OF_COSTUMENAME": "ainm na culaithe",
    "SENSING_OF_SIZE": "méid",
    "SENSING_OF_VOLUME": "airde",
    "SENSING_OF_BACKDROPNUMBER": "cúlra #",
    "SENSING_OF_BACKDROPNAME": "ainm an chúlra",
    "SENSING_OF_STAGE": "Stáitse",
    "SENSING_CURRENT": "%1 reatha",
    "SENSING_CURRENT_YEAR": "bliain",
    "SENSING_CURRENT_MONTH": "mí",
    "SENSING_CURRENT_DATE": "dáta",
    "SENSING_CURRENT_DAYOFWEEK": "lá den tseachtain",
    "SENSING_CURRENT_HOUR": "uair",
    "SENSING_CURRENT_MINUTE": "nóiméad",
    "SENSING_CURRENT_SECOND": "soicind",
    "SENSING_DAYSSINCE2000": "laethanta ó 2000",
    "SENSING_USERNAME": "ainm úsáideora",
    "SENSING_USERID": "aitheantas úsáideora",
    "SOUND_PLAY": "seinn fuaim %1",
    "SOUND_PLAYUNTILDONE": "seinn fuaim %1 go dtí a deireadh",
    "SOUND_STOPALLSOUNDS": "stop gach fuaim",
    "SOUND_SETEFFECTO": "socraigh maisíocht %1: %2",
    "SOUND_CHANGEEFFECTBY": "athraigh maisíocht %1 de %2",
    "SOUND_CLEAREFFECTS": "glan na maisíochtaí fuaime",
    "SOUND_EFFECTS_PITCH": "tuinairde",
    "SOUND_EFFECTS_PAN": "peanáil ar chlé/ar dheis",
    "SOUND_CHANGEVOLUMEBY": "athraigh airde na fuaime de %1",
    "SOUND_SETVOLUMETO": "socraigh airde na fuaime: %1%",
    "SOUND_VOLUME": "airde",
    "SOUND_RECORD": "taifead...",
    "CATEGORY_MOTION": "Gluaiseacht",
    "CATEGORY_LOOKS": "Cuma",
    "CATEGORY_SOUND": "Fuaim",
    "CATEGORY_EVENTS": "Teagmhais",
    "CATEGORY_CONTROL": "Rialú",
    "CATEGORY_SENSING": "Brath",
    "CATEGORY_OPERATORS": "Oibreoirí",
    "CATEGORY_VARIABLES": "Athróga",
    "CATEGORY_MYBLOCKS": "Mo Chuid Blocanna",
    "DUPLICATE": "Cóipeáil",
    "DELETE": "Scrios",
    "ADD_COMMENT": "Cuir Nóta Tráchta Leis",
    "REMOVE_COMMENT": "Bain an Nóta Tráchta",
    "DELETE_BLOCK": "Scrios an Bloc",
    "DELETE_X_BLOCKS": "Scrios %1 Bloc",
    "DELETE_ALL_BLOCKS": "Scrios na %1 bloc go léir?",
    "CLEAN_UP": "Glan na Blocanna",
    "HELP": "Cabhair",
    "UNDO": "Cealaigh",
    "REDO": "Athdhéan",
    "EDIT_PROCEDURE": "Eagar",
    "SHOW_PROCEDURE_DEFINITION": "Taispeáin an sainmhíniú",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Abair rud éigin...",
    "COLOUR_HUE_LABEL": "Dath",
    "COLOUR_SATURATION_LABEL": "Sáithiú",
    "COLOUR_BRIGHTNESS_LABEL": "Gile",
    "CHANGE_VALUE_TITLE": "Athraigh an luach:",
    "RENAME_VARIABLE": "Cuir ainm nua ar an athróg",
    "RENAME_VARIABLE_TITLE": "Cuir ainm nua ar gach athróg \"%1\":",
    "RENAME_VARIABLE_MODAL_TITLE": "Cuir Ainm Nua ar an Athróg",
    "NEW_VARIABLE": "Cruthaigh Athróg",
    "NEW_VARIABLE_TITLE": "Ainm na hathróige nua:",
    "VARIABLE_MODAL_TITLE": "Athróg Nua",
    "VARIABLE_ALREADY_EXISTS": "Tá athróg darb ainm \"%1\" ann cheana.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Tá athróg darb ainm \"%1\" ann cheana, athróg eile de chineál \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Scrios %1 cóip den athróg \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Ní féidir athróg \"%1\" a scriosadh toisc gur cuid den sainmhíniú ar fheidhm \"%2\" í.",
    "DELETE_VARIABLE": "Scrios an athróg \"%1\"",
    "NEW_PROCEDURE": "Cruthaigh Bloc",
    "PROCEDURE_ALREADY_EXISTS": "Tá feidhm darb ainm \"%1\" ann cheana.",
    "PROCEDURE_DEFAULT_NAME": "ainm an bhloic",
    "PROCEDURE_USED": "Chun sainmhíniú ar bhloc a scriosadh, is gá gach úsáid den bhloc a scriosadh ar dtús",
    "NEW_LIST": "Cruthaigh Liosta",
    "NEW_LIST_TITLE": "Ainm an liosta nua:",
    "LIST_MODAL_TITLE": "Liosta Nua",
    "LIST_ALREADY_EXISTS": "Tá liosta darb ainm \"%1\" ann cheana.",
    "RENAME_LIST_TITLE": "Cuir ainm nua ar gach liosta \"%1\":",
    "RENAME_LIST_MODAL_TITLE": "Cuir ainm nua ar an liosta",
    "DEFAULT_LIST_ITEM": "rud",
    "DELETE_LIST": "Scrios liosta \"%1\"",
    "RENAME_LIST": "Cuir ainm nua ar an liosta",
    "NEW_BROADCAST_MESSAGE": "Teachtaireacht nua",
    "NEW_BROADCAST_MESSAGE_TITLE": "Ainm na teachtaireachta nua:",
    "BROADCAST_MODAL_TITLE": "Teachtaireacht Nua",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "teachtaireacht1"
  },
  "gd": {
    "CONTROL_FOREVER": "gu buan",
    "CONTROL_REPEAT": "dèan seo %1 turas",
    "CONTROL_IF": "ma tha %1 a-rèiste",
    "CONTROL_ELSE": "air neo",
    "CONTROL_STOP": "cuir stad air",
    "CONTROL_STOP_ALL": "na h-uile",
    "CONTROL_STOP_THIS": "an sgriobt seo",
    "CONTROL_STOP_OTHER": "sgriobtaichean eile na sprìde",
    "CONTROL_WAIT": "fan fad %1 diog",
    "CONTROL_WAITUNTIL": "fan gus am bi %1",
    "CONTROL_REPEATUNTIL": "dèan a-rithist e gus am bi %1",
    "CONTROL_WHILE": "fhad ’s a tha %1",
    "CONTROL_FOREACH": "airson gach %1 air %2",
    "CONTROL_STARTASCLONE": "nuair a thèid thu nad chlòn",
    "CONTROL_CREATECLONEOF": "cruthaich clòn %1",
    "CONTROL_CREATECLONEOF_MYSELF": "dhut fhèin",
    "CONTROL_DELETETHISCLONE": "sguab às an clòn seo",
    "CONTROL_COUNTER": "cunntair",
    "CONTROL_INCRCOUNTER": "cunntair ioncramaide",
    "CONTROL_CLEARCOUNTER": "falamhaich an cunntair",
    "CONTROL_ALLATONCE": "a h-uile gin aig an aon àm",
    "DATA_SETVARIABLETO": "suidhich %1 air %2",
    "DATA_CHANGEVARIABLEBY": "atharraich %1 le %2",
    "DATA_SHOWVARIABLE": "seall an caochladair %1",
    "DATA_HIDEVARIABLE": "falaich an caochladair %1",
    "DATA_ADDTOLIST": "cuir %1 ri %2",
    "DATA_DELETEOFLIST": "sguab às %1 de %2",
    "DATA_DELETEALLOFLIST": "sguab às na h-uile gin de %1",
    "DATA_INSERTATLIST": "cuir %1 ris aig %2 de %3",
    "DATA_REPLACEITEMOFLIST": "cuir %3 an àite nì %1 de %2",
    "DATA_ITEMOFLIST": "nì %1 de %2",
    "DATA_ITEMNUMOFLIST": "àireamh an nì %1 air %2",
    "DATA_LENGTHOFLIST": "an fhaide aig %1",
    "DATA_LISTCONTAINSITEM": "%2 am broinn %1",
    "DATA_SHOWLIST": "seall an liosta %1",
    "DATA_HIDELIST": "falaich an liosta %1",
    "DATA_INDEX_ALL": "na h-uile",
    "DATA_INDEX_LAST": "am fear mu dheireadh",
    "DATA_INDEX_RANDOM": "tuaireamach",
    "EVENT_WHENFLAGCLICKED": "le briogadh air %1",
    "EVENT_WHENTHISSPRITECLICKED": "le briogadh air an sprìd seo",
    "EVENT_WHENSTAGECLICKED": "le briogadh air an àrd-ùrlar",
    "EVENT_WHENTOUCHINGOBJECT": "nuair a bhios an sprìd a’ beantainn ri %1",
    "EVENT_WHENBROADCASTRECEIVED": "nuair a gheibh thu %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "nuair a thèid an cùlaibh na %1",
    "EVENT_WHENGREATERTHAN": "nuair a thèid %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "an tìmear",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "àirde na fuaime",
    "EVENT_BROADCAST": "craol %1",
    "EVENT_BROADCASTANDWAIT": "craol %1 is fan ri càch",
    "EVENT_WHENKEYPRESSED": "le brùthadh air iuchair %1",
    "EVENT_WHENKEYPRESSED_SPACE": "spàis",
    "EVENT_WHENKEYPRESSED_LEFT": "saighde gu clì",
    "EVENT_WHENKEYPRESSED_RIGHT": "saighde gu deas",
    "EVENT_WHENKEYPRESSED_DOWN": "saighde sìos",
    "EVENT_WHENKEYPRESSED_UP": "saighde suas",
    "EVENT_WHENKEYPRESSED_ANY": "sam bith",
    "LOOKS_SAYFORSECS": "can %1 fad %2 diog",
    "LOOKS_SAY": "can %1",
    "LOOKS_HELLO": "Shin thu!",
    "LOOKS_THINKFORSECS": "smaoinich %1 fad %2 diog",
    "LOOKS_THINK": "smaoinich %1",
    "LOOKS_HMM": "An-dà…",
    "LOOKS_SHOW": "seall",
    "LOOKS_HIDE": "falaich",
    "LOOKS_HIDEALLSPRITES": "cuir gach sprìd am falach",
    "LOOKS_EFFECT_COLOR": "datha",
    "LOOKS_EFFECT_FISHEYE": "sùil èisg",
    "LOOKS_EFFECT_WHIRL": "cuairteige",
    "LOOKS_EFFECT_PIXELATE": "phiogsailean",
    "LOOKS_EFFECT_MOSAIC": "mosàig",
    "LOOKS_EFFECT_BRIGHTNESS": "soilleireachd",
    "LOOKS_EFFECT_GHOST": "taibhse",
    "LOOKS_CHANGEEFFECTBY": "atharraich èifeachd %1 le %2",
    "LOOKS_SETEFFECTTO": "cuir èifeachd %1 de %2 ort",
    "LOOKS_CLEARGRAPHICEFFECTS": "falamhaich na h-èifeachdan",
    "LOOKS_CHANGESIZEBY": "atharraich do mheud le %1",
    "LOOKS_SETSIZETO": "suidhich do mheud air %1 %",
    "LOOKS_SIZE": "meud",
    "LOOKS_CHANGESTRETCHBY": "atharraich an sìneadh le %1",
    "LOOKS_SETSTRETCHTO": "suidhich an sìneadh air %1 %",
    "LOOKS_SWITCHCOSTUMETO": "cuir dreach %1 ort",
    "LOOKS_NEXTCOSTUME": "an t-ath-dhreach",
    "LOOKS_SWITCHBACKDROPTO": "cuir %1 air a’ chùlaibh",
    "LOOKS_GOTOFRONTBACK": "rach gu breath %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "an fhìor-bheulaibh",
    "LOOKS_GOTOFRONTBACK_BACK": "an fhìor-chùlaibh",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "rach %2 breath %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "an comhair a’ bheòil",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "an comhair a’ chùil",
    "LOOKS_BACKDROPNUMBERNAME": "%1 a’ chùlaibh",
    "LOOKS_COSTUMENUMBERNAME": "%1 an dreacha",
    "LOOKS_NUMBERNAME_NUMBER": "àireamh",
    "LOOKS_NUMBERNAME_NAME": "ainm",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "cuir %1 air a’ chùlaibh is fan ri càch",
    "LOOKS_NEXTBACKDROP_BLOCK": "an t-ath-chùlaibh",
    "LOOKS_NEXTBACKDROP": "an t-ath-chùlaibh",
    "LOOKS_PREVIOUSBACKDROP": "a’ chùlaibh roimhe",
    "LOOKS_RANDOMBACKDROP": "cùlaibh air thuaiream",
    "MOTION_MOVESTEPS": "gluais le %1 ceum",
    "MOTION_TURNLEFT": "cuairtich %1 le %2 puing",
    "MOTION_TURNRIGHT": "cuairtich %1 le %2 puing",
    "MOTION_POINTINDIRECTION": "cuir d’ aghaidh ri %1",
    "MOTION_POINTTOWARDS": "cuir d’ aghaidh an comhair %1",
    "MOTION_POINTTOWARDS_POINTER": "tomhaire na luchaige",
    "MOTION_POINTTOWARDS_RANDOM": "tuaireamach",
    "MOTION_GOTO": "rach gu %1",
    "MOTION_GOTO_POINTER": "tomhaire na luchaige",
    "MOTION_GOTO_RANDOM": "ionad air thuaiream",
    "MOTION_GOTOXY": "rach gu x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "gluais fad %1 diog gu x: %2 y: %3",
    "MOTION_GLIDETO": "gluais fad %1 diog gu %2",
    "MOTION_GLIDETO_POINTER": "tomhaire na luchaige",
    "MOTION_GLIDETO_RANDOM": "ionad air thuaiream",
    "MOTION_CHANGEXBY": "atharraich x le %1",
    "MOTION_SETX": "suidhich x air %1",
    "MOTION_CHANGEYBY": "atharraich y le %1",
    "MOTION_SETY": "suidhich y air %1",
    "MOTION_IFONEDGEBOUNCE": "ma tha thu ris an oir, boc",
    "MOTION_SETROTATIONSTYLE": "suidhich stoidhle na cuairte air %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "clì is deas",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "gun chuairteachadh",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "cuairt shlàn",
    "MOTION_XPOSITION": "ionad x",
    "MOTION_YPOSITION": "ionad y",
    "MOTION_DIRECTION": "comhair",
    "MOTION_SCROLLRIGHT": "sgrolaich gu deas le %1",
    "MOTION_SCROLLUP": "sgrolaich suas le %1",
    "MOTION_ALIGNSCENE": "co-thaobhaich an sealladh dhan %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "taobh clì aig a’ bhonn",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "taobh deas aig a’ bhonn",
    "MOTION_ALIGNSCENE_MIDDLE": "mheadhan",
    "MOTION_ALIGNSCENE_TOPLEFT": "taobh clì aig a’ bhàrr",
    "MOTION_ALIGNSCENE_TOPRIGHT": "taobh deas aig a’ bhàrr",
    "MOTION_XSCROLL": "sgroladh x",
    "MOTION_YSCROLL": "sgroladh y",
    "MOTION_STAGE_SELECTED": "Chan eil bloca gluasaid an-seo on a thagh thu àrd-ùrlar",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 × %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "luach tuaireamach eadar %1 is %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 agus %2",
    "OPERATORS_OR": "%1 no %2",
    "OPERATORS_NOT": "e fallsa gu bheil %1",
    "OPERATORS_JOIN": "ceangail %1 ri %2",
    "OPERATORS_JOIN_APPLE": "eòrna",
    "OPERATORS_JOIN_BANANA": "seagal",
    "OPERATORS_LETTEROF": "litir %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "an fhaide aig %1",
    "OPERATORS_CONTAINS": "%2 am broinn %1",
    "OPERATORS_MOD": "%1 mòidealas %2",
    "OPERATORS_ROUND": "cuairtich %1",
    "OPERATORS_MATHOP": "%1 aig %2",
    "OPERATORS_MATHOP_ABS": "an luach absaloideach",
    "OPERATORS_MATHOP_FLOOR": "an cuairteachadh sìos",
    "OPERATORS_MATHOP_CEILING": "an cuairteachadh suas",
    "OPERATORS_MATHOP_SQRT": "am freumh ceàrnagach",
    "OPERATORS_MATHOP_SIN": "an sìneas",
    "OPERATORS_MATHOP_COS": "an co-shìneas",
    "OPERATORS_MATHOP_TAN": "am beantan",
    "OPERATORS_MATHOP_ASIN": "an t-àrc-shìneas",
    "OPERATORS_MATHOP_ACOS": "an t-àrc-cho-shìneas",
    "OPERATORS_MATHOP_ATAN": "an t-àrc-bheantan",
    "OPERATORS_MATHOP_LN": "an log-àireamh nàdarra",
    "OPERATORS_MATHOP_LOG": "an log-àireamh",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "mìnich %1",
    "SENSING_TOUCHINGOBJECT": "%1 a’ beantainn riut",
    "SENSING_TOUCHINGOBJECT_POINTER": "tomhaire na luchaige",
    "SENSING_TOUCHINGOBJECT_EDGE": "an oir",
    "SENSING_TOUCHINGCOLOR": "an dath %1 a’ beantainn riut",
    "SENSING_COLORISTOUCHINGCOLOR": "an dath %1 a’ beantainn ri %2",
    "SENSING_DISTANCETO": "an t-astar gu %1",
    "SENSING_DISTANCETO_POINTER": "tomhaire na luchaige",
    "SENSING_ASKANDWAIT": "faighnich %1 is fan ris",
    "SENSING_ASK_TEXT": "Dè an t-ainm a th’ ort?",
    "SENSING_ANSWER": "freagairt",
    "SENSING_KEYPRESSED": "iuchair %1 ga brùthadh",
    "SENSING_MOUSEDOWN": "an luchag ga briogadh",
    "SENSING_MOUSEX": "x na luchaige",
    "SENSING_MOUSEY": "y na luchaige",
    "SENSING_SETDRAGMODE": "suidhich %1 a shlaodadh",
    "SENSING_SETDRAGMODE_DRAGGABLE": "gun gabh",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "nach gabh",
    "SENSING_LOUDNESS": "àirde na fuaime",
    "SENSING_LOUD": "an fhuaim air",
    "SENSING_TIMER": "an tìmear",
    "SENSING_RESETTIMER": "ath-shuidhich an tìmear",
    "SENSING_OF": "%1 aig %2",
    "SENSING_OF_XPOSITION": "ionad x",
    "SENSING_OF_YPOSITION": "ionad y",
    "SENSING_OF_DIRECTION": "comhair",
    "SENSING_OF_COSTUMENUMBER": "àireamh an dreacha",
    "SENSING_OF_COSTUMENAME": "ainm an dreacha",
    "SENSING_OF_SIZE": "meud",
    "SENSING_OF_VOLUME": "àirde na fuaime",
    "SENSING_OF_BACKDROPNUMBER": "àireamh a’ chùlaibh",
    "SENSING_OF_BACKDROPNAME": "ainm a’ chùlaibh",
    "SENSING_OF_STAGE": "Àrd-ùrlar",
    "SENSING_CURRENT": "%1 làithreach",
    "SENSING_CURRENT_YEAR": "am bliadhna",
    "SENSING_CURRENT_MONTH": "am mìos",
    "SENSING_CURRENT_DATE": "an ceann-là",
    "SENSING_CURRENT_DAYOFWEEK": "latha na seachdaine",
    "SENSING_CURRENT_HOUR": "an uair",
    "SENSING_CURRENT_MINUTE": "a’ mhionaid",
    "SENSING_CURRENT_SECOND": "an diog",
    "SENSING_DAYSSINCE2000": "làithean o 2000 a-mach",
    "SENSING_USERNAME": "ainm-cleachdaiche",
    "SENSING_USERID": "ID a’ chleachdaiche",
    "SOUND_PLAY": "tòisich air fuaim %1 a chluich",
    "SOUND_PLAYUNTILDONE": "cluich fuaim %1 gu lèir",
    "SOUND_STOPALLSOUNDS": "cuir stad air a h-uile fuaim",
    "SOUND_SETEFFECTO": "cuir èifeachd %1 de %2 ort",
    "SOUND_CHANGEEFFECTBY": "atharraich èifeachd %1 le %2",
    "SOUND_CLEAREFFECTS": "falamhaich èifeachdan na fuaime",
    "SOUND_EFFECTS_PITCH": "gleusa",
    "SOUND_EFFECTS_PAN": "panachaidh gu clì/deas",
    "SOUND_CHANGEVOLUMEBY": "atharraich àirde na fuaime le %1",
    "SOUND_SETVOLUMETO": "suidhich àirde na fuaime air %1%",
    "SOUND_VOLUME": "àirde na fuaime",
    "SOUND_RECORD": "clàraich...",
    "CATEGORY_MOTION": "Gluasad",
    "CATEGORY_LOOKS": "Coltas",
    "CATEGORY_SOUND": "Fuaim",
    "CATEGORY_EVENTS": "Tachartas",
    "CATEGORY_CONTROL": "Smachd",
    "CATEGORY_SENSING": "Mothachadh",
    "CATEGORY_OPERATORS": "Gnìomharaiche",
    "CATEGORY_VARIABLES": "Caochladairean",
    "CATEGORY_MYBLOCKS": "Bloca agamsa",
    "DUPLICATE": "Dùblaich",
    "DELETE": "Sguab às",
    "ADD_COMMENT": "Cuir beachd ris",
    "REMOVE_COMMENT": "Thoir am beachd air falbh",
    "DELETE_BLOCK": "Sguab às am bloca",
    "DELETE_X_BLOCKS": "Sguab às %1 bloca(ichean)",
    "DELETE_ALL_BLOCKS": "A bheil thu airson na %1 bloca(ichean) uile a sguabadh às?",
    "CLEAN_UP": "Sgioblaich na blocaichean",
    "HELP": "Cobhair",
    "UNDO": "Neo-dhèan",
    "REDO": "Ath-dhèan",
    "EDIT_PROCEDURE": "Deasaich",
    "SHOW_PROCEDURE_DEFINITION": "Rach dhan mhìneachadh",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Can rudeigin…",
    "COLOUR_HUE_LABEL": "Dath",
    "COLOUR_SATURATION_LABEL": "Sàthachd",
    "COLOUR_BRIGHTNESS_LABEL": "Soilleireachd",
    "CHANGE_VALUE_TITLE": "Atharraich an luach:",
    "RENAME_VARIABLE": "Thoir ainm ùr air a’ chaochladair",
    "RENAME_VARIABLE_TITLE": "Thoir ainm ùr air gach caochladair “%1”:",
    "RENAME_VARIABLE_MODAL_TITLE": "Thoir ainm ùr air a’ chaochladair",
    "NEW_VARIABLE": "Cruthaich caochladair",
    "NEW_VARIABLE_TITLE": "Ainm ùr a’ chaochladair:",
    "VARIABLE_MODAL_TITLE": "Caochladair ùr",
    "VARIABLE_ALREADY_EXISTS": "Tha caochladair air a bheil “%1” ann mu thràth.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Tha caochladair air a bheil “%1” ann mu thràth airson caochladair eile dhen t-seòrsa “%2”.",
    "DELETE_VARIABLE_CONFIRMATION": "A bheil thu airson a sguabadh às dha %1 chleachdadh/cleachdaidhean dhen chaochladair “%2”?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Chan urrainn dhuinn an caochladair “%1” a sguabadh às on a e am broinn mìneachadh an fhoincsein “%2”",
    "DELETE_VARIABLE": "Sguab às dha “%1”",
    "NEW_PROCEDURE": "Cruthaich bloca",
    "PROCEDURE_ALREADY_EXISTS": "Tha modh air a bheil “%1” ann mu thràth.",
    "PROCEDURE_DEFAULT_NAME": "ainm a’ bhloca",
    "PROCEDURE_USED": "Gus mìneachadh bloca a sguabadh às, thoir air falbh gach cleachdadh a’ bhloca an toiseach",
    "NEW_LIST": "Cruthaich liosta",
    "NEW_LIST_TITLE": "Ainm na liosta ùire:",
    "LIST_MODAL_TITLE": "Liosta ùr",
    "LIST_ALREADY_EXISTS": "Tha liosta air a bheil “%1” ann mu thràth.",
    "RENAME_LIST_TITLE": "Thoir ainm ùr air gach liosta “%1”:",
    "RENAME_LIST_MODAL_TITLE": "Thoir ainm ùr air an liosta",
    "DEFAULT_LIST_ITEM": "nì",
    "DELETE_LIST": "Sguab às dhan liosta “%1”",
    "RENAME_LIST": "Thoir ainm ùr air an liosta",
    "NEW_BROADCAST_MESSAGE": "Teachdaireachd ùr",
    "NEW_BROADCAST_MESSAGE_TITLE": "Ainm na teachdaireachd ùire:",
    "BROADCAST_MODAL_TITLE": "teachdaireachd ùr",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "teachdaireachd1"
  },
  "gl": {
    "CONTROL_FOREVER": "para sempre",
    "CONTROL_REPEAT": "repetir %1",
    "CONTROL_IF": "se %1 entón",
    "CONTROL_ELSE": "se non",
    "CONTROL_STOP": "parar.",
    "CONTROL_STOP_ALL": "todos",
    "CONTROL_STOP_THIS": "este programa",
    "CONTROL_STOP_OTHER": "outros programas na figura",
    "CONTROL_WAIT": "agardar %1 segundos",
    "CONTROL_WAITUNTIL": "agardar até %1",
    "CONTROL_REPEATUNTIL": "repetir até %1",
    "CONTROL_WHILE": "mentres %1",
    "CONTROL_FOREACH": "para cada %1 en %2",
    "CONTROL_STARTASCLONE": "Ao comezar como clon",
    "CONTROL_CREATECLONEOF": "crear un clon de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "min mesmo",
    "CONTROL_DELETETHISCLONE": "eliminar este clon.",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "incrementar o contador",
    "CONTROL_CLEARCOUNTER": "limpar o contador",
    "CONTROL_ALLATONCE": "todo de vez",
    "DATA_SETVARIABLETO": "asignar %2 a %1",
    "DATA_CHANGEVARIABLEBY": "sumarlle %2 a %1",
    "DATA_SHOWVARIABLE": "amosar a variábel %1",
    "DATA_HIDEVARIABLE": "agochar a variábel %1",
    "DATA_ADDTOLIST": "engadir %1 a %2",
    "DATA_DELETEOFLIST": "eliminar %1 de %2",
    "DATA_DELETEALLOFLIST": "eliminar todo o contido de %1",
    "DATA_INSERTATLIST": "inserir %1 na posición %2 de %3",
    "DATA_REPLACEITEMOFLIST": "substituír o elemento %1 de %2 por %3",
    "DATA_ITEMOFLIST": "elemento %1 de %2",
    "DATA_ITEMNUMOFLIST": "posición de %2 que contén %1",
    "DATA_LENGTHOFLIST": "lonxitude de %1",
    "DATA_LISTCONTAINSITEM": "%1 contén %2",
    "DATA_SHOWLIST": "amosar a lista %1",
    "DATA_HIDELIST": "agochar a lista %1",
    "DATA_INDEX_ALL": "todos",
    "DATA_INDEX_LAST": "último",
    "DATA_INDEX_RANDOM": "ao chou",
    "EVENT_WHENFLAGCLICKED": "Ao premer en %1",
    "EVENT_WHENTHISSPRITECLICKED": "Ao premer nesta figura",
    "EVENT_WHENSTAGECLICKED": "Ao premer no escenario",
    "EVENT_WHENTOUCHINGOBJECT": "Cando esta figura toque %1",
    "EVENT_WHENBROADCASTRECEIVED": "Ao recibir %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "Ao mudar o fondo a %1",
    "EVENT_WHENGREATERTHAN": "Cando %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronómetro",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "volume do micrófono",
    "EVENT_BROADCAST": "emitir %1",
    "EVENT_BROADCASTANDWAIT": "emitir %1 e agardar",
    "EVENT_WHENKEYPRESSED": "Ao premer na tecla %1",
    "EVENT_WHENKEYPRESSED_SPACE": "espazo",
    "EVENT_WHENKEYPRESSED_LEFT": "frecha esquerda",
    "EVENT_WHENKEYPRESSED_RIGHT": "frecha dereita",
    "EVENT_WHENKEYPRESSED_DOWN": "frecha abaixo",
    "EVENT_WHENKEYPRESSED_UP": "frecha arriba",
    "EVENT_WHENKEYPRESSED_ANY": "calquera",
    "LOOKS_SAYFORSECS": "dicir %1 durante %2 segundos",
    "LOOKS_SAY": "dicir %1",
    "LOOKS_HELLO": "Ola!",
    "LOOKS_THINKFORSECS": "pensar %1 durante %2 segundos",
    "LOOKS_THINK": "pensar %1",
    "LOOKS_HMM": "Mmm...",
    "LOOKS_SHOW": "amosarse",
    "LOOKS_HIDE": "agocharse",
    "LOOKS_HIDEALLSPRITES": "agochar todas as figuras",
    "LOOKS_EFFECT_COLOR": "cor",
    "LOOKS_EFFECT_FISHEYE": "ollo de peixe",
    "LOOKS_EFFECT_WHIRL": "remuiño",
    "LOOKS_EFFECT_PIXELATE": "pixelar",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "luminosidade",
    "LOOKS_EFFECT_GHOST": "desaparecer",
    "LOOKS_CHANGEEFFECTBY": "sumar %2 ao efecto %1",
    "LOOKS_SETEFFECTTO": "aplicar o efecto %1 co valor %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "limpar os efectos gráficos",
    "LOOKS_CHANGESIZEBY": "sumar %1 ao tamaño",
    "LOOKS_SETSIZETO": "pór o tamaño ao %1 %",
    "LOOKS_SIZE": "tamaño",
    "LOOKS_CHANGESTRETCHBY": "sumar %1 ao estiramento",
    "LOOKS_SETSTRETCHTO": "pór o estiramento no %1 %",
    "LOOKS_SWITCHCOSTUMETO": "mudar traxe a %1",
    "LOOKS_NEXTCOSTUME": "traxe seguinte",
    "LOOKS_SWITCHBACKDROPTO": "mudar fondo a %1",
    "LOOKS_GOTOFRONTBACK": "ir para a capa %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "por diante",
    "LOOKS_GOTOFRONTBACK_BACK": "por detrás",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ir %1 %2 capas",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "adiante",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "atrás",
    "LOOKS_BACKDROPNUMBERNAME": "fondo %1",
    "LOOKS_COSTUMENUMBERNAME": "traxe %1",
    "LOOKS_NUMBERNAME_NUMBER": "número",
    "LOOKS_NUMBERNAME_NAME": "nome",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "mudar fondo a %1 e agardar",
    "LOOKS_NEXTBACKDROP_BLOCK": "fondo seguinte",
    "LOOKS_NEXTBACKDROP": "fondo seguinte",
    "LOOKS_PREVIOUSBACKDROP": "fondo anterior",
    "LOOKS_RANDOMBACKDROP": "fondo de pantalla aleatorio",
    "MOTION_MOVESTEPS": "mover %1 pasos",
    "MOTION_TURNLEFT": "xirar %1 %2 graos",
    "MOTION_TURNRIGHT": "xirar %1 %2 graos",
    "MOTION_POINTINDIRECTION": "apuntar na dirección %1",
    "MOTION_POINTTOWARDS": "apuntar cara a %1",
    "MOTION_POINTTOWARDS_POINTER": "punteiro do rato",
    "MOTION_POINTTOWARDS_RANDOM": "dirección aleatoria",
    "MOTION_GOTO": "ir para %1",
    "MOTION_GOTO_POINTER": "punteiro do rato",
    "MOTION_GOTO_RANDOM": "posición aleatoria",
    "MOTION_GOTOXY": "ir para X: %1 Y: %2",
    "MOTION_GLIDESECSTOXY": "esvarar durante %1 seg a X: %2 Y: %3",
    "MOTION_GLIDETO": "esvarar durante %1 seg a %2",
    "MOTION_GLIDETO_POINTER": "punteiro do rato",
    "MOTION_GLIDETO_RANDOM": "posición aleatoria",
    "MOTION_CHANGEXBY": "sumar %1 a X",
    "MOTION_SETX": "asignar a X o valor %1",
    "MOTION_CHANGEYBY": "sumar %1 a Y",
    "MOTION_SETY": "asignar a Y o valor %1",
    "MOTION_IFONEDGEBOUNCE": "se toca un bordo, rebotar",
    "MOTION_SETROTATIONSTYLE": "usar o estilo de rotación %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "esquerda-dereita",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "non rotar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "en todas as direccións",
    "MOTION_XPOSITION": "posición en X",
    "MOTION_YPOSITION": "posición en Y",
    "MOTION_DIRECTION": "dirección",
    "MOTION_SCROLLRIGHT": "desprazamento dereita %1",
    "MOTION_SCROLLUP": "desprazamento arriba %1",
    "MOTION_ALIGNSCENE": "aliñar a escena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "abaixo esquerda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "abaixo dereita",
    "MOTION_ALIGNSCENE_MIDDLE": "medio",
    "MOTION_ALIGNSCENE_TOPLEFT": "arriba esquerda",
    "MOTION_ALIGNSCENE_TOPRIGHT": "arriba dereita",
    "MOTION_XSCROLL": "desprazamento x",
    "MOTION_YSCROLL": "desprazamento Y",
    "MOTION_STAGE_SELECTED": "Escenario seleccionado: sen bloques de movemento",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 – %2",
    "OPERATORS_MULTIPLY": "%1 × %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "número ao chou entre %1 e %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 e %2",
    "OPERATORS_OR": "%1 ou %2",
    "OPERATORS_NOT": "non %1",
    "OPERATORS_JOIN": "concatenar %1 %2",
    "OPERATORS_JOIN_APPLE": "mazá",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "lonxitude de %1",
    "OPERATORS_CONTAINS": "%1 contén %2",
    "OPERATORS_MOD": "%1 módulo %2",
    "OPERATORS_ROUND": "arredondar %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "valor absoluto",
    "OPERATORS_MATHOP_FLOOR": "chan",
    "OPERATORS_MATHOP_CEILING": "teito",
    "OPERATORS_MATHOP_SQRT": "raíz cadrada",
    "OPERATORS_MATHOP_SIN": "seno",
    "OPERATORS_MATHOP_COS": "coseno",
    "OPERATORS_MATHOP_TAN": "tanxente",
    "OPERATORS_MATHOP_ASIN": "arco seno",
    "OPERATORS_MATHOP_ACOS": "arco coseno",
    "OPERATORS_MATHOP_ATAN": "arco tanxente",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definir %1",
    "SENSING_TOUCHINGOBJECT": "toca %1",
    "SENSING_TOUCHINGOBJECT_POINTER": "punteiro do rato",
    "SENSING_TOUCHINGOBJECT_EDGE": "bordo",
    "SENSING_TOUCHINGCOLOR": "toca na cor %1",
    "SENSING_COLORISTOUCHINGCOLOR": "a cor %1 toca %2",
    "SENSING_DISTANCETO": "distancia a %1",
    "SENSING_DISTANCETO_POINTER": "punteiro do rato",
    "SENSING_ASKANDWAIT": "preguntar %1 e agardar",
    "SENSING_ASK_TEXT": "Como te chamas?",
    "SENSING_ANSWER": "resposta",
    "SENSING_KEYPRESSED": "a tecla %1 está premida",
    "SENSING_MOUSEDOWN": "o rato está premido",
    "SENSING_MOUSEX": "posición en X do rato",
    "SENSING_MOUSEY": "posición en Y do rato",
    "SENSING_SETDRAGMODE": "usar o modo de arrastre %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastrábel",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "non arrastrábel",
    "SENSING_LOUDNESS": "volume no micrófono",
    "SENSING_LOUD": "forte?",
    "SENSING_TIMER": "cronómetro",
    "SENSING_RESETTIMER": "reiniciar o cronómetro",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posición en X",
    "SENSING_OF_YPOSITION": "posición en Y",
    "SENSING_OF_DIRECTION": "dirección",
    "SENSING_OF_COSTUMENUMBER": "traxe n.º",
    "SENSING_OF_COSTUMENAME": "nome do traxe",
    "SENSING_OF_SIZE": "tamaño",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "fondo n.º",
    "SENSING_OF_BACKDROPNAME": "nome do fondo",
    "SENSING_OF_STAGE": "Escenario",
    "SENSING_CURRENT": "%1 actual",
    "SENSING_CURRENT_YEAR": "ano",
    "SENSING_CURRENT_MONTH": "mes",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "día da semana",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "segundo",
    "SENSING_DAYSSINCE2000": "días desde o 2000",
    "SENSING_USERNAME": "nome de usuario",
    "SENSING_USERID": "identificador de usuario",
    "SOUND_PLAY": "iniciar son %1",
    "SOUND_PLAYUNTILDONE": "reproducir %1 até rematar",
    "SOUND_STOPALLSOUNDS": "deter todos os sons",
    "SOUND_SETEFFECTO": "aplicar o efecto %1 co valor %2",
    "SOUND_CHANGEEFFECTBY": "sumar ao efecto %1 o valor %2",
    "SOUND_CLEAREFFECTS": "limpar os efectos de son",
    "SOUND_EFFECTS_PITCH": "ton",
    "SOUND_EFFECTS_PAN": "canle esquerda/dereita",
    "SOUND_CHANGEVOLUMEBY": "subir o volume en %1",
    "SOUND_SETVOLUMETO": "pór o volume no %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "gravar...",
    "CATEGORY_MOTION": "Movemento",
    "CATEGORY_LOOKS": "Aparencia",
    "CATEGORY_SOUND": "Son",
    "CATEGORY_EVENTS": "Eventos",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensores",
    "CATEGORY_OPERATORS": "Operadores",
    "CATEGORY_VARIABLES": "Variábeis",
    "CATEGORY_MYBLOCKS": "Os meus bloques",
    "DUPLICATE": "Duplicar",
    "DELETE": "Eliminar",
    "ADD_COMMENT": "Engadir comentario",
    "REMOVE_COMMENT": "Retirar comentario",
    "DELETE_BLOCK": "Eliminar bloque",
    "DELETE_X_BLOCKS": "Eliminar %1 bloques",
    "DELETE_ALL_BLOCKS": "Eliminar os %1 bloques?",
    "CLEAN_UP": "Limpar bloques",
    "HELP": "Axuda",
    "UNDO": "Desfacer",
    "REDO": "Refacer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Ir á definición",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Di algo...",
    "COLOUR_HUE_LABEL": "Cor",
    "COLOUR_SATURATION_LABEL": "Saturación",
    "COLOUR_BRIGHTNESS_LABEL": "Luminosidade",
    "CHANGE_VALUE_TITLE": "Cambiar valor:",
    "RENAME_VARIABLE": "Renomear variábel",
    "RENAME_VARIABLE_TITLE": "Renomear as variábeis «%1» como:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renomear variábel",
    "NEW_VARIABLE": "Crear unha variábel",
    "NEW_VARIABLE_TITLE": "Nome da nova variábel:",
    "VARIABLE_MODAL_TITLE": "Nova variábel",
    "VARIABLE_ALREADY_EXISTS": "Xa existe unha variábel chamada «%1».",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Xa existe unha variábel chamada «%1» para outra variábel de tipo «%2».",
    "DELETE_VARIABLE_CONFIRMATION": "Eliminar %1 usos da variábel «%2»?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Non é posíbel eliminar a variábel «%1» porque é parte da definición da función «%2».",
    "DELETE_VARIABLE": "Eliminar a variábel «%1»",
    "NEW_PROCEDURE": "Crear un bloque",
    "PROCEDURE_ALREADY_EXISTS": "Xa existe un procedemento chamado «%1».",
    "PROCEDURE_DEFAULT_NAME": "nome do bloque",
    "PROCEDURE_USED": "Para borrar unha definición de bloque, primeiro retira todos os usos do bloque.",
    "NEW_LIST": "Crear unha lista",
    "NEW_LIST_TITLE": "Nome da nova lista:",
    "LIST_MODAL_TITLE": "Nova lista",
    "LIST_ALREADY_EXISTS": "Xa existe unha lista chamada «%1».",
    "RENAME_LIST_TITLE": "Renomear as listas «%1» como:",
    "RENAME_LIST_MODAL_TITLE": "Renomear lista",
    "DEFAULT_LIST_ITEM": "cousa",
    "DELETE_LIST": "Eliminar a lista «%1»",
    "RENAME_LIST": "Renomear lista",
    "NEW_BROADCAST_MESSAGE": "Nova mensaxe",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nome da nova mensaxe:",
    "BROADCAST_MODAL_TITLE": "Mensaxe nova",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mensaxe1"
  },
  "ko": {
    "CONTROL_FOREVER": "무한 반복하기",
    "CONTROL_REPEAT": "%1 번 반복하기",
    "CONTROL_IF": "만약 %1 (이)라면",
    "CONTROL_ELSE": "아니면",
    "CONTROL_STOP": "멈추기",
    "CONTROL_STOP_ALL": "모두",
    "CONTROL_STOP_THIS": "이 스크립트",
    "CONTROL_STOP_OTHER": "이 스프라이트에 있는 다른 스크립트",
    "CONTROL_WAIT": "%1 초 기다리기",
    "CONTROL_WAITUNTIL": "%1 까지 기다리기",
    "CONTROL_REPEATUNTIL": "%1 까지 반복하기",
    "CONTROL_WHILE": "%1 동안 반복하기",
    "CONTROL_FOREACH": "%1 변수로 %2 번 반복하기",
    "CONTROL_STARTASCLONE": "복제되었을 때",
    "CONTROL_CREATECLONEOF": "%1 복제하기",
    "CONTROL_CREATECLONEOF_MYSELF": "나 자신",
    "CONTROL_DELETETHISCLONE": "이 복제본 삭제하기",
    "CONTROL_COUNTER": "카운터",
    "CONTROL_INCRCOUNTER": "카운터 증가하기",
    "CONTROL_CLEARCOUNTER": "카운터 초기화",
    "CONTROL_ALLATONCE": "한 번에 실행하기",
    "DATA_SETVARIABLETO": "%1 을(를) %2 로 정하기",
    "DATA_CHANGEVARIABLEBY": "%1 을(를) %2 만큼 바꾸기",
    "DATA_SHOWVARIABLE": "%1 변수 보이기",
    "DATA_HIDEVARIABLE": "%1 변수 숨기기",
    "DATA_ADDTOLIST": "%1 을(를) %2 에 추가하기",
    "DATA_DELETEOFLIST": "%1 번째 항목을 %2 에서 삭제하기",
    "DATA_DELETEALLOFLIST": "%1 의 항목을 모두 삭제하기 ",
    "DATA_INSERTATLIST": "%1 을(를) %3 리스트의 %2 번째에 넣기",
    "DATA_REPLACEITEMOFLIST": "%2 리스트의 %1 번째 항목을 %3 으로 바꾸기",
    "DATA_ITEMOFLIST": "%2 리스트의 %1 번째 항목",
    "DATA_ITEMNUMOFLIST": "%2 리스트에서 %1 항목의 위치",
    "DATA_LENGTHOFLIST": "%1 의 길이",
    "DATA_LISTCONTAINSITEM": "%1 이(가) %2 을(를) 포함하는가?",
    "DATA_SHOWLIST": "%1 리스트 보이기",
    "DATA_HIDELIST": "%1 리스트 숨기기",
    "DATA_INDEX_ALL": "모두",
    "DATA_INDEX_LAST": "마지막",
    "DATA_INDEX_RANDOM": "랜덤",
    "EVENT_WHENFLAGCLICKED": "%1 클릭했을 때",
    "EVENT_WHENTHISSPRITECLICKED": "이 스프라이트를 클릭했을 때",
    "EVENT_WHENSTAGECLICKED": "무대를 클릭했을 때",
    "EVENT_WHENTOUCHINGOBJECT": "이 스프라이트가 %1 에 닿았을 때",
    "EVENT_WHENBROADCASTRECEIVED": "%1 신호를 받았을 때",
    "EVENT_WHENBACKDROPSWITCHESTO": "배경이 %1 (으)로 바뀌었을 때",
    "EVENT_WHENGREATERTHAN": "%1 > %2 일 때",
    "EVENT_WHENGREATERTHAN_TIMER": "타이머",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "음량",
    "EVENT_BROADCAST": "%1 신호 보내기",
    "EVENT_BROADCASTANDWAIT": "%1 신호 보내고 기다리기",
    "EVENT_WHENKEYPRESSED": "%1 키를 눌렀을 때",
    "EVENT_WHENKEYPRESSED_SPACE": "스페이스",
    "EVENT_WHENKEYPRESSED_LEFT": "왼쪽 화살표",
    "EVENT_WHENKEYPRESSED_RIGHT": "오른쪽 화살표",
    "EVENT_WHENKEYPRESSED_DOWN": "아래쪽 화살표",
    "EVENT_WHENKEYPRESSED_UP": "위쪽 화살표",
    "EVENT_WHENKEYPRESSED_ANY": "아무",
    "LOOKS_SAYFORSECS": "%1 을(를) %2 초 동안 말하기",
    "LOOKS_SAY": "%1 말하기",
    "LOOKS_HELLO": "안녕!",
    "LOOKS_THINKFORSECS": "%1 을(를) %2 초 동안 생각하기",
    "LOOKS_THINK": "%1 생각하기",
    "LOOKS_HMM": "음...",
    "LOOKS_SHOW": "보이기",
    "LOOKS_HIDE": "숨기기",
    "LOOKS_HIDEALLSPRITES": "모든 스프라이트 숨기기",
    "LOOKS_EFFECT_COLOR": "색깔",
    "LOOKS_EFFECT_FISHEYE": "어안 렌즈",
    "LOOKS_EFFECT_WHIRL": "소용돌이",
    "LOOKS_EFFECT_PIXELATE": "픽셀화",
    "LOOKS_EFFECT_MOSAIC": "모자이크",
    "LOOKS_EFFECT_BRIGHTNESS": "밝기",
    "LOOKS_EFFECT_GHOST": "투명도",
    "LOOKS_CHANGEEFFECTBY": "%1 효과를 %2 만큼 바꾸기",
    "LOOKS_SETEFFECTTO": "%1 효과를 %2 (으)로 정하기",
    "LOOKS_CLEARGRAPHICEFFECTS": "그래픽 효과 지우기",
    "LOOKS_CHANGESIZEBY": "크기를 %1 만큼 바꾸기",
    "LOOKS_SETSIZETO": "크기를 %1 %로 정하기",
    "LOOKS_SIZE": "크기",
    "LOOKS_CHANGESTRETCHBY": "너비를 %1 만큼 바꾸기",
    "LOOKS_SETSTRETCHTO": "너비를 %1 %로 정하기",
    "LOOKS_SWITCHCOSTUMETO": "모양을 %1 (으)로 바꾸기",
    "LOOKS_NEXTCOSTUME": "다음 모양으로 바꾸기",
    "LOOKS_SWITCHBACKDROPTO": "배경을 %1 (으)로 바꾸기",
    "LOOKS_GOTOFRONTBACK": "%1 으로 순서 바꾸기",
    "LOOKS_GOTOFRONTBACK_FRONT": "맨 앞쪽",
    "LOOKS_GOTOFRONTBACK_BACK": "맨 뒤쪽",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 단계 보내기",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "앞으로",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "뒤로",
    "LOOKS_BACKDROPNUMBERNAME": "배경 %1",
    "LOOKS_COSTUMENUMBERNAME": "모양 %1",
    "LOOKS_NUMBERNAME_NUMBER": "번호",
    "LOOKS_NUMBERNAME_NAME": "이름",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "배경을 %1 (으)로 바꾸고 기다리기",
    "LOOKS_NEXTBACKDROP_BLOCK": "다음 배경으로 바꾸기",
    "LOOKS_NEXTBACKDROP": "다음 배경",
    "LOOKS_PREVIOUSBACKDROP": "이전 배경",
    "LOOKS_RANDOMBACKDROP": "랜덤 배경",
    "MOTION_MOVESTEPS": "%1 만큼 움직이기",
    "MOTION_TURNLEFT": "%1 방향으로 %2 도 돌기",
    "MOTION_TURNRIGHT": "%1 방향으로 %2 도 돌기",
    "MOTION_POINTINDIRECTION": "%1 도 방향 보기",
    "MOTION_POINTTOWARDS": "%1 쪽 보기",
    "MOTION_POINTTOWARDS_POINTER": "마우스 포인터",
    "MOTION_POINTTOWARDS_RANDOM": "랜덤 방향",
    "MOTION_GOTO": "%1 (으)로 이동하기",
    "MOTION_GOTO_POINTER": "마우스 포인터",
    "MOTION_GOTO_RANDOM": "무작위 위치",
    "MOTION_GOTOXY": "x: %1 y: %2 (으)로 이동하기",
    "MOTION_GLIDESECSTOXY": "%1 초 동안 x: %2 y: %3 (으)로 이동하기",
    "MOTION_GLIDETO": "%1 초 동안 %2 (으)로 이동하기",
    "MOTION_GLIDETO_POINTER": "마우스 포인터",
    "MOTION_GLIDETO_RANDOM": "랜덤 위치",
    "MOTION_CHANGEXBY": "x좌표를 %1 만큼 바꾸기",
    "MOTION_SETX": "x좌표를 %1 (으)로 정하기",
    "MOTION_CHANGEYBY": "y좌표를 %1 만큼 바꾸기",
    "MOTION_SETY": "y좌표를 %1 (으)로 정하기",
    "MOTION_IFONEDGEBOUNCE": "벽에 닿으면 튕기기",
    "MOTION_SETROTATIONSTYLE": "회전 방식을 %1 (으)로 정하기",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "왼쪽-오른쪽",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "회전하지 않기",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "회전하기",
    "MOTION_XPOSITION": "x좌표",
    "MOTION_YPOSITION": "y좌표",
    "MOTION_DIRECTION": "방향",
    "MOTION_SCROLLRIGHT": "오른쪽으로 %1 만큼 스크롤하기",
    "MOTION_SCROLLUP": "위쪽으로 %1 만큼 스크롤하기",
    "MOTION_ALIGNSCENE": "화면을 %1 로 정렬하기",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "왼쪽 아래",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "오른쪽 아래",
    "MOTION_ALIGNSCENE_MIDDLE": "가운데",
    "MOTION_ALIGNSCENE_TOPLEFT": "왼쪽 위",
    "MOTION_ALIGNSCENE_TOPRIGHT": "오른쪽 위",
    "MOTION_XSCROLL": "x 스크롤",
    "MOTION_YSCROLL": "y 스크롤",
    "MOTION_STAGE_SELECTED": "무대 선택됨: 동작 블록 없음",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 부터 %2 사이의 난수",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 그리고 %2",
    "OPERATORS_OR": "%1 또는 %2",
    "OPERATORS_NOT": "%1 이(가) 아니다",
    "OPERATORS_JOIN": "%1 와(과) %2 결합하기",
    "OPERATORS_JOIN_APPLE": "가위",
    "OPERATORS_JOIN_BANANA": "나무",
    "OPERATORS_LETTEROF": "%2 의 %1 번째 글자",
    "OPERATORS_LETTEROF_APPLE": "가",
    "OPERATORS_LENGTH": "%1 의 길이",
    "OPERATORS_CONTAINS": "%1 이(가) %2 을(를) 포함하는가?",
    "OPERATORS_MOD": "%1 나누기 %2 의 나머지",
    "OPERATORS_ROUND": "%1 의 반올림",
    "OPERATORS_MATHOP": "%1 ( %2 )",
    "OPERATORS_MATHOP_ABS": "절댓값",
    "OPERATORS_MATHOP_FLOOR": "버림",
    "OPERATORS_MATHOP_CEILING": "올림",
    "OPERATORS_MATHOP_SQRT": "제곱근",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "%1 정의하기",
    "SENSING_TOUCHINGOBJECT": "%1 에 닿았는가?",
    "SENSING_TOUCHINGOBJECT_POINTER": "마우스 포인터",
    "SENSING_TOUCHINGOBJECT_EDGE": "벽",
    "SENSING_TOUCHINGCOLOR": "%1 색에 닿았는가?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 색이 %2 색에 닿았는가?",
    "SENSING_DISTANCETO": "%1 까지의 거리",
    "SENSING_DISTANCETO_POINTER": "마우스 포인터",
    "SENSING_ASKANDWAIT": "%1 라고 묻고 기다리기",
    "SENSING_ASK_TEXT": "너 이름이 뭐니?",
    "SENSING_ANSWER": "대답",
    "SENSING_KEYPRESSED": "%1 키를 눌렸는가?",
    "SENSING_MOUSEDOWN": "마우스를 클릭했는가?",
    "SENSING_MOUSEX": "마우스의 x좌표",
    "SENSING_MOUSEY": "마우스의 y좌표",
    "SENSING_SETDRAGMODE": "드래그 모드를 %1 상태로 정하기",
    "SENSING_SETDRAGMODE_DRAGGABLE": "드래그 할 수 있는",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "드래그 할 수 없는",
    "SENSING_LOUDNESS": "음량",
    "SENSING_LOUD": "소리가 큰가?",
    "SENSING_TIMER": "타이머",
    "SENSING_RESETTIMER": "타이머 초기화",
    "SENSING_OF": "%2 의 %1",
    "SENSING_OF_XPOSITION": "x좌표",
    "SENSING_OF_YPOSITION": "y좌표",
    "SENSING_OF_DIRECTION": "방향",
    "SENSING_OF_COSTUMENUMBER": "모양 번호",
    "SENSING_OF_COSTUMENAME": "모양 이름",
    "SENSING_OF_SIZE": "크기",
    "SENSING_OF_VOLUME": "음량",
    "SENSING_OF_BACKDROPNUMBER": "배경 번호",
    "SENSING_OF_BACKDROPNAME": "배경 이름",
    "SENSING_OF_STAGE": "무대",
    "SENSING_CURRENT": "현재 %1",
    "SENSING_CURRENT_YEAR": "년",
    "SENSING_CURRENT_MONTH": "월",
    "SENSING_CURRENT_DATE": "일",
    "SENSING_CURRENT_DAYOFWEEK": "요일",
    "SENSING_CURRENT_HOUR": "시",
    "SENSING_CURRENT_MINUTE": "분",
    "SENSING_CURRENT_SECOND": "초",
    "SENSING_DAYSSINCE2000": "2000년 이후 현재까지 날짜 수",
    "SENSING_USERNAME": "사용자 이름",
    "SENSING_USERID": "사용자 번호",
    "SOUND_PLAY": "%1 재생하기",
    "SOUND_PLAYUNTILDONE": "%1 끝까지 재생하기",
    "SOUND_STOPALLSOUNDS": "모든 소리 끄기",
    "SOUND_SETEFFECTO": "%1 효과를 %2 로 정하기",
    "SOUND_CHANGEEFFECTBY": "%1 효과를 %2 만큼 바꾸기",
    "SOUND_CLEAREFFECTS": "소리 효과 지우기",
    "SOUND_EFFECTS_PITCH": "음 높이",
    "SOUND_EFFECTS_PAN": "음향 위치 왼쪽/오른쪽",
    "SOUND_CHANGEVOLUMEBY": "음량을 %1 만큼 바꾸기",
    "SOUND_SETVOLUMETO": "음량을 %1%로 정하기",
    "SOUND_VOLUME": "음량",
    "SOUND_RECORD": "녹음하기...",
    "CATEGORY_MOTION": "동작",
    "CATEGORY_LOOKS": "형태",
    "CATEGORY_SOUND": "소리",
    "CATEGORY_EVENTS": "이벤트",
    "CATEGORY_CONTROL": "제어",
    "CATEGORY_SENSING": "감지",
    "CATEGORY_OPERATORS": "연산",
    "CATEGORY_VARIABLES": "변수",
    "CATEGORY_MYBLOCKS": "내 블록",
    "DUPLICATE": "복사하기",
    "DELETE": "삭제하기",
    "ADD_COMMENT": "주석 넣기",
    "REMOVE_COMMENT": "주석 지우기",
    "DELETE_BLOCK": "블록 삭제하기",
    "DELETE_X_BLOCKS": "블록 %1개 삭제하기",
    "DELETE_ALL_BLOCKS": "%1개의 블록을 모두 삭제할까요?",
    "CLEAN_UP": "블록 정리하기",
    "HELP": "도움말",
    "UNDO": "실행 취소",
    "REDO": "다시 실행",
    "EDIT_PROCEDURE": "편집",
    "SHOW_PROCEDURE_DEFINITION": "정의로 이동하기",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "무엇이든 말하여 봅시다.",
    "COLOUR_HUE_LABEL": "색상",
    "COLOUR_SATURATION_LABEL": "채도",
    "COLOUR_BRIGHTNESS_LABEL": "명도",
    "CHANGE_VALUE_TITLE": "값 바꾸기:",
    "RENAME_VARIABLE": "변수 이름 바꾸기",
    "RENAME_VARIABLE_TITLE": "\"%1\" 변수를 모두 다음으로 이름 바꾸기:",
    "RENAME_VARIABLE_MODAL_TITLE": "변수 이름 바꾸기",
    "NEW_VARIABLE": "변수 만들기",
    "NEW_VARIABLE_TITLE": "새로운 변수 이름:",
    "VARIABLE_MODAL_TITLE": "새로운 변수",
    "VARIABLE_ALREADY_EXISTS": "이름이 \"%1\"인 변수는 이미 존재합니다.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "이름이 \"%1\"인 변수는 이미 \"%2\" 형태의 다른 변수로 존재합니다.",
    "DELETE_VARIABLE_CONFIRMATION": "\"%2\" 변수가 사용된 %1곳을 삭제할까요?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "\"%2\" 함수의 정의 중 일부분이기 때문에 \"%1\" 변수를 삭제할 수 없습니다.",
    "DELETE_VARIABLE": "\"%1\" 변수 삭제하기",
    "NEW_PROCEDURE": "블록 만들기",
    "PROCEDURE_ALREADY_EXISTS": "이름이 \"%1\"인 함수는 이미 존재합니다.",
    "PROCEDURE_DEFAULT_NAME": "블록 이름",
    "PROCEDURE_USED": "정의된 블록을 삭제하기 위해서는, 먼저 이 블록이 사용된 곳을 모두 삭제해야 합니다.",
    "NEW_LIST": "리스트 만들기",
    "NEW_LIST_TITLE": "새로운 리스트 이름:",
    "LIST_MODAL_TITLE": "새로운 리스트",
    "LIST_ALREADY_EXISTS": "이름이 \"%1\"인 리스트는 이미 존재합니다.",
    "RENAME_LIST_TITLE": "\"%1\" 리스트를 모두 다음으로 이름 바꾸기:",
    "RENAME_LIST_MODAL_TITLE": "리스트 이름 바꾸기",
    "DEFAULT_LIST_ITEM": "항목",
    "DELETE_LIST": "\"%1\" 리스트 삭제하기",
    "RENAME_LIST": "리스트 이름 바꾸기",
    "NEW_BROADCAST_MESSAGE": "새로운 메시지",
    "NEW_BROADCAST_MESSAGE_TITLE": "새로운 메시지 이름:",
    "BROADCAST_MODAL_TITLE": "새로운 메시지",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "메시지1"
  },
  "ha": {
    "CONTROL_FOREVER": "har abada ",
    "CONTROL_REPEAT": "maimaita %1",
    "CONTROL_IF": "idan %1 sai",
    "CONTROL_ELSE": "ko kuma",
    "CONTROL_STOP": "tsaya ",
    "CONTROL_STOP_ALL": "duka",
    "CONTROL_STOP_THIS": "wannan rubutun",
    "CONTROL_STOP_OTHER": "sauran rubutun cikin sprite",
    "CONTROL_WAIT": "jira daƙiƙai %1",
    "CONTROL_WAITUNTIL": "jira har %1",
    "CONTROL_REPEATUNTIL": "maimaita har zuwa %1",
    "CONTROL_WHILE": "yayin da %1",
    "CONTROL_FOREACH": "ga kowanne %1 acikin %2",
    "CONTROL_STARTASCLONE": "lokacin da na fara a matsayin kwaikwayo",
    "CONTROL_CREATECLONEOF": "ƙirƙiri kwaikwayon %1",
    "CONTROL_CREATECLONEOF_MYSELF": "kaina",
    "CONTROL_DELETETHISCLONE": "goge wannan kwaikwayon ",
    "CONTROL_COUNTER": "abun ƙirge",
    "CONTROL_INCRCOUNTER": "abun ƙirge mai ƙaruwa",
    "CONTROL_CLEARCOUNTER": "share abun ƙirge",
    "CONTROL_ALLATONCE": "duka a lokaci guda",
    "DATA_SETVARIABLETO": "saita %1 zuwa %2",
    "DATA_CHANGEVARIABLEBY": "canza %1 a madadin %2",
    "DATA_SHOWVARIABLE": "nuna abu mai canzawa na %1",
    "DATA_HIDEVARIABLE": "ɓoye abu mai canzawa na %1",
    "DATA_ADDTOLIST": "ƙara %1 zuwa %2",
    "DATA_DELETEOFLIST": "goge %1 na %2",
    "DATA_DELETEALLOFLIST": "cire dukkan %1",
    "DATA_INSERTATLIST": "saka %1 a cikin %2 na %3",
    "DATA_REPLACEITEMOFLIST": "mayar da abun %1 na %2 da %3",
    "DATA_ITEMOFLIST": "abun %1 na %2",
    "DATA_ITEMNUMOFLIST": "abun # na %1 cikin %2",
    "DATA_LENGTHOFLIST": "tsawon %1",
    "DATA_LISTCONTAINSITEM": "%1 ya ƙunshi %2?",
    "DATA_SHOWLIST": "nuna jerin %1",
    "DATA_HIDELIST": "ɓoye jerin %1",
    "DATA_INDEX_ALL": "duka",
    "DATA_INDEX_LAST": "ƙarshe",
    "DATA_INDEX_RANDOM": "a hargitse",
    "EVENT_WHENFLAGCLICKED": "lokacin da aka danna %1",
    "EVENT_WHENTHISSPRITECLICKED": "lokacin da aka danna wannan sprite ɗin  ",
    "EVENT_WHENSTAGECLICKED": "lokacin da aka danna mataki",
    "EVENT_WHENTOUCHINGOBJECT": "lokacin da wannan sprite ɗin ya taɓa %1",
    "EVENT_WHENBROADCASTRECEIVED": "lokacin da na karɓi %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "lokacin da hoton fage ya koma zuwa %1",
    "EVENT_WHENGREATERTHAN": "lokacin da %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "abun ƙidayar lokaci",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ƙara",
    "EVENT_BROADCAST": "yaɗa %1",
    "EVENT_BROADCASTANDWAIT": "yaɗa %1 kuma a jira ",
    "EVENT_WHENKEYPRESSED": "lokacin da aka danna madannin %1",
    "EVENT_WHENKEYPRESSED_SPACE": "gurbi",
    "EVENT_WHENKEYPRESSED_LEFT": "kibiyar hagu",
    "EVENT_WHENKEYPRESSED_RIGHT": "kibiyar dama",
    "EVENT_WHENKEYPRESSED_DOWN": "kibiyar ƙasa",
    "EVENT_WHENKEYPRESSED_UP": "kibiyar sama",
    "EVENT_WHENKEYPRESSED_ANY": "kowane ",
    "LOOKS_SAYFORSECS": "ce %1 sau daƙiƙai %2",
    "LOOKS_SAY": "ce %1",
    "LOOKS_HELLO": "Sannu!",
    "LOOKS_THINKFORSECS": "yi tunanin %1 sau daƙiƙai %2 ",
    "LOOKS_THINK": "yi tunanin %1",
    "LOOKS_HMM": "Hmm....",
    "LOOKS_SHOW": "nuna ",
    "LOOKS_HIDE": "ɓoye",
    "LOOKS_HIDEALLSPRITES": "ɓoye duka sprites",
    "LOOKS_EFFECT_COLOR": "launi",
    "LOOKS_EFFECT_FISHEYE": "idonkifi ",
    "LOOKS_EFFECT_WHIRL": "juyawa da sauri",
    "LOOKS_EFFECT_PIXELATE": "rabe zuwa ƙananan ɗigon hoto",
    "LOOKS_EFFECT_MOSAIC": "haɗuwar ƙananan hotuna",
    "LOOKS_EFFECT_BRIGHTNESS": "haske",
    "LOOKS_EFFECT_GHOST": "fatalwa ",
    "LOOKS_CHANGEEFFECTBY": "canza tsarin %1 zuwa %2",
    "LOOKS_SETEFFECTTO": "saita tsarin %1 zuwa %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "share tsarin zanen",
    "LOOKS_CHANGESIZEBY": "canza girman da %1",
    "LOOKS_SETSIZETO": "saita girman zuwa %1 %",
    "LOOKS_SIZE": "girma",
    "LOOKS_CHANGESTRETCHBY": "canza miƙewa da %1",
    "LOOKS_SETSTRETCHTO": "saita miƙewa zuwa %1 %",
    "LOOKS_SWITCHCOSTUMETO": "sauya fasalin zuwa %1",
    "LOOKS_NEXTCOSTUME": "fasali na gaba",
    "LOOKS_SWITCHBACKDROPTO": "sauya hoton fage zuwa %1",
    "LOOKS_GOTOFRONTBACK": "je zuwa shimfiɗar %1 ",
    "LOOKS_GOTOFRONTBACK_FRONT": "gaba",
    "LOOKS_GOTOFRONTBACK_BACK": "baya",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "je zuwa shimfiɗun %1 %2 ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "na gaba",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "na baya",
    "LOOKS_BACKDROPNUMBERNAME": "hoton fagen %1",
    "LOOKS_COSTUMENUMBERNAME": "fasalin %1",
    "LOOKS_NUMBERNAME_NUMBER": "lamba",
    "LOOKS_NUMBERNAME_NAME": "suna",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "sauya hoton fage zuwa %1 kuma a jira",
    "LOOKS_NEXTBACKDROP_BLOCK": "hoton fage na gaba",
    "LOOKS_NEXTBACKDROP": "hoton fage na gaba",
    "LOOKS_PREVIOUSBACKDROP": "hoton fage na baya",
    "LOOKS_RANDOMBACKDROP": "hoton fage a hargitse",
    "MOTION_MOVESTEPS": "matsa matakai %1",
    "MOTION_TURNLEFT": "juya digiri %1 %2",
    "MOTION_TURNRIGHT": "juya digiri %1 %2 ",
    "MOTION_POINTINDIRECTION": "nuna mafuskantar %1",
    "MOTION_POINTTOWARDS": "yi nuni zuwa %1",
    "MOTION_POINTTOWARDS_POINTER": "manunin-linzamin kwamfuta",
    "MOTION_POINTTOWARDS_RANDOM": "mafuskanta a hargitse",
    "MOTION_GOTO": "je zuwa %1",
    "MOTION_GOTO_POINTER": "manunin-linzamin kwamfuta",
    "MOTION_GOTO_RANDOM": "matsayi a hargitse",
    "MOTION_GOTOXY": "je zuwa x:%1 y:%2",
    "MOTION_GLIDESECSTOXY": "matsa daƙiƙai %1 zuwa x: %2 y: %3",
    "MOTION_GLIDETO": "matsa daƙiƙai %1 zuwa %2",
    "MOTION_GLIDETO_POINTER": "manunin-linzamin kwamfuta",
    "MOTION_GLIDETO_RANDOM": "matsayi a hargitse",
    "MOTION_CHANGEXBY": "canza x da %1",
    "MOTION_SETX": "saita x zuwa %1",
    "MOTION_CHANGEYBY": "canza y da %1",
    "MOTION_SETY": "saita y zuwa %1",
    "MOTION_IFONEDGEBOUNCE": "idan a baki, yi tsalle mai maimaituwa",
    "MOTION_SETROTATIONSTYLE": "saita salon juyawa %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "hagu-dama",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "kar a juya",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "a ko'ina",
    "MOTION_XPOSITION": "matsayin x",
    "MOTION_YPOSITION": "matsayin y",
    "MOTION_DIRECTION": "mafuskanta",
    "MOTION_SCROLLRIGHT": "gungura dama %1",
    "MOTION_SCROLLUP": "gungura sama %1",
    "MOTION_ALIGNSCENE": "daidaita yanayin %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ƙasa ta hagu",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ƙasa ta dama",
    "MOTION_ALIGNSCENE_MIDDLE": "tsakiya ",
    "MOTION_ALIGNSCENE_TOPLEFT": "sama ta hagu",
    "MOTION_ALIGNSCENE_TOPRIGHT": "sama ta dama",
    "MOTION_XSCROLL": "gungura x",
    "MOTION_YSCROLL": "gungura y",
    "MOTION_STAGE_SELECTED": "Matakin da aka zaɓa: babu tubalan motsi",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2 ",
    "OPERATORS_RANDOM": "zaɓa a hargitse %1 zuwa %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 da %2",
    "OPERATORS_OR": "%1 ko %2",
    "OPERATORS_NOT": "ba %1 ba",
    "OPERATORS_JOIN": "haɗa %1 %2",
    "OPERATORS_JOIN_APPLE": "tuffa",
    "OPERATORS_JOIN_BANANA": "ayaba",
    "OPERATORS_LETTEROF": "harafin %1 na %2 ",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "tsayin %1",
    "OPERATORS_CONTAINS": "%1 ya ƙunshi %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "zagaye %1",
    "OPERATORS_MATHOP": "%1 na %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "ƙasa",
    "OPERATORS_MATHOP_CEILING": "rufi",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "In",
    "OPERATORS_MATHOP_LOG": "log ",
    "OPERATORS_MATHOP_EEXP": "e ^ ",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "ayyana %1",
    "SENSING_TOUCHINGOBJECT": "taɓawar %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "manunin-linzamin kwanfuta",
    "SENSING_TOUCHINGOBJECT_EDGE": "baki",
    "SENSING_TOUCHINGCOLOR": "taɓawar launin %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "launin %1 yana taɓa %2?",
    "SENSING_DISTANCETO": "nisa zuwa %1",
    "SENSING_DISTANCETO_POINTER": "manunin-linzamin kwamfuta",
    "SENSING_ASKANDWAIT": "tambayi %1 kuma a jira",
    "SENSING_ASK_TEXT": "menene sunanka?",
    "SENSING_ANSWER": "amsa",
    "SENSING_KEYPRESSED": "madannin %1 a danne?",
    "SENSING_MOUSEDOWN": "linzamin kwamfuta ya yi ƙasa?",
    "SENSING_MOUSEX": "linzamin kwamfuta x",
    "SENSING_MOUSEY": "linzamin kwamfuta y",
    "SENSING_SETDRAGMODE": "saita yanayin ja %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "mai janyuwa ",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "marar janyuwa ",
    "SENSING_LOUDNESS": "ƙara",
    "SENSING_LOUD": "da ƙara?",
    "SENSING_TIMER": "mai ƙidayar lokaci",
    "SENSING_RESETTIMER": "sake saita mai ƙidayar lokaci",
    "SENSING_OF": "%1 cikin %2",
    "SENSING_OF_XPOSITION": "matsayin x",
    "SENSING_OF_YPOSITION": "matsayin y",
    "SENSING_OF_DIRECTION": "mafuskanta",
    "SENSING_OF_COSTUMENUMBER": "fasali #",
    "SENSING_OF_COSTUMENAME": "sunan fasali",
    "SENSING_OF_SIZE": "girma",
    "SENSING_OF_VOLUME": "ƙarfin sauti",
    "SENSING_OF_BACKDROPNUMBER": "hoton fage",
    "SENSING_OF_BACKDROPNAME": "sunan hoton fage",
    "SENSING_OF_STAGE": "mataki",
    "SENSING_CURRENT": "yanzu %1",
    "SENSING_CURRENT_YEAR": "shekara",
    "SENSING_CURRENT_MONTH": "wata",
    "SENSING_CURRENT_DATE": "kwanan wata",
    "SENSING_CURRENT_DAYOFWEEK": "ranar mako",
    "SENSING_CURRENT_HOUR": "sa'a ",
    "SENSING_CURRENT_MINUTE": "minti ",
    "SENSING_CURRENT_SECOND": "dakika",
    "SENSING_DAYSSINCE2000": "kwanaki tun 2000",
    "SENSING_USERNAME": "sunnan mai amfani",
    "SENSING_USERID": "shaidar mai amfani",
    "SOUND_PLAY": "kunna sautin %1",
    "SOUND_PLAYUNTILDONE": "kunna sautin %1 har sai angama",
    "SOUND_STOPALLSOUNDS": "dakatar da duka sauti",
    "SOUND_SETEFFECTO": "saita tsarin %1 zuwa %2",
    "SOUND_CHANGEEFFECTBY": "canza tsarin %1 da %2",
    "SOUND_CLEAREFFECTS": "share tsarin sauti",
    "SOUND_EFFECTS_PITCH": "tsarin sauti",
    "SOUND_EFFECTS_PAN": "fitar da sauti a hagu/dama",
    "SOUND_CHANGEVOLUMEBY": "canza ƙarfin sauti da %1",
    "SOUND_SETVOLUMETO": "saita ƙarfin sauti zuwa %1% ",
    "SOUND_VOLUME": "ƙarfin sauti",
    "SOUND_RECORD": "Ɗaukar tariya...",
    "CATEGORY_MOTION": "motsi",
    "CATEGORY_LOOKS": "yanayin bayyana",
    "CATEGORY_SOUND": "sauti ",
    "CATEGORY_EVENTS": "yanayin faruwar abubuwa",
    "CATEGORY_CONTROL": "sarrafawa",
    "CATEGORY_SENSING": "ganowa",
    "CATEGORY_OPERATORS": "ma'alaƙanta",
    "CATEGORY_VARIABLES": "abubuwa masu canzawa",
    "CATEGORY_MYBLOCKS": "tubalai na",
    "DUPLICATE": "kwafa",
    "DELETE": "goge",
    "ADD_COMMENT": "ƙara tsokaci ",
    "REMOVE_COMMENT": "cire tsokaci",
    "DELETE_BLOCK": "goge tubali",
    "DELETE_X_BLOCKS": "goge tubalan %1",
    "DELETE_ALL_BLOCKS": "goge duka tubalan %1 ",
    "CLEAN_UP": "tsabtace tubalai",
    "HELP": "taimoko",
    "UNDO": "warware ",
    "REDO": "sake yi",
    "EDIT_PROCEDURE": "gyara",
    "SHOW_PROCEDURE_DEFINITION": "je zuwa ma'ana",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "faɗi wani abu...",
    "COLOUR_HUE_LABEL": "launi",
    "COLOUR_SATURATION_LABEL": "yanayin launi",
    "COLOUR_BRIGHTNESS_LABEL": "haske",
    "CHANGE_VALUE_TITLE": "canza daraja",
    "RENAME_VARIABLE": "Sake sunan abu mai canzawa",
    "RENAME_VARIABLE_TITLE": "sake sunan duka abu mai canzawa na \"%1\" zuwa:",
    "RENAME_VARIABLE_MODAL_TITLE": "sake sunan abu mai canzawa",
    "NEW_VARIABLE": "haɗa abu mai canzawa",
    "NEW_VARIABLE_TITLE": "sunan sabon abu mai canzawa: ",
    "VARIABLE_MODAL_TITLE": "sabon abu mai canzawa",
    "VARIABLE_ALREADY_EXISTS": "tuni akwai abu mai canzawa mai suna \"%1\" ",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "tuni akwai abu mai canzawa mai suna \"%1\" ga wani abu mai canzawa irin \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "goge amfanonin %1 na daga abu mai canzawan \"%2\" ",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Ba za a iya goge abu mai canzawan \"%1\" ba saboda yana wani bangare na aikin \"%2\"",
    "DELETE_VARIABLE": "goge abu mai canzawan \"%1\" ",
    "NEW_PROCEDURE": "haɗa wani tubali",
    "PROCEDURE_ALREADY_EXISTS": "tuni akwai hanya mai suna \"%1\" ",
    "PROCEDURE_DEFAULT_NAME": "sunan tubali",
    "PROCEDURE_USED": "dan goge ma'anar tubali, da farko cire duk amfanonin tubalin",
    "NEW_LIST": "yi wani jeri",
    "NEW_LIST_TITLE": "sunan sabon jeri",
    "LIST_MODAL_TITLE": "sabon jeri",
    "LIST_ALREADY_EXISTS": "tuni akwai wani jeri mai suna \"%1\".",
    "RENAME_LIST_TITLE": "sake sunan duka jerin \"%1\" zuwa:",
    "RENAME_LIST_MODAL_TITLE": "sake sunan Jeri",
    "DEFAULT_LIST_ITEM": "abu",
    "DELETE_LIST": "goge jerin \"%1\".",
    "RENAME_LIST": "sake sunan jeri",
    "NEW_BROADCAST_MESSAGE": "sabon saƙo",
    "NEW_BROADCAST_MESSAGE_TITLE": "sunan sabon saƙo:",
    "BROADCAST_MODAL_TITLE": "sabon saƙo",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "saƙon1"
  },
  "hy": {
    "CONTROL_FOREVER": "անվերջ",
    "CONTROL_REPEAT": "կրկնել %1",
    "CONTROL_IF": "եթե %1 ապա",
    "CONTROL_ELSE": "այլապես",
    "CONTROL_STOP": "դադարեցնել",
    "CONTROL_STOP_ALL": "ամբողջը",
    "CONTROL_STOP_THIS": "այս սցենարը",
    "CONTROL_STOP_OTHER": "կերպարի այլ սցենարները",
    "CONTROL_WAIT": "սպասել %1 վայրկյան",
    "CONTROL_WAITUNTIL": "սպասել մինչև %1",
    "CONTROL_REPEATUNTIL": "կրկնել մինչև %1",
    "CONTROL_WHILE": "մինչդեռ %1",
    "CONTROL_FOREACH": "բոլորի %1 -ի համար %2 -ում",
    "CONTROL_STARTASCLONE": "Երբ սկսում եմ որպես կրկնօրինակ",
    "CONTROL_CREATECLONEOF": "ստեղծել  %1-ի կրկնօրինակը ",
    "CONTROL_CREATECLONEOF_MYSELF": "իմ",
    "CONTROL_DELETETHISCLONE": "ջնջել այս կրկնօրինակը",
    "CONTROL_COUNTER": "հաշվիչ",
    "CONTROL_INCRCOUNTER": "մեծացնել հաշվիչը",
    "CONTROL_CLEARCOUNTER": "մաքրել հաշվիչը",
    "CONTROL_ALLATONCE": "բոլորը միասին",
    "DATA_SETVARIABLETO": "%1 -ը՝ %2",
    "DATA_CHANGEVARIABLEBY": "փոխել %1 -ը  %2 -ով",
    "DATA_SHOWVARIABLE": "ցույց տալ %1 փոփոխականը  ",
    "DATA_HIDEVARIABLE": "թաքցնել  %1 փոփոխականը",
    "DATA_ADDTOLIST": "ավելացնել %1 -ը %2 -ին",
    "DATA_DELETEOFLIST": "ջնջել %1 -ը %2 -ից",
    "DATA_DELETEALLOFLIST": "ջնջել %1 -ի ամենը",
    "DATA_INSERTATLIST": "%3 -ի %2 -ում զետեղել %1 -ը",
    "DATA_REPLACEITEMOFLIST": "փոխարինել %1 տարրը %2-ից  %3-ով",
    "DATA_ITEMOFLIST": "%2 -ի %1 տարրը ",
    "DATA_ITEMNUMOFLIST": "%1 տարրի համարը %2 -ում",
    "DATA_LENGTHOFLIST": "%1 -ի երկարությունը",
    "DATA_LISTCONTAINSITEM": " %1-ը պարունակու՞մ է %2",
    "DATA_SHOWLIST": "ցույց տալ %1 ցուցակը",
    "DATA_HIDELIST": "թաքցնել %1 ցուցակը",
    "DATA_INDEX_ALL": "ամբողջը",
    "DATA_INDEX_LAST": "վերջին",
    "DATA_INDEX_RANDOM": "պատահական",
    "EVENT_WHENFLAGCLICKED": "երբ %1 -ը սեղմված է",
    "EVENT_WHENTHISSPRITECLICKED": "երբ այս կերպարը սեղմված է",
    "EVENT_WHENSTAGECLICKED": "երբ բեմը սեղմված է",
    "EVENT_WHENTOUCHINGOBJECT": "երբ այս կերպարը հպվում է %1 -ին",
    "EVENT_WHENBROADCASTRECEIVED": "երբ ստանում եմ %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "երբ ետնապատկերը փոխարինվում է %1 -ով",
    "EVENT_WHENGREATERTHAN": "երբ %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "վայկյանաչափ",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ձայնի բարձրությունը",
    "EVENT_BROADCAST": "հաղորդել %1",
    "EVENT_BROADCASTANDWAIT": "հաղորդել %1 և սպասել",
    "EVENT_WHENKEYPRESSED": "երբ %1 ստեղնը սեղմված է ",
    "EVENT_WHENKEYPRESSED_SPACE": "բացատ",
    "EVENT_WHENKEYPRESSED_LEFT": "ձախ սլաք",
    "EVENT_WHENKEYPRESSED_RIGHT": "աջ սլաք",
    "EVENT_WHENKEYPRESSED_DOWN": "վար սլաք",
    "EVENT_WHENKEYPRESSED_UP": "վեր սլաք",
    "EVENT_WHENKEYPRESSED_ANY": "ցանկացած",
    "LOOKS_SAYFORSECS": "ասել %1  %2 վայրկյան",
    "LOOKS_SAY": "ասել %1",
    "LOOKS_HELLO": "Ողջու՛յն",
    "LOOKS_THINKFORSECS": "մտածել %1 %2 վայրկյան",
    "LOOKS_THINK": "մտածել %1",
    "LOOKS_HMM": "Հմմմ․․․",
    "LOOKS_SHOW": "ցույց տալ",
    "LOOKS_HIDE": "թաքցնել",
    "LOOKS_HIDEALLSPRITES": "թաքցնել բոլոր կերպարները",
    "LOOKS_EFFECT_COLOR": "գույն",
    "LOOKS_EFFECT_FISHEYE": "ձկան աչք",
    "LOOKS_EFFECT_WHIRL": "մրրիկ",
    "LOOKS_EFFECT_PIXELATE": "պիքսելացնել",
    "LOOKS_EFFECT_MOSAIC": "խճանկար",
    "LOOKS_EFFECT_BRIGHTNESS": "պայծառություն",
    "LOOKS_EFFECT_GHOST": "ուրվական",
    "LOOKS_CHANGEEFFECTBY": "փոխել %1 էֆՖեկտը %2 -ով",
    "LOOKS_SETEFFECTTO": "կիրառել %1 էֆֆեկտը  %2 արժեքով",
    "LOOKS_CLEARGRAPHICEFFECTS": "մաքրել գրաֆիկական էֆեկտները",
    "LOOKS_CHANGESIZEBY": "փոխել չափսը %1 -ով",
    "LOOKS_SETSIZETO": "չափսը՝ %1  %",
    "LOOKS_SIZE": "չափս",
    "LOOKS_CHANGESTRETCHBY": "փոխել ձգվածությունը %1 -ով",
    "LOOKS_SETSTRETCHTO": "ձգվածությունը՝  %1 % ",
    "LOOKS_SWITCHCOSTUMETO": "զգեստը՝ %1 ",
    "LOOKS_NEXTCOSTUME": "հաջորդ զգեստը",
    "LOOKS_SWITCHBACKDROPTO": "ետնապատկերը՝ %1",
    "LOOKS_GOTOFRONTBACK": "գնալ դեպի %1 շերտ",
    "LOOKS_GOTOFRONTBACK_FRONT": "դիմաց",
    "LOOKS_GOTOFRONTBACK_BACK": "ետև",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "գնալ %1 %2 շերտ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "առաջ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "ետ",
    "LOOKS_BACKDROPNUMBERNAME": "ետնապատկեր %1",
    "LOOKS_COSTUMENUMBERNAME": "զգեստ %1",
    "LOOKS_NUMBERNAME_NUMBER": "թիվ",
    "LOOKS_NUMBERNAME_NAME": "անուն",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "Ետնապատկերը փոխարինել %1 -ով և սպասել",
    "LOOKS_NEXTBACKDROP_BLOCK": "հաջորդ ետնապատկերը",
    "LOOKS_NEXTBACKDROP": "հաջորդ ետնապատկերը",
    "LOOKS_PREVIOUSBACKDROP": "նախորդ ետնապատկեր",
    "LOOKS_RANDOMBACKDROP": "պատահական ետնապատկեր",
    "MOTION_MOVESTEPS": "տեղափոխվել %1 քայլ",
    "MOTION_TURNLEFT": "շրջվել %1 %2 աստիճան",
    "MOTION_TURNRIGHT": "շրջվել %1 %2 աստիճան",
    "MOTION_POINTINDIRECTION": "ուղղությունը %1",
    "MOTION_POINTTOWARDS": "ուղղվել դեպի %1",
    "MOTION_POINTTOWARDS_POINTER": "մկնիկի ցուցիչ",
    "MOTION_POINTTOWARDS_RANDOM": "պատահական ուղղություն",
    "MOTION_GOTO": "գնալ դեպի %1",
    "MOTION_GOTO_POINTER": "մկնիկի ցուցիչ",
    "MOTION_GOTO_RANDOM": "պատահական դիրք",
    "MOTION_GOTOXY": "գնալ դեպի x. %1 y. %2",
    "MOTION_GLIDESECSTOXY": "սահել %1 վայրկյան դեպի x. %2 y. %3",
    "MOTION_GLIDETO": "սահել %1 վայրկյան դեպի %2",
    "MOTION_GLIDETO_POINTER": "մկնիկի ցուցիչ",
    "MOTION_GLIDETO_RANDOM": "պատահական դիրք",
    "MOTION_CHANGEXBY": "փոխել x -ը %1 -ով ",
    "MOTION_SETX": "x -ը՝ %1 ",
    "MOTION_CHANGEYBY": "փոխել y -ը %1 -ով",
    "MOTION_SETY": "y -ը՝ %1 ",
    "MOTION_IFONEDGEBOUNCE": "եթե եզրին է, հրվել",
    "MOTION_SETROTATIONSTYLE": "պտույտի ձևը՝ %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "ձախ-աջ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "չպտտել",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "շուրջ բոլորը",
    "MOTION_XPOSITION": "x -ը",
    "MOTION_YPOSITION": "y -ը",
    "MOTION_DIRECTION": "ուղղություն",
    "MOTION_SCROLLRIGHT": "ոլորել աջ %1",
    "MOTION_SCROLLUP": "ոլորել վեր %1",
    "MOTION_ALIGNSCENE": "ուղղել տեսարան %1 -ը",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ստորին-ձախ",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ստորին-աջ",
    "MOTION_ALIGNSCENE_MIDDLE": "մեջտեղ",
    "MOTION_ALIGNSCENE_TOPLEFT": "վերին-ձախ",
    "MOTION_ALIGNSCENE_TOPRIGHT": "վերին-աջ",
    "MOTION_XSCROLL": "ոլորել x-ը",
    "MOTION_YSCROLL": "ոլորել y-ը",
    "MOTION_STAGE_SELECTED": "Բեմն ընտրված է՝  շարժման բլոկներ չկան",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "պատահական թիվ՝ %1 -ից %2 -ը",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 և %2",
    "OPERATORS_OR": "%1 կամ %2",
    "OPERATORS_NOT": "ոչ %1",
    "OPERATORS_JOIN": "%1 -ին միավորել  %2",
    "OPERATORS_JOIN_APPLE": "խնձոր",
    "OPERATORS_JOIN_BANANA": "բանան",
    "OPERATORS_LETTEROF": "%2-ի թիվ %1 տառը ",
    "OPERATORS_LETTEROF_APPLE": "խ",
    "OPERATORS_LENGTH": "%1 տողի երկարությունը",
    "OPERATORS_CONTAINS": " %1 -ը պարունակու՞մ է %2",
    "OPERATORS_MOD": "%1 մնացորդ %2",
    "OPERATORS_ROUND": "կլորացնել %1 -ը",
    "OPERATORS_MATHOP": "%2 -ից %1",
    "OPERATORS_MATHOP_ABS": "մոդուլ",
    "OPERATORS_MATHOP_FLOOR": "ամբողջ թիվ՝ վար",
    "OPERATORS_MATHOP_CEILING": "ամբողջ թիվ՝ վեր",
    "OPERATORS_MATHOP_SQRT": "արմատ",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "սահմանել %1",
    "SENSING_TOUCHINGOBJECT": "հպվու՞մ է %1",
    "SENSING_TOUCHINGOBJECT_POINTER": "մկնիկի ցուցիչ",
    "SENSING_TOUCHINGOBJECT_EDGE": "եզր",
    "SENSING_TOUCHINGCOLOR": "հպվու՞մ է %1 գույնին",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 գույնը հպվու՞մ է %2 ",
    "SENSING_DISTANCETO": "հեռավորությունը մինչև %1",
    "SENSING_DISTANCETO_POINTER": "մկնիկի ցուցիչ",
    "SENSING_ASKANDWAIT": "հարցնել %1 և սպասել",
    "SENSING_ASK_TEXT": "Ի՞նչ է քո անունը։",
    "SENSING_ANSWER": "պատասխան",
    "SENSING_KEYPRESSED": "%1 ստեղնը սեղմվա՞ծ է",
    "SENSING_MOUSEDOWN": "մկնիկն սեղմվա՞ծ է",
    "SENSING_MOUSEX": "մկնիկի x -ը",
    "SENSING_MOUSEY": "մկնիկի y -ը",
    "SENSING_SETDRAGMODE": "տեղափոխման ռեժիմը՝  %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "սահուն",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ընդհատ",
    "SENSING_LOUDNESS": "ձայնի բարձրությունը",
    "SENSING_LOUD": "ձայնը բա՞րձր է",
    "SENSING_TIMER": "վայրկյանաչափ",
    "SENSING_RESETTIMER": "զրոյացնել վայրկյանաչափը",
    "SENSING_OF": "%2 -ի %1 -ը ",
    "SENSING_OF_XPOSITION": "x -ը",
    "SENSING_OF_YPOSITION": " y -ը",
    "SENSING_OF_DIRECTION": "ուղղություն",
    "SENSING_OF_COSTUMENUMBER": "զգեստ #",
    "SENSING_OF_COSTUMENAME": "զգեստի անունը",
    "SENSING_OF_SIZE": "չափս",
    "SENSING_OF_VOLUME": "ձայնը",
    "SENSING_OF_BACKDROPNUMBER": "ետնապատկեր #",
    "SENSING_OF_BACKDROPNAME": "ետնապատկերի անունը",
    "SENSING_OF_STAGE": "Բեմ",
    "SENSING_CURRENT": "ընթացիկ %1",
    "SENSING_CURRENT_YEAR": "տարի",
    "SENSING_CURRENT_MONTH": "ամիս",
    "SENSING_CURRENT_DATE": "ամսաթիվ",
    "SENSING_CURRENT_DAYOFWEEK": "շաբաթվա օր",
    "SENSING_CURRENT_HOUR": "ժամ",
    "SENSING_CURRENT_MINUTE": "րոպե",
    "SENSING_CURRENT_SECOND": "վայրկյան",
    "SENSING_DAYSSINCE2000": "օրերը՝ սկսած 2000-ից",
    "SENSING_USERNAME": "մուտքանուն",
    "SENSING_USERID": "օգտատիրոջ id ",
    "SOUND_PLAY": "սկսել ձայն %1 -ը",
    "SOUND_PLAYUNTILDONE": "արտաբերել %1 ձայնը մինչև ավարտը",
    "SOUND_STOPALLSOUNDS": "դադարեցնել բոլոր ձայները",
    "SOUND_SETEFFECTO": "կիրառել %1 էֆեկտը %2 արժեքով",
    "SOUND_CHANGEEFFECTBY": "փոխել %1 էֆեկտը %2 -ով",
    "SOUND_CLEAREFFECTS": "մաքրել ձայնային էֆեկտները",
    "SOUND_EFFECTS_PITCH": "խոսք",
    "SOUND_EFFECTS_PAN": "տարածում ձախ/աջ",
    "SOUND_CHANGEVOLUMEBY": "փոխել ձայնի բարձրությունը %1 -ով",
    "SOUND_SETVOLUMETO": "ձայնը բարձրությունը՝ %1% ",
    "SOUND_VOLUME": "ձայնը",
    "SOUND_RECORD": "ձայնագրել․․․",
    "CATEGORY_MOTION": "Շարժ",
    "CATEGORY_LOOKS": "Տեսք",
    "CATEGORY_SOUND": "Ձայն",
    "CATEGORY_EVENTS": "Իրադար­­ձություն",
    "CATEGORY_CONTROL": "Կառավա­­րում",
    "CATEGORY_SENSING": "Ընկալում",
    "CATEGORY_OPERATORS": "Հաշվարկ",
    "CATEGORY_VARIABLES": "Փոփոխա­­կան",
    "CATEGORY_MYBLOCKS": "Մասնիկ",
    "DUPLICATE": "Կրկնօրինակել",
    "DELETE": "Ջնջել",
    "ADD_COMMENT": "Ավելացնել մեկնաբանություն",
    "REMOVE_COMMENT": "Ջնջել մեկնաբանությունը",
    "DELETE_BLOCK": "Ջնջել մասնիկը",
    "DELETE_X_BLOCKS": "Ջնջել %1 մասնիկները",
    "DELETE_ALL_BLOCKS": "Ջնջե՞լ բոլոր %1 մասնիկները։",
    "CLEAN_UP": "Մաքրել մասնիկները",
    "HELP": "Օգնություն ",
    "UNDO": "Հետ գնալ",
    "REDO": "Առաջ գնալ",
    "EDIT_PROCEDURE": "Խմբագրել",
    "SHOW_PROCEDURE_DEFINITION": "Գնալ սահմանումը",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Մի բան ասա․․․",
    "COLOUR_HUE_LABEL": "Գույն",
    "COLOUR_SATURATION_LABEL": "Հագեցվածություն",
    "COLOUR_BRIGHTNESS_LABEL": "Պայծառություն",
    "CHANGE_VALUE_TITLE": "Փոխել արժեքը՝",
    "RENAME_VARIABLE": "Անվանափոխել փոփոխականը",
    "RENAME_VARIABLE_TITLE": "Անվանափոխել բոլոր «%1» փոփոխոխականները՝",
    "RENAME_VARIABLE_MODAL_TITLE": "Անվանափոխել փոփոխականը",
    "NEW_VARIABLE": "Ստեղծել փոփոխական",
    "NEW_VARIABLE_TITLE": "Նոր փոփոխականի անունը՝",
    "VARIABLE_MODAL_TITLE": "Նոր փոփոխական",
    "VARIABLE_ALREADY_EXISTS": "«%1» անունով փոփոխական արդեն գոյություն ունի: ",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "«%1» անունով փոփոխականն արդեն առկա է «%2» տիպի մեջ:",
    "DELETE_VARIABLE_CONFIRMATION": "Ջնջե՞լ «%2» փոփոխականի %1 կիրառումը։",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Հնարավոր չէ ջնջել «%1» փոփոխականը, քանի որ այն «%2» ֆունկցիայի սահմանման մասն է:",
    "DELETE_VARIABLE": "Ջնջել «%1» փոփոխականը",
    "NEW_PROCEDURE": "Ստեղծել մասնիկ",
    "PROCEDURE_ALREADY_EXISTS": "«%1» անունով գործողություն արդեն գոյություն ունի:",
    "PROCEDURE_DEFAULT_NAME": "մասնիկի անունը ",
    "PROCEDURE_USED": "Մասնիկը ջնջելու համար, նախ պետք է ջնջել նրա բոլոր կիրառումները:",
    "NEW_LIST": "Ստեղծել ցուցակ",
    "NEW_LIST_TITLE": "Նոր ցուցակի անունը՝",
    "LIST_MODAL_TITLE": "Նոր ցուցակ",
    "LIST_ALREADY_EXISTS": "«%1» անունով ցուցակ արդեն գոյություն ունի:",
    "RENAME_LIST_TITLE": "Անվանափոխել ամբողջ «%1» ցուցակը՝",
    "RENAME_LIST_MODAL_TITLE": "Անվանափոխել ցուցակը",
    "DEFAULT_LIST_ITEM": "առարկա",
    "DELETE_LIST": "Ջնջել  «%1»  ցուցակը",
    "RENAME_LIST": "Անվանափոխել ցուցակը",
    "NEW_BROADCAST_MESSAGE": "Նոր հաղորդագրություն",
    "NEW_BROADCAST_MESSAGE_TITLE": "Նոր հաղորդագրության անունը՝",
    "BROADCAST_MODAL_TITLE": "Նոր հաղորդագրություն",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "հաղորդագրություն1"
  },
  "he": {
    "CONTROL_FOREVER": "לעולמים",
    "CONTROL_REPEAT": "חזור  %1 פעמים",
    "CONTROL_IF": "אם %1 אז",
    "CONTROL_ELSE": "אחרת",
    "CONTROL_STOP": "עצור",
    "CONTROL_STOP_ALL": "הכול",
    "CONTROL_STOP_THIS": "תסריט זה",
    "CONTROL_STOP_OTHER": "תסריטים אחרים בדמות",
    "CONTROL_WAIT": "חכה %1 שניות",
    "CONTROL_WAITUNTIL": "חכה עד ש %1",
    "CONTROL_REPEATUNTIL": "חזור עד ש %1",
    "CONTROL_WHILE": "כל עוד %1",
    "CONTROL_FOREACH": "עבור כל %1 ב %2",
    "CONTROL_STARTASCLONE": "כאשר מופעל ככפיל",
    "CONTROL_CREATECLONEOF": "יצירת כפיל של %1",
    "CONTROL_CREATECLONEOF_MYSELF": "עצמי",
    "CONTROL_DELETETHISCLONE": "מחק כפיל זה",
    "CONTROL_COUNTER": "מונה",
    "CONTROL_INCRCOUNTER": "הגדל מונה",
    "CONTROL_CLEARCOUNTER": "אפס מונה",
    "CONTROL_ALLATONCE": "הכל בבת אחת",
    "DATA_SETVARIABLETO": "קבע %1 ל %2",
    "DATA_CHANGEVARIABLEBY": "שנה %1 ב %2",
    "DATA_SHOWVARIABLE": "הצג משתנה %1",
    "DATA_HIDEVARIABLE": "הסתר משתנה %1",
    "DATA_ADDTOLIST": "הוסף %1 ל %2",
    "DATA_DELETEOFLIST": "מחק פריט %1 מתוך %2",
    "DATA_DELETEALLOFLIST": "מחק הכול מ%1",
    "DATA_INSERTATLIST": "הכנס %1 במקום %2 של %3",
    "DATA_REPLACEITEMOFLIST": "קבע פריט %1 של %2 ל %3",
    "DATA_ITEMOFLIST": "פריט %1 של %2",
    "DATA_ITEMNUMOFLIST": "מספר פריט של %1 ב- %2",
    "DATA_LENGTHOFLIST": "האורך של %1",
    "DATA_LISTCONTAINSITEM": "%1 מכיל %2?",
    "DATA_SHOWLIST": "הצג רשימה %1",
    "DATA_HIDELIST": "הסתר רשימה %1",
    "DATA_INDEX_ALL": "הכול",
    "DATA_INDEX_LAST": "אחרון",
    "DATA_INDEX_RANDOM": "אקראי",
    "EVENT_WHENFLAGCLICKED": "כאשר לוחצים על %1",
    "EVENT_WHENTHISSPRITECLICKED": "כאשר לוחצים על דמות זו",
    "EVENT_WHENSTAGECLICKED": "כאשר לוחצים על הבמה",
    "EVENT_WHENTOUCHINGOBJECT": "כאשר דמות זו נוגעת ב %1",
    "EVENT_WHENBROADCASTRECEIVED": "כאשר מתקבל מסר %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "כאשר הרקע משתנה ל %1",
    "EVENT_WHENGREATERTHAN": "כאשר %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "שעון עצר",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "עוצמת קול",
    "EVENT_BROADCAST": "שדר מסר %1",
    "EVENT_BROADCASTANDWAIT": "שדר מסר %1 וחכה",
    "EVENT_WHENKEYPRESSED": "כאשר נלחץ מקש %1",
    "EVENT_WHENKEYPRESSED_SPACE": "רווח",
    "EVENT_WHENKEYPRESSED_LEFT": "חץ שמאלי",
    "EVENT_WHENKEYPRESSED_RIGHT": "חץ ימני",
    "EVENT_WHENKEYPRESSED_DOWN": "חץ מטה",
    "EVENT_WHENKEYPRESSED_UP": "חץ מעלה",
    "EVENT_WHENKEYPRESSED_ANY": "כל",
    "LOOKS_SAYFORSECS": "אמור %1 למשך %2 שניות",
    "LOOKS_SAY": "אמור %1",
    "LOOKS_HELLO": "שלום!",
    "LOOKS_THINKFORSECS": "חשוב %1 למשך %2 שניות",
    "LOOKS_THINK": "חשוב %1",
    "LOOKS_HMM": "הממ...",
    "LOOKS_SHOW": "הצג",
    "LOOKS_HIDE": "הסתר",
    "LOOKS_HIDEALLSPRITES": "הסתר את כל הדמויות",
    "LOOKS_EFFECT_COLOR": "צבע",
    "LOOKS_EFFECT_FISHEYE": "עין הדג",
    "LOOKS_EFFECT_WHIRL": "סחרור",
    "LOOKS_EFFECT_PIXELATE": "פיקסלים",
    "LOOKS_EFFECT_MOSAIC": "פסיפס",
    "LOOKS_EFFECT_BRIGHTNESS": "בהירות",
    "LOOKS_EFFECT_GHOST": "רוח רפאים",
    "LOOKS_CHANGEEFFECTBY": "שנה אפקט %1 ב %2",
    "LOOKS_SETEFFECTTO": "קבע אפקט %1 ל %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "נקה אפקטים",
    "LOOKS_CHANGESIZEBY": "שנה גודל ב %1",
    "LOOKS_SETSIZETO": "קבע גודל ל %1 %",
    "LOOKS_SIZE": "גודל",
    "LOOKS_CHANGESTRETCHBY": "שנה מתיחה ב %1",
    "LOOKS_SETSTRETCHTO": "קבע מתיחה ל %1",
    "LOOKS_SWITCHCOSTUMETO": "קבע תלבושת ל %1",
    "LOOKS_NEXTCOSTUME": "התלבושת הבאה",
    "LOOKS_SWITCHBACKDROPTO": "קבע רקע ל %1",
    "LOOKS_GOTOFRONTBACK": "העבר לשכבה ה %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "קדמית",
    "LOOKS_GOTOFRONTBACK_BACK": "אחורית",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "העבר %2 שכבות %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "קדימה",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "אחורה",
    "LOOKS_BACKDROPNUMBERNAME": "%1 רקע",
    "LOOKS_COSTUMENUMBERNAME": "%1 תלבושת",
    "LOOKS_NUMBERNAME_NUMBER": "מספר",
    "LOOKS_NUMBERNAME_NAME": "שם",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "החלף רקע ל %1 וחכה",
    "LOOKS_NEXTBACKDROP_BLOCK": "הרקע הבא",
    "LOOKS_NEXTBACKDROP": "הרקע הבא",
    "LOOKS_PREVIOUSBACKDROP": "הרקע הקודם",
    "LOOKS_RANDOMBACKDROP": "רקע אקראי",
    "MOTION_MOVESTEPS": "זוז %1 צעדים",
    "MOTION_TURNLEFT": "הסתובב %1 %2 מעלות",
    "MOTION_TURNRIGHT": "הסתובב %1 %2 מעלות",
    "MOTION_POINTINDIRECTION": "פנה לכיוון %1",
    "MOTION_POINTTOWARDS": "פנה לכיוון של %1",
    "MOTION_POINTTOWARDS_POINTER": "מצביע העכבר",
    "MOTION_POINTTOWARDS_RANDOM": "כיוון אקראי",
    "MOTION_GOTO": "קפוץ אל %1",
    "MOTION_GOTO_POINTER": "מצביע העכבר",
    "MOTION_GOTO_RANDOM": "מיקום אקראי",
    "MOTION_GOTOXY": "קפוץ אל x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "גלוש %1 שניות אל x: %2 y: %3",
    "MOTION_GLIDETO": "גלוש %1 שניות אל %2",
    "MOTION_GLIDETO_POINTER": "סמן העכבר",
    "MOTION_GLIDETO_RANDOM": "מיקום אקראי",
    "MOTION_CHANGEXBY": "שנה את ערך x ב %1",
    "MOTION_SETX": "קבע את ערך x ל %1",
    "MOTION_CHANGEYBY": "שנה את ערך y ב %1",
    "MOTION_SETY": "קבע את ערך y ל %1",
    "MOTION_IFONEDGEBOUNCE": "בנגיעה במסגרת שנה כיוון",
    "MOTION_SETROTATIONSTYLE": "קבע אופן סיבוב %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "שמאל-ימין",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "בטל סיבוב",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "מסביב",
    "MOTION_XPOSITION": "מיקום על ציר x",
    "MOTION_YPOSITION": "מיקום על ציר y",
    "MOTION_DIRECTION": "כיוון",
    "MOTION_SCROLLRIGHT": "גלול ימינה %1",
    "MOTION_SCROLLUP": "גלול למעלה %1",
    "MOTION_ALIGNSCENE": "ישר סצנה %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "למטה־משמאל",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "למטה־מימין",
    "MOTION_ALIGNSCENE_MIDDLE": "אמצעי",
    "MOTION_ALIGNSCENE_TOPLEFT": "למעלה־משמאל",
    "MOTION_ALIGNSCENE_TOPRIGHT": "למעלה־מימין",
    "MOTION_XSCROLL": "גלילה בציר x",
    "MOTION_YSCROLL": "גלילה בציר y",
    "MOTION_STAGE_SELECTED": "נבחרה במה: אין לבנים לתנועה",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%2 - %1",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%2 / %1",
    "OPERATORS_RANDOM": "בחר מספר אקראי בין %1 ל %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 וגם %2",
    "OPERATORS_OR": "%1 או %2",
    "OPERATORS_NOT": "לא %1",
    "OPERATORS_JOIN": "חבר %1 %2",
    "OPERATORS_JOIN_APPLE": "תפוח",
    "OPERATORS_JOIN_BANANA": "בננה",
    "OPERATORS_LETTEROF": "אות %1 של %2",
    "OPERATORS_LETTEROF_APPLE": "ת",
    "OPERATORS_LENGTH": "האורך של %1",
    "OPERATORS_CONTAINS": "%1 מכיל %2?",
    "OPERATORS_MOD": "%1 מודולו %2",
    "OPERATORS_ROUND": "עגל %1",
    "OPERATORS_MATHOP": "%1 של %2",
    "OPERATORS_MATHOP_ABS": "ערך מוחלט",
    "OPERATORS_MATHOP_FLOOR": "עיגול למטה",
    "OPERATORS_MATHOP_CEILING": "עיגול למעלה",
    "OPERATORS_MATHOP_SQRT": "שורש ריבועי",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "‏e בחזקה",
    "OPERATORS_MATHOP_10EXP": "‏10 בחזקה",
    "PROCEDURES_DEFINITION": "הגדר %1",
    "SENSING_TOUCHINGOBJECT": "נוגע ב %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "סמן העכבר",
    "SENSING_TOUCHINGOBJECT_EDGE": "קצה",
    "SENSING_TOUCHINGCOLOR": "נוגע בצבע  %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "צבע %1 נוגע בצבע %2?",
    "SENSING_DISTANCETO": "מרחק אל %1",
    "SENSING_DISTANCETO_POINTER": "סמן העכבר",
    "SENSING_ASKANDWAIT": "שאל %1 והמתן",
    "SENSING_ASK_TEXT": "מה השם שלך?",
    "SENSING_ANSWER": "תשובה",
    "SENSING_KEYPRESSED": "מקש %1 נלחץ?",
    "SENSING_MOUSEDOWN": "עכבר נלחץ?",
    "SENSING_MOUSEX": "מיקום עכבר בציר x",
    "SENSING_MOUSEY": "מיקום עכבר בציר y",
    "SENSING_SETDRAGMODE": "קבע מצב גרירה ל %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ניתן לגרירה",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "לא ניתן לגרירה",
    "SENSING_LOUDNESS": "עוצמת קול",
    "SENSING_LOUD": "עוצמת קול?",
    "SENSING_TIMER": "שעון עצר",
    "SENSING_RESETTIMER": "אפס מונה",
    "SENSING_OF": "%1 של %2",
    "SENSING_OF_XPOSITION": "מיקום על ציר x",
    "SENSING_OF_YPOSITION": "מיקום על ציר y",
    "SENSING_OF_DIRECTION": "כיוון",
    "SENSING_OF_COSTUMENUMBER": "מספר תלבושת",
    "SENSING_OF_COSTUMENAME": "שם תלבושת",
    "SENSING_OF_SIZE": "גודל",
    "SENSING_OF_VOLUME": "עוצמת קול",
    "SENSING_OF_BACKDROPNUMBER": "מספר רקע",
    "SENSING_OF_BACKDROPNAME": "שם רקע",
    "SENSING_OF_STAGE": "במה",
    "SENSING_CURRENT": "%1 נוכחית",
    "SENSING_CURRENT_YEAR": "שנה",
    "SENSING_CURRENT_MONTH": "חודש",
    "SENSING_CURRENT_DATE": "תאריך",
    "SENSING_CURRENT_DAYOFWEEK": "יום בשבוע",
    "SENSING_CURRENT_HOUR": "שעה",
    "SENSING_CURRENT_MINUTE": "דקה",
    "SENSING_CURRENT_SECOND": "שניה",
    "SENSING_DAYSSINCE2000": "ימים מאז 2000",
    "SENSING_USERNAME": "שם משתמש",
    "SENSING_USERID": "זהות המשתמש",
    "SOUND_PLAY": "נגן צליל %1",
    "SOUND_PLAYUNTILDONE": "נגן צליל %1 עד לסיום",
    "SOUND_STOPALLSOUNDS": "הפסק את כל הצלילים",
    "SOUND_SETEFFECTO": "קבע אפקט %1 ל %2",
    "SOUND_CHANGEEFFECTBY": "שנה אפקט %1 ב %2",
    "SOUND_CLEAREFFECTS": "נקה אפקטים קוליים",
    "SOUND_EFFECTS_PITCH": "גובה צליל",
    "SOUND_EFFECTS_PAN": "ערוץ שמע שמאלי/ימני",
    "SOUND_CHANGEVOLUMEBY": "שנה עוצמת קול ב %1",
    "SOUND_SETVOLUMETO": "קבע עוצמת קול ל %1%",
    "SOUND_VOLUME": "עוצמת קול",
    "SOUND_RECORD": "הקלט...",
    "CATEGORY_MOTION": "תנועה",
    "CATEGORY_LOOKS": "מראה",
    "CATEGORY_SOUND": "צלילים",
    "CATEGORY_EVENTS": "אירועים",
    "CATEGORY_CONTROL": "בקרה",
    "CATEGORY_SENSING": "חיישנים",
    "CATEGORY_OPERATORS": "מפעילים",
    "CATEGORY_VARIABLES": "משתנים",
    "CATEGORY_MYBLOCKS": "הלבנים שלי",
    "DUPLICATE": "שכפל",
    "DELETE": "מחק",
    "ADD_COMMENT": "הוספת תגובה",
    "REMOVE_COMMENT": "מחק תגובה",
    "DELETE_BLOCK": "מחק לבנה",
    "DELETE_X_BLOCKS": "מחק %1 לבנים ",
    "DELETE_ALL_BLOCKS": "למחוק את כל הלבנים של %1?",
    "CLEAN_UP": "סדר לבנים",
    "HELP": "עזרה",
    "UNDO": "בטל",
    "REDO": "בצע שוב",
    "EDIT_PROCEDURE": "ערוך",
    "SHOW_PROCEDURE_DEFINITION": "עבור להגדרה",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "כתבו משהו...",
    "COLOUR_HUE_LABEL": "צבע",
    "COLOUR_SATURATION_LABEL": "רווי צבע",
    "COLOUR_BRIGHTNESS_LABEL": "בהירות",
    "CHANGE_VALUE_TITLE": "שנה ערך:",
    "RENAME_VARIABLE": "שנה שם משתנה",
    "RENAME_VARIABLE_TITLE": "שנה שמם של כל המשתנים \"%1\" ל:",
    "RENAME_VARIABLE_MODAL_TITLE": "שנה שם משתנה",
    "NEW_VARIABLE": "יצירת משתנה",
    "NEW_VARIABLE_TITLE": "שם המשתנה החדש",
    "VARIABLE_MODAL_TITLE": "משתנה חדש",
    "VARIABLE_ALREADY_EXISTS": "משתנה בשם \"%1\" כבר קיים",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "משתנה בשם  \"%1\" כבר קיים למשתנה אחר \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "האם  למחוק את %1 השימושים של המשתנה \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "לא ניתן למחוק את המשתנה \"%1\" מפני שזה חלק מהגדרת הפונקציה \"%2\"",
    "DELETE_VARIABLE": "מחק את המשתנה \"%1\"",
    "NEW_PROCEDURE": "יצירת לבנה",
    "PROCEDURE_ALREADY_EXISTS": "פרוצדורה בשם  \"%1\" כבר קיימת",
    "PROCEDURE_DEFAULT_NAME": "שם הלבנה",
    "PROCEDURE_USED": "כדי למחוק הגדרה של בלוק כלשהו, ראשית יש להסיר את כל השימושים של אותו הבלוק",
    "NEW_LIST": "יצירת רשימה",
    "NEW_LIST_TITLE": "שם הרשימה",
    "LIST_MODAL_TITLE": "רשימה חדשה",
    "LIST_ALREADY_EXISTS": "רשימה בשם \"%1\" כבר קיימת",
    "RENAME_LIST_TITLE": "שנה את שם כל  רשימות ־\"%1\"  ל:",
    "RENAME_LIST_MODAL_TITLE": "שנה שם רשימה",
    "DEFAULT_LIST_ITEM": "דבר",
    "DELETE_LIST": "מחק את הרשימה \"%1\"",
    "RENAME_LIST": "תן שם חדש  לרשימה",
    "NEW_BROADCAST_MESSAGE": "מסר חדש",
    "NEW_BROADCAST_MESSAGE_TITLE": "צור מסר חדש",
    "BROADCAST_MODAL_TITLE": "מסר חדש",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "מסר 1"
  },
  "hi": {
    "CONTROL_FOREVER": "सदैव",
    "CONTROL_REPEAT": "%1 बार दोहराएं",
    "CONTROL_IF": "यदि %1 तो",
    "CONTROL_ELSE": "या",
    "CONTROL_STOP": "रोकें ",
    "CONTROL_STOP_ALL": "सब",
    "CONTROL_STOP_THIS": "यह लिपि",
    "CONTROL_STOP_OTHER": "पात्र के लिये दूसरी लिपि ",
    "CONTROL_WAIT": "रुके %1 क्षण ",
    "CONTROL_WAITUNTIL": "रुके %1 क्षण तक ",
    "CONTROL_REPEATUNTIL": "%1  तक दोहराते रहे",
    "CONTROL_WHILE": "जब तक %1 ",
    "CONTROL_FOREACH": "हर एक %1 में %2  ",
    "CONTROL_STARTASCLONE": "मेरे एक क्लोन के रूप में शुरू होने पर",
    "CONTROL_CREATECLONEOF": "%1  का क्लोन  बनायें ",
    "CONTROL_CREATECLONEOF_MYSELF": "स्वताः  ",
    "CONTROL_DELETETHISCLONE": "इस क्लोन को डिलिट करें",
    "CONTROL_COUNTER": "गणक",
    "CONTROL_INCRCOUNTER": " वृद्धि गणक",
    "CONTROL_CLEARCOUNTER": "गणक व्यामार्जन",
    "CONTROL_ALLATONCE": "सब एक बार ",
    "DATA_SETVARIABLETO": "%1 को %2 पर सेट करें",
    "DATA_CHANGEVARIABLEBY": "बदलिए %1 को %2 से ",
    "DATA_SHOWVARIABLE": "वेरिएबल दिखाओ %1 ",
    "DATA_HIDEVARIABLE": "%1 वेरिएबल छुपाओ ",
    "DATA_ADDTOLIST": "%1 को %2 में जोड़ें",
    "DATA_DELETEOFLIST": "%2 का %1 हटाएं",
    "DATA_DELETEALLOFLIST": "%1 का सभी हटाए",
    "DATA_INSERTATLIST": "%3 के %2 को सम्मिलित  करे %1 से",
    "DATA_REPLACEITEMOFLIST": "%2 की %1 चीज बदले %3 से",
    "DATA_ITEMOFLIST": "%2 कि %1 चीज ",
    "DATA_ITEMNUMOFLIST": "%2 में से %1 की चीज #",
    "DATA_LENGTHOFLIST": "%1 की लम्बाई ",
    "DATA_LISTCONTAINSITEM": "%1 में सम्मिलित %2 ?",
    "DATA_SHOWLIST": "%1 सूचि दिखाएँ ",
    "DATA_HIDELIST": "%1 सूचि छुपाए",
    "DATA_INDEX_ALL": "सब",
    "DATA_INDEX_LAST": "आखरी ",
    "DATA_INDEX_RANDOM": "क्रमरहित",
    "EVENT_WHENFLAGCLICKED": "जब %1 क्लिक किए गए",
    "EVENT_WHENTHISSPRITECLICKED": "इस स्प्राईट को क्लिक करने पर",
    "EVENT_WHENSTAGECLICKED": "जब पड़ाव क्लिक किए गए",
    "EVENT_WHENTOUCHINGOBJECT": "जब यह पात्र %1 को स्पर्श करे",
    "EVENT_WHENBROADCASTRECEIVED": "जब %1 प्राप्त हो ",
    "EVENT_WHENBACKDROPSWITCHESTO": "जब पृष्ठभूमि %1 से बदले",
    "EVENT_WHENGREATERTHAN": "जब %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "घड़ी",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "आवाज़ की प्रखरता",
    "EVENT_BROADCAST": "प्रसारण करे %1",
    "EVENT_BROADCASTANDWAIT": "प्रसारण करे %1 और रुकें ",
    "EVENT_WHENKEYPRESSED": "जब %1 कुंजी दबी हो",
    "EVENT_WHENKEYPRESSED_SPACE": "स्पेस ",
    "EVENT_WHENKEYPRESSED_LEFT": "बाएं एरो  ",
    "EVENT_WHENKEYPRESSED_RIGHT": "दाहिना एरो",
    "EVENT_WHENKEYPRESSED_DOWN": "निचला एरो ",
    "EVENT_WHENKEYPRESSED_UP": "उपरी एरो ",
    "EVENT_WHENKEYPRESSED_ANY": "कोई",
    "LOOKS_SAYFORSECS": "%1 को %2 क्षणों तक बोलिए ",
    "LOOKS_SAY": "%1 बोलिए ",
    "LOOKS_HELLO": "नमस्ते!",
    "LOOKS_THINKFORSECS": "%1 को %2 क्षणों तक सोचे ",
    "LOOKS_THINK": "%1 सोचे",
    "LOOKS_HMM": "ह्म...",
    "LOOKS_SHOW": "दिखाएँ ",
    "LOOKS_HIDE": "छुपाएँ",
    "LOOKS_HIDEALLSPRITES": "सभी पात्र छुपाए ",
    "LOOKS_EFFECT_COLOR": "रंग",
    "LOOKS_EFFECT_FISHEYE": "फ़िशआई",
    "LOOKS_EFFECT_WHIRL": "घूमर ",
    "LOOKS_EFFECT_PIXELATE": "धुंधला ",
    "LOOKS_EFFECT_MOSAIC": "कुट्टीभचित्र ",
    "LOOKS_EFFECT_BRIGHTNESS": "चमक",
    "LOOKS_EFFECT_GHOST": "भूत",
    "LOOKS_CHANGEEFFECTBY": "बदले %1 प्रभाव को %2 से ",
    "LOOKS_SETEFFECTTO": "%2 को %1 प्रभाव सेट करें",
    "LOOKS_CLEARGRAPHICEFFECTS": "ग्राफ़िक प्रभाव मिटा दे",
    "LOOKS_CHANGESIZEBY": "%1 से आकर बदले",
    "LOOKS_SETSIZETO": "आकर रखे  %1 %",
    "LOOKS_SIZE": "आकार",
    "LOOKS_CHANGESTRETCHBY": "%1 से तनाव बदले ",
    "LOOKS_SETSTRETCHTO": "%1 % तनाव पर सेट करें",
    "LOOKS_SWITCHCOSTUMETO": "%1 से पोशाख बदले",
    "LOOKS_NEXTCOSTUME": "अगली पोशाक",
    "LOOKS_SWITCHBACKDROPTO": "%1 से पृष्ठभूमि बदले",
    "LOOKS_GOTOFRONTBACK": "%1 आवरण पे जाए ",
    "LOOKS_GOTOFRONTBACK_FRONT": "सामने",
    "LOOKS_GOTOFRONTBACK_BACK": "पीछे",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "पृष्ठ %1 %2 पे जाए ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "आगे की ओर ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "पीछे की ओर ",
    "LOOKS_BACKDROPNUMBERNAME": "%1 पृष्ठभूमि",
    "LOOKS_COSTUMENUMBERNAME": "%1 पोषाख",
    "LOOKS_NUMBERNAME_NUMBER": "अंक",
    "LOOKS_NUMBERNAME_NAME": "नाम",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "पृष्ठभूमि को %1 से बदले और रुके ",
    "LOOKS_NEXTBACKDROP_BLOCK": "अगली पृष्ठभूमि",
    "LOOKS_NEXTBACKDROP": "अगली पृष्ठभूमि",
    "LOOKS_PREVIOUSBACKDROP": "पिछली पृष्ठभूमि",
    "LOOKS_RANDOMBACKDROP": "क्रमरहित पृष्ठभूमि ",
    "MOTION_MOVESTEPS": "%1 कदम बढ़ाए",
    "MOTION_TURNLEFT": "%1 को %2 डिग्री घुमाओ ",
    "MOTION_TURNRIGHT": "%1 %2 अंश घूमें ",
    "MOTION_POINTINDIRECTION": "%1 की दिशा में देखे",
    "MOTION_POINTTOWARDS": "%1 की ओर इंगित करें",
    "MOTION_POINTTOWARDS_POINTER": "माउस-पॉइंटर ",
    "MOTION_POINTTOWARDS_RANDOM": "क्रमरहित दिशा ",
    "MOTION_GOTO": "%1 पर जाएं",
    "MOTION_GOTO_POINTER": "माउस-पॉइंटर ",
    "MOTION_GOTO_RANDOM": "अव्यवस्थित स्थिति ",
    "MOTION_GOTOXY": "x: %1  y: %2 पर जाएं",
    "MOTION_GLIDESECSTOXY": "%1 क्षणों तक फिसले x: %2 y: %3 ",
    "MOTION_GLIDETO": "%1 से %2 क्षणों तक फिसले",
    "MOTION_GLIDETO_POINTER": "माउस-पॉइंटर ",
    "MOTION_GLIDETO_RANDOM": "अव्यवस्थित स्थिति ",
    "MOTION_CHANGEXBY": "x को %1 से बदले",
    "MOTION_SETX": "x को %1 पे रखे",
    "MOTION_CHANGEYBY": "y को %1 से बदले",
    "MOTION_SETY": "y को %1 पे रखे",
    "MOTION_IFONEDGEBOUNCE": "अगर किनारे पर है तो उछाले",
    "MOTION_SETROTATIONSTYLE": "%1 को घूमने का प्रकार चुने",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "बाएँ - दांए",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "मत घूमे ",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "सब ओर",
    "MOTION_XPOSITION": "x स्थिति",
    "MOTION_YPOSITION": "y स्थिति",
    "MOTION_DIRECTION": "दिशा",
    "MOTION_SCROLLRIGHT": "%1 दाहिने सरकाए",
    "MOTION_SCROLLUP": "%1 ऊपर सरकाए",
    "MOTION_ALIGNSCENE": "पंक्तिबद्ध भाव %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "निचला-बाएं",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "नीचे दाएं",
    "MOTION_ALIGNSCENE_MIDDLE": "बीचमें",
    "MOTION_ALIGNSCENE_TOPLEFT": "ऊपरी-बाएं ",
    "MOTION_ALIGNSCENE_TOPRIGHT": "ऊपरी दाएँ ",
    "MOTION_XSCROLL": "x सरकण",
    "MOTION_YSCROLL": "y सरकण ",
    "MOTION_STAGE_SELECTED": "चुनिंदा पड़ाव: कोई गति खंड नहीं",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 से %2 तक में से क्रमरहित चुने",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 और %2",
    "OPERATORS_OR": "%1 या %2",
    "OPERATORS_NOT": "नहीं %1",
    "OPERATORS_JOIN": "जोड़े %1 और %2",
    "OPERATORS_JOIN_APPLE": "सेब ",
    "OPERATORS_JOIN_BANANA": "केला",
    "OPERATORS_LETTEROF": "%2 अक्षर का %1",
    "OPERATORS_LETTEROF_APPLE": "ए",
    "OPERATORS_LENGTH": "%1 की लम्बाई ",
    "OPERATORS_CONTAINS": "%1 में सम्मिलित %2 ?",
    "OPERATORS_MOD": "%1 रुप %2",
    "OPERATORS_ROUND": "घुमाव %1 ",
    "OPERATORS_MATHOP": "%2 का %1",
    "OPERATORS_MATHOP_ABS": "निरपेक्ष मूल्य",
    "OPERATORS_MATHOP_FLOOR": "floor",
    "OPERATORS_MATHOP_CEILING": "ceiling",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10^",
    "PROCEDURES_DEFINITION": "व्याख्या %1",
    "SENSING_TOUCHINGOBJECT": "स्पर्श %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "माउस-पॉइंटर ",
    "SENSING_TOUCHINGOBJECT_EDGE": "किनारा",
    "SENSING_TOUCHINGCOLOR": "%1 रंग को स्पर्श ?",
    "SENSING_COLORISTOUCHINGCOLOR": "%2 द्वारा %1 रंग का स्पर्श",
    "SENSING_DISTANCETO": "%1 की दूरी",
    "SENSING_DISTANCETO_POINTER": "माउस-पॉइंटर ",
    "SENSING_ASKANDWAIT": "पूछे %1 और रुकिए",
    "SENSING_ASK_TEXT": "आपका नाम क्या है?",
    "SENSING_ANSWER": "जवाब",
    "SENSING_KEYPRESSED": "जब बटन %1 दबाया जाए ?",
    "SENSING_MOUSEDOWN": "क्या माउस नीचे है?",
    "SENSING_MOUSEX": "माउस X",
    "SENSING_MOUSEY": "माउस y",
    "SENSING_SETDRAGMODE": "%1 को खींचने का प्रकार चुने",
    "SENSING_SETDRAGMODE_DRAGGABLE": "खींचने योग्य",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "खींचने अयोग्य",
    "SENSING_LOUDNESS": "आवाज़ की प्रबलता",
    "SENSING_LOUD": "जोरसे ?",
    "SENSING_TIMER": "घड़ी",
    "SENSING_RESETTIMER": "घड़ी रीसेट करे",
    "SENSING_OF": "%2 का %1",
    "SENSING_OF_XPOSITION": "x स्थिति",
    "SENSING_OF_YPOSITION": "y स्थिति",
    "SENSING_OF_DIRECTION": "दिशा",
    "SENSING_OF_COSTUMENUMBER": "पोशाक #",
    "SENSING_OF_COSTUMENAME": "पोशाख का नाम",
    "SENSING_OF_SIZE": "आकार",
    "SENSING_OF_VOLUME": "आवाज़",
    "SENSING_OF_BACKDROPNUMBER": "पृष्ठभूमि#",
    "SENSING_OF_BACKDROPNAME": "पृष्ठभूमि का नाम",
    "SENSING_OF_STAGE": "मंच",
    "SENSING_CURRENT": "मौजुदा %1",
    "SENSING_CURRENT_YEAR": "वर्ष",
    "SENSING_CURRENT_MONTH": "महीना",
    "SENSING_CURRENT_DATE": "तारीख",
    "SENSING_CURRENT_DAYOFWEEK": "सप्ताह के दिन",
    "SENSING_CURRENT_HOUR": "घंटा",
    "SENSING_CURRENT_MINUTE": "मिनट",
    "SENSING_CURRENT_SECOND": "क्षण",
    "SENSING_DAYSSINCE2000": "वर्ष 2000 के बाद के दिन",
    "SENSING_USERNAME": "यूज़र नेम",
    "SENSING_USERID": "यूजर आइ डी ",
    "SOUND_PLAY": "आवाज शुरू करे %1",
    "SOUND_PLAYUNTILDONE": "%1 पूरा होने तक आवाज करें",
    "SOUND_STOPALLSOUNDS": "सभी आवाज़ को रोक दे",
    "SOUND_SETEFFECTO": "%2 को %1 प्रभाव सेट करें",
    "SOUND_CHANGEEFFECTBY": "बदले %1 प्रभाव को %2 से ",
    "SOUND_CLEAREFFECTS": "आवाज के प्रभाव को रद्द करें",
    "SOUND_EFFECTS_PITCH": "ध्वनि अंक",
    "SOUND_EFFECTS_PAN": "पुँछ बाएँ / दांए",
    "SOUND_CHANGEVOLUMEBY": "%1 से आवाज बदले",
    "SOUND_SETVOLUMETO": "आवाज की तीव्रता को %1% रखें",
    "SOUND_VOLUME": "आवाज़",
    "SOUND_RECORD": "दर्ज करे...",
    "CATEGORY_MOTION": "चाल",
    "CATEGORY_LOOKS": "रूप",
    "CATEGORY_SOUND": "अवाज",
    "CATEGORY_EVENTS": "घटनाक्रम",
    "CATEGORY_CONTROL": "कंट्रोल",
    "CATEGORY_SENSING": "महसूस",
    "CATEGORY_OPERATORS": "ऑपरेटर्स",
    "CATEGORY_VARIABLES": "चर वस्तुएँ",
    "CATEGORY_MYBLOCKS": "मेरे खण्ड",
    "DUPLICATE": "प्रतिरुप",
    "DELETE": "मिटाये",
    "ADD_COMMENT": "टिप्पणी दे",
    "REMOVE_COMMENT": "टिप्पणी मिटाये",
    "DELETE_BLOCK": "खंड मिटाये",
    "DELETE_X_BLOCKS": "%1 खंड मिटाये",
    "DELETE_ALL_BLOCKS": "सभी %1 खंडों को मिटाये",
    "CLEAN_UP": "खंडो को साफ करे",
    "HELP": "सहायता",
    "UNDO": "पूर्ववत",
    "REDO": "पुनः",
    "EDIT_PROCEDURE": "संपादित करे",
    "SHOW_PROCEDURE_DEFINITION": "व्याख्या पे जाये",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "कुछ कहे ...",
    "COLOUR_HUE_LABEL": "रंग",
    "COLOUR_SATURATION_LABEL": "संतृप्ति",
    "COLOUR_BRIGHTNESS_LABEL": "चमक",
    "CHANGE_VALUE_TITLE": "संख्या बदले",
    "RENAME_VARIABLE": "चर-पद नामकरन",
    "RENAME_VARIABLE_TITLE": "सभी \"%1\" चर-पदों का नाम परिवर्तन करे",
    "RENAME_VARIABLE_MODAL_TITLE": "चर-पद नामकरन",
    "NEW_VARIABLE": "चर-पद बनाये",
    "NEW_VARIABLE_TITLE": "नए चर-पद का नाम",
    "VARIABLE_MODAL_TITLE": "नया चर-पद ",
    "VARIABLE_ALREADY_EXISTS": "\"%1\" नामक चर-पद पहलेसे उपलब्ध ",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "\"%1\" नामक चर-पद पहलेसे उपलब्ध दूसरे चर-पद के लिए \"%2\" लिखे",
    "DELETE_VARIABLE_CONFIRMATION": "\"%2\" चर-पद का %1 उपयोग मिटाये?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "\"%1\" चर-पद को मिटा नहीं सकते, क्योंकि यह समीकरण \"%2\" की व्याख्या का भाग है ",
    "DELETE_VARIABLE": "\"%1\" चर-पद  को मिटाये",
    "NEW_PROCEDURE": "खंड बनाये",
    "PROCEDURE_ALREADY_EXISTS": "\"%1\" नामक कृति पहले से उपलब्ध",
    "PROCEDURE_DEFAULT_NAME": "खंड का नाम",
    "PROCEDURE_USED": "ब्लॉक परिभाषा को हटाने के लिए, पहले ब्लॉक के सभी उपयोगों को हटा दें",
    "NEW_LIST": "सूची बनाये",
    "NEW_LIST_TITLE": "नई सूची का नाम",
    "LIST_MODAL_TITLE": "नई सूची  ",
    "LIST_ALREADY_EXISTS": "\"%1\" नामक सूचि पहले से उपलब्ध है ",
    "RENAME_LIST_TITLE": "सभी \"%1\" सुचिओं का नाम बदलें",
    "RENAME_LIST_MODAL_TITLE": "सूची का नाम बदलें",
    "DEFAULT_LIST_ITEM": "वस्तु",
    "DELETE_LIST": "\"%1\" सूची को मिटायें",
    "RENAME_LIST": "सूची का नाम बदलें",
    "NEW_BROADCAST_MESSAGE": "नया संदेश ",
    "NEW_BROADCAST_MESSAGE_TITLE": "नए संदेश का नाम",
    "BROADCAST_MODAL_TITLE": "नया संदेश ",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "संदेश 1 "
  },
  "hr": {
    "CONTROL_FOREVER": "ponavljaj",
    "CONTROL_REPEAT": "ponovi %1",
    "CONTROL_IF": "ako %1 onda",
    "CONTROL_ELSE": "inače",
    "CONTROL_STOP": "zaustavi",
    "CONTROL_STOP_ALL": "sve",
    "CONTROL_STOP_THIS": "ovaj program",
    "CONTROL_STOP_OTHER": "druge programe lika",
    "CONTROL_WAIT": "čekaj %1 sekundi",
    "CONTROL_WAITUNTIL": "čekaj do %1",
    "CONTROL_REPEATUNTIL": "ponavljaj dok nije %1",
    "CONTROL_WHILE": "dok je %1",
    "CONTROL_FOREACH": "za svaki %1 u %2",
    "CONTROL_STARTASCLONE": "kada krećem kao klon",
    "CONTROL_CREATECLONEOF": "kloniraj %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ja",
    "CONTROL_DELETETHISCLONE": "izbriši klona",
    "CONTROL_COUNTER": "brojač",
    "CONTROL_INCRCOUNTER": "uvečaj brojač",
    "CONTROL_CLEARCOUNTER": "obriši brojač",
    "CONTROL_ALLATONCE": "sve odjednom",
    "DATA_SETVARIABLETO": "postavi %1 na %2",
    "DATA_CHANGEVARIABLEBY": "promijeni %1 za %2",
    "DATA_SHOWVARIABLE": "prikaži varijablu %1",
    "DATA_HIDEVARIABLE": "sakrij varijablu %1",
    "DATA_ADDTOLIST": "dodaj %1 u %2",
    "DATA_DELETEOFLIST": "izbriši %1 iz %2",
    "DATA_DELETEALLOFLIST": "izbriši sve %1",
    "DATA_INSERTATLIST": "umetni %1 na %2 u %3",
    "DATA_REPLACEITEMOFLIST": "zamijeni %1 na %2 s %3",
    "DATA_ITEMOFLIST": "element %1 od %2",
    "DATA_ITEMNUMOFLIST": "element # od %1 u %2",
    "DATA_LENGTHOFLIST": "dužina %1",
    "DATA_LISTCONTAINSITEM": "Sadrži li %1 %2?",
    "DATA_SHOWLIST": "prikaži listu %1",
    "DATA_HIDELIST": "sakrij listu %1",
    "DATA_INDEX_ALL": "sve",
    "DATA_INDEX_LAST": "posljednje",
    "DATA_INDEX_RANDOM": "nasumično",
    "EVENT_WHENFLAGCLICKED": "Kada je kliknuta %1 ",
    "EVENT_WHENTHISSPRITECLICKED": "Kada je lik kliknut",
    "EVENT_WHENSTAGECLICKED": "kada je kliknuto na pozadinu",
    "EVENT_WHENTOUCHINGOBJECT": "kada lik dodiruje %1",
    "EVENT_WHENBROADCASTRECEIVED": "kada primim %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "kada se pozadina promijeni u %1",
    "EVENT_WHENGREATERTHAN": "kada je %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "štoperica",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "glasnoća",
    "EVENT_BROADCAST": "pošalji %1",
    "EVENT_BROADCASTANDWAIT": "pošalji %1 i čekaj",
    "EVENT_WHENKEYPRESSED": "kada je tipka %1 pritisnuta",
    "EVENT_WHENKEYPRESSED_SPACE": "razmaknica",
    "EVENT_WHENKEYPRESSED_LEFT": "strelica lijevo",
    "EVENT_WHENKEYPRESSED_RIGHT": "strelica desno",
    "EVENT_WHENKEYPRESSED_DOWN": "strelica dolje",
    "EVENT_WHENKEYPRESSED_UP": "strelica gore",
    "EVENT_WHENKEYPRESSED_ANY": "bilo koja",
    "LOOKS_SAYFORSECS": "govori %1 %2 sekundi",
    "LOOKS_SAY": "reci %1",
    "LOOKS_HELLO": "Bok!",
    "LOOKS_THINKFORSECS": "razmišljaj %1 %2 sekundi",
    "LOOKS_THINK": "misli %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "prikaži",
    "LOOKS_HIDE": "sakrij",
    "LOOKS_HIDEALLSPRITES": "sakrij sve likove",
    "LOOKS_EFFECT_COLOR": "boja",
    "LOOKS_EFFECT_FISHEYE": "riblje oko",
    "LOOKS_EFFECT_WHIRL": "vrtlog",
    "LOOKS_EFFECT_PIXELATE": "pozrnati",
    "LOOKS_EFFECT_MOSAIC": "mozaik",
    "LOOKS_EFFECT_BRIGHTNESS": "osvjetljenje",
    "LOOKS_EFFECT_GHOST": "duh",
    "LOOKS_CHANGEEFFECTBY": "promijeni efekt %1 za %2",
    "LOOKS_SETEFFECTTO": "promijeni efekt %1 na %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "ukloni grafičke efekte",
    "LOOKS_CHANGESIZEBY": "promijeni veličinu za %1",
    "LOOKS_SETSIZETO": "postavi veličinu na %1 %",
    "LOOKS_SIZE": "veličina",
    "LOOKS_CHANGESTRETCHBY": "promijeni uvećanje za %1",
    "LOOKS_SETSTRETCHTO": "postavi uvećanje na %1",
    "LOOKS_SWITCHCOSTUMETO": "promijeni kostim u %1",
    "LOOKS_NEXTCOSTUME": "sljedeći kostim",
    "LOOKS_SWITCHBACKDROPTO": "promijeni pozadinu na %1",
    "LOOKS_GOTOFRONTBACK": "idi na sloj %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "prednji",
    "LOOKS_GOTOFRONTBACK_BACK": "stražnji",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "idi %1 %2 sloja",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "naprijed",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "natrag",
    "LOOKS_BACKDROPNUMBERNAME": "pozadina %1",
    "LOOKS_COSTUMENUMBERNAME": "kostim %1",
    "LOOKS_NUMBERNAME_NUMBER": "broj",
    "LOOKS_NUMBERNAME_NAME": "ime",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "promijeni pozadinu u %1 i čekaj",
    "LOOKS_NEXTBACKDROP_BLOCK": "sljedeća pozadina",
    "LOOKS_NEXTBACKDROP": "sljedeća pozadina",
    "LOOKS_PREVIOUSBACKDROP": "prethodna pozadina",
    "LOOKS_RANDOMBACKDROP": "nasumična pozadina",
    "MOTION_MOVESTEPS": "idi %1 koraka",
    "MOTION_TURNLEFT": "skreni %1 %2 stupnjeva",
    "MOTION_TURNRIGHT": "skreni %1 %2 stupnjeva",
    "MOTION_POINTINDIRECTION": "okreni se u smjeru %1",
    "MOTION_POINTTOWARDS": "okreni se prema %1",
    "MOTION_POINTTOWARDS_POINTER": "pokazivač miša",
    "MOTION_POINTTOWARDS_RANDOM": "nasumičan smjer",
    "MOTION_GOTO": "idi do %1",
    "MOTION_GOTO_POINTER": "pokazivač miša",
    "MOTION_GOTO_RANDOM": "nasumična pozicija",
    "MOTION_GOTOXY": "idi na x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "klizi %1 sekundi do x: %2 y: %3",
    "MOTION_GLIDETO": "klizi %1 sekundi do %2",
    "MOTION_GLIDETO_POINTER": "pokazivač miša",
    "MOTION_GLIDETO_RANDOM": "nasumična pozicija",
    "MOTION_CHANGEXBY": "promijeni x za %1",
    "MOTION_SETX": "postavi x na %1",
    "MOTION_CHANGEYBY": "promijeni y za %1",
    "MOTION_SETY": "postavi y na %1",
    "MOTION_IFONEDGEBOUNCE": "ako si na rubu, okreni se",
    "MOTION_SETROTATIONSTYLE": "postavi stil rotacije %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "lijevo-desno",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ne rotiraj",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "sve unaokolo",
    "MOTION_XPOSITION": "x položaj",
    "MOTION_YPOSITION": "y položaj",
    "MOTION_DIRECTION": "smjer",
    "MOTION_SCROLLRIGHT": "zrcali desno %1",
    "MOTION_SCROLLUP": "zrcali gore %1",
    "MOTION_ALIGNSCENE": "poravnanje scene %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "dolje-lijevo",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "dolje-desno",
    "MOTION_ALIGNSCENE_MIDDLE": "sredina",
    "MOTION_ALIGNSCENE_TOPLEFT": "gore-lijevo",
    "MOTION_ALIGNSCENE_TOPRIGHT": "gore-desno",
    "MOTION_XSCROLL": "x klizanje",
    "MOTION_YSCROLL": "y klizanje",
    "MOTION_STAGE_SELECTED": "Pozornica je izabrana: nema blokova za kretanje",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "slučajan broj od %1 do %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 i %2",
    "OPERATORS_OR": "%1 ili %2",
    "OPERATORS_NOT": "nije %1",
    "OPERATORS_JOIN": "spoji %1 %2",
    "OPERATORS_JOIN_APPLE": "jabuka",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "slovo %1 od %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "dužina %1",
    "OPERATORS_CONTAINS": "%1 sadrži %2",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "zaokruži %1",
    "OPERATORS_MATHOP": "%1 od %2",
    "OPERATORS_MATHOP_ABS": "apsolutno",
    "OPERATORS_MATHOP_FLOOR": "donja vrijednost",
    "OPERATORS_MATHOP_CEILING": "gornja vrijednost",
    "OPERATORS_MATHOP_SQRT": "korijen",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definiraj %1",
    "SENSING_TOUCHINGOBJECT": "dodiruje %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "pokazivač miša",
    "SENSING_TOUCHINGOBJECT_EDGE": "rub",
    "SENSING_TOUCHINGCOLOR": "dodiruje boju %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "boja %1 dodiruje %2?",
    "SENSING_DISTANCETO": "udaljenost do %1",
    "SENSING_DISTANCETO_POINTER": "pokazivač miša",
    "SENSING_ASKANDWAIT": "pitaj %1 i čekaj",
    "SENSING_ASK_TEXT": "Kako se zoveš?",
    "SENSING_ANSWER": "odgovor",
    "SENSING_KEYPRESSED": "tipka %1 pritisnuta?",
    "SENSING_MOUSEDOWN": "miš pritisnut?",
    "SENSING_MOUSEX": "miš x",
    "SENSING_MOUSEY": "miš y",
    "SENSING_SETDRAGMODE": "postavi način povlačenja na %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "moguće povlačenje",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "bez povlačenja",
    "SENSING_LOUDNESS": "glasnoća",
    "SENSING_LOUD": "glasno?",
    "SENSING_TIMER": "štoperica",
    "SENSING_RESETTIMER": "poništi štopericu",
    "SENSING_OF": "%1 od %2",
    "SENSING_OF_XPOSITION": "x položaj",
    "SENSING_OF_YPOSITION": "y položaj",
    "SENSING_OF_DIRECTION": "smjer",
    "SENSING_OF_COSTUMENUMBER": "kostim #",
    "SENSING_OF_COSTUMENAME": "naziv kostima",
    "SENSING_OF_SIZE": "veličina",
    "SENSING_OF_VOLUME": "jačina zvuka",
    "SENSING_OF_BACKDROPNUMBER": "pozadina #",
    "SENSING_OF_BACKDROPNAME": "naziv pozadine",
    "SENSING_OF_STAGE": "Pozornica",
    "SENSING_CURRENT": "trenutna %1",
    "SENSING_CURRENT_YEAR": "godina",
    "SENSING_CURRENT_MONTH": "mjesec",
    "SENSING_CURRENT_DATE": "dan",
    "SENSING_CURRENT_DAYOFWEEK": "dan u tjednu",
    "SENSING_CURRENT_HOUR": "sat",
    "SENSING_CURRENT_MINUTE": "minuta",
    "SENSING_CURRENT_SECOND": "sekunda",
    "SENSING_DAYSSINCE2000": "dana od 2000",
    "SENSING_USERNAME": "nadimak",
    "SENSING_USERID": "korisnički id",
    "SOUND_PLAY": "sviraj zvuk %1",
    "SOUND_PLAYUNTILDONE": "sviraj zvuk %1 do kraja",
    "SOUND_STOPALLSOUNDS": "zaustavi sve zvukove",
    "SOUND_SETEFFECTO": "promijeni efekt %1 na %2",
    "SOUND_CHANGEEFFECTBY": "promijeni efekt %1 za %2",
    "SOUND_CLEAREFFECTS": "očisti sve efekte zvuka",
    "SOUND_EFFECTS_PITCH": "visina tona",
    "SOUND_EFFECTS_PAN": "kretanje lijevo/desno",
    "SOUND_CHANGEVOLUMEBY": "promijeni glasnoću za %1",
    "SOUND_SETVOLUMETO": "postavi glasnoću na %1%",
    "SOUND_VOLUME": "glasnoća",
    "SOUND_RECORD": "snimaj...",
    "CATEGORY_MOTION": "Kretanje",
    "CATEGORY_LOOKS": "Izgled",
    "CATEGORY_SOUND": "Zvuk",
    "CATEGORY_EVENTS": "Događaji",
    "CATEGORY_CONTROL": "Upravljanje",
    "CATEGORY_SENSING": "Očitanja",
    "CATEGORY_OPERATORS": "Operacije",
    "CATEGORY_VARIABLES": "Varijable",
    "CATEGORY_MYBLOCKS": "Moji Blokovi",
    "DUPLICATE": "Dupliciraj",
    "DELETE": "Izbriši",
    "ADD_COMMENT": "Dodaj komentar",
    "REMOVE_COMMENT": "Ukloni komentar",
    "DELETE_BLOCK": "Izbriši blok",
    "DELETE_X_BLOCKS": "Izbriši %1 blokove",
    "DELETE_ALL_BLOCKS": "Izbriši sve %1 blokove?",
    "CLEAN_UP": "Očisti blokove",
    "HELP": "Pomoć",
    "UNDO": "Poništi",
    "REDO": "Ponovi",
    "EDIT_PROCEDURE": "Uredi",
    "SHOW_PROCEDURE_DEFINITION": "Idi do definicije",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Reci nešto...",
    "COLOUR_HUE_LABEL": "Boja",
    "COLOUR_SATURATION_LABEL": "Saturacija",
    "COLOUR_BRIGHTNESS_LABEL": "Osvjetljenje",
    "CHANGE_VALUE_TITLE": "Promijeni vrijednost:",
    "RENAME_VARIABLE": "Preimenuj varijablu",
    "RENAME_VARIABLE_TITLE": "Preimenuj sve \"%1\" varijable u:",
    "RENAME_VARIABLE_MODAL_TITLE": "Preimenuj varijablu",
    "NEW_VARIABLE": "Napravi varijablu",
    "NEW_VARIABLE_TITLE": "Ime varijable:",
    "VARIABLE_MODAL_TITLE": "Nova varijabla",
    "VARIABLE_ALREADY_EXISTS": "Varijabla \"%1\" već postoji.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Varijabla \"%1\" već postoji kod druge varijable tipa \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Izbriši %1 upotrebu varijable \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Ne mogu izbrisati varijablu \"%1\" jer je dio definicije funkcije \"%2\"",
    "DELETE_VARIABLE": "Izbriši varijablu \"%1\"",
    "NEW_PROCEDURE": "Napravi blok",
    "PROCEDURE_ALREADY_EXISTS": "Procedura \"%1\" već postoji.",
    "PROCEDURE_DEFAULT_NAME": "ime bloka",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Napravi listu",
    "NEW_LIST_TITLE": "Novo ime lliste:",
    "LIST_MODAL_TITLE": "Nova lista",
    "LIST_ALREADY_EXISTS": "Lista imena \"%1\" već postoji.",
    "RENAME_LIST_TITLE": "Preimenuj sve \"%1\" liste u:",
    "RENAME_LIST_MODAL_TITLE": "Preimenuj listu",
    "DEFAULT_LIST_ITEM": "stvar",
    "DELETE_LIST": "Izbriši listu \"%1\"",
    "RENAME_LIST": "Preimenuj listu",
    "NEW_BROADCAST_MESSAGE": "Nova poruka",
    "NEW_BROADCAST_MESSAGE_TITLE": "Naziv nove poruke:",
    "BROADCAST_MODAL_TITLE": "Nova poruka",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "poruka1"
  },
  "xh": {
    "CONTROL_FOREVER": "naphakade",
    "CONTROL_REPEAT": "phinda %1",
    "CONTROL_IF": "if %1 then",
    "CONTROL_ELSE": "okunye",
    "CONTROL_STOP": "yima",
    "CONTROL_STOP_ALL": "konke",
    "CONTROL_STOP_THIS": "lo mbhalo",
    "CONTROL_STOP_OTHER": "eminye imibhalo kwispraythi",
    "CONTROL_WAIT": "yima %1 umzuzwana",
    "CONTROL_WAITUNTIL": "linda kude kube %1",
    "CONTROL_REPEATUNTIL": "pinda kude kube %1",
    "CONTROL_WHILE": "ngelixa %1",
    "CONTROL_FOREACH": "nganye %1 kwi %2",
    "CONTROL_STARTASCLONE": "xa ndiqala njengomfanekiso",
    "CONTROL_CREATECLONEOF": "yenza umfanekiso %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mna",
    "CONTROL_DELETETHISCLONE": "cima lomfanekiso",
    "CONTROL_COUNTER": "isibali",
    "CONTROL_INCRCOUNTER": "isibali sikachatha",
    "CONTROL_CLEARCOUNTER": "cima isibali",
    "CONTROL_ALLATONCE": "konke ngaxeshanye",
    "DATA_SETVARIABLETO": "lungiselela %1 ukuya %2",
    "DATA_CHANGEVARIABLEBY": "guqula %1 ngo %2",
    "DATA_SHOWVARIABLE": "bonakalisa i-variable %1",
    "DATA_HIDEVARIABLE": "fihla i-variable %1",
    "DATA_ADDTOLIST": "yongeza %1 ku %2",
    "DATA_DELETEOFLIST": "cima %1 ka %2",
    "DATA_DELETEALLOFLIST": "cima konke okuka %1",
    "DATA_INSERTATLIST": "faka %1 ku %2 ka %3",
    "DATA_REPLACEITEMOFLIST": "beka endaweni yento %1 ka %2 u %3 ",
    "DATA_ITEMOFLIST": "into %1 ye %2",
    "DATA_ITEMNUMOFLIST": "into # ye %1 kwi %2",
    "DATA_LENGTHOFLIST": "Ubude be %1",
    "DATA_LISTCONTAINSITEM": "%1 iqulathe %2",
    "DATA_SHOWLIST": "bonisa uluhlu %1",
    "DATA_HIDELIST": "fihla uluhlu %1",
    "DATA_INDEX_ALL": "konke",
    "DATA_INDEX_LAST": "yokugqibela",
    "DATA_INDEX_RANDOM": "ngokungacwangciswanga",
    "EVENT_WHENFLAGCLICKED": "xa %1 ecofiwe",
    "EVENT_WHENTHISSPRITECLICKED": "ukuba ucofe i-sprite ",
    "EVENT_WHENSTAGECLICKED": "xa ucofe iqonga",
    "EVENT_WHENTOUCHINGOBJECT": "xa esi sprite sichukumisa %1",
    "EVENT_WHENBROADCASTRECEIVED": "xa ndifumana %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "xa umva utshintshela ku %1",
    "EVENT_WHENGREATERTHAN": "xa %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "isigcina xesha",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ingxolo",
    "EVENT_BROADCAST": "usasazo %1",
    "EVENT_BROADCASTANDWAIT": "sasaza %1 ulinde",
    "EVENT_WHENKEYPRESSED": "xa %1 iqhosha licinezelwe",
    "EVENT_WHENKEYPRESSED_SPACE": "isithuba",
    "EVENT_WHENKEYPRESSED_LEFT": "utolo olusekhohlo",
    "EVENT_WHENKEYPRESSED_RIGHT": "utolo olusekunene",
    "EVENT_WHENKEYPRESSED_DOWN": "utolo olungezantsi",
    "EVENT_WHENKEYPRESSED_UP": "utolo oluphezulu",
    "EVENT_WHENKEYPRESSED_ANY": "nayiphi",
    "LOOKS_SAYFORSECS": "yithi %1 i %2 imizuzwana",
    "LOOKS_SAY": "yithi %1",
    "LOOKS_HELLO": "Mholo!",
    "LOOKS_THINKFORSECS": "cinga %1 i %2 yemizuzwana",
    "LOOKS_THINK": "cinga %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "bonisa",
    "LOOKS_HIDE": "fihla",
    "LOOKS_HIDEALLSPRITES": "fihla zonke i-sprites",
    "LOOKS_EFFECT_COLOR": "umbala",
    "LOOKS_EFFECT_FISHEYE": "iliso lentlanzi",
    "LOOKS_EFFECT_WHIRL": "jikeleza",
    "LOOKS_EFFECT_PIXELATE": "yahlula iziqwengana",
    "LOOKS_EFFECT_MOSAIC": "umfanekiso wamatye amancinane",
    "LOOKS_EFFECT_BRIGHTNESS": "ukuqaqamba",
    "LOOKS_EFFECT_GHOST": "isiporho",
    "LOOKS_CHANGEEFFECTBY": "guqula %1 ifuthe ngo %2",
    "LOOKS_SETEFFECTTO": "lungisa %1 ifuthe ku %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "imizobo ecacileyo",
    "LOOKS_CHANGESIZEBY": "guqula ubungakanani %1",
    "LOOKS_SETSIZETO": "lungiselela ubungakanani bube %1 %",
    "LOOKS_SIZE": "ubungakanani",
    "LOOKS_CHANGESTRETCHBY": "guqula ukunweba ngo %1",
    "LOOKS_SETSTRETCHTO": "lungisa ukunweba bube %1 %",
    "LOOKS_SWITCHCOSTUMETO": "guqulela ikhostyum ku %1",
    "LOOKS_NEXTCOSTUME": "elandelayo ikhostyum",
    "LOOKS_SWITCHBACKDROPTO": "guqulelaa umva ku %1",
    "LOOKS_GOTOFRONTBACK": "yiya ku %1 leya",
    "LOOKS_GOTOFRONTBACK_FRONT": "phambili",
    "LOOKS_GOTOFRONTBACK_BACK": "emva",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "yiya kwii %1 %2 leya",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "phambili",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "emva ",
    "LOOKS_BACKDROPNUMBERNAME": "umva %1",
    "LOOKS_COSTUMENUMBERNAME": "ikhostyum %1",
    "LOOKS_NUMBERNAME_NUMBER": "inani",
    "LOOKS_NUMBERNAME_NAME": "igama",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "guqula umva %1 ulinde",
    "LOOKS_NEXTBACKDROP_BLOCK": "umva olandelayo",
    "LOOKS_NEXTBACKDROP": " umva olandelayo",
    "LOOKS_PREVIOUSBACKDROP": "umva ogqithilieyo",
    "LOOKS_RANDOMBACKDROP": "umva ongacwangciswanga",
    "MOTION_MOVESTEPS": "hamba %1 amanyathelo",
    "MOTION_TURNLEFT": "guqula %1 %2 iidigri",
    "MOTION_TURNRIGHT": "guqula %1 %2 iidigri",
    "MOTION_POINTINDIRECTION": "yolatha kwicala %1",
    "MOTION_POINTTOWARDS": "yolatha ngaku %1",
    "MOTION_POINTTOWARDS_POINTER": "impuku salithisi",
    "MOTION_POINTTOWARDS_RANDOM": "icala elingacwangciswanga",
    "MOTION_GOTO": "yiya ku %1",
    "MOTION_GOTO_POINTER": "isalathisi mpuku ",
    "MOTION_GOTO_RANDOM": "indawo engacwangciswangqa",
    "MOTION_GOTOXY": "yiya ku x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "tyibilikela %1 umzuzwana ku x: %2 y: %3",
    "MOTION_GLIDETO": "tyibilikela %1 imizuzwana ku %2",
    "MOTION_GLIDETO_POINTER": "impuku salathisi",
    "MOTION_GLIDETO_RANDOM": "indawo engacwangciswanga",
    "MOTION_CHANGEXBY": "guqula x ngo %1",
    "MOTION_SETX": "ngqamanisa x no %1",
    "MOTION_CHANGEYBY": "guqula y ngo %1",
    "MOTION_SETY": "ngqamanisa y no %1",
    "MOTION_IFONEDGEBOUNCE": "ukuba ucuphekile, taka",
    "MOTION_SETROTATIONSTYLE": "lungisa uhlobo lojikelezo %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "ekhohlo-ekunene",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "sukujikelezisa",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "jikelele",
    "MOTION_XPOSITION": "indawo ka x",
    "MOTION_YPOSITION": "indawo ka y",
    "MOTION_DIRECTION": "ulwalathiso",
    "MOTION_SCROLLRIGHT": "hambisela ekunene %1",
    "MOTION_SCROLLUP": "hambisela phezulu %1",
    "MOTION_ALIGNSCENE": "lungelelanisa imeko %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ezantsi-ekhohlo",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ezantsi-ekunene",
    "MOTION_ALIGNSCENE_MIDDLE": "esiphakathini",
    "MOTION_ALIGNSCENE_TOPLEFT": "phezulu-ekhohlo",
    "MOTION_ALIGNSCENE_TOPRIGHT": "phezulu-ekunene",
    "MOTION_XSCROLL": "x hambisa",
    "MOTION_YSCROLL": "y hambisa",
    "MOTION_STAGE_SELECTED": "iqonga elikhethiweyo: akhukho bhloko inantshukumo ",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "khetha ngokungacwangciswanga %1 ku %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 kunye %2",
    "OPERATORS_OR": "%1 okanye %2",
    "OPERATORS_NOT": "hayi %1",
    "OPERATORS_JOIN": "dibanisa %1 %2",
    "OPERATORS_JOIN_APPLE": "i-apile",
    "OPERATORS_JOIN_BANANA": "i-bhanana",
    "OPERATORS_LETTEROF": "unobumba %1 ku %2",
    "OPERATORS_LETTEROF_APPLE": "i",
    "OPERATORS_LENGTH": "Ubude be %1",
    "OPERATORS_CONTAINS": "%1 iqulathe %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "umjikelo %1",
    "OPERATORS_MATHOP": "%1 ka %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "umgangatho",
    "OPERATORS_MATHOP_CEILING": "isilingi",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "phakathi",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "chaza %1",
    "SENSING_TOUCHINGOBJECT": "ukubamba %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "impuku-salathisi",
    "SENSING_TOUCHINGOBJECT_EDGE": "esiphelweni",
    "SENSING_TOUCHINGCOLOR": "ukubamba umbala %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "umbala %1 ukubamba %2?",
    "SENSING_DISTANCETO": "umgama %1",
    "SENSING_DISTANCETO_POINTER": "impuku-salathisi",
    "SENSING_ASKANDWAIT": "buza %1 ulinde",
    "SENSING_ASK_TEXT": "ngubani igama lakho",
    "SENSING_ANSWER": "phendula",
    "SENSING_KEYPRESSED": "iqhosha %1 licofiwe?",
    "SENSING_MOUSEDOWN": "impuku phantsi?",
    "SENSING_MOUSEX": "impuku x",
    "SENSING_MOUSEY": "impuku y",
    "SENSING_SETDRAGMODE": "lungiselela ubume bokurhuqa %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "iyarhuqeka",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ayirhuqeki",
    "SENSING_LOUDNESS": "ingxolo",
    "SENSING_LOUD": "ingxolo?",
    "SENSING_TIMER": "isibali xesha",
    "SENSING_RESETTIMER": "lungiselela isibali xesha okutsha",
    "SENSING_OF": "%1 ka %2",
    "SENSING_OF_XPOSITION": "indawo x",
    "SENSING_OF_YPOSITION": "indawo y",
    "SENSING_OF_DIRECTION": "ikhondo",
    "SENSING_OF_COSTUMENUMBER": "ikhostyum #",
    "SENSING_OF_COSTUMENAME": "igama lekhostyum",
    "SENSING_OF_SIZE": "ubungakanani",
    "SENSING_OF_VOLUME": "iqondo lesandi",
    "SENSING_OF_BACKDROPNUMBER": "umva",
    "SENSING_OF_BACKDROPNAME": "ingama lomva",
    "SENSING_OF_STAGE": "iqonga",
    "SENSING_CURRENT": "eyangoku %1",
    "SENSING_CURRENT_YEAR": "unyaka",
    "SENSING_CURRENT_MONTH": "inyanga",
    "SENSING_CURRENT_DATE": "umhla",
    "SENSING_CURRENT_DAYOFWEEK": "usuku lweveki",
    "SENSING_CURRENT_HOUR": "iyure",
    "SENSING_CURRENT_MINUTE": "umzuzu",
    "SENSING_CURRENT_SECOND": "umzuzwana",
    "SENSING_DAYSSINCE2000": "intsuku ususela ku 2000",
    "SENSING_USERNAME": "igama lomsebenzisi",
    "SENSING_USERID": "isazisi somsebenzisi",
    "SOUND_PLAY": "qala isandi%1",
    "SOUND_PLAYUNTILDONE": "dlala isandi %1 side siphele",
    "SOUND_STOPALLSOUNDS": "cima zonke izandi",
    "SOUND_SETEFFECTO": "lungiselela %1 ifuthe ku %2",
    "SOUND_CHANGEEFFECTBY": "tshintsha %1 ifuthe ngo %2",
    "SOUND_CLEAREFFECTS": "ifuthe lesandi esicacileyo",
    "SOUND_EFFECTS_PITCH": "inqanaba",
    "SOUND_EFFECTS_PAN": "bhala ekhohlo/ekunene",
    "SOUND_CHANGEVOLUMEBY": "guqula ubungakanani besandingo %1",
    "SOUND_SETVOLUMETO": "lungiselela ubungakanani besandi ku %1%",
    "SOUND_VOLUME": "ubungakanani besandi",
    "SOUND_RECORD": "shicilela",
    "CATEGORY_MOTION": "intshukumo",
    "CATEGORY_LOOKS": "ujonga",
    "CATEGORY_SOUND": "isandi",
    "CATEGORY_EVENTS": "Iziganeko",
    "CATEGORY_CONTROL": "Lawula",
    "CATEGORY_SENSING": "ukuva",
    "CATEGORY_OPERATORS": "ababhexeshi",
    "CATEGORY_VARIABLES": "iiveriyebhl",
    "CATEGORY_MYBLOCKS": "Ibhloko zam",
    "DUPLICATE": "ukukhuphela",
    "DELETE": "cima",
    "ADD_COMMENT": "faka uluvo",
    "REMOVE_COMMENT": "Susa uluvo",
    "DELETE_BLOCK": "cima iibhloko",
    "DELETE_X_BLOCKS": "cima zonke %1 iibhloko",
    "DELETE_ALL_BLOCKS": "cima zonke %1 ibhloko?",
    "CLEAN_UP": "coca iibhloko",
    "HELP": "nceda",
    "UNDO": "susa",
    "REDO": "phinda",
    "EDIT_PROCEDURE": "lungisa",
    "SHOW_PROCEDURE_DEFINITION": "yiya kwinkcazelo",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "thetha into",
    "COLOUR_HUE_LABEL": "umbala",
    "COLOUR_SATURATION_LABEL": "iqondo lokugqibela",
    "COLOUR_BRIGHTNESS_LABEL": "ukuqaqamba",
    "CHANGE_VALUE_TITLE": "guqula ixabiso",
    "RENAME_VARIABLE": "biza okutsha ivariyebhl",
    "RENAME_VARIABLE_TITLE": "biza okutsha zonke \"%1\" iivariyebhl ku",
    "RENAME_VARIABLE_MODAL_TITLE": "biza okutsha ivariyebhl",
    "NEW_VARIABLE": "yenza iveriyebhl",
    "NEW_VARIABLE_TITLE": "igama elitshe leveriyebhl",
    "VARIABLE_MODAL_TITLE": "ivariyebhl entsha",
    "VARIABLE_ALREADY_EXISTS": "ivariyabhl ebizwa \"%1\" seyikhona.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "ivariyebhl egama \"%1\" seyikhona endaweni yenye ivariyebhl eludidi \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "cima %1 imisebenzi \"%2\" variyebhl?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "awukwazi ukucima ivariyebhl \"%1\" ngoba iyinxalenye yengcaciso yomsebenzi \"%2\"",
    "DELETE_VARIABLE": "cima i \"%1\" variyebhl",
    "NEW_PROCEDURE": "Yenza ibhloko",
    "PROCEDURE_ALREADY_EXISTS": "inkqubo ebizwa \"%1\" seyikhona",
    "PROCEDURE_DEFAULT_NAME": "igama lebhloko",
    "PROCEDURE_USED": "xa ucima  inkcazo yebhloko, qala ngokususa yonke imisebenzi yebhloko.",
    "NEW_LIST": "Yenza uluhlu",
    "NEW_LIST_TITLE": "igama loluhlu elitsha",
    "LIST_MODAL_TITLE": "uluhlu olutsha",
    "LIST_ALREADY_EXISTS": "uluhlu lwamagama abizwa \"%1\" selukhona.",
    "RENAME_LIST_TITLE": "biza ngokutsha lonke \"%1\" uluhlu:",
    "RENAME_LIST_MODAL_TITLE": "biza uluhlu okutsha",
    "DEFAULT_LIST_ITEM": "into",
    "DELETE_LIST": "cima uluhlu i \"%1\"",
    "RENAME_LIST": "biza uluhlu okutsha",
    "NEW_BROADCAST_MESSAGE": "umyalezo omtsha",
    "NEW_BROADCAST_MESSAGE_TITLE": "igama lomyalezo elitsha",
    "BROADCAST_MODAL_TITLE": "umyalezo omtsha",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "umyalezo1"
  },
  "zu": {
    "CONTROL_FOREVER": "phakade ",
    "CONTROL_REPEAT": "phinda %1 ",
    "CONTROL_IF": "uma %1 lapho ke",
    "CONTROL_ELSE": " noma ",
    "CONTROL_STOP": "ima",
    "CONTROL_STOP_ALL": "konke",
    "CONTROL_STOP_THIS": "lo mbhalo",
    "CONTROL_STOP_OTHER": "eminye imibhalo kumlingisi",
    "CONTROL_WAIT": "linda %1 umzuzuwana",
    "CONTROL_WAITUNTIL": "linda kuze kube  %1",
    "CONTROL_REPEATUNTIL": "phinda kuze kube %1",
    "CONTROL_WHILE": "ngenkathi %1",
    "CONTROL_FOREACH": "ngokunye %1 phakathi kwe %2",
    "CONTROL_STARTASCLONE": "lapho ngiqala njengo mfanekiso ",
    "CONTROL_CREATECLONEOF": " akha okufanayo %1 ",
    "CONTROL_CREATECLONEOF_MYSELF": "mina uqobo",
    "CONTROL_DELETETHISCLONE": " Susa lumfanekiso ",
    "CONTROL_COUNTER": "isibali ",
    "CONTROL_INCRCOUNTER": " isibali sokukhuphula",
    "CONTROL_CLEARCOUNTER": "susa isibali ",
    "CONTROL_ALLATONCE": "konke ngesikhathi esisodwa ",
    "DATA_SETVARIABLETO": "lungisa %1 sibe ku %2",
    "DATA_CHANGEVARIABLEBY": "shintsha %1 ngoku %2 ",
    "DATA_SHOWVARIABLE": " khombisa okuguqukayo nge %1 ",
    "DATA_HIDEVARIABLE": "fihla okuguqukayo ngokwe %1",
    "DATA_ADDTOLIST": "engeza %1 kuya %2",
    "DATA_DELETEOFLIST": " susa %1 ka %2 ",
    "DATA_DELETEALLOFLIST": "susa konke %1",
    "DATA_INSERTATLIST": "faka  u %1 ku %2 ka %3",
    "DATA_REPLACEITEMOFLIST": "faka okunye esikhundleni %1 ku %2 ngo %3",
    "DATA_ITEMOFLIST": "into %1 ye %2",
    "DATA_ITEMNUMOFLIST": "into # yaku %1 ku %2",
    "DATA_LENGTHOFLIST": "ubude be %1",
    "DATA_LISTCONTAINSITEM": "%1 iqukethe %2 ",
    "DATA_SHOWLIST": "khombisa uhlu %1 ",
    "DATA_HIDELIST": "fihla uluhlu le %1 ",
    "DATA_INDEX_ALL": "konke ",
    "DATA_INDEX_LAST": "okokugcina",
    "DATA_INDEX_RANDOM": "okungahleliwe",
    "EVENT_WHENFLAGCLICKED": "uma %1 kuchofoziwe ",
    "EVENT_WHENTHISSPRITECLICKED": "Uma lomlingisi echofoziwe ",
    "EVENT_WHENSTAGECLICKED": "uma isiteji ichofoziwe",
    "EVENT_WHENTOUCHINGOBJECT": "uma lomlingisi ethinta %1",
    "EVENT_WHENBROADCASTRECEIVED": " lapho ngithola %1 ",
    "EVENT_WHENBACKDROPSWITCHESTO": "lapho okwasemuva kushintshela ku %1",
    "EVENT_WHENGREATERTHAN": "uma %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "isibali sikhathi ",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ubukhulu bomsindo",
    "EVENT_BROADCAST": "sakaza %1",
    "EVENT_BROADCASTANDWAIT": "sakaza %1 bese ulinda",
    "EVENT_WHENKEYPRESSED": "uma sekucindezelwe ukhiye %1",
    "EVENT_WHENKEYPRESSED_SPACE": "isikhala",
    "EVENT_WHENKEYPRESSED_LEFT": "umcibisholo ongakwesokunxele",
    "EVENT_WHENKEYPRESSED_RIGHT": "umcibilisholo ongakwesokudla",
    "EVENT_WHENKEYPRESSED_DOWN": "umcibisholo waphansi",
    "EVENT_WHENKEYPRESSED_UP": "umcibilisholo ophezulu",
    "EVENT_WHENKEYPRESSED_ANY": "noma yikuphi",
    "LOOKS_SAYFORSECS": "ithi %1 imizuzwana %2 ",
    "LOOKS_SAY": "ithi %1",
    "LOOKS_HELLO": "Sawubona!",
    "LOOKS_THINKFORSECS": "Cabanga %1 okwemizuzwana %2 ",
    "LOOKS_THINK": "cabanga %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "khombisa",
    "LOOKS_HIDE": "fihla",
    "LOOKS_HIDEALLSPRITES": "fihla bonke abalingisi",
    "LOOKS_EFFECT_COLOR": "umbala",
    "LOOKS_EFFECT_FISHEYE": "ihlo likafishi",
    "LOOKS_EFFECT_WHIRL": "isivunguvungu",
    "LOOKS_EFFECT_PIXELATE": "pixelate",
    "LOOKS_EFFECT_MOSAIC": "mosaic",
    "LOOKS_EFFECT_BRIGHTNESS": "ukukhanya",
    "LOOKS_EFFECT_GHOST": "isipoki",
    "LOOKS_CHANGEEFFECTBY": "shintsha  umphumela ongu %1 ngo  %2",
    "LOOKS_SETEFFECTTO": "beka  imiphumela ye %1 uye ku %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "sula imiphumela yokuqhafaza ",
    "LOOKS_CHANGESIZEBY": "shintsha ubukhulu nge %1",
    "LOOKS_SETSIZETO": "Lungisa ubukhulu ubuyise ku %1",
    "LOOKS_SIZE": "Isisindo / Ubukhulu ",
    "LOOKS_CHANGESTRETCHBY": "shinthsa ukwelula ngo %1",
    "LOOKS_SETSTRETCHTO": "lungisa ukwelula ngo%1",
    "LOOKS_SWITCHCOSTUMETO": "shintsha impahla iyeku %1",
    "LOOKS_NEXTCOSTUME": "impahla elandelayo",
    "LOOKS_SWITCHBACKDROPTO": "shintsha okwasemuva ukuyise kwi %1",
    "LOOKS_GOTOFRONTBACK": "hamba ku %1 ngesendlalelo",
    "LOOKS_GOTOFRONTBACK_FRONT": "phambili",
    "LOOKS_GOTOFRONTBACK_BACK": "emuva",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "buyela %1 %2 ngesendlalelo",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "phambili ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "emuva ",
    "LOOKS_BACKDROPNUMBERNAME": "okwasemuva %1",
    "LOOKS_COSTUMENUMBERNAME": "impahla %1",
    "LOOKS_NUMBERNAME_NUMBER": "inombolo",
    "LOOKS_NUMBERNAME_NAME": "igama",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": " shintsha okwasemuva ukuse ku %1 besulinda",
    "LOOKS_NEXTBACKDROP_BLOCK": "okwasemuva okulandelayo",
    "LOOKS_NEXTBACKDROP": "okwasemuva okulandelayo",
    "LOOKS_PREVIOUSBACKDROP": "okwasemuva osekudlulile",
    "LOOKS_RANDOMBACKDROP": "okwasemuva okungahleliwe",
    "MOTION_MOVESTEPS": "hambisa isinyathelo esingu %1",
    "MOTION_TURNLEFT": "Phenduka %1 %2 ibanga ",
    "MOTION_TURNRIGHT": " Phenduka %1 %2 ibanga ",
    "MOTION_POINTINDIRECTION": "khomba ohlangothini %1",
    "MOTION_POINTTOWARDS": "khomba ubhekise %1",
    "MOTION_POINTTOWARDS_POINTER": "isikhombi se mouse",
    "MOTION_POINTTOWARDS_RANDOM": "indlela engahleliwe",
    "MOTION_GOTO": "hamba uyeku  %1     ",
    "MOTION_GOTO_POINTER": "isikhombi se mouse",
    "MOTION_GOTO_RANDOM": "isikhundla esingahleliwe",
    "MOTION_GOTOXY": "hamba uyeku x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "ukushibilika %1 umzuzuwana kwi x: %2 y: %3",
    "MOTION_GLIDETO": "ukushibilika %1 umzuzuwana kwi %2",
    "MOTION_GLIDETO_POINTER": "isikhombi se mouse",
    "MOTION_GLIDETO_RANDOM": "isikhundla esingahleliwe",
    "MOTION_CHANGEXBY": "shintsha u-x ngoku %1",
    "MOTION_SETX": "lungisa u-x umbeke ku %1",
    "MOTION_CHANGEYBY": "shintsha u-y ngokuthi %1",
    "MOTION_SETY": "lungisa u-y ukuze %1",
    "MOTION_IFONEDGEBOUNCE": "uma isenigcupheni, gxuma",
    "MOTION_SETROTATIONSTYLE": "lungisa isitayela sokuzungezisa %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "kwesobunxele-kwesokudla ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "musa ukushintshanisa",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "yonke indawo ",
    "MOTION_XPOSITION": "indawo ka- x ",
    "MOTION_YPOSITION": "indawo ka-y",
    "MOTION_DIRECTION": "indlela",
    "MOTION_SCROLLRIGHT": "sikrolla kwesokudla %1 ",
    "MOTION_SCROLLUP": "sikrola phezulu %1  ",
    "MOTION_ALIGNSCENE": "qondanisa inkundla %1 ",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ngakwesobunxele-ngezansi",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ngakwesokudla-ngezansi ",
    "MOTION_ALIGNSCENE_MIDDLE": "phakathi ",
    "MOTION_ALIGNSCENE_TOPLEFT": "kwesobunxele-phezulu  ",
    "MOTION_ALIGNSCENE_TOPRIGHT": "kwesokudla-phezulu ",
    "MOTION_XSCROLL": "x sikrola ",
    "MOTION_YSCROLL": "y sikrola ",
    "MOTION_STAGE_SELECTED": "Ukhethile isiteji: ayinawo amabhulokisi okunyakaza",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "khetha noma ikuphi %1 kuya %2 ",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 futhi %2",
    "OPERATORS_OR": "%1 noma %2",
    "OPERATORS_NOT": "hhayi %1",
    "OPERATORS_JOIN": "hlanganisa %1 %2 / xhuma/ bandakanya",
    "OPERATORS_JOIN_APPLE": "aphula",
    "OPERATORS_JOIN_BANANA": "bhanana ",
    "OPERATORS_LETTEROF": "usonhlamvu %1  ka %2 ",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "ubude be %1",
    "OPERATORS_CONTAINS": "%1 iqukethe %2",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "yingiliza %1",
    "OPERATORS_MATHOP": "%1 kwa %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "phansi",
    "OPERATORS_MATHOP_CEILING": "uphahla",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "chaza %1",
    "SENSING_TOUCHINGOBJECT": "ethinta%1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "isikhombi se mouse",
    "SENSING_TOUCHINGOBJECT_EDGE": "umphetho / icele",
    "SENSING_TOUCHINGCOLOR": "kuthinta umbala %1 ?",
    "SENSING_COLORISTOUCHINGCOLOR": "umbala %1 uthinta %2?  ",
    "SENSING_DISTANCETO": "ibanga eliya %1",
    "SENSING_DISTANCETO_POINTER": "isikhombi se mouse",
    "SENSING_ASKANDWAIT": "buza %1 futhi linda",
    "SENSING_ASK_TEXT": "Ubani igama lakho?",
    "SENSING_ANSWER": "phendula / Impendulo ",
    "SENSING_KEYPRESSED": "ukhiye %1 ucindezelwe?",
    "SENSING_MOUSEDOWN": " phansi i mouse",
    "SENSING_MOUSEX": "mouse x",
    "SENSING_MOUSEY": "mouse y",
    "SENSING_SETDRAGMODE": "lungisa isimo sokuhudula %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "kuyahuduleka",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "akuhuduleki",
    "SENSING_LOUDNESS": "ubukhulu bomsindo",
    "SENSING_LOUD": "kukhulu umsindo? / Umsindo uphezulu? ",
    "SENSING_TIMER": "Isibali sikhathi",
    "SENSING_RESETTIMER": "qalakabusha isibali sikhathi",
    "SENSING_OF": "%1 kwa%2",
    "SENSING_OF_XPOSITION": "indawo ka-x ",
    "SENSING_OF_YPOSITION": "Indawo ka-y ",
    "SENSING_OF_DIRECTION": "indlela ",
    "SENSING_OF_COSTUMENUMBER": "impahla #",
    "SENSING_OF_COSTUMENAME": "igama lempahla",
    "SENSING_OF_SIZE": "ubukhulu",
    "SENSING_OF_VOLUME": "ubuningi bomsindo",
    "SENSING_OF_BACKDROPNUMBER": "okwasemuva #",
    "SENSING_OF_BACKDROPNAME": "igama lokwasemuva",
    "SENSING_OF_STAGE": "Isiteji",
    "SENSING_CURRENT": "manje  %1 ",
    "SENSING_CURRENT_YEAR": "unyaka",
    "SENSING_CURRENT_MONTH": "inyanga",
    "SENSING_CURRENT_DATE": "usuku",
    "SENSING_CURRENT_DAYOFWEEK": "usuku lwesonto",
    "SENSING_CURRENT_HOUR": "ihora",
    "SENSING_CURRENT_MINUTE": "umzuzu",
    "SENSING_CURRENT_SECOND": "umzuzwana",
    "SENSING_DAYSSINCE2000": "izinsuku kusukela 2000",
    "SENSING_USERNAME": "igama elisebenzile",
    "SENSING_USERID": "umsebenzisi ID",
    "SOUND_PLAY": "qala umsindo %1",
    "SOUND_PLAYUNTILDONE": "dlala umsindo %1 uze uqede",
    "SOUND_STOPALLSOUNDS": "misa yonke imisindo",
    "SOUND_SETEFFECTO": "Lungisa %1 umthelela ngo %2",
    "SOUND_CHANGEEFFECTBY": "Shintsha %1 womthelela ngo %2",
    "SOUND_CLEAREFFECTS": "susa umthelela womsindo",
    "SOUND_EFFECTS_PITCH": "izinga elidlulele / iphimbo",
    "SOUND_EFFECTS_PAN": "jikisa isinxele-nangakwesokudla",
    "SOUND_CHANGEVOLUMEBY": "shintsha umsindo ngokuthi %1",
    "SOUND_SETVOLUMETO": "lungisa inani lo msindo ukuze %1%",
    "SOUND_VOLUME": "umsindo",
    "SOUND_RECORD": "qopha...",
    "CATEGORY_MOTION": "Ukunyakaza",
    "CATEGORY_LOOKS": "Ukubukeka",
    "CATEGORY_SOUND": "Umsindo",
    "CATEGORY_EVENTS": "Izehlakalo",
    "CATEGORY_CONTROL": "Lawula",
    "CATEGORY_SENSING": "Ukuzwa",
    "CATEGORY_OPERATORS": "Abahambisayo",
    "CATEGORY_VARIABLES": "okuguqukayo",
    "CATEGORY_MYBLOCKS": "Amabhulokisi ami",
    "DUPLICATE": "Fanisa",
    "DELETE": "Cima",
    "ADD_COMMENT": "engeza ukuphawula",
    "REMOVE_COMMENT": "Susa ukuphawula",
    "DELETE_BLOCK": "Susa Ibhulokisi ",
    "DELETE_X_BLOCKS": "Susa %1 Amabhulokisi",
    "DELETE_ALL_BLOCKS": "Susa wonke %1 amabhulokisi?",
    "CLEAN_UP": "hlanza amabhulokisi",
    "HELP": "Usizo",
    "UNDO": "Susa okwenzile",
    "REDO": "Phinda ukwenze ",
    "EDIT_PROCEDURE": "Qondisa",
    "SHOW_PROCEDURE_DEFINITION": "Iya kwingcazelo",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Isho okuthile...",
    "COLOUR_HUE_LABEL": "Umbala",
    "COLOUR_SATURATION_LABEL": "Ukugcwala",
    "COLOUR_BRIGHTNESS_LABEL": "Ukukhanya",
    "CHANGE_VALUE_TITLE": "Shintsha inani:",
    "RENAME_VARIABLE": "Shintsha igama lokuguqukayo",
    "RENAME_VARIABLE_TITLE": "Shinthsha konke okuguqukayo kwi \"%1\" ukuse ku",
    "RENAME_VARIABLE_MODAL_TITLE": "Shintsha Igama lokuguqukayo",
    "NEW_VARIABLE": "Yenza okuguqukayo",
    "NEW_VARIABLE_TITLE": "Igama elisha lokuguqukayo",
    "VARIABLE_MODAL_TITLE": "Okuguqukayo okusha",
    "VARIABLE_ALREADY_EXISTS": "Igama lokuguqukayo \"%1\" selikhona ",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": " Igama lokuguqukayo \"%1\" selikhona kokunye okuguqukayo kwe \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "Cisha %1 ukusetshenziswa kwe \"%2\" okuguqukayo",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Ngeke ucishe okuguqukayo\"%1\" ngoba iyingxenye yencazelo yalomsebenzi \"%2\"",
    "DELETE_VARIABLE": " Susa \"%1\" yokuguqukayo",
    "NEW_PROCEDURE": "Enza ibhulokisi ",
    "PROCEDURE_ALREADY_EXISTS": "Inqubomgomo \"%1\" isivele ikhona ",
    "PROCEDURE_DEFAULT_NAME": "igama lebhulokisi ",
    "PROCEDURE_USED": "Ukuze ususe incazelo yebhulokisi, qala usule konke okusebenzile kwale bhulokisi",
    "NEW_LIST": "Yenza uhlu ",
    "NEW_LIST_TITLE": "Igama loluhlu olusha  ",
    "LIST_MODAL_TITLE": "Uhlu olusha",
    "LIST_ALREADY_EXISTS": " Uhlu lwalelogama \"%1\" lukhona  ",
    "RENAME_LIST_TITLE": " Qambaa kabusha wonke \"%1\" woluhlu: ",
    "RENAME_LIST_MODAL_TITLE": "Qamba kabusha uhlu ",
    "DEFAULT_LIST_ITEM": "into",
    "DELETE_LIST": "Susa \"%1\" i-List ",
    "RENAME_LIST": "Qamba kabusha uhlu ",
    "NEW_BROADCAST_MESSAGE": "Umyalezo omusha",
    "NEW_BROADCAST_MESSAGE_TITLE": "Igama lomyalezo elisha",
    "BROADCAST_MODAL_TITLE": "Umyalezo Omusha",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "umyalezo wokuqala"
  },
  "is": {
    "CONTROL_FOREVER": "endalaust",
    "CONTROL_REPEAT": "endurtaka %1 sinnum",
    "CONTROL_IF": "ef %1 þá",
    "CONTROL_ELSE": "annars",
    "CONTROL_STOP": "stöðva",
    "CONTROL_STOP_ALL": "allt",
    "CONTROL_STOP_THIS": "þetta forrit",
    "CONTROL_STOP_OTHER": "önnur forrit á karakter",
    "CONTROL_WAIT": "bíða í %1 sekúndur",
    "CONTROL_WAITUNTIL": "bíða þangað til %1",
    "CONTROL_REPEATUNTIL": "endurtaka þar til %1",
    "CONTROL_WHILE": "á meðan %1",
    "CONTROL_FOREACH": "fyrir hvert %1 í %2",
    "CONTROL_STARTASCLONE": "þegar ég byrja sem klónn",
    "CONTROL_CREATECLONEOF": "búa til klón af %1",
    "CONTROL_CREATECLONEOF_MYSELF": "sjálfum mér",
    "CONTROL_DELETETHISCLONE": "eyða þessum klón",
    "CONTROL_COUNTER": "teljari",
    "CONTROL_INCRCOUNTER": "vaxandi teljari",
    "CONTROL_CLEARCOUNTER": "tæma teljara",
    "CONTROL_ALLATONCE": "alla í einu",
    "DATA_SETVARIABLETO": "láttu %1 verða %2",
    "DATA_CHANGEVARIABLEBY": "breyttu %1 um %2",
    "DATA_SHOWVARIABLE": "sýndu mér breytu %1",
    "DATA_HIDEVARIABLE": "feldu breytu %1",
    "DATA_ADDTOLIST": "bættu %1 við %2",
    "DATA_DELETEOFLIST": "fjarlægðu %1 af %2",
    "DATA_DELETEALLOFLIST": "eyddu öllu af %1",
    "DATA_INSERTATLIST": "settu %1 við %2 af %3",
    "DATA_REPLACEITEMOFLIST": "skiptu út hlut %1 af %2 fyrir %3",
    "DATA_ITEMOFLIST": "hlutur %1 af %2",
    "DATA_ITEMNUMOFLIST": "item # of %1 in %2",
    "DATA_LENGTHOFLIST": "lengd %1",
    "DATA_LISTCONTAINSITEM": "inniheldur %1, %2?",
    "DATA_SHOWLIST": "sýndu lista %1",
    "DATA_HIDELIST": "feldu lista %1",
    "DATA_INDEX_ALL": "allt",
    "DATA_INDEX_LAST": "seinasti",
    "DATA_INDEX_RANDOM": "handahófskenndur",
    "EVENT_WHENFLAGCLICKED": "þegar smellt er á %1",
    "EVENT_WHENTHISSPRITECLICKED": "þegar smellt er á þennan karakter",
    "EVENT_WHENSTAGECLICKED": "þegar smellt er a sviðið",
    "EVENT_WHENTOUCHINGOBJECT": "þegar karakterinn snertir %1",
    "EVENT_WHENBROADCASTRECEIVED": "þegar ég fæ sent %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "þegar bakgrunnurinn verður %1",
    "EVENT_WHENGREATERTHAN": "þegar %1 er meira en %2",
    "EVENT_WHENGREATERTHAN_TIMER": "skeiðklukka",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "hljóðstyrkur",
    "EVENT_BROADCAST": "senda %1",
    "EVENT_BROADCASTANDWAIT": "senda %1 og bíða",
    "EVENT_WHENKEYPRESSED": "þegar ýtt er á %1",
    "EVENT_WHENKEYPRESSED_SPACE": "bilslá",
    "EVENT_WHENKEYPRESSED_LEFT": "vinstri ör",
    "EVENT_WHENKEYPRESSED_RIGHT": "hægri ör",
    "EVENT_WHENKEYPRESSED_DOWN": "niður ör",
    "EVENT_WHENKEYPRESSED_UP": "upp ör",
    "EVENT_WHENKEYPRESSED_ANY": "eitthvert",
    "LOOKS_SAYFORSECS": "segðu %1 í %2 sekúndur",
    "LOOKS_SAY": "segðu %1",
    "LOOKS_HELLO": "Hæ!",
    "LOOKS_THINKFORSECS": "hugsaðu %1 í %2 sekúndur",
    "LOOKS_THINK": "hugsaðu %1",
    "LOOKS_HMM": "Hmmmm....",
    "LOOKS_SHOW": "birta",
    "LOOKS_HIDE": "fela",
    "LOOKS_HIDEALLSPRITES": "fela allar teikningar",
    "LOOKS_EFFECT_COLOR": "litur",
    "LOOKS_EFFECT_FISHEYE": "fiskauga",
    "LOOKS_EFFECT_WHIRL": "þyrla",
    "LOOKS_EFFECT_PIXELATE": "pixla",
    "LOOKS_EFFECT_MOSAIC": "mósaík",
    "LOOKS_EFFECT_BRIGHTNESS": "birtustig",
    "LOOKS_EFFECT_GHOST": "draugur",
    "LOOKS_CHANGEEFFECTBY": "breyta %1 áhrifunum um %2",
    "LOOKS_SETEFFECTTO": "settu %1 áhrifin á %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "hreinsa myndbrellur",
    "LOOKS_CHANGESIZEBY": "breyta stærð um %1",
    "LOOKS_SETSIZETO": "stærð verður %1 %",
    "LOOKS_SIZE": "stærð",
    "LOOKS_CHANGESTRETCHBY": "breyta teygju um %1",
    "LOOKS_SETSTRETCHTO": "teygja verður %1 %",
    "LOOKS_SWITCHCOSTUMETO": "breyttu í búning %1",
    "LOOKS_NEXTCOSTUME": "næsti búningur",
    "LOOKS_SWITCHBACKDROPTO": "bakgrunnur verður %1",
    "LOOKS_GOTOFRONTBACK": "farðu á lag %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "fremst",
    "LOOKS_GOTOFRONTBACK_BACK": "aftast",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "farðu %1 %2 lög",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "áfram",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "aftur á bak",
    "LOOKS_BACKDROPNUMBERNAME": "bakgrunnur %1",
    "LOOKS_COSTUMENUMBERNAME": "búningur %1",
    "LOOKS_NUMBERNAME_NUMBER": "númer",
    "LOOKS_NUMBERNAME_NAME": "nafn",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "nota bakgrunn %1 og bíða",
    "LOOKS_NEXTBACKDROP_BLOCK": "næsti bakgrunnur",
    "LOOKS_NEXTBACKDROP": "næsti bakgrunnur",
    "LOOKS_PREVIOUSBACKDROP": "síðasti bakgrunnur",
    "LOOKS_RANDOMBACKDROP": "handahófskenndur bakgrunnur",
    "MOTION_MOVESTEPS": "fara %1 skref",
    "MOTION_TURNLEFT": "snúa til %1 um %2 gráður",
    "MOTION_TURNRIGHT": "snúa til %1 um %2 gráður",
    "MOTION_POINTINDIRECTION": "stefna í %1 gráður",
    "MOTION_POINTTOWARDS": "stefna í átt að %1",
    "MOTION_POINTTOWARDS_POINTER": "músarbendill",
    "MOTION_POINTTOWARDS_RANDOM": "random direction",
    "MOTION_GOTO": "fara til %1",
    "MOTION_GOTO_POINTER": "músarbendill",
    "MOTION_GOTO_RANDOM": "handahófskennd staðsetning",
    "MOTION_GOTOXY": "fara til x: %1 og y: %2",
    "MOTION_GLIDESECSTOXY": "svífa í %1 sekúndur til x: %2 og y: %3",
    "MOTION_GLIDETO": "svífa í %1 sekúndur til %2",
    "MOTION_GLIDETO_POINTER": "músarbendill",
    "MOTION_GLIDETO_RANDOM": "handahófskend staðsetning",
    "MOTION_CHANGEXBY": "breyta x um %1",
    "MOTION_SETX": "láttu x verða %1",
    "MOTION_CHANGEYBY": "breyttu y um %1",
    "MOTION_SETY": "láttu y verða %1",
    "MOTION_IFONEDGEBOUNCE": "ef á kanti, snúðu við",
    "MOTION_SETROTATIONSTYLE": "snúningsgerð verður %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "vinstri-hægri",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ekki snúast",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "allan hringinn",
    "MOTION_XPOSITION": "x hnit",
    "MOTION_YPOSITION": "y hnit",
    "MOTION_DIRECTION": "stefna",
    "MOTION_SCROLLRIGHT": "skrolla hægri um %1",
    "MOTION_SCROLLUP": "skrolla up %1",
    "MOTION_ALIGNSCENE": "stilla til svið %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "neðra vinstra megin",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "neðra hægra megin",
    "MOTION_ALIGNSCENE_MIDDLE": "miðjunni",
    "MOTION_ALIGNSCENE_TOPLEFT": "efra vinstra megin",
    "MOTION_ALIGNSCENE_TOPRIGHT": "efra hægra megin",
    "MOTION_XSCROLL": "x skroll",
    "MOTION_YSCROLL": "y skroll",
    "MOTION_STAGE_SELECTED": "Sviðið hefur enga hreyfikubba",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "velja tölu á milli %1 og %2 af handahófi",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 og %2",
    "OPERATORS_OR": "%1 eða %2",
    "OPERATORS_NOT": "ekki %1",
    "OPERATORS_JOIN": "sameina %1 og %2",
    "OPERATORS_JOIN_APPLE": "epli",
    "OPERATORS_JOIN_BANANA": "banani",
    "OPERATORS_LETTEROF": "stafur númer %1 úr %2",
    "OPERATORS_LETTEROF_APPLE": "e",
    "OPERATORS_LENGTH": "lengd %1",
    "OPERATORS_CONTAINS": "inniheldur %1 %2?",
    "OPERATORS_MOD": "%1 modulus %2",
    "OPERATORS_ROUND": "rúna %1",
    "OPERATORS_MATHOP": "%1 af %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "rúna niður",
    "OPERATORS_MATHOP_CEILING": "rúna upp",
    "OPERATORS_MATHOP_SQRT": "kvaðratrót",
    "OPERATORS_MATHOP_SIN": "sínus",
    "OPERATORS_MATHOP_COS": "kósínus",
    "OPERATORS_MATHOP_TAN": "tangens",
    "OPERATORS_MATHOP_ASIN": "arksínus",
    "OPERATORS_MATHOP_ACOS": "arkcósínus",
    "OPERATORS_MATHOP_ATAN": "arktangens",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "skilgreina %1",
    "SENSING_TOUCHINGOBJECT": "snertir %1",
    "SENSING_TOUCHINGOBJECT_POINTER": "músarbendill",
    "SENSING_TOUCHINGOBJECT_EDGE": "brún",
    "SENSING_TOUCHINGCOLOR": "snertir litinn %1",
    "SENSING_COLORISTOUCHINGCOLOR": "liturinn %1 snertir litinn %2",
    "SENSING_DISTANCETO": "fjarlægð til %1",
    "SENSING_DISTANCETO_POINTER": "músarbendill",
    "SENSING_ASKANDWAIT": "spurðu %1 og bíddu",
    "SENSING_ASK_TEXT": "Hvað heitir þú?",
    "SENSING_ANSWER": "svar",
    "SENSING_KEYPRESSED": "hnappur %1 sleginn",
    "SENSING_MOUSEDOWN": "músarhnappur niðri?",
    "SENSING_MOUSEX": "x hnit músar",
    "SENSING_MOUSEY": "y hnit músar",
    "SENSING_SETDRAGMODE": "breyttu dragstillingu %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "draganlegur",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ekki draganlegur",
    "SENSING_LOUDNESS": "hljóðstyrkur",
    "SENSING_LOUD": "hávær?",
    "SENSING_TIMER": "skeiðklukka",
    "SENSING_RESETTIMER": "endurstilla skeiðklukku",
    "SENSING_OF": "%1 af %2",
    "SENSING_OF_XPOSITION": "x hnit",
    "SENSING_OF_YPOSITION": "y hnit",
    "SENSING_OF_DIRECTION": "stefna",
    "SENSING_OF_COSTUMENUMBER": "búnungur númer",
    "SENSING_OF_COSTUMENAME": "nafn búnings",
    "SENSING_OF_SIZE": "stærð",
    "SENSING_OF_VOLUME": "hljóðstyrkur",
    "SENSING_OF_BACKDROPNUMBER": "bakgrunnur númer",
    "SENSING_OF_BACKDROPNAME": "nafn bakgrunns",
    "SENSING_OF_STAGE": "Svið",
    "SENSING_CURRENT": "núverandi %1",
    "SENSING_CURRENT_YEAR": "ár",
    "SENSING_CURRENT_MONTH": "mánuður",
    "SENSING_CURRENT_DATE": "dagsetning",
    "SENSING_CURRENT_DAYOFWEEK": "vikudagur",
    "SENSING_CURRENT_HOUR": "klukkustund",
    "SENSING_CURRENT_MINUTE": "mínúta",
    "SENSING_CURRENT_SECOND": "sekúnda",
    "SENSING_DAYSSINCE2000": "dagar síðan árið 2000",
    "SENSING_USERNAME": "notendanafn",
    "SENSING_USERID": "einkenni notenda",
    "SOUND_PLAY": "spila hljóð %1",
    "SOUND_PLAYUNTILDONE": "spila hljóð %1 þar til það klárast",
    "SOUND_STOPALLSOUNDS": "stöðva öll hljóð",
    "SOUND_SETEFFECTO": "settu %1 áhrifin á %2",
    "SOUND_CHANGEEFFECTBY": "breyta %1 áhrifunum um %2",
    "SOUND_CLEAREFFECTS": "fjarlægja hljóðbreytingar",
    "SOUND_EFFECTS_PITCH": "tónhæð",
    "SOUND_EFFECTS_PAN": "skima til vinstri/hægri",
    "SOUND_CHANGEVOLUMEBY": "breyta hljóðstyrk um %1",
    "SOUND_SETVOLUMETO": "setja hljóðstyrk í  %1%",
    "SOUND_VOLUME": "hljóðstyrkur",
    "SOUND_RECORD": "record...",
    "CATEGORY_MOTION": "Hreyfing",
    "CATEGORY_LOOKS": "Útlit",
    "CATEGORY_SOUND": "Hljóð",
    "CATEGORY_EVENTS": "Atburðir",
    "CATEGORY_CONTROL": "Stjórn",
    "CATEGORY_SENSING": "Mæling",
    "CATEGORY_OPERATORS": "Virkjar",
    "CATEGORY_VARIABLES": "Breytur",
    "CATEGORY_MYBLOCKS": "Mínir kubbar",
    "DUPLICATE": "Tvöfalda",
    "DELETE": "Eyða",
    "ADD_COMMENT": "Bæta við athugasemd",
    "REMOVE_COMMENT": "Fjarlægja athugasemd",
    "DELETE_BLOCK": "Eyða kubb",
    "DELETE_X_BLOCKS": "Eyða %1 kubbum",
    "DELETE_ALL_BLOCKS": "Eyða öllum %1 kubbum",
    "CLEAN_UP": "Hreinsa til kubbana",
    "HELP": "Hjálp",
    "UNDO": "Afturkalla",
    "REDO": "Framkalla",
    "EDIT_PROCEDURE": "Breyta",
    "SHOW_PROCEDURE_DEFINITION": "Fara að skilgreiningu",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Segðu eitthvað...",
    "COLOUR_HUE_LABEL": "Litur",
    "COLOUR_SATURATION_LABEL": "mettun",
    "COLOUR_BRIGHTNESS_LABEL": "Birtustig",
    "CHANGE_VALUE_TITLE": "Breyta gildi:",
    "RENAME_VARIABLE": "Endurskýra breytu",
    "RENAME_VARIABLE_TITLE": "Endurskýra allar \"%1\" breytur sem: ",
    "RENAME_VARIABLE_MODAL_TITLE": "Endurskýra breytu",
    "NEW_VARIABLE": "Smíða breytu",
    "NEW_VARIABLE_TITLE": "Nafn nýrrar breytu:",
    "VARIABLE_MODAL_TITLE": "Ný breyta",
    "VARIABLE_ALREADY_EXISTS": "Það er nú þegar til breyta sem heitir \"%1\".",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Það er nú þegar til breyta sem heitir \"%1\" fyrir aðra breytu af týpunni \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Þú ert að nota \"%2\" á %1 stöðum. Viltu samt eyða breytunni?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Þú getur ekki eytt breytunni \"%1\" vegna þess að þú ert að nota hana í kubb af eigin hönnun. Hann heitir: \"%2\".",
    "DELETE_VARIABLE": "Eyða \"%1\" breytunni",
    "NEW_PROCEDURE": "Búa til kubb",
    "PROCEDURE_ALREADY_EXISTS": "Fall með nafninu \"%1\" er nú þegar til.",
    "PROCEDURE_DEFAULT_NAME": "nafn kubbs",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Búa til lista",
    "NEW_LIST_TITLE": "Nafn nýs lista:",
    "LIST_MODAL_TITLE": "Nýr listi",
    "LIST_ALREADY_EXISTS": "Það er nú þegar til listi sem heitir \"%1\".",
    "RENAME_LIST_TITLE": "Endurskýra alla \"%1\" lista sem:",
    "RENAME_LIST_MODAL_TITLE": "Endurskýra lista",
    "DEFAULT_LIST_ITEM": "hlutur",
    "DELETE_LIST": "Delete the \"%1\" list",
    "RENAME_LIST": "Rename list",
    "NEW_BROADCAST_MESSAGE": "Ný skilaboð",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nafn nýrra skilaboða",
    "BROADCAST_MODAL_TITLE": "Ný skilaboð",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "dæmiUmNafnÁSkilaboðum"
  },
  "it": {
    "CONTROL_FOREVER": "per sempre",
    "CONTROL_REPEAT": "ripeti %1  volte",
    "CONTROL_IF": "se %1 allora",
    "CONTROL_ELSE": "altrimenti",
    "CONTROL_STOP": "ferma",
    "CONTROL_STOP_ALL": "tutto",
    "CONTROL_STOP_THIS": "questo script",
    "CONTROL_STOP_OTHER": "tutti gli altri script dello sprite",
    "CONTROL_WAIT": "attendi %1 secondi",
    "CONTROL_WAITUNTIL": "attendi fino a quando %1",
    "CONTROL_REPEATUNTIL": "ripeti fino a quando %1",
    "CONTROL_WHILE": "mentre %1",
    "CONTROL_FOREACH": "per ogni %1 in %2",
    "CONTROL_STARTASCLONE": "quando vengo clonato",
    "CONTROL_CREATECLONEOF": "crea clone di %1",
    "CONTROL_CREATECLONEOF_MYSELF": "me stesso",
    "CONTROL_DELETETHISCLONE": "elimina questo clone",
    "CONTROL_COUNTER": "contatore",
    "CONTROL_INCRCOUNTER": "incrementa contatore",
    "CONTROL_CLEARCOUNTER": "azzera contatore",
    "CONTROL_ALLATONCE": "esegui tutto insieme",
    "DATA_SETVARIABLETO": "porta %1 a %2",
    "DATA_CHANGEVARIABLEBY": "cambia %1 di %2",
    "DATA_SHOWVARIABLE": "mostra la variabile %1",
    "DATA_HIDEVARIABLE": "nascondi la variabile %1",
    "DATA_ADDTOLIST": "aggiungi %1 a %2",
    "DATA_DELETEOFLIST": "cancella %1 da %2",
    "DATA_DELETEALLOFLIST": "cancella tutto da %1",
    "DATA_INSERTATLIST": "inserisci %1 alla posizione %2 di %3",
    "DATA_REPLACEITEMOFLIST": "sostituisci elemento %1 di %2 con %3",
    "DATA_ITEMOFLIST": "elemento %1 di %2",
    "DATA_ITEMNUMOFLIST": "posizione di %1 in %2",
    "DATA_LENGTHOFLIST": "lunghezza di %1",
    "DATA_LISTCONTAINSITEM": "%1 contiene %2",
    "DATA_SHOWLIST": "mostra la lista %1",
    "DATA_HIDELIST": "nascondi la lista %1",
    "DATA_INDEX_ALL": "tutto",
    "DATA_INDEX_LAST": "ultimo",
    "DATA_INDEX_RANDOM": "a caso",
    "EVENT_WHENFLAGCLICKED": "quando si clicca su %1",
    "EVENT_WHENTHISSPRITECLICKED": "quando si clicca questo sprite",
    "EVENT_WHENSTAGECLICKED": "quando si clicca sullo Stage",
    "EVENT_WHENTOUCHINGOBJECT": "quando questo sprite tocca %1",
    "EVENT_WHENBROADCASTRECEIVED": "quando ricevo %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "quando lo sfondo passa a %1",
    "EVENT_WHENGREATERTHAN": "quando %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronometro",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "volume microfono",
    "EVENT_BROADCAST": "invia a tutti %1",
    "EVENT_BROADCASTANDWAIT": "invia a tutti %1 e attendi",
    "EVENT_WHENKEYPRESSED": "quando si preme il tasto %1",
    "EVENT_WHENKEYPRESSED_SPACE": "spazio",
    "EVENT_WHENKEYPRESSED_LEFT": "freccia sinistra",
    "EVENT_WHENKEYPRESSED_RIGHT": "freccia destra",
    "EVENT_WHENKEYPRESSED_DOWN": "freccia giù",
    "EVENT_WHENKEYPRESSED_UP": "freccia su",
    "EVENT_WHENKEYPRESSED_ANY": "qualunque",
    "LOOKS_SAYFORSECS": "dire %1 per %2 secondi",
    "LOOKS_SAY": "dire %1",
    "LOOKS_HELLO": "Ciao!",
    "LOOKS_THINKFORSECS": "pensa %1 per %2 secondi",
    "LOOKS_THINK": "pensa %1",
    "LOOKS_HMM": "Uhm...",
    "LOOKS_SHOW": "mostra",
    "LOOKS_HIDE": "nascondi",
    "LOOKS_HIDEALLSPRITES": "nascondi tutti gli sprite",
    "LOOKS_EFFECT_COLOR": "colore",
    "LOOKS_EFFECT_FISHEYE": "fish-eye",
    "LOOKS_EFFECT_WHIRL": "mulinello",
    "LOOKS_EFFECT_PIXELATE": "effetto pixel",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "luminosità",
    "LOOKS_EFFECT_GHOST": "fantasma",
    "LOOKS_CHANGEEFFECTBY": "cambia effetto %1 di %2",
    "LOOKS_SETEFFECTTO": "porta effetto %1 a %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "rimuovi effetti grafici",
    "LOOKS_CHANGESIZEBY": "cambia dimensione di %1",
    "LOOKS_SETSIZETO": "porta dimensione a %1 %",
    "LOOKS_SIZE": "dimensione",
    "LOOKS_CHANGESTRETCHBY": "cambia allungamento di %1",
    "LOOKS_SETSTRETCHTO": "porta allungamento a %1 %",
    "LOOKS_SWITCHCOSTUMETO": "passa al costume %1",
    "LOOKS_NEXTCOSTUME": "passa al costume seguente",
    "LOOKS_SWITCHBACKDROPTO": "passa allo sfondo %1",
    "LOOKS_GOTOFRONTBACK": "vai in %1 piano",
    "LOOKS_GOTOFRONTBACK_FRONT": "primo",
    "LOOKS_GOTOFRONTBACK_BACK": "secondo",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "vai %1 di %2 livelli",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "avanti",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "indietro",
    "LOOKS_BACKDROPNUMBERNAME": "%1 sfondo",
    "LOOKS_COSTUMENUMBERNAME": "%1 costume",
    "LOOKS_NUMBERNAME_NUMBER": "numero",
    "LOOKS_NUMBERNAME_NAME": "nome",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "passa allo sfondo %1 e attendi",
    "LOOKS_NEXTBACKDROP_BLOCK": "passa allo sfondo seguente",
    "LOOKS_NEXTBACKDROP": "seguente",
    "LOOKS_PREVIOUSBACKDROP": "precedente",
    "LOOKS_RANDOMBACKDROP": "scelto a caso",
    "MOTION_MOVESTEPS": "fai %1 passi",
    "MOTION_TURNLEFT": "ruota %1 di %2 gradi",
    "MOTION_TURNRIGHT": "ruota %1 di %2 gradi",
    "MOTION_POINTINDIRECTION": "punta in direzione %1",
    "MOTION_POINTTOWARDS": "punta verso %1",
    "MOTION_POINTTOWARDS_POINTER": "puntatore del mouse",
    "MOTION_POINTTOWARDS_RANDOM": "direzione a caso",
    "MOTION_GOTO": "raggiungi %1",
    "MOTION_GOTO_POINTER": "puntatore del mouse",
    "MOTION_GOTO_RANDOM": "posizione a caso",
    "MOTION_GOTOXY": "vai a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "scivola in %1 secondi a x: %2 y: %3",
    "MOTION_GLIDETO": "scivola in %1 secondi a %2",
    "MOTION_GLIDETO_POINTER": "puntatore del mouse",
    "MOTION_GLIDETO_RANDOM": "posizione a caso",
    "MOTION_CHANGEXBY": "cambia x di %1",
    "MOTION_SETX": "vai dove x è %1",
    "MOTION_CHANGEYBY": "cambia y di %1",
    "MOTION_SETY": "vai dove y è %1",
    "MOTION_IFONEDGEBOUNCE": "rimbalza quando tocchi il bordo",
    "MOTION_SETROTATIONSTYLE": "usa stile rotazione %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "sinistra-destra",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "non ruotare",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "può ruotare",
    "MOTION_XPOSITION": "posizione x",
    "MOTION_YPOSITION": "posizione y",
    "MOTION_DIRECTION": "direzione",
    "MOTION_SCROLLRIGHT": "scrolla a destra di %1",
    "MOTION_SCROLLUP": "scrolla in alto di %1",
    "MOTION_ALIGNSCENE": "allinea la scena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "in basso a sinistra",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "in basso a destra",
    "MOTION_ALIGNSCENE_MIDDLE": "in mezzo",
    "MOTION_ALIGNSCENE_TOPLEFT": "in alto a sinistra",
    "MOTION_ALIGNSCENE_TOPRIGHT": "in alto a destra",
    "MOTION_XSCROLL": "posizione x dello scroll",
    "MOTION_YSCROLL": "posizione y dello scroll",
    "MOTION_STAGE_SELECTED": "Stage selezionato: nessun blocco di movimento",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "numero a caso tra %1 e %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 e %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "non %1",
    "OPERATORS_JOIN": "unione di %1 e %2",
    "OPERATORS_JOIN_APPLE": "mela",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "lettera %1 di %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "lunghezza di %1",
    "OPERATORS_CONTAINS": "%1 contiene %2",
    "OPERATORS_MOD": "resto della divisione di %1 diviso %2",
    "OPERATORS_ROUND": "arrotonda %1",
    "OPERATORS_MATHOP": "%1 di %2",
    "OPERATORS_MATHOP_ABS": "valore assoluto",
    "OPERATORS_MATHOP_FLOOR": "intero inferiore",
    "OPERATORS_MATHOP_CEILING": "intero superiore",
    "OPERATORS_MATHOP_SQRT": "radice quadrata",
    "OPERATORS_MATHOP_SIN": "sen",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsen",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definisci %1",
    "SENSING_TOUCHINGOBJECT": "sta toccando %1",
    "SENSING_TOUCHINGOBJECT_POINTER": "puntatore del mouse",
    "SENSING_TOUCHINGOBJECT_EDGE": "bordo",
    "SENSING_TOUCHINGCOLOR": "sta toccando il colore %1",
    "SENSING_COLORISTOUCHINGCOLOR": "il colore %1 sta toccando il colore %2",
    "SENSING_DISTANCETO": "distanza da %1",
    "SENSING_DISTANCETO_POINTER": "puntatore del mouse",
    "SENSING_ASKANDWAIT": "chiedi %1 e attendi",
    "SENSING_ASK_TEXT": "Come ti chiami?",
    "SENSING_ANSWER": "risposta",
    "SENSING_KEYPRESSED": "tasto %1 premuto",
    "SENSING_MOUSEDOWN": "pulsante del mouse premuto",
    "SENSING_MOUSEX": "x del mouse",
    "SENSING_MOUSEY": "y del mouse",
    "SENSING_SETDRAGMODE": "rendi lo sprite %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "trascinabile",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "non trascinabile",
    "SENSING_LOUDNESS": "volume microfono",
    "SENSING_LOUD": "volume alto?",
    "SENSING_TIMER": "cronometro",
    "SENSING_RESETTIMER": "azzera cronometro",
    "SENSING_OF": "%1 di %2",
    "SENSING_OF_XPOSITION": "posizione x",
    "SENSING_OF_YPOSITION": "posizione y",
    "SENSING_OF_DIRECTION": "direzione",
    "SENSING_OF_COSTUMENUMBER": "numero del costume",
    "SENSING_OF_COSTUMENAME": "nome del costume",
    "SENSING_OF_SIZE": "dimensione",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "numero dello sfondo",
    "SENSING_OF_BACKDROPNAME": "nome dello sfondo",
    "SENSING_OF_STAGE": "Stage",
    "SENSING_CURRENT": "%1 attuale",
    "SENSING_CURRENT_YEAR": "anno",
    "SENSING_CURRENT_MONTH": "mese",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "giorno della settimana",
    "SENSING_CURRENT_HOUR": "ora",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "secondo",
    "SENSING_DAYSSINCE2000": "giorni trascorsi dal 2000",
    "SENSING_USERNAME": "username",
    "SENSING_USERID": "user id",
    "SOUND_PLAY": "avvia riproduzione suono %1",
    "SOUND_PLAYUNTILDONE": "riproduci suono %1 e attendi la fine",
    "SOUND_STOPALLSOUNDS": "ferma tutti i suoni",
    "SOUND_SETEFFECTO": "porta effetto %1 a %2",
    "SOUND_CHANGEEFFECTBY": "cambia effetto %1 di %2",
    "SOUND_CLEAREFFECTS": "rimuovi effetti audio",
    "SOUND_EFFECTS_PITCH": "frequenza",
    "SOUND_EFFECTS_PAN": "panning sinistra/destra",
    "SOUND_CHANGEVOLUMEBY": "cambia volume di %1",
    "SOUND_SETVOLUMETO": "porta volume a %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "registrazione...",
    "CATEGORY_MOTION": "Movimento",
    "CATEGORY_LOOKS": "Aspetto",
    "CATEGORY_SOUND": "Suono",
    "CATEGORY_EVENTS": "Situazioni",
    "CATEGORY_CONTROL": "Controllo",
    "CATEGORY_SENSING": "Sensori",
    "CATEGORY_OPERATORS": "Operatori",
    "CATEGORY_VARIABLES": "Variabili",
    "CATEGORY_MYBLOCKS": "I Miei Blocchi",
    "DUPLICATE": "Duplica",
    "DELETE": "Cancella",
    "ADD_COMMENT": "Aggiungi commento",
    "REMOVE_COMMENT": "Rimuovi commento",
    "DELETE_BLOCK": "Cancella questo Blocco",
    "DELETE_X_BLOCKS": "Cancella %1 Blocchi",
    "DELETE_ALL_BLOCKS": "Cancellare i %1 blocchi?",
    "CLEAN_UP": "Riordina i Blocchi",
    "HELP": "Aiuto",
    "UNDO": "Annulla",
    "REDO": "Ripristina",
    "EDIT_PROCEDURE": "Modifica",
    "SHOW_PROCEDURE_DEFINITION": "Vai alla definizione",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Dì qualcosa...",
    "COLOUR_HUE_LABEL": "Colore",
    "COLOUR_SATURATION_LABEL": "Saturazione",
    "COLOUR_BRIGHTNESS_LABEL": "Luminosità",
    "CHANGE_VALUE_TITLE": "Cambia il valore:",
    "RENAME_VARIABLE": "Rinomina la variabile",
    "RENAME_VARIABLE_TITLE": "Rinomina tutti i riferimenti alla variabile \"%1\" come:",
    "RENAME_VARIABLE_MODAL_TITLE": "Rinomina la Variabile",
    "NEW_VARIABLE": "Crea una Variabile",
    "NEW_VARIABLE_TITLE": "Nome della nuova variabile:",
    "VARIABLE_MODAL_TITLE": "Nuova Variabile",
    "VARIABLE_ALREADY_EXISTS": "Una variabile chiamata \"%1\" esiste già.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Una variabile chiamata \"%1\" già esiste per un'altra variabile di tipo '%2'.",
    "DELETE_VARIABLE_CONFIRMATION": "Eliminare tutti i %1 riferimenti alla variabile \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Non è possibile eliminare la variabile \"%1\" perchè fa parte della definizione della funzione \"%2\"",
    "DELETE_VARIABLE": "Elimina la variabile \"%1\"",
    "NEW_PROCEDURE": "Crea un Blocco",
    "PROCEDURE_ALREADY_EXISTS": "Una procedura chiamata \"%1\" esiste già.",
    "PROCEDURE_DEFAULT_NAME": "nome del blocco",
    "PROCEDURE_USED": "Per rimuovere la definizione di un blocco è prima necessario rimuovere tutti i punti in cui il blocco viene usato",
    "NEW_LIST": "Crea una Lista",
    "NEW_LIST_TITLE": "Nome della nuova lista:",
    "LIST_MODAL_TITLE": "Nuova Lista",
    "LIST_ALREADY_EXISTS": "Una lista chiamata \"%1\" esiste già.",
    "RENAME_LIST_TITLE": "Rinomina tutti i riferimenti alla lista \"%1\" come:",
    "RENAME_LIST_MODAL_TITLE": "Rinomina la Lista",
    "DEFAULT_LIST_ITEM": "cosa",
    "DELETE_LIST": "Cancella la lista \"%1\"",
    "RENAME_LIST": "Rinomina lista",
    "NEW_BROADCAST_MESSAGE": "Nuovo messaggio...",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nome del nuovo messaggio:",
    "BROADCAST_MODAL_TITLE": "Nuovo Messaggio...",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "messaggio1"
  },
  "ka": {
    "CONTROL_FOREVER": "მუდმივად",
    "CONTROL_REPEAT": "გაიმეორე %1ჯერ",
    "CONTROL_IF": "თუ %1 მაშინ",
    "CONTROL_ELSE": "სხვა შემთხვევაში",
    "CONTROL_STOP": "გააჩერე",
    "CONTROL_STOP_ALL": "ყველაფერი",
    "CONTROL_STOP_THIS": "ეს სკრიპტი",
    "CONTROL_STOP_OTHER": "სპრაიტის სხვა სკრიპტები",
    "CONTROL_WAIT": "იცადე %1 წამი",
    "CONTROL_WAITUNTIL": "იცადე მანამ %1",
    "CONTROL_REPEATUNTIL": "გაიმეორე მანამ %1",
    "CONTROL_WHILE": "მანამ სანამ %1",
    "CONTROL_FOREACH": "ყოველი %1თვის %2ში",
    "CONTROL_STARTASCLONE": "როდესაც მე ვიწყებ როგორც კლონი",
    "CONTROL_CREATECLONEOF": "შექმენი  %1ს კლონი",
    "CONTROL_CREATECLONEOF_MYSELF": "ჩემი",
    "CONTROL_DELETETHISCLONE": "წაშალე ეს კლონი",
    "CONTROL_COUNTER": "მთვლელი",
    "CONTROL_INCRCOUNTER": "დანამატის მთვლელი",
    "CONTROL_CLEARCOUNTER": "მთვლელის განულება",
    "CONTROL_ALLATONCE": "ყველაფერი ერთად",
    "DATA_SETVARIABLETO": "მიანიჭე %1ს %2",
    "DATA_CHANGEVARIABLEBY": "შეცვალე %1 %2ით",
    "DATA_SHOWVARIABLE": "გამოაჩინე ცვლადი %1",
    "DATA_HIDEVARIABLE": "დამალე ცვლადი %1",
    "DATA_ADDTOLIST": "დაუმატე %1 %2ს",
    "DATA_DELETEOFLIST": "წაშალე %1 %2დან",
    "DATA_DELETEALLOFLIST": "წაშალე ყველაფერი %1დან",
    "DATA_INSERTATLIST": "ჩასვი %1 %2მდე %3ში",
    "DATA_REPLACEITEMOFLIST": "შეცვალე %1 %2დან %3ით",
    "DATA_ITEMOFLIST": "ელემენტი %1 %2დან ",
    "DATA_ITEMNUMOFLIST": "%1 ელემენტის № %2ში",
    "DATA_LENGTHOFLIST": "%1ს სიგრძე",
    "DATA_LISTCONTAINSITEM": "%1 შეიცავს %2ს?",
    "DATA_SHOWLIST": "გამოაჩინე სია %1",
    "DATA_HIDELIST": "დამალე სია %1",
    "DATA_INDEX_ALL": "ყველა",
    "DATA_INDEX_LAST": "ბოლო",
    "DATA_INDEX_RANDOM": "შემთხვევითი",
    "EVENT_WHENFLAGCLICKED": "როდესაც აჭერ %1",
    "EVENT_WHENTHISSPRITECLICKED": "როდესაც აჭერ ამ სპრაიტს",
    "EVENT_WHENSTAGECLICKED": "როდესაც აჭერ სცენას",
    "EVENT_WHENTOUCHINGOBJECT": "როდესაც ეს სპრაიტი ეხება %1ს",
    "EVENT_WHENBROADCASTRECEIVED": "როდესაც ვიღებ %1ს",
    "EVENT_WHENBACKDROPSWITCHESTO": "როდესაც ფონი ხდება %1",
    "EVENT_WHENGREATERTHAN": "როდესაც %1 >%2",
    "EVENT_WHENGREATERTHAN_TIMER": "წამზომი",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ხმის სიმაღლე",
    "EVENT_BROADCAST": "გადაეცი %1",
    "EVENT_BROADCASTANDWAIT": "გადაეცი %1 და იცადე",
    "EVENT_WHENKEYPRESSED": "როდესაც აჭერ ღილაკს %1",
    "EVENT_WHENKEYPRESSED_SPACE": "დაშორება",
    "EVENT_WHENKEYPRESSED_LEFT": "ისარი მარცხნივ",
    "EVENT_WHENKEYPRESSED_RIGHT": "ისარი მარჯვნივ",
    "EVENT_WHENKEYPRESSED_DOWN": "ისარი ქვევით",
    "EVENT_WHENKEYPRESSED_UP": "ისარი ზევით",
    "EVENT_WHENKEYPRESSED_ANY": "ნებისმიერი",
    "LOOKS_SAYFORSECS": "თქვი %1 %2 წამით",
    "LOOKS_SAY": "თქვი %1",
    "LOOKS_HELLO": "გამარჯობა!",
    "LOOKS_THINKFORSECS": "იფიქრე %1 %2 წამით",
    "LOOKS_THINK": "იფიქრე %1",
    "LOOKS_HMM": "ჰმმ...",
    "LOOKS_SHOW": "გამოჩნდი",
    "LOOKS_HIDE": "დაიმალე",
    "LOOKS_HIDEALLSPRITES": "დამალე ყველა სპრაიტი",
    "LOOKS_EFFECT_COLOR": "ფერი",
    "LOOKS_EFFECT_FISHEYE": "თევზის თვალი",
    "LOOKS_EFFECT_WHIRL": "ქარიშხალი",
    "LOOKS_EFFECT_PIXELATE": "პიქსელიზაცია",
    "LOOKS_EFFECT_MOSAIC": "მოზაიკა",
    "LOOKS_EFFECT_BRIGHTNESS": "სიკაშკაშე",
    "LOOKS_EFFECT_GHOST": "მოჩვენება",
    "LOOKS_CHANGEEFFECTBY": "შეცვალე%1ეფექტი%2ით",
    "LOOKS_SETEFFECTTO": "დააყენე %1 ეფექტი %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "გრაფიკული ეფექტების მოხსნა",
    "LOOKS_CHANGESIZEBY": "შეცვალე ზომა %1ით",
    "LOOKS_SETSIZETO": "დააყენე ზომა %1 %",
    "LOOKS_SIZE": "ზომა",
    "LOOKS_CHANGESTRETCHBY": "შეცვალე დაჭიმულობა %1ით",
    "LOOKS_SETSTRETCHTO": "დაჭიმულობა %1 %",
    "LOOKS_SWITCHCOSTUMETO": "გადაერთე კოსტიუმზე %1",
    "LOOKS_NEXTCOSTUME": "მომდევნო კოსტიუმი",
    "LOOKS_SWITCHBACKDROPTO": "გადაერთე ფონზე %1",
    "LOOKS_GOTOFRONTBACK": "გადადი %1 შრეზე",
    "LOOKS_GOTOFRONTBACK_FRONT": "წინა",
    "LOOKS_GOTOFRONTBACK_BACK": "უკანა",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "გადადი %1 %2 შრით",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "წინ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "უკან",
    "LOOKS_BACKDROPNUMBERNAME": "ფონი %1",
    "LOOKS_COSTUMENUMBERNAME": "კოსტიუმი %1",
    "LOOKS_NUMBERNAME_NUMBER": "ნომერი",
    "LOOKS_NUMBERNAME_NAME": "სახელი",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "გადაერთე ფონზე %1 და იცადე",
    "LOOKS_NEXTBACKDROP_BLOCK": "მომდევნო ფონი",
    "LOOKS_NEXTBACKDROP": "მომდევნო ფონი",
    "LOOKS_PREVIOUSBACKDROP": "წინა ფონი",
    "LOOKS_RANDOMBACKDROP": "შემთხვევითი ფონი",
    "MOTION_MOVESTEPS": "გადადგი %1 ნაბიჯი",
    "MOTION_TURNLEFT": "მობრუნდი %1 %2 გრადუსით",
    "MOTION_TURNRIGHT": "მობრუნდი %1 %2 გრადუსით",
    "MOTION_POINTINDIRECTION": "მიუთითე %1 მიმართულებით",
    "MOTION_POINTTOWARDS": "მიუთითე %1",
    "MOTION_POINTTOWARDS_POINTER": "თაგვის მაჩვენებლისაკენ",
    "MOTION_POINTTOWARDS_RANDOM": "შემთხვევითი მიმართულებით",
    "MOTION_GOTO": "გადადი %1",
    "MOTION_GOTO_POINTER": "თაგვის მაჩვენებლისაკენ",
    "MOTION_GOTO_RANDOM": "შემთხვევითი ადგილისაკენ",
    "MOTION_GOTOXY": "გადადი x: %1 y:%2",
    "MOTION_GLIDESECSTOXY": "ისრიალე %1 წმ x:%2 y:%3კენ",
    "MOTION_GLIDETO": "ისრიალე %1 წმ %2",
    "MOTION_GLIDETO_POINTER": "თაგვის მაჩვენებლისაკენ",
    "MOTION_GLIDETO_RANDOM": "შემთხვევითი ადგილისაკენ",
    "MOTION_CHANGEXBY": "შეცვალე x %1ით",
    "MOTION_SETX": "მიანიჭე x-ს %1",
    "MOTION_CHANGEYBY": "შეცვალე y %1ით",
    "MOTION_SETY": "მიანიჭე y-ს %1",
    "MOTION_IFONEDGEBOUNCE": "ზღვარზე უკანდახევა",
    "MOTION_SETROTATIONSTYLE": "ბრუნვის წესი %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "მარცხნივ-მარჯვნივ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ბრუნვის გარეშე",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "გარშემო",
    "MOTION_XPOSITION": "x მდებარეობა",
    "MOTION_YPOSITION": "y მდებარეობა",
    "MOTION_DIRECTION": "მიმართულება",
    "MOTION_SCROLLRIGHT": "მარჯვნივ გადახვევა %1",
    "MOTION_SCROLLUP": "ზემოთ გადახვევა %1",
    "MOTION_ALIGNSCENE": "გაასწორე სცენა %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ქვედა-მარცხენა",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ქვედა-მარჯვენა",
    "MOTION_ALIGNSCENE_MIDDLE": "შუა",
    "MOTION_ALIGNSCENE_TOPLEFT": "ზედა-მარცხენა",
    "MOTION_ALIGNSCENE_TOPRIGHT": "ზედა-მარჯვენა",
    "MOTION_XSCROLL": "x გადახვევა",
    "MOTION_YSCROLL": "y გადახვევა",
    "MOTION_STAGE_SELECTED": "არჩეულია სცენა: მოძრაობის ბლოკების გარეშე",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1-%2",
    "OPERATORS_MULTIPLY": "%1*%2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "შემთხვევითი %1დან %2მდე",
    "OPERATORS_GT": "%1>%2",
    "OPERATORS_LT": "%1<%2",
    "OPERATORS_EQUALS": "%1=%2",
    "OPERATORS_AND": "%1 და %2",
    "OPERATORS_OR": "%1 ან %2",
    "OPERATORS_NOT": "არა %1",
    "OPERATORS_JOIN": "შეაერთე %1 %2",
    "OPERATORS_JOIN_APPLE": "ვაშლი",
    "OPERATORS_JOIN_BANANA": "ბანანი",
    "OPERATORS_LETTEROF": "ასო %1 %2დან ",
    "OPERATORS_LETTEROF_APPLE": "ა",
    "OPERATORS_LENGTH": "%1ს სიგრძე",
    "OPERATORS_CONTAINS": "%1 შეიცავს %2ს?",
    "OPERATORS_MOD": "%1 მოდული %2",
    "OPERATORS_ROUND": "დაამრგვალე %1",
    "OPERATORS_MATHOP": "%2ს %1",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "უმცირესი მთელი",
    "OPERATORS_MATHOP_CEILING": "უდიდესი მთელი",
    "OPERATORS_MATHOP_SQRT": "კვადრატული ფესვი",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10^",
    "PROCEDURES_DEFINITION": "განსაზღვრე %1",
    "SENSING_TOUCHINGOBJECT": "ეხება %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "თაგვის მაჩვენებელს",
    "SENSING_TOUCHINGOBJECT_EDGE": "ზღვარს",
    "SENSING_TOUCHINGCOLOR": "ეხება ფერს %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "ფერი %1 ეხება %2ს?",
    "SENSING_DISTANCETO": "მანძილი %1",
    "SENSING_DISTANCETO_POINTER": "თაგვის მაჩვენებლამდე",
    "SENSING_ASKANDWAIT": "იკითხე %1 და იცადე ",
    "SENSING_ASK_TEXT": "რა გქვია?",
    "SENSING_ANSWER": "პასუხი",
    "SENSING_KEYPRESSED": "ღილაკი %1 დაჭერილია?",
    "SENSING_MOUSEDOWN": "თაგვი დაჭერილია?",
    "SENSING_MOUSEX": "თაგვი x",
    "SENSING_MOUSEY": "თაგვი y",
    "SENSING_SETDRAGMODE": "გადატანის წესი %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "შეიძლება",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "არ შეიძლება",
    "SENSING_LOUDNESS": "ხმის სიმაღლე",
    "SENSING_LOUD": "ხმა მაღალია?",
    "SENSING_TIMER": "წამზომი",
    "SENSING_RESETTIMER": "წამზომის განულება",
    "SENSING_OF": "%2ს %1",
    "SENSING_OF_XPOSITION": "x მდებარეობა",
    "SENSING_OF_YPOSITION": "y მდებარეობა",
    "SENSING_OF_DIRECTION": "მიმართულება",
    "SENSING_OF_COSTUMENUMBER": "კოსტიუმის ნომერი",
    "SENSING_OF_COSTUMENAME": "კოსტიუმის სახელი",
    "SENSING_OF_SIZE": "ზომა",
    "SENSING_OF_VOLUME": "ხმის სიმაღლე",
    "SENSING_OF_BACKDROPNUMBER": "ფონის ნომერი",
    "SENSING_OF_BACKDROPNAME": "ფონის სახელი",
    "SENSING_OF_STAGE": "სცენა",
    "SENSING_CURRENT": "მიმდინარე %1",
    "SENSING_CURRENT_YEAR": "წელი",
    "SENSING_CURRENT_MONTH": "თვე",
    "SENSING_CURRENT_DATE": "თარიღი",
    "SENSING_CURRENT_DAYOFWEEK": "კვირის დღე",
    "SENSING_CURRENT_HOUR": "საათი",
    "SENSING_CURRENT_MINUTE": "წუთი",
    "SENSING_CURRENT_SECOND": "წამი",
    "SENSING_DAYSSINCE2000": "2000-ის შემდგომი დღეები",
    "SENSING_USERNAME": "მომხმარებელი",
    "SENSING_USERID": "მომხმარებლის id",
    "SOUND_PLAY": "ჩართე ხმა %1",
    "SOUND_PLAYUNTILDONE": "დაუკარი ხმა %1 დასრულებამდე",
    "SOUND_STOPALLSOUNDS": "გამორთე ყველა ხმა",
    "SOUND_SETEFFECTO": "დააყენე%1ეფექტი%2",
    "SOUND_CHANGEEFFECTBY": "შეცვალე%1ეფექტი%2ით",
    "SOUND_CLEAREFFECTS": "ხმის ეფექტების მოხსნა",
    "SOUND_EFFECTS_PITCH": "ბგერის სიმაღლე",
    "SOUND_EFFECTS_PAN": "ხმა მარცხნიდან/მარჯვნიდან",
    "SOUND_CHANGEVOLUMEBY": "შეცვლე ხმის სიმაღლე %1ით",
    "SOUND_SETVOLUMETO": "ხმის სიმაღლე %1%",
    "SOUND_VOLUME": "ხმის სიმაღლე",
    "SOUND_RECORD": "ჩაწერა...",
    "CATEGORY_MOTION": "მოძრაობა",
    "CATEGORY_LOOKS": "გარეგნობა",
    "CATEGORY_SOUND": "ხმა",
    "CATEGORY_EVENTS": "მოვლენები",
    "CATEGORY_CONTROL": "მართვა",
    "CATEGORY_SENSING": "სენსორები",
    "CATEGORY_OPERATORS": "ოპერატორები",
    "CATEGORY_VARIABLES": "ცვლადები",
    "CATEGORY_MYBLOCKS": "ჩემი ბლოკები",
    "DUPLICATE": "დუბლირება",
    "DELETE": "წაშლა",
    "ADD_COMMENT": "დაამატე კომენტარი",
    "REMOVE_COMMENT": "წაშალე კომენტარი",
    "DELETE_BLOCK": "წაშალე ბლოკი",
    "DELETE_X_BLOCKS": "წაშალე %1 ბლოკები",
    "DELETE_ALL_BLOCKS": "წავშალო ყველა %1 ბლოკები?",
    "CLEAN_UP": "გაასუფთავე ბლოკები",
    "HELP": "დახმარება",
    "UNDO": "მოქმედების გაუქმება",
    "REDO": "აღდგენა",
    "EDIT_PROCEDURE": "რედაქტირება",
    "SHOW_PROCEDURE_DEFINITION": "გადადი განმარტებაზე",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "თქვი რამე...",
    "COLOUR_HUE_LABEL": "ფერი",
    "COLOUR_SATURATION_LABEL": "გაჯერება",
    "COLOUR_BRIGHTNESS_LABEL": "სიკაშკაშე",
    "CHANGE_VALUE_TITLE": "შეცვალე მნიშვნელობა:",
    "RENAME_VARIABLE": "შეუცვალე სახელი ცვლადს",
    "RENAME_VARIABLE_TITLE": "შეუცვალე სახელი ყველა \"%1\" ცვლადს შემდეგით:",
    "RENAME_VARIABLE_MODAL_TITLE": "შეუცვალე სახელი ცვლადს",
    "NEW_VARIABLE": "შექმენი ცვლადი",
    "NEW_VARIABLE_TITLE": "ახალი ცვლადის სახელი:",
    "VARIABLE_MODAL_TITLE": "ახალი ცვლადი",
    "VARIABLE_ALREADY_EXISTS": "ცვლადი სახელად \"%1\" უკვე არსებობს",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "ცვლადი სახელად \"%1\" უკვე არსებობს სხვა ცვლადების ტიპისათვის \"%2\" ",
    "DELETE_VARIABLE_CONFIRMATION": "წავშალო \"%2\" ცვლადის %1 გამოყენება? ",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "შეუძლებელია ცვლადი \"%1\"-ის წაშლა რადგან ის არის \"%2\"-ის ფუნქციის განსაზღვრის ნაწილი ",
    "DELETE_VARIABLE": "წაშალე ცვლადი \"%1\"",
    "NEW_PROCEDURE": "შექმენი ბლოკი",
    "PROCEDURE_ALREADY_EXISTS": "პროცედურა სახელად \"%1\" უკვე არსებობს",
    "PROCEDURE_DEFAULT_NAME": "ბლოკის სახელი",
    "PROCEDURE_USED": "ბლოკის განსაზღვრის წასაშლელად ჯერ მისი ყველა გამოყენება ამოიღე",
    "NEW_LIST": "შექმენი სია",
    "NEW_LIST_TITLE": "ახალი სიის სახელი:",
    "LIST_MODAL_TITLE": "ახალი სია",
    "LIST_ALREADY_EXISTS": "სია სახელად \"%1\" უკვე არსებობს",
    "RENAME_LIST_TITLE": "შეუცვალე სახელი ყველა \"%1\" სიას:",
    "RENAME_LIST_MODAL_TITLE": "სიის სახელის შეცვლა",
    "DEFAULT_LIST_ITEM": "რაიმე",
    "DELETE_LIST": "წაშალე  სია \"%1\"",
    "RENAME_LIST": "სიის სახელის შეცვლა",
    "NEW_BROADCAST_MESSAGE": "ახალი შეტყობინება",
    "NEW_BROADCAST_MESSAGE_TITLE": "ახალი შეტყობინების სახელი",
    "BROADCAST_MODAL_TITLE": "ახალი შეტყობინება",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "შეტყობინება1"
  },
  "kk": {
    "CONTROL_FOREVER": "әрқашан",
    "CONTROL_REPEAT": "%1 рет қайталау",
    "CONTROL_IF": "егер %1, онда",
    "CONTROL_ELSE": "әйтпесе",
    "CONTROL_STOP": "тоқтату",
    "CONTROL_STOP_ALL": "барлық",
    "CONTROL_STOP_THIS": "осы скрипт",
    "CONTROL_STOP_OTHER": "спрайттағы басқа скрипттер",
    "CONTROL_WAIT": "%1 секунд күту",
    "CONTROL_WAITUNTIL": "%1 секундка дейін күту",
    "CONTROL_REPEATUNTIL": "%1 болғанға дейін қайталау",
    "CONTROL_WHILE": "%1 дейін",
    "CONTROL_FOREACH": "әр %2дегі %1 үшін",
    "CONTROL_STARTASCLONE": "мен клон ретінде бастағанда",
    "CONTROL_CREATECLONEOF": "%1 клонын жасау",
    "CONTROL_CREATECLONEOF_MYSELF": "өзім",
    "CONTROL_DELETETHISCLONE": "бұл клонды жою",
    "CONTROL_COUNTER": "санауыш",
    "CONTROL_INCRCOUNTER": "санауышты өсіру",
    "CONTROL_CLEARCOUNTER": "санауышты өшіру",
    "CONTROL_ALLATONCE": "барлығын бірден",
    "DATA_SETVARIABLETO": "%2ге %1ді орнату",
    "DATA_CHANGEVARIABLEBY": "%1ді %2ге өзгерту",
    "DATA_SHOWVARIABLE": "%1 айнымалысын көрсету",
    "DATA_HIDEVARIABLE": "%1 айнымалысын жасыру",
    "DATA_ADDTOLIST": "%1ге %2ні қосу",
    "DATA_DELETEOFLIST": "%2ден %1ді алу",
    "DATA_DELETEALLOFLIST": "%1 түгел жою",
    "DATA_INSERTATLIST": "%3тің %2сіне %1ді салу",
    "DATA_REPLACEITEMOFLIST": "%2нің %1ін %3пен алмастыру",
    "DATA_ITEMOFLIST": "%2нің %1і",
    "DATA_ITEMNUMOFLIST": "%2дегі %1 мүшесінің #",
    "DATA_LENGTHOFLIST": "%1дің ұзындығы",
    "DATA_LISTCONTAINSITEM": "%1де %2 бар ма?",
    "DATA_SHOWLIST": "%1 тізімін көрсет",
    "DATA_HIDELIST": "%1 тізімін жасыр",
    "DATA_INDEX_ALL": "Барлық",
    "DATA_INDEX_LAST": "соңғы",
    "DATA_INDEX_RANDOM": "кездейсоқ",
    "EVENT_WHENFLAGCLICKED": "%1 басылғанда",
    "EVENT_WHENTHISSPRITECLICKED": "спрайт басылған кезде",
    "EVENT_WHENSTAGECLICKED": "сахна басылғанда",
    "EVENT_WHENTOUCHINGOBJECT": "осы спрайт %1ге тигенде",
    "EVENT_WHENBROADCASTRECEIVED": "маған %1 келгенде",
    "EVENT_WHENBACKDROPSWITCHESTO": "аясы %1ге ауысқанда",
    "EVENT_WHENGREATERTHAN": "%1>%2 болғанда",
    "EVENT_WHENGREATERTHAN_TIMER": "таймер",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "дыбыс деңгейі",
    "EVENT_BROADCAST": "%1ді тарату",
    "EVENT_BROADCASTANDWAIT": "%1ді таратып күту",
    "EVENT_WHENKEYPRESSED": "%1 пернесі басылғанда",
    "EVENT_WHENKEYPRESSED_SPACE": "пробел",
    "EVENT_WHENKEYPRESSED_LEFT": "нұсқары солға",
    "EVENT_WHENKEYPRESSED_RIGHT": "нұсқары оңға",
    "EVENT_WHENKEYPRESSED_DOWN": "нұсқары төмен",
    "EVENT_WHENKEYPRESSED_UP": "нұсқары жоғары",
    "EVENT_WHENKEYPRESSED_ANY": "кез келген",
    "LOOKS_SAYFORSECS": "%2 секунд бойы %1 айту",
    "LOOKS_SAY": "%1 де",
    "LOOKS_HELLO": "Сәлем!",
    "LOOKS_THINKFORSECS": "%2 секунд бойы %1 ойла",
    "LOOKS_THINK": "%1 ойла",
    "LOOKS_HMM": "Хмм...",
    "LOOKS_SHOW": "көрсету",
    "LOOKS_HIDE": "жасыру",
    "LOOKS_HIDEALLSPRITES": "барлық спрайттарды жасыру",
    "LOOKS_EFFECT_COLOR": "түс",
    "LOOKS_EFFECT_FISHEYE": "балық көз",
    "LOOKS_EFFECT_WHIRL": "құйындау",
    "LOOKS_EFFECT_PIXELATE": "пиксельдерді ірілендіру",
    "LOOKS_EFFECT_MOSAIC": "мозаика",
    "LOOKS_EFFECT_BRIGHTNESS": "жарықтық",
    "LOOKS_EFFECT_GHOST": "елес",
    "LOOKS_CHANGEEFFECTBY": "%1 әсерін %2ге өзерту",
    "LOOKS_SETEFFECTTO": "%2ге %1 әсерін беру",
    "LOOKS_CLEARGRAPHICEFFECTS": "сызбалық әсерлерді тазалау",
    "LOOKS_CHANGESIZEBY": "өлшемді %1ге өзгерту",
    "LOOKS_SETSIZETO": "өлшем мәніне %1 беру",
    "LOOKS_SIZE": "өлшем",
    "LOOKS_CHANGESTRETCHBY": "созылуын %1ге өзгерту",
    "LOOKS_SETSTRETCHTO": "созылуы мәнін %1 ету",
    "LOOKS_SWITCHCOSTUMETO": "киімін %1ге ауыстыру",
    "LOOKS_NEXTCOSTUME": "келесі костюм",
    "LOOKS_SWITCHBACKDROPTO": "аясын %1ге ауыстыру",
    "LOOKS_GOTOFRONTBACK": "%1 қабатына бару",
    "LOOKS_GOTOFRONTBACK_FRONT": "алды",
    "LOOKS_GOTOFRONTBACK_BACK": "арты",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 қабаттарына бару",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "алдыға",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "артқа",
    "LOOKS_BACKDROPNUMBERNAME": "%1 аясы",
    "LOOKS_COSTUMENUMBERNAME": "%1 киімі",
    "LOOKS_NUMBERNAME_NUMBER": "сан",
    "LOOKS_NUMBERNAME_NAME": "есім",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "аясын %1ге ауыстырып күту",
    "LOOKS_NEXTBACKDROP_BLOCK": "келесі фон",
    "LOOKS_NEXTBACKDROP": "келесі фон",
    "LOOKS_PREVIOUSBACKDROP": "алдыңғы фон",
    "LOOKS_RANDOMBACKDROP": "кездейсоқ аяны орнату",
    "MOTION_MOVESTEPS": "%1 қадамға жылжу",
    "MOTION_TURNLEFT": "%1ді %2ге градусқа бұру",
    "MOTION_TURNRIGHT": "%1ді %2ге градусқа бұру",
    "MOTION_POINTINDIRECTION": "%1 бағытына бұру",
    "MOTION_POINTTOWARDS": "%1 бағытында",
    "MOTION_POINTTOWARDS_POINTER": "тінтуір көрсеткіші",
    "MOTION_POINTTOWARDS_RANDOM": "кездейсоқ бағыт",
    "MOTION_GOTO": "%1ге бару",
    "MOTION_GOTO_POINTER": "тінтуір көрсеткіші",
    "MOTION_GOTO_RANDOM": "кездейсоқ орын",
    "MOTION_GOTOXY": "x: %1 y:%2 бару",
    "MOTION_GLIDESECSTOXY": "%1 секунд бойы x: %2 y: %3ке сырғу",
    "MOTION_GLIDETO": "%2ге %1 секунд бойы сырғу",
    "MOTION_GLIDETO_POINTER": "тінтуір көрсеткіші",
    "MOTION_GLIDETO_RANDOM": "кездейсоқ орын",
    "MOTION_CHANGEXBY": "x мәнін %1ге өзгерту",
    "MOTION_SETX": "x-қа %1 мәнін беру",
    "MOTION_CHANGEYBY": "y-ті %1ге өзгерту",
    "MOTION_SETY": "y-ке %1 мәнін беру",
    "MOTION_IFONEDGEBOUNCE": "шетте болса, әрі итерілу",
    "MOTION_SETROTATIONSTYLE": "бұрылу стиліне %1 мәнін беру",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "солға-оңға",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "айналдырмау",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "барлық айналасында",
    "MOTION_XPOSITION": "x орны",
    "MOTION_YPOSITION": "y орны",
    "MOTION_DIRECTION": "бағыт",
    "MOTION_SCROLLRIGHT": "%1ге оңға жылжу",
    "MOTION_SCROLLUP": "%1ге жоғары жылжу",
    "MOTION_ALIGNSCENE": "сахнаны  %1ге түзету",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "төменгі сол жағы",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "төменгі оң жағы",
    "MOTION_ALIGNSCENE_MIDDLE": "ортасы",
    "MOTION_ALIGNSCENE_TOPLEFT": "жоғарғы сол жағы",
    "MOTION_ALIGNSCENE_TOPRIGHT": "жоғарғы оң жағы",
    "MOTION_XSCROLL": "x жылжыту",
    "MOTION_YSCROLL": "y жылжыту",
    "MOTION_STAGE_SELECTED": "Таңдалған орта: қимылсыз блоктар",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 мен %2 аралығындағы кездейсоқ санды таңда",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 and %2",
    "OPERATORS_OR": "%1 немесе %2",
    "OPERATORS_NOT": "%1 емес",
    "OPERATORS_JOIN": "%1 %2 біріктіру",
    "OPERATORS_JOIN_APPLE": "алма",
    "OPERATORS_JOIN_BANANA": "банан",
    "OPERATORS_LETTEROF": "%2нің %1 әрібі",
    "OPERATORS_LETTEROF_APPLE": "а",
    "OPERATORS_LENGTH": "%1дің ұзындығы",
    "OPERATORS_CONTAINS": "%1де %2 бар ма?",
    "OPERATORS_MOD": "%1 қб %2",
    "OPERATORS_ROUND": "%1ді дөңгелекте",
    "OPERATORS_MATHOP": "%2нің %1і",
    "OPERATORS_MATHOP_ABS": "модуль",
    "OPERATORS_MATHOP_FLOOR": "еден",
    "OPERATORS_MATHOP_CEILING": "шектеу",
    "OPERATORS_MATHOP_SQRT": "квадрат түбір",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "%1ге мән бер",
    "SENSING_TOUCHINGOBJECT": "%1ге тиді ме?",
    "SENSING_TOUCHINGOBJECT_POINTER": "тінтуір көрсеткіші",
    "SENSING_TOUCHINGOBJECT_EDGE": "шет",
    "SENSING_TOUCHINGCOLOR": "%1 түсіне тиді ме?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 түсі %2ге тиді ме?",
    "SENSING_DISTANCETO": "%1 дейінгі қашықтық",
    "SENSING_DISTANCETO_POINTER": "тінтуір көрсеткіші",
    "SENSING_ASKANDWAIT": "%1ден сұра да күт",
    "SENSING_ASK_TEXT": "Сенің есімің кім?",
    "SENSING_ANSWER": "жауап",
    "SENSING_KEYPRESSED": "%1 пернесі басылды ма?",
    "SENSING_MOUSEDOWN": "тінтуір басылған ба?",
    "SENSING_MOUSEX": "тінтуір x бойынша",
    "SENSING_MOUSEY": "тінтуір y бойынша",
    "SENSING_SETDRAGMODE": "%1 тарту күйін орнату",
    "SENSING_SETDRAGMODE_DRAGGABLE": "тартылмалы",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "тартылмалы емес",
    "SENSING_LOUDNESS": "дыбыс қаттылығы",
    "SENSING_LOUD": "дауысу тым жоғары ма?",
    "SENSING_TIMER": "таймер",
    "SENSING_RESETTIMER": "таймерді қайта іске қосу",
    "SENSING_OF": "%2нің %1і",
    "SENSING_OF_XPOSITION": "x орны",
    "SENSING_OF_YPOSITION": "y орны",
    "SENSING_OF_DIRECTION": "бағыт",
    "SENSING_OF_COSTUMENUMBER": "костюм #",
    "SENSING_OF_COSTUMENAME": "костюм аты",
    "SENSING_OF_SIZE": "өлшем",
    "SENSING_OF_VOLUME": "дыбыс",
    "SENSING_OF_BACKDROPNUMBER": "фон #",
    "SENSING_OF_BACKDROPNAME": "фонның аты",
    "SENSING_OF_STAGE": "Көрініс",
    "SENSING_CURRENT": "ағымдағы %1",
    "SENSING_CURRENT_YEAR": "жыл",
    "SENSING_CURRENT_MONTH": "ай",
    "SENSING_CURRENT_DATE": "төмен",
    "SENSING_CURRENT_DAYOFWEEK": "апта күні",
    "SENSING_CURRENT_HOUR": "сағат",
    "SENSING_CURRENT_MINUTE": "минут",
    "SENSING_CURRENT_SECOND": "секунд",
    "SENSING_DAYSSINCE2000": "2000-шы жылдан бастап күндер",
    "SENSING_USERNAME": "пайдаланушының аты",
    "SENSING_USERID": "қолданушы id",
    "SOUND_PLAY": "%1 дыбысын баста",
    "SOUND_PLAYUNTILDONE": "%1 дыбысын ақталғанша ойна",
    "SOUND_STOPALLSOUNDS": "Дыбыстардың барлығын тоқтатыңыз",
    "SOUND_SETEFFECTO": "%2ге %1 әсерін беру",
    "SOUND_CHANGEEFFECTBY": "%1 әсерін %2ге өзерту",
    "SOUND_CLEAREFFECTS": "дыбыс эффектерін жою",
    "SOUND_EFFECTS_PITCH": "лақтыру",
    "SOUND_EFFECTS_PAN": "оң/сол қыздыру",
    "SOUND_CHANGEVOLUMEBY": "мәнін %1-ге өзгерту",
    "SOUND_SETVOLUMETO": "дыбыс күштілігін %1% орнату",
    "SOUND_VOLUME": "Дыбыс",
    "SOUND_RECORD": "жазу...",
    "CATEGORY_MOTION": "Қозғалыс",
    "CATEGORY_LOOKS": "Келбет",
    "CATEGORY_SOUND": "Дыбыс",
    "CATEGORY_EVENTS": "Оқиғалар",
    "CATEGORY_CONTROL": "Басқару",
    "CATEGORY_SENSING": "Сенсорлер",
    "CATEGORY_OPERATORS": "Операторлар",
    "CATEGORY_VARIABLES": "айнымалылар",
    "CATEGORY_MYBLOCKS": "Менің блоктарым",
    "DUPLICATE": "Көшірмесін жасау",
    "DELETE": "Жою",
    "ADD_COMMENT": "Комментарий жазу",
    "REMOVE_COMMENT": "Комментарийді өшіру",
    "DELETE_BLOCK": "Блокты өшіру",
    "DELETE_X_BLOCKS": "%1 блоктарын өшіру",
    "DELETE_ALL_BLOCKS": "Барлық %1 блоктарын өшіру?",
    "CLEAN_UP": "Блоктарды тазалау",
    "HELP": "Көмек",
    "UNDO": "Болдырмау",
    "REDO": "Қайталау",
    "EDIT_PROCEDURE": "Түзету",
    "SHOW_PROCEDURE_DEFINITION": "Анықтамасын ашу",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Сөйле...",
    "COLOUR_HUE_LABEL": "Түс",
    "COLOUR_SATURATION_LABEL": "Қанықтылық",
    "COLOUR_BRIGHTNESS_LABEL": "Жарықтығы",
    "CHANGE_VALUE_TITLE": "Мәнін өзгерту:",
    "RENAME_VARIABLE": "Айнымалының атын өзгерту",
    "RENAME_VARIABLE_TITLE": "Барлық \"%1\" айнымалыларының атын мынаған өзгерту:",
    "RENAME_VARIABLE_MODAL_TITLE": "Айнымалының атын өзгерту",
    "NEW_VARIABLE": "Айнымалы жасау",
    "NEW_VARIABLE_TITLE": "Жаңа айнымаланың атауы: ",
    "VARIABLE_MODAL_TITLE": "Жаңа айнымалы",
    "VARIABLE_ALREADY_EXISTS": "\"%1\" атты айнымалысы жарияланған.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "\"%1\" атты айнымалы \"%2\" типіндегі басқа айнымалыға арнап жарияланған.",
    "DELETE_VARIABLE_CONFIRMATION": "%2 айнымалысның %1 пайдаланылуын өшіру қажет пе?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "%1 айнымалысын өшіру мүмкін емес, себебі ол %2 функциясының мүшесі",
    "DELETE_VARIABLE": "%1 айнымалысын өшіру",
    "NEW_PROCEDURE": "Блок жасау",
    "PROCEDURE_ALREADY_EXISTS": "\"%1\" атты процедура жарияланған.",
    "PROCEDURE_DEFAULT_NAME": "блоктың атауы",
    "PROCEDURE_USED": "блок анықтамасын өшіру үшін, алдымен блоктың барлық жердегі қолдануларын өшір",
    "NEW_LIST": "Тізім жасау",
    "NEW_LIST_TITLE": "Жаңа тізімнің атауы",
    "LIST_MODAL_TITLE": "Жаңа тізім",
    "LIST_ALREADY_EXISTS": "\"%1\" атты тізім жарияланған.",
    "RENAME_LIST_TITLE": "Барлық \"%1\" тізімдерінің атауын өзгерту:",
    "RENAME_LIST_MODAL_TITLE": "Тізімнің атауын өзгерту",
    "DEFAULT_LIST_ITEM": "зат",
    "DELETE_LIST": "\"%1\" тізімін өшіру",
    "RENAME_LIST": "Тізімнің атауын өзгерту",
    "NEW_BROADCAST_MESSAGE": "Жаға хабарлама",
    "NEW_BROADCAST_MESSAGE_TITLE": "Жаңа хабарламаның атауы",
    "BROADCAST_MODAL_TITLE": "Жаңа Хабарлама",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "хабарлама1"
  },
  "qu": {
    "CONTROL_FOREVER": "wiñaypaq",
    "CONTROL_REPEAT": "musuqmanta %1",
    "CONTROL_IF": "icha %1 hinaptin",
    "CONTROL_ELSE": "ñataq",
    "CONTROL_STOP": "sayay",
    "CONTROL_STOP_ALL": "llapa",
    "CONTROL_STOP_THIS": "kay qillqay",
    "CONTROL_STOP_OTHER": "huk qillqaykuna ipupi",
    "CONTROL_WAIT": "Suyay %1 kaq",
    "CONTROL_WAITUNTIL": "suyaykuy askama %1",
    "CONTROL_REPEATUNTIL": "musuqmanta ruray askama %1",
    "CONTROL_WHILE": "chawpillampi %1",
    "CONTROL_FOREACH": "sapa %1 llapanmanta %2 ",
    "CONTROL_STARTASCLONE": "Hayka qallarisaq huk ñuqahina",
    "CONTROL_CREATECLONEOF": "ruray huk hukhinata %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ñuqa",
    "CONTROL_DELETETHISCLONE": "wañuchiy kay hukhina",
    "CONTROL_COUNTER": "yupay",
    "CONTROL_INCRCOUNTER": "masyachiy yupaykunata",
    "CONTROL_CLEARCOUNTER": "yupaq",
    "CONTROL_ALLATONCE": "Hinaspa",
    "DATA_SETVARIABLETO": "llapa kaymanta %1  kayman %2 ",
    "DATA_CHANGEVARIABLEBY": "tikray %1 kaywan %2",
    "DATA_SHOWVARIABLE": "qawachiy kayta %1",
    "DATA_HIDEVARIABLE": "pakay kayta %1",
    "DATA_ADDTOLIST": "yapay %1 kayman %2",
    "DATA_DELETEOFLIST": "anchuchiy %1 kaymanta %2",
    "DATA_DELETEALLOFLIST": "anchuchiy llapanta %1 ",
    "DATA_INSERTATLIST": "winay %1 chaymantapas %2 kaymanta %3",
    "DATA_REPLACEITEMOFLIST": "kikraykuy chayta %1 kaymanta %2 kaywan %3",
    "DATA_ITEMOFLIST": "Imakuna %1 kaymanta %2",
    "DATA_ITEMNUMOFLIST": "Imakuna # kaypa %1 in %2",
    "DATA_LENGTHOFLIST": "sunin %1",
    "DATA_LISTCONTAINSITEM": "%1  kachkanchu %2?",
    "DATA_SHOWLIST": "qawachiy qillqayta %1",
    "DATA_HIDELIST": "pakay qillqayta %1",
    "DATA_INDEX_ALL": "llapa",
    "DATA_INDEX_LAST": "qipa",
    "DATA_INDEX_RANDOM": "mayqimpas",
    "EVENT_WHENFLAGCLICKED": "haykapi %1 ñitiypi",
    "EVENT_WHENTHISSPRITECLICKED": "kay muki ñitinqa",
    "EVENT_WHENSTAGECLICKED": "iscinario ñitinqa",
    "EVENT_WHENTOUCHINGOBJECT": "kay muki ñitinqa %1",
    "EVENT_WHENBROADCASTRECEIVED": "ñuqa chaskispa %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "ukuchaknin hipaynin %1",
    "EVENT_WHENGREATERTHAN": "maypi %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "yupachaq",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "qapariknin",
    "EVENT_BROADCAST": "qawachinapaq %1",
    "EVENT_BROADCASTANDWAIT": "qawachinapaq %1 chaymanta suyay",
    "EVENT_WHENKEYPRESSED": "ñitispa  kay %1 qillqanata",
    "EVENT_WHENKEYPRESSED_SPACE": "chimpa",
    "EVENT_WHENKEYPRESSED_LEFT": "lluqiman qillqana",
    "EVENT_WHENKEYPRESSED_RIGHT": "alliqman qillqana",
    "EVENT_WHENKEYPRESSED_DOWN": "urayman qillqana",
    "EVENT_WHENKEYPRESSED_UP": "hanayman qillqana",
    "EVENT_WHENKEYPRESSED_ANY": "mayqimpas",
    "LOOKS_SAYFORSECS": "niykuy %1 %2 sigundus unayman",
    "LOOKS_SAY": "niykuy %1",
    "LOOKS_HELLO": "Rimaykullayki!",
    "LOOKS_THINKFORSECS": "umachay %1 %2 sigundus unayman",
    "LOOKS_THINK": "umachay %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "qawanapaq",
    "LOOKS_HIDE": "pakay",
    "LOOKS_HIDEALLSPRITES": "pakay llapa mukikunata",
    "LOOKS_EFFECT_COLOR": "kulur",
    "LOOKS_EFFECT_FISHEYE": "qawachinapaq",
    "LOOKS_EFFECT_WHIRL": "muyuy",
    "LOOKS_EFFECT_PIXELATE": "qillqaslla",
    "LOOKS_EFFECT_MOSAIC": "uchuy qillqaykuna",
    "LOOKS_EFFECT_BRIGHTNESS": "kanchiq",
    "LOOKS_EFFECT_GHOST": "aya",
    "LOOKS_CHANGEEFFECTBY": "tikray %1 imayna rikuriqninta kaywan %2",
    "LOOKS_SETEFFECTTO": "churaykuy %1 imayna rikuriqninta %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "pichay llapa qillqaykunata",
    "LOOKS_CHANGESIZEBY": "tikray imayna hatunkarayninta %1",
    "LOOKS_SETSIZETO": "churay imayna hatunkarayninta %1 %",
    "LOOKS_SIZE": "hatunin",
    "LOOKS_CHANGESTRETCHBY": "tikray chutayninta %1",
    "LOOKS_SETSTRETCHTO": "churay chutayninta %1 %",
    "LOOKS_SWITCHCOSTUMETO": "tikray pachata %1",
    "LOOKS_NEXTCOSTUME": "huknin pacha",
    "LOOKS_SWITCHBACKDROPTO": "tikray ukuqillqayta %1",
    "LOOKS_GOTOFRONTBACK": "riy %1 chukuman",
    "LOOKS_GOTOFRONTBACK_FRONT": "chimpa",
    "LOOKS_GOTOFRONTBACK_BACK": "hipa",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "riy %1 %2 chukukunaman",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "apachiy",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "riy hipaman",
    "LOOKS_BACKDROPNUMBERNAME": "uku lliklla %1",
    "LOOKS_COSTUMENUMBERNAME": "pacha %1",
    "LOOKS_NUMBERNAME_NUMBER": "yupay",
    "LOOKS_NUMBERNAME_NAME": "suti",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "tikray ukuqillqayta %1 hinaspa suyay",
    "LOOKS_NEXTBACKDROP_BLOCK": "huk uku lliklla",
    "LOOKS_NEXTBACKDROP": "huk uku lliklla",
    "LOOKS_PREVIOUSBACKDROP": "ñawpaq uku lliklla",
    "LOOKS_RANDOMBACKDROP": "mayqin uku lliklla",
    "MOTION_MOVESTEPS": "muyuq %1 chankayta",
    "MOTION_TURNLEFT": "muyuy %1 %2 gradukuna",
    "MOTION_TURNRIGHT": "muyuy %1 %2 gradukuna",
    "MOTION_POINTINDIRECTION": "rikuy kaylawman %1",
    "MOTION_POINTTOWARDS": "rikuy chayman %1",
    "MOTION_POINTTOWARDS_POINTER": "ukucha puntan",
    "MOTION_POINTTOWARDS_RANDOM": "maymanpas",
    "MOTION_GOTO": "pasay %1",
    "MOTION_GOTO_POINTER": "ukucha puntan",
    "MOTION_GOTO_RANDOM": "maypipas sayay",
    "MOTION_GOTOXY": "riy x: %1 chaymanta: %2",
    "MOTION_GLIDESECSTOXY": "muyuy %1 sigunduta x:%2 chaymanta y: %3",
    "MOTION_GLIDETO": "muyuy %1 segundukuna kayman %2 ",
    "MOTION_GLIDETO_POINTER": "ukucha puntan",
    "MOTION_GLIDETO_RANDOM": "maypipas sayay",
    "MOTION_CHANGEXBY": "tikray x kaywan %1",
    "MOTION_SETX": "churay x %1",
    "MOTION_CHANGEYBY": "tikray y kaywan %1",
    "MOTION_SETY": "churay y %1",
    "MOTION_IFONEDGEBOUNCE": "icha kachkan patapi, pinkin",
    "MOTION_SETROTATIONSTYLE": "churay imayna muyunampaq %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "ichuq - alliq",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "mana muyuq",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "maymanpas muyuq",
    "MOTION_XPOSITION": "x sayay",
    "MOTION_YPOSITION": "y sayay",
    "MOTION_DIRECTION": "maypi",
    "MOTION_SCROLLRIGHT": "alliqman puriy %1",
    "MOTION_SCROLLUP": "hanayman puriy %1",
    "MOTION_ALIGNSCENE": "llamcayninchikta sichyay %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ichuq- butun",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "alliq-butun",
    "MOTION_ALIGNSCENE_MIDDLE": "chawpi",
    "MOTION_ALIGNSCENE_TOPLEFT": "hanay-ichuq",
    "MOTION_ALIGNSCENE_TOPRIGHT": "hanay-alliq",
    "MOTION_XSCROLL": "x puriy",
    "MOTION_YSCROLL": "y puriy",
    "MOTION_STAGE_SELECTED": "Chimpa qaway akllasqa: mana Muyuy champa",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%2 - %1",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%2 / %1",
    "OPERATORS_RANDOM": "mayqintapas akllay %1 kayman %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 chaymanta %2",
    "OPERATORS_OR": "%1 utaq %2",
    "OPERATORS_NOT": "manam %1",
    "OPERATORS_JOIN": "huqllachay %1 %2",
    "OPERATORS_JOIN_APPLE": "mansana",
    "OPERATORS_JOIN_BANANA": "platanu",
    "OPERATORS_LETTEROF": "qillqa %1 chaymanta %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "sunin %1",
    "OPERATORS_CONTAINS": "%1  kachkanchu %2?",
    "OPERATORS_MOD": "%1 awqa %2",
    "OPERATORS_ROUND": "muyunchay %1",
    "OPERATORS_MATHOP": "%1 kaymanta %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "allpa",
    "OPERATORS_MATHOP_CEILING": "qata",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "in",
    "OPERATORS_MATHOP_LOG": "Qallarichiy",
    "OPERATORS_MATHOP_EEXP": "Y ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "nin %1",
    "SENSING_TOUCHINGOBJECT": "tukay %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "ukucha puntan",
    "SENSING_TOUCHINGOBJECT_EDGE": "kantu",
    "SENSING_TOUCHINGCOLOR": "tukay kulur %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "kulur %1 tukachkan %2?",
    "SENSING_DISTANCETO": "karumanta %1",
    "SENSING_DISTANCETO_POINTER": "ukucha puntan",
    "SENSING_ASKANDWAIT": "tapuy %1 chaymanta suyay",
    "SENSING_ASK_TEXT": "imaynataq sutiki?",
    "SENSING_ANSWER": "kutichiy rimayta",
    "SENSING_KEYPRESSED": "tikla %1 ñitiy?",
    "SENSING_MOUSEDOWN": "ukucha urayman?",
    "SENSING_MOUSEX": "ukucha x",
    "SENSING_MOUSEY": "ukucha y",
    "SENSING_SETDRAGMODE": "churay aysanaman %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "aysana",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "mana aysana",
    "SENSING_LOUDNESS": "qapariknin",
    "SENSING_LOUD": "qapari?",
    "SENSING_TIMER": "yupachaq",
    "SENSING_RESETTIMER": "qallari yupachaq",
    "SENSING_OF": "%1 kaymanta %2",
    "SENSING_OF_XPOSITION": "x sayay",
    "SENSING_OF_YPOSITION": "y sayay",
    "SENSING_OF_DIRECTION": "maypi",
    "SENSING_OF_COSTUMENUMBER": "pacha #",
    "SENSING_OF_COSTUMENAME": "pachapa sutin",
    "SENSING_OF_SIZE": "hatunin",
    "SENSING_OF_VOLUME": "ancha uyarina",
    "SENSING_OF_BACKDROPNUMBER": "hipaynin",
    "SENSING_OF_BACKDROPNAME": "hipaynin sutin",
    "SENSING_OF_STAGE": "chimpa qaway",
    "SENSING_CURRENT": "kunan %1",
    "SENSING_CURRENT_YEAR": "wata",
    "SENSING_CURRENT_MONTH": "killa",
    "SENSING_CURRENT_DATE": "punchaw",
    "SENSING_CURRENT_DAYOFWEEK": "punchawkuna",
    "SENSING_CURRENT_HOUR": "ura",
    "SENSING_CURRENT_MINUTE": "minutu",
    "SENSING_CURRENT_SECOND": "wawa pacha",
    "SENSING_DAYSSINCE2000": "2000 wata punchawmanta",
    "SENSING_USERNAME": "llamkaqpa sutin",
    "SENSING_USERID": "id llamkaqpa",
    "SOUND_PLAY": "tukayachi %1",
    "SOUND_PLAYUNTILDONE": "tukachi %1 tukunankama",
    "SOUND_STOPALLSOUNDS": "llapan tukachkaqta sayay",
    "SOUND_SETEFFECTO": "churaykuy %1 imayna rikuriqninta %2",
    "SOUND_CHANGEEFFECTBY": "tikray %1 imayna rikuriqninta kaywan %2",
    "SOUND_CLEAREFFECTS": "pichay llapa tukachkaqta",
    "SOUND_EFFECTS_PITCH": "luqyay",
    "SOUND_EFFECTS_PAN": "paniyay alliqman / ichuqman",
    "SOUND_CHANGEVOLUMEBY": "tikray uyarinata %1",
    "SOUND_SETVOLUMETO": "churay uyarinata %1%",
    "SOUND_VOLUME": "ancha uyarina",
    "SOUND_RECORD": "qrabay...",
    "CATEGORY_MOTION": "Muyuy",
    "CATEGORY_LOOKS": "Qaway",
    "CATEGORY_SOUND": "qapariqnin",
    "CATEGORY_EVENTS": "llamka",
    "CATEGORY_CONTROL": "kamachiy",
    "CATEGORY_SENSING": "musyay",
    "CATEGORY_OPERATORS": "Llamkaq",
    "CATEGORY_VARIABLES": "hukniraq",
    "CATEGORY_MYBLOCKS": "champaykuna",
    "DUPLICATE": "iskachay",
    "DELETE": "Pichay",
    "ADD_COMMENT": "yapay parlarisqaykita",
    "REMOVE_COMMENT": "parlasqaykita kitay",
    "DELETE_BLOCK": "pichay harkay",
    "DELETE_X_BLOCKS": "pichay %1 champata",
    "DELETE_ALL_BLOCKS": "pichay llapa %1 champakunata?",
    "CLEAN_UP": "pichay champata",
    "HELP": "yanapay",
    "UNDO": "ruraray",
    "REDO": "kutipay",
    "EDIT_PROCEDURE": "Ruraykuy musuqmanta",
    "SHOW_PROCEDURE_DEFINITION": "kikinchariyman pasay",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "rimay munasqaykita",
    "COLOUR_HUE_LABEL": "kulur",
    "COLOUR_SATURATION_LABEL": "Llimpi yuraqchay",
    "COLOUR_BRIGHTNESS_LABEL": "kanchiq",
    "CHANGE_VALUE_TITLE": "chanin tikray",
    "RENAME_VARIABLE": "musuqmanta sutichay hukniraqta",
    "RENAME_VARIABLE_TITLE": "llapanta musuqmanta sutichay \"%1\" hukniraqta",
    "RENAME_VARIABLE_MODAL_TITLE": "musuqmanta sutichay hukniraqta",
    "NEW_VARIABLE": "hukniraqta ruray",
    "NEW_VARIABLE_TITLE": "musuq suti hukniraqpa",
    "VARIABLE_MODAL_TITLE": "musuq hukniraq",
    "VARIABLE_ALREADY_EXISTS": "hukniraq kay sutiyuq\"%1\" tarikunñam.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "kay sutiyuq wariable tarikunñam \"%1\" hukaq warabliman \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Kitay %1 wariablita churay \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "manam kitayta atikunchu \"%1\" hukaq parti kaptinmi \"%2\"",
    "DELETE_VARIABLE": "pichari \"%1\" hukniraqta",
    "NEW_PROCEDURE": "ruray huk champata",
    "PROCEDURE_ALREADY_EXISTS": "kay sutiyuq prosidimiyinto tarikunñam \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "champapa sutin",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "ruray huk sutisuyuta",
    "NEW_LIST_TITLE": "musuq sutisuyupa sutin",
    "LIST_MODAL_TITLE": "musuq sutisuyu",
    "LIST_ALREADY_EXISTS": "kay suti sutiyuqa \"%1\" tarikunñam",
    "RENAME_LIST_TITLE": "llapanta musuqmanta sutichay \"%1\" sutisuyukunata:",
    "RENAME_LIST_MODAL_TITLE": "Musuqmanta Sutichay Sutisuyuta",
    "DEFAULT_LIST_ITEM": "imalla",
    "DELETE_LIST": "pichari \"%1\" sutisuyuta",
    "RENAME_LIST": "musuqmanta sutichay sutisuyuta",
    "NEW_BROADCAST_MESSAGE": "Musuq qillqa",
    "NEW_BROADCAST_MESSAGE_TITLE": "Musuq qillqapa sutin:",
    "BROADCAST_MODAL_TITLE": "Musuq Qillqa",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "qillqa1"
  },
  "sw": {
    "CONTROL_FOREVER": "milele",
    "CONTROL_REPEAT": "rudia %1",
    "CONTROL_IF": "ikiwa %1 basi",
    "CONTROL_ELSE": "isivyo",
    "CONTROL_STOP": "komesha",
    "CONTROL_STOP_ALL": "kila kitu",
    "CONTROL_STOP_THIS": "hati hii",
    "CONTROL_STOP_OTHER": "hati nyingine katika kihusika",
    "CONTROL_WAIT": "subiri sekunde %1",
    "CONTROL_WAITUNTIL": "subiri hadi %1",
    "CONTROL_REPEATUNTIL": "rudia hadi %1",
    "CONTROL_WHILE": "wakati %1",
    "CONTROL_FOREACH": "kwa kila %1 katika %2   ",
    "CONTROL_STARTASCLONE": "nikianza kama kinakili",
    "CONTROL_CREATECLONEOF": "unda kinakili cha %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mimi mwenye",
    "CONTROL_DELETETHISCLONE": "futa kinakili hiki",
    "CONTROL_COUNTER": "kipiga hesabu",
    "CONTROL_INCRCOUNTER": "ongezea kwa kipiga hesabu",
    "CONTROL_CLEARCOUNTER": "futa kipiga hesabu",
    "CONTROL_ALLATONCE": "zote mara moja",
    "DATA_SETVARIABLETO": "weka %1 iwe %2",
    "DATA_CHANGEVARIABLEBY": "badilisha %1 kwa %2",
    "DATA_SHOWVARIABLE": "onyesha kibadilika %1",
    "DATA_HIDEVARIABLE": "ficha kibadilika %1",
    "DATA_ADDTOLIST": "ongeza %1 kwa %2",
    "DATA_DELETEOFLIST": "futa %1 kati ya %2",
    "DATA_DELETEALLOFLIST": "futa %1 zote",
    "DATA_INSERTATLIST": "weka %1 kwa %2 kati ya %3",
    "DATA_REPLACEITEMOFLIST": "badilisha kipengee %1 kati ya %2 na %3",
    "DATA_ITEMOFLIST": "kipengee %1 kati ya %2",
    "DATA_ITEMNUMOFLIST": "kipengee # kati ya %1 katika %2",
    "DATA_LENGTHOFLIST": "urefu wa %1",
    "DATA_LISTCONTAINSITEM": "%1 ina %2?",
    "DATA_SHOWLIST": "onyesha orodha %1",
    "DATA_HIDELIST": "ficha orodha %1",
    "DATA_INDEX_ALL": "kila kitu",
    "DATA_INDEX_LAST": "mwisho",
    "DATA_INDEX_RANDOM": "mahali popote",
    "EVENT_WHENFLAGCLICKED": "wakati %1 inapobonyezwa",
    "EVENT_WHENTHISSPRITECLICKED": "wakati kihusika hiki kinapobonyezwa",
    "EVENT_WHENSTAGECLICKED": "wakati jukwaa linapobonyezwa",
    "EVENT_WHENTOUCHINGOBJECT": "wakati kihusika hiki kinapoguza %1",
    "EVENT_WHENBROADCASTRECEIVED": "wakati ninapopokea %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "mandhari ya nyuma itakapobadilika kuwa %1",
    "EVENT_WHENGREATERTHAN": "wakati %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "kipima muda",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ukubwa wa sauti",
    "EVENT_BROADCAST": "tangaza %1",
    "EVENT_BROADCASTANDWAIT": "tangaza %1 na usubiri",
    "EVENT_WHENKEYPRESSED": "wakati kitufe cha %1 kinapobonyezwa",
    "EVENT_WHENKEYPRESSED_SPACE": "nafasi",
    "EVENT_WHENKEYPRESSED_LEFT": "kishale kushoto",
    "EVENT_WHENKEYPRESSED_RIGHT": "kishale kulia",
    "EVENT_WHENKEYPRESSED_DOWN": "kishale chini",
    "EVENT_WHENKEYPRESSED_UP": "kishale juu",
    "EVENT_WHENKEYPRESSED_ANY": "kitufe chochote",
    "LOOKS_SAYFORSECS": "sema %1 kwa sekunde %2",
    "LOOKS_SAY": "sema %1",
    "LOOKS_HELLO": "Habari!",
    "LOOKS_THINKFORSECS": "fikiria %1 kwa sekunde %2",
    "LOOKS_THINK": "fikiria %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "onyesha",
    "LOOKS_HIDE": "ficha",
    "LOOKS_HIDEALLSPRITES": "ficha vihusika vyote",
    "LOOKS_EFFECT_COLOR": "rangi",
    "LOOKS_EFFECT_FISHEYE": "jicho la samaki",
    "LOOKS_EFFECT_WHIRL": "mzunguko",
    "LOOKS_EFFECT_PIXELATE": "ubora wa picha",
    "LOOKS_EFFECT_MOSAIC": "mozaiki",
    "LOOKS_EFFECT_BRIGHTNESS": "mng'aro",
    "LOOKS_EFFECT_GHOST": "mzuka",
    "LOOKS_CHANGEEFFECTBY": "badilisha athari ya %1 kwa %2",
    "LOOKS_SETEFFECTTO": "weka athari ya %1 iwe %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "futa athari za picha",
    "LOOKS_CHANGESIZEBY": "badilisha ukubwa kwa %1",
    "LOOKS_SETSIZETO": "weka ukubwa uwe %1",
    "LOOKS_SIZE": "ukubwa",
    "LOOKS_CHANGESTRETCHBY": "badilisha mnyoosho kwa %1",
    "LOOKS_SETSTRETCHTO": "weka mnyoosho uwe %1 %",
    "LOOKS_SWITCHCOSTUMETO": "badilisha mtindo kuwa %1",
    "LOOKS_NEXTCOSTUME": "mtindo ufuatao",
    "LOOKS_SWITCHBACKDROPTO": "badilisha mandhari ya nyuma iwe %1",
    "LOOKS_GOTOFRONTBACK": "enda kwa safu ya %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "mbele",
    "LOOKS_GOTOFRONTBACK_BACK": "nyuma",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 kwa safu ya %2",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "enda mbele",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "rudi nyuma",
    "LOOKS_BACKDROPNUMBERNAME": "mandhari ya nyuma %1",
    "LOOKS_COSTUMENUMBERNAME": "mtindo %1",
    "LOOKS_NUMBERNAME_NUMBER": "nambari",
    "LOOKS_NUMBERNAME_NAME": "jina",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "badilisha mandhari ya nyuma kuwa %1 na subiri",
    "LOOKS_NEXTBACKDROP_BLOCK": "mandhari ya nyuma ifuatayo",
    "LOOKS_NEXTBACKDROP": "mandhari ya nyuma ifuatayo",
    "LOOKS_PREVIOUSBACKDROP": "mandhari ya nyuma iliyotangulia",
    "LOOKS_RANDOMBACKDROP": "mandhari ya nyuma yoyote",
    "MOTION_MOVESTEPS": "songa hatua %1",
    "MOTION_TURNLEFT": "zunguka digrii %1 %2 ",
    "MOTION_TURNRIGHT": "zunguka digrii %1 %2 ",
    "MOTION_POINTINDIRECTION": "elekeza kwa mwelekeo %1",
    "MOTION_POINTTOWARDS": "elekea %1",
    "MOTION_POINTTOWARDS_POINTER": "kielekezi cha kipanya",
    "MOTION_POINTTOWARDS_RANDOM": "mwelekeo wowote",
    "MOTION_GOTO": "enda kwa %1",
    "MOTION_GOTO_POINTER": "kielekezi cha kipanya",
    "MOTION_GOTO_RANDOM": "mahali popote",
    "MOTION_GOTOXY": "enda kwa x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "teleza %1 sekunde hadi x: %2 y: %3",
    "MOTION_GLIDETO": "teleza sekunde %1 hadi %2",
    "MOTION_GLIDETO_POINTER": "kielekezi cha kipanya",
    "MOTION_GLIDETO_RANDOM": "mahali popote",
    "MOTION_CHANGEXBY": "badilisha x kwa %1",
    "MOTION_SETX": "weka x kuwa %1",
    "MOTION_CHANGEYBY": "badilisha y kwa %1",
    "MOTION_SETY": "weka y kuwa %1",
    "MOTION_IFONEDGEBOUNCE": "ikiwa kwenye ukingo wa jukwaa, rejesha",
    "MOTION_SETROTATIONSTYLE": "weka mtindo wa mzunguko %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "kushoto-kulia",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "isizunguke",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "pande zote",
    "MOTION_XPOSITION": "nafasi ya x",
    "MOTION_YPOSITION": "nafasi ya y",
    "MOTION_DIRECTION": "mwelekeo",
    "MOTION_SCROLLRIGHT": "tembeza kulia %1",
    "MOTION_SCROLLUP": "tembeza juu %1",
    "MOTION_ALIGNSCENE": "patanisha eneo %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "chini-kushoto",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "chini-kulia",
    "MOTION_ALIGNSCENE_MIDDLE": "katikati",
    "MOTION_ALIGNSCENE_TOPLEFT": "juu-kushoto",
    "MOTION_ALIGNSCENE_TOPRIGHT": "juu-kulia",
    "MOTION_XSCROLL": "tembeza x",
    "MOTION_YSCROLL": "tembeza y",
    "MOTION_STAGE_SELECTED": "Jukwaa limechanguliwa: hakuna bloku za mwendo",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "chagua %1  yoyote hadi %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 na %2",
    "OPERATORS_OR": "%1 au %2",
    "OPERATORS_NOT": "si %1",
    "OPERATORS_JOIN": "unganisha %1 %2",
    "OPERATORS_JOIN_APPLE": "tufaha",
    "OPERATORS_JOIN_BANANA": "ndizi",
    "OPERATORS_LETTEROF": "herufi %1 kati ya %2",
    "OPERATORS_LETTEROF_APPLE": "t",
    "OPERATORS_LENGTH": "urefu wa %1",
    "OPERATORS_CONTAINS": "%1 ina %2?",
    "OPERATORS_MOD": "%1 mabaki %2",
    "OPERATORS_ROUND": "kadiria %1",
    "OPERATORS_MATHOP": "%1 kati ya %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "kadiria chini namba kamili",
    "OPERATORS_MATHOP_CEILING": "kadiria juu namba kamili",
    "OPERATORS_MATHOP_SQRT": "kipeo cha pili",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "fafanua %1",
    "SENSING_TOUCHINGOBJECT": "inashika %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "kielekezi cha kipanya",
    "SENSING_TOUCHINGOBJECT_EDGE": "ukingo",
    "SENSING_TOUCHINGCOLOR": "inashika rangi %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "rangi %1 inashika %2?",
    "SENSING_DISTANCETO": "umbali hadi %1",
    "SENSING_DISTANCETO_POINTER": "kielekezi cha kipanya",
    "SENSING_ASKANDWAIT": "uliza %1 na subiri",
    "SENSING_ASK_TEXT": "Jina lako nani?",
    "SENSING_ANSWER": "jibu",
    "SENSING_KEYPRESSED": "kitufe cha %1 kimebonyezwa?",
    "SENSING_MOUSEDOWN": "kipanya chini?",
    "SENSING_MOUSEX": "kipanya x",
    "SENSING_MOUSEY": "kipanya y",
    "SENSING_SETDRAGMODE": "kihusika %1 kuvutwa",
    "SENSING_SETDRAGMODE_DRAGGABLE": "kinaweza",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "hakiwezi",
    "SENSING_LOUDNESS": "ukubwa wa sauti",
    "SENSING_LOUD": "kuna sauti kubwa?",
    "SENSING_TIMER": "kitunza wakati",
    "SENSING_RESETTIMER": "anzisha tena kitunza muda",
    "SENSING_OF": "%1 kwa %2",
    "SENSING_OF_XPOSITION": "nafasi ya x",
    "SENSING_OF_YPOSITION": "nafasi ya y",
    "SENSING_OF_DIRECTION": "mwelekeo",
    "SENSING_OF_COSTUMENUMBER": "mtindo #",
    "SENSING_OF_COSTUMENAME": "jina la mtindo",
    "SENSING_OF_SIZE": "ukubwa",
    "SENSING_OF_VOLUME": "kiasi ya sauti",
    "SENSING_OF_BACKDROPNUMBER": "mandhari ya nyuma #",
    "SENSING_OF_BACKDROPNAME": "jina la mandhari ya nyuma",
    "SENSING_OF_STAGE": "Jukwaa",
    "SENSING_CURRENT": "sasa hivi %1",
    "SENSING_CURRENT_YEAR": "mwaka",
    "SENSING_CURRENT_MONTH": "mwezi",
    "SENSING_CURRENT_DATE": "tarehe",
    "SENSING_CURRENT_DAYOFWEEK": "siku ya wiki",
    "SENSING_CURRENT_HOUR": "saa",
    "SENSING_CURRENT_MINUTE": "dakika",
    "SENSING_CURRENT_SECOND": "sekunde",
    "SENSING_DAYSSINCE2000": "siku tangu 2000",
    "SENSING_USERNAME": "jina la mtumiaji",
    "SENSING_USERID": "kitambulisho cha mtumiaji",
    "SOUND_PLAY": "anza sauti %1",
    "SOUND_PLAYUNTILDONE": "cheza sauti %1 hadi ikamilike",
    "SOUND_STOPALLSOUNDS": "komesha sauti zote",
    "SOUND_SETEFFECTO": "weka athari ya %1 kuwa %2",
    "SOUND_CHANGEEFFECTBY": "badilisha athari ya %1 kwa %2",
    "SOUND_CLEAREFFECTS": "futa athari zote za sauti",
    "SOUND_EFFECTS_PITCH": "uzito wa sauti",
    "SOUND_EFFECTS_PAN": "peleka sauti kushoto/kulia",
    "SOUND_CHANGEVOLUMEBY": "badilisha kiasi ya sauti kwa %1",
    "SOUND_SETVOLUMETO": "weka kiasi ya sauti kuwa %1%",
    "SOUND_VOLUME": "kiasi ya sauti",
    "SOUND_RECORD": "inarekodi...",
    "CATEGORY_MOTION": "Mwendo",
    "CATEGORY_LOOKS": "Muonekano",
    "CATEGORY_SOUND": "Sauti",
    "CATEGORY_EVENTS": "Matukio",
    "CATEGORY_CONTROL": "Kidhibiti",
    "CATEGORY_SENSING": "Hisi",
    "CATEGORY_OPERATORS": "Opereta",
    "CATEGORY_VARIABLES": "Vibadilika",
    "CATEGORY_MYBLOCKS": "Bloku Zangu",
    "DUPLICATE": "Toa Nakala Nyingine",
    "DELETE": "Futa",
    "ADD_COMMENT": "Ongeza Maoni",
    "REMOVE_COMMENT": "Futa Maoni",
    "DELETE_BLOCK": "Futa Bloku",
    "DELETE_X_BLOCKS": "Futa Bloku %1",
    "DELETE_ALL_BLOCKS": "Unataka kufuta bloku zote za %1?",
    "CLEAN_UP": "Safisha Bloku",
    "HELP": "Usaidizi",
    "UNDO": "Ondoa",
    "REDO": "Rudia",
    "EDIT_PROCEDURE": "Hariri",
    "SHOW_PROCEDURE_DEFINITION": "Enda kwa ufafanuzi",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Sema kitu...",
    "COLOUR_HUE_LABEL": "Rangi",
    "COLOUR_SATURATION_LABEL": "Kiasi ya Rangi",
    "COLOUR_BRIGHTNESS_LABEL": "Mng'aro",
    "CHANGE_VALUE_TITLE": "Badilisha thamani:",
    "RENAME_VARIABLE": "Badilisha jina la kibadilika",
    "RENAME_VARIABLE_TITLE": "Badilisha majina ya vibadilika vyote \"%1\"  viwe:",
    "RENAME_VARIABLE_MODAL_TITLE": "Badilisha Jina la Kibadilika",
    "NEW_VARIABLE": "Unda Kibadilika",
    "NEW_VARIABLE_TITLE": "Jina jipya la kibadilika:",
    "VARIABLE_MODAL_TITLE": "Kibadilika Kipya",
    "VARIABLE_ALREADY_EXISTS": "Kibadilika kinachoitwa \"%1\" tayari ipo.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Kibadilika kinachoitwa \"%1\" tayari ipo kwa kibadilika kingine chenye aina ya \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Unataka kufuta matumizi %1 ya kibadilika \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Haiwezi kufuta kibadilika \"%1\" kwa sababu ni sehemu ya kitendaji \"%2\"",
    "DELETE_VARIABLE": "Futa kibadilika \"%1\"",
    "NEW_PROCEDURE": "Unda Bloku",
    "PROCEDURE_ALREADY_EXISTS": "Utaratibu ulio na jina \"%1\" tayari upo.",
    "PROCEDURE_DEFAULT_NAME": "jina la bloku",
    "PROCEDURE_USED": "Kufuta ufafanuzi wa bloku, anza kwa kutoa matumizi yote ya bloku hiyo",
    "NEW_LIST": "Unda Orodha",
    "NEW_LIST_TITLE": "Jina ya orodha mpya:",
    "LIST_MODAL_TITLE": "Orodha Mpya",
    "LIST_ALREADY_EXISTS": "Orodha iliyo na jina \"%1\" tayari upo.",
    "RENAME_LIST_TITLE": "Badilisha jina la orodha zote \"%1\" kuwa:",
    "RENAME_LIST_MODAL_TITLE": "Badilisha Jina La Orodha",
    "DEFAULT_LIST_ITEM": "kitu",
    "DELETE_LIST": "Futa orodha ya \"%1\"",
    "RENAME_LIST": "Badilisha jina la orodha",
    "NEW_BROADCAST_MESSAGE": "Ujumbe mpya",
    "NEW_BROADCAST_MESSAGE_TITLE": "Jina la ujumbe mpya:",
    "BROADCAST_MODAL_TITLE": "Ujumbe Mpya",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "ujumbe1"
  },
  "ht": {
    "CONTROL_FOREVER": "pou toujou",
    "CONTROL_REPEAT": "repete %1",
    "CONTROL_IF": "si %1 ebyen",
    "CONTROL_ELSE": "si non",
    "CONTROL_STOP": "kanpe",
    "CONTROL_STOP_ALL": "tout",
    "CONTROL_STOP_THIS": "eskrip sa a",
    "CONTROL_STOP_OTHER": "lòt eskrip nan aktè la",
    "CONTROL_WAIT": "rete tann %1 segond",
    "CONTROL_WAITUNTIL": "tann jiska %1",
    "CONTROL_REPEATUNTIL": "repete jiska %1",
    "CONTROL_WHILE": "pandan %1",
    "CONTROL_FOREACH": "pou chak %1 nan %2",
    "CONTROL_STARTASCLONE": "lè m parèt kòm marasa",
    "CONTROL_CREATECLONEOF": "kreye marasa pou  %1 sa a",
    "CONTROL_CREATECLONEOF_MYSELF": "mwen menm",
    "CONTROL_DELETETHISCLONE": "efase marasa sa a",
    "CONTROL_COUNTER": "kontè",
    "CONTROL_INCRCOUNTER": "ajoute sou kontè a",
    "CONTROL_CLEARCOUNTER": "efase kontè a",
    "CONTROL_ALLATONCE": "on sèl kou",
    "DATA_SETVARIABLETO": "fikse %2 a %1",
    "DATA_CHANGEVARIABLEBY": "chanje %1 pa %2",
    "DATA_SHOWVARIABLE": "montre varyab %1",
    "DATA_HIDEVARIABLE": "kache varyab %1",
    "DATA_ADDTOLIST": "ajoute %1 sou %2",
    "DATA_DELETEOFLIST": "efase %1 nan %2",
    "DATA_DELETEALLOFLIST": "efase tout %1",
    "DATA_INSERTATLIST": "antre %1 nan %2 de %3",
    "DATA_REPLACEITEMOFLIST": "ranplase %1 nan %2 avèk %3",
    "DATA_ITEMOFLIST": "bagay %1 nan %2",
    "DATA_ITEMNUMOFLIST": "bagay # de %1 nan %2",
    "DATA_LENGTHOFLIST": "longè %1 a",
    "DATA_LISTCONTAINSITEM": "èske %1 genyen %2 ladan l ? ",
    "DATA_SHOWLIST": "montre lis %1",
    "DATA_HIDELIST": "kache lis %1",
    "DATA_INDEX_ALL": "tout",
    "DATA_INDEX_LAST": "dènye",
    "DATA_INDEX_RANDOM": "pa aza",
    "EVENT_WHENFLAGCLICKED": "lè n klike %1",
    "EVENT_WHENTHISSPRITECLICKED": "lè aktè la klike",
    "EVENT_WHENSTAGECLICKED": "lè sèn an klike",
    "EVENT_WHENTOUCHINGOBJECT": "lè aktè sa a touche %1",
    "EVENT_WHENBROADCASTRECEIVED": "lè m resevwa %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "lè fon an chanje a %1",
    "EVENT_WHENGREATERTHAN": "lè %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "kwonomèt",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "volim lan",
    "EVENT_BROADCAST": "kònen %1",
    "EVENT_BROADCASTANDWAIT": "kònen %1 epi tann",
    "EVENT_WHENKEYPRESSED": "depi bouton %1 peze",
    "EVENT_WHENKEYPRESSED_SPACE": "espas",
    "EVENT_WHENKEYPRESSED_LEFT": "flèch goch",
    "EVENT_WHENKEYPRESSED_RIGHT": "flèch dwat",
    "EVENT_WHENKEYPRESSED_DOWN": "flèch an ba",
    "EVENT_WHENKEYPRESSED_UP": "flèch an wo",
    "EVENT_WHENKEYPRESSED_ANY": "nenpòt",
    "LOOKS_SAYFORSECS": "di %1 pandan %2 segond",
    "LOOKS_SAY": "di %1",
    "LOOKS_HELLO": "Alo !",
    "LOOKS_THINKFORSECS": "panse %1 pou %2 segond",
    "LOOKS_THINK": "panse %1",
    "LOOKS_HMM": "M ap reflechi...",
    "LOOKS_SHOW": "montre",
    "LOOKS_HIDE": "kache",
    "LOOKS_HIDEALLSPRITES": "Kache tout aktè yo",
    "LOOKS_EFFECT_COLOR": "koulè",
    "LOOKS_EFFECT_FISHEYE": "objektif gran ang",
    "LOOKS_EFFECT_WHIRL": "toubiyon",
    "LOOKS_EFFECT_PIXELATE": "piksale",
    "LOOKS_EFFECT_MOSAIC": "mozayik",
    "LOOKS_EFFECT_BRIGHTNESS": "ekleraj",
    "LOOKS_EFFECT_GHOST": "transparan",
    "LOOKS_CHANGEEFFECTBY": "chanje efè %1 pa %2",
    "LOOKS_SETEFFECTTO": "fikse efè %1 a %2 ",
    "LOOKS_CLEARGRAPHICEFFECTS": "efase efè grafik yo",
    "LOOKS_CHANGESIZEBY": "chanje gwosè a pa %1",
    "LOOKS_SETSIZETO": "mete gwosè a %1 %",
    "LOOKS_SIZE": "gwosè",
    "LOOKS_CHANGESTRETCHBY": "chanje detire a pa %1",
    "LOOKS_SETSTRETCHTO": "detire li pa %1 %",
    "LOOKS_SWITCHCOSTUMETO": "chanje a kostim %1",
    "LOOKS_NEXTCOSTUME": "pwochenn kostim",
    "LOOKS_SWITCHBACKDROPTO": "chanje fon an a %1",
    "LOOKS_GOTOFRONTBACK": "ale nan kouch %1 ",
    "LOOKS_GOTOFRONTBACK_FRONT": "devan",
    "LOOKS_GOTOFRONTBACK_BACK": "dèyè",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ale nan kouch %1 %2",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "mete devan",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "mete dèyè",
    "LOOKS_BACKDROPNUMBERNAME": "fon %1",
    "LOOKS_COSTUMENUMBERNAME": "kostim %1",
    "LOOKS_NUMBERNAME_NUMBER": "nimewo",
    "LOOKS_NUMBERNAME_NAME": "non",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "chanje fon a %1 epi tann",
    "LOOKS_NEXTBACKDROP_BLOCK": "pwochenn fon ",
    "LOOKS_NEXTBACKDROP": "pwochenn fon",
    "LOOKS_PREVIOUSBACKDROP": "fon anvan an",
    "LOOKS_RANDOMBACKDROP": "fon pa aza",
    "MOTION_MOVESTEPS": "fè %1 pa",
    "MOTION_TURNLEFT": "vire %1 %2 grad",
    "MOTION_TURNRIGHT": "vire %1 %2 grad",
    "MOTION_POINTINDIRECTION": "bay tèt li sou direksyon %1",
    "MOTION_POINTTOWARDS": "bay tèt li sou %1",
    "MOTION_POINTTOWARDS_POINTER": "flèch souri a",
    "MOTION_POINTTOWARDS_RANDOM": "direksyon pa aza",
    "MOTION_GOTO": "ale nan %1",
    "MOTION_GOTO_POINTER": "flèch souri a",
    "MOTION_GOTO_RANDOM": "pozisyon pa aza",
    "MOTION_GOTOXY": "ale nan x : %1 y : %2",
    "MOTION_GLIDESECSTOXY": "glise pou %1 segond vè x : %2 y : %3 ",
    "MOTION_GLIDETO": "glise pou %1 segond vè %2",
    "MOTION_GLIDETO_POINTER": "flèch souri a",
    "MOTION_GLIDETO_RANDOM": "pozisyon pa aza",
    "MOTION_CHANGEXBY": "chanje x pa %1",
    "MOTION_SETX": "fikse x a %1",
    "MOTION_CHANGEYBY": "chanje y pa %1",
    "MOTION_SETY": "fikse y a %1",
    "MOTION_IFONEDGEBOUNCE": "si li nan bout la, rebondi li",
    "MOTION_SETROTATIONSTYLE": "fikse stil vire a %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "goch-dwat",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "pa vire",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "fè wonn",
    "MOTION_XPOSITION": "pozisyon x",
    "MOTION_YPOSITION": "pozisyon y",
    "MOTION_DIRECTION": "direksyon",
    "MOTION_SCROLLRIGHT": "ale a dwat %1",
    "MOTION_SCROLLUP": "monte %1",
    "MOTION_ALIGNSCENE": "aliyen sèn %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "an ba a goch",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "an ba a dwat",
    "MOTION_ALIGNSCENE_MIDDLE": "mitan",
    "MOTION_ALIGNSCENE_TOPLEFT": "an wo a goch",
    "MOTION_ALIGNSCENE_TOPRIGHT": "an wo a dwat",
    "MOTION_XSCROLL": "ale sou x",
    "MOTION_YSCROLL": "ale sou y",
    "MOTION_STAGE_SELECTED": "Sèn la chwazi : pa gen blòk mouvman",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "chwazi pa aza soti %1 rive %2 ",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 ak %2",
    "OPERATORS_OR": "%1 oubyen %2",
    "OPERATORS_NOT": "pa %1",
    "OPERATORS_JOIN": "kole %1 ak %2",
    "OPERATORS_JOIN_APPLE": "pòm",
    "OPERATORS_JOIN_BANANA": "fig",
    "OPERATORS_LETTEROF": "lèt %1 nan %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "longè %1 ",
    "OPERATORS_CONTAINS": "èske %1 gen %2 ladan l ?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "awondi %1",
    "OPERATORS_MATHOP": "%1 nan %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "desann pou awondi chif la",
    "OPERATORS_MATHOP_CEILING": "monte pou awondi chif la",
    "OPERATORS_MATHOP_SQRT": "rasin kare",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "defini %1",
    "SENSING_TOUCHINGOBJECT": "èske l ap touche %1 ?",
    "SENSING_TOUCHINGOBJECT_POINTER": "flèch souri a",
    "SENSING_TOUCHINGOBJECT_EDGE": "bout",
    "SENSING_TOUCHINGCOLOR": "èske l ap touche koulè %1 ?",
    "SENSING_COLORISTOUCHINGCOLOR": "èske koulè %1 ap touche %2 ? ",
    "SENSING_DISTANCETO": "distans a %1",
    "SENSING_DISTANCETO_POINTER": "flèch souri ",
    "SENSING_ASKANDWAIT": "mande %1 epi tann",
    "SENSING_ASK_TEXT": "Ki jan w rele ?",
    "SENSING_ANSWER": "repons",
    "SENSING_KEYPRESSED": "èske bouton %1 peze ?",
    "SENSING_MOUSEDOWN": "sourit peze ?",
    "SENSING_MOUSEX": "sourit x",
    "SENSING_MOUSEY": "sourit y",
    "SENSING_SETDRAGMODE": "fikse mòd glise a %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ka glise",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "pa ka glise",
    "SENSING_LOUDNESS": "volim ",
    "SENSING_LOUD": "fò ?",
    "SENSING_TIMER": "kwonomèt",
    "SENSING_RESETTIMER": "rekòmanse kwonomèt la",
    "SENSING_OF": "%1 nan %2",
    "SENSING_OF_XPOSITION": "pozisyon x",
    "SENSING_OF_YPOSITION": "pozisyon y",
    "SENSING_OF_DIRECTION": "direksyon",
    "SENSING_OF_COSTUMENUMBER": "kostim #",
    "SENSING_OF_COSTUMENAME": "non kostim",
    "SENSING_OF_SIZE": "gwosè",
    "SENSING_OF_VOLUME": "volim",
    "SENSING_OF_BACKDROPNUMBER": "# fon ",
    "SENSING_OF_BACKDROPNAME": "non fon an",
    "SENSING_OF_STAGE": "Sèn",
    "SENSING_CURRENT": "%1 aktyèl",
    "SENSING_CURRENT_YEAR": "ane",
    "SENSING_CURRENT_MONTH": "mwa",
    "SENSING_CURRENT_DATE": "jou",
    "SENSING_CURRENT_DAYOFWEEK": "jou nan semenn lan",
    "SENSING_CURRENT_HOUR": "lè",
    "SENSING_CURRENT_MINUTE": "minit",
    "SENSING_CURRENT_SECOND": "segond",
    "SENSING_DAYSSINCE2000": "jou depi 2000",
    "SENSING_USERNAME": "non itilizatè",
    "SENSING_USERID": "idantite itilizatè",
    "SOUND_PLAY": "kòmanse jwe son %1",
    "SOUND_PLAYUNTILDONE": "jwe son %1 jiskaske l fini",
    "SOUND_STOPALLSOUNDS": "koupe tout son",
    "SOUND_SETEFFECTO": "fikse efè %1 a %2 ",
    "SOUND_CHANGEEFFECTBY": "chanje efè %1 pa %2",
    "SOUND_CLEAREFFECTS": "efase tout efè son yo",
    "SOUND_EFFECTS_PITCH": "ton",
    "SOUND_EFFECTS_PAN": "voye sou bò goch/dwat",
    "SOUND_CHANGEVOLUMEBY": "chanje volim lan pa %1",
    "SOUND_SETVOLUMETO": "fikse volim lan a %1%",
    "SOUND_VOLUME": "volim",
    "SOUND_RECORD": "anrejistre...",
    "CATEGORY_MOTION": "Mouvman",
    "CATEGORY_LOOKS": "Aparans",
    "CATEGORY_SOUND": "Son",
    "CATEGORY_EVENTS": "Evènman",
    "CATEGORY_CONTROL": "Kontwòl",
    "CATEGORY_SENSING": "Deteksyon",
    "CATEGORY_OPERATORS": "Operatè",
    "CATEGORY_VARIABLES": "Varyab ",
    "CATEGORY_MYBLOCKS": "Blòk mwen yo",
    "DUPLICATE": "Fè marasa",
    "DELETE": "Efase",
    "ADD_COMMENT": "Ajoute remak",
    "REMOVE_COMMENT": "Retire remak",
    "DELETE_BLOCK": "Efase blòk la",
    "DELETE_X_BLOCKS": "Efase blòk %1 yo",
    "DELETE_ALL_BLOCKS": "Efase tout blòk %1 yo ?",
    "CLEAN_UP": "Òganize blòk yo",
    "HELP": "Èd",
    "UNDO": "Anile",
    "REDO": "Fè ankò",
    "EDIT_PROCEDURE": "Chanje",
    "SHOW_PROCEDURE_DEFINITION": "Ale nan definisyon",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Di yon bagay...",
    "COLOUR_HUE_LABEL": "Koulè",
    "COLOUR_SATURATION_LABEL": "Satirasyon",
    "COLOUR_BRIGHTNESS_LABEL": "Ekleraj",
    "CHANGE_VALUE_TITLE": "Chanje valè : ",
    "RENAME_VARIABLE": "Chanje non varyab la",
    "RENAME_VARIABLE_TITLE": "Chanje non tout varyab ki rele \"%1\" yo a :",
    "RENAME_VARIABLE_MODAL_TITLE": "Chanje non varyab la",
    "NEW_VARIABLE": "Fè yon varyab",
    "NEW_VARIABLE_TITLE": "Non nouvo varyab la :",
    "VARIABLE_MODAL_TITLE": "Nouvo varyab",
    "VARIABLE_ALREADY_EXISTS": "Gen yon varyab ki rele \"%1\" deja",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Gen yon varyab ki rele \"%1\" deja nan kategori \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "Efase tou le %1 fwa w ap sèvi ak varyab \"%2\" la ?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Varyab \"%1\" pa ka efase paske li fè pati fonksyon \"%2\"",
    "DELETE_VARIABLE": "Efase varyab \"%1\" la",
    "NEW_PROCEDURE": "Fè yon blòk ",
    "PROCEDURE_ALREADY_EXISTS": "Gen yon pwosedi ki rele \"%1\" deja",
    "PROCEDURE_DEFAULT_NAME": "non blòk la",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Fè yon lis",
    "NEW_LIST_TITLE": "Non nouvo lis la :",
    "LIST_MODAL_TITLE": "Nouvo lis",
    "LIST_ALREADY_EXISTS": "Gen yon lis ki rele \"%1\" deja",
    "RENAME_LIST_TITLE": "Bay tout lis ki rele \"%1\" yo nouvo non sa a :",
    "RENAME_LIST_MODAL_TITLE": "Chanje non lis la",
    "DEFAULT_LIST_ITEM": "bagay",
    "DELETE_LIST": "Efase lis \"%1\" la :",
    "RENAME_LIST": "Chanje non lis la",
    "NEW_BROADCAST_MESSAGE": "Nouvo mesaj",
    "NEW_BROADCAST_MESSAGE_TITLE": "Non nouvo mesaj la:",
    "BROADCAST_MODAL_TITLE": "Nouvo Mesaj",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mesaj1"
  },
  "ku": {
    "CONTROL_FOREVER": "berdewamî",
    "CONTROL_REPEAT": "%1 caran dubare bike",
    "CONTROL_IF": "heke %1 be",
    "CONTROL_ELSE": "ne ew be",
    "CONTROL_STOP": "rawestîne",
    "CONTROL_STOP_ALL": "hemûyan",
    "CONTROL_STOP_THIS": "vê rêzikê",
    "CONTROL_STOP_OTHER": "di pêlîstikê de rêzikên din",
    "CONTROL_WAIT": "%1 çirkeyan bisekine",
    "CONTROL_WAITUNTIL": "heta ku bibe %1 bisekine",
    "CONTROL_REPEATUNTIL": "heta ku bibe %1 dubare bike",
    "CONTROL_WHILE": "heta %1ê",
    "CONTROL_FOREACH": "ji bo her %1a di %2ê de",
    "CONTROL_STARTASCLONE": "dema ku min wekî cotikan dest pê kir",
    "CONTROL_CREATECLONEOF": "cotika %1yê biafirîne",
    "CONTROL_CREATECLONEOF_MYSELF": "ez bi xwe",
    "CONTROL_DELETETHISCLONE": "vê cotikê jê bibe",
    "CONTROL_COUNTER": "jimêrk",
    "CONTROL_INCRCOUNTER": "jimêrkê zêde bike",
    "CONTROL_CLEARCOUNTER": "jimêrkê paqij bike",
    "CONTROL_ALLATONCE": "hemû bi yek carê",
    "DATA_SETVARIABLETO": " %1ê bike %2",
    "DATA_CHANGEVARIABLEBY": "%1ê biguherîne %2ê",
    "DATA_SHOWVARIABLE": "guheroka %1ê nîşan bide",
    "DATA_HIDEVARIABLE": "guheroka %1ê veşêre",
    "DATA_ADDTOLIST": "%1ê tevlî %2ê bike",
    "DATA_DELETEOFLIST": "%1ê ji %2ê bibe",
    "DATA_DELETEALLOFLIST": "hemû tiştên %1ê jê bibe",
    "DATA_INSERTATLIST": "%1ê tevlî pozisyona %3 ya %2ê bike",
    "DATA_REPLACEITEMOFLIST": "hêmana %2 ya %1ê bi %3ê re pev biguherîne",
    "DATA_ITEMOFLIST": "hêmana %1 ya %2ê",
    "DATA_ITEMNUMOFLIST": "hêmana %1 ya %2ê",
    "DATA_LENGTHOFLIST": "dirêjiya %1ê",
    "DATA_LISTCONTAINSITEM": "%1 di nav %2ê de heye?",
    "DATA_SHOWLIST": "lîsteya %1ê nîşan bide",
    "DATA_HIDELIST": "lîsteya %1ê veşêre",
    "DATA_INDEX_ALL": "hemû",
    "DATA_INDEX_LAST": "dawîn",
    "DATA_INDEX_RANDOM": "ketoberî",
    "EVENT_WHENFLAGCLICKED": "dema ku %1 hat tikandin",
    "EVENT_WHENTHISSPRITECLICKED": "dema ku ev pêlîstik hate tikandin",
    "EVENT_WHENSTAGECLICKED": "dema ku dik hate tikandin",
    "EVENT_WHENTOUCHINGOBJECT": "dema ku vê pêlîstikê li %1ê tikand",
    "EVENT_WHENBROADCASTRECEIVED": "dema ku min %1ê wergirt",
    "EVENT_WHENBACKDROPSWITCHESTO": "dema ku dekor wekî %1ê hate guhertin",
    "EVENT_WHENGREATERTHAN": "dema ku bû wekî %1 > %2 yê",
    "EVENT_WHENGREATERTHAN_TIMER": "demsazker",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "bilindbûna deng",
    "EVENT_BROADCAST": "%1ê biweşîne",
    "EVENT_BROADCASTANDWAIT": "%1ê biweşîne û bisekine",
    "EVENT_WHENKEYPRESSED": "dema ku pêlî bişkoka %1ê hate kirin",
    "EVENT_WHENKEYPRESSED_SPACE": "valahî",
    "EVENT_WHENKEYPRESSED_LEFT": "tîra çepê",
    "EVENT_WHENKEYPRESSED_RIGHT": "tîra rastê",
    "EVENT_WHENKEYPRESSED_DOWN": "tîra jêr",
    "EVENT_WHENKEYPRESSED_UP": "tîra jor",
    "EVENT_WHENKEYPRESSED_ANY": "her çi yek",
    "LOOKS_SAYFORSECS": "bi qasî %2 çirkeyan bibêje %1",
    "LOOKS_SAY": "bibêje %1",
    "LOOKS_HELLO": "Silav!",
    "LOOKS_THINKFORSECS": "bi qasî %2 çirkeyan wekî %1 bifikire",
    "LOOKS_THINK": "wekî %1 bifikire",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "nîşan bide",
    "LOOKS_HIDE": "veşêre",
    "LOOKS_HIDEALLSPRITES": "hemû pêlîstikan veşêre",
    "LOOKS_EFFECT_COLOR": "reng",
    "LOOKS_EFFECT_FISHEYE": "çavmasî",
    "LOOKS_EFFECT_WHIRL": "bizîvirîne",
    "LOOKS_EFFECT_PIXELATE": "deqdeqî bike",
    "LOOKS_EFFECT_MOSAIC": "mozayîk",
    "LOOKS_EFFECT_BRIGHTNESS": "ronahî",
    "LOOKS_EFFECT_GHOST": "pîrhebok",
    "LOOKS_CHANGEEFFECTBY": "efekta %1 bi qasî %2 biguherîne",
    "LOOKS_SETEFFECTTO": "efekta %1 bike %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "efektên grafikê paqij bike",
    "LOOKS_CHANGESIZEBY": "mezinbûnê bi qasî %1 biguherîne",
    "LOOKS_SETSIZETO": "mezinbûnê bike %1 %",
    "LOOKS_SIZE": "mezinahî",
    "LOOKS_CHANGESTRETCHBY": "vezelandinê bi qasî %1 biguherîne",
    "LOOKS_SETSTRETCHTO": "vezelandinê wekî %1 % saz bike",
    "LOOKS_SWITCHCOSTUMETO": "kostumê %1ê li xwe bike",
    "LOOKS_NEXTCOSTUME": "kostumê pêş",
    "LOOKS_SWITCHBACKDROPTO": "derbasî dekora %1ê bibe",
    "LOOKS_GOTOFRONTBACK": "here tebeqeya %1yê",
    "LOOKS_GOTOFRONTBACK_FRONT": "pêşî",
    "LOOKS_GOTOFRONTBACK_BACK": "paşî",
    "LOOKS_GOFORWARDBACKWARDLAYERS": " %1 %2 tebeqeyan here",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "pêşve",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "paşve",
    "LOOKS_BACKDROPNUMBERNAME": "dekora %1",
    "LOOKS_COSTUMENUMBERNAME": "kostumê %1",
    "LOOKS_NUMBERNAME_NUMBER": "hejmar",
    "LOOKS_NUMBERNAME_NAME": "nav",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "derbasî dekora %1 bibe û bisekine",
    "LOOKS_NEXTBACKDROP_BLOCK": "dekora piştre",
    "LOOKS_NEXTBACKDROP": "dekora piştre",
    "LOOKS_PREVIOUSBACKDROP": "dekora berî vê",
    "LOOKS_RANDOMBACKDROP": "dekor bi ketoberî",
    "MOTION_MOVESTEPS": "%1 gavan biavêje",
    "MOTION_TURNLEFT": "%1 %2 dereceyan bizîvirîne",
    "MOTION_TURNRIGHT": "%1 %2 dereceyan bizîvirîne",
    "MOTION_POINTINDIRECTION": "berê wê %1 dereceyan bizîvirîne",
    "MOTION_POINTTOWARDS": "berê wê bide %1",
    "MOTION_POINTTOWARDS_POINTER": "nîşandera-mişkê",
    "MOTION_POINTTOWARDS_RANDOM": "hêla ketoberî",
    "MOTION_GOTO": "here %1",
    "MOTION_GOTO_POINTER": "nîşandera-mişkê",
    "MOTION_GOTO_RANDOM": "ciyekî ketoberî",
    "MOTION_GOTOXY": "biçe x: %1 y: %2ê",
    "MOTION_GLIDESECSTOXY": "di %1 çirkeyan de biçe x: %2 y: %3ê",
    "MOTION_GLIDETO": "di %1 çirkeyan de biçe %2ê",
    "MOTION_GLIDETO_POINTER": "nîşandera-mişkê",
    "MOTION_GLIDETO_RANDOM": "ciyekî ketoberî",
    "MOTION_CHANGEXBY": "cîgeha x'ê bi %1an biguherîne",
    "MOTION_SETX": "cîgeha x'ê bike %1",
    "MOTION_CHANGEYBY": "cîgeha y'yê bi %1an biguherîne",
    "MOTION_SETY": "cîgeha y'yê bike %1",
    "MOTION_IFONEDGEBOUNCE": "heke li kêlekê be, hilpekîne",
    "MOTION_SETROTATIONSTYLE": "şêweya zîvirê bike %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "çep-rast",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "nezîvirîne",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "bi hemû hela ve",
    "MOTION_XPOSITION": "cîgeha x'ê",
    "MOTION_YPOSITION": "cîgeha y'yê",
    "MOTION_DIRECTION": "hêl",
    "MOTION_SCROLLRIGHT": "%1ê bikişîne rastê",
    "MOTION_SCROLLUP": "%1ê bikîşîne jorê",
    "MOTION_ALIGNSCENE": "dika %1ê rast bike",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "jêra-çepê",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "jêra-rastê",
    "MOTION_ALIGNSCENE_MIDDLE": "navîn",
    "MOTION_ALIGNSCENE_TOPLEFT": "jora-çepê",
    "MOTION_ALIGNSCENE_TOPRIGHT": "jora-rastê",
    "MOTION_XSCROLL": "bikişîne ser x'ê",
    "MOTION_YSCROLL": "bikişîne ser y'yê",
    "MOTION_STAGE_SELECTED": "Dik hate hibijartin: blokên tevgerê tune ne",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "hejmareke ketoberî di navbera %1 - %2an de hilbijêre",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 û %2",
    "OPERATORS_OR": "%1 an jî %2",
    "OPERATORS_NOT": "ne %1 e",
    "OPERATORS_JOIN": "%1 û %2ê tevlî hev bike",
    "OPERATORS_JOIN_APPLE": "sêv",
    "OPERATORS_JOIN_BANANA": "mûz",
    "OPERATORS_LETTEROF": "tîpa %1. ya '%2ê",
    "OPERATORS_LETTEROF_APPLE": "yek",
    "OPERATORS_LENGTH": "dirêjiya %1ê",
    "OPERATORS_CONTAINS": "di nav %2ê de %1 heye?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "bi qasî %1 bizîvirîne",
    "OPERATORS_MATHOP": "%1-a %2ê",
    "OPERATORS_MATHOP_ABS": "nirxê mutlaq",
    "OPERATORS_MATHOP_FLOOR": "bigindirîne erdê",
    "OPERATORS_MATHOP_CEILING": "bigindirîne jorê",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "In",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "%1ê pênase bike",
    "SENSING_TOUCHINGOBJECT": "%1 tê tepandin?",
    "SENSING_TOUCHINGOBJECT_POINTER": "nîşandera-mişkê",
    "SENSING_TOUCHINGOBJECT_EDGE": "kêlek",
    "SENSING_TOUCHINGCOLOR": "te pêlî rengê %1 kir?",
    "SENSING_COLORISTOUCHINGCOLOR": "rengê %2 dikeve nav yê %1?",
    "SENSING_DISTANCETO": "mesafeya bi %1 re",
    "SENSING_DISTANCETO_POINTER": "nîşandera-mişkê",
    "SENSING_ASKANDWAIT": "%1ê bipirse û bisekine",
    "SENSING_ASK_TEXT": "Navê te çi ye?",
    "SENSING_ANSWER": "bersiv",
    "SENSING_KEYPRESSED": "pêlî bişkoka %1ê hate kirin?",
    "SENSING_MOUSEDOWN": "mişk pêlêkirî ye?",
    "SENSING_MOUSEX": "x'a mişkê",
    "SENSING_MOUSEY": "y'ya mişkê",
    "SENSING_SETDRAGMODE": "moda kişkişandinê wekî %1ê saz bike",
    "SENSING_SETDRAGMODE_DRAGGABLE": "kişînbar",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ne kişînbar",
    "SENSING_LOUDNESS": "bilindbûna deng",
    "SENSING_LOUD": "denge bilind?",
    "SENSING_TIMER": "demsazker",
    "SENSING_RESETTIMER": "demsazkerê nûsaz bike",
    "SENSING_OF": "%1 ya %2ê",
    "SENSING_OF_XPOSITION": "cîgeha x'ê",
    "SENSING_OF_YPOSITION": "cîgeha y'yê",
    "SENSING_OF_DIRECTION": "hêl",
    "SENSING_OF_COSTUMENUMBER": "kostum #",
    "SENSING_OF_COSTUMENAME": "navê kostumê",
    "SENSING_OF_SIZE": "mezinahî",
    "SENSING_OF_VOLUME": "rêjeya deng",
    "SENSING_OF_BACKDROPNUMBER": "dekor #",
    "SENSING_OF_BACKDROPNAME": "navê dekorê",
    "SENSING_OF_STAGE": "Dik",
    "SENSING_CURRENT": "aniha %1",
    "SENSING_CURRENT_YEAR": "sal",
    "SENSING_CURRENT_MONTH": "meh",
    "SENSING_CURRENT_DATE": "dîrok",
    "SENSING_CURRENT_DAYOFWEEK": "roja hefteyê",
    "SENSING_CURRENT_HOUR": "demjimêr",
    "SENSING_CURRENT_MINUTE": "xulek",
    "SENSING_CURRENT_SECOND": "çirke",
    "SENSING_DAYSSINCE2000": "rojên ji salên 2000an vir de",
    "SENSING_USERNAME": "navê bikarhêner",
    "SENSING_USERID": "nasnameya bikarhêner",
    "SOUND_PLAY": "denge %1ê bide destpêkirin",
    "SOUND_PLAYUNTILDONE": "heta denge %1ê biqede, lêxe",
    "SOUND_STOPALLSOUNDS": "hemû dengan rawestîne",
    "SOUND_SETEFFECTO": "efekta %1ê bike %2",
    "SOUND_CHANGEEFFECTBY": "efekta %1ê bi qasî %2 biguherîne",
    "SOUND_CLEAREFFECTS": "efektên deng paqij bike",
    "SOUND_EFFECTS_PITCH": "perdeya deng",
    "SOUND_EFFECTS_PAN": "bikişîne rastê-çepê",
    "SOUND_CHANGEVOLUMEBY": "rêjeya deng bike %1",
    "SOUND_SETVOLUMETO": "rêjeya deng bike %1%",
    "SOUND_VOLUME": "rêjeya deng",
    "SOUND_RECORD": "tomar bike...",
    "CATEGORY_MOTION": "Tevger",
    "CATEGORY_LOOKS": "Xuyang",
    "CATEGORY_SOUND": "Deng",
    "CATEGORY_EVENTS": "Çalakî",
    "CATEGORY_CONTROL": "Kontrol",
    "CATEGORY_SENSING": "Pêhisîn",
    "CATEGORY_OPERATORS": "Operator",
    "CATEGORY_VARIABLES": "Guherok",
    "CATEGORY_MYBLOCKS": "Blokên Min",
    "DUPLICATE": "Dubare",
    "DELETE": "Jê bibe",
    "ADD_COMMENT": "Şîrove tevlî bike",
    "REMOVE_COMMENT": "Şîroveyê Rake",
    "DELETE_BLOCK": "Blokê Jê bibe",
    "DELETE_X_BLOCKS": "Blokên %1ê jê bibe",
    "DELETE_ALL_BLOCKS": "Bila hemû bloken %1ê bên jêbirin?",
    "CLEAN_UP": "Blokan paqij bike",
    "HELP": "Alîkarî",
    "UNDO": "Vegerîne",
    "REDO": "Dîsa pêşve",
    "EDIT_PROCEDURE": "Sererast bike",
    "SHOW_PROCEDURE_DEFINITION": "Biçe destnîşan bike",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Çendek tiştan bibêje...",
    "COLOUR_HUE_LABEL": "Reng",
    "COLOUR_SATURATION_LABEL": "Têrbûna Reng",
    "COLOUR_BRIGHTNESS_LABEL": "Ronahî",
    "CHANGE_VALUE_TITLE": "Rêjeyê biguherîne:",
    "RENAME_VARIABLE": "Guherokê dîsa bi nav bike",
    "RENAME_VARIABLE_TITLE": "Hemû guherokên \"%1\"ê dîsa bi nav bike bi:",
    "RENAME_VARIABLE_MODAL_TITLE": "Guherokê dîsa bi nav bike",
    "NEW_VARIABLE": "Guherokekê Çê Bike",
    "NEW_VARIABLE_TITLE": "Navê guheroka nû:",
    "VARIABLE_MODAL_TITLE": "Guheroka Nû",
    "VARIABLE_ALREADY_EXISTS": "Jixwe berê guherokek bi navê \"%1\"ê heye.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Jixwe berê guheroka \"%1\"ê bi tîpa \"%2\"ê heye.",
    "DELETE_VARIABLE_CONFIRMATION": "Bila bikaranînên %1ê ji guheroka \"%2\"ê bêne jêbirin?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Jiber ku guheroka \"%1\"ê beşek ji fonksiyona \"%2\"ê ye nabe were jêbirin",
    "DELETE_VARIABLE": "Guheroka \"%1\"ê jê bibe",
    "NEW_PROCEDURE": "Blokekê Çê Bike",
    "PROCEDURE_ALREADY_EXISTS": "Jixwe berê prosedurek bi navê \"%1\"ê heye.",
    "PROCEDURE_DEFAULT_NAME": "navê blokê",
    "PROCEDURE_USED": "Ji bo jêbirina pênaseya blokekê, pêşî hemû bikaranînên blokê jê bibe",
    "NEW_LIST": "Lîsteyekê Çê Bike",
    "NEW_LIST_TITLE": "Navê lîsteya nû:",
    "LIST_MODAL_TITLE": "Lîsteya Nû",
    "LIST_ALREADY_EXISTS": "Jixwe berê lîsteyek bi navê \"%1\"ê heye.",
    "RENAME_LIST_TITLE": "Hemû lîsteyên \"%1\"ê dîsa bi nav bike bi:",
    "RENAME_LIST_MODAL_TITLE": "Lîsteyê dîsa bi nav bike",
    "DEFAULT_LIST_ITEM": "tişt",
    "DELETE_LIST": "Lîsteya \"%1\"ê jê bibe",
    "RENAME_LIST": "Lîsteyê dîsa bi nav bike",
    "NEW_BROADCAST_MESSAGE": "Peyama nû",
    "NEW_BROADCAST_MESSAGE_TITLE": "Navê peyama nû:",
    "BROADCAST_MODAL_TITLE": "Peyama Nû",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "peyam1"
  },
  "ckb": {
    "CONTROL_FOREVER": "بۆهەتایە",
    "CONTROL_REPEAT": "دوبارەکردنەوە %1",
    "CONTROL_IF": "ئەگەر %1 ئینجا",
    "CONTROL_ELSE": "ئەگەرنا",
    "CONTROL_STOP": "وەستان",
    "CONTROL_STOP_ALL": "هەموو",
    "CONTROL_STOP_THIS": "ئەم سکریپتە",
    "CONTROL_STOP_OTHER": "سکریپتەکانی تر لە تەن",
    "CONTROL_WAIT": "بوەستە %1 چرکە",
    "CONTROL_WAITUNTIL": "چاوەڕێ بکە تا %1",
    "CONTROL_REPEATUNTIL": "دوبارەکردنەوە تا %1",
    "CONTROL_WHILE": "کاتێک %1",
    "CONTROL_FOREACH": "بۆ هەر %1 لە %2",
    "CONTROL_STARTASCLONE": "کاتێک دەستپێدەکەم وەک لێکچووێک",
    "CONTROL_CREATECLONEOF": "دروستکردنی لێکچوو لە %1",
    "CONTROL_CREATECLONEOF_MYSELF": "خۆم",
    "CONTROL_DELETETHISCLONE": "سڕینەوەی ئەم لێکچووە",
    "CONTROL_COUNTER": "ژمێرەر",
    "CONTROL_INCRCOUNTER": "زیادکردنی ژمێرەر",
    "CONTROL_CLEARCOUNTER": "بەتاڵکردنەوەی ژمێرەر",
    "CONTROL_ALLATONCE": "هەموو بەیەکەوە",
    "DATA_SETVARIABLETO": "دانانی %1 بۆ %2",
    "DATA_CHANGEVARIABLEBY": "گۆڕین %1 بە %2",
    "DATA_SHOWVARIABLE": "پیشاندانی گۆڕاو %1",
    "DATA_HIDEVARIABLE": "شاردنەوەی گۆڕاوی %1",
    "DATA_ADDTOLIST": "زیادکردنی %1 بۆ %2",
    "DATA_DELETEOFLIST": "سڕینەوە %1 لە %2",
    "DATA_DELETEALLOFLIST": "سڕینەوەی هەموو لە %1",
    "DATA_INSERTATLIST": "خستنەناو %1 بۆ %2 لە %3",
    "DATA_REPLACEITEMOFLIST": "گۆڕینەوەی دانە %1 لە %2 لەگەڵ %3",
    "DATA_ITEMOFLIST": "دانە %1 لە %2",
    "DATA_ITEMNUMOFLIST": "دانەی # %1 لە %2",
    "DATA_LENGTHOFLIST": "درێژی لە %1",
    "DATA_LISTCONTAINSITEM": "%1 تێیدایە %2؟",
    "DATA_SHOWLIST": "پیشاندانی لیست %1",
    "DATA_HIDELIST": "شاردنەوەی لیست %1",
    "DATA_INDEX_ALL": "هەموو",
    "DATA_INDEX_LAST": "دوایەمین",
    "DATA_INDEX_RANDOM": "هەڕەمەکی",
    "EVENT_WHENFLAGCLICKED": "کاتێک %1 کرتەکرا",
    "EVENT_WHENTHISSPRITECLICKED": "کاتێک ئەم تەنە کرتەکرا",
    "EVENT_WHENSTAGECLICKED": "کاتێک سەکۆ کرتەکرا",
    "EVENT_WHENTOUCHINGOBJECT": "کاتێک ئەم تەنە بەرکەوت %1",
    "EVENT_WHENBROADCASTRECEIVED": "کاتێک بەدەستم گەیشت %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "کاتێک پاشبنەما دەگۆڕێت بۆ %1",
    "EVENT_WHENGREATERTHAN": "کاتێک %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "کاتێنەر",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "دەنگەدەنگ",
    "EVENT_BROADCAST": "پەخشکردن %1",
    "EVENT_BROADCASTANDWAIT": "پەخشکردنی %1 و چاوەڕێکردن",
    "EVENT_WHENKEYPRESSED": "کاتێک دوگمەی %1 کرتەکرا",
    "EVENT_WHENKEYPRESSED_SPACE": "بۆشایی",
    "EVENT_WHENKEYPRESSED_LEFT": "تیری چەپ",
    "EVENT_WHENKEYPRESSED_RIGHT": "تیری ڕاست",
    "EVENT_WHENKEYPRESSED_DOWN": "تیری خواروو",
    "EVENT_WHENKEYPRESSED_UP": "تیری سەروو",
    "EVENT_WHENKEYPRESSED_ANY": "هەر کام",
    "LOOKS_SAYFORSECS": "بڵێ %1 بۆ %2 چرکە",
    "LOOKS_SAY": "بڵێ %1",
    "LOOKS_HELLO": "سڵاو!",
    "LOOKS_THINKFORSECS": "بیرکردنەوە %1 بۆ %2 چرکە",
    "LOOKS_THINK": "بیرکردنەوەی %1",
    "LOOKS_HMM": "ئمم...",
    "LOOKS_SHOW": "پیشاندان",
    "LOOKS_HIDE": "شاردنەوە",
    "LOOKS_HIDEALLSPRITES": "شاردنەوەی هەموو تەنەکان",
    "LOOKS_EFFECT_COLOR": "ڕەنگ",
    "LOOKS_EFFECT_FISHEYE": "چاوماسی",
    "LOOKS_EFFECT_WHIRL": "خولانەوە",
    "LOOKS_EFFECT_PIXELATE": "وێنەخاڵکردن",
    "LOOKS_EFFECT_MOSAIC": "موزایک",
    "LOOKS_EFFECT_BRIGHTNESS": "ڕووناکی",
    "LOOKS_EFFECT_GHOST": "خێو",
    "LOOKS_CHANGEEFFECTBY": "گۆڕینی %1 کاریگەری بە %2",
    "LOOKS_SETEFFECTTO": "دانانی %1 کاریگەری بۆ %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "سڕینەوەی کاریگەرییەکانی هێلکاری",
    "LOOKS_CHANGESIZEBY": "گۆڕینی قەبارە بە %1",
    "LOOKS_SETSIZETO": "دانانی قەبارە بە %1 ٪",
    "LOOKS_SIZE": "قەبارە",
    "LOOKS_CHANGESTRETCHBY": "گۆڕینی درێژبوونەوە بە %1",
    "LOOKS_SETSTRETCHTO": "دانانی درێژبوونەوە بە %1 ٪",
    "LOOKS_SWITCHCOSTUMETO": "گۆڕینی بەرگ بۆ %1",
    "LOOKS_NEXTCOSTUME": "بەرگی دواتر",
    "LOOKS_SWITCHBACKDROPTO": "گۆڕینی پاشبنەما بۆ %1",
    "LOOKS_GOTOFRONTBACK": "بڕۆ بۆ %1 چین",
    "LOOKS_GOTOFRONTBACK_FRONT": "پێشەوە",
    "LOOKS_GOTOFRONTBACK_BACK": "دواوە",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "بڕۆ بۆ %1 %2 چین",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "بۆ پێشەوە",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "بۆ دواوە",
    "LOOKS_BACKDROPNUMBERNAME": "پاشبنه‌ما %1",
    "LOOKS_COSTUMENUMBERNAME": "بەرگ %1",
    "LOOKS_NUMBERNAME_NUMBER": "ژمارە",
    "LOOKS_NUMBERNAME_NAME": "ناو",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "گۆڕینی پاشبنەما بۆ %1 و چاوەڕێ بکە",
    "LOOKS_NEXTBACKDROP_BLOCK": "پاشبنەمای دواتر",
    "LOOKS_NEXTBACKDROP": "پاشبنەمای دواتر",
    "LOOKS_PREVIOUSBACKDROP": "پاشبنەمای پێشتر",
    "LOOKS_RANDOMBACKDROP": "پاشبنەمای هەڕەمەکی",
    "MOTION_MOVESTEPS": "جوڵان %1 هەنگاو",
    "MOTION_TURNLEFT": "بیسوڕێنەوە %1 %2 پلە",
    "MOTION_TURNRIGHT": "بیسوڕێنەوە %1 %2 پلە",
    "MOTION_POINTINDIRECTION": "خاڵ بە ئاڕاستەی %1",
    "MOTION_POINTTOWARDS": "خاڵ بەرەو %1",
    "MOTION_POINTTOWARDS_POINTER": "نیشاندەری ماوس",
    "MOTION_POINTTOWARDS_RANDOM": "ئاڕاستەی هەڕەمەکی",
    "MOTION_GOTO": "بڕۆ بۆ %1",
    "MOTION_GOTO_POINTER": "نیشاندەری ماوس",
    "MOTION_GOTO_RANDOM": "شوێنی هەڕەمەکی",
    "MOTION_GOTOXY": "بڕۆ بۆ x: %1   y: %2",
    "MOTION_GLIDESECSTOXY": "خلیسکان %1 چرکە بۆ x %2  y %3",
    "MOTION_GLIDETO": "خلیسکان %1 چرکە بۆ %2",
    "MOTION_GLIDETO_POINTER": "نیشاندەری ماوس",
    "MOTION_GLIDETO_RANDOM": "شوێنی هەڕەمەکی",
    "MOTION_CHANGEXBY": "گۆڕینی x بە %1",
    "MOTION_SETX": "دانانی x بە %1",
    "MOTION_CHANGEYBY": "گۆڕینی y بە %1",
    "MOTION_SETY": "دانانی y بە %1",
    "MOTION_IFONEDGEBOUNCE": "ئەگەر لە لێواربوو، بگەڕێوە",
    "MOTION_SETROTATIONSTYLE": "دانانی شێوازی سوڕانەوە %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "چەپ-ڕاست",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "مەیسوڕێنە",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "بەدەوری",
    "MOTION_XPOSITION": "شوێنی x",
    "MOTION_YPOSITION": "شوێنی y",
    "MOTION_DIRECTION": "ئاڕاستە",
    "MOTION_SCROLLRIGHT": "پێچۆکە بۆ ڕاست %1",
    "MOTION_SCROLLUP": "پێچۆکه‌ هه‌ڵکێشان %1",
    "MOTION_ALIGNSCENE": "لاگرتنی دیمەن %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ژێرەوە-چەپ",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ژێرەوە-ڕاست",
    "MOTION_ALIGNSCENE_MIDDLE": "ناوەند",
    "MOTION_ALIGNSCENE_TOPLEFT": "سەرەوە-چەپ",
    "MOTION_ALIGNSCENE_TOPRIGHT": "سەرەوە-ڕاست",
    "MOTION_XSCROLL": "پێچۆکەی x",
    "MOTION_YSCROLL": "پێچۆکەی y",
    "MOTION_STAGE_SELECTED": "سەکۆی دیاریکراو: هیچ بلۆکێکی جوڵاندن",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "هەڵبژاردنی هەڕەمەکی %1 بۆ %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 and %2",
    "OPERATORS_OR": "%1 or %2",
    "OPERATORS_NOT": "نا %1",
    "OPERATORS_JOIN": "پەیوەندی %1 %2",
    "OPERATORS_JOIN_APPLE": "سێو",
    "OPERATORS_JOIN_BANANA": "مۆز",
    "OPERATORS_LETTEROF": "پیت %1 لە %2",
    "OPERATORS_LETTEROF_APPLE": "ێ",
    "OPERATORS_LENGTH": "درێژی لە %1",
    "OPERATORS_CONTAINS": "%1 تێیدایە %2؟",
    "OPERATORS_MOD": "%1 ماوە %2",
    "OPERATORS_ROUND": "نزیککردنەوە %1",
    "OPERATORS_MATHOP": "%1 لە %2",
    "OPERATORS_MATHOP_ABS": "ڕەگی دووجا",
    "OPERATORS_MATHOP_FLOOR": "زەوی",
    "OPERATORS_MATHOP_CEILING": "بنمیچ",
    "OPERATORS_MATHOP_SQRT": "ڕەگی دووجا",
    "OPERATORS_MATHOP_SIN": "تەژێ",
    "OPERATORS_MATHOP_COS": "تەژێ تەواو",
    "OPERATORS_MATHOP_TAN": "تانجێنت",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "لن",
    "OPERATORS_MATHOP_LOG": "لۆگاریتم",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "پێناسەی %1",
    "SENSING_TOUCHINGOBJECT": "بەرکەوتنی %1؟",
    "SENSING_TOUCHINGOBJECT_POINTER": "نیشاندەری ماوس",
    "SENSING_TOUCHINGOBJECT_EDGE": "لێوار",
    "SENSING_TOUCHINGCOLOR": "بەرکەوتنی ڕەنگ %1؟",
    "SENSING_COLORISTOUCHINGCOLOR": "ڕەنگ %1 بەردەکەوێت %2؟",
    "SENSING_DISTANCETO": "دووری بۆ %1",
    "SENSING_DISTANCETO_POINTER": "نیشاندەری ماوس",
    "SENSING_ASKANDWAIT": "پرسیار بکە %1 و چاوەڕێ بکە",
    "SENSING_ASK_TEXT": "ناوت چییە؟",
    "SENSING_ANSWER": "وەڵام",
    "SENSING_KEYPRESSED": "دوگمەی %1 داگیرا؟",
    "SENSING_MOUSEDOWN": "ماوس بۆ خوارەوە؟",
    "SENSING_MOUSEX": "ماوس x",
    "SENSING_MOUSEY": "ماوس y",
    "SENSING_SETDRAGMODE": "دانانی شێوازی  ڕاکێشان %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ڕادەکێشترێت",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ڕاناکێشرێت",
    "SENSING_LOUDNESS": "دەنگەدەنگ",
    "SENSING_LOUD": "بەدەنگی بەرز؟",
    "SENSING_TIMER": "کاتێنەر",
    "SENSING_RESETTIMER": "ڕێکخستنەوەی کاتێنەر",
    "SENSING_OF": "%1 لە %2",
    "SENSING_OF_XPOSITION": "شوێنی x",
    "SENSING_OF_YPOSITION": "شوێنی y",
    "SENSING_OF_DIRECTION": "ئاڕاستە",
    "SENSING_OF_COSTUMENUMBER": "بەرگ #",
    "SENSING_OF_COSTUMENAME": "ناوی بەرگ",
    "SENSING_OF_SIZE": "قەبارە",
    "SENSING_OF_VOLUME": "قەبارە",
    "SENSING_OF_BACKDROPNUMBER": "پاشبنه‌ما #",
    "SENSING_OF_BACKDROPNAME": "ناوی پاشبنەما",
    "SENSING_OF_STAGE": "سەکۆ",
    "SENSING_CURRENT": "ئێستا %1",
    "SENSING_CURRENT_YEAR": "ساڵ",
    "SENSING_CURRENT_MONTH": "مانگ",
    "SENSING_CURRENT_DATE": "بەروار",
    "SENSING_CURRENT_DAYOFWEEK": "ڕۆژی هەفتە",
    "SENSING_CURRENT_HOUR": "کاتژمێر",
    "SENSING_CURRENT_MINUTE": "خولەک",
    "SENSING_CURRENT_SECOND": "چرکە",
    "SENSING_DAYSSINCE2000": "ڕۆژ لەوەتەی 2000",
    "SENSING_USERNAME": "ناوی بەکارهێنەر",
    "SENSING_USERID": "ژمارەی بەکارهێنەر",
    "SOUND_PLAY": "دەستپێکردنی دەنگ %1",
    "SOUND_PLAYUNTILDONE": "لێدانی دەنگی %1 تا تەواوبوون",
    "SOUND_STOPALLSOUNDS": "هەموو دەنگەکان ڕاگرە",
    "SOUND_SETEFFECTO": "دانانی %1 کاریگەری بۆ %2",
    "SOUND_CHANGEEFFECTBY": "گۆڕینی %1 کاریگەری بە %2",
    "SOUND_CLEAREFFECTS": "سڕینەوەی کاریگەرییەکانی دەنگ",
    "SOUND_EFFECTS_PITCH": "بەرزی دەنگ",
    "SOUND_EFFECTS_PAN": "سوڕانەوە چەپ/ڕاست",
    "SOUND_CHANGEVOLUMEBY": "گۆڕینی دەنگ بە %1",
    "SOUND_SETVOLUMETO": "دانانی دانگ بە %1%",
    "SOUND_VOLUME": "قەبارە",
    "SOUND_RECORD": "تۆمارکردن...",
    "CATEGORY_MOTION": "جوڵان",
    "CATEGORY_LOOKS": "ڕوانین",
    "CATEGORY_SOUND": "دەنگ",
    "CATEGORY_EVENTS": "چالاکییەکان",
    "CATEGORY_CONTROL": "کۆنتڕۆڵ",
    "CATEGORY_SENSING": "هەستکردن",
    "CATEGORY_OPERATORS": "كرده‌هێماکان",
    "CATEGORY_VARIABLES": "گۆڕاوەکان",
    "CATEGORY_MYBLOCKS": "بلۆکەکانم",
    "DUPLICATE": "هاوشێوەکردنەوە",
    "DELETE": "سڕینەوە",
    "ADD_COMMENT": "زیادکردنی لێدوان",
    "REMOVE_COMMENT": "لابردنی لێدوان",
    "DELETE_BLOCK": "سڕینەوەی بلۆک",
    "DELETE_X_BLOCKS": "سڕینەوەی %1 بلۆک",
    "DELETE_ALL_BLOCKS": "سڕینەوەی هەموو %1 بلۆکەکان؟",
    "CLEAN_UP": "بەتاڵکردنەوەی بلۆکەکان",
    "HELP": "یارمەتی",
    "UNDO": "هه‌ڵوه‌شاندنه‌وه‌",
    "REDO": "کردنەوە",
    "EDIT_PROCEDURE": "دەستکاری",
    "SHOW_PROCEDURE_DEFINITION": "بڕۆ بۆ پێناسە",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "شتێک بڵێ",
    "COLOUR_HUE_LABEL": "ڕەنگ",
    "COLOUR_SATURATION_LABEL": "تێری",
    "COLOUR_BRIGHTNESS_LABEL": "ڕووناکی",
    "CHANGE_VALUE_TITLE": "گۆڕینی نرخ:",
    "RENAME_VARIABLE": "ناونانەوەی گۆڕاو",
    "RENAME_VARIABLE_TITLE": "ناونانەوەی هەموو \"%1\" گۆڕاوەکان بۆ:",
    "RENAME_VARIABLE_MODAL_TITLE": "ناونانەوەی گۆڕاو",
    "NEW_VARIABLE": "دروستکردنی گۆڕاوێک",
    "NEW_VARIABLE_TITLE": "ناوی نوێی گۆڕاو",
    "VARIABLE_MODAL_TITLE": "گۆڕاوی نوێ",
    "VARIABLE_ALREADY_EXISTS": "گۆڕاوی ناونراو \"%1\" هەیە.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "گۆڕاوی ناونراو \"%1\" هەیە بۆ گۆڕاوێکی تر لە جۆری \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "سڕینەوەی %1 بەکارهێنانی \"%2\" گۆڕاو؟",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "گۆڕاوەی \"%1\" ناسڕێتەوە چونکە بەشێکە لە پێناسەی فرمانی \"%2\"",
    "DELETE_VARIABLE": "سڕینەوەی \"%1\" گۆڕاو",
    "NEW_PROCEDURE": "دروستکردنی بلۆکێک",
    "PROCEDURE_ALREADY_EXISTS": "کارایی ناونراو \"%1\" هەیە.",
    "PROCEDURE_DEFAULT_NAME": "ناوی بلۆک",
    "PROCEDURE_USED": "بۆ سڕینەوەی پێناسەی بلۆکێک، سەرەتا هەموو بەکارهێنانەکانی ئەو بلۆکە لابە",
    "NEW_LIST": "دروستکردنی لیستێک",
    "NEW_LIST_TITLE": "ناوی نوێی لیست",
    "LIST_MODAL_TITLE": "لیستی نوێ",
    "LIST_ALREADY_EXISTS": "لیستی ناونراو \"%1\" هەیە.",
    "RENAME_LIST_TITLE": "ناونانەوەی هەموو \"%1\" لیستەکان بە:",
    "RENAME_LIST_MODAL_TITLE": "ناونانەوەی لیست",
    "DEFAULT_LIST_ITEM": "شت",
    "DELETE_LIST": "سڕینەوەی \"%1\" لیست",
    "RENAME_LIST": "ناونانەوەی لیست",
    "NEW_BROADCAST_MESSAGE": "پەیامی نوێ",
    "NEW_BROADCAST_MESSAGE_TITLE": "ناوی نامەی نوێی",
    "BROADCAST_MODAL_TITLE": "پەیامی نوێ",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "نامەی1"
  },
  "lv": {
    "CONTROL_FOREVER": "nepārtraukti",
    "CONTROL_REPEAT": "atkārtot %1",
    "CONTROL_IF": "ja %1 tad",
    "CONTROL_ELSE": "citādi",
    "CONTROL_STOP": "apturēt",
    "CONTROL_STOP_ALL": "viss",
    "CONTROL_STOP_THIS": "šis skripts",
    "CONTROL_STOP_OTHER": "citi skripti gariņā",
    "CONTROL_WAIT": "gaidīt %1 sekundes",
    "CONTROL_WAITUNTIL": "gaidīt līdz %1",
    "CONTROL_REPEATUNTIL": "atkārtot līdz %1",
    "CONTROL_WHILE": "kamēr %1",
    "CONTROL_FOREACH": "katram %1 %2",
    "CONTROL_STARTASCLONE": "kad es parādos kā dublikāts",
    "CONTROL_CREATECLONEOF": "izveidot %1 dublikātu",
    "CONTROL_CREATECLONEOF_MYSELF": "savu",
    "CONTROL_DELETETHISCLONE": "dzēst šo dublikātu",
    "CONTROL_COUNTER": "skaitītājs",
    "CONTROL_INCRCOUNTER": "pieauguma skaitītājs",
    "CONTROL_CLEARCOUNTER": "nodzēst skaitītāju",
    "CONTROL_ALLATONCE": "viss vienlaikus",
    "DATA_SETVARIABLETO": "iestatīt %1 uz %2",
    "DATA_CHANGEVARIABLEBY": "mainīt %1 par %2",
    "DATA_SHOWVARIABLE": "rādīt mainīgo %1",
    "DATA_HIDEVARIABLE": "slēpt mainīgo %1",
    "DATA_ADDTOLIST": "pievienot %1 pie %2",
    "DATA_DELETEOFLIST": "dzēst %1 no %2",
    "DATA_DELETEALLOFLIST": "dzēst visu no %1",
    "DATA_INSERTATLIST": "ievietot %1 kā %2 sarakstā %3",
    "DATA_REPLACEITEMOFLIST": "aizvietot %1 vienumu sarakstā %2 ar %3",
    "DATA_ITEMOFLIST": "vienums %1 sarakstā %2",
    "DATA_ITEMNUMOFLIST": "vienuma %1 # sarakstā %2",
    "DATA_LENGTHOFLIST": "%1 garums",
    "DATA_LISTCONTAINSITEM": "%1 satur %2?",
    "DATA_SHOWLIST": "rādīt sarakstu %1",
    "DATA_HIDELIST": "slēpt sarakstu %1",
    "DATA_INDEX_ALL": "viss",
    "DATA_INDEX_LAST": "pēdējais",
    "DATA_INDEX_RANDOM": "nejaušs",
    "EVENT_WHENFLAGCLICKED": "kad %1 nospiests",
    "EVENT_WHENTHISSPRITECLICKED": "kad noklikšķināts šis gariņš",
    "EVENT_WHENSTAGECLICKED": "kad noklikšķināta skatuve",
    "EVENT_WHENTOUCHINGOBJECT": "kad šis gariņš pieskaras %1",
    "EVENT_WHENBROADCASTRECEIVED": "kad es saņemu %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "kad fons nomainās uz %1",
    "EVENT_WHENGREATERTHAN": "kad %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "taimeris",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "skaļums",
    "EVENT_BROADCAST": "pārraidīt %1",
    "EVENT_BROADCASTANDWAIT": "pārraidīt %1 un gaidīt",
    "EVENT_WHENKEYPRESSED": "kad nospiests taustiņš %1",
    "EVENT_WHENKEYPRESSED_SPACE": "atstarpe",
    "EVENT_WHENKEYPRESSED_LEFT": "kreisā bulta",
    "EVENT_WHENKEYPRESSED_RIGHT": "labā bulta",
    "EVENT_WHENKEYPRESSED_DOWN": "apakšējā bulta",
    "EVENT_WHENKEYPRESSED_UP": "augšējā bulta",
    "EVENT_WHENKEYPRESSED_ANY": "jebkāds",
    "LOOKS_SAYFORSECS": "teikt %1 %2 sekundes",
    "LOOKS_SAY": "teikt %1",
    "LOOKS_HELLO": "Sveiki!",
    "LOOKS_THINKFORSECS": "domāt %1 %2 sekundes",
    "LOOKS_THINK": "domāt %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "rādīt",
    "LOOKS_HIDE": "slēpt",
    "LOOKS_HIDEALLSPRITES": "slēpt visus gariņus",
    "LOOKS_EFFECT_COLOR": "krāsa",
    "LOOKS_EFFECT_FISHEYE": "zivsacs",
    "LOOKS_EFFECT_WHIRL": "virpuļi",
    "LOOKS_EFFECT_PIXELATE": "pikseļi",
    "LOOKS_EFFECT_MOSAIC": "mozaīka",
    "LOOKS_EFFECT_BRIGHTNESS": "gaišums",
    "LOOKS_EFFECT_GHOST": "spoks",
    "LOOKS_CHANGEEFFECTBY": "mainīt efektu %1 par %2",
    "LOOKS_SETEFFECTTO": "iestatīt efektu %1 par %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "notīrīt grafiskos efektus",
    "LOOKS_CHANGESIZEBY": "mainīt izmēru par %1",
    "LOOKS_SETSIZETO": "iestatīt izmēru uz %1 %",
    "LOOKS_SIZE": "izmērs",
    "LOOKS_CHANGESTRETCHBY": "manīt saspīlējumu par %1",
    "LOOKS_SETSTRETCHTO": "iestatīt saspīlējumu uz %1",
    "LOOKS_SWITCHCOSTUMETO": "mainīt tērpu uz %1",
    "LOOKS_NEXTCOSTUME": "nākamais tērps",
    "LOOKS_SWITCHBACKDROPTO": "mainīt fonu uz %1",
    "LOOKS_GOTOFRONTBACK": "iet uz %1 slāni",
    "LOOKS_GOTOFRONTBACK_FRONT": "priekšējo",
    "LOOKS_GOTOFRONTBACK_BACK": "aizmugurējo",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "iet %1 %2 slāņus",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "uz priekšu",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "atpakaļ",
    "LOOKS_BACKDROPNUMBERNAME": "fona %1",
    "LOOKS_COSTUMENUMBERNAME": "tērpa %1",
    "LOOKS_NUMBERNAME_NUMBER": "numurs",
    "LOOKS_NUMBERNAME_NAME": "vārds",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "mainīt fonu uz %1 un gaidīt",
    "LOOKS_NEXTBACKDROP_BLOCK": "nākamais fons",
    "LOOKS_NEXTBACKDROP": "nākamais fons",
    "LOOKS_PREVIOUSBACKDROP": "iepriekšējais fons",
    "LOOKS_RANDOMBACKDROP": "nejaušs fons",
    "MOTION_MOVESTEPS": "pārvietoties %1 soļus",
    "MOTION_TURNLEFT": "pagriezties %1 par %2 grādiem",
    "MOTION_TURNRIGHT": "pagriezties %1 par %2 grādiem",
    "MOTION_POINTINDIRECTION": "pagriezt virzienā %1",
    "MOTION_POINTTOWARDS": "pagriezt uz %1",
    "MOTION_POINTTOWARDS_POINTER": "peles kursors",
    "MOTION_POINTTOWARDS_RANDOM": "nejaušs virziens",
    "MOTION_GOTO": "iet uz %1",
    "MOTION_GOTO_POINTER": "peles kursors",
    "MOTION_GOTO_RANDOM": "nejauša pozīcija",
    "MOTION_GOTOXY": "iet uz x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "slīdēt %1 sekundes uz x: %2 y: %3",
    "MOTION_GLIDETO": "slīdēt %1 sekundes uz %2",
    "MOTION_GLIDETO_POINTER": "peles kursors",
    "MOTION_GLIDETO_RANDOM": "nejauša pozīcija",
    "MOTION_CHANGEXBY": "mainīt x par %1",
    "MOTION_SETX": "iestatīt x uz %1",
    "MOTION_CHANGEYBY": "mainīt y par %1",
    "MOTION_SETY": "iestatīt y uz %1",
    "MOTION_IFONEDGEBOUNCE": "ja uz malas, atlēkt",
    "MOTION_SETROTATIONSTYLE": "iestatīt griešanās stilu uz %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "pa kreisi - pa labi",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "negriezties",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "jebkurā virzienā",
    "MOTION_XPOSITION": "x pozīcija",
    "MOTION_YPOSITION": "y pozīcija",
    "MOTION_DIRECTION": "virziens",
    "MOTION_SCROLLRIGHT": "ritināt pa labi %1",
    "MOTION_SCROLLUP": "ritināt uz augšu %1",
    "MOTION_ALIGNSCENE": "izlīdzināt ainu %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "apakšā-pa kreisi",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "apakšā-pa labi",
    "MOTION_ALIGNSCENE_MIDDLE": " vidū",
    "MOTION_ALIGNSCENE_TOPLEFT": "augšā-pa kreisi",
    "MOTION_ALIGNSCENE_TOPRIGHT": "augšā-pa labi",
    "MOTION_XSCROLL": "x ritināšana",
    "MOTION_YSCROLL": "y ritināšana",
    "MOTION_STAGE_SELECTED": "Izvēlēta skatuve: nav kustības bloku",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "izvēlēties nejauši no %1 līdz %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 un %2",
    "OPERATORS_OR": "%1 vai %2",
    "OPERATORS_NOT": "nav  %1",
    "OPERATORS_JOIN": "apvienot %1 %2",
    "OPERATORS_JOIN_APPLE": "ābols",
    "OPERATORS_JOIN_BANANA": "banāns",
    "OPERATORS_LETTEROF": "burts %1 no %2",
    "OPERATORS_LETTEROF_APPLE": "ā",
    "OPERATORS_LENGTH": "%1 garums",
    "OPERATORS_CONTAINS": "%1 satur %2?",
    "OPERATORS_MOD": "%1 atlikums dalot ar %2",
    "OPERATORS_ROUND": "noapaļot %1",
    "OPERATORS_MATHOP": "%1 no %2",
    "OPERATORS_MATHOP_ABS": "modulis (absolūtā vērtība)",
    "OPERATORS_MATHOP_FLOOR": "apaļot uz leju",
    "OPERATORS_MATHOP_CEILING": "apaļot uz augšu",
    "OPERATORS_MATHOP_SQRT": "kvadrātsakne",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "In",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definēt %1",
    "SENSING_TOUCHINGOBJECT": "pieskaras %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "peles kursors",
    "SENSING_TOUCHINGOBJECT_EDGE": "mala",
    "SENSING_TOUCHINGCOLOR": "pieskaras krāsai %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "krāsa %1 pieskaras %2?",
    "SENSING_DISTANCETO": "attālums līdz %1",
    "SENSING_DISTANCETO_POINTER": "peles kursors",
    "SENSING_ASKANDWAIT": "jautāt %1 un gaidīt ",
    "SENSING_ASK_TEXT": "Kā tevi sauc?",
    "SENSING_ANSWER": "atbilde",
    "SENSING_KEYPRESSED": "nospiests taustiņš %1?",
    "SENSING_MOUSEDOWN": "peles taustiņš nospiests?",
    "SENSING_MOUSEX": "peles x",
    "SENSING_MOUSEY": "peles y",
    "SENSING_SETDRAGMODE": "iestatīt vilkšanas režīmu uz %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "velkams",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "nav velkams",
    "SENSING_LOUDNESS": "skaļums",
    "SENSING_LOUD": "skaļš?",
    "SENSING_TIMER": "taimeris",
    "SENSING_RESETTIMER": "atiestatīt taimeri",
    "SENSING_OF": "%1 no %2",
    "SENSING_OF_XPOSITION": "x pozīcija",
    "SENSING_OF_YPOSITION": "y pozīcija",
    "SENSING_OF_DIRECTION": "virziens",
    "SENSING_OF_COSTUMENUMBER": "tērpa #",
    "SENSING_OF_COSTUMENAME": "tērpa nosaukums",
    "SENSING_OF_SIZE": "izmērs",
    "SENSING_OF_VOLUME": "skaļums",
    "SENSING_OF_BACKDROPNUMBER": "fona #",
    "SENSING_OF_BACKDROPNAME": "fona nosaukums",
    "SENSING_OF_STAGE": "Skatuve",
    "SENSING_CURRENT": "pašreizējais %1",
    "SENSING_CURRENT_YEAR": "gads",
    "SENSING_CURRENT_MONTH": "mēnesis",
    "SENSING_CURRENT_DATE": "datums",
    "SENSING_CURRENT_DAYOFWEEK": "nedēļas diena",
    "SENSING_CURRENT_HOUR": "stunda",
    "SENSING_CURRENT_MINUTE": "minūte",
    "SENSING_CURRENT_SECOND": "sekunde",
    "SENSING_DAYSSINCE2000": "dienas kopš 2000",
    "SENSING_USERNAME": "lietotājvārds",
    "SENSING_USERID": "lietotāja id",
    "SOUND_PLAY": "atskaņot skaņu %1",
    "SOUND_PLAYUNTILDONE": "atskaņot skaņu %1 līdz galam",
    "SOUND_STOPALLSOUNDS": "apturēt visas skaņas",
    "SOUND_SETEFFECTO": "iestatīt efektu %1 uz %2",
    "SOUND_CHANGEEFFECTBY": "mainīt efektu %1 par %2",
    "SOUND_CLEAREFFECTS": "notīrīt skaņas efektus",
    "SOUND_EFFECTS_PITCH": "augstums",
    "SOUND_EFFECTS_PAN": "bīdīt pa labi/pa kreisi",
    "SOUND_CHANGEVOLUMEBY": "mainīt skaļumu par %1",
    "SOUND_SETVOLUMETO": "iestatīt skaļumu uz %1%",
    "SOUND_VOLUME": "skaļums",
    "SOUND_RECORD": "ierakstīt...",
    "CATEGORY_MOTION": "Kustība",
    "CATEGORY_LOOKS": "Izskats",
    "CATEGORY_SOUND": "Skaņa",
    "CATEGORY_EVENTS": "Notikumi",
    "CATEGORY_CONTROL": "Vadība",
    "CATEGORY_SENSING": "Uztveršana",
    "CATEGORY_OPERATORS": "Operatori",
    "CATEGORY_VARIABLES": "Mainīgie",
    "CATEGORY_MYBLOCKS": "Mani bloki",
    "DUPLICATE": "Dublēt",
    "DELETE": "Dzēst",
    "ADD_COMMENT": "Pievienot komentāru",
    "REMOVE_COMMENT": "Noņemt komentāru",
    "DELETE_BLOCK": "Dzēst bloku",
    "DELETE_X_BLOCKS": "Dzēst %1 blokus",
    "DELETE_ALL_BLOCKS": "Dzēst visus %1 blokus?",
    "CLEAN_UP": "Satīrīt blokus",
    "HELP": "Palīdzība",
    "UNDO": "Atsaukt",
    "REDO": "Atcelt atsaukšanu",
    "EDIT_PROCEDURE": "Rediģēt",
    "SHOW_PROCEDURE_DEFINITION": "Iet uz definīciju",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Saki kaut ko...",
    "COLOUR_HUE_LABEL": "Krāsa",
    "COLOUR_SATURATION_LABEL": "Piesātinājums",
    "COLOUR_BRIGHTNESS_LABEL": "Gaišums",
    "CHANGE_VALUE_TITLE": "Mainīt vērtību:",
    "RENAME_VARIABLE": "Pārdēvēt mainīgo",
    "RENAME_VARIABLE_TITLE": "Pārdēvēt visus \"%1\" mainīgos uz:",
    "RENAME_VARIABLE_MODAL_TITLE": "Pārdēvēt Mainīgo",
    "NEW_VARIABLE": "Izveidot Mainīgo",
    "NEW_VARIABLE_TITLE": "Jauns mainīgā nosaukums:",
    "VARIABLE_MODAL_TITLE": "Jauns Mainīgais",
    "VARIABLE_ALREADY_EXISTS": "Mainīgais \"%1\" jau pastāv.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Mainīgais \"%1\" jau pastāv citam mainīgajam ar tipu ''%2''.",
    "DELETE_VARIABLE_CONFIRMATION": "Dzēst %1 mainīgā \"%2\" lietojumus?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Nevar dzēst mainīgo \"%1\", jo tas ir daļa no funkcijas \"%2\" definīcijas",
    "DELETE_VARIABLE": "Dzēst ''%1'' mainīgo",
    "NEW_PROCEDURE": "Izveidot bloku",
    "PROCEDURE_ALREADY_EXISTS": "Procedūra ar nosaukumu \"%1\" jau pastāv.",
    "PROCEDURE_DEFAULT_NAME": "bloka nosaukums",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Izveidot sarakstu",
    "NEW_LIST_TITLE": "Jauns saraksta nosaukums:",
    "LIST_MODAL_TITLE": "Jauns saraksts",
    "LIST_ALREADY_EXISTS": "Saraksts ar nosaukumu \"%1\" jau pastāv.",
    "RENAME_LIST_TITLE": "Pārdēvēt visus \"%1\" sarakstus uz:",
    "RENAME_LIST_MODAL_TITLE": "Pārdēvēt sarakstu",
    "DEFAULT_LIST_ITEM": "lieta",
    "DELETE_LIST": "Dzēst \"%1\" sarakstu",
    "RENAME_LIST": "Pārdēvēt sarakstu",
    "NEW_BROADCAST_MESSAGE": "Jauna ziņa",
    "NEW_BROADCAST_MESSAGE_TITLE": "Jauns ziņas nosaukums:",
    "BROADCAST_MODAL_TITLE": "Jauna ziņa",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "ziņa1"
  },
  "lt": {
    "CONTROL_FOREVER": "kartok be galo",
    "CONTROL_REPEAT": "kartok %1",
    "CONTROL_IF": "jeigu %1",
    "CONTROL_ELSE": "kitais atvejais",
    "CONTROL_STOP": "sustok",
    "CONTROL_STOP_ALL": "visiškai",
    "CONTROL_STOP_THIS": "šį scenarijų",
    "CONTROL_STOP_OTHER": "kitus veikėjo scenarijus",
    "CONTROL_WAIT": "palauk %1 sek.",
    "CONTROL_WAITUNTIL": "palauk, kol pasidarys %1",
    "CONTROL_REPEATUNTIL": "kartok, kol pasidarys %1",
    "CONTROL_WHILE": "kol %1",
    "CONTROL_FOREACH": "su kiekvienu %1 iš %2",
    "CONTROL_STARTASCLONE": "kai pradės veikti klonas",
    "CONTROL_CREATECLONEOF": "sukurk %1 kloną",
    "CONTROL_CREATECLONEOF_MYSELF": "savęs",
    "CONTROL_DELETETHISCLONE": "ištrink šį kloną",
    "CONTROL_COUNTER": "skaitiklis",
    "CONTROL_INCRCOUNTER": "padidink skaitiklį vienetu",
    "CONTROL_CLEARCOUNTER": "skaitiklis = 0",
    "CONTROL_ALLATONCE": "viskas vienu metu",
    "DATA_SETVARIABLETO": "%1 = %2",
    "DATA_CHANGEVARIABLEBY": "%1 padidink %2",
    "DATA_SHOWVARIABLE": "rodyk %1",
    "DATA_HIDEVARIABLE": "slėpk %1",
    "DATA_ADDTOLIST": "pridėk %1 į %2",
    "DATA_DELETEOFLIST": "ištrinti %1 iš %2",
    "DATA_DELETEALLOFLIST": "ištrinti visus iš %1",
    "DATA_INSERTATLIST": "į sąrašo %3 %2 vietą įterpti %1",
    "DATA_REPLACEITEMOFLIST": "sąrašo %2  %1 vietai priskirti %3",
    "DATA_ITEMOFLIST": "%2 nr. %1",
    "DATA_ITEMNUMOFLIST": "%1 vieta sąraše %2",
    "DATA_LENGTHOFLIST": "%1 ilgis",
    "DATA_LISTCONTAINSITEM": "%1 turi %2?",
    "DATA_SHOWLIST": "rodyti sąrašą %1",
    "DATA_HIDELIST": "slėpti sąrašą %1",
    "DATA_INDEX_ALL": "viskas",
    "DATA_INDEX_LAST": "paskutinis",
    "DATA_INDEX_RANDOM": "atsitiktinis",
    "EVENT_WHENFLAGCLICKED": "kai spusteli %1",
    "EVENT_WHENTHISSPRITECLICKED": "kai spusteli ant šio veikėjo",
    "EVENT_WHENSTAGECLICKED": "kai paspaudi scenoje",
    "EVENT_WHENTOUCHINGOBJECT": "kai paliesi %1",
    "EVENT_WHENBROADCASTRECEIVED": "kai gausi žinutę %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "kai fonas perjungiamas į %1",
    "EVENT_WHENGREATERTHAN": "kai %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "laikmatis",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "garsumas",
    "EVENT_BROADCAST": "skelbti %1",
    "EVENT_BROADCASTANDWAIT": "skelbti %1 ir palaukti",
    "EVENT_WHENKEYPRESSED": "kai paspaudi %1",
    "EVENT_WHENKEYPRESSED_SPACE": "tarpą",
    "EVENT_WHENKEYPRESSED_LEFT": "<--",
    "EVENT_WHENKEYPRESSED_RIGHT": "-->",
    "EVENT_WHENKEYPRESSED_DOWN": "⬇️",
    "EVENT_WHENKEYPRESSED_UP": "⬆️",
    "EVENT_WHENKEYPRESSED_ANY": "bet kurį",
    "LOOKS_SAYFORSECS": "sakyk %1 %2 s.",
    "LOOKS_SAY": "sakyk %1",
    "LOOKS_HELLO": "Sveiki!",
    "LOOKS_THINKFORSECS": "galvok %1 %2 s.",
    "LOOKS_THINK": "galvok %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "rodyk",
    "LOOKS_HIDE": "slėpk",
    "LOOKS_HIDEALLSPRITES": "paslėpti visus veikėjus",
    "LOOKS_EFFECT_COLOR": "spalva",
    "LOOKS_EFFECT_FISHEYE": "lęšis",
    "LOOKS_EFFECT_WHIRL": "susukimas",
    "LOOKS_EFFECT_PIXELATE": "stambinti taškus",
    "LOOKS_EFFECT_MOSAIC": "mozaika",
    "LOOKS_EFFECT_BRIGHTNESS": "šviesumas",
    "LOOKS_EFFECT_GHOST": "permatomumas",
    "LOOKS_CHANGEEFFECTBY": "efektą %1 padidink %2",
    "LOOKS_SETEFFECTTO": "efektas %1 = %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "panaikink išvaizdos efektus",
    "LOOKS_CHANGESIZEBY": "dydį padidink %1 ",
    "LOOKS_SETSIZETO": "dydis = %1 %",
    "LOOKS_SIZE": "dydis",
    "LOOKS_CHANGESTRETCHBY": "ruožą padidink %1",
    "LOOKS_SETSTRETCHTO": "ruožas = %1 %",
    "LOOKS_SWITCHCOSTUMETO": "kaukė = %1",
    "LOOKS_NEXTCOSTUME": "kita kaukė",
    "LOOKS_SWITCHBACKDROPTO": "fonas = %1",
    "LOOKS_GOTOFRONTBACK": "perkelk į %1 sluoksnį",
    "LOOKS_GOTOFRONTBACK_FRONT": "arčiausią",
    "LOOKS_GOTOFRONTBACK_BACK": "tolimiausią",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "perkelti per %2 sluoksnius %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "arčiau",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "toliau",
    "LOOKS_BACKDROPNUMBERNAME": "fonas %1",
    "LOOKS_COSTUMENUMBERNAME": "kaukė %1",
    "LOOKS_NUMBERNAME_NUMBER": "numeris",
    "LOOKS_NUMBERNAME_NAME": "vardas",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "fonas = %1 (palauk, kol pasikeis)",
    "LOOKS_NEXTBACKDROP_BLOCK": "kitas  fonas",
    "LOOKS_NEXTBACKDROP": "kitas  fonas",
    "LOOKS_PREVIOUSBACKDROP": "ankstesnis fonas",
    "LOOKS_RANDOMBACKDROP": "atsitiktinis fonas",
    "MOTION_MOVESTEPS": "eik %1",
    "MOTION_TURNLEFT": "pasisuk %1 %2 laipsnių",
    "MOTION_TURNRIGHT": "pasisuk %1 %2 laipsnių",
    "MOTION_POINTINDIRECTION": "žiūrėk %1 laipsnių kryptimi",
    "MOTION_POINTTOWARDS": "žiūrėk į %1",
    "MOTION_POINTTOWARDS_POINTER": "pelės žymeklį",
    "MOTION_POINTTOWARDS_RANDOM": "atsitiktinę kryptį",
    "MOTION_GOTO": "eik ten, kur %1",
    "MOTION_GOTO_POINTER": "pelės žymeklis",
    "MOTION_GOTO_RANDOM": "atsitiktinė pozicija",
    "MOTION_GOTOXY": "eik į x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "slink į x: %2 y: %3 per %1 s.",
    "MOTION_GLIDETO": "slink ten, kur %2 per %1 s.",
    "MOTION_GLIDETO_POINTER": "pelės žymeklis",
    "MOTION_GLIDETO_RANDOM": "atsitiktinė pozicija",
    "MOTION_CHANGEXBY": "x padidink %1",
    "MOTION_SETX": "x = %1",
    "MOTION_CHANGEYBY": "y padidink %1",
    "MOTION_SETY": "y = %1",
    "MOTION_IFONEDGEBOUNCE": "jei prie krašto, atšok",
    "MOTION_SETROTATIONSTYLE": "sukimosi būdas = %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "kairėn-dešinėn",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "nesisukti",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "visomis kryptimis",
    "MOTION_XPOSITION": "x vieta",
    "MOTION_YPOSITION": "y vieta",
    "MOTION_DIRECTION": "kryptis",
    "MOTION_SCROLLRIGHT": "slinkti dešinėn %1",
    "MOTION_SCROLLUP": "slinkti aukštyn %1",
    "MOTION_ALIGNSCENE": "lygiuoti sceną %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "apačioj kairėj",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "apačioj dešinėj",
    "MOTION_ALIGNSCENE_MIDDLE": "viduryje",
    "MOTION_ALIGNSCENE_TOPLEFT": "kairėj viršuj",
    "MOTION_ALIGNSCENE_TOPRIGHT": "dešinėj viršuj",
    "MOTION_XSCROLL": "x slinktis",
    "MOTION_YSCROLL": "y slinktis",
    "MOTION_STAGE_SELECTED": "Pažymėta scena: jokių judesio blokų",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "atsitiktinis sk. tarp %1 ir %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 ir %2",
    "OPERATORS_OR": "%1 arba %2",
    "OPERATORS_NOT": "ne %1",
    "OPERATORS_JOIN": "sujunk %1 ir %2",
    "OPERATORS_JOIN_APPLE": "obuolys",
    "OPERATORS_JOIN_BANANA": "bananas",
    "OPERATORS_LETTEROF": "%2 raidė nr. %1",
    "OPERATORS_LETTEROF_APPLE": "o",
    "OPERATORS_LENGTH": "%1 ilgis",
    "OPERATORS_CONTAINS": "ar %1 turi %2?",
    "OPERATORS_MOD": "%1 / %2 liekana",
    "OPERATORS_ROUND": "suapvalinta %1",
    "OPERATORS_MATHOP": "%1 ( %2 )",
    "OPERATORS_MATHOP_ABS": "teigiama reikšmė",
    "OPERATORS_MATHOP_FLOOR": "apvalinimas žemyn",
    "OPERATORS_MATHOP_CEILING": "apvalinimas aukštyn",
    "OPERATORS_MATHOP_SQRT": "kvadratinė šaknis",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tg",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctg",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "komanda %1",
    "SENSING_TOUCHINGOBJECT": "lieti %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "pelės žymeklį",
    "SENSING_TOUCHINGOBJECT_EDGE": "kraštą",
    "SENSING_TOUCHINGCOLOR": "lieti spalvą %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "spalva %1 liečia %2?",
    "SENSING_DISTANCETO": "atstumas iki %1",
    "SENSING_DISTANCETO_POINTER": "pelės žymeklio",
    "SENSING_ASKANDWAIT": "paklausk %1 ir lauk",
    "SENSING_ASK_TEXT": "Koks tavo vardas?",
    "SENSING_ANSWER": "atsakas",
    "SENSING_KEYPRESSED": "%1 paspausta?",
    "SENSING_MOUSEDOWN": "pelė paspausta?",
    "SENSING_MOUSEX": "pelės x",
    "SENSING_MOUSEY": "pelės y",
    "SENSING_SETDRAGMODE": "vilkimas pele = %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "velkamas",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "nevelkamas",
    "SENSING_LOUDNESS": "garsumas",
    "SENSING_LOUD": "garsiai?",
    "SENSING_TIMER": "laikmatis",
    "SENSING_RESETTIMER": "laikmatis = 0",
    "SENSING_OF": "%2 : %1",
    "SENSING_OF_XPOSITION": "x koordinatė",
    "SENSING_OF_YPOSITION": "y koordinatė",
    "SENSING_OF_DIRECTION": "kryptis",
    "SENSING_OF_COSTUMENUMBER": "kaukės nr.",
    "SENSING_OF_COSTUMENAME": "kaukės pavadinimas",
    "SENSING_OF_SIZE": "dydis",
    "SENSING_OF_VOLUME": "garsas",
    "SENSING_OF_BACKDROPNUMBER": "fono nr.",
    "SENSING_OF_BACKDROPNAME": "fono pavadinimas",
    "SENSING_OF_STAGE": "Scena",
    "SENSING_CURRENT": "šio momento %1",
    "SENSING_CURRENT_YEAR": "metai",
    "SENSING_CURRENT_MONTH": "mėnuo",
    "SENSING_CURRENT_DATE": "mėn. diena",
    "SENSING_CURRENT_DAYOFWEEK": "savaitės diena",
    "SENSING_CURRENT_HOUR": "valanda",
    "SENSING_CURRENT_MINUTE": "minutė",
    "SENSING_CURRENT_SECOND": "sekundė",
    "SENSING_DAYSSINCE2000": "dienų skaičius nuo 2000-ųjų",
    "SENSING_USERNAME": "vartotojo vardas",
    "SENSING_USERID": "vartotojo ID",
    "SOUND_PLAY": "grok %1",
    "SOUND_PLAYUNTILDONE": "grok %1 kol pasibaigs",
    "SOUND_STOPALLSOUNDS": "išjunk garsus",
    "SOUND_SETEFFECTO": "efektas %1 = %2",
    "SOUND_CHANGEEFFECTBY": "efektą %1 padidink %2",
    "SOUND_CLEAREFFECTS": "pašalink garso efektus",
    "SOUND_EFFECTS_PITCH": "garso aukštis",
    "SOUND_EFFECTS_PAN": "kairiau/dešiniau",
    "SOUND_CHANGEVOLUMEBY": "garsą padidink %1",
    "SOUND_SETVOLUMETO": "garsumas = %1%",
    "SOUND_VOLUME": "garsumas",
    "SOUND_RECORD": "įrašyti garsą...",
    "CATEGORY_MOTION": "Judėjimas",
    "CATEGORY_LOOKS": "Išvaizda",
    "CATEGORY_SOUND": "Garsas",
    "CATEGORY_EVENTS": "Įvykiai",
    "CATEGORY_CONTROL": "Valdymas",
    "CATEGORY_SENSING": "Jutimas",
    "CATEGORY_OPERATORS": "Matematika",
    "CATEGORY_VARIABLES": "Kintamieji",
    "CATEGORY_MYBLOCKS": "Mano Komandos",
    "DUPLICATE": "Kurti kopiją",
    "DELETE": "Ištrinti",
    "ADD_COMMENT": "Pridėti komentarą",
    "REMOVE_COMMENT": "Pašalinti komentarą",
    "DELETE_BLOCK": "Ištrinti bloką",
    "DELETE_X_BLOCKS": "Ištrinti %1 blokus",
    "DELETE_ALL_BLOCKS": "Ištrinti visus %1 blokus?",
    "CLEAN_UP": "Valyti blokus",
    "HELP": "Pagalba",
    "UNDO": "Atšaukti",
    "REDO": "Grąžinti",
    "EDIT_PROCEDURE": "Taisyti",
    "SHOW_PROCEDURE_DEFINITION": "Eiti į apibrėžimą",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Pasakyk ką nors...",
    "COLOUR_HUE_LABEL": "Spalva",
    "COLOUR_SATURATION_LABEL": "Sodrumas",
    "COLOUR_BRIGHTNESS_LABEL": "Šviesumas",
    "CHANGE_VALUE_TITLE": "Pakeisti reikšmę:",
    "RENAME_VARIABLE": "Pervadinti kintamąjį",
    "RENAME_VARIABLE_TITLE": "Pervadinti visus \"%1\" kintamuosius į:",
    "RENAME_VARIABLE_MODAL_TITLE": "Pervadinti kintamąjį",
    "NEW_VARIABLE": "Sukurti kintamąjį",
    "NEW_VARIABLE_TITLE": "Naujo kintamojo vardas:",
    "VARIABLE_MODAL_TITLE": "Naujas kintamasis",
    "VARIABLE_ALREADY_EXISTS": "Kintamasis vardu \"%1\" jau yra.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Vardas \"%1\" jau panaudotas kitam \"%2\" tipo kintamajam.",
    "DELETE_VARIABLE_CONFIRMATION": "Ištrinti %1 atvejus su kintamuoju \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Negalima ištrinti \"%1\", nes jis yra funkcijos \"%2\" aprašymo dalis.",
    "DELETE_VARIABLE": "Ištrinti kintamąjį \"%1\"",
    "NEW_PROCEDURE": "Sukurti bloką",
    "PROCEDURE_ALREADY_EXISTS": "Jau egzistuoja procedūra \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "bloko pavadinimas",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Sukurti sąrašą",
    "NEW_LIST_TITLE": "Naujo sąrašo pavadinimas:",
    "LIST_MODAL_TITLE": "Naujas sąrašas",
    "LIST_ALREADY_EXISTS": "Jau egzistuoja sąrašas pavadintas \"%1\".",
    "RENAME_LIST_TITLE": "Pervadinti visus \"%1\" sąrašus į:",
    "RENAME_LIST_MODAL_TITLE": "Pervadinti sąrašą",
    "DEFAULT_LIST_ITEM": "kažkas",
    "DELETE_LIST": "Ištrinti \"%1\" sąrašą",
    "RENAME_LIST": "Pervadinti sąrašą",
    "NEW_BROADCAST_MESSAGE": "Nauja žinutė",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nauja žinutė pavadinimu:",
    "BROADCAST_MODAL_TITLE": "Nauja žinutė",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "žinutė1"
  },
  "hu": {
    "CONTROL_FOREVER": "mindig",
    "CONTROL_REPEAT": "ismételd %1",
    "CONTROL_IF": "ha %1 akkor",
    "CONTROL_ELSE": "különben",
    "CONTROL_STOP": "álljon le",
    "CONTROL_STOP_ALL": "minden",
    "CONTROL_STOP_THIS": "ez az eljárás",
    "CONTROL_STOP_OTHER": "szereplő többi eljárása",
    "CONTROL_WAIT": "várj %1 mp-et",
    "CONTROL_WAITUNTIL": "várj eddig: %1",
    "CONTROL_REPEATUNTIL": "ismételd eddig: %1",
    "CONTROL_WHILE": "amíg %1",
    "CONTROL_FOREACH": "minden %1 elemet a %2 listában",
    "CONTROL_STARTASCLONE": "másolatként kezdéskor",
    "CONTROL_CREATECLONEOF": "készíts másolatot: %1",
    "CONTROL_CREATECLONEOF_MYSELF": "magadról",
    "CONTROL_DELETETHISCLONE": "töröld ezt a másolatot",
    "CONTROL_COUNTER": "számláló",
    "CONTROL_INCRCOUNTER": "növeld a számlálót",
    "CONTROL_CLEARCOUNTER": "nullázd a számlálót",
    "CONTROL_ALLATONCE": "mindent egyszerre",
    "DATA_SETVARIABLETO": "%1 legyen %2",
    "DATA_CHANGEVARIABLEBY": "%1 változzon %2",
    "DATA_SHOWVARIABLE": "%1 változó jelenjen meg",
    "DATA_HIDEVARIABLE": "%1 változó tűnjön el",
    "DATA_ADDTOLIST": "add %1 elemet %2 listához",
    "DATA_DELETEOFLIST": "töröld %1 elemet %2 listából",
    "DATA_DELETEALLOFLIST": "töröld %1 lista minden elemét",
    "DATA_INSERTATLIST": "szúrd be %1 elemet %2 helyre %3 listában",
    "DATA_REPLACEITEMOFLIST": "cseréld le %1 elemet %2 listában %3 elemre",
    "DATA_ITEMOFLIST": "%2 %1 eleme",
    "DATA_ITEMNUMOFLIST": "%1 sorszáma %2 listában",
    "DATA_LENGTHOFLIST": "%1 hossza",
    "DATA_LISTCONTAINSITEM": "%1 tartalmazza %2?",
    "DATA_SHOWLIST": "%1 lista jelenjen meg",
    "DATA_HIDELIST": "%1 lista tűnjön el",
    "DATA_INDEX_ALL": "minden",
    "DATA_INDEX_LAST": "utolsó",
    "DATA_INDEX_RANDOM": "véletlen",
    "EVENT_WHENFLAGCLICKED": "%1 -ra kattintáskor",
    "EVENT_WHENTHISSPRITECLICKED": "ezen szereplőre kattintáskor",
    "EVENT_WHENSTAGECLICKED": "színpadra kattintáskor",
    "EVENT_WHENTOUCHINGOBJECT": "%1 érintésekor",
    "EVENT_WHENBROADCASTRECEIVED": "%1 üzenet érkezésekor",
    "EVENT_WHENBACKDROPSWITCHESTO": "%1 háttér beállításakor",
    "EVENT_WHENGREATERTHAN": "amikor %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "időmérő",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "hangerő",
    "EVENT_BROADCAST": "küldj üzenetet: %1",
    "EVENT_BROADCASTANDWAIT": "küldj üzenetet: %1 és várj",
    "EVENT_WHENKEYPRESSED": "%1 gomb lenyomásakor",
    "EVENT_WHENKEYPRESSED_SPACE": "szóköz",
    "EVENT_WHENKEYPRESSED_LEFT": "balra nyíl",
    "EVENT_WHENKEYPRESSED_RIGHT": "jobbra nyíl",
    "EVENT_WHENKEYPRESSED_DOWN": "lefelé nyíl",
    "EVENT_WHENKEYPRESSED_UP": "felfelé nyíl",
    "EVENT_WHENKEYPRESSED_ANY": "bármelyik",
    "LOOKS_SAYFORSECS": "mondd: %1 %2 másodpercig",
    "LOOKS_SAY": "mondd: %1",
    "LOOKS_HELLO": "Szia!",
    "LOOKS_THINKFORSECS": "gondold: %1 %2 másodpercig",
    "LOOKS_THINK": "gondold: %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "jelenj meg",
    "LOOKS_HIDE": "tűnj el",
    "LOOKS_HIDEALLSPRITES": "rejtsd el az összes szereplőt",
    "LOOKS_EFFECT_COLOR": "szín",
    "LOOKS_EFFECT_FISHEYE": "halszem",
    "LOOKS_EFFECT_WHIRL": "örvény",
    "LOOKS_EFFECT_PIXELATE": "pixeles",
    "LOOKS_EFFECT_MOSAIC": "mozaik",
    "LOOKS_EFFECT_BRIGHTNESS": "fényerő",
    "LOOKS_EFFECT_GHOST": "szellem",
    "LOOKS_CHANGEEFFECTBY": "%1 hatás változzon %2",
    "LOOKS_SETEFFECTTO": "%1 hatás legyen %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "töröld a grafikus hatásokat",
    "LOOKS_CHANGESIZEBY": "méret változzon %1",
    "LOOKS_SETSIZETO": "méret legyen %1 %",
    "LOOKS_SIZE": "méret",
    "LOOKS_CHANGESTRETCHBY": "nyújtás változzon %1",
    "LOOKS_SETSTRETCHTO": "nyújtás legyen %1",
    "LOOKS_SWITCHCOSTUMETO": "jelmez legyen %1",
    "LOOKS_NEXTCOSTUME": "következő jelmez",
    "LOOKS_SWITCHBACKDROPTO": "háttér legyen %1",
    "LOOKS_GOTOFRONTBACK": "kerülj %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "legelőre",
    "LOOKS_GOTOFRONTBACK_BACK": "leghátra",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "kerülj %1 %2 szintet",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "előre",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "hátra",
    "LOOKS_BACKDROPNUMBERNAME": "háttér %1",
    "LOOKS_COSTUMENUMBERNAME": "jelmez %1",
    "LOOKS_NUMBERNAME_NUMBER": "sorszáma",
    "LOOKS_NUMBERNAME_NAME": "neve",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "háttér legyen %1 és várj",
    "LOOKS_NEXTBACKDROP_BLOCK": "következő háttér",
    "LOOKS_NEXTBACKDROP": "következő háttér",
    "LOOKS_PREVIOUSBACKDROP": "előző háttér",
    "LOOKS_RANDOMBACKDROP": "véletlen háttér",
    "MOTION_MOVESTEPS": "menj %1 lépést",
    "MOTION_TURNLEFT": "fordulj %1 %2 fokot",
    "MOTION_TURNRIGHT": "fordulj %1 %2 fokot",
    "MOTION_POINTINDIRECTION": "nézz %1 fokos irányba",
    "MOTION_POINTTOWARDS": "nézz %1 felé",
    "MOTION_POINTTOWARDS_POINTER": "egérmutató",
    "MOTION_POINTTOWARDS_RANDOM": "véletlen irány",
    "MOTION_GOTO": "ugorj %1 helyére",
    "MOTION_GOTO_POINTER": "egérmutató",
    "MOTION_GOTO_RANDOM": "véletlen hely",
    "MOTION_GOTOXY": "ugorj ide: x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "csússz %1 mp-ig ide: x: %2 y: %3",
    "MOTION_GLIDETO": "csússz %1 mp-ig ide: %2",
    "MOTION_GLIDETO_POINTER": "egérmutató",
    "MOTION_GLIDETO_RANDOM": "véletlen hely",
    "MOTION_CHANGEXBY": "x változzon %1",
    "MOTION_SETX": "x legyen %1",
    "MOTION_CHANGEYBY": "y változzon %1",
    "MOTION_SETY": "y legyen %1",
    "MOTION_IFONEDGEBOUNCE": "ha szélen vagy, pattanj vissza",
    "MOTION_SETROTATIONSTYLE": "jelmez %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "balra-jobbra nézhet",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "nem foroghat",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "foroghat",
    "MOTION_XPOSITION": "x hely",
    "MOTION_YPOSITION": "y hely",
    "MOTION_DIRECTION": "irány",
    "MOTION_SCROLLRIGHT": "görgess jobbra: %1",
    "MOTION_SCROLLUP": "görgess fel: %1",
    "MOTION_ALIGNSCENE": "%1 jelenet igazítása",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "lent balra",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "lent jobbra",
    "MOTION_ALIGNSCENE_MIDDLE": "középen",
    "MOTION_ALIGNSCENE_TOPLEFT": "fent balra",
    "MOTION_ALIGNSCENE_TOPRIGHT": "fent jobbra",
    "MOTION_XSCROLL": "x görgetés",
    "MOTION_YSCROLL": "y görgetés",
    "MOTION_STAGE_SELECTED": "A színpad nem mozgatható",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "véletlen %1 és %2 között",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 és %2",
    "OPERATORS_OR": "%1 vagy %2",
    "OPERATORS_NOT": "nem %1",
    "OPERATORS_JOIN": "%1 %2 együtt",
    "OPERATORS_JOIN_APPLE": "alma",
    "OPERATORS_JOIN_BANANA": "banán",
    "OPERATORS_LETTEROF": "%2 %1 betűje",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "%1 hossza",
    "OPERATORS_CONTAINS": "%1 tartalmazza %2?",
    "OPERATORS_MOD": "%1 / %2 maradéka",
    "OPERATORS_ROUND": "%1 kerekítve",
    "OPERATORS_MATHOP": "%1 %2",
    "OPERATORS_MATHOP_ABS": "abszolut érték",
    "OPERATORS_MATHOP_FLOOR": "lefelé kerekítve",
    "OPERATORS_MATHOP_CEILING": "felfelé kerekítve",
    "OPERATORS_MATHOP_SQRT": "gyök",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tg",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e^",
    "OPERATORS_MATHOP_10EXP": "10^",
    "PROCEDURES_DEFINITION": "%1 meghatározása",
    "SENSING_TOUCHINGOBJECT": "érinted: %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "egérmutató",
    "SENSING_TOUCHINGOBJECT_EDGE": "színpad széle",
    "SENSING_TOUCHINGCOLOR": "érintesz %1 színt?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 érint %2 színt?",
    "SENSING_DISTANCETO": "%1 távolsága",
    "SENSING_DISTANCETO_POINTER": "egérmutató",
    "SENSING_ASKANDWAIT": "kérdezd meg: %1 és várj",
    "SENSING_ASK_TEXT": "Hogy hívnak?",
    "SENSING_ANSWER": "válasz",
    "SENSING_KEYPRESSED": "%1 lenyomva?",
    "SENSING_MOUSEDOWN": "egér lenyomva?",
    "SENSING_MOUSEX": "egér x",
    "SENSING_MOUSEY": "egér y",
    "SENSING_SETDRAGMODE": "húzás módja legyen %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "húzható",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "nem húzható",
    "SENSING_LOUDNESS": "hangerő",
    "SENSING_LOUD": "hangos?",
    "SENSING_TIMER": "időmérő",
    "SENSING_RESETTIMER": "időmérő visszaállítása",
    "SENSING_OF": "%2 %1",
    "SENSING_OF_XPOSITION": "x hely",
    "SENSING_OF_YPOSITION": "y hely",
    "SENSING_OF_DIRECTION": "irány",
    "SENSING_OF_COSTUMENUMBER": "jelmez sorszáma",
    "SENSING_OF_COSTUMENAME": "jelmez neve",
    "SENSING_OF_SIZE": "mérete",
    "SENSING_OF_VOLUME": "hangereje",
    "SENSING_OF_BACKDROPNUMBER": "háttér sorszáma",
    "SENSING_OF_BACKDROPNAME": "háttér neve",
    "SENSING_OF_STAGE": "Színpad",
    "SENSING_CURRENT": "jelenlegi %1",
    "SENSING_CURRENT_YEAR": "év",
    "SENSING_CURRENT_MONTH": "hónap",
    "SENSING_CURRENT_DATE": "nap",
    "SENSING_CURRENT_DAYOFWEEK": "hét napja",
    "SENSING_CURRENT_HOUR": "óra",
    "SENSING_CURRENT_MINUTE": "perc",
    "SENSING_CURRENT_SECOND": "másodperc",
    "SENSING_DAYSSINCE2000": "napok 2000 óta",
    "SENSING_USERNAME": "felhasználó",
    "SENSING_USERID": "felhasználóazonosító",
    "SOUND_PLAY": "indítsd el %1 hangot",
    "SOUND_PLAYUNTILDONE": "játszd végig %1 hangot",
    "SOUND_STOPALLSOUNDS": "minden hang álljon le",
    "SOUND_SETEFFECTO": "%1 hatás legyen %2",
    "SOUND_CHANGEEFFECTBY": "%1 hatás változzon %2",
    "SOUND_CLEAREFFECTS": "hanghatások törlése",
    "SOUND_EFFECTS_PITCH": "hangmagasság",
    "SOUND_EFFECTS_PAN": "pásztázás balra/jobbra",
    "SOUND_CHANGEVOLUMEBY": "hangerő változzon %1",
    "SOUND_SETVOLUMETO": "hangerő legyen %1%",
    "SOUND_VOLUME": "hangerő",
    "SOUND_RECORD": "felvétel...",
    "CATEGORY_MOTION": "Mozgás",
    "CATEGORY_LOOKS": "Kinézet",
    "CATEGORY_SOUND": "Hang",
    "CATEGORY_EVENTS": "Események",
    "CATEGORY_CONTROL": "Vezérlés",
    "CATEGORY_SENSING": "Érzékelés",
    "CATEGORY_OPERATORS": "Műveletek",
    "CATEGORY_VARIABLES": "Változók",
    "CATEGORY_MYBLOCKS": "Blokkjaim",
    "DUPLICATE": "Duplikálás",
    "DELETE": "Törlés",
    "ADD_COMMENT": "Megjegyzés",
    "REMOVE_COMMENT": "Megjegyzés eltávolítása",
    "DELETE_BLOCK": "Blokk törlése",
    "DELETE_X_BLOCKS": "Törölj %1 blokkot",
    "DELETE_ALL_BLOCKS": "Mind a %1 blokk törlése?",
    "CLEAN_UP": "Rendrakás",
    "HELP": "Súgó",
    "UNDO": "Visszavonás",
    "REDO": "Mégis",
    "EDIT_PROCEDURE": "Szerkesztés",
    "SHOW_PROCEDURE_DEFINITION": "Ugorj a meghatározáshoz",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Mondj valamit...",
    "COLOUR_HUE_LABEL": "Szín",
    "COLOUR_SATURATION_LABEL": "Telítettség",
    "COLOUR_BRIGHTNESS_LABEL": "Fényerő",
    "CHANGE_VALUE_TITLE": "Érték változtatása:",
    "RENAME_VARIABLE": "Változó átnevezése",
    "RENAME_VARIABLE_TITLE": "Minden „%1” változó átnevezése erre:",
    "RENAME_VARIABLE_MODAL_TITLE": "Változó átnevezése",
    "NEW_VARIABLE": "Változó létrehozása",
    "NEW_VARIABLE_TITLE": "Új változó neve:",
    "VARIABLE_MODAL_TITLE": "Új változó",
    "VARIABLE_ALREADY_EXISTS": "„%1” nevű változó már létezik.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "„%1” nevű változó már létezik egy másik „%2” típusú változónál",
    "DELETE_VARIABLE_CONFIRMATION": "Törlöd „%2” változót (%1 használat)?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "„%1” változó nem törölhető, mert „%2” függvény leírásának része",
    "DELETE_VARIABLE": "Töröld „%1” változót",
    "NEW_PROCEDURE": "Blokk létrehozása",
    "PROCEDURE_ALREADY_EXISTS": "„%1” nevű blokk már létezik.",
    "PROCEDURE_DEFAULT_NAME": "blokknév",
    "PROCEDURE_USED": "Az egyedi parancs definiáló blokkjának törléséhez előbb távolítsd el a blokk összes használatát a projektben.",
    "NEW_LIST": "Lista létrehozása",
    "NEW_LIST_TITLE": "Új lista neve:",
    "LIST_MODAL_TITLE": "Új lista",
    "LIST_ALREADY_EXISTS": "„%1” nevű lista már létezik.",
    "RENAME_LIST_TITLE": "Nevezd át az összes „%1” listát erre:",
    "RENAME_LIST_MODAL_TITLE": "Lista átnevezése",
    "DEFAULT_LIST_ITEM": "valami",
    "DELETE_LIST": "Töröld „%1” listát",
    "RENAME_LIST": "Lista átnevezése",
    "NEW_BROADCAST_MESSAGE": "Új üzenet",
    "NEW_BROADCAST_MESSAGE_TITLE": "Új üzenet neve:",
    "BROADCAST_MODAL_TITLE": "Új üzenet",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "üzenet1"
  },
  "mi": {
    "CONTROL_FOREVER": "mō ake, ake mahia",
    "CONTROL_REPEAT": "tōaitia %1",
    "CONTROL_IF": "mēnā %1 mahia",
    "CONTROL_ELSE": "kē atu",
    "CONTROL_STOP": "katia",
    "CONTROL_STOP_ALL": "katoa",
    "CONTROL_STOP_THIS": "tēnei hōtuhi",
    "CONTROL_STOP_OTHER": "hōtuhi kē i roto i te parehe",
    "CONTROL_WAIT": "tatari kia %1 hēkona",
    "CONTROL_WAITUNTIL": "tatari kia %1",
    "CONTROL_REPEATUNTIL": "tōaitia tonutia kia %1",
    "CONTROL_WHILE": "tōaitia tonutia mēnā %1",
    "CONTROL_FOREACH": "mō ia %1 o roto i te %2",
    "CONTROL_STARTASCLONE": "ina ka tīmata mai ahau hei tārua",
    "CONTROL_CREATECLONEOF": "whakapūruatia %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ahau anō",
    "CONTROL_DELETETHISCLONE": "mukua tēnei tāruarua",
    "CONTROL_COUNTER": "pūtatau",
    "CONTROL_INCRCOUNTER": "tāpiri tahi ki te pūtatau",
    "CONTROL_CLEARCOUNTER": "ūkui pūtatau",
    "CONTROL_ALLATONCE": "te katoa i te wā kotahi",
    "DATA_SETVARIABLETO": "tautuhia %1 ki te %2",
    "DATA_CHANGEVARIABLEBY": "panonitia %1 mā te %2",
    "DATA_SHOWVARIABLE": "whakaaturia te taurangi %1",
    "DATA_HIDEVARIABLE": "hunaia te taurangi %1",
    "DATA_ADDTOLIST": "tāpiritia te %1 ki te %2",
    "DATA_DELETEOFLIST": "mukua %1 i a %2",
    "DATA_DELETEALLOFLIST": "mukua te katoa o %1",
    "DATA_INSERTATLIST": "whakaurua te %1 hei %2 o %3",
    "DATA_REPLACEITEMOFLIST": "whakakapia te tūemi %1 o %2, ki %3",
    "DATA_ITEMOFLIST": "te tūemi %1 o %2",
    "DATA_ITEMNUMOFLIST": "te tūemi # %1 o %2",
    "DATA_LENGTHOFLIST": "te roanga o te %1",
    "DATA_LISTCONTAINSITEM": "kei roto i %1 te %2?",
    "DATA_SHOWLIST": "whakaaturia te rārangi %1",
    "DATA_HIDELIST": "hunāia te rārangi %1",
    "DATA_INDEX_ALL": "katoa",
    "DATA_INDEX_LAST": "whakamutunga",
    "DATA_INDEX_RANDOM": "matapōkere",
    "EVENT_WHENFLAGCLICKED": "ina pāwhiria te %1",
    "EVENT_WHENTHISSPRITECLICKED": "ina pāwhiria tēnei parehe",
    "EVENT_WHENSTAGECLICKED": "ina pāwhiria te Atamira",
    "EVENT_WHENTOUCHINGOBJECT": "ka pā tēnei parehe i te %1",
    "EVENT_WHENBROADCASTRECEIVED": "ina ka riro mai te %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "ina hurihia te ārai tuarongo kia %1",
    "EVENT_WHENGREATERTHAN": "mēnā %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "taima",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "hoihoi",
    "EVENT_BROADCAST": "whakapaoho %1",
    "EVENT_BROADCASTANDWAIT": "whakapaoho %1, kātahi tatari",
    "EVENT_WHENKEYPRESSED": "ina pēhia te pātuhi %1",
    "EVENT_WHENKEYPRESSED_SPACE": "mokowā",
    "EVENT_WHENKEYPRESSED_LEFT": "pere mauī",
    "EVENT_WHENKEYPRESSED_RIGHT": "pere katau",
    "EVENT_WHENKEYPRESSED_DOWN": "pere whakararo",
    "EVENT_WHENKEYPRESSED_UP": "pere whakarunga",
    "EVENT_WHENKEYPRESSED_ANY": "noa",
    "LOOKS_SAYFORSECS": "kīia %1 mō ngā hēkona %2",
    "LOOKS_SAY": "kīia %1",
    "LOOKS_HELLO": "Kia ora!",
    "LOOKS_THINKFORSECS": "whakaarohia te %1 mō ngā hēkona %2",
    "LOOKS_THINK": "whakaarohia te %1",
    "LOOKS_HMM": "Āa...",
    "LOOKS_SHOW": "whakaatu",
    "LOOKS_HIDE": "huna",
    "LOOKS_HIDEALLSPRITES": "hunaia ngā parehe katoa",
    "LOOKS_EFFECT_COLOR": "tae",
    "LOOKS_EFFECT_FISHEYE": "karu ika",
    "LOOKS_EFFECT_WHIRL": "kōriporipo",
    "LOOKS_EFFECT_PIXELATE": "whakatongitongi",
    "LOOKS_EFFECT_MOSAIC": "toi rōpinepine",
    "LOOKS_EFFECT_BRIGHTNESS": "pīataata",
    "LOOKS_EFFECT_GHOST": "kēhua",
    "LOOKS_CHANGEEFFECTBY": "panonitia te rākeitanga %1 mā te %2",
    "LOOKS_SETEFFECTTO": "panonitia te rākeitanga %1 ki te %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "ūkui rākeitanga whakairoiro",
    "LOOKS_CHANGESIZEBY": "panonitia te rahi mā te %1",
    "LOOKS_SETSIZETO": "tautuhia te rahi kia %1 %",
    "LOOKS_SIZE": "rahi",
    "LOOKS_CHANGESTRETCHBY": "panonitia te toronga mā te %1",
    "LOOKS_SETSTRETCHTO": "tautuhia te toronga kia %1 %",
    "LOOKS_SWITCHCOSTUMETO": "panonitia te kākahu kia %1",
    "LOOKS_NEXTCOSTUME": "kākahu panuku",
    "LOOKS_SWITCHBACKDROPTO": "panonitia te ārai tuarongo kia %1",
    "LOOKS_GOTOFRONTBACK": "haere ki te apa %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "mua",
    "LOOKS_GOTOFRONTBACK_BACK": "muri",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "nekehia %1, kia %2 ngā apaapa",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ki mua",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "ki muri",
    "LOOKS_BACKDROPNUMBERNAME": "ārai tuarongo %1",
    "LOOKS_COSTUMENUMBERNAME": "kākahu %1",
    "LOOKS_NUMBERNAME_NUMBER": "nama",
    "LOOKS_NUMBERNAME_NAME": "ingoa",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "panonitia te ārai tuarongo kia %1, kātahi, tatari",
    "LOOKS_NEXTBACKDROP_BLOCK": "ārai tuarongo panuku",
    "LOOKS_NEXTBACKDROP": "ārai tuarongo panuku",
    "LOOKS_PREVIOUSBACKDROP": "ārai tuarongo o mua",
    "LOOKS_RANDOMBACKDROP": "ārai tuarongo matapōkere",
    "MOTION_MOVESTEPS": "nekehia kia %1 ngā takahanga",
    "MOTION_TURNLEFT": "hurihia %1, kia %2 putu",
    "MOTION_TURNRIGHT": "hurihia %1, kia %2 putu",
    "MOTION_POINTINDIRECTION": "atatohua ki %1",
    "MOTION_POINTTOWARDS": "atatohua ki %1",
    "MOTION_POINTTOWARDS_POINTER": "atatohu-kiore",
    "MOTION_POINTTOWARDS_RANDOM": "ahunga matapōkere",
    "MOTION_GOTO": "neke ki %1",
    "MOTION_GOTO_POINTER": "atatohu-kiore",
    "MOTION_GOTO_RANDOM": "tūnga matapōkere",
    "MOTION_GOTOXY": "neke ki x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "wania kia %1 hēkona ki x: %2 y: %3",
    "MOTION_GLIDETO": "wania kia %1 hēkona ki %2",
    "MOTION_GLIDETO_POINTER": "atatohu-kiore",
    "MOTION_GLIDETO_RANDOM": "tūnga matapōkere",
    "MOTION_CHANGEXBY": "panonitia x mā te %1",
    "MOTION_SETX": "tautuhia te x kia %1",
    "MOTION_CHANGEYBY": "panonitia y mā te %1",
    "MOTION_SETY": "tautuhia te y kia %1",
    "MOTION_IFONEDGEBOUNCE": "mēnā kei te taitapa, tupanatia",
    "MOTION_SETROTATIONSTYLE": "tautuhia te momo huringa kia %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "mauī-ki-katau",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "kaua e takahuri",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "huri noa",
    "MOTION_XPOSITION": "tūnga x",
    "MOTION_YPOSITION": "tūnga y",
    "MOTION_DIRECTION": "ahunga",
    "MOTION_SCROLLRIGHT": "panuku whakatekatau %1",
    "MOTION_SCROLLUP": "panuku whakarunga %1",
    "MOTION_ALIGNSCENE": "tīaro kāpeka %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "taha mauī o raro",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "taha katau o raro",
    "MOTION_ALIGNSCENE_MIDDLE": "waenga",
    "MOTION_ALIGNSCENE_TOPLEFT": "taha mauī o runga",
    "MOTION_ALIGNSCENE_TOPRIGHT": "taha katau o runga",
    "MOTION_XSCROLL": "panuku x",
    "MOTION_YSCROLL": "panuku y",
    "MOTION_STAGE_SELECTED": "Kua tīpakongia te atamira: kāore he paraka nekeneke",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "kōwhiria matapōkere %1 ki te %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 me %2",
    "OPERATORS_OR": "%1, %2 rānei",
    "OPERATORS_NOT": "ehara ko te %1",
    "OPERATORS_JOIN": "tāpiritia te %1, %2",
    "OPERATORS_JOIN_APPLE": "āporo",
    "OPERATORS_JOIN_BANANA": "panana",
    "OPERATORS_LETTEROF": "te pū %1 o te %2",
    "OPERATORS_LETTEROF_APPLE": "ā",
    "OPERATORS_LENGTH": "te roanga o te %1",
    "OPERATORS_CONTAINS": "kei roto i a %1 : %2?",
    "OPERATORS_MOD": "%1 % %2",
    "OPERATORS_ROUND": "whakaawhiwhi %1",
    "OPERATORS_MATHOP": "%1 o te %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "papa",
    "OPERATORS_MATHOP_CEILING": "tuanui",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "tautuhia %1",
    "SENSING_TOUCHINGOBJECT": "kei te pā ki te %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "atatohu-kiore",
    "SENSING_TOUCHINGOBJECT_EDGE": "taitapa",
    "SENSING_TOUCHINGCOLOR": "kei te pā ki te tae %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "ka pā te tae %1 i te %2?",
    "SENSING_DISTANCETO": "tawhiti ki %1",
    "SENSING_DISTANCETO_POINTER": "atatohu-kiore",
    "SENSING_ASKANDWAIT": "pātai %1, kātahi, tatari",
    "SENSING_ASK_TEXT": "Ko wai tō ingoa?",
    "SENSING_ANSWER": "whakautu",
    "SENSING_KEYPRESSED": "kua pēhia te pātuhi %1?",
    "SENSING_MOUSEDOWN": "pāwhiri kiore?",
    "SENSING_MOUSEX": "x kiore",
    "SENSING_MOUSEY": "y kiore",
    "SENSING_SETDRAGMODE": "tautuhia te aratau tō kia %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ka taea te tō",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "kāore e taea te tō",
    "SENSING_LOUDNESS": "hoihoi",
    "SENSING_LOUD": "hoihoi?",
    "SENSING_TIMER": "taima",
    "SENSING_RESETTIMER": "tautuhia anōtia te taima",
    "SENSING_OF": "%1 o %2",
    "SENSING_OF_XPOSITION": "tūnga x",
    "SENSING_OF_YPOSITION": "tūnga y",
    "SENSING_OF_DIRECTION": "ahunga",
    "SENSING_OF_COSTUMENUMBER": "kākahu #",
    "SENSING_OF_COSTUMENAME": "ingoa kākahu",
    "SENSING_OF_SIZE": "rahi",
    "SENSING_OF_VOLUME": "kahaoro",
    "SENSING_OF_BACKDROPNUMBER": "ārai tuarongo #",
    "SENSING_OF_BACKDROPNAME": "ingoa ārai tuarongo",
    "SENSING_OF_STAGE": "Atamira",
    "SENSING_CURRENT": "%1 o nāianei",
    "SENSING_CURRENT_YEAR": "tau",
    "SENSING_CURRENT_MONTH": "marama",
    "SENSING_CURRENT_DATE": "te rā",
    "SENSING_CURRENT_DAYOFWEEK": "te rangi o te wiki",
    "SENSING_CURRENT_HOUR": "haora",
    "SENSING_CURRENT_MINUTE": "miniti",
    "SENSING_CURRENT_SECOND": "hēkona",
    "SENSING_DAYSSINCE2000": "ngā rā mai i 2000",
    "SENSING_USERNAME": "ingoa kaiwhakamahi",
    "SENSING_USERID": "tohu tuakiri",
    "SOUND_PLAY": "tīmatahia te whakatangi i te oro %1",
    "SOUND_PLAYUNTILDONE": "whakatangihia te oro %1 kia mutu rawa",
    "SOUND_STOPALLSOUNDS": "katia ngā oro katoa",
    "SOUND_SETEFFECTO": "tautuhia te rākeitanga %1 kia %2",
    "SOUND_CHANGEEFFECTBY": "panonitia te rākeitanga %1 mā te %2",
    "SOUND_CLEAREFFECTS": "ūkui rākeitanga orotaunaki",
    "SOUND_EFFECTS_PITCH": "hauoro",
    "SOUND_EFFECTS_PAN": "huri whakatemauī/whakatekatau",
    "SOUND_CHANGEVOLUMEBY": "panonitia te kahaoro mā te %1",
    "SOUND_SETVOLUMETO": "tautuhia te kahaoro kia %1%",
    "SOUND_VOLUME": "kahaoro",
    "SOUND_RECORD": "hopukina...",
    "CATEGORY_MOTION": "Nekehanga",
    "CATEGORY_LOOKS": "Āhua",
    "CATEGORY_SOUND": "Oro",
    "CATEGORY_EVENTS": "Takahanga",
    "CATEGORY_CONTROL": "Whakatina",
    "CATEGORY_SENSING": "Paerongo",
    "CATEGORY_OPERATORS": "Tohutūmahi",
    "CATEGORY_VARIABLES": "Ngā Taurangi",
    "CATEGORY_MYBLOCKS": "Aku Paraka",
    "DUPLICATE": "Tāruatia",
    "DELETE": "Mukua",
    "ADD_COMMENT": "Tāpiri Tākupu",
    "REMOVE_COMMENT": "Mukua te Tākupu",
    "DELETE_BLOCK": "Mukua te Paraka",
    "DELETE_X_BLOCKS": "Mukua %1 Paraka",
    "DELETE_ALL_BLOCKS": "Mukua te katoa o ngā paraka e %1 ?",
    "CLEAN_UP": "Whakatikatika i ngā Paraka",
    "HELP": "Āwhina",
    "UNDO": "Wetekia",
    "REDO": "Mahia anōtia",
    "EDIT_PROCEDURE": "Whakatikaina",
    "SHOW_PROCEDURE_DEFINITION": "Haere ki te tautuhinga",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Kīia tētahi mea...",
    "COLOUR_HUE_LABEL": "Tae",
    "COLOUR_SATURATION_LABEL": "Waiwai",
    "COLOUR_BRIGHTNESS_LABEL": "Pīataata",
    "CHANGE_VALUE_TITLE": "Panonitia te uara:",
    "RENAME_VARIABLE": "Tapaina anōtia te taurangi",
    "RENAME_VARIABLE_TITLE": "Tapaina anōtia te katoa o ngā taurangi \"%1\" ki:",
    "RENAME_VARIABLE_MODAL_TITLE": "Tapaina anōtia te Taurangi",
    "NEW_VARIABLE": "Hangaia tētahi taurangi",
    "NEW_VARIABLE_TITLE": "Ingoa taurangi hou:",
    "VARIABLE_MODAL_TITLE": "Taurangi Hou",
    "VARIABLE_ALREADY_EXISTS": "Kua hangaia kētia tētahi taurangi, ko \"%1\" te ingoa.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Kua hangaia kētia tētahi taurangi, ko \"%1\"  te ingoa, engari he momo \"%2\" tērā.",
    "DELETE_VARIABLE_CONFIRMATION": "Mukua hoki %1 ngā mahinga o te taurangi \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Kāore e taea te muku i te taurangi \"%1\", nā te mea he wāhanga taua taurangi o te tautuhinga mō te hātepe \"%2\"",
    "DELETE_VARIABLE": "Mukua te taurangi \"%1\"",
    "NEW_PROCEDURE": "Hangaia tētahi Paraka",
    "PROCEDURE_ALREADY_EXISTS": "Kua hangaia kētia tētahi hātepe ko \"%1\" te ingoa.",
    "PROCEDURE_DEFAULT_NAME": "ingoa paraka",
    "PROCEDURE_USED": "Hei muku i tētahi tautuhinga paraka, tuatahi, mukua ngā mahinga katoa o te paraka.",
    "NEW_LIST": "Hangaia tētahi Rārangi",
    "NEW_LIST_TITLE": "Ingoa rārangi hou:",
    "LIST_MODAL_TITLE": "Rārangi Hou",
    "LIST_ALREADY_EXISTS": "Kua hangaia kētia tētahi rārangi ko \"%1\" te ingoa.",
    "RENAME_LIST_TITLE": "Tapaina anōtia te katoa o ngā rārangi \"%1\" ki:",
    "RENAME_LIST_MODAL_TITLE": "Tapaina te Rārangi",
    "DEFAULT_LIST_ITEM": "mea",
    "DELETE_LIST": "Mukua te rārangi \"%1\"",
    "RENAME_LIST": "Tapaina anōtia te Rārangi",
    "NEW_BROADCAST_MESSAGE": "Karere hou",
    "NEW_BROADCAST_MESSAGE_TITLE": "Ingoa karere hou:",
    "BROADCAST_MODAL_TITLE": "Karere Hou",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "karere1"
  },
  "mn": {
    "CONTROL_FOREVER": "Үргэлж",
    "CONTROL_REPEAT": "%1 удаа давтах",
    "CONTROL_IF": "хэрэв %1 бол",
    "CONTROL_ELSE": "эсвэл",
    "CONTROL_STOP": "зогсоо",
    "CONTROL_STOP_ALL": "бүгд",
    "CONTROL_STOP_THIS": "энэ код",
    "CONTROL_STOP_OTHER": "дүрсний бусад кодууд",
    "CONTROL_WAIT": "%1 секунд хүлээх",
    "CONTROL_WAITUNTIL": "%1 болтол хүлээх",
    "CONTROL_REPEATUNTIL": "%1 болтол давт",
    "CONTROL_WHILE": "%1 хүртэл",
    "CONTROL_FOREACH": "%2-н %1 болгонд ",
    "CONTROL_STARTASCLONE": "Миний хуулбар үүсэх үед",
    "CONTROL_CREATECLONEOF": "%1-н хуулбарыг үүсгэ",
    "CONTROL_CREATECLONEOF_MYSELF": "өөрийн",
    "CONTROL_DELETETHISCLONE": "Энэ хуулбарыг устга",
    "CONTROL_COUNTER": "тоолуур",
    "CONTROL_INCRCOUNTER": "тоолуурыг нэмэгдүүлэх",
    "CONTROL_CLEARCOUNTER": "тоолуурыг тэглэ",
    "CONTROL_ALLATONCE": "бүгдийг нэг дор",
    "DATA_SETVARIABLETO": "%1 хувьсагчийг %2 болго",
    "DATA_CHANGEVARIABLEBY": "%1 хувьсагчийг %2 нэгжээр өөрчил",
    "DATA_SHOWVARIABLE": "%1 хувьсагчийг харуул",
    "DATA_HIDEVARIABLE": "%1 хувьсагчийг нуу",
    "DATA_ADDTOLIST": "%1-г %2 дээр нэм",
    "DATA_DELETEOFLIST": "%2-н %1-г устга",
    "DATA_DELETEALLOFLIST": "%1 жагсаалтын бүгдийг устга",
    "DATA_INSERTATLIST": "%3-н %2-р байранд %1-г оруул",
    "DATA_REPLACEITEMOFLIST": "%2-н %1-г %3 болгож өөрчил",
    "DATA_ITEMOFLIST": "%2 жагсаалтын %1 ",
    "DATA_ITEMNUMOFLIST": "%2 доторх %1-н # хэсэг",
    "DATA_LENGTHOFLIST": "%1 жагсаалтын урт",
    "DATA_LISTCONTAINSITEM": "%1 жагсаалт %2-г агуулж байвал",
    "DATA_SHOWLIST": "%1 жагсаалтыг харуул",
    "DATA_HIDELIST": "%1 жагсаалтыг нуу",
    "DATA_INDEX_ALL": "бүгд",
    "DATA_INDEX_LAST": "сүүлчийн",
    "DATA_INDEX_RANDOM": "санамсаргүй",
    "EVENT_WHENFLAGCLICKED": "%1 дарагдсан үед",
    "EVENT_WHENTHISSPRITECLICKED": "Дүрс дээр дарах үед",
    "EVENT_WHENSTAGECLICKED": "тайз дээр дарах үед",
    "EVENT_WHENTOUCHINGOBJECT": "Энэ дүрс %1-т хүрэх үед",
    "EVENT_WHENBROADCASTRECEIVED": "би %1-г хүлээж авах үед",
    "EVENT_WHENBACKDROPSWITCHESTO": "дэвсгэр %1 болж өөрчлөгдөх үед",
    "EVENT_WHENGREATERTHAN": "%1 > %2 үед",
    "EVENT_WHENGREATERTHAN_TIMER": "хугацаа хэмжигч",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "Дууг чангалбал",
    "EVENT_BROADCAST": "%1-г дамжуулах",
    "EVENT_BROADCASTANDWAIT": "%1-г дамжуулаад хүлээ",
    "EVENT_WHENKEYPRESSED": "товчлуур %1 дарагдах үед",
    "EVENT_WHENKEYPRESSED_SPACE": "спейс товчлуур",
    "EVENT_WHENKEYPRESSED_LEFT": "зүүн сум",
    "EVENT_WHENKEYPRESSED_RIGHT": "баруун сум",
    "EVENT_WHENKEYPRESSED_DOWN": "доош сум",
    "EVENT_WHENKEYPRESSED_UP": "дээш сум",
    "EVENT_WHENKEYPRESSED_ANY": "ямар нэг",
    "LOOKS_SAYFORSECS": "%2 секундийн турш %1-г хэл",
    "LOOKS_SAY": "%1-г хэл",
    "LOOKS_HELLO": "Сайн уу!",
    "LOOKS_THINKFORSECS": "%2 секундийн турш %1-г бод",
    "LOOKS_THINK": "%1-г бод",
    "LOOKS_HMM": "Хмм...",
    "LOOKS_SHOW": "харагд",
    "LOOKS_HIDE": "нуугд",
    "LOOKS_HIDEALLSPRITES": "Бүх дүрсийг нуу",
    "LOOKS_EFFECT_COLOR": "өнгө",
    "LOOKS_EFFECT_FISHEYE": "загасан нүд",
    "LOOKS_EFFECT_WHIRL": "эргүүлгэн",
    "LOOKS_EFFECT_PIXELATE": "пиксел томруулах",
    "LOOKS_EFFECT_MOSAIC": "шигтгэмэл хээн",
    "LOOKS_EFFECT_BRIGHTNESS": "цайруулалт",
    "LOOKS_EFFECT_GHOST": "сүнс",
    "LOOKS_CHANGEEFFECTBY": "%1 нөлөөг %2 нэгжээр өөрчил",
    "LOOKS_SETEFFECTTO": "%1 нөлөөг %2 болго",
    "LOOKS_CLEARGRAPHICEFFECTS": "дүрсэнд оруулсан нөлөөг арилга",
    "LOOKS_CHANGESIZEBY": "хэмжээг %1 нэгжээр өөрчил",
    "LOOKS_SETSIZETO": "хэмжээг %1 болго",
    "LOOKS_SIZE": "хэмжээ",
    "LOOKS_CHANGESTRETCHBY": "суналтыг %1 нэгжээр өөрчил",
    "LOOKS_SETSTRETCHTO": "суналтыг %1 % болго",
    "LOOKS_SWITCHCOSTUMETO": "өмсгөлийг %1 болгож соль",
    "LOOKS_NEXTCOSTUME": "дараах өмсгөл",
    "LOOKS_SWITCHBACKDROPTO": "Дэвсгэрийг %1 болгож өөрчил",
    "LOOKS_GOTOFRONTBACK": "Давхрага %1-рүү оч",
    "LOOKS_GOTOFRONTBACK_FRONT": "Нүүр тал",
    "LOOKS_GOTOFRONTBACK_BACK": "Ар тал",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 давхрага руу оч",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "Урагш",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "Арагш",
    "LOOKS_BACKDROPNUMBERNAME": "Дэвсгэр %1",
    "LOOKS_COSTUMENUMBERNAME": "Өмсгөл %1",
    "LOOKS_NUMBERNAME_NUMBER": "дугаар",
    "LOOKS_NUMBERNAME_NAME": "нэр",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "Дэвсгэр %1 -рүү шилжээд хүлээ",
    "LOOKS_NEXTBACKDROP_BLOCK": "дараах дэвсгэр",
    "LOOKS_NEXTBACKDROP": "дараах дэвсгэр",
    "LOOKS_PREVIOUSBACKDROP": "өмнөх дэвсгэр",
    "LOOKS_RANDOMBACKDROP": "санамсаргүй сонгогдсон дэвсгэр",
    "MOTION_MOVESTEPS": "%1 алхам яв",
    "MOTION_TURNLEFT": "%1 тийш %2 хэм эргэ",
    "MOTION_TURNRIGHT": "%1 тийш %2 хэм эргэ",
    "MOTION_POINTINDIRECTION": "чиглэлийг %1 хэм болго",
    "MOTION_POINTTOWARDS": "чигийг %1 рүү чиглүүл",
    "MOTION_POINTTOWARDS_POINTER": "хулганы заагч",
    "MOTION_POINTTOWARDS_RANDOM": "санамсаргүй сонгосон чиглэл",
    "MOTION_GOTO": "%1-рүү оч",
    "MOTION_GOTO_POINTER": "хулганы заагч",
    "MOTION_GOTO_RANDOM": "санамсаргүй сонгосон байршил",
    "MOTION_GOTOXY": "x: %1 y:%2 цэгт оч",
    "MOTION_GLIDESECSTOXY": "%1 секундэд x: %2 y: %3 цэг рүү гулс",
    "MOTION_GLIDETO": "%1 секундэд %2-руу гулс",
    "MOTION_GLIDETO_POINTER": "хулганы заагч",
    "MOTION_GLIDETO_RANDOM": "санамсаргүй сонгосон байршил",
    "MOTION_CHANGEXBY": "x-г %1 нэгжээр өөрчил",
    "MOTION_SETX": "x-н утгыг %1 болго",
    "MOTION_CHANGEYBY": "y-г %1 нэгжээр өөрчил",
    "MOTION_SETY": "y-н утгыг %1 болго",
    "MOTION_IFONEDGEBOUNCE": "Ирмэгт хүрсэн бол ой",
    "MOTION_SETROTATIONSTYLE": "эргэх хэлбэрийг %1 болго",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "баруун-зүүн",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "эргүүлэхгүй",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "бүх чигт",
    "MOTION_XPOSITION": "x - н утга",
    "MOTION_YPOSITION": "y - н утга",
    "MOTION_DIRECTION": "чиглэл",
    "MOTION_SCROLLRIGHT": "дэлгэцийг %1-р баруун гүйлгэ",
    "MOTION_SCROLLUP": "дэлгэцийг %1-р дээш гүйлгэ",
    "MOTION_ALIGNSCENE": "scene %1-г тэгшлэх",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "зүүн-доод",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "баруун-доод",
    "MOTION_ALIGNSCENE_MIDDLE": "дунд",
    "MOTION_ALIGNSCENE_TOPLEFT": "зүүн-дээд",
    "MOTION_ALIGNSCENE_TOPRIGHT": "баруун-дээд",
    "MOTION_XSCROLL": "x - хуйлралт",
    "MOTION_YSCROLL": "y - хуйлралт",
    "MOTION_STAGE_SELECTED": "Тайзанд хөдлөхүйн блокууд байхгүй",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1-ээс %2 хооронд санамсаргүй сонго",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1  = %2 ",
    "OPERATORS_AND": "%1 ба %2",
    "OPERATORS_OR": "%1 эсвэл %2",
    "OPERATORS_NOT": "%1 биш",
    "OPERATORS_JOIN": "%1-г %2-т залга",
    "OPERATORS_JOIN_APPLE": "алим",
    "OPERATORS_JOIN_BANANA": "гадил",
    "OPERATORS_LETTEROF": "%2-ийн %1-р үсэг",
    "OPERATORS_LETTEROF_APPLE": "а",
    "OPERATORS_LENGTH": "%1-н урт",
    "OPERATORS_CONTAINS": "%1 нь %2-г агуулж байна уу?",
    "OPERATORS_MOD": "%1-г %2-р хуваасны үлдэгдэл",
    "OPERATORS_ROUND": "%1-г тоймло",
    "OPERATORS_MATHOP": "%2-н %1",
    "OPERATORS_MATHOP_ABS": "модуль",
    "OPERATORS_MATHOP_FLOOR": "доош бүхэлд тоймлох",
    "OPERATORS_MATHOP_CEILING": "дээш бүхэлд тоймлох",
    "OPERATORS_MATHOP_SQRT": "квадрат язгуур",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "%1-г зохио",
    "SENSING_TOUCHINGOBJECT": "%1-д хүрсэн үү?",
    "SENSING_TOUCHINGOBJECT_POINTER": "хулганы заагч",
    "SENSING_TOUCHINGOBJECT_EDGE": "ирмэг",
    "SENSING_TOUCHINGCOLOR": "%1 өнгөнд хүрсэн үү?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 өнгө %2-т хүрсэн үү?",
    "SENSING_DISTANCETO": "%1 хүртэлх зай",
    "SENSING_DISTANCETO_POINTER": "хулганы заагч",
    "SENSING_ASKANDWAIT": "%1-ийг асуугаад хүлээ",
    "SENSING_ASK_TEXT": "Чамайг хэн гэдэг вэ?",
    "SENSING_ANSWER": "хариулт",
    "SENSING_KEYPRESSED": "товчлуур %1 дарагдсан",
    "SENSING_MOUSEDOWN": "хулгана дарагдсан",
    "SENSING_MOUSEX": "x-н утга",
    "SENSING_MOUSEY": "y-н утга",
    "SENSING_SETDRAGMODE": "чирэх горимыг %1 болго",
    "SENSING_SETDRAGMODE_DRAGGABLE": "чирэх боломжтой",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "чирэх боломжгүй",
    "SENSING_LOUDNESS": "дууны чанга",
    "SENSING_LOUD": "чанга уу?",
    "SENSING_TIMER": "тоолуур",
    "SENSING_RESETTIMER": "тоолуурыг тэглэ",
    "SENSING_OF": "%2-н %1",
    "SENSING_OF_XPOSITION": "x - н утга",
    "SENSING_OF_YPOSITION": "y - н утга",
    "SENSING_OF_DIRECTION": "чиглэл",
    "SENSING_OF_COSTUMENUMBER": "өмсгөл #",
    "SENSING_OF_COSTUMENAME": "өмсгөлийн нэр",
    "SENSING_OF_SIZE": "хэмжээ",
    "SENSING_OF_VOLUME": "дууны эрч",
    "SENSING_OF_BACKDROPNUMBER": "# дэвсгэр",
    "SENSING_OF_BACKDROPNAME": "дэвсгэрийн нэр",
    "SENSING_OF_STAGE": "Тайз",
    "SENSING_CURRENT": "одоогийн %1",
    "SENSING_CURRENT_YEAR": "жил",
    "SENSING_CURRENT_MONTH": "сар",
    "SENSING_CURRENT_DATE": "огноо",
    "SENSING_CURRENT_DAYOFWEEK": "долоо хоногийн гариг",
    "SENSING_CURRENT_HOUR": "цаг",
    "SENSING_CURRENT_MINUTE": "минут",
    "SENSING_CURRENT_SECOND": "секунд",
    "SENSING_DAYSSINCE2000": "2000 оноос хойших өдрийн тоо",
    "SENSING_USERNAME": "хэрэглэгчийн нэр",
    "SENSING_USERID": "хэрэглэгчийн ID",
    "SOUND_PLAY": "дуу %1-ийг эхлүүл",
    "SOUND_PLAYUNTILDONE": "дуу %1-г дуусах хүртэл нь тоглуул",
    "SOUND_STOPALLSOUNDS": "бүх дууг зогсоо",
    "SOUND_SETEFFECTO": "%1 эффектийг %2 болго",
    "SOUND_CHANGEEFFECTBY": "%1 эффектийг %2 нэгжээр өөрчил",
    "SOUND_CLEAREFFECTS": "дууны нөлөөг арилга",
    "SOUND_EFFECTS_PITCH": "авиа",
    "SOUND_EFFECTS_PAN": "pan зүүн/баруун",
    "SOUND_CHANGEVOLUMEBY": "дууны эрчийг %1 нэгжээр өөрчил",
    "SOUND_SETVOLUMETO": "дууны эрчийг %1% болго",
    "SOUND_VOLUME": "дууны эрч",
    "SOUND_RECORD": "бичлэг...",
    "CATEGORY_MOTION": "Хөдлөхүй",
    "CATEGORY_LOOKS": "Харагдахуй",
    "CATEGORY_SOUND": "Сонсогдохуй",
    "CATEGORY_EVENTS": "Хэзээ",
    "CATEGORY_CONTROL": "Хянахуй",
    "CATEGORY_SENSING": "Мэдрэхүй",
    "CATEGORY_OPERATORS": "Тоолохуй",
    "CATEGORY_VARIABLES": "Хувьсагч",
    "CATEGORY_MYBLOCKS": "Миний блокууд",
    "DUPLICATE": "Хувилах",
    "DELETE": "Устгах",
    "ADD_COMMENT": "Тайлбар нэмэх",
    "REMOVE_COMMENT": "Тайлбар устгах",
    "DELETE_BLOCK": "Блок устгах",
    "DELETE_X_BLOCKS": "%1 блокуудыг устгах",
    "DELETE_ALL_BLOCKS": "%1 блокуудыг бүгдийг устгах уу?",
    "CLEAN_UP": "Блокуудыг цэгцлэх",
    "HELP": "Тусламж",
    "UNDO": "Үйлдийг буцаах",
    "REDO": "Буцаасан үйлдлийг сэргээх",
    "EDIT_PROCEDURE": "Засварлах",
    "SHOW_PROCEDURE_DEFINITION": "Тодорхойлолт руу очих",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Ямар нэг юм хэлэх...",
    "COLOUR_HUE_LABEL": "Өнгө",
    "COLOUR_SATURATION_LABEL": "Тунгалагшилт",
    "COLOUR_BRIGHTNESS_LABEL": "Цайруулалт",
    "CHANGE_VALUE_TITLE": "Утгыг өөрчлөх: ",
    "RENAME_VARIABLE": "Хувьсагчийн нэр солих",
    "RENAME_VARIABLE_TITLE": "Бүх \"%1\" хувьсагчийн нэрийг солих:",
    "RENAME_VARIABLE_MODAL_TITLE": "Хувьсагчийн нэр солих",
    "NEW_VARIABLE": "Хувьсагч үүсгэх",
    "NEW_VARIABLE_TITLE": "Шинэ хувьсагчийн нэр:",
    "VARIABLE_MODAL_TITLE": "Шинэ хувьсагч",
    "VARIABLE_ALREADY_EXISTS": "Хувьсагчийн \"%1\" нэр давхцаж байна.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Хувьсагчийн \"%1\" нэр нь \"%2\" төрлийн өөр хувьсагчийн нэртэй давхцаж байна.",
    "DELETE_VARIABLE_CONFIRMATION": "\"%2\" хувьсагчийн %1 хэрэглээг устгах уу?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Хувьсагч \"%1\" нь \"%2\" функцэд ашиглагдаж байгаа тул устгах боломжгүй",
    "DELETE_VARIABLE": "Хувьсагч \"%1\"-г устга",
    "NEW_PROCEDURE": "Блок үүсгэх",
    "PROCEDURE_ALREADY_EXISTS": "\"%1\" нэртэй үйл ажиллагаа аль хэдийн оршиж байна. ",
    "PROCEDURE_DEFAULT_NAME": "блокийн нэр",
    "PROCEDURE_USED": "Блокыг устгах бол эхлээд бүх ашигласан газраасаа арилгана уу",
    "NEW_LIST": "Жагсаалт үүсгэх",
    "NEW_LIST_TITLE": "Шинэ жагсаалтын нэр:",
    "LIST_MODAL_TITLE": "Шинэ жагсаалт",
    "LIST_ALREADY_EXISTS": "\"%1\" нэртэй жагсаалт аль хэдийн оршиж байна.",
    "RENAME_LIST_TITLE": "Бүх \"%1\" жагсаалтын нэрийг өөрчлөх:",
    "RENAME_LIST_MODAL_TITLE": "Жагсаалтын нэрийг өөрчлөх",
    "DEFAULT_LIST_ITEM": "зүйл",
    "DELETE_LIST": "\"%1\" жагсаалтыг устгах",
    "RENAME_LIST": "Жагсаалтын нэрийг өөрчлөх",
    "NEW_BROADCAST_MESSAGE": "Шинэ мэссэж",
    "NEW_BROADCAST_MESSAGE_TITLE": "Шинэ мэссэжийн нэр:",
    "BROADCAST_MODAL_TITLE": "Шинэ мэссэж",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "мэссэж1"
  },
  "nl": {
    "CONTROL_FOREVER": "herhaal",
    "CONTROL_REPEAT": "herhaal %1",
    "CONTROL_IF": "als %1 dan",
    "CONTROL_ELSE": "anders",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "alle",
    "CONTROL_STOP_THIS": "dit script",
    "CONTROL_STOP_OTHER": "andere scripts in sprite",
    "CONTROL_WAIT": "wacht %1 sec.",
    "CONTROL_WAITUNTIL": "wacht tot %1",
    "CONTROL_REPEATUNTIL": "herhaal tot %1",
    "CONTROL_WHILE": "zolang %1",
    "CONTROL_FOREACH": "voor elke %1 in %2",
    "CONTROL_STARTASCLONE": "wanneer ik als kloon start",
    "CONTROL_CREATECLONEOF": "maak een kloon van %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mijzelf",
    "CONTROL_DELETETHISCLONE": "verwijder deze kloon",
    "CONTROL_COUNTER": "teller",
    "CONTROL_INCRCOUNTER": "verhoog teller",
    "CONTROL_CLEARCOUNTER": "zet teller op 0",
    "CONTROL_ALLATONCE": "alles in een keer",
    "DATA_SETVARIABLETO": "maak %1 %2",
    "DATA_CHANGEVARIABLEBY": "verander %1 met %2",
    "DATA_SHOWVARIABLE": "toon variabele %1",
    "DATA_HIDEVARIABLE": "verberg variabele %1",
    "DATA_ADDTOLIST": "voeg %1 toe aan %2",
    "DATA_DELETEOFLIST": "verwijder %1 van %2",
    "DATA_DELETEALLOFLIST": "verwijder alle van %1",
    "DATA_INSERTATLIST": "voeg %1 toe op %2 van %3",
    "DATA_REPLACEITEMOFLIST": "vervang item %1 van %2 door %3",
    "DATA_ITEMOFLIST": "item %1 van %2",
    "DATA_ITEMNUMOFLIST": "item # van %1 in %2",
    "DATA_LENGTHOFLIST": "lengte van %1",
    "DATA_LISTCONTAINSITEM": "%1 bevat %2?",
    "DATA_SHOWLIST": "toon lijst %1",
    "DATA_HIDELIST": "verberg lijst %1",
    "DATA_INDEX_ALL": "alle",
    "DATA_INDEX_LAST": "laatste",
    "DATA_INDEX_RANDOM": "willekeurig",
    "EVENT_WHENFLAGCLICKED": "wanneer op %1 wordt geklikt",
    "EVENT_WHENTHISSPRITECLICKED": "wanneer op deze sprite wordt geklikt",
    "EVENT_WHENSTAGECLICKED": "wanneer op het speelveld wordt geklikt",
    "EVENT_WHENTOUCHINGOBJECT": "wanneer deze sprite %1 raakt",
    "EVENT_WHENBROADCASTRECEIVED": "wanneer ik signaal %1 ontvang",
    "EVENT_WHENBACKDROPSWITCHESTO": "wanneer achtergrond verandert naar %1",
    "EVENT_WHENGREATERTHAN": "wanneer %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "klok",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "volume",
    "EVENT_BROADCAST": "zend signaal %1",
    "EVENT_BROADCASTANDWAIT": "zend signaal %1 en wacht",
    "EVENT_WHENKEYPRESSED": "wanneer %1 is ingedrukt",
    "EVENT_WHENKEYPRESSED_SPACE": "spatiebalk",
    "EVENT_WHENKEYPRESSED_LEFT": "pijltje links",
    "EVENT_WHENKEYPRESSED_RIGHT": "pijltje rechts",
    "EVENT_WHENKEYPRESSED_DOWN": "pijltje omlaag",
    "EVENT_WHENKEYPRESSED_UP": "pijltje omhoog",
    "EVENT_WHENKEYPRESSED_ANY": "willekeurig",
    "LOOKS_SAYFORSECS": "zeg %1 %2 sec.",
    "LOOKS_SAY": "zeg %1",
    "LOOKS_HELLO": "Hallo!",
    "LOOKS_THINKFORSECS": "denk %1 %2 sec.",
    "LOOKS_THINK": "denk %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "verschijn",
    "LOOKS_HIDE": "verdwijn",
    "LOOKS_HIDEALLSPRITES": "verberg alle sprites",
    "LOOKS_EFFECT_COLOR": "kleur",
    "LOOKS_EFFECT_FISHEYE": "vissenoog",
    "LOOKS_EFFECT_WHIRL": "draaikolk",
    "LOOKS_EFFECT_PIXELATE": "pixeleren",
    "LOOKS_EFFECT_MOSAIC": "mozaïek",
    "LOOKS_EFFECT_BRIGHTNESS": "helderheid",
    "LOOKS_EFFECT_GHOST": "transparant",
    "LOOKS_CHANGEEFFECTBY": "verander %1 effect met %2",
    "LOOKS_SETEFFECTTO": "zet %1 effect op %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "zet alle effecten uit",
    "LOOKS_CHANGESIZEBY": "verander grootte met %1",
    "LOOKS_SETSIZETO": "maak grootte %1 %",
    "LOOKS_SIZE": "grootte",
    "LOOKS_CHANGESTRETCHBY": "verander stretch met %1",
    "LOOKS_SETSTRETCHTO": "maak stretch %1 %",
    "LOOKS_SWITCHCOSTUMETO": "verander uiterlijk naar %1",
    "LOOKS_NEXTCOSTUME": "volgend uiterlijk",
    "LOOKS_SWITCHBACKDROPTO": "verander achtergrond naar %1",
    "LOOKS_GOTOFRONTBACK": "ga naar laag %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "voorgrond",
    "LOOKS_GOTOFRONTBACK_BACK": "achtergrond",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ga %1 %2 lagen",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "naar voren",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "naar achteren",
    "LOOKS_BACKDROPNUMBERNAME": "achtergrond %1",
    "LOOKS_COSTUMENUMBERNAME": "uiterlijk %1",
    "LOOKS_NUMBERNAME_NUMBER": "nummer",
    "LOOKS_NUMBERNAME_NAME": "naam",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "verander achtergrond naar %1 en wacht",
    "LOOKS_NEXTBACKDROP_BLOCK": "volgende achtergrond",
    "LOOKS_NEXTBACKDROP": "volgende achtergrond",
    "LOOKS_PREVIOUSBACKDROP": "vorige achtergrond",
    "LOOKS_RANDOMBACKDROP": "willekeurige achtergrond",
    "MOTION_MOVESTEPS": "neem %1 stappen",
    "MOTION_TURNLEFT": "draai %1 %2 graden",
    "MOTION_TURNRIGHT": "draai %1 %2 graden",
    "MOTION_POINTINDIRECTION": "richt naar %1 graden",
    "MOTION_POINTTOWARDS": "richt naar %1",
    "MOTION_POINTTOWARDS_POINTER": "muisaanwijzer",
    "MOTION_POINTTOWARDS_RANDOM": "willekeurige richting",
    "MOTION_GOTO": "ga naar %1",
    "MOTION_GOTO_POINTER": "muisaanwijzer",
    "MOTION_GOTO_RANDOM": "willekeurige positie",
    "MOTION_GOTOXY": "ga naar x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "schuif in %1 sec. naar x: %2 y: %3",
    "MOTION_GLIDETO": "schuif in %1 sec. naar %2",
    "MOTION_GLIDETO_POINTER": "muisaanwijzer",
    "MOTION_GLIDETO_RANDOM": "willekeurige positie",
    "MOTION_CHANGEXBY": "verander x met %1",
    "MOTION_SETX": "maak x %1",
    "MOTION_CHANGEYBY": "verander y met %1",
    "MOTION_SETY": "maak y %1",
    "MOTION_IFONEDGEBOUNCE": "keer om aan de rand",
    "MOTION_SETROTATIONSTYLE": "maak draaistijl %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "links-rechts",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "niet draaien",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "helemaal rond",
    "MOTION_XPOSITION": "x-positie",
    "MOTION_YPOSITION": "y-positie",
    "MOTION_DIRECTION": "richting",
    "MOTION_SCROLLRIGHT": "rechts scrollen %1",
    "MOTION_SCROLLUP": "omhoog scrollen %1",
    "MOTION_ALIGNSCENE": "scène uitlijnen %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "linksonder",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "rechtsonder",
    "MOTION_ALIGNSCENE_MIDDLE": "midden",
    "MOTION_ALIGNSCENE_TOPLEFT": "linksboven",
    "MOTION_ALIGNSCENE_TOPRIGHT": "rechtsboven",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "Speelveld geselecteerd: geen bewegingsblokken",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "willekeurig getal tussen %1 en %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 en %2",
    "OPERATORS_OR": "%1 of %2",
    "OPERATORS_NOT": "niet %1",
    "OPERATORS_JOIN": "voeg %1 en %2 samen",
    "OPERATORS_JOIN_APPLE": "appel",
    "OPERATORS_JOIN_BANANA": "banaan",
    "OPERATORS_LETTEROF": "letter %1 van %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "lengte van %1",
    "OPERATORS_CONTAINS": "%1 bevat %2?",
    "OPERATORS_MOD": "%1 modulo %2",
    "OPERATORS_ROUND": "afgerond %1",
    "OPERATORS_MATHOP": "%1 van %2",
    "OPERATORS_MATHOP_ABS": "absoluut",
    "OPERATORS_MATHOP_FLOOR": "beneden",
    "OPERATORS_MATHOP_CEILING": "boven",
    "OPERATORS_MATHOP_SQRT": "wortel",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definieer %1",
    "SENSING_TOUCHINGOBJECT": "raak ik %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "muisaanwijzer",
    "SENSING_TOUCHINGOBJECT_EDGE": "rand",
    "SENSING_TOUCHINGCOLOR": "raak ik kleur %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "raakt kleur %1 kleur %2?",
    "SENSING_DISTANCETO": "afstand tot %1",
    "SENSING_DISTANCETO_POINTER": "muisaanwijzer",
    "SENSING_ASKANDWAIT": "vraag %1 en wacht",
    "SENSING_ASK_TEXT": "Hoe heet je?",
    "SENSING_ANSWER": "antwoord",
    "SENSING_KEYPRESSED": "toets %1 ingedrukt?",
    "SENSING_MOUSEDOWN": "muis ingedrukt?",
    "SENSING_MOUSEX": "muis x",
    "SENSING_MOUSEY": "muis y",
    "SENSING_SETDRAGMODE": "zet sleepbaar op %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "sleepbaar",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "niet sleepbaar",
    "SENSING_LOUDNESS": "volume",
    "SENSING_LOUD": "luid?",
    "SENSING_TIMER": "klok",
    "SENSING_RESETTIMER": "zet klok op 0",
    "SENSING_OF": "%1 van %2",
    "SENSING_OF_XPOSITION": "x-positie",
    "SENSING_OF_YPOSITION": "y-positie",
    "SENSING_OF_DIRECTION": "richting",
    "SENSING_OF_COSTUMENUMBER": "uiterlijk #",
    "SENSING_OF_COSTUMENAME": "naam uiterlijk",
    "SENSING_OF_SIZE": "grootte",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "achtergrond #",
    "SENSING_OF_BACKDROPNAME": "achtergrond naam",
    "SENSING_OF_STAGE": "Speelveld",
    "SENSING_CURRENT": "huidige %1",
    "SENSING_CURRENT_YEAR": "jaar",
    "SENSING_CURRENT_MONTH": "maand",
    "SENSING_CURRENT_DATE": "datum",
    "SENSING_CURRENT_DAYOFWEEK": "dag van de week",
    "SENSING_CURRENT_HOUR": "uur",
    "SENSING_CURRENT_MINUTE": "minuut",
    "SENSING_CURRENT_SECOND": "seconde",
    "SENSING_DAYSSINCE2000": "dagen sinds 2000",
    "SENSING_USERNAME": "gebruikersnaam",
    "SENSING_USERID": "gebruiker id",
    "SOUND_PLAY": "start geluid %1",
    "SOUND_PLAYUNTILDONE": "start geluid %1 en wacht",
    "SOUND_STOPALLSOUNDS": "stop alle geluiden",
    "SOUND_SETEFFECTO": "zet effect %1 op %2",
    "SOUND_CHANGEEFFECTBY": "verander %1-effect met %2",
    "SOUND_CLEAREFFECTS": "zet alle effecten uit",
    "SOUND_EFFECTS_PITCH": "toonhoogte",
    "SOUND_EFFECTS_PAN": "kanaal links/rechts",
    "SOUND_CHANGEVOLUMEBY": "verander volume met %1",
    "SOUND_SETVOLUMETO": "zet volume op %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "opnemen...",
    "CATEGORY_MOTION": "Beweging",
    "CATEGORY_LOOKS": "Uiterlijken",
    "CATEGORY_SOUND": "Geluid",
    "CATEGORY_EVENTS": "Gebeurtenissen",
    "CATEGORY_CONTROL": "Besturen",
    "CATEGORY_SENSING": "Waarnemen",
    "CATEGORY_OPERATORS": "Functies",
    "CATEGORY_VARIABLES": "Variabelen",
    "CATEGORY_MYBLOCKS": "Mijn blokken",
    "DUPLICATE": "Kopie maken",
    "DELETE": "Verwijderen",
    "ADD_COMMENT": "Commentaar toevoegen",
    "REMOVE_COMMENT": "Commentaar verwijderen",
    "DELETE_BLOCK": "Blok verwijderen",
    "DELETE_X_BLOCKS": "Verwijder %1 blokken",
    "DELETE_ALL_BLOCKS": "Verwijder alle %1 blokken?",
    "CLEAN_UP": "Blokken opruimen",
    "HELP": "Help",
    "UNDO": "Ongedaan maken",
    "REDO": "Opnieuw",
    "EDIT_PROCEDURE": "Bewerk",
    "SHOW_PROCEDURE_DEFINITION": "Ga naar definitie",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Zeg iets...",
    "COLOUR_HUE_LABEL": "Kleur",
    "COLOUR_SATURATION_LABEL": "Verzadiging",
    "COLOUR_BRIGHTNESS_LABEL": "Helderheid",
    "CHANGE_VALUE_TITLE": "Verander waarde:",
    "RENAME_VARIABLE": "Variabele hernoemen",
    "RENAME_VARIABLE_TITLE": "Hernoem alle '%1' variabelen naar:",
    "RENAME_VARIABLE_MODAL_TITLE": "Variabele hernoemen",
    "NEW_VARIABLE": "Maak een variabele",
    "NEW_VARIABLE_TITLE": "Nieuwe variabelenaam:",
    "VARIABLE_MODAL_TITLE": "Nieuwe variabele",
    "VARIABLE_ALREADY_EXISTS": "Er bestaat al een variabele met de naam '%1'.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Er bestaat al een variabele met de naam '%1' voor een andere variabele van het type '%2'",
    "DELETE_VARIABLE_CONFIRMATION": "Verwijder de %1 toepassingen van de variabele '%2'?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Kan de variabele '%1' niet verwijderen, omdat die deel uitmaakt van de definitie van de functie '%2'",
    "DELETE_VARIABLE": "Verwijder de variabele '%1'",
    "NEW_PROCEDURE": "Maak een blok",
    "PROCEDURE_ALREADY_EXISTS": "Er bestaat al een procedure met de naam '%1'.",
    "PROCEDURE_DEFAULT_NAME": "bloknaam",
    "PROCEDURE_USED": "Om een blokdefinitie te verwijderen, moet je eerst zorgen dat het nergens meer wordt gebruikt.",
    "NEW_LIST": "Maak een lijst",
    "NEW_LIST_TITLE": "Nieuwe lijstnaam:",
    "LIST_MODAL_TITLE": "Nieuwe lijst",
    "LIST_ALREADY_EXISTS": "Er bestaat al een lijst met de naam '%1'.",
    "RENAME_LIST_TITLE": "Hernoem alle '%1' lijsten naar:",
    "RENAME_LIST_MODAL_TITLE": "Lijst hernoemen",
    "DEFAULT_LIST_ITEM": "ding",
    "DELETE_LIST": "Verwijder de \"%1\" lijst",
    "RENAME_LIST": "Hernoem lijst",
    "NEW_BROADCAST_MESSAGE": "Nieuw bericht",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nieuwe berichtnaam:",
    "BROADCAST_MODAL_TITLE": "Nieuw bericht",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "bericht1"
  },
  "ja": {
    "CONTROL_FOREVER": "ずっと",
    "CONTROL_REPEAT": "%1 回繰り返す",
    "CONTROL_IF": "もし %1 なら",
    "CONTROL_ELSE": "でなければ",
    "CONTROL_STOP": "　",
    "CONTROL_STOP_ALL": "すべてを止める",
    "CONTROL_STOP_THIS": "このスクリプトを止める",
    "CONTROL_STOP_OTHER": "スプライトの他のスクリプトを止める",
    "CONTROL_WAIT": "%1 秒待つ",
    "CONTROL_WAITUNTIL": "%1 まで待つ",
    "CONTROL_REPEATUNTIL": "%1 まで繰り返す",
    "CONTROL_WHILE": "%1 の間繰り返す",
    "CONTROL_FOREACH": "%2 の要素を %1 に入れて繰り返す",
    "CONTROL_STARTASCLONE": "クローンされたとき",
    "CONTROL_CREATECLONEOF": "%1 のクローンを作る",
    "CONTROL_CREATECLONEOF_MYSELF": "自分自身",
    "CONTROL_DELETETHISCLONE": "このクローンを削除する",
    "CONTROL_COUNTER": "カウンター",
    "CONTROL_INCRCOUNTER": "カウンターに足す",
    "CONTROL_CLEARCOUNTER": "カウンターをクリアする",
    "CONTROL_ALLATONCE": "一斉に",
    "DATA_SETVARIABLETO": "%1 を %2 にする",
    "DATA_CHANGEVARIABLEBY": "%1 を %2 ずつ変える",
    "DATA_SHOWVARIABLE": "変数 %1 を表示する",
    "DATA_HIDEVARIABLE": "変数 %1 を隠す",
    "DATA_ADDTOLIST": "%1 を %2 に追加する",
    "DATA_DELETEOFLIST": "%2 の %1 番目を削除する",
    "DATA_DELETEALLOFLIST": "%1のすべてを削除する",
    "DATA_INSERTATLIST": "%3 の %2 番目に %1 を挿入する",
    "DATA_REPLACEITEMOFLIST": "%2 の %1 番目を %3 で置き換える",
    "DATA_ITEMOFLIST": "%2 の %1 番目",
    "DATA_ITEMNUMOFLIST": "%2中の%1の場所",
    "DATA_LENGTHOFLIST": "%1 の長さ",
    "DATA_LISTCONTAINSITEM": "%1 に %2 が含まれる",
    "DATA_SHOWLIST": "リスト %1 を表示する",
    "DATA_HIDELIST": "リスト %1 を隠す",
    "DATA_INDEX_ALL": "すべて",
    "DATA_INDEX_LAST": "最後",
    "DATA_INDEX_RANDOM": "乱数",
    "EVENT_WHENFLAGCLICKED": "%1 が押されたとき",
    "EVENT_WHENTHISSPRITECLICKED": "このスプライトが押されたとき",
    "EVENT_WHENSTAGECLICKED": "ステージが押されたとき",
    "EVENT_WHENTOUCHINGOBJECT": "このスプライトが %1 に触れたとき",
    "EVENT_WHENBROADCASTRECEIVED": "%1 を受け取ったとき",
    "EVENT_WHENBACKDROPSWITCHESTO": "背景が %1 になったとき",
    "EVENT_WHENGREATERTHAN": "%1 > %2 のとき",
    "EVENT_WHENGREATERTHAN_TIMER": "タイマー",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "音量",
    "EVENT_BROADCAST": "%1 を送る",
    "EVENT_BROADCASTANDWAIT": "%1 を送って待つ",
    "EVENT_WHENKEYPRESSED": "%1 キーが押されたとき",
    "EVENT_WHENKEYPRESSED_SPACE": "スペース",
    "EVENT_WHENKEYPRESSED_LEFT": "左向き矢印",
    "EVENT_WHENKEYPRESSED_RIGHT": "右向き矢印",
    "EVENT_WHENKEYPRESSED_DOWN": "下向き矢印",
    "EVENT_WHENKEYPRESSED_UP": "上向き矢印",
    "EVENT_WHENKEYPRESSED_ANY": "どれかの",
    "LOOKS_SAYFORSECS": "%1 と %2 秒言う",
    "LOOKS_SAY": "%1 と言う",
    "LOOKS_HELLO": "こんにちは!",
    "LOOKS_THINKFORSECS": "%1 と %2 秒考える",
    "LOOKS_THINK": "%1 と考える",
    "LOOKS_HMM": "うーん...",
    "LOOKS_SHOW": "表示する",
    "LOOKS_HIDE": "隠す",
    "LOOKS_HIDEALLSPRITES": "すべてのスプライトを隠す",
    "LOOKS_EFFECT_COLOR": "色",
    "LOOKS_EFFECT_FISHEYE": "魚眼レンズ",
    "LOOKS_EFFECT_WHIRL": "渦巻き",
    "LOOKS_EFFECT_PIXELATE": "ピクセル化",
    "LOOKS_EFFECT_MOSAIC": "モザイク",
    "LOOKS_EFFECT_BRIGHTNESS": "明るさ",
    "LOOKS_EFFECT_GHOST": "幽霊",
    "LOOKS_CHANGEEFFECTBY": "%1 の効果を %2 ずつ変える",
    "LOOKS_SETEFFECTTO": "%1 の効果を %2 にする",
    "LOOKS_CLEARGRAPHICEFFECTS": "画像効果をなくす",
    "LOOKS_CHANGESIZEBY": "大きさを %1 ずつ変える",
    "LOOKS_SETSIZETO": "大きさを %1 %にする",
    "LOOKS_SIZE": "大きさ",
    "LOOKS_CHANGESTRETCHBY": "伸びを %1 ずつ変える",
    "LOOKS_SETSTRETCHTO": "伸びを %1 %にする",
    "LOOKS_SWITCHCOSTUMETO": "コスチュームを %1 にする",
    "LOOKS_NEXTCOSTUME": "次のコスチュームにする",
    "LOOKS_SWITCHBACKDROPTO": "背景を %1 にする",
    "LOOKS_GOTOFRONTBACK": "%1 へ移動する",
    "LOOKS_GOTOFRONTBACK_FRONT": "最前面",
    "LOOKS_GOTOFRONTBACK_BACK": "最背面",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%2 層 %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "手前に出す",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "奥に下げる",
    "LOOKS_BACKDROPNUMBERNAME": "背景の %1",
    "LOOKS_COSTUMENUMBERNAME": "コスチュームの %1",
    "LOOKS_NUMBERNAME_NUMBER": "番号",
    "LOOKS_NUMBERNAME_NAME": "名前",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "背景を %1 にして待つ",
    "LOOKS_NEXTBACKDROP_BLOCK": "次の背景にする",
    "LOOKS_NEXTBACKDROP": "次の背景",
    "LOOKS_PREVIOUSBACKDROP": "前の背景",
    "LOOKS_RANDOMBACKDROP": "どれかの背景",
    "MOTION_MOVESTEPS": "%1 歩動かす",
    "MOTION_TURNLEFT": "%1 %2 度回す",
    "MOTION_TURNRIGHT": "%1 %2 度回す",
    "MOTION_POINTINDIRECTION": "%1 度に向ける",
    "MOTION_POINTTOWARDS": "%1 へ向ける",
    "MOTION_POINTTOWARDS_POINTER": "マウスのポインター",
    "MOTION_POINTTOWARDS_RANDOM": "どれかの向き",
    "MOTION_GOTO": "%1 へ行く",
    "MOTION_GOTO_POINTER": "マウスのポインター",
    "MOTION_GOTO_RANDOM": "どこかの場所",
    "MOTION_GOTOXY": "x座標を %1 、y座標を %2 にする",
    "MOTION_GLIDESECSTOXY": "%1 秒でx座標を %2 に、y座標を %3 に変える",
    "MOTION_GLIDETO": "%1 秒で %2 へ行く",
    "MOTION_GLIDETO_POINTER": "マウスのポインター",
    "MOTION_GLIDETO_RANDOM": "どこかの場所",
    "MOTION_CHANGEXBY": "x座標を %1 ずつ変える",
    "MOTION_SETX": "x座標を %1 にする",
    "MOTION_CHANGEYBY": "y座標を %1 ずつ変える",
    "MOTION_SETY": "y座標を %1 にする",
    "MOTION_IFONEDGEBOUNCE": "もし端に着いたら、跳ね返る",
    "MOTION_SETROTATIONSTYLE": "回転方法を %1 にする",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "左右のみ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "回転しない",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "自由に回転",
    "MOTION_XPOSITION": "x座標",
    "MOTION_YPOSITION": "y座標",
    "MOTION_DIRECTION": "向き",
    "MOTION_SCROLLRIGHT": "右に %1 スクロールする",
    "MOTION_SCROLLUP": "上に %1 スクロールする",
    "MOTION_ALIGNSCENE": "スクロール位置を %1 にする",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "左下",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "右下",
    "MOTION_ALIGNSCENE_MIDDLE": "中央",
    "MOTION_ALIGNSCENE_TOPLEFT": "左上",
    "MOTION_ALIGNSCENE_TOPRIGHT": "右上",
    "MOTION_XSCROLL": "x方向のスクロール量",
    "MOTION_YSCROLL": "y方向のスクロール方向",
    "MOTION_STAGE_SELECTED": "ステージに動きブロックはありません",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 から %2 までの乱数",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 かつ %2",
    "OPERATORS_OR": "%1 または %2",
    "OPERATORS_NOT": "%1 ではない",
    "OPERATORS_JOIN": "%1 と %2",
    "OPERATORS_JOIN_APPLE": "りんご",
    "OPERATORS_JOIN_BANANA": "バナナ",
    "OPERATORS_LETTEROF": "%2 の %1 番目の文字",
    "OPERATORS_LETTEROF_APPLE": "り",
    "OPERATORS_LENGTH": "%1 の長さ",
    "OPERATORS_CONTAINS": "%1 に %2 が含まれる",
    "OPERATORS_MOD": "%1 を %2 で割った余り",
    "OPERATORS_ROUND": "%1 を四捨五入",
    "OPERATORS_MATHOP": "%2 の %1",
    "OPERATORS_MATHOP_ABS": "絶対値",
    "OPERATORS_MATHOP_FLOOR": "切り下げ",
    "OPERATORS_MATHOP_CEILING": "切り上げ",
    "OPERATORS_MATHOP_SQRT": "平方根",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "定義 %1",
    "SENSING_TOUCHINGOBJECT": "%1 に触れた",
    "SENSING_TOUCHINGOBJECT_POINTER": "マウスのポインター",
    "SENSING_TOUCHINGOBJECT_EDGE": "端",
    "SENSING_TOUCHINGCOLOR": "%1 色に触れた",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 色が %2 色に触れた",
    "SENSING_DISTANCETO": "%1 までの距離",
    "SENSING_DISTANCETO_POINTER": "マウスのポインター",
    "SENSING_ASKANDWAIT": "%1 と聞いて待つ",
    "SENSING_ASK_TEXT": "あなたの名前は何ですか?",
    "SENSING_ANSWER": "答え",
    "SENSING_KEYPRESSED": "%1 キーが押された",
    "SENSING_MOUSEDOWN": "マウスが押された",
    "SENSING_MOUSEX": "マウスのx座標",
    "SENSING_MOUSEY": "マウスのy座標",
    "SENSING_SETDRAGMODE": "ドラッグ %1 ようにする",
    "SENSING_SETDRAGMODE_DRAGGABLE": "できる",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "できない",
    "SENSING_LOUDNESS": "音量",
    "SENSING_LOUD": "うるさい",
    "SENSING_TIMER": "タイマー",
    "SENSING_RESETTIMER": "タイマーをリセット",
    "SENSING_OF": "%2 の %1",
    "SENSING_OF_XPOSITION": "x座標",
    "SENSING_OF_YPOSITION": "y座標",
    "SENSING_OF_DIRECTION": "向き",
    "SENSING_OF_COSTUMENUMBER": "コスチューム #",
    "SENSING_OF_COSTUMENAME": "コスチューム名",
    "SENSING_OF_SIZE": "大きさ",
    "SENSING_OF_VOLUME": "音量",
    "SENSING_OF_BACKDROPNUMBER": "背景 #",
    "SENSING_OF_BACKDROPNAME": "背景の名前",
    "SENSING_OF_STAGE": "ステージ",
    "SENSING_CURRENT": "現在の %1",
    "SENSING_CURRENT_YEAR": "年",
    "SENSING_CURRENT_MONTH": "月",
    "SENSING_CURRENT_DATE": "日",
    "SENSING_CURRENT_DAYOFWEEK": "曜日",
    "SENSING_CURRENT_HOUR": "時",
    "SENSING_CURRENT_MINUTE": "分",
    "SENSING_CURRENT_SECOND": "秒",
    "SENSING_DAYSSINCE2000": "2000年からの日数",
    "SENSING_USERNAME": "ユーザー名",
    "SENSING_USERID": "ユーザーID",
    "SOUND_PLAY": "%1 の音を鳴らす",
    "SOUND_PLAYUNTILDONE": "終わるまで %1 の音を鳴らす",
    "SOUND_STOPALLSOUNDS": "すべての音を止める",
    "SOUND_SETEFFECTO": "%1 の効果を %2 にする",
    "SOUND_CHANGEEFFECTBY": "%1 の効果を %2 ずつ変える",
    "SOUND_CLEAREFFECTS": "音の効果をなくす",
    "SOUND_EFFECTS_PITCH": "ピッチ",
    "SOUND_EFFECTS_PAN": "左右にパン",
    "SOUND_CHANGEVOLUMEBY": "音量を %1 ずつ変える",
    "SOUND_SETVOLUMETO": "音量を %1 %にする",
    "SOUND_VOLUME": "音量",
    "SOUND_RECORD": "録音...",
    "CATEGORY_MOTION": "動き",
    "CATEGORY_LOOKS": "見た目",
    "CATEGORY_SOUND": "音",
    "CATEGORY_EVENTS": "イベント",
    "CATEGORY_CONTROL": "制御",
    "CATEGORY_SENSING": "調べる",
    "CATEGORY_OPERATORS": "演算",
    "CATEGORY_VARIABLES": "変数",
    "CATEGORY_MYBLOCKS": "ブロック定義",
    "DUPLICATE": "複製",
    "DELETE": "削除",
    "ADD_COMMENT": "コメントを追加",
    "REMOVE_COMMENT": "コメントを削除",
    "DELETE_BLOCK": "ブロックを削除",
    "DELETE_X_BLOCKS": "%1 個のブロックを削除",
    "DELETE_ALL_BLOCKS": "%1 個のブロックをすべて削除しますか?",
    "CLEAN_UP": "きれいにする",
    "HELP": "ヘルプ",
    "UNDO": "取り消し",
    "REDO": "やり直し",
    "EDIT_PROCEDURE": "編集",
    "SHOW_PROCEDURE_DEFINITION": "定義へ行く",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "コメントを書く...",
    "COLOUR_HUE_LABEL": "色",
    "COLOUR_SATURATION_LABEL": "鮮やかさ",
    "COLOUR_BRIGHTNESS_LABEL": "明るさ",
    "CHANGE_VALUE_TITLE": "値を変える:",
    "RENAME_VARIABLE": "変数名を変更",
    "RENAME_VARIABLE_TITLE": "変数\"%1\"をすべて以下の名前に変える:",
    "RENAME_VARIABLE_MODAL_TITLE": "変数名を変更",
    "NEW_VARIABLE": "変数を作る",
    "NEW_VARIABLE_TITLE": "新しい変数名:",
    "VARIABLE_MODAL_TITLE": "新しい変数",
    "VARIABLE_ALREADY_EXISTS": "変数\"%1\"はすでに存在します。",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "変数\"%1\"は\"%2\"型の変数としてすでに存在します。",
    "DELETE_VARIABLE_CONFIRMATION": "変数\"%2\"が使われている %1 箇所も削除しますか?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "変数\"%1\"は定義\"%2\"で使われているため削除できません",
    "DELETE_VARIABLE": "変数\"%1\"を削除",
    "NEW_PROCEDURE": "ブロックを作る",
    "PROCEDURE_ALREADY_EXISTS": "定義\"%1\"はすでに存在します。",
    "PROCEDURE_DEFAULT_NAME": "ブロック名",
    "PROCEDURE_USED": "ブロック定義を削除するには、まずそのブロックを使っている箇所を消してください。 ",
    "NEW_LIST": "リストを作る",
    "NEW_LIST_TITLE": "新しいリスト名:",
    "LIST_MODAL_TITLE": "新しいリスト",
    "LIST_ALREADY_EXISTS": "リスト\"%1\"はすでに存在します。",
    "RENAME_LIST_TITLE": "リスト\"%1\"をすべて以下の名前に変える:",
    "RENAME_LIST_MODAL_TITLE": "リスト名を変更",
    "DEFAULT_LIST_ITEM": "なにか",
    "DELETE_LIST": "リスト「%1」を削除する",
    "RENAME_LIST": "リスト名を変更",
    "NEW_BROADCAST_MESSAGE": "新しいメッセージ",
    "NEW_BROADCAST_MESSAGE_TITLE": "新しいメッセージ名:",
    "BROADCAST_MODAL_TITLE": "新しいメッセージ",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "メッセージ1"
  },
  "ja-Hira": {
    "CONTROL_FOREVER": "ずっと",
    "CONTROL_REPEAT": "%1 かいくりかえす",
    "CONTROL_IF": "もし %1 なら",
    "CONTROL_ELSE": "でなければ",
    "CONTROL_STOP": "　",
    "CONTROL_STOP_ALL": "すべてをとめる",
    "CONTROL_STOP_THIS": "このスクリプトをとめる",
    "CONTROL_STOP_OTHER": "スプライトのほかのスクリプトをとめる",
    "CONTROL_WAIT": "%1 びょうまつ",
    "CONTROL_WAITUNTIL": "%1 までまつ",
    "CONTROL_REPEATUNTIL": "%1 までくりかえす",
    "CONTROL_WHILE": "%1 のあいだくりかえす",
    "CONTROL_FOREACH": "%2 のようそを %1 にいれてくりかえす",
    "CONTROL_STARTASCLONE": "クローンされたとき",
    "CONTROL_CREATECLONEOF": "%1 のクローンをつくる",
    "CONTROL_CREATECLONEOF_MYSELF": "じぶんじしん",
    "CONTROL_DELETETHISCLONE": "このクローンをさくじょする",
    "CONTROL_COUNTER": "カウンター",
    "CONTROL_INCRCOUNTER": "カウンターにたす",
    "CONTROL_CLEARCOUNTER": "カウンターをクリアする",
    "CONTROL_ALLATONCE": "いっせいに",
    "DATA_SETVARIABLETO": "%1 を %2 にする",
    "DATA_CHANGEVARIABLEBY": "%1 を %2 ずつかえる",
    "DATA_SHOWVARIABLE": "へんすう %1 をひょうじする",
    "DATA_HIDEVARIABLE": "へんすう %1 をかくす",
    "DATA_ADDTOLIST": "%1 を %2 についかする",
    "DATA_DELETEOFLIST": "%2 の %1 ばんめをさくじょする",
    "DATA_DELETEALLOFLIST": "%1のすべてをさくじょする",
    "DATA_INSERTATLIST": "%3 の %2 ばんめに %1 をそうにゅうする",
    "DATA_REPLACEITEMOFLIST": "%2 の %1 ばんめを %3 でおきかえる",
    "DATA_ITEMOFLIST": "%2 の %1 ばんめ",
    "DATA_ITEMNUMOFLIST": "%2なかの%1のばしょ",
    "DATA_LENGTHOFLIST": "%1 のながさ",
    "DATA_LISTCONTAINSITEM": "%1 に %2 がふくまれる",
    "DATA_SHOWLIST": "リスト %1 をひょうじする",
    "DATA_HIDELIST": "リスト %1 をかくす",
    "DATA_INDEX_ALL": "すべて",
    "DATA_INDEX_LAST": "さいご",
    "DATA_INDEX_RANDOM": "らんすう",
    "EVENT_WHENFLAGCLICKED": "%1 がおされたとき",
    "EVENT_WHENTHISSPRITECLICKED": "このスプライトがおされたとき",
    "EVENT_WHENSTAGECLICKED": "ステージがおされたとき",
    "EVENT_WHENTOUCHINGOBJECT": "このスプライトが %1 にふれたとき",
    "EVENT_WHENBROADCASTRECEIVED": "%1 をうけとったとき",
    "EVENT_WHENBACKDROPSWITCHESTO": "はいけいが %1 になったとき",
    "EVENT_WHENGREATERTHAN": "%1 > %2 のとき",
    "EVENT_WHENGREATERTHAN_TIMER": "タイマー",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "おんりょう",
    "EVENT_BROADCAST": "%1 をおくる",
    "EVENT_BROADCASTANDWAIT": "%1 をおくってまつ",
    "EVENT_WHENKEYPRESSED": "%1 キーがおされたとき",
    "EVENT_WHENKEYPRESSED_SPACE": "スペース",
    "EVENT_WHENKEYPRESSED_LEFT": "ひだりむきやじるし",
    "EVENT_WHENKEYPRESSED_RIGHT": "みぎむきやじるし",
    "EVENT_WHENKEYPRESSED_DOWN": "したむきやじるし",
    "EVENT_WHENKEYPRESSED_UP": "うわむきやじるし",
    "EVENT_WHENKEYPRESSED_ANY": "どれかの",
    "LOOKS_SAYFORSECS": "%1 と %2 びょういう",
    "LOOKS_SAY": "%1 という",
    "LOOKS_HELLO": "こんにちは!",
    "LOOKS_THINKFORSECS": "%1 と %2 びょうかんがえる",
    "LOOKS_THINK": "%1 とかんがえる",
    "LOOKS_HMM": "うーん...",
    "LOOKS_SHOW": "ひょうじする",
    "LOOKS_HIDE": "かくす",
    "LOOKS_HIDEALLSPRITES": "すべてのスプライトをかくす",
    "LOOKS_EFFECT_COLOR": "いろ",
    "LOOKS_EFFECT_FISHEYE": "ぎょがんレンズ",
    "LOOKS_EFFECT_WHIRL": "うずまき",
    "LOOKS_EFFECT_PIXELATE": "ピクセルか",
    "LOOKS_EFFECT_MOSAIC": "モザイク",
    "LOOKS_EFFECT_BRIGHTNESS": "あかるさ",
    "LOOKS_EFFECT_GHOST": "ゆうれい",
    "LOOKS_CHANGEEFFECTBY": "%1 のこうかを %2 ずつかえる",
    "LOOKS_SETEFFECTTO": "%1 のこうかを %2 にする",
    "LOOKS_CLEARGRAPHICEFFECTS": "がぞうこうかをなくす",
    "LOOKS_CHANGESIZEBY": "おおきさを %1 ずつかえる",
    "LOOKS_SETSIZETO": "おおきさを %1 %にする",
    "LOOKS_SIZE": "おおきさ",
    "LOOKS_CHANGESTRETCHBY": "のびを %1 ずつかえる",
    "LOOKS_SETSTRETCHTO": "のびを %1 %にする",
    "LOOKS_SWITCHCOSTUMETO": "コスチュームを %1 にする",
    "LOOKS_NEXTCOSTUME": "つぎのコスチュームにする",
    "LOOKS_SWITCHBACKDROPTO": "はいけいを %1 にする",
    "LOOKS_GOTOFRONTBACK": "%1 へいどうする",
    "LOOKS_GOTOFRONTBACK_FRONT": "さいぜんめん",
    "LOOKS_GOTOFRONTBACK_BACK": "さいはいめん",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%2 そう %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "てまえにだす",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "おくにさげる",
    "LOOKS_BACKDROPNUMBERNAME": "はいけいの %1",
    "LOOKS_COSTUMENUMBERNAME": "コスチュームの %1",
    "LOOKS_NUMBERNAME_NUMBER": "ばんごう",
    "LOOKS_NUMBERNAME_NAME": "なまえ",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "はいけいを %1 にしてまつ",
    "LOOKS_NEXTBACKDROP_BLOCK": "つぎのはいけいにする",
    "LOOKS_NEXTBACKDROP": "つぎのはいけい",
    "LOOKS_PREVIOUSBACKDROP": "まえのはいけい",
    "LOOKS_RANDOMBACKDROP": "どれかのはいけい",
    "MOTION_MOVESTEPS": "%1 ほうごかす",
    "MOTION_TURNLEFT": "%1 %2 どまわす",
    "MOTION_TURNRIGHT": "%1 %2 どまわす",
    "MOTION_POINTINDIRECTION": "%1 どにむける",
    "MOTION_POINTTOWARDS": "%1 へむける",
    "MOTION_POINTTOWARDS_POINTER": "マウスのポインター",
    "MOTION_POINTTOWARDS_RANDOM": "どれかのむき",
    "MOTION_GOTO": "%1 へいく",
    "MOTION_GOTO_POINTER": "マウスのポインター",
    "MOTION_GOTO_RANDOM": "どこかのばしょ",
    "MOTION_GOTOXY": "xざひょうを %1 、yざひょうを %2 にする",
    "MOTION_GLIDESECSTOXY": "%1 びょうでxざひょうを %2 に、yざひょうを %3 にかえる",
    "MOTION_GLIDETO": "%1 びょうで %2 へいく",
    "MOTION_GLIDETO_POINTER": "マウスのポインター",
    "MOTION_GLIDETO_RANDOM": "どこかのばしょ",
    "MOTION_CHANGEXBY": "xざひょうを %1 ずつかえる",
    "MOTION_SETX": "xざひょうを %1 にする",
    "MOTION_CHANGEYBY": "yざひょうを %1 ずつかえる",
    "MOTION_SETY": "yざひょうを %1 にする",
    "MOTION_IFONEDGEBOUNCE": "もしはしについたら、はねかえる",
    "MOTION_SETROTATIONSTYLE": "かいてんほうほうを %1 にする",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "さゆうのみ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "かいてんしない",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "じゆうにかいてん",
    "MOTION_XPOSITION": "xざひょう",
    "MOTION_YPOSITION": "yざひょう",
    "MOTION_DIRECTION": "むき",
    "MOTION_SCROLLRIGHT": "みぎに %1 スクロールする",
    "MOTION_SCROLLUP": "うえに %1 スクロールする",
    "MOTION_ALIGNSCENE": "スクロールいちを %1 にする",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ひだりした",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "みぎした",
    "MOTION_ALIGNSCENE_MIDDLE": "ちゅうおう",
    "MOTION_ALIGNSCENE_TOPLEFT": "ひだりうえ",
    "MOTION_ALIGNSCENE_TOPRIGHT": "みぎうえ",
    "MOTION_XSCROLL": "xほうこうのスクロールりょう",
    "MOTION_YSCROLL": "yほうこうのスクロールほうこう",
    "MOTION_STAGE_SELECTED": "ステージがせんたくされました: うごきブロックはありません",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 から %2 までのらんすう",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 かつ %2",
    "OPERATORS_OR": "%1 または %2",
    "OPERATORS_NOT": "%1 ではない",
    "OPERATORS_JOIN": "%1 と %2",
    "OPERATORS_JOIN_APPLE": "りんご",
    "OPERATORS_JOIN_BANANA": "バナナ",
    "OPERATORS_LETTEROF": "%2 の %1 ばんめのもじ",
    "OPERATORS_LETTEROF_APPLE": "り",
    "OPERATORS_LENGTH": "%1 のながさ",
    "OPERATORS_CONTAINS": "%1 に %2 がふくまれる",
    "OPERATORS_MOD": "%1 を %2 でわったあまり",
    "OPERATORS_ROUND": "%1 をししゃごにゅう",
    "OPERATORS_MATHOP": "%2 の %1",
    "OPERATORS_MATHOP_ABS": "ぜったいち",
    "OPERATORS_MATHOP_FLOOR": "きりさげ",
    "OPERATORS_MATHOP_CEILING": "きりあげ",
    "OPERATORS_MATHOP_SQRT": "へいほうこん",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "ていぎ %1",
    "SENSING_TOUCHINGOBJECT": "%1 にふれた",
    "SENSING_TOUCHINGOBJECT_POINTER": "マウスのポインター",
    "SENSING_TOUCHINGOBJECT_EDGE": "はし",
    "SENSING_TOUCHINGCOLOR": "%1 いろにふれた",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 いろが %2 いろにふれた",
    "SENSING_DISTANCETO": "%1 までのきょり",
    "SENSING_DISTANCETO_POINTER": "マウスのポインター",
    "SENSING_ASKANDWAIT": "%1 ときいてまつ",
    "SENSING_ASK_TEXT": "あなたのなまえはなんですか?",
    "SENSING_ANSWER": "こたえ",
    "SENSING_KEYPRESSED": "%1 キーがおされた",
    "SENSING_MOUSEDOWN": "マウスがおされた",
    "SENSING_MOUSEX": "マウスのxざひょう",
    "SENSING_MOUSEY": "マウスのyざひょう",
    "SENSING_SETDRAGMODE": "ドラッグ %1 ようにする",
    "SENSING_SETDRAGMODE_DRAGGABLE": "できる",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "できない",
    "SENSING_LOUDNESS": "おんりょう",
    "SENSING_LOUD": "うるさい",
    "SENSING_TIMER": "タイマー",
    "SENSING_RESETTIMER": "タイマーをリセット",
    "SENSING_OF": "%2 の %1",
    "SENSING_OF_XPOSITION": "xざひょう",
    "SENSING_OF_YPOSITION": "yざひょう",
    "SENSING_OF_DIRECTION": "むき",
    "SENSING_OF_COSTUMENUMBER": "コスチューム #",
    "SENSING_OF_COSTUMENAME": "コスチュームめい",
    "SENSING_OF_SIZE": "おおきさ",
    "SENSING_OF_VOLUME": "おんりょう",
    "SENSING_OF_BACKDROPNUMBER": "はいけい #",
    "SENSING_OF_BACKDROPNAME": "はいけいのなまえ",
    "SENSING_OF_STAGE": "ステージ",
    "SENSING_CURRENT": "げんざいの %1",
    "SENSING_CURRENT_YEAR": "とし",
    "SENSING_CURRENT_MONTH": "つき",
    "SENSING_CURRENT_DATE": "ひ",
    "SENSING_CURRENT_DAYOFWEEK": "ようび",
    "SENSING_CURRENT_HOUR": "じ",
    "SENSING_CURRENT_MINUTE": "ふん",
    "SENSING_CURRENT_SECOND": "びょう",
    "SENSING_DAYSSINCE2000": "2000ねんからのにっすう",
    "SENSING_USERNAME": "ユーザーめい",
    "SENSING_USERID": "ユーザーID",
    "SOUND_PLAY": "%1 のおとをならす",
    "SOUND_PLAYUNTILDONE": "おわるまで %1 のおとをならす",
    "SOUND_STOPALLSOUNDS": "すべてのおとをとめる",
    "SOUND_SETEFFECTO": "%1 のこうかを %2 にする",
    "SOUND_CHANGEEFFECTBY": "%1 のこうかを %2 ずつかえる",
    "SOUND_CLEAREFFECTS": "おとのこうかをなくす",
    "SOUND_EFFECTS_PITCH": "ピッチ",
    "SOUND_EFFECTS_PAN": "さゆうにパン",
    "SOUND_CHANGEVOLUMEBY": "おんりょうを %1 ずつかえる",
    "SOUND_SETVOLUMETO": "おんりょうを %1 %にする",
    "SOUND_VOLUME": "おんりょう",
    "SOUND_RECORD": "ろくおん...",
    "CATEGORY_MOTION": "うごき",
    "CATEGORY_LOOKS": "みため",
    "CATEGORY_SOUND": "おと",
    "CATEGORY_EVENTS": "イベント",
    "CATEGORY_CONTROL": "せいぎょ",
    "CATEGORY_SENSING": "しらべる",
    "CATEGORY_OPERATORS": "えんざん",
    "CATEGORY_VARIABLES": "へんすう",
    "CATEGORY_MYBLOCKS": "ブロックていぎ",
    "DUPLICATE": "ふくせい",
    "DELETE": "さくじょ",
    "ADD_COMMENT": "コメントをついか",
    "REMOVE_COMMENT": "コメントをさくじょ",
    "DELETE_BLOCK": "ブロックをさくじょ",
    "DELETE_X_BLOCKS": "%1 このブロックをさくじょ",
    "DELETE_ALL_BLOCKS": "%1 このブロックをすべてさくじょしますか?",
    "CLEAN_UP": "きれいにする",
    "HELP": "ヘルプ",
    "UNDO": "とりけし",
    "REDO": "やりなおし",
    "EDIT_PROCEDURE": "へんしゅう",
    "SHOW_PROCEDURE_DEFINITION": "ていぎへいく",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "コメントをかく...",
    "COLOUR_HUE_LABEL": "いろ",
    "COLOUR_SATURATION_LABEL": "あざやかさ",
    "COLOUR_BRIGHTNESS_LABEL": "あかるさ",
    "CHANGE_VALUE_TITLE": "あたいをかえる:",
    "RENAME_VARIABLE": "へんすうめいをへんこう",
    "RENAME_VARIABLE_TITLE": "へんすう\"%1\"をすべていかのなまえにかえる:",
    "RENAME_VARIABLE_MODAL_TITLE": "へんすうめいをへんこう",
    "NEW_VARIABLE": "へんすうをつくる",
    "NEW_VARIABLE_TITLE": "あたらしいへんすうめい:",
    "VARIABLE_MODAL_TITLE": "あたらしいへんすう",
    "VARIABLE_ALREADY_EXISTS": "へんすう\"%1\"はすでにそんざいします。",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "へんすう\"%1\"は\"%2\"かたのへんすうとしてすでにそんざいします。",
    "DELETE_VARIABLE_CONFIRMATION": "へんすう\"%2\"がつかわれている %1 かしょもさくじょしますか?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "へんすう\"%1\"はていぎ\"%2\"でつかわれているためさくじょできません",
    "DELETE_VARIABLE": "へんすう\"%1\"をさくじょ",
    "NEW_PROCEDURE": "ブロックをつくる",
    "PROCEDURE_ALREADY_EXISTS": "ていぎ\"%1\"はすでにそんざいします。",
    "PROCEDURE_DEFAULT_NAME": "ブロックめい",
    "PROCEDURE_USED": "ブロックていぎをさくじょするには、まずそのブロックをつかっているかしょをけしてください。",
    "NEW_LIST": "リストをつくる",
    "NEW_LIST_TITLE": "あたらしいリストめい:",
    "LIST_MODAL_TITLE": "あたらしいリスト",
    "LIST_ALREADY_EXISTS": "リスト\"%1\"はすでにそんざいします。",
    "RENAME_LIST_TITLE": "リスト\"%1\"をすべていかのなまえにかえる:",
    "RENAME_LIST_MODAL_TITLE": "リストめいをへんこう",
    "DEFAULT_LIST_ITEM": "なにか",
    "DELETE_LIST": "リスト「%1」をさくじょする",
    "RENAME_LIST": "リストめいをへんこう",
    "NEW_BROADCAST_MESSAGE": "あたらしいメッセージ",
    "NEW_BROADCAST_MESSAGE_TITLE": "あたらしいメッセージめい:",
    "BROADCAST_MODAL_TITLE": "あたらしいメッセージ",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "メッセージ1"
  },
  "nb": {
    "CONTROL_FOREVER": "gjenta for alltid",
    "CONTROL_REPEAT": "gjenta %1 ganger",
    "CONTROL_IF": "hvis %1",
    "CONTROL_ELSE": "ellers",
    "CONTROL_STOP": "stopp",
    "CONTROL_STOP_ALL": "alle",
    "CONTROL_STOP_THIS": "dette skriptet",
    "CONTROL_STOP_OTHER": "andre skript i figuren",
    "CONTROL_WAIT": "vent %1 sekunder",
    "CONTROL_WAITUNTIL": "vent til %1",
    "CONTROL_REPEATUNTIL": "gjenta til %1",
    "CONTROL_WHILE": "gjenta hvis %1",
    "CONTROL_FOREACH": "for hver %1 i %2",
    "CONTROL_STARTASCLONE": "når jeg starter som klon",
    "CONTROL_CREATECLONEOF": "lag klon av %1",
    "CONTROL_CREATECLONEOF_MYSELF": "meg",
    "CONTROL_DELETETHISCLONE": "slett denne klonen",
    "CONTROL_COUNTER": "teller",
    "CONTROL_INCRCOUNTER": "tell opp med 1",
    "CONTROL_CLEARCOUNTER": "nullstill telleren",
    "CONTROL_ALLATONCE": "kjør fort",
    "DATA_SETVARIABLETO": "sett %1 til %2",
    "DATA_CHANGEVARIABLEBY": "endre %1 med %2",
    "DATA_SHOWVARIABLE": "vis variabel %1",
    "DATA_HIDEVARIABLE": "skjul variabel %1",
    "DATA_ADDTOLIST": "legg til %1 i %2",
    "DATA_DELETEOFLIST": "slett element %1 i %2",
    "DATA_DELETEALLOFLIST": "slett alt i %1",
    "DATA_INSERTATLIST": "sett inn %1 på plass %2 i %3",
    "DATA_REPLACEITEMOFLIST": "erstatt element %1 i %2 med %3",
    "DATA_ITEMOFLIST": "element %1 i %2",
    "DATA_ITEMNUMOFLIST": "posisjon av %1 i %2",
    "DATA_LENGTHOFLIST": "lengden av %1",
    "DATA_LISTCONTAINSITEM": "%1 inneholder %2?",
    "DATA_SHOWLIST": "vis liste %1",
    "DATA_HIDELIST": "skjul liste %1",
    "DATA_INDEX_ALL": "alle",
    "DATA_INDEX_LAST": "siste",
    "DATA_INDEX_RANDOM": "tilfeldig",
    "EVENT_WHENFLAGCLICKED": "når %1 klikkes",
    "EVENT_WHENTHISSPRITECLICKED": "når denne figuren klikkes",
    "EVENT_WHENSTAGECLICKED": "når scenen klikkes",
    "EVENT_WHENTOUCHINGOBJECT": "når denne figuren berører %1",
    "EVENT_WHENBROADCASTRECEIVED": "når jeg mottar %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "når bakgrunn bytter til %1",
    "EVENT_WHENGREATERTHAN": "når %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "sekundklokke",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "lydnivå",
    "EVENT_BROADCAST": "send melding %1",
    "EVENT_BROADCASTANDWAIT": "send melding %1 og vent",
    "EVENT_WHENKEYPRESSED": "når %1 trykkes",
    "EVENT_WHENKEYPRESSED_SPACE": "mellomrom",
    "EVENT_WHENKEYPRESSED_LEFT": "pil venstre",
    "EVENT_WHENKEYPRESSED_RIGHT": "pil høyre",
    "EVENT_WHENKEYPRESSED_DOWN": "pil ned",
    "EVENT_WHENKEYPRESSED_UP": "pil opp",
    "EVENT_WHENKEYPRESSED_ANY": "hvilken som helst",
    "LOOKS_SAYFORSECS": "si %1 i %2 sekunder",
    "LOOKS_SAY": "si %1",
    "LOOKS_HELLO": "Hei!",
    "LOOKS_THINKFORSECS": "tenk %1 i %2 sekunder",
    "LOOKS_THINK": "tenk %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "vis",
    "LOOKS_HIDE": "skjul",
    "LOOKS_HIDEALLSPRITES": "skjul alle figurer",
    "LOOKS_EFFECT_COLOR": "farge",
    "LOOKS_EFFECT_FISHEYE": "fiskeøye",
    "LOOKS_EFFECT_WHIRL": "virvel",
    "LOOKS_EFFECT_PIXELATE": "piksel",
    "LOOKS_EFFECT_MOSAIC": "mosaikk",
    "LOOKS_EFFECT_BRIGHTNESS": "lysstyrke",
    "LOOKS_EFFECT_GHOST": "gjennomsiktig",
    "LOOKS_CHANGEEFFECTBY": "endre %1 effekt med %2",
    "LOOKS_SETEFFECTTO": "sett %1 effekt til %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "fjern grafiske effekter",
    "LOOKS_CHANGESIZEBY": "endre størrelse med %1",
    "LOOKS_SETSIZETO": "sett størrelse til %1 %",
    "LOOKS_SIZE": "størrelse",
    "LOOKS_CHANGESTRETCHBY": "endre strekk med %1",
    "LOOKS_SETSTRETCHTO": "sett strekk til %1 %",
    "LOOKS_SWITCHCOSTUMETO": "bytt drakt til %1",
    "LOOKS_NEXTCOSTUME": "neste drakt",
    "LOOKS_SWITCHBACKDROPTO": "bytt bakgrunn til %1",
    "LOOKS_GOTOFRONTBACK": "legg %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "foran alt",
    "LOOKS_GOTOFRONTBACK_BACK": "bakerst",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "gå %1 %2 lag",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "forover",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "bakover",
    "LOOKS_BACKDROPNUMBERNAME": "bakgrunn %1",
    "LOOKS_COSTUMENUMBERNAME": "drakt %1",
    "LOOKS_NUMBERNAME_NUMBER": "nummer",
    "LOOKS_NUMBERNAME_NAME": "navn",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "bytt bakgrunn til %1 og vent",
    "LOOKS_NEXTBACKDROP_BLOCK": "neste bakgrunn",
    "LOOKS_NEXTBACKDROP": "neste bakgrunn",
    "LOOKS_PREVIOUSBACKDROP": "forrige bakgrunn",
    "LOOKS_RANDOMBACKDROP": "tilfeldig bakgrunn",
    "MOTION_MOVESTEPS": "gå %1 steg",
    "MOTION_TURNLEFT": "snu %1 %2 grader",
    "MOTION_TURNRIGHT": "snu %1 %2 grader",
    "MOTION_POINTINDIRECTION": "pek i retning %1",
    "MOTION_POINTTOWARDS": "pek mot %1",
    "MOTION_POINTTOWARDS_POINTER": "musepeker",
    "MOTION_POINTTOWARDS_RANDOM": "tilfeldig retning",
    "MOTION_GOTO": "gå til %1",
    "MOTION_GOTO_POINTER": "musepeker",
    "MOTION_GOTO_RANDOM": "tilfeldig sted",
    "MOTION_GOTOXY": "gå til x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "gli %1 sekunder til x: %2 y: %3",
    "MOTION_GLIDETO": "gli %1 sekunder til %2",
    "MOTION_GLIDETO_POINTER": "musepeker",
    "MOTION_GLIDETO_RANDOM": "tilfeldig sted",
    "MOTION_CHANGEXBY": "endre x med %1",
    "MOTION_SETX": "sett x til %1",
    "MOTION_CHANGEYBY": "endre y med %1",
    "MOTION_SETY": "sett y til %1",
    "MOTION_IFONEDGEBOUNCE": "sprett tilbake ved kanten",
    "MOTION_SETROTATIONSTYLE": "begrens rotasjon %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "vend sideveis",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ikke roter",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "fri rotasjon",
    "MOTION_XPOSITION": "x-posisjon",
    "MOTION_YPOSITION": "y-posisjon",
    "MOTION_DIRECTION": "retning",
    "MOTION_SCROLLRIGHT": "rull høyre %1",
    "MOTION_SCROLLUP": "rull opp %1",
    "MOTION_ALIGNSCENE": "flytt bakgrunn %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "nederst til venstre",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "nederst til høyre",
    "MOTION_ALIGNSCENE_MIDDLE": "i midten",
    "MOTION_ALIGNSCENE_TOPLEFT": "øverst til venstre",
    "MOTION_ALIGNSCENE_TOPRIGHT": "øverst til høyre",
    "MOTION_XSCROLL": "rull x",
    "MOTION_YSCROLL": "rull y",
    "MOTION_STAGE_SELECTED": "Scenen er valgt: den har ingen bevegelsesklosser",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "tilfeldig tall fra %1 til %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 og %2",
    "OPERATORS_OR": "%1 eller %2",
    "OPERATORS_NOT": "ikke %1",
    "OPERATORS_JOIN": "sett sammen %1 %2",
    "OPERATORS_JOIN_APPLE": "eple",
    "OPERATORS_JOIN_BANANA": "banan",
    "OPERATORS_LETTEROF": "bokstav %1 i %2",
    "OPERATORS_LETTEROF_APPLE": "p",
    "OPERATORS_LENGTH": "lengden av %1",
    "OPERATORS_CONTAINS": "%1 inneholder %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "avrund %1",
    "OPERATORS_MATHOP": "%1 av %2",
    "OPERATORS_MATHOP_ABS": "absoluttverdi",
    "OPERATORS_MATHOP_FLOOR": "avrund ned",
    "OPERATORS_MATHOP_CEILING": "avrund opp",
    "OPERATORS_MATHOP_SQRT": "kvadratrot",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definer %1",
    "SENSING_TOUCHINGOBJECT": "berører %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "musepeker",
    "SENSING_TOUCHINGOBJECT_EDGE": "kant",
    "SENSING_TOUCHINGCOLOR": "berører fargen %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "farge %1 berører %2?",
    "SENSING_DISTANCETO": "avstand til %1",
    "SENSING_DISTANCETO_POINTER": "musepeker",
    "SENSING_ASKANDWAIT": "spør %1 og vent",
    "SENSING_ASK_TEXT": "Hva heter du?",
    "SENSING_ANSWER": "svar",
    "SENSING_KEYPRESSED": "tast %1 trykket?",
    "SENSING_MOUSEDOWN": "museknappen er trykket?",
    "SENSING_MOUSEX": "mus x",
    "SENSING_MOUSEY": "mus y",
    "SENSING_SETDRAGMODE": "%1 å dra med musen",
    "SENSING_SETDRAGMODE_DRAGGABLE": "tillat",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ikke tillat",
    "SENSING_LOUDNESS": "lydnivå",
    "SENSING_LOUD": "høy lyd?",
    "SENSING_TIMER": "sekundklokke",
    "SENSING_RESETTIMER": "nullstill klokken",
    "SENSING_OF": "%1 av %2",
    "SENSING_OF_XPOSITION": "x-posisjon",
    "SENSING_OF_YPOSITION": "y-posisjon",
    "SENSING_OF_DIRECTION": "retning",
    "SENSING_OF_COSTUMENUMBER": "drakt nr.",
    "SENSING_OF_COSTUMENAME": "draktnavn",
    "SENSING_OF_SIZE": "størrelse",
    "SENSING_OF_VOLUME": "volum",
    "SENSING_OF_BACKDROPNUMBER": "bakgrunn nr.",
    "SENSING_OF_BACKDROPNAME": "navn på bakgrunn",
    "SENSING_OF_STAGE": "Scene",
    "SENSING_CURRENT": "%1 nå",
    "SENSING_CURRENT_YEAR": "år",
    "SENSING_CURRENT_MONTH": "måned",
    "SENSING_CURRENT_DATE": "dato",
    "SENSING_CURRENT_DAYOFWEEK": "ukedag",
    "SENSING_CURRENT_HOUR": "time",
    "SENSING_CURRENT_MINUTE": "minutt",
    "SENSING_CURRENT_SECOND": "sekund",
    "SENSING_DAYSSINCE2000": "dager siden 2000",
    "SENSING_USERNAME": "brukernavn",
    "SENSING_USERID": "brukernavn",
    "SOUND_PLAY": "start lyden %1",
    "SOUND_PLAYUNTILDONE": "spill lyden %1 til den er ferdig",
    "SOUND_STOPALLSOUNDS": "stopp alle lyder",
    "SOUND_SETEFFECTO": "sett %1 effekt til %2",
    "SOUND_CHANGEEFFECTBY": "endre %1 effekt med %2",
    "SOUND_CLEAREFFECTS": "fjern lydeffekter",
    "SOUND_EFFECTS_PITCH": "tonehøyde",
    "SOUND_EFFECTS_PAN": "retning",
    "SOUND_CHANGEVOLUMEBY": "endre volum med %1",
    "SOUND_SETVOLUMETO": "sett volum %1%",
    "SOUND_VOLUME": "volum",
    "SOUND_RECORD": "spill inn...",
    "CATEGORY_MOTION": "Bevegelse",
    "CATEGORY_LOOKS": "Utseende",
    "CATEGORY_SOUND": "Lyd",
    "CATEGORY_EVENTS": "Hendelser",
    "CATEGORY_CONTROL": "Styring",
    "CATEGORY_SENSING": "Sansing",
    "CATEGORY_OPERATORS": "Operatorer",
    "CATEGORY_VARIABLES": "Variabler",
    "CATEGORY_MYBLOCKS": "Mine klosser",
    "DUPLICATE": "Lag en kopi",
    "DELETE": "Slett",
    "ADD_COMMENT": "Skriv en kommentar",
    "REMOVE_COMMENT": "Fjern kommentar",
    "DELETE_BLOCK": "Slett kloss",
    "DELETE_X_BLOCKS": "Slett %1 klosser",
    "DELETE_ALL_BLOCKS": "Slette disse %1  klossene?",
    "CLEAN_UP": "Rydd opp klossene",
    "HELP": "Hjelp",
    "UNDO": "Angre",
    "REDO": "Gjør igjen",
    "EDIT_PROCEDURE": "Rediger",
    "SHOW_PROCEDURE_DEFINITION": "Gå til definisjonen",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Si noe...",
    "COLOUR_HUE_LABEL": "Farge",
    "COLOUR_SATURATION_LABEL": "Fargemetning",
    "COLOUR_BRIGHTNESS_LABEL": "Lysstyrke",
    "CHANGE_VALUE_TITLE": "Endre verdi:",
    "RENAME_VARIABLE": "Endre navn på variabel",
    "RENAME_VARIABLE_TITLE": "Endre variabelnavn \"%1\" til:",
    "RENAME_VARIABLE_MODAL_TITLE": "Endre navn på variabel",
    "NEW_VARIABLE": "Lag en variabel",
    "NEW_VARIABLE_TITLE": "Nytt variabelnavn:",
    "VARIABLE_MODAL_TITLE": "Ny variabel",
    "VARIABLE_ALREADY_EXISTS": "Det finnes allerede en variabel som heter \"%1\".",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Det finnes allerede en \"%2\"-variabel som heter \"%1\"",
    "DELETE_VARIABLE_CONFIRMATION": "Slette variabelen \"%2\" som er brukt %1 ganger?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Kan ikke slette variabelen \"%1\" fordi den brukes i definisjonen av funksjonen \"%2\"",
    "DELETE_VARIABLE": "Slett variabelen \"%1\"",
    "NEW_PROCEDURE": "Lag en kloss",
    "PROCEDURE_ALREADY_EXISTS": "Det finnes allerede en prosedyre som heter \"%1\".",
    "PROCEDURE_DEFAULT_NAME": "klossnavn",
    "PROCEDURE_USED": "Klossen må slettes fra alle skript før definisjonen kan slettes.",
    "NEW_LIST": "Lag en Liste",
    "NEW_LIST_TITLE": "Nytt navn på listen:",
    "LIST_MODAL_TITLE": "Ny liste",
    "LIST_ALREADY_EXISTS": "Det finnes allerede en liste som heter \"%1\".",
    "RENAME_LIST_TITLE": "Endre listenavnet \"%1\" til:",
    "RENAME_LIST_MODAL_TITLE": "Gi listen et annet navn",
    "DEFAULT_LIST_ITEM": "ting",
    "DELETE_LIST": "Slett listen \"%1\"",
    "RENAME_LIST": "Endre listenavn",
    "NEW_BROADCAST_MESSAGE": "Ny melding",
    "NEW_BROADCAST_MESSAGE_TITLE": "Skriv ny  melding:",
    "BROADCAST_MODAL_TITLE": "Ny melding",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "melding1"
  },
  "nn": {
    "CONTROL_FOREVER": "for alltid",
    "CONTROL_REPEAT": "gjenta %1 gongar",
    "CONTROL_IF": "viss %1",
    "CONTROL_ELSE": "elles",
    "CONTROL_STOP": "stopp",
    "CONTROL_STOP_ALL": "alle",
    "CONTROL_STOP_THIS": "dette skriptet",
    "CONTROL_STOP_OTHER": "andre skript i figuren",
    "CONTROL_WAIT": "vent %1 sekund",
    "CONTROL_WAITUNTIL": "vent til %1",
    "CONTROL_REPEATUNTIL": "gjenta til %1",
    "CONTROL_WHILE": "gjenta viss %1",
    "CONTROL_FOREACH": "for kvar %1 i %2",
    "CONTROL_STARTASCLONE": "når eg startar som klon",
    "CONTROL_CREATECLONEOF": "lag klon av %1",
    "CONTROL_CREATECLONEOF_MYSELF": "meg",
    "CONTROL_DELETETHISCLONE": "slett denne klonen",
    "CONTROL_COUNTER": "teljar",
    "CONTROL_INCRCOUNTER": "auk teljar",
    "CONTROL_CLEARCOUNTER": "tøm teljar",
    "CONTROL_ALLATONCE": "alle på éin gong",
    "DATA_SETVARIABLETO": "set %1 til %2",
    "DATA_CHANGEVARIABLEBY": "endra %1 med %2",
    "DATA_SHOWVARIABLE": "vis variabelen %1",
    "DATA_HIDEVARIABLE": "gøym variabelen %1",
    "DATA_ADDTOLIST": "legg %1 til %2",
    "DATA_DELETEOFLIST": "slett element %1 i %2",
    "DATA_DELETEALLOFLIST": "slett alt i %1",
    "DATA_INSERTATLIST": "set inn %1 på plass %2 i %3",
    "DATA_REPLACEITEMOFLIST": "byt ut element %1 i %2 med %3",
    "DATA_ITEMOFLIST": "element %1 i %2",
    "DATA_ITEMNUMOFLIST": "posisjon til %1 i %2",
    "DATA_LENGTHOFLIST": "lengda til %1",
    "DATA_LISTCONTAINSITEM": "%1 inneheld %2?",
    "DATA_SHOWLIST": "vis lista %1",
    "DATA_HIDELIST": "gøym lista %1",
    "DATA_INDEX_ALL": "alle",
    "DATA_INDEX_LAST": "siste",
    "DATA_INDEX_RANDOM": "tilfeldig",
    "EVENT_WHENFLAGCLICKED": "når %1 vert trykt på",
    "EVENT_WHENTHISSPRITECLICKED": "når denne figuren vert trykt på",
    "EVENT_WHENSTAGECLICKED": "når scena vert trykt på",
    "EVENT_WHENTOUCHINGOBJECT": "når figuren rører %1",
    "EVENT_WHENBROADCASTRECEIVED": "når eg får meldinga %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "når bakgrunnen byter til %1",
    "EVENT_WHENGREATERTHAN": "når %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "klokke",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "lydstyrke",
    "EVENT_BROADCAST": "send meldinga %1",
    "EVENT_BROADCASTANDWAIT": "send meldinga %1 og vent",
    "EVENT_WHENKEYPRESSED": "når %1 vert trykt",
    "EVENT_WHENKEYPRESSED_SPACE": "mellomrom",
    "EVENT_WHENKEYPRESSED_LEFT": "pil venstre",
    "EVENT_WHENKEYPRESSED_RIGHT": "pil høgre",
    "EVENT_WHENKEYPRESSED_DOWN": "pil ned",
    "EVENT_WHENKEYPRESSED_UP": "pil opp",
    "EVENT_WHENKEYPRESSED_ANY": "vilkårleg",
    "LOOKS_SAYFORSECS": "sei %1 i %2 sekund",
    "LOOKS_SAY": "sei %1",
    "LOOKS_HELLO": "Hei!",
    "LOOKS_THINKFORSECS": "tenk %1 i %2 sekund",
    "LOOKS_THINK": "tenk %1",
    "LOOKS_HMM": "Hm …",
    "LOOKS_SHOW": "vis",
    "LOOKS_HIDE": "gøym",
    "LOOKS_HIDEALLSPRITES": "gøym alle figurar",
    "LOOKS_EFFECT_COLOR": "farge",
    "LOOKS_EFFECT_FISHEYE": "fiskeauge",
    "LOOKS_EFFECT_WHIRL": "kvervel",
    "LOOKS_EFFECT_PIXELATE": "pikselering",
    "LOOKS_EFFECT_MOSAIC": "mosaikk",
    "LOOKS_EFFECT_BRIGHTNESS": "lysstyrke",
    "LOOKS_EFFECT_GHOST": "gjennomsiktig",
    "LOOKS_CHANGEEFFECTBY": "endra %1-effekten med %2",
    "LOOKS_SETEFFECTTO": "set %1-effekten til %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "ta vekk grafiske effektar",
    "LOOKS_CHANGESIZEBY": "endra storleik med %1",
    "LOOKS_SETSIZETO": "set storleik til %1 %",
    "LOOKS_SIZE": "storleik",
    "LOOKS_CHANGESTRETCHBY": "endra strekking med %1",
    "LOOKS_SETSTRETCHTO": "set strekking til %1 %",
    "LOOKS_SWITCHCOSTUMETO": "byt drakt til %1",
    "LOOKS_NEXTCOSTUME": "neste drakt",
    "LOOKS_SWITCHBACKDROPTO": "byt bakgrunn til %1",
    "LOOKS_GOTOFRONTBACK": "legg %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "framfor alt",
    "LOOKS_GOTOFRONTBACK_BACK": "bak alt",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "gå %1 %2 lag",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "framover",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "bakover",
    "LOOKS_BACKDROPNUMBERNAME": "bakgrunn %1",
    "LOOKS_COSTUMENUMBERNAME": "drakt %1",
    "LOOKS_NUMBERNAME_NUMBER": "tal",
    "LOOKS_NUMBERNAME_NAME": "namn",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "byt bakgrunn til %1 og vent",
    "LOOKS_NEXTBACKDROP_BLOCK": "neste bakgrunn",
    "LOOKS_NEXTBACKDROP": "neste bakgrunn",
    "LOOKS_PREVIOUSBACKDROP": "førre bakgrunn",
    "LOOKS_RANDOMBACKDROP": "tilfeldig bakgrunn",
    "MOTION_MOVESTEPS": "gå %1 steg",
    "MOTION_TURNLEFT": "snu %1 %2 gradar",
    "MOTION_TURNRIGHT": "snu %1 %2 gradar",
    "MOTION_POINTINDIRECTION": "peik i retning %1",
    "MOTION_POINTTOWARDS": "peik mot %1",
    "MOTION_POINTTOWARDS_POINTER": "musepeikar",
    "MOTION_POINTTOWARDS_RANDOM": "tilfeldig retning",
    "MOTION_GOTO": "gå til %1",
    "MOTION_GOTO_POINTER": "musepeikar",
    "MOTION_GOTO_RANDOM": "tilfeldig plassering",
    "MOTION_GOTOXY": "gå til x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "gli %1 sekund til x: %2 y: %3",
    "MOTION_GLIDETO": "gli %1 sekund til %2",
    "MOTION_GLIDETO_POINTER": "musepeikar",
    "MOTION_GLIDETO_RANDOM": "tilfeldig plassering",
    "MOTION_CHANGEXBY": "endra x med %1",
    "MOTION_SETX": "set x til %1",
    "MOTION_CHANGEYBY": "endra y med %1",
    "MOTION_SETY": "set y til %1",
    "MOTION_IFONEDGEBOUNCE": "viss ved kant, sprett",
    "MOTION_SETROTATIONSTYLE": "avgrens rotering til %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "venstre–høgre",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ikkje roter",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "roter fritt",
    "MOTION_XPOSITION": "x-posisjon",
    "MOTION_YPOSITION": "y-posisjon",
    "MOTION_DIRECTION": "retning",
    "MOTION_SCROLLRIGHT": "rull til høgre %1",
    "MOTION_SCROLLUP": "rull opp %1",
    "MOTION_ALIGNSCENE": "flytt bakgrunn %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "nede til venstre",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "nede til høgre",
    "MOTION_ALIGNSCENE_MIDDLE": "i midten",
    "MOTION_ALIGNSCENE_TOPLEFT": "oppe til venstre",
    "MOTION_ALIGNSCENE_TOPRIGHT": "oppe til høgre",
    "MOTION_XSCROLL": "rull x",
    "MOTION_YSCROLL": "rull y",
    "MOTION_STAGE_SELECTED": "Scene vald: ingen rørsleklossar",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 − %2",
    "OPERATORS_MULTIPLY": "%1 × %2",
    "OPERATORS_DIVIDE": "%1 : %2",
    "OPERATORS_RANDOM": "tilfeldig tal frå %1 til %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 og %2",
    "OPERATORS_OR": "%1 eller %2",
    "OPERATORS_NOT": "ikkje %1",
    "OPERATORS_JOIN": "set saman %1 %2",
    "OPERATORS_JOIN_APPLE": "eple",
    "OPERATORS_JOIN_BANANA": "banan",
    "OPERATORS_LETTEROF": "bokstav %1 i %2",
    "OPERATORS_LETTEROF_APPLE": "e",
    "OPERATORS_LENGTH": "lengda til %1",
    "OPERATORS_CONTAINS": "%1 inneheld %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "rund av %1",
    "OPERATORS_MATHOP": "%1 av %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "golv",
    "OPERATORS_MATHOP_CEILING": "tak",
    "OPERATORS_MATHOP_SQRT": "kvadratrot",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e^",
    "OPERATORS_MATHOP_10EXP": "10^",
    "PROCEDURES_DEFINITION": "definer %1",
    "SENSING_TOUCHINGOBJECT": "rører %1",
    "SENSING_TOUCHINGOBJECT_POINTER": "musepeikar",
    "SENSING_TOUCHINGOBJECT_EDGE": "kant",
    "SENSING_TOUCHINGCOLOR": "rører fargen %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "fargen %1 rører %2?",
    "SENSING_DISTANCETO": "avstand til %1",
    "SENSING_DISTANCETO_POINTER": "musepeikar",
    "SENSING_ASKANDWAIT": "spør %1 og vent",
    "SENSING_ASK_TEXT": "Kva heiter du?",
    "SENSING_ANSWER": "svar",
    "SENSING_KEYPRESSED": "tasten %1 er trykt?",
    "SENSING_MOUSEDOWN": "museknappen er trykt?",
    "SENSING_MOUSEX": "mus x",
    "SENSING_MOUSEY": "mus y",
    "SENSING_SETDRAGMODE": "%1 å dra med musa",
    "SENSING_SETDRAGMODE_DRAGGABLE": "tillate",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ikkje tillate",
    "SENSING_LOUDNESS": "lydstyrke",
    "SENSING_LOUD": "høg lyd?",
    "SENSING_TIMER": "sekundklokke",
    "SENSING_RESETTIMER": "nullstill klokka",
    "SENSING_OF": "%1 av %2",
    "SENSING_OF_XPOSITION": "x-posisjon",
    "SENSING_OF_YPOSITION": "y-posisjon",
    "SENSING_OF_DIRECTION": "retning",
    "SENSING_OF_COSTUMENUMBER": "drakt nr.",
    "SENSING_OF_COSTUMENAME": "draktnamn",
    "SENSING_OF_SIZE": "storleik",
    "SENSING_OF_VOLUME": "lydstyrke",
    "SENSING_OF_BACKDROPNUMBER": "bakgrunn nr.",
    "SENSING_OF_BACKDROPNAME": "bakgrunnsnamn",
    "SENSING_OF_STAGE": "Scene",
    "SENSING_CURRENT": "%1 nett no",
    "SENSING_CURRENT_YEAR": "året",
    "SENSING_CURRENT_MONTH": "månaden",
    "SENSING_CURRENT_DATE": "datoen",
    "SENSING_CURRENT_DAYOFWEEK": "vekedagen",
    "SENSING_CURRENT_HOUR": "timen",
    "SENSING_CURRENT_MINUTE": "minuttet",
    "SENSING_CURRENT_SECOND": "sekundet",
    "SENSING_DAYSSINCE2000": "dagar sidan år 2000",
    "SENSING_USERNAME": "brukarnamn",
    "SENSING_USERID": "brukar-id",
    "SOUND_PLAY": "start lyden %1",
    "SOUND_PLAYUNTILDONE": "spel lyden %1 til han er ferdig",
    "SOUND_STOPALLSOUNDS": "stopp alle lydar",
    "SOUND_SETEFFECTO": "set %1-effekt til %2",
    "SOUND_CHANGEEFFECTBY": "endra %1-effekt med %2",
    "SOUND_CLEAREFFECTS": "fjern lydeffektar",
    "SOUND_EFFECTS_PITCH": "tonehøgd",
    "SOUND_EFFECTS_PAN": "venstre–høgre-panorering",
    "SOUND_CHANGEVOLUMEBY": "endra lydstyrken med %1",
    "SOUND_SETVOLUMETO": "set lydstyrken til %1 %",
    "SOUND_VOLUME": "lydstyrke",
    "SOUND_RECORD": "spel inn …",
    "CATEGORY_MOTION": "Rørsle",
    "CATEGORY_LOOKS": "Utsjånad",
    "CATEGORY_SOUND": "Lyd",
    "CATEGORY_EVENTS": "Hendingar",
    "CATEGORY_CONTROL": "Styring",
    "CATEGORY_SENSING": "Sansing",
    "CATEGORY_OPERATORS": "Operatorar",
    "CATEGORY_VARIABLES": "Variablar",
    "CATEGORY_MYBLOCKS": "Mine klossar",
    "DUPLICATE": "Lag ein kopi",
    "DELETE": "Slett",
    "ADD_COMMENT": "Skriv kommentar",
    "REMOVE_COMMENT": "Fjern kommentar",
    "DELETE_BLOCK": "Slett kloss",
    "DELETE_X_BLOCKS": "Slett %1 klossar",
    "DELETE_ALL_BLOCKS": "Vil du sletta alle %1 klossane?",
    "CLEAN_UP": "Rydd opp i klossar",
    "HELP": "Hjelp",
    "UNDO": "Angra",
    "REDO": "Gjer om",
    "EDIT_PROCEDURE": "Rediger",
    "SHOW_PROCEDURE_DEFINITION": "Gå til definisjonen",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Sei noko …",
    "COLOUR_HUE_LABEL": "Farge",
    "COLOUR_SATURATION_LABEL": "Fargemetting",
    "COLOUR_BRIGHTNESS_LABEL": "Lysstyrke",
    "CHANGE_VALUE_TITLE": "Endra verdi:",
    "RENAME_VARIABLE": "Gje nytt namn",
    "RENAME_VARIABLE_TITLE": "Endra namnet på alle «%1»-variablane til:",
    "RENAME_VARIABLE_MODAL_TITLE": "Gje nytt namn",
    "NEW_VARIABLE": "Lag ein variabel",
    "NEW_VARIABLE_TITLE": "Namn på ny variabel:",
    "VARIABLE_MODAL_TITLE": "Ny variabel",
    "VARIABLE_ALREADY_EXISTS": "Det finst alt ein variabel som heiter «%1».",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Det finst alt ein variabel som heiter «%1», for ein annan variabel av type «%2».",
    "DELETE_VARIABLE_CONFIRMATION": "Vil du sletta %1 bruk av variabelen «%2»?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Kan ikkje sletta variabelen «%1», då han er del av definisjonen til funksjonen «%2».",
    "DELETE_VARIABLE": "Slett variabelen «%1»",
    "NEW_PROCEDURE": "Lag ein kloss",
    "PROCEDURE_ALREADY_EXISTS": "Det finst alt ein prosedyre som heiter «%1».",
    "PROCEDURE_DEFAULT_NAME": "klossnamn",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Lag ei liste",
    "NEW_LIST_TITLE": "Namn på ny liste:",
    "LIST_MODAL_TITLE": "Ny liste",
    "LIST_ALREADY_EXISTS": "Det finst alt ei liste som heiter «%1».",
    "RENAME_LIST_TITLE": "Endra namnet på alle «%1»-listene til:",
    "RENAME_LIST_MODAL_TITLE": "Gje nytt namn",
    "DEFAULT_LIST_ITEM": "ting",
    "DELETE_LIST": "Slett lista «%1»",
    "RENAME_LIST": "Gje nytt namn",
    "NEW_BROADCAST_MESSAGE": "Ny melding",
    "NEW_BROADCAST_MESSAGE_TITLE": "Namn på ny melding:",
    "BROADCAST_MODAL_TITLE": "Ny melding",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "melding1"
  },
  "oc": {
    "CONTROL_FOREVER": "per totjorn",
    "CONTROL_REPEAT": "repetir %1",
    "CONTROL_IF": "se %1 alara",
    "CONTROL_ELSE": "senon",
    "CONTROL_STOP": "estòp",
    "CONTROL_STOP_ALL": "tot",
    "CONTROL_STOP_THIS": "aquel escript",
    "CONTROL_STOP_OTHER": "autres escripts dins sprite",
    "CONTROL_WAIT": "esperar %1 segondas",
    "CONTROL_WAITUNTIL": "esperar fins a %1",
    "CONTROL_REPEATUNTIL": "repetir fins a %1",
    "CONTROL_WHILE": "pendent %1",
    "CONTROL_FOREACH": "per cada %1 de %2",
    "CONTROL_STARTASCLONE": "quand comenci coma un clòn",
    "CONTROL_CREATECLONEOF": "crear clòn de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ieu",
    "CONTROL_DELETETHISCLONE": "suprimir aquel clòn",
    "CONTROL_COUNTER": "comptador",
    "CONTROL_INCRCOUNTER": "comptador d'increment",
    "CONTROL_CLEARCOUNTER": "purgar comptador",
    "CONTROL_ALLATONCE": "tot a l'encòp",
    "DATA_SETVARIABLETO": "definir %1 a %2",
    "DATA_CHANGEVARIABLEBY": "cambiar %1 per %2",
    "DATA_SHOWVARIABLE": "mostrar variabla %1",
    "DATA_HIDEVARIABLE": "amagar variabla %1",
    "DATA_ADDTOLIST": "apondre %1 a %2",
    "DATA_DELETEOFLIST": "suprimir %1 de %2",
    "DATA_DELETEALLOFLIST": "suprimir tot de %1",
    "DATA_INSERTATLIST": "inserir %1 a %2 de %3",
    "DATA_REPLACEITEMOFLIST": "remplaçar element %1 de %2 amb %3",
    "DATA_ITEMOFLIST": "element %1 de %2",
    "DATA_ITEMNUMOFLIST": "element # de %1 dins %2",
    "DATA_LENGTHOFLIST": "longor de %1",
    "DATA_LISTCONTAINSITEM": "%1 conten %2 ?",
    "DATA_SHOWLIST": "mostrar tièra %1",
    "DATA_HIDELIST": "amagar tièra %1",
    "DATA_INDEX_ALL": "tot",
    "DATA_INDEX_LAST": "darrièr",
    "DATA_INDEX_RANDOM": "aleatòri",
    "EVENT_WHENFLAGCLICKED": "quand %1 es clicat",
    "EVENT_WHENTHISSPRITECLICKED": "quand aquela sprite es clicada",
    "EVENT_WHENSTAGECLICKED": "quand la scèna es clicada",
    "EVENT_WHENTOUCHINGOBJECT": "quand aquela sprite toca %1",
    "EVENT_WHENBROADCASTRECEIVED": "quand recebi %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "quand lo fon cambia per %1",
    "EVENT_WHENGREATERTHAN": "quand %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "minutor",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "intensitat",
    "EVENT_BROADCAST": "difusir %1",
    "EVENT_BROADCASTANDWAIT": "difusir %1 e esperar",
    "EVENT_WHENKEYPRESSED": "quand la toca %1 es premsada",
    "EVENT_WHENKEYPRESSED_SPACE": "espaci",
    "EVENT_WHENKEYPRESSED_LEFT": "sageta esquèrra",
    "EVENT_WHENKEYPRESSED_RIGHT": "sageta drecha",
    "EVENT_WHENKEYPRESSED_DOWN": "sageta bas",
    "EVENT_WHENKEYPRESSED_UP": "sageta naut",
    "EVENT_WHENKEYPRESSED_ANY": "Quin que siá",
    "LOOKS_SAYFORSECS": "dire %1 pendent %2 segondas",
    "LOOKS_SAY": "dire %1",
    "LOOKS_HELLO": "Adieu !",
    "LOOKS_THINKFORSECS": "pensar %1 pendent %2 segondas",
    "LOOKS_THINK": "pensar %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "mostrar",
    "LOOKS_HIDE": "amagar",
    "LOOKS_HIDEALLSPRITES": "amagar totas las sprites",
    "LOOKS_EFFECT_COLOR": "amagar totes las sprites",
    "LOOKS_EFFECT_FISHEYE": "Uèlh-de-peis",
    "LOOKS_EFFECT_WHIRL": "revolum",
    "LOOKS_EFFECT_PIXELATE": "pixelizar",
    "LOOKS_EFFECT_MOSAIC": "mosaïca",
    "LOOKS_EFFECT_BRIGHTNESS": "luminositat",
    "LOOKS_EFFECT_GHOST": "trèva",
    "LOOKS_CHANGEEFFECTBY": "cambiar %1 efièch per %2",
    "LOOKS_SETEFFECTTO": "reglar %1 efièch sus %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "purgar los efièches grafics",
    "LOOKS_CHANGESIZEBY": "cambiar la talha per %1",
    "LOOKS_SETSIZETO": "reglar la talha a %1 %",
    "LOOKS_SIZE": "talha",
    "LOOKS_CHANGESTRETCHBY": "cambiar estirament per %1",
    "LOOKS_SETSTRETCHTO": "reglar estirament a %1 %",
    "LOOKS_SWITCHCOSTUMETO": "escambiar lo costum per %1",
    "LOOKS_NEXTCOSTUME": "costum seguent",
    "LOOKS_SWITCHBACKDROPTO": "escambiar lo fons per %1",
    "LOOKS_GOTOFRONTBACK": "anar al clac %1 ",
    "LOOKS_GOTOFRONTBACK_FRONT": "davant",
    "LOOKS_GOTOFRONTBACK_BACK": "darrièr",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "anar %1 %2 calcs",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "endavant",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "endarrièr",
    "LOOKS_BACKDROPNUMBERNAME": "fons %1",
    "LOOKS_COSTUMENUMBERNAME": "costum %1",
    "LOOKS_NUMBERNAME_NUMBER": "numèro",
    "LOOKS_NUMBERNAME_NAME": "nom",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "escambiar fons per %1 e esperar",
    "LOOKS_NEXTBACKDROP_BLOCK": "fons seguent",
    "LOOKS_NEXTBACKDROP": "fons seguent",
    "LOOKS_PREVIOUSBACKDROP": "fons precedent",
    "LOOKS_RANDOMBACKDROP": "fons aleatòri",
    "MOTION_MOVESTEPS": "avançar %1 passes",
    "MOTION_TURNLEFT": "virar %1 %2 grases",
    "MOTION_TURNRIGHT": "virar %1 %2 grases",
    "MOTION_POINTINDIRECTION": "puntat dins la direccion %1",
    "MOTION_POINTTOWARDS": "puntat cap a %1",
    "MOTION_POINTTOWARDS_POINTER": "puntaire de mirga",
    "MOTION_POINTTOWARDS_RANDOM": "direccion aleatòria",
    "MOTION_GOTO": "anar a %1",
    "MOTION_GOTO_POINTER": "puntaire de mirga",
    "MOTION_GOTO_RANDOM": "posicion aleatòri",
    "MOTION_GOTOXY": "anar a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "lisar %1 s. cap a x%2 y: %3",
    "MOTION_GLIDETO": "lisar %1 s. cap a %2",
    "MOTION_GLIDETO_POINTER": "puntaire de mirga",
    "MOTION_GLIDETO_RANDOM": "posicion aleatòri",
    "MOTION_CHANGEXBY": "cambiar x per %1",
    "MOTION_SETX": "reglar x a %1",
    "MOTION_CHANGEYBY": "cambiar y per %1",
    "MOTION_SETY": "reglar y a %1",
    "MOTION_IFONEDGEBOUNCE": "se al ras, rebombir",
    "MOTION_SETROTATIONSTYLE": "reglar l'estil de rotation %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "esquèrra-drecha",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "pas virar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "tot a l'entorn",
    "MOTION_XPOSITION": "posicion x",
    "MOTION_YPOSITION": "posicion y",
    "MOTION_DIRECTION": "direccion",
    "MOTION_SCROLLRIGHT": "desfilar a drecha %1",
    "MOTION_SCROLLUP": "far desfilar ennaut %1",
    "MOTION_ALIGNSCENE": "alinhar scèna %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "enbas a esquèrra",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "enbas a drecha",
    "MOTION_ALIGNSCENE_MIDDLE": "al mitan",
    "MOTION_ALIGNSCENE_TOPLEFT": "ennaut a esquèrra",
    "MOTION_ALIGNSCENE_TOPRIGHT": "ennaut a drecha",
    "MOTION_XSCROLL": "desfilament x",
    "MOTION_YSCROLL": "desfilament y",
    "MOTION_STAGE_SELECTED": "Scèna seleccionada : pas de blòcs de moviment",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "causida aleatòria de %1 de %2 ",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 e %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "pas %1",
    "OPERATORS_JOIN": "juntar %1 %2",
    "OPERATORS_JOIN_APPLE": "poma",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "longor de %1",
    "OPERATORS_CONTAINS": "%1 conten %2 ?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "redond %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "arredondit.inf",
    "OPERATORS_MATHOP_CEILING": "arredondit.sup",
    "OPERATORS_MATHOP_SQRT": "rasiga",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "define %1",
    "SENSING_TOUCHINGOBJECT": "touching %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "puntaire de mirga",
    "SENSING_TOUCHINGOBJECT_EDGE": "bòrd",
    "SENSING_TOUCHINGCOLOR": "de tocar la color %1 ?",
    "SENSING_COLORISTOUCHINGCOLOR": "color %1 es a tocar %2",
    "SENSING_DISTANCETO": "distància a %1",
    "SENSING_DISTANCETO_POINTER": "puntaire de mirga",
    "SENSING_ASKANDWAIT": "demandar %1 e esperar",
    "SENSING_ASK_TEXT": "Cossí te sonas ?",
    "SENSING_ANSWER": "responsa",
    "SENSING_KEYPRESSED": "tòca %1 premsada ?",
    "SENSING_MOUSEDOWN": "mirga bassa ?",
    "SENSING_MOUSEX": "mirga x",
    "SENSING_MOUSEY": "mirga y",
    "SENSING_SETDRAGMODE": "reglar lo mòde de tirassar %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "tirassable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "pas tirassable",
    "SENSING_LOUDNESS": "intensitat",
    "SENSING_LOUD": "fòrt ?",
    "SENSING_TIMER": "minutor",
    "SENSING_RESETTIMER": "purgar lo minutor",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posicion x",
    "SENSING_OF_YPOSITION": "posicion y",
    "SENSING_OF_DIRECTION": "direccion",
    "SENSING_OF_COSTUMENUMBER": "costum #",
    "SENSING_OF_COSTUMENAME": "nom del costum",
    "SENSING_OF_SIZE": "talha",
    "SENSING_OF_VOLUME": "volum",
    "SENSING_OF_BACKDROPNUMBER": "fons #",
    "SENSING_OF_BACKDROPNAME": "nom del fons",
    "SENSING_OF_STAGE": "Scèna",
    "SENSING_CURRENT": "corrent %1",
    "SENSING_CURRENT_YEAR": "annada",
    "SENSING_CURRENT_MONTH": "mes",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "jorn de la setmana",
    "SENSING_CURRENT_HOUR": "ora",
    "SENSING_CURRENT_MINUTE": "minuta",
    "SENSING_CURRENT_SECOND": "segonda",
    "SENSING_DAYSSINCE2000": "jorns dempuèi 2000",
    "SENSING_USERNAME": "nom d'utilizaire",
    "SENSING_USERID": "id d'utilizaire",
    "SOUND_PLAY": "començar son  %1",
    "SOUND_PLAYUNTILDONE": "jogar son %1 fins a que s'acabe",
    "SOUND_STOPALLSOUNDS": "arrestat totes los sons",
    "SOUND_SETEFFECTO": "reglar %1 efièch sus %2",
    "SOUND_CHANGEEFFECTBY": "cambiar %1 efièch per %2",
    "SOUND_CLEAREFFECTS": "purgar los efièches de son",
    "SOUND_EFFECTS_PITCH": "ton",
    "SOUND_EFFECTS_PAN": "equilibrar drecha/esquèrra",
    "SOUND_CHANGEVOLUMEBY": "cambiar volum per %1",
    "SOUND_SETVOLUMETO": "reglar volum a %1%",
    "SOUND_VOLUME": "volum",
    "SOUND_RECORD": "enregistrar...",
    "CATEGORY_MOTION": "Moviment",
    "CATEGORY_LOOKS": "Aparéncias",
    "CATEGORY_SOUND": "Son",
    "CATEGORY_EVENTS": "Eveniments",
    "CATEGORY_CONTROL": "Contraròtle",
    "CATEGORY_SENSING": "Captors",
    "CATEGORY_OPERATORS": "Operators",
    "CATEGORY_VARIABLES": "Variablas",
    "CATEGORY_MYBLOCKS": "Mos Blòcs",
    "DUPLICATE": "Desdoblar",
    "DELETE": "Suprimir",
    "ADD_COMMENT": "Apondre Comentari",
    "REMOVE_COMMENT": "Suprimir Comentari",
    "DELETE_BLOCK": "Suprimir Blòc",
    "DELETE_X_BLOCKS": "Suprimir %1 Blòcs",
    "DELETE_ALL_BLOCKS": "Suprimir totes los %1 blòcs",
    "CLEAN_UP": "Netejar los Blòcs",
    "HELP": "Ajuda",
    "UNDO": "Anullar",
    "REDO": "Tornar far",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Anar a la definicion",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Dire quicòm...",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturacion",
    "COLOUR_BRIGHTNESS_LABEL": "Luminositat",
    "CHANGE_VALUE_TITLE": "Cambiar valor :",
    "RENAME_VARIABLE": "Tornar nomenar la variabla",
    "RENAME_VARIABLE_TITLE": "Tornar nomenar totes « %1 » variablas coma : ",
    "RENAME_VARIABLE_MODAL_TITLE": "Tornar nomenar Variabla",
    "NEW_VARIABLE": "Far una Variabla",
    "NEW_VARIABLE_TITLE": "Nom de la Variabla Novèla",
    "VARIABLE_MODAL_TITLE": "Variabla Novèla",
    "VARIABLE_ALREADY_EXISTS": "Una variabla nomenada « %1 » existís ja.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Una variable nomenada « %1 » existís ja per una autra variabla de tipe « %2 ».",
    "DELETE_VARIABLE_CONFIRMATION": "Suprimir las utilizacions %1 de la variable « %2 »",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "La variabla %1 pòt pas èsser suprimida, que fa partida de la definicion de la foncion « %2 »",
    "DELETE_VARIABLE": "Suprimir la variable « %1 »",
    "NEW_PROCEDURE": "Fargar un blòc",
    "PROCEDURE_ALREADY_EXISTS": "Un procediment nomenat « %1 » existís ja.",
    "PROCEDURE_DEFAULT_NAME": "nom del blòc",
    "PROCEDURE_USED": "Per suprimir la definicion d'un blòc, tirar primièr totas las utilizacions del blòc.",
    "NEW_LIST": "Far una tièra",
    "NEW_LIST_TITLE": "Nom de la tièra novèa",
    "LIST_MODAL_TITLE": "Novèla tièra",
    "LIST_ALREADY_EXISTS": "Una tièra nomenada « %1 » existís ja.",
    "RENAME_LIST_TITLE": "Tornar nomenar totas las tièras « %1 » en :",
    "RENAME_LIST_MODAL_TITLE": "Tornar nomenar la tièra",
    "DEFAULT_LIST_ITEM": "causa",
    "DELETE_LIST": "Suprimir la tièra « %1 »",
    "RENAME_LIST": "Tornar nomenar la tièra",
    "NEW_BROADCAST_MESSAGE": "Messatge novèl",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nom del messatge novèl",
    "BROADCAST_MODAL_TITLE": "Messatge novèl",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "messatge1"
  },
  "or": {
    "CONTROL_FOREVER": "ସବୁ ଦିନ ପାଇଁ ",
    "CONTROL_REPEAT": "%1 ପୁନରାବୃତ୍ତି କର",
    "CONTROL_IF": "ଯଦି %1 ତେବେ",
    "CONTROL_ELSE": "ଅଥବା",
    "CONTROL_STOP": "ବନ୍ଦ କର",
    "CONTROL_STOP_ALL": "ସବୁ",
    "CONTROL_STOP_THIS": "ଏହି ଲିପି",
    "CONTROL_STOP_OTHER": "ସ୍ପ୍ରାଇଟ ରେ ଥିବା ଅନ୍ୟ ଲିପି",
    "CONTROL_WAIT": "%1 ସେକେଣ୍ଡ ଅପେକ୍ଷା କର",
    "CONTROL_WAITUNTIL": "%1 ସେକେଣ୍ଡ ପର୍ଯନ୍ତ ଅପେକ୍ଷା କର",
    "CONTROL_REPEATUNTIL": "%1 ପର୍ଯନ୍ତ ପୁନରାବୃତ୍ତି କର ",
    "CONTROL_WHILE": "ଯେ ପର୍ଯନ୍ତ  %1 ",
    "CONTROL_FOREACH": "ପ୍ରତ୍ଯେକ %1 ରୁ %2  ",
    "CONTROL_STARTASCLONE": "ମୋର ଏକ କ୍ଲୋନ ରୂପରେ ଆରମ୍ଭ ହେଲାପରେ",
    "CONTROL_CREATECLONEOF": "%1 ର କ୍ଲୋନ ତିଆର କର ",
    "CONTROL_CREATECLONEOF_MYSELF": "ନିଜେ ",
    "CONTROL_DELETETHISCLONE": "ଏହି କ୍ଲୋନ କୁ ଲିଭାଇ ଦିଅ",
    "CONTROL_COUNTER": "ଗଣକ",
    "CONTROL_INCRCOUNTER": "ଗଣକ କୁ ଏକ ବଢାଅ",
    "CONTROL_CLEARCOUNTER": "ଗଣକ କୁ ଲିଭାଇ ଦିଅ",
    "CONTROL_ALLATONCE": "ସବୁ ଗୋଟିଏ ଥରରେ",
    "DATA_SETVARIABLETO": " %1 କୁ %2 ରେ ବଦଳାଇଦିଅ",
    "DATA_CHANGEVARIABLEBY": " %1 ରେ  %2 ମିଶାଇ ଦିଅ",
    "DATA_SHOWVARIABLE": "%1 ଭେରିଏବଲ୍ ଟି ଦର୍ଶାଅ",
    "DATA_HIDEVARIABLE": "ଭେରିଏବଲ୍ %1 କୁ ଲୁଚାଅ",
    "DATA_ADDTOLIST": "%2 ରେ %1 ମିଶାଅ",
    "DATA_DELETEOFLIST": "%2 ରୁ %1 ବିଲୋପ କର",
    "DATA_DELETEALLOFLIST": "%1 କୁ ପୁରା ବିଲୋପ କର",
    "DATA_INSERTATLIST": " %1 କୁ %3 ର %2 ଠାରେ ରଖ ",
    "DATA_REPLACEITEMOFLIST": "%2 ର %1 ତମ ବସ୍ତୁ କୁ %3 ଦ୍ବାରା ବଦଳାଇ ଦିଅ",
    "DATA_ITEMOFLIST": "%2 ର %1 ତମ ବସ୍ତୁ ",
    "DATA_ITEMNUMOFLIST": "%2 ରେ %1 ତମ ବସ୍ତୁ",
    "DATA_LENGTHOFLIST": "%1 ର ଦୈର୍ଘ୍ୟ",
    "DATA_LISTCONTAINSITEM": "%1 ରେ %2 ଅଛି କି?",
    "DATA_SHOWLIST": "%1 ତାଲିକା ଦେଖାଅ",
    "DATA_HIDELIST": "%1 ତାଲିକା ଲୁଚାଅ",
    "DATA_INDEX_ALL": "ସବୁ",
    "DATA_INDEX_LAST": "ଶେଷ",
    "DATA_INDEX_RANDOM": "କ୍ରମହୀନ",
    "EVENT_WHENFLAGCLICKED": "ଯେବେ %1 କୁ କ୍ଲିକ କରାଯିବ",
    "EVENT_WHENTHISSPRITECLICKED": "ଯେତେବେଳେ ଏହି ସ୍ପ୍ରାଇଟ କ୍ଲିକ କରାଯାଏ",
    "EVENT_WHENSTAGECLICKED": "ଯେତେବେଳେ ମଞ୍ଚ କୁ କ୍ଲିକ କରାଯାଏ",
    "EVENT_WHENTOUCHINGOBJECT": "ଯେତେବେଳେ ଏହି ସ୍ପ୍ରାଇଟ %1 କୁ ସ୍ପର୍ଶ କରିବ",
    "EVENT_WHENBROADCASTRECEIVED": "ଯେତେବେଳେ ମୋତେ %1 ମିଳେ ",
    "EVENT_WHENBACKDROPSWITCHESTO": "ଯେତେବେଳେ ପୃଷ୍ଠଭୂମି %1 କୁ ବଦଳି ଯାଏ",
    "EVENT_WHENGREATERTHAN": "ଯେତେବେଳେ %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "ଘଣ୍ଟା",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ଶବ୍ଦ ର ତୀବ୍ରତା",
    "EVENT_BROADCAST": "%1 କୁ ପ୍ରସାରଣ କର",
    "EVENT_BROADCASTANDWAIT": "%1 ପ୍ରସାରଣ କରି ଅପେକ୍ଷା କର",
    "EVENT_WHENKEYPRESSED": "ଯେବେ %1 ଚାବି ଟି କୁ ଦାବି ଦିଆ ଯାଏ",
    "EVENT_WHENKEYPRESSED_SPACE": "ଶୂନ୍ୟ ସ୍ଥାନ",
    "EVENT_WHENKEYPRESSED_LEFT": "ବାମ ତୀର",
    "EVENT_WHENKEYPRESSED_RIGHT": "ଦକ୍ଷିଣ ତୀର",
    "EVENT_WHENKEYPRESSED_DOWN": "ତଳ ତୀର",
    "EVENT_WHENKEYPRESSED_UP": "ଉପର ତୀର",
    "EVENT_WHENKEYPRESSED_ANY": "କୌଣସି",
    "LOOKS_SAYFORSECS": "%1 କୁ %2 ସେକେଣ୍ଡ ପର୍ଯନ୍ତ କୁହ",
    "LOOKS_SAY": "%1 କୁହ",
    "LOOKS_HELLO": "ନମସ୍କାର",
    "LOOKS_THINKFORSECS": "%1 କୁ %2 ସେକେଣ୍ଡ ପର୍ଯନ୍ତ ଚିନ୍ତା କର",
    "LOOKS_THINK": "%1 ଭାବ",
    "LOOKS_HMM": "ହୁଁ",
    "LOOKS_SHOW": "ଦେଖାଅ",
    "LOOKS_HIDE": "ଲୁଚାଅ",
    "LOOKS_HIDEALLSPRITES": "ସବୁ ସ୍ପ୍ରାଇଟ ମାନଙ୍କୁ ଲୁଚାଇ ଦିଅ",
    "LOOKS_EFFECT_COLOR": "ରଙ୍ଗ",
    "LOOKS_EFFECT_FISHEYE": "ମାଛି ଆଖି",
    "LOOKS_EFFECT_WHIRL": "ଗୋଳେଇବା",
    "LOOKS_EFFECT_PIXELATE": "ପିକ୍ସେଲେଟ",
    "LOOKS_EFFECT_MOSAIC": "ମୋଜେଇକ ",
    "LOOKS_EFFECT_BRIGHTNESS": "ଉଜ୍ଜ୍ଵଳତା",
    "LOOKS_EFFECT_GHOST": "ଭୁତ",
    "LOOKS_CHANGEEFFECTBY": "%1 ର ପ୍ରଭାବ କୁ %2 ଦ୍ବାରା ବଦଳାଅ",
    "LOOKS_SETEFFECTTO": "%1 ର ପ୍ରଭାବ କୁ %2 ରେ ବଦଳାଇ ଦିଅ",
    "LOOKS_CLEARGRAPHICEFFECTS": "ଚିତ୍ରରୂପ ର ପ୍ରଭାବ କୁ ବିଲୋପ କର",
    "LOOKS_CHANGESIZEBY": "ଆକାର କୁ %1 ବଦଳାଅ",
    "LOOKS_SETSIZETO": "ଆକାର କୁ  %1 % ରଖ",
    "LOOKS_SIZE": "ଆକାର",
    "LOOKS_CHANGESTRETCHBY": "ବିସ୍ତାର କୁ %1 ବଦଳାଅ",
    "LOOKS_SETSTRETCHTO": "ବିସ୍ତାର କୁ %1 % ରଖ",
    "LOOKS_SWITCHCOSTUMETO": "ପୋଷାକ %1 କୁ ବଦଳାଇ ଦିଅ",
    "LOOKS_NEXTCOSTUME": "ପରବର୍ତୀ ପୋଷାକ",
    "LOOKS_SWITCHBACKDROPTO": "ପୃଷ୍ଠଭୂମି %1 କୁ ବଦଳାଅ",
    "LOOKS_GOTOFRONTBACK": "%1 ସ୍ତର କୁ ଯାଅ",
    "LOOKS_GOTOFRONTBACK_FRONT": "ସାମନା",
    "LOOKS_GOTOFRONTBACK_BACK": "ପାଶ୍ଚାତ ଭାଗ",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 ସ୍ତର କୁ ଯାଅ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ଆଗକୁ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "ପଛକୁ",
    "LOOKS_BACKDROPNUMBERNAME": "%1 ପୃଷ୍ଠଭୂମି",
    "LOOKS_COSTUMENUMBERNAME": "%1 ପୋଷାକ",
    "LOOKS_NUMBERNAME_NUMBER": "ଅଙ୍କ",
    "LOOKS_NUMBERNAME_NAME": "ନାଁ",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "ପୃଷ୍ଠଭୂମି %1 କୁ ବଦଳାଅ ଓ ଅପେକ୍ଷା କର",
    "LOOKS_NEXTBACKDROP_BLOCK": "ପରବର୍ତୀ ପୃଷ୍ଠଭୂମି",
    "LOOKS_NEXTBACKDROP": "ପରବର୍ତୀ ପୃଷ୍ଠଭୂମି",
    "LOOKS_PREVIOUSBACKDROP": "ପୂର୍ବବର୍ତୀ ପୃଷ୍ଠଭୂମି",
    "LOOKS_RANDOMBACKDROP": "କ୍ରମହୀନ ପୃଷ୍ଟଭୂମି",
    "MOTION_MOVESTEPS": "%1 ପାଦ ଆଗକୁ ଯାଅ",
    "MOTION_TURNLEFT": "%1 କୁ %2 ଡିଗ୍ରୀ ମୋଡ",
    "MOTION_TURNRIGHT": "%1କୁ  %2 ଡିଗ୍ରୀ ମୋଡ ",
    "MOTION_POINTINDIRECTION": "%1 ଦିଗରେ ମୁହାଁଇ ଦିଅ",
    "MOTION_POINTTOWARDS": "%1 ଦିଗରେ ମୁହାଁଇ ଦିଅ",
    "MOTION_POINTTOWARDS_POINTER": "ମାଉସ-ସୂଚକ",
    "MOTION_POINTTOWARDS_RANDOM": "କ୍ରମବିହୀନ ଦିଗ",
    "MOTION_GOTO": "%1 କୁ ଯାଅ",
    "MOTION_GOTO_POINTER": "ମାଉସ-ସୂଚକ",
    "MOTION_GOTO_RANDOM": "ଯେକୌଣସି ସ୍ଥାନ",
    "MOTION_GOTOXY": "x: %1  y: %2 କୁ ଯାଅ",
    "MOTION_GLIDESECSTOXY": "%1 ସେକେଣ୍ଡ  x: %2 y: %3 କୁ ଖସାଅ",
    "MOTION_GLIDETO": "%1 ସେକେଣ୍ଡ %2 କୁ ଖସାଅ",
    "MOTION_GLIDETO_POINTER": "ମାଉସ-ସୂଚକ",
    "MOTION_GLIDETO_RANDOM": "ଯେକୌଣସି ସ୍ଥାନ",
    "MOTION_CHANGEXBY": "x କୁ %1 ଦ୍ବାରା ବଦଳାଅ",
    "MOTION_SETX": "x କୁ %1 କର",
    "MOTION_CHANGEYBY": "y କୁ %1 ଦ୍ବାରା ବଦଳ କର",
    "MOTION_SETY": "y କୁ %1 କର",
    "MOTION_IFONEDGEBOUNCE": "ଯଦି ସୀମା ରେ ଅଛ ତାହେଲେ ଡିଆଁ ମାର",
    "MOTION_SETROTATIONSTYLE": "%1 କୁ ଘୂରିବାର ଶୈଳୀ ବାଛ",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "ବାମ-ଡାହାଣ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ଘୂର ନାହିଁ",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "ସବୁ ଆଡେ",
    "MOTION_XPOSITION": "x ସ୍ଥିତି",
    "MOTION_YPOSITION": "y ସ୍ଥିତି",
    "MOTION_DIRECTION": "ଦିଗ",
    "MOTION_SCROLLRIGHT": "ଡାହାଣ ଦିଗ କୁ %1 ଗଡି ଯାଅ",
    "MOTION_SCROLLUP": "ଉପର ଆଡକୁ %1 ଗଡାଅ",
    "MOTION_ALIGNSCENE": "ଦୃଶ୍ୟ %1 କୁ କ୍ରମବଦ୍ଧ କର",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ତଳ-ବାମ",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ତଳ-ଡାହାଣ",
    "MOTION_ALIGNSCENE_MIDDLE": "ମଝିରେ",
    "MOTION_ALIGNSCENE_TOPLEFT": "ଉପର-ବାମ",
    "MOTION_ALIGNSCENE_TOPRIGHT": "ଉପର ଡାହାଣ",
    "MOTION_XSCROLL": "x ଗଡାଅ",
    "MOTION_YSCROLL": "y ଗଡାଅ",
    "MOTION_STAGE_SELECTED": "ମଞ୍ଚ ବଛା ଯାଇଛି : କୌଣସି ଗତିଶୀଳ ବ୍ଲକ ନାହାନ୍ତି",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 ରୁ %2 ପର୍ଯନ୍ତ ଯେକୌଣସି ସଂଖ୍ୟା ବାଛ",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 ଓ %2",
    "OPERATORS_OR": "%1 ବା %2",
    "OPERATORS_NOT": "%1 ନୁହେଁ ",
    "OPERATORS_JOIN": "ଯୋଗ ଦିଅନ୍ତୁ %1 %2 ",
    "OPERATORS_JOIN_APPLE": "ସେଉ",
    "OPERATORS_JOIN_BANANA": "କଦଳୀ",
    "OPERATORS_LETTEROF": "%2 ରୁ  %1 ଅକ୍ଷର ",
    "OPERATORS_LETTEROF_APPLE": "स",
    "OPERATORS_LENGTH": "%1 ର ଦୈର୍ଘ୍ୟ",
    "OPERATORS_CONTAINS": "%1 ରେ %2 ଅନ୍ତର୍ଭୁକ୍ତ ?",
    "OPERATORS_MOD": "%1 ମଡ଼ %2",
    "OPERATORS_ROUND": "ଗୋଲ %1 ",
    "OPERATORS_MATHOP": "%2 ରୁ %1",
    "OPERATORS_MATHOP_ABS": "ଏବିଏସ",
    "OPERATORS_MATHOP_FLOOR": "ତଳ",
    "OPERATORS_MATHOP_CEILING": "ଛାତ",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "cosec ",
    "OPERATORS_MATHOP_ATAN": "cot",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10^",
    "PROCEDURES_DEFINITION": "%1 କୁ ବୁଝାଅ",
    "SENSING_TOUCHINGOBJECT": "%1 ସ୍ପର୍ଶ କରୁଥିବା?",
    "SENSING_TOUCHINGOBJECT_POINTER": "ମାଉସ-ସୂଚକ",
    "SENSING_TOUCHINGOBJECT_EDGE": "ଧାର",
    "SENSING_TOUCHINGCOLOR": "%1 ରଙ୍ଗ କୁ ସ୍ପର୍ଶ କରୁଛି?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 ରଙ୍ଗ %2 କୁ ସ୍ପର୍ଶ କରୁଛି?",
    "SENSING_DISTANCETO": "%1 ପର୍ଯ୍ୟନ୍ତ ଦୂରତା",
    "SENSING_DISTANCETO_POINTER": "ମାଉସ-ସୂଚକ",
    "SENSING_ASKANDWAIT": "%1 ପଚାର ଓ ଅପେକ୍ଷା କର ",
    "SENSING_ASK_TEXT": "ତୁମ ନାଁ କଣ?",
    "SENSING_ANSWER": "ଉତ୍ତର",
    "SENSING_KEYPRESSED": "ଯେବେ %1 ବୋତାମ ଦବା ଯିବ?",
    "SENSING_MOUSEDOWN": "ମାଉସ ତଳକୁ?",
    "SENSING_MOUSEX": "ମାଉସ x",
    "SENSING_MOUSEY": "ମାଉସ y",
    "SENSING_SETDRAGMODE": "ଟାଣିବାର ପ୍ରକାର %1 ରଖ",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ଟାଣିବା ଯୋଗ୍ୟ",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ଟାଣିବା ଅଯୋଗ୍ୟ",
    "SENSING_LOUDNESS": "ଶବ୍ଦ ର ତୀବ୍ରତା",
    "SENSING_LOUD": "ଅଧିକ?",
    "SENSING_TIMER": "ଘଣ୍ଟା",
    "SENSING_RESETTIMER": "ଘଂଟା କୁ ରିସେଟ କର",
    "SENSING_OF": "%2 ର %1",
    "SENSING_OF_XPOSITION": "x ସ୍ଥିତି ",
    "SENSING_OF_YPOSITION": "y ସ୍ଥିତି ",
    "SENSING_OF_DIRECTION": "ଦିଗ ",
    "SENSING_OF_COSTUMENUMBER": "ପୋଷାକ #",
    "SENSING_OF_COSTUMENAME": "ପୋଷାକ ର ନାମ",
    "SENSING_OF_SIZE": "ଆକାର",
    "SENSING_OF_VOLUME": "ତୀବ୍ରତା",
    "SENSING_OF_BACKDROPNUMBER": "ପୃଷ୍ଠଭୂମି #",
    "SENSING_OF_BACKDROPNAME": "ପୃଷ୍ଠଭୂମି ର ନାମ",
    "SENSING_OF_STAGE": "ମଂଚ ",
    "SENSING_CURRENT": "ଏବର %1",
    "SENSING_CURRENT_YEAR": "ବର୍ଷ ",
    "SENSING_CURRENT_MONTH": "ମାସ",
    "SENSING_CURRENT_DATE": "ତାରିଖ",
    "SENSING_CURRENT_DAYOFWEEK": "ଦିନ",
    "SENSING_CURRENT_HOUR": "ଘଣ୍ଟା",
    "SENSING_CURRENT_MINUTE": "ମିନିଟ",
    "SENSING_CURRENT_SECOND": "ସେକେଣ୍ଡ",
    "SENSING_DAYSSINCE2000": "ବର୍ଷ 2000 ପରଠାରୁ ଦିନ",
    "SENSING_USERNAME": "ବ୍ୟବହାରକାରୀ ର ନାମ",
    "SENSING_USERID": "ବ୍ୟବହାରକାରୀ ର ଚିହ୍ନ",
    "SOUND_PLAY": "ଶବ୍ଦ %1 ଆରମ୍ଭ କର ",
    "SOUND_PLAYUNTILDONE": "ଶବ୍ଦ %1 ଶେଷ ପର୍ଯ୍ୟନ୍ତ କର",
    "SOUND_STOPALLSOUNDS": "ସବୁ ଶବ୍ଦ ବନ୍ଦ କର",
    "SOUND_SETEFFECTO": "%1 ପ୍ରଭାବ କୁ %2 ରେ ରଖ",
    "SOUND_CHANGEEFFECTBY": "%1 ପ୍ରଭାବ କୁ %2 ରେ ବଦଳାଅ",
    "SOUND_CLEAREFFECTS": "ଶବ୍ଦ ର ପ୍ରଭାବ କୁ ବନ୍ଦ କର",
    "SOUND_EFFECTS_PITCH": "ଧ୍ବନୀ ର ସ୍ତର",
    "SOUND_EFFECTS_PAN": "ବାମ-ଡାହାଣ କୁ ଦେଖାଅ",
    "SOUND_CHANGEVOLUMEBY": "%1 ରେ ତୀବ୍ରତା ବଦଳାଅ",
    "SOUND_SETVOLUMETO": "ଶବ୍ଦ ର ତୀବ୍ରତା କୁ %1% ରଖ",
    "SOUND_VOLUME": "ତୀବ୍ରତା",
    "SOUND_RECORD": "ଲିପିବଦ୍ଧ କରିବା ...",
    "CATEGORY_MOTION": "ଗତି",
    "CATEGORY_LOOKS": "ରୂପ",
    "CATEGORY_SOUND": "ଶବ୍ଦ",
    "CATEGORY_EVENTS": "ଘଟଣାକ୍ରମ",
    "CATEGORY_CONTROL": "ନିୟନ୍ତ୍ରଣ",
    "CATEGORY_SENSING": "ଅନୁଭବ କରିବା",
    "CATEGORY_OPERATORS": "ଅପରେଟର ଗୁଡିକ",
    "CATEGORY_VARIABLES": "ଭେରିଏବଲ୍ ଗୁଡିକ",
    "CATEGORY_MYBLOCKS": "ମୋ ବ୍ଲକ ଗୁଡି଼କ",
    "DUPLICATE": "ପ୍ରତିରୂପ",
    "DELETE": "ଲିଭାଅ",
    "ADD_COMMENT": "ଟିପ୍ପଣୀ ଦିଅ",
    "REMOVE_COMMENT": "ଟିପ୍ପଣୀ ଲିଭାଅ",
    "DELETE_BLOCK": "ବ୍ଲକ ଲିଭାଅ",
    "DELETE_X_BLOCKS": "%1 ବ୍ଲକ ଲିଭାଅ",
    "DELETE_ALL_BLOCKS": "ସବୁ %1 ବ୍ଲକ ଗୁଡିକୁ ଲିଭାଅ ",
    "CLEAN_UP": "ବ୍ଲକ ଗୁଡିକୁ ସଫା କର ",
    "HELP": "ସହାୟତା ",
    "UNDO": "ପୂର୍ବବତ",
    "REDO": "ପୁଣି",
    "EDIT_PROCEDURE": "ସଂପାଦନ କର",
    "SHOW_PROCEDURE_DEFINITION": "ସଂଜ୍ଞା କୁ ଯାଅ",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "କିଛି କୁହ...",
    "COLOUR_HUE_LABEL": "ରଂଗ",
    "COLOUR_SATURATION_LABEL": "ପରିପୃଷ୍ଠି",
    "COLOUR_BRIGHTNESS_LABEL": "ଉଜ୍ଜ୍ଵଳତା",
    "CHANGE_VALUE_TITLE": "ସଂଖ୍ୟା ବଦଳାଅ",
    "RENAME_VARIABLE": "ଭେରିଏବଲ୍ ର ନାମ ପରିବର୍ତନ କର",
    "RENAME_VARIABLE_TITLE": "ସବୁ \"%1\" ଭେରିଏବଲ୍ ର ନାମ ପରିବର୍ତନ କର",
    "RENAME_VARIABLE_MODAL_TITLE": "ଭେରିଏବଲ୍ ର ନାମ ପରିବର୍ତନ କର",
    "NEW_VARIABLE": "ଭେରିଏବଲ୍ ତିଆରି କର",
    "NEW_VARIABLE_TITLE": "ନୂଆ ଭେରିଏବଲ୍ ର ନାମ",
    "VARIABLE_MODAL_TITLE": "ନୂଆ ଭେରିଏବଲ୍ ",
    "VARIABLE_ALREADY_EXISTS": "\"%1\" ଭେରିଏବଲ୍ ଆଗରୁ ଅଛି,",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "\"%1\" ଭେରିଏବଲ୍ ଆଗରୁ ଅଛି, ଅନ୍ୟ ଭେରିଏବଲ୍ ପାଇଁ \"%2\" ଲେଖ",
    "DELETE_VARIABLE_CONFIRMATION": "\"%2\" ଭେରିଏବଲ୍ ର %1 ବ୍ୟବହାର ଲିଭାଅ ",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "\"%1\" ଭେରିଏବଲ୍ କୁ ଲିଭାଇବା ସମ୍ଭବ ନୁହେଁ, କାରଣ ଏହା ଫଙ୍କସନ \"%2\" ର ଅଂଶ ଅଟେ ",
    "DELETE_VARIABLE": "\"%1\" ଭେରିଏବଲ୍ କୁ ଲିଭାଇ ଦିଅ",
    "NEW_PROCEDURE": "ବ୍ଲକ ତିଆରି କର",
    "PROCEDURE_ALREADY_EXISTS": "\"%1\" ନାମକ ଗୋଟିଏ ପ୍ରକ୍ରିୟା ପୂର୍ବରୁ ଅବସ୍ଥିତ ଅଛି।",
    "PROCEDURE_DEFAULT_NAME": "ବ୍ଲକ ର ନାମ",
    "PROCEDURE_USED": "ବ୍ଲକ ର ସଂଜ୍ଞା ବଦଳାଇବା ପାଇଁ ପ୍ରଥମେ ବ୍ଲକ ର ସବୁ ବ୍ୟବହାର ହଟାଅ",
    "NEW_LIST": "ସୂଚୀ ତିଆରି କର/",
    "NEW_LIST_TITLE": "ନୂଆ ସୂଚୀ ର ନାମ/",
    "LIST_MODAL_TITLE": "ନୂଆ ସୂଚୀ",
    "LIST_ALREADY_EXISTS": "\"%1\" ନାମକ ଗୋଟିଏ ତାଲିକା ପୂର୍ବରୁ ଅବସ୍ଥିତ ଅଛି।",
    "RENAME_LIST_TITLE": "ସମସ୍ତ \"%1\" ତାଲିକାକୁ ପୁନଃନାମକରଣ କରନ୍ତୁ:",
    "RENAME_LIST_MODAL_TITLE": "ସୂଚୀ  ର ନାମ ବଦଳାଅ/",
    "DEFAULT_LIST_ITEM": "ବସ୍ତୁ ",
    "DELETE_LIST": "\"%1\" ତାଲିକାକୁ ଅପସାରଣ କରନ୍ତୁ",
    "RENAME_LIST": "ସୂଚୀ  ର ନାମ ବଦଳାଅ",
    "NEW_BROADCAST_MESSAGE": "ନୂଆ ସନ୍ଦେଶ",
    "NEW_BROADCAST_MESSAGE_TITLE": "ନୂଆ ସନ୍ଦେଶ ର ନାମ:",
    "BROADCAST_MODAL_TITLE": "ନୂଆ ସନ୍ଦେଶ",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "ସନ୍ଦେଶ 1 "
  },
  "uz": {
    "CONTROL_FOREVER": "har doim",
    "CONTROL_REPEAT": "%1 marta takrorlash",
    "CONTROL_IF": "agar %1 bo'lsa",
    "CONTROL_ELSE": "aks holda",
    "CONTROL_STOP": "to'xtatish",
    "CONTROL_STOP_ALL": "hammasini",
    "CONTROL_STOP_THIS": "bu skript",
    "CONTROL_STOP_OTHER": "boshqa spraytlardagi skriptlar",
    "CONTROL_WAIT": "%1 soniya kutish",
    "CONTROL_WAITUNTIL": "%1 gacha kutish",
    "CONTROL_REPEATUNTIL": "%1 gacha takrorlash",
    "CONTROL_WHILE": "%1 davomida",
    "CONTROL_FOREACH": "%2 dagi har bir %1 uchun ",
    "CONTROL_STARTASCLONE": "nusxani qabul qilganda",
    "CONTROL_CREATECLONEOF": "%1 o'zidan nusxa yaratish",
    "CONTROL_CREATECLONEOF_MYSELF": "o'zini",
    "CONTROL_DELETETHISCLONE": "bu nusxani o'chirish",
    "CONTROL_COUNTER": "hisoblagich",
    "CONTROL_INCRCOUNTER": "hisoblagichni orttirish",
    "CONTROL_CLEARCOUNTER": "hisoblagichni yangilash",
    "CONTROL_ALLATONCE": "bir vaqtning o'zida",
    "DATA_SETVARIABLETO": "%1 ni %2 ga sozlash",
    "DATA_CHANGEVARIABLEBY": "%1 ni %2 ga o'zgartirish",
    "DATA_SHOWVARIABLE": "%1 o'zgaruvchini ko'rsatish",
    "DATA_HIDEVARIABLE": "%1 o'zgaruvchini yashirish",
    "DATA_ADDTOLIST": "%1 ni %2 ga qo'shish",
    "DATA_DELETEOFLIST": "%1 ni %2 dan o'chirish",
    "DATA_DELETEALLOFLIST": "%1 hammasini o'chirish",
    "DATA_INSERTATLIST": "%1 ni %2 dan %3 ga qo'shish",
    "DATA_REPLACEITEMOFLIST": "%2 ro'yxatning %1 chi mavzusini %3 ga o'zgartirish",
    "DATA_ITEMOFLIST": "%2 ro'yxatning %1 chi mavzusi",
    "DATA_ITEMNUMOFLIST": "%2 ro'yxatda %1 mavzuning joylashuvi",
    "DATA_LENGTHOFLIST": "uzunligidan %1",
    "DATA_LISTCONTAINSITEM": "%1 %2 ni ichiga oladimi?",
    "DATA_SHOWLIST": "%1 ro'yxatni ko'rsatish",
    "DATA_HIDELIST": "%1 ro'yxatni yashirish",
    "DATA_INDEX_ALL": "hammasi",
    "DATA_INDEX_LAST": "oxirgisi",
    "DATA_INDEX_RANDOM": "tasodifiy",
    "EVENT_WHENFLAGCLICKED": " %1 bosilganda",
    "EVENT_WHENTHISSPRITECLICKED": "shu sprayt bosilganda",
    "EVENT_WHENSTAGECLICKED": "sahna bosilganda",
    "EVENT_WHENTOUCHINGOBJECT": "shu sprayt %1 ga teginganda",
    "EVENT_WHENBROADCASTRECEIVED": "%1 ga teginganda",
    "EVENT_WHENBACKDROPSWITCHESTO": "%1 fon o'zgarganda",
    "EVENT_WHENGREATERTHAN": "%1 > %2 bo'lganda",
    "EVENT_WHENGREATERTHAN_TIMER": "taymer",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "tovush",
    "EVENT_BROADCAST": "%1 ni tarqatish",
    "EVENT_BROADCASTANDWAIT": "%1 ni tarqatib kutish",
    "EVENT_WHENKEYPRESSED": "%1 bosilganda",
    "EVENT_WHENKEYPRESSED_SPACE": "bo'sh joy",
    "EVENT_WHENKEYPRESSED_LEFT": "chap ko'rsatgich",
    "EVENT_WHENKEYPRESSED_RIGHT": "o'ng ko'rsatgich",
    "EVENT_WHENKEYPRESSED_DOWN": "past ko'rsatgich",
    "EVENT_WHENKEYPRESSED_UP": "yuqori ko'rsatgich",
    "EVENT_WHENKEYPRESSED_ANY": "ixtiyoriy boshqa",
    "LOOKS_SAYFORSECS": "%1 ni %2 soniya aytish",
    "LOOKS_SAY": "%1 aytish",
    "LOOKS_HELLO": "Salom!",
    "LOOKS_THINKFORSECS": "%1 ni %2 soniya o'ylash",
    "LOOKS_THINK": "%1 o'ylash",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "ko'rsatish",
    "LOOKS_HIDE": "yashirish",
    "LOOKS_HIDEALLSPRITES": "hamma spraytlarni yashirish",
    "LOOKS_EFFECT_COLOR": "rang",
    "LOOKS_EFFECT_FISHEYE": "baliq ko'zi",
    "LOOKS_EFFECT_WHIRL": "aylanish",
    "LOOKS_EFFECT_PIXELATE": "piksellashtirish",
    "LOOKS_EFFECT_MOSAIC": "mozayka",
    "LOOKS_EFFECT_BRIGHTNESS": "yorqinlik",
    "LOOKS_EFFECT_GHOST": "sharpa",
    "LOOKS_CHANGEEFFECTBY": "%1 effektni %2 ga o'zgartir",
    "LOOKS_SETEFFECTTO": "%1 effektni %2 ga sozlash",
    "LOOKS_CLEARGRAPHICEFFECTS": "grafik effektlarni tozalsh",
    "LOOKS_CHANGESIZEBY": "o'lchamni %1 ga o'zgartir",
    "LOOKS_SETSIZETO": "o'lchamni %1 ga sozlash",
    "LOOKS_SIZE": "o'lcham",
    "LOOKS_CHANGESTRETCHBY": "uzunlikni %1 ga o'zgartir",
    "LOOKS_SETSTRETCHTO": "uzunlikni %1 ga sozlash",
    "LOOKS_SWITCHCOSTUMETO": "ko'rinishni %1 ga o'zgartir",
    "LOOKS_NEXTCOSTUME": "keyingi ko'rinish",
    "LOOKS_SWITCHBACKDROPTO": "fonni %1 ga o'zgartir",
    "LOOKS_GOTOFRONTBACK": "eng %1 ga o'tkazish",
    "LOOKS_GOTOFRONTBACK_FRONT": "oldinga",
    "LOOKS_GOTOFRONTBACK_BACK": "orqaga",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 ga %2 qatlam o'tkazish",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "oldinga",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "orqaga",
    "LOOKS_BACKDROPNUMBERNAME": "fon %1",
    "LOOKS_COSTUMENUMBERNAME": "ko'rinish %1",
    "LOOKS_NUMBERNAME_NUMBER": "raqam",
    "LOOKS_NUMBERNAME_NAME": "nomi",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "%1 fonga o'zgartirib kutish",
    "LOOKS_NEXTBACKDROP_BLOCK": "keyingi fon",
    "LOOKS_NEXTBACKDROP": "keyingi fon",
    "LOOKS_PREVIOUSBACKDROP": "oldingi fon",
    "LOOKS_RANDOMBACKDROP": "tasodifiy fon",
    "MOTION_MOVESTEPS": "%1 qadam yurish",
    "MOTION_TURNLEFT": "%1 %2 darajaga burilish",
    "MOTION_TURNRIGHT": "%1 %2 darajaga burilish",
    "MOTION_POINTINDIRECTION": "%1 harakat yo'nalishi ",
    "MOTION_POINTTOWARDS": "%1 tomonga qarash",
    "MOTION_POINTTOWARDS_POINTER": "sichqon-ko'rsatkichi",
    "MOTION_POINTTOWARDS_RANDOM": "tasodifiy yo'nalish",
    "MOTION_GOTO": "%1 ga borish",
    "MOTION_GOTO_POINTER": "sichqon-ko'rsatkichi",
    "MOTION_GOTO_RANDOM": "tasodifiy joyi",
    "MOTION_GOTOXY": "x: %1 y: %2 ga borish",
    "MOTION_GLIDESECSTOXY": "%1 soniyada x: %2 y: %3 ga borish",
    "MOTION_GLIDETO": "%1 soniyada %2 ga borish",
    "MOTION_GLIDETO_POINTER": "sichqon-ko'rsatkichi",
    "MOTION_GLIDETO_RANDOM": "tasodifiy joy",
    "MOTION_CHANGEXBY": "X o'qini %1 ga o'zgartirish",
    "MOTION_SETX": "X o'qini %1 ga sozlash",
    "MOTION_CHANGEYBY": "Y o'qini %1 ga o'zgartirish",
    "MOTION_SETY": "Y o'qini %1 ga sozlash",
    "MOTION_IFONEDGEBOUNCE": "agar devorga urilsa qaytish",
    "MOTION_SETROTATIONSTYLE": "burilishni %1 ga sozlash",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "chapga-o'ngga ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "aylanishni taqiqlash",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "aylanish",
    "MOTION_XPOSITION": "x koordinatasi",
    "MOTION_YPOSITION": "y koordinatasi",
    "MOTION_DIRECTION": "yo'nalish",
    "MOTION_SCROLLRIGHT": "%1 ni o'ngga olib kelish ",
    "MOTION_SCROLLUP": "%1 yuqoriga olib kelish ",
    "MOTION_ALIGNSCENE": "%1 ko'rinishni o'zgartirish",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "pastga-chapga",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "pastga-o'ngga ",
    "MOTION_ALIGNSCENE_MIDDLE": "o'rta",
    "MOTION_ALIGNSCENE_TOPLEFT": "yuqori-chap",
    "MOTION_ALIGNSCENE_TOPRIGHT": "yuqori-o'ng",
    "MOTION_XSCROLL": "X yurguzish",
    "MOTION_YSCROLL": "Y yurguzish",
    "MOTION_STAGE_SELECTED": "Amallar bloklari",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 dan %2 gacha taxminiy",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 va %2",
    "OPERATORS_OR": "%1 yoki %2",
    "OPERATORS_NOT": "%1 bo'lmasa",
    "OPERATORS_JOIN": "%1 va %2 ni qo'shish",
    "OPERATORS_JOIN_APPLE": "olma",
    "OPERATORS_JOIN_BANANA": "banan",
    "OPERATORS_LETTEROF": "%1 %2 xat",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "uzunligi %1",
    "OPERATORS_CONTAINS": "%1 tarkibida %2 mavjudmi?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "%1 atrofida",
    "OPERATORS_MATHOP": "%1 dan %2",
    "OPERATORS_MATHOP_ABS": "modul",
    "OPERATORS_MATHOP_FLOOR": "pol",
    "OPERATORS_MATHOP_CEILING": "ship",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sinus qiymati",
    "OPERATORS_MATHOP_COS": "kosinus qiymati",
    "OPERATORS_MATHOP_TAN": "tan qiymati",
    "OPERATORS_MATHOP_ASIN": "asinus qiymati",
    "OPERATORS_MATHOP_ACOS": "akosinus qiymati",
    "OPERATORS_MATHOP_ATAN": "atan qiymati",
    "OPERATORS_MATHOP_LN": "Ichida",
    "OPERATORS_MATHOP_LOG": "logarifm",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "%1 ni belgilash",
    "SENSING_TOUCHINGOBJECT": "%1 ga teginganda",
    "SENSING_TOUCHINGOBJECT_POINTER": "sichqon-ko'rsatkichi",
    "SENSING_TOUCHINGOBJECT_EDGE": "qirra",
    "SENSING_TOUCHINGCOLOR": "%1 ga teginganda",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 rang %2 rangga tegdimi?",
    "SENSING_DISTANCETO": "%1 gacha masofa",
    "SENSING_DISTANCETO_POINTER": "sichqon-ko'rsatkichi",
    "SENSING_ASKANDWAIT": "%1 ni so'rab kutish",
    "SENSING_ASK_TEXT": "Ismingiz nima?",
    "SENSING_ANSWER": "javob",
    "SENSING_KEYPRESSED": "%1 tugmasini bosdingizmi?",
    "SENSING_MOUSEDOWN": "Sichqonchani bosdingizmi?",
    "SENSING_MOUSEX": "sichiqoncha X koordinatasi",
    "SENSING_MOUSEY": "sichiqoncha Y koordinatasi",
    "SENSING_SETDRAGMODE": "Drag rejimni sudrab %1 ga sozlash",
    "SENSING_SETDRAGMODE_DRAGGABLE": "oladigan holat",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "bo'lmaydigan holat",
    "SENSING_LOUDNESS": "tovush",
    "SENSING_LOUD": "baland ovoz?",
    "SENSING_TIMER": "taymer",
    "SENSING_RESETTIMER": "taymerni qaytarish",
    "SENSING_OF": "%1 dan %2",
    "SENSING_OF_XPOSITION": "X koordinatasi",
    "SENSING_OF_YPOSITION": "Y koordinatasi",
    "SENSING_OF_DIRECTION": "yo'nalish",
    "SENSING_OF_COSTUMENUMBER": "kostyum #",
    "SENSING_OF_COSTUMENAME": "kostyum nomi",
    "SENSING_OF_SIZE": "o'lcham",
    "SENSING_OF_VOLUME": "ovoz",
    "SENSING_OF_BACKDROPNUMBER": "fonning soni",
    "SENSING_OF_BACKDROPNAME": "fonning nomi",
    "SENSING_OF_STAGE": "Sahna",
    "SENSING_CURRENT": "hozirgi %1",
    "SENSING_CURRENT_YEAR": "yil",
    "SENSING_CURRENT_MONTH": "oy",
    "SENSING_CURRENT_DATE": "sana",
    "SENSING_CURRENT_DAYOFWEEK": "hafta kuni",
    "SENSING_CURRENT_HOUR": "soat",
    "SENSING_CURRENT_MINUTE": "daqiqa",
    "SENSING_CURRENT_SECOND": "soniya",
    "SENSING_DAYSSINCE2000": "2000-yildan keyingi kunlar",
    "SENSING_USERNAME": "foydalanuvchi ismi",
    "SENSING_USERID": "foydalanuvchi ID",
    "SOUND_PLAY": " %1 ni ijro etish",
    "SOUND_PLAYUNTILDONE": "%1 ni tugaguncha ijro etish",
    "SOUND_STOPALLSOUNDS": "hamma ovozlarni to'xtat",
    "SOUND_SETEFFECTO": "%1 effektni %2 ga sozlash",
    "SOUND_CHANGEEFFECTBY": "%1 effektni %2 ga o'zgartir",
    "SOUND_CLEAREFFECTS": "ovos effektini o'chirish",
    "SOUND_EFFECTS_PITCH": "ovoz balandligi",
    "SOUND_EFFECTS_PAN": "ovoz manzili o'ng-chap",
    "SOUND_CHANGEVOLUMEBY": "ovozni %1 ga o'zgartirish",
    "SOUND_SETVOLUMETO": "ovozni %1% ga sozlash",
    "SOUND_VOLUME": "ovoz",
    "SOUND_RECORD": "ovoz yozish",
    "CATEGORY_MOTION": "Harakatlar",
    "CATEGORY_LOOKS": "Ko'rinishlar",
    "CATEGORY_SOUND": "Ovozlar",
    "CATEGORY_EVENTS": "Hodisalar",
    "CATEGORY_CONTROL": "Boshqaruvchi",
    "CATEGORY_SENSING": "Sezgirlik",
    "CATEGORY_OPERATORS": "Amallar",
    "CATEGORY_VARIABLES": "O'zgaruvchi",
    "CATEGORY_MYBLOCKS": "Mening bloklarim",
    "DUPLICATE": "Nusxalash",
    "DELETE": "O'chirish",
    "ADD_COMMENT": "Izoh qo'shish",
    "REMOVE_COMMENT": "Izohni o'chirish",
    "DELETE_BLOCK": "Blokni o'chirish",
    "DELETE_X_BLOCKS": "%1 blokni o'chirish",
    "DELETE_ALL_BLOCKS": "%1 hamma bloklar o'chirilsinmi?",
    "CLEAN_UP": "Bloklarni tozalash",
    "HELP": "Yordam",
    "UNDO": "Bekor qilish",
    "REDO": "Qaytarish",
    "EDIT_PROCEDURE": "Oʻzgartirish",
    "SHOW_PROCEDURE_DEFINITION": "Ta'rifga o'ting",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "biron nima aytish",
    "COLOUR_HUE_LABEL": "Rang",
    "COLOUR_SATURATION_LABEL": "To'yinganlik",
    "COLOUR_BRIGHTNESS_LABEL": "Yorqinlik ",
    "CHANGE_VALUE_TITLE": "Qiymatni o'zgartirish:",
    "RENAME_VARIABLE": "O'zgaruvchini nomlash:",
    "RENAME_VARIABLE_TITLE": "\"%1\" o'zgaruvchini qayta nomlash",
    "RENAME_VARIABLE_MODAL_TITLE": "O'zgaruvchini nomlash",
    "NEW_VARIABLE": "O'zgaruvchi yaratish",
    "NEW_VARIABLE_TITLE": "Yangi o'zgaruvchining nomi:",
    "VARIABLE_MODAL_TITLE": "Yangi o'zgaruvchi",
    "VARIABLE_ALREADY_EXISTS": "\"%1\" nomli o'zgaruvchi mavjud",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "\"%2\" ko'rinish boshqa o'zgaruvchida \"%1\" o'zgaruvchida allaqachon mavjud",
    "DELETE_VARIABLE_CONFIRMATION": "\"%2\" o'zgaruvchisi uchun %1 ni o'chirmoqchimisiz?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "\"%1\" o'zgaruvchisini o'chirib bo'lmaydi, chunki u \"%2\" funksiyasining bir qismi",
    "DELETE_VARIABLE": "\"%1\" o'zgaruvchini o'chirish",
    "NEW_PROCEDURE": "blok yaratish",
    "PROCEDURE_ALREADY_EXISTS": "\"%1\" usuli allaqachon mavjud",
    "PROCEDURE_DEFAULT_NAME": "blok nomi",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Ro‘yxat tuzing",
    "NEW_LIST_TITLE": "Yangi ro'yxat nomi:",
    "LIST_MODAL_TITLE": "Yangi roʻyxat",
    "LIST_ALREADY_EXISTS": "\"%1\" ro'yxat nomi allaqachon mavjud",
    "RENAME_LIST_TITLE": "Barcha \"%1\" ro'yxatini qayta nomlash",
    "RENAME_LIST_MODAL_TITLE": "Ro'yxatni nomlash",
    "DEFAULT_LIST_ITEM": "narsa",
    "DELETE_LIST": "\"%1\" ro'yxatni o'chirish",
    "RENAME_LIST": "ro'yxatni nomlash",
    "NEW_BROADCAST_MESSAGE": "Yangi xabar",
    "NEW_BROADCAST_MESSAGE_TITLE": "Yangi xabar nomi:",
    "BROADCAST_MODAL_TITLE": "Yangi xabar",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "xabar1"
  },
  "th": {
    "CONTROL_FOREVER": "วนซ้ำตลอด",
    "CONTROL_REPEAT": "ทำซ้ำ %1",
    "CONTROL_IF": "ถ้า %1 แล้ว",
    "CONTROL_ELSE": "มิฉะนั้น",
    "CONTROL_STOP": "หยุด",
    "CONTROL_STOP_ALL": "ทั้งหมด",
    "CONTROL_STOP_THIS": "สคริปต์นี้",
    "CONTROL_STOP_OTHER": "สริปต์อื่นในตัวละคร",
    "CONTROL_WAIT": "รอ %1 วินาที",
    "CONTROL_WAITUNTIL": "รอจนกระทั่ง %1",
    "CONTROL_REPEATUNTIL": "ทำซ้ำจน %1",
    "CONTROL_WHILE": "ขณะที่ %1",
    "CONTROL_FOREACH": "สำหรับแต่ละ %1 ใน %2",
    "CONTROL_STARTASCLONE": "เมื่อฉันเริ่มในฐานะโคลน",
    "CONTROL_CREATECLONEOF": "สร้าง โคลน ของ %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ตัวฉันเอง",
    "CONTROL_DELETETHISCLONE": "ลบโคลนตัวนี้",
    "CONTROL_COUNTER": "ตัวนับ",
    "CONTROL_INCRCOUNTER": "ตัวนับเพิ่ม",
    "CONTROL_CLEARCOUNTER": "ล้างตัวนับ",
    "CONTROL_ALLATONCE": "ทั้งหมดในครั้งเดียว",
    "DATA_SETVARIABLETO": "ตั้งค่า %1 เป็น %2",
    "DATA_CHANGEVARIABLEBY": "เปลี่ยน %1 ทีละ %2",
    "DATA_SHOWVARIABLE": "แสดงตัวแปร %1",
    "DATA_HIDEVARIABLE": "ซ่อนตัวแปร %1",
    "DATA_ADDTOLIST": "เพิ่ม %1 ไปยัง %2",
    "DATA_DELETEOFLIST": "ลบรายการที่ %1 ออกจาก %2",
    "DATA_DELETEALLOFLIST": "ลบทั้งหมดจาก %1",
    "DATA_INSERTATLIST": "แทรก %1 ที่ลำดับ %2 ของ %3",
    "DATA_REPLACEITEMOFLIST": "แทนที่รายการที่ %1 ของ %2 ด้วย %3",
    "DATA_ITEMOFLIST": "รายการที่ %1 ของ %2",
    "DATA_ITEMNUMOFLIST": " รายการ # ของ %1 จาก %2",
    "DATA_LENGTHOFLIST": "ความยาวของ %1",
    "DATA_LISTCONTAINSITEM": "%1 มี %2?",
    "DATA_SHOWLIST": "แสดงรายการ %1",
    "DATA_HIDELIST": "ซ่อนรายการ %1",
    "DATA_INDEX_ALL": "ทั้งหมด",
    "DATA_INDEX_LAST": "สุดท้าย",
    "DATA_INDEX_RANDOM": "สุ่ม",
    "EVENT_WHENFLAGCLICKED": "เมื่อคลิก %1",
    "EVENT_WHENTHISSPRITECLICKED": "เมื่อตัวละครนี้ถูกคลิก",
    "EVENT_WHENSTAGECLICKED": "เมื่อคลิกเวที",
    "EVENT_WHENTOUCHINGOBJECT": "เมื่อสไปรต์นี้แตะ %1",
    "EVENT_WHENBROADCASTRECEIVED": "เมื่อฉันได้รับ %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "เมื่อฉากหลังเปลี่ยนเป็น %1",
    "EVENT_WHENGREATERTHAN": "เมื่อ %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "ตัวจับเวลา",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ระดับความดัง",
    "EVENT_BROADCAST": "กระจาย %1",
    "EVENT_BROADCASTANDWAIT": "กระจาย %1 และรอ",
    "EVENT_WHENKEYPRESSED": "เมื่อกดปุ่ม %1",
    "EVENT_WHENKEYPRESSED_SPACE": "สเปซบาร์",
    "EVENT_WHENKEYPRESSED_LEFT": "ลูกศรชี้ทางซ้าย",
    "EVENT_WHENKEYPRESSED_RIGHT": "ลูกศรชี้ขวา",
    "EVENT_WHENKEYPRESSED_DOWN": "ลูกศรชี้ลง",
    "EVENT_WHENKEYPRESSED_UP": "ลูกศรขึ้น",
    "EVENT_WHENKEYPRESSED_ANY": "อะไรก็ได้",
    "LOOKS_SAYFORSECS": "พูด %1   %2 วินาที",
    "LOOKS_SAY": "พูด %1",
    "LOOKS_HELLO": "สวัสดี!",
    "LOOKS_THINKFORSECS": "คิด %1   %2 วินาที",
    "LOOKS_THINK": "คิด %1",
    "LOOKS_HMM": "อืมม...",
    "LOOKS_SHOW": "แสดง",
    "LOOKS_HIDE": "ซ่อน",
    "LOOKS_HIDEALLSPRITES": "ซ่อนสไปรต์ทั้งหมด",
    "LOOKS_EFFECT_COLOR": "สี",
    "LOOKS_EFFECT_FISHEYE": "ตาปลา",
    "LOOKS_EFFECT_WHIRL": "หมุนวน",
    "LOOKS_EFFECT_PIXELATE": "แยกพิกเซล",
    "LOOKS_EFFECT_MOSAIC": "โมเสก",
    "LOOKS_EFFECT_BRIGHTNESS": "ความสว่าง",
    "LOOKS_EFFECT_GHOST": "ล่องหน",
    "LOOKS_CHANGEEFFECTBY": "เปลี่ยนเอฟเฟกต์ %1 ทีละ %2",
    "LOOKS_SETEFFECTTO": "ตั้งค่าเอฟเฟกต์ %1 เป็น %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "ล้างเอฟเฟคภาพ",
    "LOOKS_CHANGESIZEBY": "เปลี่ยนขนาดทีละ %1",
    "LOOKS_SETSIZETO": "กำหนดขนาดเป็น %1 %",
    "LOOKS_SIZE": "ขนาด",
    "LOOKS_CHANGESTRETCHBY": "เปลี่ยนความยืดทีละ %1",
    "LOOKS_SETSTRETCHTO": "ตั้งค่าความยืดเป็น %1 %",
    "LOOKS_SWITCHCOSTUMETO": "เปลี่ยนคอสตูมเป็น %1",
    "LOOKS_NEXTCOSTUME": "ชุดถัดไป",
    "LOOKS_SWITCHBACKDROPTO": "เปลี่ยนฉากหลังเป็น %1",
    "LOOKS_GOTOFRONTBACK": "ไปที่ระดับ %1 ",
    "LOOKS_GOTOFRONTBACK_FRONT": "หน้าสุด",
    "LOOKS_GOTOFRONTBACK_BACK": "หลังสุด",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ไป %1 %2 ระดับ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ด้านหน้า",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "ด้านหลัง",
    "LOOKS_BACKDROPNUMBERNAME": "ฉากหลัง %1",
    "LOOKS_COSTUMENUMBERNAME": "คอสตูม %1",
    "LOOKS_NUMBERNAME_NUMBER": "หมายเลข",
    "LOOKS_NUMBERNAME_NAME": "ชื่อ",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "เปลี่ยนฉากหลังเป็น %1 และรอ",
    "LOOKS_NEXTBACKDROP_BLOCK": "ฉากหลังต่อไป",
    "LOOKS_NEXTBACKDROP": "ฉากหลังต่อไป",
    "LOOKS_PREVIOUSBACKDROP": "ฉากหลังก่อนหน้า",
    "LOOKS_RANDOMBACKDROP": "ฉากหลังแบบสุ่ม",
    "MOTION_MOVESTEPS": "เคลื่อนที่ %1 ก้าว",
    "MOTION_TURNLEFT": "หัน %1 %2 องศา",
    "MOTION_TURNRIGHT": "หัน %1 %2 องศา",
    "MOTION_POINTINDIRECTION": "หันในทิศทาง %1",
    "MOTION_POINTTOWARDS": "หันไปทาง %1",
    "MOTION_POINTTOWARDS_POINTER": "ตัวชี้เมาส์",
    "MOTION_POINTTOWARDS_RANDOM": "สุ่มทิศทาง",
    "MOTION_GOTO": "ไปที่ %1",
    "MOTION_GOTO_POINTER": "ตัวชี้เมาส์",
    "MOTION_GOTO_RANDOM": "ตำแหน่งสุ่ม",
    "MOTION_GOTOXY": "ไปที่ x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "เหิน %1 วินาที ไปยัง x: %2 y: %3",
    "MOTION_GLIDETO": "เหิน %1 วินาที ไปยัง %2",
    "MOTION_GLIDETO_POINTER": "ตัวชี้เมาส์",
    "MOTION_GLIDETO_RANDOM": "ตำแหน่งสุ่ม",
    "MOTION_CHANGEXBY": "เปลี่ยน x ทีละ %1",
    "MOTION_SETX": "ตั้งค่า x เป็น %1",
    "MOTION_CHANGEYBY": "เปลี่ยน y ทีละ %1",
    "MOTION_SETY": "ตั้งค่า y เป็น %1",
    "MOTION_IFONEDGEBOUNCE": "ถ้าชนขอบให้สะท้อนกลับ",
    "MOTION_SETROTATIONSTYLE": "ตั้งรูปแบบการหมุนเป็น %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "ซ้าย-ขวา",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ห้ามหมุน",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "รอบด้าน",
    "MOTION_XPOSITION": "ตำแหน่ง x ",
    "MOTION_YPOSITION": "ตำแหน่ง y",
    "MOTION_DIRECTION": "ทิศทาง",
    "MOTION_SCROLLRIGHT": "เลื่อนขวา %1",
    "MOTION_SCROLLUP": "เลื่อนขึ้น %1",
    "MOTION_ALIGNSCENE": "แนวฉาก %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ล่างซ้าย",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ล่างขวา",
    "MOTION_ALIGNSCENE_MIDDLE": "กึ่งกลาง",
    "MOTION_ALIGNSCENE_TOPLEFT": "บนซ้าย",
    "MOTION_ALIGNSCENE_TOPRIGHT": "บนขวา",
    "MOTION_XSCROLL": "x เลื่อน",
    "MOTION_YSCROLL": "y เลื่อน",
    "MOTION_STAGE_SELECTED": "เลือกเวที: ไม่มีบล็อกเคลื่อนไหว",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "เลือกสุ่มจาก %1 ถึง %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 และ %2",
    "OPERATORS_OR": "%1 หรือ %2",
    "OPERATORS_NOT": "ไม่ %1",
    "OPERATORS_JOIN": "ต่อ %1 %2",
    "OPERATORS_JOIN_APPLE": "แอปเปิ้ล",
    "OPERATORS_JOIN_BANANA": "กล้วย",
    "OPERATORS_LETTEROF": "อักษรที่ %1 ของ %2",
    "OPERATORS_LETTEROF_APPLE": "อ",
    "OPERATORS_LENGTH": "ความยาวของ %1",
    "OPERATORS_CONTAINS": "%1 มี %2?",
    "OPERATORS_MOD": "%1 หารเอาเศษ %2",
    "OPERATORS_ROUND": "ปัดเศษ %1",
    "OPERATORS_MATHOP": "%1 ของ %2",
    "OPERATORS_MATHOP_ABS": "ค่าสัมบูรณ์",
    "OPERATORS_MATHOP_FLOOR": "พื้น",
    "OPERATORS_MATHOP_CEILING": "เพดาน",
    "OPERATORS_MATHOP_SQRT": "รากที่สอง",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "กำหนด %1",
    "SENSING_TOUCHINGOBJECT": "แตะ %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "ตัวชี้เมาส์",
    "SENSING_TOUCHINGOBJECT_EDGE": "ขอบ",
    "SENSING_TOUCHINGCOLOR": "แตะสี %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "สี %1 แตะกับสี %2?",
    "SENSING_DISTANCETO": "ระยะห่างไปยัง %1",
    "SENSING_DISTANCETO_POINTER": "ตัวชี้เมาส์",
    "SENSING_ASKANDWAIT": "ถาม %1 และรอ",
    "SENSING_ASK_TEXT": "คุณชื่ออะไร?",
    "SENSING_ANSWER": "คำตอบ",
    "SENSING_KEYPRESSED": "ปุ่ม %1 ถูกกด?",
    "SENSING_MOUSEDOWN": "เมาส์ถูกกด?",
    "SENSING_MOUSEX": "ตำแหน่ง x ของเมาส์",
    "SENSING_MOUSEY": "ตำแหน่ง y ของเมาส์",
    "SENSING_SETDRAGMODE": "ตั้งค่าโหมดลาก %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ลากได้",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ลากไม่ได้",
    "SENSING_LOUDNESS": "ระดับความดัง",
    "SENSING_LOUD": "เสียงดัง?",
    "SENSING_TIMER": "จับเวลา",
    "SENSING_RESETTIMER": "จับเวลาใหม่",
    "SENSING_OF": "%1 ของ %2",
    "SENSING_OF_XPOSITION": "ตำแหน่ง x ",
    "SENSING_OF_YPOSITION": "ตำแหน่ง y",
    "SENSING_OF_DIRECTION": "ทิศทาง",
    "SENSING_OF_COSTUMENUMBER": "คอสตูม #",
    "SENSING_OF_COSTUMENAME": "ชื่อคอสตูม",
    "SENSING_OF_SIZE": "ขนาด",
    "SENSING_OF_VOLUME": "ระดับเสียง",
    "SENSING_OF_BACKDROPNUMBER": "ฉากหลัง #",
    "SENSING_OF_BACKDROPNAME": "ชื่อฉากหลัง",
    "SENSING_OF_STAGE": "เวที",
    "SENSING_CURRENT": "%1 ปัจจุบัน",
    "SENSING_CURRENT_YEAR": "ปี",
    "SENSING_CURRENT_MONTH": "เดือน",
    "SENSING_CURRENT_DATE": "วันที่",
    "SENSING_CURRENT_DAYOFWEEK": "วันของสัปดาห์",
    "SENSING_CURRENT_HOUR": "ชั่วโมง",
    "SENSING_CURRENT_MINUTE": "นาที",
    "SENSING_CURRENT_SECOND": "วินาที",
    "SENSING_DAYSSINCE2000": "จำนวนวันตั้งแต่ปี ค.ศ 2000",
    "SENSING_USERNAME": "ชื่อผู้ใช้",
    "SENSING_USERID": "รหัสผู้ใช้",
    "SOUND_PLAY": "เริ่มเสียง %1",
    "SOUND_PLAYUNTILDONE": "เล่นเสียง %1 จนจบ",
    "SOUND_STOPALLSOUNDS": "หยุดเสียงทั้งหมด",
    "SOUND_SETEFFECTO": "ตั้งค่าเอฟเฟกต์ %1 เป็น %2",
    "SOUND_CHANGEEFFECTBY": "เปลี่ยนเอฟเฟกต์ %1 ทีละ %2",
    "SOUND_CLEAREFFECTS": "ล้างเอฟเฟกต์เสียง",
    "SOUND_EFFECTS_PITCH": "เสียงสูงต่ำ",
    "SOUND_EFFECTS_PAN": "แพนเสียงซ้าย/ขวา",
    "SOUND_CHANGEVOLUMEBY": "เปลี่ยนระดับเสียงทีละ %1",
    "SOUND_SETVOLUMETO": "ตั้งระดับเสียงเป็น %1%",
    "SOUND_VOLUME": "ระดับเสียง",
    "SOUND_RECORD": "อัดบันทึก...",
    "CATEGORY_MOTION": "เคลื่อนไหว",
    "CATEGORY_LOOKS": "รูปลักษณ์",
    "CATEGORY_SOUND": "เสียง",
    "CATEGORY_EVENTS": "เหตุการณ์",
    "CATEGORY_CONTROL": "ควบคุม",
    "CATEGORY_SENSING": "ตรวจจับ",
    "CATEGORY_OPERATORS": "ตัวดำเนินการ",
    "CATEGORY_VARIABLES": "ตัวแปร",
    "CATEGORY_MYBLOCKS": "บล็อกของฉัน",
    "DUPLICATE": "ทำซ้ำ",
    "DELETE": "ลบ",
    "ADD_COMMENT": "เพิ่มคำอธิบาย",
    "REMOVE_COMMENT": "ลบคำอธิบาย",
    "DELETE_BLOCK": "ลบบล็อก",
    "DELETE_X_BLOCKS": "ลบ %1 บล็อก",
    "DELETE_ALL_BLOCKS": "ลบทั้งหมด %1 บล็อก?",
    "CLEAN_UP": "จัดระเบียบบล็อก",
    "HELP": "ช่วยเหลือ",
    "UNDO": "ย้อนกลับ",
    "REDO": "ทำซ้ำ",
    "EDIT_PROCEDURE": "แก้ไข",
    "SHOW_PROCEDURE_DEFINITION": "ไปยังตัวกำหนด",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "พูดอะไรสักอย่าง...",
    "COLOUR_HUE_LABEL": "สี",
    "COLOUR_SATURATION_LABEL": "ความอิ่มตัว",
    "COLOUR_BRIGHTNESS_LABEL": "ความสว่าง",
    "CHANGE_VALUE_TITLE": "เปลี่ยนค่า:",
    "RENAME_VARIABLE": "เปลี่ยนชื่อตัวแปร",
    "RENAME_VARIABLE_TITLE": "เปลี่ยนชื่อตัวแปร \"%1\" ทั้งหมดเป็น:",
    "RENAME_VARIABLE_MODAL_TITLE": "เปลี่ยนชื่อตัวแปร",
    "NEW_VARIABLE": "สร้างตัวแปร",
    "NEW_VARIABLE_TITLE": "ชื่อตัวแปรใหม่:",
    "VARIABLE_MODAL_TITLE": "ตัวแปรใหม่",
    "VARIABLE_ALREADY_EXISTS": "มีตัวแปรชื่อ \"%1\" อยู่แล้ว",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "มีตัวแปรชื่อ \"%1\" อยู่แล้วสำหรับตัวแปรอื่นชนิด \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "ลบตัวแปร \"%2\" ซึ่งใช้อยู่ %1 ที่?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "ไม่สามารถลบตัวแปร \"%1\" ได้เนื่องจากเป็นส่วนหนึ่งของคำจำกัดความของฟังก์ชัน \"%2\"",
    "DELETE_VARIABLE": "ลบตัวแปร \"%1\"",
    "NEW_PROCEDURE": "สร้างบล็อกใหม่",
    "PROCEDURE_ALREADY_EXISTS": "มีขั้นตอนชื่อ \"%1\" อยู่แล้ว",
    "PROCEDURE_DEFAULT_NAME": "ชื่อบล็อก",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "สร้างรายการ",
    "NEW_LIST_TITLE": "ชื่อรายการ:",
    "LIST_MODAL_TITLE": "รายการใหม่",
    "LIST_ALREADY_EXISTS": "มีรายการชื่อ \"%1\" อยู่แล้ว",
    "RENAME_LIST_TITLE": "เปลี่ยนชื่อรายการ \"%1\" ทั้งหมดเป็น:",
    "RENAME_LIST_MODAL_TITLE": "เปลี่ยนชื่อรายการ",
    "DEFAULT_LIST_ITEM": "สิ่ง",
    "DELETE_LIST": "ลบรายชื่อ \"%1\"",
    "RENAME_LIST": "เปลี่ยนชื่อรายชื่อ",
    "NEW_BROADCAST_MESSAGE": "ข้อความใหม่",
    "NEW_BROADCAST_MESSAGE_TITLE": "ชื่อข้อความใหม่:",
    "BROADCAST_MODAL_TITLE": "ข้อความใหม่",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "ข้อความ1"
  },
  "km": {
    "CONTROL_FOREVER": "រហូត",
    "CONTROL_REPEAT": "ធ្វើដដែលៗ %1 ដង",
    "CONTROL_IF": "ប្រសិន %1 នោះ",
    "CONTROL_ELSE": "បើមិនដូច្នោះទេ",
    "CONTROL_STOP": "ឈប់",
    "CONTROL_STOP_ALL": "ទាំងអស់",
    "CONTROL_STOP_THIS": "ស្គ្រីបនេះ",
    "CONTROL_STOP_OTHER": "ស្រ្គីបផ្សេងទៀតក្នុងតួអង្គ",
    "CONTROL_WAIT": "ចាំ %1 វិនាទី",
    "CONTROL_WAITUNTIL": "ចាំរហូតដល់ %1",
    "CONTROL_REPEATUNTIL": "ធ្វើដដែលៗរហូតដល់ %1",
    "CONTROL_WHILE": "ខណៈពេល %1",
    "CONTROL_FOREACH": "សម្រាប់ %1 នីមួយៗ ក្នុង %2",
    "CONTROL_STARTASCLONE": "ពេលខ្ញុំចាប់ផ្តើមជារូបចម្លង",
    "CONTROL_CREATECLONEOF": "ចម្លងរូបរាងនៃ %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ខ្លួនឯង",
    "CONTROL_DELETETHISCLONE": "លុបរូបចម្លងនេះ",
    "CONTROL_COUNTER": "លេខរាប់",
    "CONTROL_INCRCOUNTER": "បង្កើនលេខរាប់",
    "CONTROL_CLEARCOUNTER": "លុបលេខរាប់",
    "CONTROL_ALLATONCE": "ម្តងទាំងអស់",
    "DATA_SETVARIABLETO": "ដាក់ %1 ទៅជា %2",
    "DATA_CHANGEVARIABLEBY": "ប្តូរ %1 ចំនួន %2",
    "DATA_SHOWVARIABLE": "បង្ហាញអថេរ %1",
    "DATA_HIDEVARIABLE": "លាក់អថេរ %1",
    "DATA_ADDTOLIST": "បន្ថែម %1 ទៅលើ %2",
    "DATA_DELETEOFLIST": "លុបធាតុទី %1 ចេញពី %2",
    "DATA_DELETEALLOFLIST": "លុបធាតុទាំងអស់ក្នុង %1",
    "DATA_INSERTATLIST": "បញ្ចូល %1 នៅទីតាំង %2 ក្នុង %3",
    "DATA_REPLACEITEMOFLIST": "ជំនួសធាតុ %1 នៃ %2 ដោយ %3",
    "DATA_ITEMOFLIST": "ធាតុ %1 នៃ %2",
    "DATA_ITEMNUMOFLIST": "លេខទីតាំងនៃធាតុ %1 ក្នុង %2",
    "DATA_LENGTHOFLIST": "ប្រវែងនៃ %1",
    "DATA_LISTCONTAINSITEM": "%1 មាន %2?",
    "DATA_SHOWLIST": "បង្ហាញបញ្ជី %1",
    "DATA_HIDELIST": "លាក់បញ្ជី %1",
    "DATA_INDEX_ALL": "ទាំងអស់",
    "DATA_INDEX_LAST": "ចុងក្រោយ",
    "DATA_INDEX_RANDOM": "ចៃដន្យ",
    "EVENT_WHENFLAGCLICKED": "ពេលចុច %1",
    "EVENT_WHENTHISSPRITECLICKED": "ពេលចុចតួអង្គ",
    "EVENT_WHENSTAGECLICKED": "ពេលចុចឆាក",
    "EVENT_WHENTOUCHINGOBJECT": "នៅពេលតួអង្គនេះប៉ះ %1",
    "EVENT_WHENBROADCASTRECEIVED": "ពេលខ្ញុំទទួលបាន %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "ពេលផ្ទាំងខាងក្រោយប្តូរទៅជា %1",
    "EVENT_WHENGREATERTHAN": "ពេល %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "ម៉ោងរាប់ថយក្រោយ",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "កម្រិតឮ",
    "EVENT_BROADCAST": "បញ្ជូនសារ %1",
    "EVENT_BROADCASTANDWAIT": "បញ្ជូនសារ %1 ហើយចាំ",
    "EVENT_WHENKEYPRESSED": "ពេលចុច %1",
    "EVENT_WHENKEYPRESSED_SPACE": "ច្នុចដក​ឃ្លា",
    "EVENT_WHENKEYPRESSED_LEFT": "ព្រួញខាង​ឆ្វេង",
    "EVENT_WHENKEYPRESSED_RIGHT": "ព្រួញខាង​ស្ដាំ",
    "EVENT_WHENKEYPRESSED_DOWN": "ព្រួញខាងក្រោម",
    "EVENT_WHENKEYPRESSED_UP": "ព្រួញ​ខាង​លើ",
    "EVENT_WHENKEYPRESSED_ANY": "ណាមួយ",
    "LOOKS_SAYFORSECS": "និយាយ %1 រយៈពេល %2 វិនាទី",
    "LOOKS_SAY": "និយាយ %1",
    "LOOKS_HELLO": "សួស្តី!",
    "LOOKS_THINKFORSECS": "គិត %1 រយៈពេល %2 វិនាទី",
    "LOOKS_THINK": "គិត %1",
    "LOOKS_HMM": "អឺ...",
    "LOOKS_SHOW": "បង្ហាញ",
    "LOOKS_HIDE": "លាក់",
    "LOOKS_HIDEALLSPRITES": "លាក់តួអង្គទាំងអស់",
    "LOOKS_EFFECT_COLOR": "ពណ៌",
    "LOOKS_EFFECT_FISHEYE": "fisheye",
    "LOOKS_EFFECT_WHIRL": "whirl",
    "LOOKS_EFFECT_PIXELATE": "pixelate",
    "LOOKS_EFFECT_MOSAIC": "mosaic",
    "LOOKS_EFFECT_BRIGHTNESS": "កម្រិតពន្លឺ",
    "LOOKS_EFFECT_GHOST": "ghost",
    "LOOKS_CHANGEEFFECTBY": "ប្តូរបែបផែន %1 ចំនួន %2",
    "LOOKS_SETEFFECTTO": "ដាក់បែបផែន %1 ត្រឹម %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "លុបបែបផែនក្រាហ្វិក",
    "LOOKS_CHANGESIZEBY": "ប្តូរទំហំចំនួន %1",
    "LOOKS_SETSIZETO": "ដាក់ទំហំត្រឹម %1 %",
    "LOOKS_SIZE": "ទំហំ",
    "LOOKS_CHANGESTRETCHBY": "ប្តូរកម្រិតយឺតចំនួន %1",
    "LOOKS_SETSTRETCHTO": "ដាក់កម្រិតយឺតត្រឹម %1 %",
    "LOOKS_SWITCHCOSTUMETO": "ប្តូររូបរាងទៅជា %1",
    "LOOKS_NEXTCOSTUME": "រូបរាងបន្ទាប់",
    "LOOKS_SWITCHBACKDROPTO": "ប្ដូរផ្ទាំង​ខាងក្រោយ​ទៅជា %1",
    "LOOKS_GOTOFRONTBACK": "ទៅស្រទាប់ %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "មុខ",
    "LOOKS_GOTOFRONTBACK_BACK": "ក្រោយ",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 ស្រទាប់",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ទៅមុខ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "ថយក្រោយ",
    "LOOKS_BACKDROPNUMBERNAME": "ផ្ទាំងខាងក្រោយ %1",
    "LOOKS_COSTUMENUMBERNAME": "រូបរាង %1",
    "LOOKS_NUMBERNAME_NUMBER": "លេខ",
    "LOOKS_NUMBERNAME_NAME": "ឈ្មោះ",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "ប្ដូរផ្ទាំងខាង​ក្រោយ​ទៅជា %1 ហើយ​រងចាំ",
    "LOOKS_NEXTBACKDROP_BLOCK": "ផ្ទាំងខាងក្រោយបន្ទាប់",
    "LOOKS_NEXTBACKDROP": "ផ្ទាំងខាងក្រោយបន្ទាប់",
    "LOOKS_PREVIOUSBACKDROP": "ផ្ទាំងខាងក្រោយមុន",
    "LOOKS_RANDOMBACKDROP": "ផ្ទាំងខាងក្រោយចៃដន្យ",
    "MOTION_MOVESTEPS": "ផ្លាស់ទី %1 ជំហាន",
    "MOTION_TURNLEFT": "បង្វិល %1 %2 ដឺក្រេ",
    "MOTION_TURNRIGHT": "បង្វិល %1 %2 ដឺក្រេ",
    "MOTION_POINTINDIRECTION": "ចង្អុលទៅទិសដៅ %1",
    "MOTION_POINTTOWARDS": "ចង្អុលទៅ %1",
    "MOTION_POINTTOWARDS_POINTER": "ព្រួញម៉ៅស៍",
    "MOTION_POINTTOWARDS_RANDOM": "ទិសដៅចៃដន្យ",
    "MOTION_GOTO": "ទៅកាន់ %1",
    "MOTION_GOTO_POINTER": "ព្រួញម៉ៅស៍",
    "MOTION_GOTO_RANDOM": "ទីតាំង​ចៃ​ដន្យ",
    "MOTION_GOTOXY": "ទៅកាន់ x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "រំកិល %1 វិនាទី ទៅ x: %2 y: %3",
    "MOTION_GLIDETO": "រំកិល %1 វិនាទី ទៅ %2",
    "MOTION_GLIDETO_POINTER": "ព្រួញម៉ៅស៍",
    "MOTION_GLIDETO_RANDOM": "ទីតាំង​ចៃ​ដន្យ",
    "MOTION_CHANGEXBY": "ប្តូរ x ចំនួន %1",
    "MOTION_SETX": "ដាក់ x ត្រឹម %1",
    "MOTION_CHANGEYBY": "ប្តូរ y ចំនួន %1",
    "MOTION_SETY": "ដាក់ y ត្រឹម %1",
    "MOTION_IFONEDGEBOUNCE": "បើនៅគែមឆាក, អោយខ្ទាតចេញ",
    "MOTION_SETROTATIONSTYLE": "ដាក់ស្តាយបង្វិល %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "ឆ្វេង-ស្តាំ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "កុំ​បង្វិល",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "ពេញមួយជុំ",
    "MOTION_XPOSITION": "ទីតាំង x",
    "MOTION_YPOSITION": "ទីតាំង y",
    "MOTION_DIRECTION": "ទិសដៅ",
    "MOTION_SCROLLRIGHT": "រមូរស្តាំ %1",
    "MOTION_SCROLLUP": "រមូរឡើងលើ %1",
    "MOTION_ALIGNSCENE": "តម្រឹមឈុត %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ក្រោម-ឆ្វេង",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ក្រោម-ស្តាំ",
    "MOTION_ALIGNSCENE_MIDDLE": "កណ្តាល",
    "MOTION_ALIGNSCENE_TOPLEFT": "លើ-ឆ្វេង",
    "MOTION_ALIGNSCENE_TOPRIGHT": "លើ-ស្តាំ",
    "MOTION_XSCROLL": "រមូរ x",
    "MOTION_YSCROLL": "រមូរ y",
    "MOTION_STAGE_SELECTED": "អ្នកបានជ្រើសឆាក។ មិនមានប្លុកចលនាទេ",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "យកតម្លៃចៃដន្យពី %1 ទៅ %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 និង %2",
    "OPERATORS_OR": "%1 ឬ %2",
    "OPERATORS_NOT": "មិនមែន %1",
    "OPERATORS_JOIN": "ភ្ជាប់ %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "តួអក្សរទី %1 នៃ %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "ប្រវែងនៃ %1",
    "OPERATORS_CONTAINS": "%1 មាន %2?",
    "OPERATORS_MOD": "សំណល់នៃ %1 ចែកនឹង %2",
    "OPERATORS_ROUND": "បង្គត់ %1",
    "OPERATORS_MATHOP": "%1 នៃ %2",
    "OPERATORS_MATHOP_ABS": "តម្លៃដាច់ខាត",
    "OPERATORS_MATHOP_FLOOR": "បង្គត់ចុះ",
    "OPERATORS_MATHOP_CEILING": "បង្គត់ឡើង",
    "OPERATORS_MATHOP_SQRT": "ឫស​ការ៉េ",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "កំណត់ន័យ %1",
    "SENSING_TOUCHINGOBJECT": "ប៉ះ %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "ព្រួញម៉ៅស៍",
    "SENSING_TOUCHINGOBJECT_EDGE": "គែម",
    "SENSING_TOUCHINGCOLOR": "ប៉ះពណ៌ %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "ពណ៌ %1 ប៉ះ %2?",
    "SENSING_DISTANCETO": "ចម្ងាយពី %1",
    "SENSING_DISTANCETO_POINTER": "ព្រួញម៉ៅស៍",
    "SENSING_ASKANDWAIT": "សួរ %1 ហើយចាំ",
    "SENSING_ASK_TEXT": "តើអ្នកឈ្មោះអ្វី?",
    "SENSING_ANSWER": "ចម្លើយ",
    "SENSING_KEYPRESSED": "ច្នុច %1 ត្រូវបានចុច?",
    "SENSING_MOUSEDOWN": "ចុចម៉ៅស៍?",
    "SENSING_MOUSEX": "ទីតាំងព្រួញម៉ៅស៍ x",
    "SENSING_MOUSEY": "ទីតាំងព្រួញម៉ៅស៍ y",
    "SENSING_SETDRAGMODE": "ដាក់ម៉ូតអូស %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "អាចអូសបាន",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "មិនអាចអូសបាន",
    "SENSING_LOUDNESS": "កម្រិតឮ",
    "SENSING_LOUD": "លឺ?",
    "SENSING_TIMER": "ម៉ោងរាប់ថយក្រោយ",
    "SENSING_RESETTIMER": "កំណត់ម៉ោងរាប់ថយក្រោយឡើងវិញ",
    "SENSING_OF": "%1 នៃ %2",
    "SENSING_OF_XPOSITION": "ទីតាំង x ",
    "SENSING_OF_YPOSITION": "ទីតាំង y",
    "SENSING_OF_DIRECTION": "ទិសដៅ",
    "SENSING_OF_COSTUMENUMBER": "រូបរាង #",
    "SENSING_OF_COSTUMENAME": "ឈ្មោះរូបរាង",
    "SENSING_OF_SIZE": "ទំហំ",
    "SENSING_OF_VOLUME": "កម្រិតសម្លេង",
    "SENSING_OF_BACKDROPNUMBER": "ផ្ទាំងខាងក្រោយ #",
    "SENSING_OF_BACKDROPNAME": "ឈ្មោះផ្ទាំងខាងក្រោយ",
    "SENSING_OF_STAGE": "ឆាក",
    "SENSING_CURRENT": "%1 បច្ចុប្បន្ន",
    "SENSING_CURRENT_YEAR": "ឆ្នាំ",
    "SENSING_CURRENT_MONTH": "ខែ",
    "SENSING_CURRENT_DATE": "ថ្ងៃខែ",
    "SENSING_CURRENT_DAYOFWEEK": "ថ្ងៃប្រចាំសប្តាហ៍",
    "SENSING_CURRENT_HOUR": "ម៉ោង",
    "SENSING_CURRENT_MINUTE": "នាទី",
    "SENSING_CURRENT_SECOND": "វិនាទី",
    "SENSING_DAYSSINCE2000": "ចំនួនថ្ងៃចាប់ពីឆ្នាំ 2000",
    "SENSING_USERNAME": "ឈ្មោះគណនី",
    "SENSING_USERID": "លេខសម្គាល់អ្នកប្រើ",
    "SOUND_PLAY": "ផ្តើមសម្លេង %1",
    "SOUND_PLAYUNTILDONE": "លេងសម្លេង %1 រហូតដល់ចប់",
    "SOUND_STOPALLSOUNDS": "បញ្ឈប់សម្លេងទាំងអស់",
    "SOUND_SETEFFECTO": "ដាក់បែបផែន %1 ត្រឹម %2",
    "SOUND_CHANGEEFFECTBY": "ប្តូរបែបផែន %1 ចំនួន %2",
    "SOUND_CLEAREFFECTS": "លុបបែបផែនសម្លេង",
    "SOUND_EFFECTS_PITCH": "កម្រិតខ្ពស់ទាប",
    "SOUND_EFFECTS_PAN": "កម្រិតឆ្វេងស្តាំ",
    "SOUND_CHANGEVOLUMEBY": "ប្តូរកម្រិតសម្លេងចំនួន %1",
    "SOUND_SETVOLUMETO": "ដាក់កម្រិតសម្លេងត្រឹម %1%",
    "SOUND_VOLUME": "កម្រិតសម្លេង",
    "SOUND_RECORD": "ថតសម្លេង...",
    "CATEGORY_MOTION": "ចលនា",
    "CATEGORY_LOOKS": "រូបរាង",
    "CATEGORY_SOUND": "សម្លេង",
    "CATEGORY_EVENTS": "ព្រឹត្តិការណ៍",
    "CATEGORY_CONTROL": "គ្រប់គ្រង",
    "CATEGORY_SENSING": "ញ្ញាណ",
    "CATEGORY_OPERATORS": "ប្រមាណវិធី",
    "CATEGORY_VARIABLES": "អថេរ",
    "CATEGORY_MYBLOCKS": "ប្លុកខ្ញុំ",
    "DUPLICATE": "ចម្លង",
    "DELETE": "លុប",
    "ADD_COMMENT": "ដាក់មតិ",
    "REMOVE_COMMENT": "លុបមតិ",
    "DELETE_BLOCK": "លុបប្លុក",
    "DELETE_X_BLOCKS": "លុបប្លុក %1",
    "DELETE_ALL_BLOCKS": "លុបប្លុកទាំង %1?",
    "CLEAN_UP": "រៀបរយប្លុក",
    "HELP": "ជំនួយ",
    "UNDO": "មិនធ្វើវិញ",
    "REDO": "ធ្វើឡើងវិញ",
    "EDIT_PROCEDURE": "កែសម្រួល",
    "SHOW_PROCEDURE_DEFINITION": "ទៅកាន់និយមន័យ",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "និយាយអ្វីមួយ...",
    "COLOUR_HUE_LABEL": "ពណ៌",
    "COLOUR_SATURATION_LABEL": "កម្រិតដិត",
    "COLOUR_BRIGHTNESS_LABEL": "កម្រិតពន្លឺ",
    "CHANGE_VALUE_TITLE": "ប្តូរតម្លៃ៖",
    "RENAME_VARIABLE": "កែឈ្មោះអថេរ",
    "RENAME_VARIABLE_TITLE": "កែឈ្មោះអថេរ \"%1\" ទាំងអស់ទៅជា៖",
    "RENAME_VARIABLE_MODAL_TITLE": "កែឈ្មោះអថេរ",
    "NEW_VARIABLE": "បង្កើតអថេរ",
    "NEW_VARIABLE_TITLE": "ឈ្មោះអថេរថ្មី ៖",
    "VARIABLE_MODAL_TITLE": "អថេរថ្មី",
    "VARIABLE_ALREADY_EXISTS": "អថេរឈ្មោះ \"%1\" មានរួចហើយ",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "អថេរឈ្មោះ \"%1\" មានរួចហើយសម្រាប់អថេរប្រភេទ \"%2\"។",
    "DELETE_VARIABLE_CONFIRMATION": "លុបអថេរ \"%2\" និងការប្រើប្រាស់ %1 ដងរបស់វា?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "មិនអាចលុបអថេរ \"%1\" ទេព្រោះវាទាក់ទងនឹងអនុគមន៍ \"%2\"",
    "DELETE_VARIABLE": "លុបអថេរ \"%1\"",
    "NEW_PROCEDURE": "បង្កើតប្លុកមួយ",
    "PROCEDURE_ALREADY_EXISTS": "ដំណាក់កាលឈ្មោះ \"%1\" មានរួចហើយ។",
    "PROCEDURE_DEFAULT_NAME": "ឈ្មោះប្លុក",
    "PROCEDURE_USED": "ដើម្បីលុបប្លុកដំបូង អ្នកត្រូវយកប្លុកដែលប្រើទាំងអស់ចេញសិន",
    "NEW_LIST": "បង្កើតបញ្ជី",
    "NEW_LIST_TITLE": "ឈ្មោះបញ្ជីថ្មី៖",
    "LIST_MODAL_TITLE": "បញ្ជីថ្មី",
    "LIST_ALREADY_EXISTS": "បញ្ជីឈ្មោះ \"%1\" មានរួចហើយ។",
    "RENAME_LIST_TITLE": "កែឈ្មោះបញ្ជី \"%1\" ទាំងអស់ទៅជា៖",
    "RENAME_LIST_MODAL_TITLE": "កែឈ្មោះបញ្ជី",
    "DEFAULT_LIST_ITEM": "វត្ថុ",
    "DELETE_LIST": "លុបបញ្ជី \"%1\"",
    "RENAME_LIST": "កែឈ្មោះបញ្ជី",
    "NEW_BROADCAST_MESSAGE": "សារថ្មី",
    "NEW_BROADCAST_MESSAGE_TITLE": "ឈ្មោះសារថ្មី៖",
    "BROADCAST_MODAL_TITLE": "សារថ្មី",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "សារ 1"
  },
  "pl": {
    "CONTROL_FOREVER": "zawsze",
    "CONTROL_REPEAT": "powtórz %1 razy",
    "CONTROL_IF": "jeżeli %1 to",
    "CONTROL_ELSE": "w przeciwnym razie",
    "CONTROL_STOP": "zatrzymaj",
    "CONTROL_STOP_ALL": "wszystko",
    "CONTROL_STOP_THIS": "ten skrypt",
    "CONTROL_STOP_OTHER": "inne skrypty duszka",
    "CONTROL_WAIT": "czekaj %1 sekund",
    "CONTROL_WAITUNTIL": "czekaj aż %1",
    "CONTROL_REPEATUNTIL": "powtarzaj aż %1",
    "CONTROL_WHILE": "podczas gdy %1",
    "CONTROL_FOREACH": "dla każdego %1 z %2",
    "CONTROL_STARTASCLONE": "gdy zaczynam jako klon",
    "CONTROL_CREATECLONEOF": "utwórz klona z %1",
    "CONTROL_CREATECLONEOF_MYSELF": "siebie",
    "CONTROL_DELETETHISCLONE": "usuń tego klona",
    "CONTROL_COUNTER": "licznik",
    "CONTROL_INCRCOUNTER": "zwiększ licznik",
    "CONTROL_CLEARCOUNTER": "zeruj licznik",
    "CONTROL_ALLATONCE": "wszystko na raz",
    "DATA_SETVARIABLETO": "ustaw %1 na %2",
    "DATA_CHANGEVARIABLEBY": "zmień %1 o %2",
    "DATA_SHOWVARIABLE": "pokaż zmienną %1",
    "DATA_HIDEVARIABLE": "ukryj zmienną %1",
    "DATA_ADDTOLIST": "dodaj %1 do %2",
    "DATA_DELETEOFLIST": "usuń %1 z %2",
    "DATA_DELETEALLOFLIST": "usuń wszystko z %1",
    "DATA_INSERTATLIST": "wstaw %1 na %2 pozycji z %3",
    "DATA_REPLACEITEMOFLIST": "zamień %1 z %2 na %3",
    "DATA_ITEMOFLIST": "element %1 z %2",
    "DATA_ITEMNUMOFLIST": "pozycja %1 na liście %2",
    "DATA_LENGTHOFLIST": "długość %1",
    "DATA_LISTCONTAINSITEM": "%1 zawiera %2?",
    "DATA_SHOWLIST": "pokaż listę %1",
    "DATA_HIDELIST": "ukryj listę %1",
    "DATA_INDEX_ALL": "wszystko",
    "DATA_INDEX_LAST": "ostatni",
    "DATA_INDEX_RANDOM": "losowa",
    "EVENT_WHENFLAGCLICKED": "kiedy kliknięto %1",
    "EVENT_WHENTHISSPRITECLICKED": "kiedy ten duszek kliknięty",
    "EVENT_WHENSTAGECLICKED": "kiedy scena kliknięta",
    "EVENT_WHENTOUCHINGOBJECT": "kiedy ten duszek dotknie %1",
    "EVENT_WHENBROADCASTRECEIVED": "kiedy otrzymam %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "kiedy tło zmieni się na %1",
    "EVENT_WHENGREATERTHAN": "kiedy %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "stoper",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "głośność",
    "EVENT_BROADCAST": "nadaj komunikat %1",
    "EVENT_BROADCASTANDWAIT": "nadaj komunikat %1 i czekaj",
    "EVENT_WHENKEYPRESSED": "kiedy klawisz %1 naciśnięty",
    "EVENT_WHENKEYPRESSED_SPACE": "spacja",
    "EVENT_WHENKEYPRESSED_LEFT": "strzałka w lewo",
    "EVENT_WHENKEYPRESSED_RIGHT": "strzałka w prawo",
    "EVENT_WHENKEYPRESSED_DOWN": "strzałka w dół",
    "EVENT_WHENKEYPRESSED_UP": "strzałka w górę",
    "EVENT_WHENKEYPRESSED_ANY": "dowolny",
    "LOOKS_SAYFORSECS": "powiedz %1 przez %2 sekund",
    "LOOKS_SAY": "powiedz %1",
    "LOOKS_HELLO": "Cześć!",
    "LOOKS_THINKFORSECS": "pomyśl %1 przez %2 sekund",
    "LOOKS_THINK": "pomyśl %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "pokaż",
    "LOOKS_HIDE": "ukryj",
    "LOOKS_HIDEALLSPRITES": "ukryj wszystkie duszki",
    "LOOKS_EFFECT_COLOR": "kolor",
    "LOOKS_EFFECT_FISHEYE": "rybie oko",
    "LOOKS_EFFECT_WHIRL": "wir",
    "LOOKS_EFFECT_PIXELATE": "zniekształć",
    "LOOKS_EFFECT_MOSAIC": "mozaika",
    "LOOKS_EFFECT_BRIGHTNESS": "jasność",
    "LOOKS_EFFECT_GHOST": "duch",
    "LOOKS_CHANGEEFFECTBY": "zmień efekt %1 o %2",
    "LOOKS_SETEFFECTTO": "ustaw efekt %1 na %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "wyczyść efekty graficzne",
    "LOOKS_CHANGESIZEBY": "zmień rozmiar o %1",
    "LOOKS_SETSIZETO": "ustaw rozmiar na %1 %",
    "LOOKS_SIZE": "rozmiar",
    "LOOKS_CHANGESTRETCHBY": "zmień rozciągnięcie o %1",
    "LOOKS_SETSTRETCHTO": "ustaw rozciąganie na %1 %",
    "LOOKS_SWITCHCOSTUMETO": "zmień kostium na %1",
    "LOOKS_NEXTCOSTUME": "następny kostium",
    "LOOKS_SWITCHBACKDROPTO": "zmień tło na %1",
    "LOOKS_GOTOFRONTBACK": "przesuń na %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "wierzch",
    "LOOKS_GOTOFRONTBACK_BACK": "spód",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "przesuń %1 o %2 warstw",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "do przodu",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "do tyłu",
    "LOOKS_BACKDROPNUMBERNAME": "tło %1",
    "LOOKS_COSTUMENUMBERNAME": "kostium %1",
    "LOOKS_NUMBERNAME_NUMBER": "liczba",
    "LOOKS_NUMBERNAME_NAME": "nazwa",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "zmień tło na %1 i czekaj",
    "LOOKS_NEXTBACKDROP_BLOCK": "następne tło",
    "LOOKS_NEXTBACKDROP": "następne tło",
    "LOOKS_PREVIOUSBACKDROP": "poprzednie tło",
    "LOOKS_RANDOMBACKDROP": "losowo wybrane tło",
    "MOTION_MOVESTEPS": "przesuń o %1 kroków",
    "MOTION_TURNLEFT": "obróć %1 o %2 stopni",
    "MOTION_TURNRIGHT": "obróć %1 o %2 stopni",
    "MOTION_POINTINDIRECTION": "ustaw kierunek na %1",
    "MOTION_POINTTOWARDS": "ustaw w kierunku duszka %1",
    "MOTION_POINTTOWARDS_POINTER": "wskaźnik myszy",
    "MOTION_POINTTOWARDS_RANDOM": "losowy kierunek",
    "MOTION_GOTO": "idź do %1",
    "MOTION_GOTO_POINTER": "wskaźnik myszy",
    "MOTION_GOTO_RANDOM": "losowa pozycja",
    "MOTION_GOTOXY": "Idź do x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "leć przez %1 sekund do x: %2 y: %3",
    "MOTION_GLIDETO": "leć przez %1 sekund do %2",
    "MOTION_GLIDETO_POINTER": "wskaźnik myszy",
    "MOTION_GLIDETO_RANDOM": "losowa pozycja",
    "MOTION_CHANGEXBY": "zmień x o %1",
    "MOTION_SETX": "ustaw x na %1",
    "MOTION_CHANGEYBY": "zmień y o %1",
    "MOTION_SETY": "ustaw y na %1",
    "MOTION_IFONEDGEBOUNCE": "jeżeli na brzegu, odbij się",
    "MOTION_SETROTATIONSTYLE": "ustaw styl obrotu na %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "lewo-prawo",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "nie obracaj",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "dookoła",
    "MOTION_XPOSITION": "pozycja x",
    "MOTION_YPOSITION": "pozycja y",
    "MOTION_DIRECTION": "kierunek",
    "MOTION_SCROLLRIGHT": "przewiń w prawo %1",
    "MOTION_SCROLLUP": "przewiń w górę %1",
    "MOTION_ALIGNSCENE": "wyrównaj scenę %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "na dole po lewej stronie",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "na dole z prawej stronie",
    "MOTION_ALIGNSCENE_MIDDLE": "środek",
    "MOTION_ALIGNSCENE_TOPLEFT": "na górze po lewej stronie",
    "MOTION_ALIGNSCENE_TOPRIGHT": "na górze po prawej stronie",
    "MOTION_XSCROLL": "przewijanie x",
    "MOTION_YSCROLL": "przewijanie y",
    "MOTION_STAGE_SELECTED": "wybrana scena: bez bloków ruchu",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "losuj liczbę od %1 do %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 i %2",
    "OPERATORS_OR": "%1 lub %2",
    "OPERATORS_NOT": "nie %1",
    "OPERATORS_JOIN": "połącz %1 i %2",
    "OPERATORS_JOIN_APPLE": "jabłko",
    "OPERATORS_JOIN_BANANA": "banan",
    "OPERATORS_LETTEROF": "litera %1 z %2",
    "OPERATORS_LETTEROF_APPLE": "j",
    "OPERATORS_LENGTH": "długość %1",
    "OPERATORS_CONTAINS": "Czy %1 zawiera %2 ?",
    "OPERATORS_MOD": "reszta z dzielenia %1 przez %2",
    "OPERATORS_ROUND": "zaokrąglij %1",
    "OPERATORS_MATHOP": "%1 z %2",
    "OPERATORS_MATHOP_ABS": "wartość bezwzględna",
    "OPERATORS_MATHOP_FLOOR": "podłoga",
    "OPERATORS_MATHOP_CEILING": "sufit",
    "OPERATORS_MATHOP_SQRT": "pierwiastek kwadratowy",
    "OPERATORS_MATHOP_SIN": "sinus",
    "OPERATORS_MATHOP_COS": "cosinus",
    "OPERATORS_MATHOP_TAN": "tangens",
    "OPERATORS_MATHOP_ASIN": "arcus sinus",
    "OPERATORS_MATHOP_ACOS": "arcus cosinus",
    "OPERATORS_MATHOP_ATAN": "arcus tangens",
    "OPERATORS_MATHOP_LN": "logarytm naturalny",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definiuj %1",
    "SENSING_TOUCHINGOBJECT": "dotyka %1 ?",
    "SENSING_TOUCHINGOBJECT_POINTER": "wskaźnik myszy",
    "SENSING_TOUCHINGOBJECT_EDGE": "krawędź",
    "SENSING_TOUCHINGCOLOR": "dotyka koloru %1 ?",
    "SENSING_COLORISTOUCHINGCOLOR": "kolor %1 dotyka %2 ? ",
    "SENSING_DISTANCETO": "odległość od %1",
    "SENSING_DISTANCETO_POINTER": "wskaźnik myszy",
    "SENSING_ASKANDWAIT": "zapytaj %1 i czekaj",
    "SENSING_ASK_TEXT": "Jak się nazywasz?",
    "SENSING_ANSWER": "odpowiedź",
    "SENSING_KEYPRESSED": "klawisz %1 naciśnięty ?",
    "SENSING_MOUSEDOWN": "kliknięto myszką?",
    "SENSING_MOUSEX": "x myszy",
    "SENSING_MOUSEY": "y myszy",
    "SENSING_SETDRAGMODE": "ustaw tryb przeciągania na %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "z przeciąganiem",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "bez przeciągania",
    "SENSING_LOUDNESS": "głośność",
    "SENSING_LOUD": "głośno?",
    "SENSING_TIMER": "stoper",
    "SENSING_RESETTIMER": "resetuj stoper",
    "SENSING_OF": "%1 z %2",
    "SENSING_OF_XPOSITION": "pozycja x",
    "SENSING_OF_YPOSITION": "pozycja y",
    "SENSING_OF_DIRECTION": "kierunek",
    "SENSING_OF_COSTUMENUMBER": "indeks kostiumu",
    "SENSING_OF_COSTUMENAME": "nazwa kostiumu",
    "SENSING_OF_SIZE": "rozmiar",
    "SENSING_OF_VOLUME": "głośność",
    "SENSING_OF_BACKDROPNUMBER": "indeks tła",
    "SENSING_OF_BACKDROPNAME": "nazwa tła",
    "SENSING_OF_STAGE": "scena",
    "SENSING_CURRENT": "obecny %1",
    "SENSING_CURRENT_YEAR": "rok",
    "SENSING_CURRENT_MONTH": "miesiąc",
    "SENSING_CURRENT_DATE": "dzień",
    "SENSING_CURRENT_DAYOFWEEK": "dzień tygodnia",
    "SENSING_CURRENT_HOUR": "godzina",
    "SENSING_CURRENT_MINUTE": "minuta",
    "SENSING_CURRENT_SECOND": "sekunda",
    "SENSING_DAYSSINCE2000": "dni od 2000",
    "SENSING_USERNAME": "nazwa użytkownika",
    "SENSING_USERID": "ID użytkownika",
    "SOUND_PLAY": "zagraj dźwięk %1",
    "SOUND_PLAYUNTILDONE": "graj dźwięk %1 aż się skończy",
    "SOUND_STOPALLSOUNDS": "zakończ wszystkie dźwięki",
    "SOUND_SETEFFECTO": "ustaw efekt %1 na %2",
    "SOUND_CHANGEEFFECTBY": "zmień efekt %1 o %2",
    "SOUND_CLEAREFFECTS": "usuń efekty dźwiękowe",
    "SOUND_EFFECTS_PITCH": "płynność dźwięku",
    "SOUND_EFFECTS_PAN": "przesuń w lewo/prawo",
    "SOUND_CHANGEVOLUMEBY": "zmień głośność o %1",
    "SOUND_SETVOLUMETO": "ustaw głośność na %1%",
    "SOUND_VOLUME": "głośność",
    "SOUND_RECORD": "nagraj...",
    "CATEGORY_MOTION": "Ruch",
    "CATEGORY_LOOKS": "Wygląd",
    "CATEGORY_SOUND": "Dźwięk",
    "CATEGORY_EVENTS": "Zdarzenia",
    "CATEGORY_CONTROL": "Kontrola",
    "CATEGORY_SENSING": "Czujniki",
    "CATEGORY_OPERATORS": "Wyrażenia",
    "CATEGORY_VARIABLES": "Zmienne",
    "CATEGORY_MYBLOCKS": "Moje bloki",
    "DUPLICATE": "Duplikuj",
    "DELETE": "Usuń",
    "ADD_COMMENT": "Dodaj komentarz",
    "REMOVE_COMMENT": "Usuń komentarz",
    "DELETE_BLOCK": "Usuń blok",
    "DELETE_X_BLOCKS": "Usuń %1 bloków",
    "DELETE_ALL_BLOCKS": "Czy usunąć wszystkie %1 bloków?",
    "CLEAN_UP": "Posprzątaj bloki",
    "HELP": "Pomoc",
    "UNDO": "Cofnij",
    "REDO": "Ponów",
    "EDIT_PROCEDURE": "Edycja",
    "SHOW_PROCEDURE_DEFINITION": "Przejdź do definicji",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Powiedz coś...",
    "COLOUR_HUE_LABEL": "Kolor",
    "COLOUR_SATURATION_LABEL": "Nasycenie",
    "COLOUR_BRIGHTNESS_LABEL": "Jasność",
    "CHANGE_VALUE_TITLE": "Zmień wartość:",
    "RENAME_VARIABLE": "Zmień nazwę zmiennej",
    "RENAME_VARIABLE_TITLE": "Zmień nazwę wszystkich zmiennych \"%1\" na:",
    "RENAME_VARIABLE_MODAL_TITLE": "Zmień nazwę zmiennej",
    "NEW_VARIABLE": "Utwórz zmienną",
    "NEW_VARIABLE_TITLE": "Nowa nazwa zmiennej:",
    "VARIABLE_MODAL_TITLE": "Nowa zmienna",
    "VARIABLE_ALREADY_EXISTS": "Zmienna o nazwie \"%1\" już istnieje.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Zmienna o nazwie \"%1\" już istnieje dla innego typu zmiennej \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Czy usunąć %1 używając zmiennej \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Nie można usunąć zmiennej \"%1\", ponieważ stanowi część definicji funkcji \"%2\"",
    "DELETE_VARIABLE": "Usuń zmienną \"%1\"",
    "NEW_PROCEDURE": "Utwórz blok",
    "PROCEDURE_ALREADY_EXISTS": "Procedura o nazwie \"%1\" już istnieje.",
    "PROCEDURE_DEFAULT_NAME": "nazwa bloku",
    "PROCEDURE_USED": "Aby usunąć blok definicji, najpierw usuń wszystkie jego elementy",
    "NEW_LIST": "Stwórz listę",
    "NEW_LIST_TITLE": "Nowa nazwa lista:",
    "LIST_MODAL_TITLE": "Nowa lista",
    "LIST_ALREADY_EXISTS": "Lista o nazwie \"%1\" już istnieje.",
    "RENAME_LIST_TITLE": "Zmień nazwy wszystkich list \"%1\" na:",
    "RENAME_LIST_MODAL_TITLE": "Zmień nazwę listy",
    "DEFAULT_LIST_ITEM": "obiekt",
    "DELETE_LIST": "Usuń listę \"%1\"",
    "RENAME_LIST": "Zmień nazwę listy",
    "NEW_BROADCAST_MESSAGE": "Nowa wiadomość",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nowa nazwa wiadomości:",
    "BROADCAST_MODAL_TITLE": "Nowa wiadomość",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "wiadomość1"
  },
  "pt": {
    "CONTROL_FOREVER": "repete para sempre",
    "CONTROL_REPEAT": "repete %1 vezes",
    "CONTROL_IF": "se %1 , então",
    "CONTROL_ELSE": "senão,",
    "CONTROL_STOP": "pára",
    "CONTROL_STOP_ALL": "tudo",
    "CONTROL_STOP_THIS": "este guião",
    "CONTROL_STOP_OTHER": "os teus outros guiões",
    "CONTROL_WAIT": "espera %1 s",
    "CONTROL_WAITUNTIL": "espera até que %1",
    "CONTROL_REPEATUNTIL": "até que %1 , repete",
    "CONTROL_WHILE": "enquanto %1",
    "CONTROL_FOREACH": "para cada %1 em %2",
    "CONTROL_STARTASCLONE": "Quando fores criado como um clone",
    "CONTROL_CREATECLONEOF": "cria um clone de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ti mesmo",
    "CONTROL_DELETETHISCLONE": "remove-te como clone",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "incrementa o contador",
    "CONTROL_CLEARCOUNTER": "põe o contador a zero",
    "CONTROL_ALLATONCE": "executa tudo de uma vez",
    "DATA_SETVARIABLETO": "altera %1 para %2",
    "DATA_CHANGEVARIABLEBY": "adiciona a %1 o valor %2",
    "DATA_SHOWVARIABLE": "mostra a variável %1",
    "DATA_HIDEVARIABLE": "esconde a variável %1",
    "DATA_ADDTOLIST": "acrescenta %1 a %2",
    "DATA_DELETEOFLIST": "remove %1 de %2",
    "DATA_DELETEALLOFLIST": "remove tudo de %1",
    "DATA_INSERTATLIST": "insere %1 como %2 de %3",
    "DATA_REPLACEITEMOFLIST": "substitui %1 de %2 por %3",
    "DATA_ITEMOFLIST": "%1 de %2",
    "DATA_ITEMNUMOFLIST": "o número do item %1 em %2",
    "DATA_LENGTHOFLIST": "o comprimento de %1",
    "DATA_LISTCONTAINSITEM": "%1 contém %2",
    "DATA_SHOWLIST": "mostra a lista %1",
    "DATA_HIDELIST": "esconde a lista %1",
    "DATA_INDEX_ALL": "tudo",
    "DATA_INDEX_LAST": "o último item",
    "DATA_INDEX_RANDOM": "um item ao acaso",
    "EVENT_WHENFLAGCLICKED": "Quando alguém clicar em %1",
    "EVENT_WHENTHISSPRITECLICKED": "Quando alguém clicar em ti",
    "EVENT_WHENSTAGECLICKED": "Quando alguém clicar no palco",
    "EVENT_WHENTOUCHINGOBJECT": "Quando tocares em %1",
    "EVENT_WHENBROADCASTRECEIVED": "Quando receberes a mensagem %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "Quando o cenário mudar para %1",
    "EVENT_WHENGREATERTHAN": "Quando o valor do sensor %1 exceder %2",
    "EVENT_WHENGREATERTHAN_TIMER": "o valor do cronómetro",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "o volume no microfone",
    "EVENT_BROADCAST": "difunde a mensagem %1",
    "EVENT_BROADCASTANDWAIT": "difunde a mensagem %1 e espera",
    "EVENT_WHENKEYPRESSED": "Quando alguém pressionar a tecla %1",
    "EVENT_WHENKEYPRESSED_SPACE": "espaço",
    "EVENT_WHENKEYPRESSED_LEFT": "seta para a esquerda",
    "EVENT_WHENKEYPRESSED_RIGHT": "seta para a direita",
    "EVENT_WHENKEYPRESSED_DOWN": "seta para baixo",
    "EVENT_WHENKEYPRESSED_UP": "seta para cima",
    "EVENT_WHENKEYPRESSED_ANY": "qualquer",
    "LOOKS_SAYFORSECS": "diz %1 durante %2 s",
    "LOOKS_SAY": "diz %1",
    "LOOKS_HELLO": "Olá!",
    "LOOKS_THINKFORSECS": "pensa %1 durante %2 s",
    "LOOKS_THINK": "pensa %1",
    "LOOKS_HMM": "Hmm…",
    "LOOKS_SHOW": "mostra-te",
    "LOOKS_HIDE": "esconde-te",
    "LOOKS_HIDEALLSPRITES": "esconde todos os actores",
    "LOOKS_EFFECT_COLOR": "cor",
    "LOOKS_EFFECT_FISHEYE": "olho de peixe",
    "LOOKS_EFFECT_WHIRL": "remoinho",
    "LOOKS_EFFECT_PIXELATE": "pixelização",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "brilho",
    "LOOKS_EFFECT_GHOST": "fantasma",
    "LOOKS_CHANGEEFFECTBY": "adiciona ao teu efeito %1 o valor %2",
    "LOOKS_SETEFFECTTO": "altera o teu efeito %1 para %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "cancela os teus efeitos gráficos",
    "LOOKS_CHANGESIZEBY": "adiciona %1 ao teu tamanho",
    "LOOKS_SETSIZETO": "altera o teu tamanho para %1 %",
    "LOOKS_SIZE": "o tamanho",
    "LOOKS_CHANGESTRETCHBY": "adiciona %1 % ao esticamento",
    "LOOKS_SETSTRETCHTO": "altera o esticamento para %1 %",
    "LOOKS_SWITCHCOSTUMETO": "muda o teu traje para %1",
    "LOOKS_NEXTCOSTUME": "passa para o teu próximo traje",
    "LOOKS_SWITCHBACKDROPTO": "muda o cenário para %1",
    "LOOKS_GOTOFRONTBACK": "vai para a camada %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "frontal",
    "LOOKS_GOTOFRONTBACK_BACK": "traseira",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 camadas",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "avança",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "recua",
    "LOOKS_BACKDROPNUMBERNAME": "%1 do cenário",
    "LOOKS_COSTUMENUMBERNAME": "%1 do traje",
    "LOOKS_NUMBERNAME_NUMBER": "o número",
    "LOOKS_NUMBERNAME_NAME": "o nome",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "muda o cenário para %1 e espera",
    "LOOKS_NEXTBACKDROP_BLOCK": "passa para o teu próximo cenário",
    "LOOKS_NEXTBACKDROP": "passa para o teu próximo cenário",
    "LOOKS_PREVIOUSBACKDROP": "o cenário anterior",
    "LOOKS_RANDOMBACKDROP": "um cenário ao acaso",
    "MOTION_MOVESTEPS": "anda %1 passos",
    "MOTION_TURNLEFT": "gira %1 %2 °",
    "MOTION_TURNRIGHT": "gira %1 %2 °",
    "MOTION_POINTINDIRECTION": "altera a tua direcção para %1 °",
    "MOTION_POINTTOWARDS": "aponta em direcção a %1",
    "MOTION_POINTTOWARDS_POINTER": "ponteiro do rato",
    "MOTION_POINTTOWARDS_RANDOM": "uma direcção ao acaso",
    "MOTION_GOTO": "vai para %1",
    "MOTION_GOTO_POINTER": "o ponteiro do rato",
    "MOTION_GOTO_RANDOM": "uma posição ao acaso",
    "MOTION_GOTOXY": "vai para a posição x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "desliza em %1 s para a posição x: %2 y: %3",
    "MOTION_GLIDETO": "desliza em %1 s em direcção a%2",
    "MOTION_GLIDETO_POINTER": "o ponteiro do rato",
    "MOTION_GLIDETO_RANDOM": "uma posição ao acaso",
    "MOTION_CHANGEXBY": "adiciona %1 ao teu x",
    "MOTION_SETX": "altera o teu x para %1",
    "MOTION_CHANGEYBY": "adiciona %1 ao teu y",
    "MOTION_SETY": "altera o teu y para %1",
    "MOTION_IFONEDGEBOUNCE": "se estiveres a bater na borda, ressalta",
    "MOTION_SETROTATIONSTYLE": "altera o teu estilo de rotação para %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "olha apenas para a esquerda e para a direita",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "não gires",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "gira a toda a volta",
    "MOTION_XPOSITION": "o x da tua posição",
    "MOTION_YPOSITION": "o y da tua posição",
    "MOTION_DIRECTION": "a direcção",
    "MOTION_SCROLLRIGHT": "rola %1 para a direita",
    "MOTION_SCROLLUP": "rola %1 para cima",
    "MOTION_ALIGNSCENE": "alinha a cena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ao fundo e à esquerda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ao fundo e à direita",
    "MOTION_ALIGNSCENE_MIDDLE": "a meio",
    "MOTION_ALIGNSCENE_TOPLEFT": "no topo e à esquerda",
    "MOTION_ALIGNSCENE_TOPRIGHT": "no topo e à direita",
    "MOTION_XSCROLL": "o rolamento em x",
    "MOTION_YSCROLL": "o rolamento em y",
    "MOTION_STAGE_SELECTED": "Palco seleccionado: não tem blocos de movimento",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 − %2",
    "OPERATORS_MULTIPLY": "%1 × %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "um valor ao acaso entre %1 e %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 e %2",
    "OPERATORS_OR": "%1 ou %2",
    "OPERATORS_NOT": "é falso que %1",
    "OPERATORS_JOIN": "a junção de %1 com %2",
    "OPERATORS_JOIN_APPLE": "maçã",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "o caractere %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "o comprimento de %1",
    "OPERATORS_CONTAINS": "%1 contém %2",
    "OPERATORS_MOD": "o resto de %1 a dividir por %2",
    "OPERATORS_ROUND": "o arredondamento de %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "o valor absoluto",
    "OPERATORS_MATHOP_FLOOR": "o chão (o maior inteiro não superior)",
    "OPERATORS_MATHOP_CEILING": "o tecto (menor inteiro não inferior)",
    "OPERATORS_MATHOP_SQRT": "a raiz quadrada",
    "OPERATORS_MATHOP_SIN": "o seno",
    "OPERATORS_MATHOP_COS": "o cosseno",
    "OPERATORS_MATHOP_TAN": "a tangente",
    "OPERATORS_MATHOP_ASIN": "o arco-seno",
    "OPERATORS_MATHOP_ACOS": "o arco-cosseno",
    "OPERATORS_MATHOP_ATAN": "o arco-tangente",
    "OPERATORS_MATHOP_LN": "o logaritmo natural",
    "OPERATORS_MATHOP_LOG": "o logaritmo",
    "OPERATORS_MATHOP_EEXP": "a exponencial",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "Define %1",
    "SENSING_TOUCHINGOBJECT": "estás a tocar em %1",
    "SENSING_TOUCHINGOBJECT_POINTER": "o ponteiro do rato",
    "SENSING_TOUCHINGOBJECT_EDGE": "a borda",
    "SENSING_TOUCHINGCOLOR": "estás a tocar na cor %1",
    "SENSING_COLORISTOUCHINGCOLOR": "a cor %1 está a tocar na cor %2",
    "SENSING_DISTANCETO": "a distância até %1",
    "SENSING_DISTANCETO_POINTER": "o ponteiro do rato",
    "SENSING_ASKANDWAIT": "pergunta %1 e espera pela resposta",
    "SENSING_ASK_TEXT": "Como te chamas?",
    "SENSING_ANSWER": "a resposta",
    "SENSING_KEYPRESSED": "a tecla %1 está a ser pressionada",
    "SENSING_MOUSEDOWN": "o botão do rato está pressionado",
    "SENSING_MOUSEX": "o x da posição do rato",
    "SENSING_MOUSEY": "o y da posição do rato",
    "SENSING_SETDRAGMODE": "altera o teu modo de arrasto para %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastável",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "não arrastável",
    "SENSING_LOUDNESS": "o volume no microfone",
    "SENSING_LOUD": "o som é forte",
    "SENSING_TIMER": "o valor do cronómetro",
    "SENSING_RESETTIMER": "reinicia o cronómetro",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "o x da posição",
    "SENSING_OF_YPOSITION": "o y da posição",
    "SENSING_OF_DIRECTION": "a direcção",
    "SENSING_OF_COSTUMENUMBER": "o número do traje",
    "SENSING_OF_COSTUMENAME": "o nome do traje",
    "SENSING_OF_SIZE": "o tamanho",
    "SENSING_OF_VOLUME": "o volume",
    "SENSING_OF_BACKDROPNUMBER": "o número do cenário",
    "SENSING_OF_BACKDROPNAME": "o nome do cenário",
    "SENSING_OF_STAGE": "o palco",
    "SENSING_CURRENT": "%1 actual",
    "SENSING_CURRENT_YEAR": "o ano",
    "SENSING_CURRENT_MONTH": "o mês",
    "SENSING_CURRENT_DATE": "a data",
    "SENSING_CURRENT_DAYOFWEEK": "o dia da semana",
    "SENSING_CURRENT_HOUR": "a hora",
    "SENSING_CURRENT_MINUTE": "o minuto",
    "SENSING_CURRENT_SECOND": "o segundo",
    "SENSING_DAYSSINCE2000": "o número de dias desde 2000",
    "SENSING_USERNAME": "o nome de utilizador",
    "SENSING_USERID": "o ID de utilizador",
    "SOUND_PLAY": "toca o som %1",
    "SOUND_PLAYUNTILDONE": "toca o som %1 até terminar",
    "SOUND_STOPALLSOUNDS": "pára todos os sons",
    "SOUND_SETEFFECTO": "altera o teu efeito %1 para %2",
    "SOUND_CHANGEEFFECTBY": "adiciona ao teu efeito %1 o valor %2",
    "SOUND_CLEAREFFECTS": "cancela todos os teus efeitos sonoros",
    "SOUND_EFFECTS_PITCH": "tom",
    "SOUND_EFFECTS_PAN": "canal esquerdo/direito",
    "SOUND_CHANGEVOLUMEBY": "adiciona %1 % ao teu volume",
    "SOUND_SETVOLUMETO": "altera o teu volume para %1%",
    "SOUND_VOLUME": "o volume",
    "SOUND_RECORD": "gravar…",
    "CATEGORY_MOTION": "Movimento",
    "CATEGORY_LOOKS": "Aparência",
    "CATEGORY_SOUND": "Som",
    "CATEGORY_EVENTS": "Eventos",
    "CATEGORY_CONTROL": "Controlo",
    "CATEGORY_SENSING": "Sensores",
    "CATEGORY_OPERATORS": "Operadores",
    "CATEGORY_VARIABLES": "Variáveis",
    "CATEGORY_MYBLOCKS": "Os Meus Blocos",
    "DUPLICATE": "Duplicar",
    "DELETE": "Remover",
    "ADD_COMMENT": "Adicionar Comentário",
    "REMOVE_COMMENT": "Remover Comentário",
    "DELETE_BLOCK": "Remover Bloco",
    "DELETE_X_BLOCKS": "Remover %1 Blocos",
    "DELETE_ALL_BLOCKS": "Remover todos os %1 blocos?",
    "CLEAN_UP": "Arrumar Blocos",
    "HELP": "Ajuda",
    "UNDO": "Desfazer",
    "REDO": "Refazer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Ir para a definição",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Diga qualquer coisa…",
    "COLOUR_HUE_LABEL": "Matiz",
    "COLOUR_SATURATION_LABEL": "Saturação",
    "COLOUR_BRIGHTNESS_LABEL": "Brilho",
    "CHANGE_VALUE_TITLE": "Alterar o valor:",
    "RENAME_VARIABLE": "Renomear a variável",
    "RENAME_VARIABLE_TITLE": "Renomear todas as variáveis «%1» para:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renomear Variável",
    "NEW_VARIABLE": "Criar uma Variável",
    "NEW_VARIABLE_TITLE": "Novo nome da variável:",
    "VARIABLE_MODAL_TITLE": "Nova Variável",
    "VARIABLE_ALREADY_EXISTS": "Já existe uma variável com o nome «%1».",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Já existe uma variável com o nome «%1» do tipo «%2».",
    "DELETE_VARIABLE_CONFIRMATION": "Remover %1 utilizações da variável «%2»?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Não é possível remover a variável «%1» porque é parte da definição da função «%2»",
    "DELETE_VARIABLE": "Remover a variável «%1»",
    "NEW_PROCEDURE": "Criar um Bloco",
    "PROCEDURE_ALREADY_EXISTS": "Já existe um procedimento com o nome «%1».",
    "PROCEDURE_DEFAULT_NAME": "nome do bloco",
    "PROCEDURE_USED": "Para remover uma definição de bloco, remova primeiro todas as utilizações desse bloco",
    "NEW_LIST": "Criar uma Lista",
    "NEW_LIST_TITLE": "Nome da nova lista:",
    "LIST_MODAL_TITLE": "Nova Lista",
    "LIST_ALREADY_EXISTS": "Já existe uma lista com o nome «%1».",
    "RENAME_LIST_TITLE": "Renomear todas as listas «%1» para:",
    "RENAME_LIST_MODAL_TITLE": "Renomear Lista",
    "DEFAULT_LIST_ITEM": "uma coisa",
    "DELETE_LIST": "Remover a lista «%1»",
    "RENAME_LIST": "Renomear a lista",
    "NEW_BROADCAST_MESSAGE": "Nova mensagem",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nome da nova mensagem:",
    "BROADCAST_MODAL_TITLE": "Nova Mensagem",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "Mensagem 1"
  },
  "pt-br": {
    "CONTROL_FOREVER": "sempre",
    "CONTROL_REPEAT": "repita %1 vezes",
    "CONTROL_IF": "se %1 então",
    "CONTROL_ELSE": "senão",
    "CONTROL_STOP": "pare",
    "CONTROL_STOP_ALL": "todos",
    "CONTROL_STOP_THIS": "este script",
    "CONTROL_STOP_OTHER": "outros scripts no ator",
    "CONTROL_WAIT": "espere %1 seg",
    "CONTROL_WAITUNTIL": "espere até que %1",
    "CONTROL_REPEATUNTIL": "repita até que %1",
    "CONTROL_WHILE": "enquanto %1",
    "CONTROL_FOREACH": "para cada %1 em %2",
    "CONTROL_STARTASCLONE": "quando eu começar como um clone",
    "CONTROL_CREATECLONEOF": "crie clone de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "este ator",
    "CONTROL_DELETETHISCLONE": "apague este clone",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "desenvolver contador",
    "CONTROL_CLEARCOUNTER": "limpar contador",
    "CONTROL_ALLATONCE": "todos de uma vez",
    "DATA_SETVARIABLETO": "mude %1 para %2",
    "DATA_CHANGEVARIABLEBY": "adicione %2 a %1",
    "DATA_SHOWVARIABLE": "mostre a variável %1",
    "DATA_HIDEVARIABLE": "esconda a variável %1",
    "DATA_ADDTOLIST": "adicione %1 a %2",
    "DATA_DELETEOFLIST": "apague %1 de %2",
    "DATA_DELETEALLOFLIST": "apague todos os itens de %1",
    "DATA_INSERTATLIST": "insira %1 na posição %2 de %3",
    "DATA_REPLACEITEMOFLIST": "substitua o item %1 de %2 por %3",
    "DATA_ITEMOFLIST": "item %1 de %2",
    "DATA_ITEMNUMOFLIST": "item # de %1 em %2",
    "DATA_LENGTHOFLIST": "tamanho de %1",
    "DATA_LISTCONTAINSITEM": "%1 contém %2?",
    "DATA_SHOWLIST": "mostre a lista %1",
    "DATA_HIDELIST": "esconda a lista %1",
    "DATA_INDEX_ALL": "todos",
    "DATA_INDEX_LAST": "último",
    "DATA_INDEX_RANDOM": "aleatório",
    "EVENT_WHENFLAGCLICKED": "quando %1 for clicado",
    "EVENT_WHENTHISSPRITECLICKED": "quando este ator for clicado",
    "EVENT_WHENSTAGECLICKED": "quando o palco for clicado",
    "EVENT_WHENTOUCHINGOBJECT": "quando este ator tocar %1",
    "EVENT_WHENBROADCASTRECEIVED": "quando eu receber %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "quando o cenário mudar para %1",
    "EVENT_WHENGREATERTHAN": "quando %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronômetro",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ruído",
    "EVENT_BROADCAST": "transmita %1",
    "EVENT_BROADCASTANDWAIT": "transmita %1 e espere",
    "EVENT_WHENKEYPRESSED": "quando a tecla %1 for pressionada",
    "EVENT_WHENKEYPRESSED_SPACE": "espaço",
    "EVENT_WHENKEYPRESSED_LEFT": "seta para esquerda",
    "EVENT_WHENKEYPRESSED_RIGHT": "seta para direita",
    "EVENT_WHENKEYPRESSED_DOWN": "seta para baixo",
    "EVENT_WHENKEYPRESSED_UP": "seta para cima",
    "EVENT_WHENKEYPRESSED_ANY": "qualquer",
    "LOOKS_SAYFORSECS": "diga %1 por %2 segundos",
    "LOOKS_SAY": "diga %1",
    "LOOKS_HELLO": "Olá!",
    "LOOKS_THINKFORSECS": "pense %1 por %2 segundos",
    "LOOKS_THINK": "pense %1",
    "LOOKS_HMM": "Hummm...",
    "LOOKS_SHOW": "mostre",
    "LOOKS_HIDE": "esconda",
    "LOOKS_HIDEALLSPRITES": "esconda todos os atores",
    "LOOKS_EFFECT_COLOR": "cor",
    "LOOKS_EFFECT_FISHEYE": "olho de peixe",
    "LOOKS_EFFECT_WHIRL": "turbilhão",
    "LOOKS_EFFECT_PIXELATE": "pixelado",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "brilho",
    "LOOKS_EFFECT_GHOST": "fantasma",
    "LOOKS_CHANGEEFFECTBY": "mude %2 ao efeito %1",
    "LOOKS_SETEFFECTTO": "defina o efeito %1 como %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "remova os efeitos gráficos",
    "LOOKS_CHANGESIZEBY": "mude %1 no tamanho",
    "LOOKS_SETSIZETO": "defina o tamanho como %1 %",
    "LOOKS_SIZE": "tamanho",
    "LOOKS_CHANGESTRETCHBY": "mude trajeto por %1",
    "LOOKS_SETSTRETCHTO": "defina curso para %1 %",
    "LOOKS_SWITCHCOSTUMETO": "mude para a fantasia %1",
    "LOOKS_NEXTCOSTUME": "próxima fantasia",
    "LOOKS_SWITCHBACKDROPTO": "mude para o cenário %1",
    "LOOKS_GOTOFRONTBACK": "vá para a camada %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "da frente",
    "LOOKS_GOTOFRONTBACK_BACK": "de trás",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "vá para %1 %2 camadas",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "frente",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "trás",
    "LOOKS_BACKDROPNUMBERNAME": "cenário %1",
    "LOOKS_COSTUMENUMBERNAME": "fantasia %1",
    "LOOKS_NUMBERNAME_NUMBER": "número",
    "LOOKS_NUMBERNAME_NAME": "nome",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "mude para o cenário %1 e espere",
    "LOOKS_NEXTBACKDROP_BLOCK": "próximo cenário",
    "LOOKS_NEXTBACKDROP": "próximo cenário",
    "LOOKS_PREVIOUSBACKDROP": "cenário anterior",
    "LOOKS_RANDOMBACKDROP": "cenário aleatório",
    "MOTION_MOVESTEPS": "mova %1 passos",
    "MOTION_TURNLEFT": "gire %1 %2 graus",
    "MOTION_TURNRIGHT": "gire %1 %2 graus",
    "MOTION_POINTINDIRECTION": "aponte para a direção %1",
    "MOTION_POINTTOWARDS": "aponte para %1",
    "MOTION_POINTTOWARDS_POINTER": "ponteiro do mouse",
    "MOTION_POINTTOWARDS_RANDOM": "direção aleatória",
    "MOTION_GOTO": "vá para %1",
    "MOTION_GOTO_POINTER": "ponteiro do mouse",
    "MOTION_GOTO_RANDOM": "posição aleatória",
    "MOTION_GOTOXY": "vá para x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "deslize por %1 segs. até x: %2 y: %3",
    "MOTION_GLIDETO": "deslize por %1 segs. até %2",
    "MOTION_GLIDETO_POINTER": "ponteiro do mouse",
    "MOTION_GLIDETO_RANDOM": "posição aleatória",
    "MOTION_CHANGEXBY": "adicione %1 a x",
    "MOTION_SETX": "mude x para %1",
    "MOTION_CHANGEYBY": "adicione %1 a y",
    "MOTION_SETY": "mude y para %1",
    "MOTION_IFONEDGEBOUNCE": "se tocar na borda, volte",
    "MOTION_SETROTATIONSTYLE": "defina o estilo de rotação para %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "esquerda-direita",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "não rotacionar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "rotação completa",
    "MOTION_XPOSITION": "posição x",
    "MOTION_YPOSITION": "posição y",
    "MOTION_DIRECTION": "direção",
    "MOTION_SCROLLRIGHT": "rolar para direita %1 %",
    "MOTION_SCROLLUP": "rolar para cima %1",
    "MOTION_ALIGNSCENE": "alinhar cena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "inferior esquerda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "inferior direita",
    "MOTION_ALIGNSCENE_MIDDLE": "meio",
    "MOTION_ALIGNSCENE_TOPLEFT": "superior esquerdo",
    "MOTION_ALIGNSCENE_TOPRIGHT": "superior direita",
    "MOTION_XSCROLL": "rolagem eixo x",
    "MOTION_YSCROLL": "rolagem eixo y",
    "MOTION_STAGE_SELECTED": "Palco selecionado: sem blocos de movimento",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "número aleatório entre %1 e %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 e %2",
    "OPERATORS_OR": "%1 ou %2",
    "OPERATORS_NOT": "não %1",
    "OPERATORS_JOIN": "junte %1 com %2",
    "OPERATORS_JOIN_APPLE": "maçã",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "m",
    "OPERATORS_LENGTH": "tamanho de %1",
    "OPERATORS_CONTAINS": "%1 contém %2?",
    "OPERATORS_MOD": "resto de %1 por %2",
    "OPERATORS_ROUND": "arredondamento de %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "módulo",
    "OPERATORS_MATHOP_FLOOR": "arredondamento para baixo de",
    "OPERATORS_MATHOP_CEILING": "arredondamento para cima de",
    "OPERATORS_MATHOP_SQRT": "raiz quadrada",
    "OPERATORS_MATHOP_SIN": "sen",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tg",
    "OPERATORS_MATHOP_ASIN": "arcsen",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctg",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "logaritmo",
    "OPERATORS_MATHOP_EEXP": "e elevado à ",
    "OPERATORS_MATHOP_10EXP": "10 elevado à ",
    "PROCEDURES_DEFINITION": "defina %1",
    "SENSING_TOUCHINGOBJECT": "tocando em %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "ponteiro do mouse",
    "SENSING_TOUCHINGOBJECT_EDGE": "borda",
    "SENSING_TOUCHINGCOLOR": "tocando na cor %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "a cor %1 está tocando na cor %2?",
    "SENSING_DISTANCETO": "distância até %1",
    "SENSING_DISTANCETO_POINTER": "ponteiro do mouse",
    "SENSING_ASKANDWAIT": "pergunte %1 e espere",
    "SENSING_ASK_TEXT": "Qual o seu nome?",
    "SENSING_ANSWER": "resposta",
    "SENSING_KEYPRESSED": "tecla %1 pressionada?",
    "SENSING_MOUSEDOWN": "mouse pressionado?",
    "SENSING_MOUSEX": "posição x do mouse",
    "SENSING_MOUSEY": "posição y do mouse",
    "SENSING_SETDRAGMODE": "defina modo de arrasto para %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastável",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "não arrastável",
    "SENSING_LOUDNESS": "ruído",
    "SENSING_LOUD": "alto?",
    "SENSING_TIMER": "cronômetro",
    "SENSING_RESETTIMER": "zere o cronômetro",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posição x",
    "SENSING_OF_YPOSITION": "posição y",
    "SENSING_OF_DIRECTION": "direção",
    "SENSING_OF_COSTUMENUMBER": "n° da fantasia",
    "SENSING_OF_COSTUMENAME": "nome da fantasia",
    "SENSING_OF_SIZE": "tamanho",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "n° do cenário",
    "SENSING_OF_BACKDROPNAME": "nome do cenário",
    "SENSING_OF_STAGE": "Palco",
    "SENSING_CURRENT": "%1 atual",
    "SENSING_CURRENT_YEAR": "ano",
    "SENSING_CURRENT_MONTH": "mês",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "dia da semana",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "segundo",
    "SENSING_DAYSSINCE2000": "número de dias desde 2000",
    "SENSING_USERNAME": "nome de usuário",
    "SENSING_USERID": "id do usuário",
    "SOUND_PLAY": "toque o som %1",
    "SOUND_PLAYUNTILDONE": "toque o som %1 até o fim",
    "SOUND_STOPALLSOUNDS": "pare todos os sons",
    "SOUND_SETEFFECTO": "mude o efeito %1 para %2",
    "SOUND_CHANGEEFFECTBY": "mude  %2 no efeito %1",
    "SOUND_CLEAREFFECTS": "remova os efeitos sonoros ",
    "SOUND_EFFECTS_PITCH": "tom",
    "SOUND_EFFECTS_PAN": "balanço esquerda/direita",
    "SOUND_CHANGEVOLUMEBY": "mude volume em %1",
    "SOUND_SETVOLUMETO": "mude o volume para %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "gravar...",
    "CATEGORY_MOTION": "Movimento",
    "CATEGORY_LOOKS": "Aparência",
    "CATEGORY_SOUND": "Som",
    "CATEGORY_EVENTS": "Eventos",
    "CATEGORY_CONTROL": "Controle",
    "CATEGORY_SENSING": "Sensores",
    "CATEGORY_OPERATORS": "Operadores",
    "CATEGORY_VARIABLES": "Variáveis",
    "CATEGORY_MYBLOCKS": "Meus Blocos",
    "DUPLICATE": "Duplicar",
    "DELETE": "Apagar",
    "ADD_COMMENT": "Comentar",
    "REMOVE_COMMENT": "Remover Comentário",
    "DELETE_BLOCK": "Apagar Bloco",
    "DELETE_X_BLOCKS": "Apagar %1 Blocos",
    "DELETE_ALL_BLOCKS": "Apagar todos os blocos %1?",
    "CLEAN_UP": "Organizar Blocos",
    "HELP": "Ajuda",
    "UNDO": "Desfazer",
    "REDO": "Refazer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Vá para definição",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Diga algo...",
    "COLOUR_HUE_LABEL": "Cor",
    "COLOUR_SATURATION_LABEL": "Saturação",
    "COLOUR_BRIGHTNESS_LABEL": "Brilho",
    "CHANGE_VALUE_TITLE": "Mudar valor:",
    "RENAME_VARIABLE": "Renomear variável",
    "RENAME_VARIABLE_TITLE": "Renomear todas as variáveis \"%1\" para:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renomear Variável",
    "NEW_VARIABLE": "Criar uma Variável",
    "NEW_VARIABLE_TITLE": "Nome da nova variável:",
    "VARIABLE_MODAL_TITLE": "Nova Variável",
    "VARIABLE_ALREADY_EXISTS": "Uma variável chamada \"%1\" já existe.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Uma variável chamada \"%1\" já existe para outra variável do tipo \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Apagar os %1 usos da variável \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Não é possível apagar a variável '%1' pois ela faz parte da definição do bloco '%2'",
    "DELETE_VARIABLE": "Apagar a variável '%1'",
    "NEW_PROCEDURE": "Criar um bloco",
    "PROCEDURE_ALREADY_EXISTS": "Já existe um bloco chamado '%1'.",
    "PROCEDURE_DEFAULT_NAME": "nome do bloco",
    "PROCEDURE_USED": "Para remover a definição de um bloco, elimine primeiro todas as referências a esse bloco.",
    "NEW_LIST": "Criar uma Lista",
    "NEW_LIST_TITLE": "Nome da nova lista:",
    "LIST_MODAL_TITLE": "Nova Lista",
    "LIST_ALREADY_EXISTS": "Já existe uma lista chamada '%1'.",
    "RENAME_LIST_TITLE": "Renomear todas as listas \"%1\" para:",
    "RENAME_LIST_MODAL_TITLE": "Renomear Lista",
    "DEFAULT_LIST_ITEM": "coisa",
    "DELETE_LIST": "Apagar a lista \"%1\"",
    "RENAME_LIST": "Renomear lista",
    "NEW_BROADCAST_MESSAGE": "Nova mensagem",
    "NEW_BROADCAST_MESSAGE_TITLE": "Novo nome de mensagem:",
    "BROADCAST_MODAL_TITLE": "Nova Mensagem",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mensagem 1"
  },
  "rap": {
    "CONTROL_FOREVER": "mo āŋa paurō te hora",
    "CONTROL_REPEAT": "haka ʾou %1",
    "CONTROL_IF": "eʾe %1 oira",
    "CONTROL_ELSE": "eʾe ina",
    "CONTROL_STOP": "noho",
    "CONTROL_STOP_ALL": "taʾatoʾa",
    "CONTROL_STOP_THIS": "te āŋa nei he programa",
    "CONTROL_STOP_OTHER": "te tahi programa i te sprite",
    "CONTROL_WAIT": "e tiaki %1 piere",
    "CONTROL_WAITUNTIL": "tiaki ki %1",
    "CONTROL_REPEATUNTIL": "hakaʾou ki %1",
    "CONTROL_WHILE": "ki te tiaki %1",
    "CONTROL_FOREACH": "mo te %1 e ai te %2",
    "CONTROL_STARTASCLONE": "ki haʾamata pahe clon",
    "CONTROL_CREATECLONEOF": "e aŋa te ko tu meʾe a o te %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ko au mau ā",
    "CONTROL_DELETETHISCLONE": "haka kore te clon nei",
    "CONTROL_COUNTER": "te tataku",
    "CONTROL_INCRCOUNTER": "e hahaʾo te tataku",
    "CONTROL_CLEARCOUNTER": "haka kore te tataku",
    "CONTROL_ALLATONCE": "taʾatoʾa etahi no vece",
    "DATA_SETVARIABLETO": " e vaʾai ki te %1 te mau %2",
    "DATA_CHANGEVARIABLEBY": "haka rahi ki te %1 %2",
    "DATA_SHOWVARIABLE": "haka tikeʾa te variable %1",
    "DATA_HIDEVARIABLE": "e naʾa te variable %1",
    "DATA_ADDTOLIST": "ka hahaʾo te %1 ki te %2",
    "DATA_DELETEOFLIST": "haka kore %1 de %2",
    "DATA_DELETEALLOFLIST": "haka kore taʾa toʾa te %1",
    "DATA_INSERTATLIST": "e hahaʾo te %1 ki te %2 o te %3",
    "DATA_REPLACEITEMOFLIST": "ka hahaʾo te rua meʾe %1 o te %2 hai %3",
    "DATA_ITEMOFLIST": "meʾe %1 i te %2",
    "DATA_ITEMNUMOFLIST": "# o te meʾe he %1 i te %2",
    "DATA_LENGTHOFLIST": "roa roa o te %1",
    "DATA_LISTCONTAINSITEM": "¿%2 e ai era te %1?",
    "DATA_SHOWLIST": "haka tikeʾa te parau o te meʾe %1",
    "DATA_HIDELIST": "naʾa te parau %1",
    "DATA_INDEX_ALL": "taʾatoʾa",
    "DATA_INDEX_LAST": "hopeʾa",
    "DATA_INDEX_RANDOM": "aleatorio",
    "EVENT_WHENFLAGCLICKED": "ki āŋa te clic i te %1",
    "EVENT_WHENTHISSPRITECLICKED": "ki āŋa te clic i te meʾe nei",
    "EVENT_WHENSTAGECLICKED": "mo ŋatu te clic i te ahu",
    "EVENT_WHENTOUCHINGOBJECT": "mo te sprite he ŋatu te %1",
    "EVENT_WHENBROADCASTRECEIVED": "ki vaʾai mai %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "ki kamiare te tuʾa nui ki te %1",
    "EVENT_WHENGREATERTHAN": " a he %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronómetro",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "volumen o te pakeke",
    "EVENT_BROADCAST": "haka oho %1",
    "EVENT_BROADCASTANDWAIT": "e haka oho %1 e tiaki",
    "EVENT_WHENKEYPRESSED": "mo ŋatu te pito pito %1",
    "EVENT_WHENKEYPRESSED_SPACE": "kona",
    "EVENT_WHENKEYPRESSED_LEFT": "teʾa maui",
    "EVENT_WHENKEYPRESSED_RIGHT": "teʾa mataʾu",
    "EVENT_WHENKEYPRESSED_DOWN": "teʾa ki raro",
    "EVENT_WHENKEYPRESSED_UP": "teʾa ki ruŋa",
    "EVENT_WHENKEYPRESSED_ANY": "taʾatoʾa meʾe",
    "LOOKS_SAYFORSECS": "e ki %1 i te %2 segundos",
    "LOOKS_SAY": "e ki %1",
    "LOOKS_HELLO": "¡Iorana!",
    "LOOKS_THINKFORSECS": "e manaʾu mmmm %1 i te %2",
    "LOOKS_THINK": "e manaʾu %1",
    "LOOKS_HMM": "Umm...",
    "LOOKS_SHOW": "haka tikeʾa",
    "LOOKS_HIDE": "naʾa",
    "LOOKS_HIDEALLSPRITES": "ka naʾa te sprite taʾatoʾa",
    "LOOKS_EFFECT_COLOR": "kiʾea",
    "LOOKS_EFFECT_FISHEYE": "ojo de pez",
    "LOOKS_EFFECT_WHIRL": "remolino",
    "LOOKS_EFFECT_PIXELATE": "pixelar",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "ʾuira",
    "LOOKS_EFFECT_GHOST": "haka kore iti",
    "LOOKS_CHANGEEFFECTBY": "haka rahi te efecto %1 %2",
    "LOOKS_SETEFFECTTO": "ka vaʾai te efecto %1 te %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "haka kore te efectos graficos",
    "LOOKS_CHANGESIZEBY": "ka kamiare te nui nui hai %1",
    "LOOKS_SETSIZETO": "haka noho te nui nui ki te %1 %",
    "LOOKS_SIZE": "he haito",
    "LOOKS_CHANGESTRETCHBY": "haka rahi ki te haka roa roa te %1",
    "LOOKS_SETSTRETCHTO": "haka tano te haka roa roa ki te %1",
    "LOOKS_SWITCHCOSTUMETO": "ka kamiare te diseño ki te %1",
    "LOOKS_NEXTCOSTUME": "te rua diseño",
    "LOOKS_SWITCHBACKDROPTO": "ka kamiare te tuʾa nui ki te %1",
    "LOOKS_GOTOFRONTBACK": "e oho a capa %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "a muʾa ki te tahi",
    "LOOKS_GOTOFRONTBACK_BACK": "i tuʾa",
    "LOOKS_GOFORWARDBACKWARDLAYERS": " e oho %2 capas ki te %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "a muʾa ki te tahi",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "a tuʾa ",
    "LOOKS_BACKDROPNUMBERNAME": "%1 o te tuʾa nui",
    "LOOKS_COSTUMENUMBERNAME": "%1 o te diseño",
    "LOOKS_NUMBERNAME_NUMBER": "nūmera",
    "LOOKS_NUMBERNAME_NAME": "iŋoa",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "kamiare te tuʾa nui ki te %1 e ka tiaki",
    "LOOKS_NEXTBACKDROP_BLOCK": "te rua tuʾa nui",
    "LOOKS_NEXTBACKDROP": "te rua tuʾa nui",
    "LOOKS_PREVIOUSBACKDROP": "tuʾa nui hoki a tuʾa",
    "LOOKS_RANDOMBACKDROP": "tuʾa nui aleatorio",
    "MOTION_MOVESTEPS": "e makenu %1 te vaʾe",
    "MOTION_TURNLEFT": "e teka %1 %2 grados",
    "MOTION_TURNRIGHT": "e teka %1 %2 grados",
    "MOTION_POINTINDIRECTION": "ka tuhi ki te kona %1",
    "MOTION_POINTTOWARDS": "ka tuki ki %1",
    "MOTION_POINTTOWARDS_POINTER": "teʾa  kioʾe",
    "MOTION_POINTTOWARDS_RANDOM": "he oho haŋa te aleatoria",
    "MOTION_GOTO": "e oho ki te %1",
    "MOTION_GOTO_POINTER": "teʾa  kioʾe",
    "MOTION_GOTO_RANDOM": "posición aleatoria",
    "MOTION_GOTOXY": "e oho ki te a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "haka nini ki te %1 piere ki te x:%2 y: %3",
    "MOTION_GLIDETO": "haka nini hai %1 piere ki te %2",
    "MOTION_GLIDETO_POINTER": "teʾa  kioʾe",
    "MOTION_GLIDETO_RANDOM": "posición aleatoria",
    "MOTION_CHANGEXBY": "haka rahi te a x %1",
    "MOTION_SETX": "ka vaʾai ki te x te mau %1",
    "MOTION_CHANGEYBY": "haka rahi te y %1",
    "MOTION_SETY": "ka vaʾai ki te a e ki te %1",
    "MOTION_IFONEDGEBOUNCE": "ana hahine ki te titi, ka rere rere",
    "MOTION_SETROTATIONSTYLE": "fijar estilo de rotación a %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "maūi - mataʾu",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ina ko haka teka",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "ki te taʾatoʾa kona",
    "MOTION_XPOSITION": "he noho o te x",
    "MOTION_YPOSITION": "he noho o te y",
    "MOTION_DIRECTION": "ara",
    "MOTION_SCROLLRIGHT": "ka makenu ki te mataʾu %1",
    "MOTION_SCROLLUP": "ka makenu ki ruŋa %1",
    "MOTION_ALIGNSCENE": "haka titika te escena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "i raro ki te maui",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "i raro ki mataʾu",
    "MOTION_ALIGNSCENE_MIDDLE": "ki vaeŋa",
    "MOTION_ALIGNSCENE_TOPLEFT": "a ruŋa ki te maui",
    "MOTION_ALIGNSCENE_TOPRIGHT": "a ruŋa ki te mataʾu",
    "MOTION_XSCROLL": "he makenu hai x",
    "MOTION_YSCROLL": "he makenu hai y",
    "MOTION_STAGE_SELECTED": "escenario tuhi: ina he avahata mo te makenu",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "numera aleatorio i a %1 e %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 e %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "ina %1",
    "OPERATORS_JOIN": "ka haka piri %1 %2",
    "OPERATORS_JOIN_APPLE": "manzana",
    "OPERATORS_JOIN_BANANA": "maika",
    "OPERATORS_LETTEROF": " tiaraʾa %1 o te %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "roa roa o te %1",
    "OPERATORS_CONTAINS": "¿%2 e ai era te %1?",
    "OPERATORS_MOD": "%1 módulo %2",
    "OPERATORS_ROUND": "haka taka taka %1",
    "OPERATORS_MATHOP": "%1 o te %2",
    "OPERATORS_MATHOP_ABS": "valor absoluto",
    "OPERATORS_MATHOP_FLOOR": "suelo",
    "OPERATORS_MATHOP_CEILING": "techo",
    "OPERATORS_MATHOP_SQRT": "raíz cuadrada",
    "OPERATORS_MATHOP_SIN": "sen",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsen",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "haka tano te %1",
    "SENSING_TOUCHINGOBJECT": "¿e puʾa %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "teʾa  kioʾe",
    "SENSING_TOUCHINGOBJECT_EDGE": "tītī",
    "SENSING_TOUCHINGCOLOR": "¿e puʾa te kiea %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "¿kiea %1 ē puʾa %2?",
    "SENSING_DISTANCETO": "roa ki %1",
    "SENSING_DISTANCETO_POINTER": "teʾa  kioʾe",
    "SENSING_ASKANDWAIT": "e ʾui %1 e he tiaki",
    "SENSING_ASK_TEXT": "¿ko ai toʾu iŋoa?",
    "SENSING_ANSWER": "pahono",
    "SENSING_KEYPRESSED": "¿pito pito %1 ko ŋatu ā?",
    "SENSING_MOUSEDOWN": "¿kioʾe ko te ŋatu hāŋa ā?",
    "SENSING_MOUSEX": "he kona noho x o te kioʾe",
    "SENSING_MOUSEY": "he kona noho y o te kioʾe",
    "SENSING_SETDRAGMODE": "haka titika te modo makenu ki te %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "e riva ro mo haka makenu",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "e ko tano mo haka makenu",
    "SENSING_LOUDNESS": "volumen o te pakeke",
    "SENSING_LOUD": "¿poŋeha?",
    "SENSING_TIMER": "cronómetro",
    "SENSING_RESETTIMER": "e haʾamata haka ʾou te cronómetro",
    "SENSING_OF": "%1 o te %2",
    "SENSING_OF_XPOSITION": "he noho o te x",
    "SENSING_OF_YPOSITION": "he noho o te y",
    "SENSING_OF_DIRECTION": "ara",
    "SENSING_OF_COSTUMENUMBER": "# o te diseño",
    "SENSING_OF_COSTUMENAME": "iŋoa o te diseño",
    "SENSING_OF_SIZE": "he haito",
    "SENSING_OF_VOLUME": "re´o o te computador",
    "SENSING_OF_BACKDROPNUMBER": " o te tuʾa nui",
    "SENSING_OF_BACKDROPNAME": "iŋoa o te tuʾa nui",
    "SENSING_OF_STAGE": "Ahu",
    "SENSING_CURRENT": "%1 apī",
    "SENSING_CURRENT_YEAR": "matahiti",
    "SENSING_CURRENT_MONTH": "avaʾe",
    "SENSING_CURRENT_DATE": "mahana",
    "SENSING_CURRENT_DAYOFWEEK": "mahana o te tapati",
    "SENSING_CURRENT_HOUR": "hōra",
    "SENSING_CURRENT_MINUTE": "minuti",
    "SENSING_CURRENT_SECOND": "segundo",
    "SENSING_DAYSSINCE2000": "he mahana mai te 2000",
    "SENSING_USERNAME": "iŋoa o te  usuario",
    "SENSING_USERID": "id o te kope kori",
    "SOUND_PLAY": "haʾamata te pakeke %1",
    "SOUND_PLAYUNTILDONE": "ka pakeke %1 ki te oti",
    "SOUND_STOPALLSOUNDS": "haka noho te pakeke taʾatoʾa",
    "SOUND_SETEFFECTO": "ka vaʾai te efecto %1 te %2",
    "SOUND_CHANGEEFFECTBY": "haka rahi te efecto %1 %2",
    "SOUND_CLEAREFFECTS": "haka kore te  efecto  o te pakeke",
    "SOUND_EFFECTS_PITCH": "roa roatano",
    "SOUND_EFFECTS_PAN": "haka iri te reʾo o a te maui o a te mataʾu",
    "SOUND_CHANGEVOLUMEBY": "ka kamiare te reʾo ki te %1",
    "SOUND_SETVOLUMETO": "haka tano te volumen al %1%",
    "SOUND_VOLUME": "re´o o te computador",
    "SOUND_RECORD": "hapaʾo…",
    "CATEGORY_MOTION": "makenu",
    "CATEGORY_LOOKS": "pahe meʾe no e tahi",
    "CATEGORY_SOUND": "pakeke",
    "CATEGORY_EVENTS": "ŋoŋoro",
    "CATEGORY_CONTROL": "aʾaru",
    "CATEGORY_SENSING": "sensores",
    "CATEGORY_OPERATORS": "operadores",
    "CATEGORY_VARIABLES": "variables",
    "CATEGORY_MYBLOCKS": "taʾaku avhata poto roa mekera",
    "DUPLICATE": "haka rahi",
    "DELETE": "haka kore",
    "ADD_COMMENT": "hahaʾo te vanāŋa",
    "REMOVE_COMMENT": "haka kore te vanaŋa",
    "DELETE_BLOCK": "haka kore te avahata poto roa",
    "DELETE_X_BLOCKS": "haka kore %1 avahata poto roa o te puŋa",
    "DELETE_ALL_BLOCKS": "¿haka kore te %1?",
    "CLEAN_UP": "apapa te mekera avahata poto roa",
    "HELP": "hāʾuʾu",
    "UNDO": "moumou",
    "REDO": "he anga haka ʾou",
    "EDIT_PROCEDURE": "haka titika",
    "SHOW_PROCEDURE_DEFINITION": "Go to definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "ka ki e tahi meʾe…",
    "COLOUR_HUE_LABEL": "Kiʾea",
    "COLOUR_SATURATION_LABEL": "Saturación",
    "COLOUR_BRIGHTNESS_LABEL": "ʾUira",
    "CHANGE_VALUE_TITLE": "kamiare te mau:",
    "RENAME_VARIABLE": "ka nape hakaʾou te variable",
    "RENAME_VARIABLE_TITLE": "ka papaʾi te variable taʾatoʾa iŋoa ko \"%1\" a:",
    "RENAME_VARIABLE_MODAL_TITLE": "ka nape hakaʾou te variable",
    "NEW_VARIABLE": "he manaʾu mo āŋa te variable",
    "NEW_VARIABLE_TITLE": "iŋoa o te variable:",
    "VARIABLE_MODAL_TITLE": "variable apī",
    "VARIABLE_ALREADY_EXISTS": "ko ai a te variable iŋoa \"%1\"",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "ko ai a te variable iŋoa \"%1\" mo te rua variable o te huru \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "¿haka kore %1 aŋa o te variable \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "ē ko tano mo haka kore te variable \"%1\" o te ai he tano o te funcion \"%2\"",
    "DELETE_VARIABLE": "haka kore te variable \"%1\"",
    "NEW_PROCEDURE": "he manaʾu mo āŋa e tahi avahata poto roa mekerā",
    "PROCEDURE_ALREADY_EXISTS": "ko ai a te aŋa ioa ko \"%1\"",
    "PROCEDURE_DEFAULT_NAME": "iŋoa o te avahata poto roa puŋa",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "ka manaʾu mo āŋa te parau",
    "NEW_LIST_TITLE": "iŋoa o te parau:",
    "LIST_MODAL_TITLE": "parau apī",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "he nape hakaʾou",
    "DEFAULT_LIST_ITEM": "meʾe",
    "DELETE_LIST": "haka kore te parau \"%1\"",
    "RENAME_LIST": "he nape hakaʾou",
    "NEW_BROADCAST_MESSAGE": "parau apī",
    "NEW_BROADCAST_MESSAGE_TITLE": "iŋoa o te papaʾi:",
    "BROADCAST_MODAL_TITLE": "parau apī",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "ki hāŋa1"
  },
  "ro": {
    "CONTROL_FOREVER": "la infinit",
    "CONTROL_REPEAT": "repetă %1",
    "CONTROL_IF": "dacă %1 atunci",
    "CONTROL_ELSE": "altfel",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "totul",
    "CONTROL_STOP_THIS": "acest script",
    "CONTROL_STOP_OTHER": "alte scripturi pentru personaj",
    "CONTROL_WAIT": "așteaptă %1 secunde",
    "CONTROL_WAITUNTIL": "așteaptă până când %1",
    "CONTROL_REPEATUNTIL": "repetă până când %1",
    "CONTROL_WHILE": "cât timp %1",
    "CONTROL_FOREACH": "pentru fiecare %1 în %2",
    "CONTROL_STARTASCLONE": "când încep ca și clonă",
    "CONTROL_CREATECLONEOF": "creează o clonă a %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mea",
    "CONTROL_DELETETHISCLONE": "șterge această clonă",
    "CONTROL_COUNTER": "contor",
    "CONTROL_INCRCOUNTER": "incrementează contor",
    "CONTROL_CLEARCOUNTER": "resetează contor",
    "CONTROL_ALLATONCE": "integral",
    "DATA_SETVARIABLETO": "setează %1 la %2",
    "DATA_CHANGEVARIABLEBY": "modifică %1 cu %2",
    "DATA_SHOWVARIABLE": "arată variabila %1",
    "DATA_HIDEVARIABLE": "ascunde variabila %1",
    "DATA_ADDTOLIST": "adaugă %1 la %2",
    "DATA_DELETEOFLIST": "șterge %1 din %2",
    "DATA_DELETEALLOFLIST": "șterge tot din %1",
    "DATA_INSERTATLIST": "inserează %1 la %2 din %3",
    "DATA_REPLACEITEMOFLIST": "înlocuiește item %1 din %2 cu %3",
    "DATA_ITEMOFLIST": "element %1 din %2",
    "DATA_ITEMNUMOFLIST": "nr. elementului %1 în %2",
    "DATA_LENGTHOFLIST": "lungimea lui %1",
    "DATA_LISTCONTAINSITEM": "%1 conține %2?",
    "DATA_SHOWLIST": "arată lista %1",
    "DATA_HIDELIST": "ascunde lista %1",
    "DATA_INDEX_ALL": "totul",
    "DATA_INDEX_LAST": "ultim",
    "DATA_INDEX_RANDOM": "aleator",
    "EVENT_WHENFLAGCLICKED": "când se dă click pe %1",
    "EVENT_WHENTHISSPRITECLICKED": "când se dă click pe acest personaj",
    "EVENT_WHENSTAGECLICKED": "când se dă clic pe scenă",
    "EVENT_WHENTOUCHINGOBJECT": "când personajul atinge %1",
    "EVENT_WHENBROADCASTRECEIVED": "când primesc %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "când decorul se schimbă la %1",
    "EVENT_WHENGREATERTHAN": "când %1>%2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronometru",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "intensitatea sunetului",
    "EVENT_BROADCAST": "difuzează %1",
    "EVENT_BROADCASTANDWAIT": "difuzează %1 și așteaptă",
    "EVENT_WHENKEYPRESSED": "când tasta %1 este apăsată",
    "EVENT_WHENKEYPRESSED_SPACE": "spațiu",
    "EVENT_WHENKEYPRESSED_LEFT": "săgeată stânga",
    "EVENT_WHENKEYPRESSED_RIGHT": "săgeată dreapta",
    "EVENT_WHENKEYPRESSED_DOWN": "săgeată jos",
    "EVENT_WHENKEYPRESSED_UP": "săgeată în sus",
    "EVENT_WHENKEYPRESSED_ANY": "oricare",
    "LOOKS_SAYFORSECS": "spune %1 pentru %2 secunde",
    "LOOKS_SAY": "spune %1",
    "LOOKS_HELLO": "Salut!",
    "LOOKS_THINKFORSECS": "gândește %1 pentru %2 secunde ",
    "LOOKS_THINK": "gândește %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "arată",
    "LOOKS_HIDE": "ascunde",
    "LOOKS_HIDEALLSPRITES": "ascunde toate personajele",
    "LOOKS_EFFECT_COLOR": "culoare",
    "LOOKS_EFFECT_FISHEYE": "ochi de pește",
    "LOOKS_EFFECT_WHIRL": "vârtej",
    "LOOKS_EFFECT_PIXELATE": "pixelare",
    "LOOKS_EFFECT_MOSAIC": "mozaic",
    "LOOKS_EFFECT_BRIGHTNESS": "strălucire",
    "LOOKS_EFFECT_GHOST": "fantomă",
    "LOOKS_CHANGEEFFECTBY": "modifică efectul %1 cu %2",
    "LOOKS_SETEFFECTTO": "setează efectul %1 la %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "anulează efectele grafice",
    "LOOKS_CHANGESIZEBY": "modifică mărimea cu %1",
    "LOOKS_SETSIZETO": "setează mărimea la %1 %",
    "LOOKS_SIZE": "mărime",
    "LOOKS_CHANGESTRETCHBY": "modifică lărgimea cu %1",
    "LOOKS_SETSTRETCHTO": "setează lărgimea %1",
    "LOOKS_SWITCHCOSTUMETO": "schimbă costumul la %1",
    "LOOKS_NEXTCOSTUME": "costumul următor",
    "LOOKS_SWITCHBACKDROPTO": "schimbă decorul la %1",
    "LOOKS_GOTOFRONTBACK": "mergi la stratul %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "în față",
    "LOOKS_GOTOFRONTBACK_BACK": "înapoi",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "mergi %1 %2 straturi",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "înainte",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "înapoi",
    "LOOKS_BACKDROPNUMBERNAME": "decor %1",
    "LOOKS_COSTUMENUMBERNAME": "costumul %1",
    "LOOKS_NUMBERNAME_NUMBER": "număr",
    "LOOKS_NUMBERNAME_NAME": "nume",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "schimbă decorul la %1 și așteaptă",
    "LOOKS_NEXTBACKDROP_BLOCK": "decorul următor",
    "LOOKS_NEXTBACKDROP": "decorul următor",
    "LOOKS_PREVIOUSBACKDROP": "decorul anterior",
    "LOOKS_RANDOMBACKDROP": "decor aleatoriu",
    "MOTION_MOVESTEPS": "mergi %1 pași",
    "MOTION_TURNLEFT": "rotește-te %1 %2 grade",
    "MOTION_TURNRIGHT": "rotește-te %1 %2 grade",
    "MOTION_POINTINDIRECTION": "orientează-te în direcția %1",
    "MOTION_POINTTOWARDS": "orientează-te spre %1",
    "MOTION_POINTTOWARDS_POINTER": "cursorul mouse-ului",
    "MOTION_POINTTOWARDS_RANDOM": "direcție aleatoare",
    "MOTION_GOTO": "mergi la %1",
    "MOTION_GOTO_POINTER": "cursorul mouse-ului",
    "MOTION_GOTO_RANDOM": "poziție aleatoare",
    "MOTION_GOTOXY": "mergi la x %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glisează în %1 secunde la x: %2 y: %3",
    "MOTION_GLIDETO": "glisează în %1 secunde la %2 ",
    "MOTION_GLIDETO_POINTER": "cursorul mouse-ului",
    "MOTION_GLIDETO_RANDOM": "poziție aleatoare",
    "MOTION_CHANGEXBY": "modifică x cu %1",
    "MOTION_SETX": "setează x la %1",
    "MOTION_CHANGEYBY": "modifică y cu %1",
    "MOTION_SETY": "setează y la %1",
    "MOTION_IFONEDGEBOUNCE": "dacă atinge marginea, ricoșează",
    "MOTION_SETROTATIONSTYLE": "setează stilul de rotație %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "stânga-dreapta",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "nu te roti",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "de jur împrejur",
    "MOTION_XPOSITION": "poziția x",
    "MOTION_YPOSITION": "poziția y",
    "MOTION_DIRECTION": "direcția",
    "MOTION_SCROLLRIGHT": "derulează la dreapta %1",
    "MOTION_SCROLLUP": "derulează în sus %1",
    "MOTION_ALIGNSCENE": "aliniază scena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "stânga-jos",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "dreapta-jos",
    "MOTION_ALIGNSCENE_MIDDLE": "în centru",
    "MOTION_ALIGNSCENE_TOPLEFT": "stânga-sus",
    "MOTION_ALIGNSCENE_TOPRIGHT": "dreapta-sus",
    "MOTION_XSCROLL": "derulare x",
    "MOTION_YSCROLL": "derulare y",
    "MOTION_STAGE_SELECTED": "Scena selectată: fără blocuri de mișcare",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1  - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "alege aleator între %1 și %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1  = %2",
    "OPERATORS_AND": "%1 și %2",
    "OPERATORS_OR": "%1 sau %2",
    "OPERATORS_NOT": "nu %1",
    "OPERATORS_JOIN": "alătură %1 %2",
    "OPERATORS_JOIN_APPLE": "măr",
    "OPERATORS_JOIN_BANANA": "banană",
    "OPERATORS_LETTEROF": "litera %1 din %2",
    "OPERATORS_LETTEROF_APPLE": "m",
    "OPERATORS_LENGTH": "lungimea lui %1",
    "OPERATORS_CONTAINS": "%1 conține %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "rotunjește %1",
    "OPERATORS_MATHOP": "%1 din %2",
    "OPERATORS_MATHOP_ABS": "modul",
    "OPERATORS_MATHOP_FLOOR": "partea întreagă",
    "OPERATORS_MATHOP_CEILING": "rotunjire prin adaos",
    "OPERATORS_MATHOP_SQRT": "radical",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definește %1",
    "SENSING_TOUCHINGOBJECT": "atinge %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "cursorul mouse-ului",
    "SENSING_TOUCHINGOBJECT_EDGE": "marginea",
    "SENSING_TOUCHINGCOLOR": "atinge culoarea %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "culoarea %1 atinge %2?",
    "SENSING_DISTANCETO": "distanța până la %1",
    "SENSING_DISTANCETO_POINTER": "cursorul mouse-ului",
    "SENSING_ASKANDWAIT": "întreabă %1 și așteaptă",
    "SENSING_ASK_TEXT": "Cum te numești?",
    "SENSING_ANSWER": "răspuns",
    "SENSING_KEYPRESSED": "tasta %1 apăsată?",
    "SENSING_MOUSEDOWN": "butonul mouse-ului e apăsat?",
    "SENSING_MOUSEX": "mouse x",
    "SENSING_MOUSEY": "mouse y",
    "SENSING_SETDRAGMODE": "setează mod tragere %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "activat",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "dezactivat",
    "SENSING_LOUDNESS": "intensitatea sunetului",
    "SENSING_LOUD": "tare?",
    "SENSING_TIMER": "cronometru",
    "SENSING_RESETTIMER": "resetează cronometru",
    "SENSING_OF": "%1 din %2",
    "SENSING_OF_XPOSITION": "poziția x",
    "SENSING_OF_YPOSITION": "poziția y",
    "SENSING_OF_DIRECTION": "direcția",
    "SENSING_OF_COSTUMENUMBER": "nr. costum",
    "SENSING_OF_COSTUMENAME": "denumire costum",
    "SENSING_OF_SIZE": "mărime",
    "SENSING_OF_VOLUME": "volum",
    "SENSING_OF_BACKDROPNUMBER": "nr. decor",
    "SENSING_OF_BACKDROPNAME": "denumire decor",
    "SENSING_OF_STAGE": "Scenă",
    "SENSING_CURRENT": "%1 curent(ă)",
    "SENSING_CURRENT_YEAR": "anul",
    "SENSING_CURRENT_MONTH": "luna",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "ziua săptămânii",
    "SENSING_CURRENT_HOUR": "ora",
    "SENSING_CURRENT_MINUTE": "minutul",
    "SENSING_CURRENT_SECOND": "secunda",
    "SENSING_DAYSSINCE2000": "zile din 2000",
    "SENSING_USERNAME": "nume utilizator",
    "SENSING_USERID": "id utilizator",
    "SOUND_PLAY": "pornește sunetul %1",
    "SOUND_PLAYUNTILDONE": "redă sunetul %1 până la final",
    "SOUND_STOPALLSOUNDS": "oprește toate sunetele",
    "SOUND_SETEFFECTO": "setează efectul %1 la %2",
    "SOUND_CHANGEEFFECTBY": "modifică efectul %1 cu %2",
    "SOUND_CLEAREFFECTS": "șterge efectele audio",
    "SOUND_EFFECTS_PITCH": "înălțimea sunetului",
    "SOUND_EFFECTS_PAN": "deplasare la stânga/dreapta",
    "SOUND_CHANGEVOLUMEBY": "modifică volumul cu %1",
    "SOUND_SETVOLUMETO": "setează volumul la %1%",
    "SOUND_VOLUME": "volum",
    "SOUND_RECORD": "se înregistrează...",
    "CATEGORY_MOTION": "Mișcare",
    "CATEGORY_LOOKS": "Aspect",
    "CATEGORY_SOUND": "Sunet",
    "CATEGORY_EVENTS": "Evenimente",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Detectare",
    "CATEGORY_OPERATORS": "Operatori",
    "CATEGORY_VARIABLES": "Variabile",
    "CATEGORY_MYBLOCKS": "Blocurile mele",
    "DUPLICATE": "Duplică",
    "DELETE": "Șterge",
    "ADD_COMMENT": "Adaugă comentariu",
    "REMOVE_COMMENT": "Șterge comentariul",
    "DELETE_BLOCK": "Șterge blocul",
    "DELETE_X_BLOCKS": "Șterge %1 blocuri",
    "DELETE_ALL_BLOCKS": "Șterg toate %1 blocuri?",
    "CLEAN_UP": "Șterge blocurile",
    "HELP": "Ajutor",
    "UNDO": "Anulează ultima modificare",
    "REDO": "Refă acțiunea anulată",
    "EDIT_PROCEDURE": "Editează",
    "SHOW_PROCEDURE_DEFINITION": "Mergi la definiție",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Spune ceva ...",
    "COLOUR_HUE_LABEL": "Culoare",
    "COLOUR_SATURATION_LABEL": "Saturație",
    "COLOUR_BRIGHTNESS_LABEL": "Strălucire",
    "CHANGE_VALUE_TITLE": "Modifică valoarea:",
    "RENAME_VARIABLE": "Redenumește variabila",
    "RENAME_VARIABLE_TITLE": "Redenumește peste tot variabila \"%1\" la:",
    "RENAME_VARIABLE_MODAL_TITLE": "Redenumește variabila",
    "NEW_VARIABLE": "Creează o variabilă",
    "NEW_VARIABLE_TITLE": "Numele variabilei:",
    "VARIABLE_MODAL_TITLE": "Variabilă nouă",
    "VARIABLE_ALREADY_EXISTS": "O variabilă denumită \"%1\" există deja.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "O variabilă cu numele \"%1\" există deja pentru o altă variabilă de tip \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Șterge %1 utilizări ale variabilei \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Variabila cu numele \"%1\" nu poate fi ștearsă deoarece este parte a definiției funcției \"%2\". ",
    "DELETE_VARIABLE": "Șterge variabila cu numele \"%1\" .",
    "NEW_PROCEDURE": "Creează un bloc",
    "PROCEDURE_ALREADY_EXISTS": "O procedură cu numele \"%1\" există deja.",
    "PROCEDURE_DEFAULT_NAME": "numele blocului",
    "PROCEDURE_USED": "Pentru a șterge definiția unui bloc, mai întâi șterge toate utilizările acestuia.",
    "NEW_LIST": "Creează o listă",
    "NEW_LIST_TITLE": "Noul nume al listei:",
    "LIST_MODAL_TITLE": "Listă nouă",
    "LIST_ALREADY_EXISTS": "O listă cu numele \"%1\" există deja.",
    "RENAME_LIST_TITLE": "Redenumește peste tot lista \"%1\" la:",
    "RENAME_LIST_MODAL_TITLE": "Redenumește lista",
    "DEFAULT_LIST_ITEM": "element",
    "DELETE_LIST": "Șterge lista  \"%1\" ",
    "RENAME_LIST": "Redenumește lista",
    "NEW_BROADCAST_MESSAGE": "Mesaj nou",
    "NEW_BROADCAST_MESSAGE_TITLE": "Numele mesajului",
    "BROADCAST_MODAL_TITLE": "Mesaj nou",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mesaj1"
  },
  "ru": {
    "CONTROL_FOREVER": "повторять всегда",
    "CONTROL_REPEAT": "повторить %1 раз",
    "CONTROL_IF": "если %1 , то",
    "CONTROL_ELSE": "иначе",
    "CONTROL_STOP": "стоп",
    "CONTROL_STOP_ALL": "все",
    "CONTROL_STOP_THIS": "этот скрипт",
    "CONTROL_STOP_OTHER": "другие скрипты спрайта",
    "CONTROL_WAIT": "ждать %1 секунд",
    "CONTROL_WAITUNTIL": "ждать до %1",
    "CONTROL_REPEATUNTIL": "повторять пока не %1",
    "CONTROL_WHILE": "пока %1",
    "CONTROL_FOREACH": "для каждого %1 в %2",
    "CONTROL_STARTASCLONE": "когда я начинаю как клон",
    "CONTROL_CREATECLONEOF": "создать клон %1",
    "CONTROL_CREATECLONEOF_MYSELF": "самого себя",
    "CONTROL_DELETETHISCLONE": "удалить клон",
    "CONTROL_COUNTER": "счётчик",
    "CONTROL_INCRCOUNTER": "увеличить счётчик",
    "CONTROL_CLEARCOUNTER": "очистить счётчик",
    "CONTROL_ALLATONCE": "все сразу",
    "DATA_SETVARIABLETO": "задать %1 значение %2",
    "DATA_CHANGEVARIABLEBY": "изменить %1 на %2",
    "DATA_SHOWVARIABLE": "показать переменную %1",
    "DATA_HIDEVARIABLE": "скрыть переменную %1",
    "DATA_ADDTOLIST": "добавить %1 к %2",
    "DATA_DELETEOFLIST": "удалить %1 из %2",
    "DATA_DELETEALLOFLIST": "удалить все из %1",
    "DATA_INSERTATLIST": "вставить %1 в %3 из %2",
    "DATA_REPLACEITEMOFLIST": "заменить элемент %1 в %2 на %3",
    "DATA_ITEMOFLIST": "элемент %1 в %2",
    "DATA_ITEMNUMOFLIST": "№ элемента %1 в %2",
    "DATA_LENGTHOFLIST": "длина списка %1",
    "DATA_LISTCONTAINSITEM": "%1 содержит %2?",
    "DATA_SHOWLIST": "показать список %1",
    "DATA_HIDELIST": "скрыть список %1",
    "DATA_INDEX_ALL": "все",
    "DATA_INDEX_LAST": "последний",
    "DATA_INDEX_RANDOM": "случайный",
    "EVENT_WHENFLAGCLICKED": "когда %1 нажат",
    "EVENT_WHENTHISSPRITECLICKED": "когда спрайт нажат",
    "EVENT_WHENSTAGECLICKED": "когда кликнут по сцене",
    "EVENT_WHENTOUCHINGOBJECT": "когда этот спрайт касается %1",
    "EVENT_WHENBROADCASTRECEIVED": "когда я получу %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "когда фон сменился на %1",
    "EVENT_WHENGREATERTHAN": "когда %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "таймер",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "громкость",
    "EVENT_BROADCAST": "передать %1",
    "EVENT_BROADCASTANDWAIT": "передать %1 и ждать до конца",
    "EVENT_WHENKEYPRESSED": "когда клавиша %1 нажата",
    "EVENT_WHENKEYPRESSED_SPACE": "пробел",
    "EVENT_WHENKEYPRESSED_LEFT": "стрелка влево",
    "EVENT_WHENKEYPRESSED_RIGHT": "стрелка вправо",
    "EVENT_WHENKEYPRESSED_DOWN": "стрелка вниз",
    "EVENT_WHENKEYPRESSED_UP": "стрелка вверх",
    "EVENT_WHENKEYPRESSED_ANY": "любая",
    "LOOKS_SAYFORSECS": "говорить %1 %2 секунд",
    "LOOKS_SAY": "сказать %1",
    "LOOKS_HELLO": "Привет!",
    "LOOKS_THINKFORSECS": "думать %1 %2 секунд",
    "LOOKS_THINK": "думать %1",
    "LOOKS_HMM": "М-м-м...",
    "LOOKS_SHOW": "показаться",
    "LOOKS_HIDE": "спрятаться",
    "LOOKS_HIDEALLSPRITES": "спрятать все спрайты",
    "LOOKS_EFFECT_COLOR": "цвет",
    "LOOKS_EFFECT_FISHEYE": "рыбий глаз",
    "LOOKS_EFFECT_WHIRL": "завихрение",
    "LOOKS_EFFECT_PIXELATE": "укрупнение пикселей",
    "LOOKS_EFFECT_MOSAIC": "мозаика",
    "LOOKS_EFFECT_BRIGHTNESS": "яркость",
    "LOOKS_EFFECT_GHOST": "прозрачность",
    "LOOKS_CHANGEEFFECTBY": "изменить эффект %1 на %2",
    "LOOKS_SETEFFECTTO": "установить эффект %1 %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "убрать графические эффекты",
    "LOOKS_CHANGESIZEBY": "изменить размер на %1 %",
    "LOOKS_SETSIZETO": "установить размер %1 %",
    "LOOKS_SIZE": "размер",
    "LOOKS_CHANGESTRETCHBY": "изменить натяжение на %1",
    "LOOKS_SETSTRETCHTO": "установить натяжение %1 %",
    "LOOKS_SWITCHCOSTUMETO": "изменить костюм на %1",
    "LOOKS_NEXTCOSTUME": "следующий костюм",
    "LOOKS_SWITCHBACKDROPTO": "переключить фон на %1",
    "LOOKS_GOTOFRONTBACK": "перейти на %1 слой",
    "LOOKS_GOTOFRONTBACK_FRONT": "передний",
    "LOOKS_GOTOFRONTBACK_BACK": "задний",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "перейти %1 на %2 слоя",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "вперёд",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "назад",
    "LOOKS_BACKDROPNUMBERNAME": "фон %1",
    "LOOKS_COSTUMENUMBERNAME": "костюм %1",
    "LOOKS_NUMBERNAME_NUMBER": "номер",
    "LOOKS_NUMBERNAME_NAME": "имя",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "переключить фон на %1 и ждать",
    "LOOKS_NEXTBACKDROP_BLOCK": "следующий фон",
    "LOOKS_NEXTBACKDROP": "следующий фон",
    "LOOKS_PREVIOUSBACKDROP": "предыдущий фон",
    "LOOKS_RANDOMBACKDROP": "случайный фон",
    "MOTION_MOVESTEPS": "идти %1 шагов",
    "MOTION_TURNLEFT": "повернуть %1 на %2 градусов",
    "MOTION_TURNRIGHT": "повернуть %1 на %2 градусов",
    "MOTION_POINTINDIRECTION": "повернуться в направлении %1",
    "MOTION_POINTTOWARDS": "повернуться к %1",
    "MOTION_POINTTOWARDS_POINTER": "указатель мыши",
    "MOTION_POINTTOWARDS_RANDOM": "случайно направление",
    "MOTION_GOTO": "перейти на %1",
    "MOTION_GOTO_POINTER": "указатель мыши",
    "MOTION_GOTO_RANDOM": "случайное положение",
    "MOTION_GOTOXY": "перейти в x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "плыть %1 секунд в точку x: %2 y: %3",
    "MOTION_GLIDETO": "плыть %1 секунд к %2",
    "MOTION_GLIDETO_POINTER": "указатель мыши",
    "MOTION_GLIDETO_RANDOM": "случайное положение",
    "MOTION_CHANGEXBY": "изменить x на %1",
    "MOTION_SETX": "установить x в %1",
    "MOTION_CHANGEYBY": "изменить y на %1",
    "MOTION_SETY": "установить y в %1",
    "MOTION_IFONEDGEBOUNCE": "если касается края, оттолкнуться",
    "MOTION_SETROTATIONSTYLE": "установить способ вращения %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "влево-вправо",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "не вращать",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "кругом",
    "MOTION_XPOSITION": "положение x",
    "MOTION_YPOSITION": "положение y",
    "MOTION_DIRECTION": "направление",
    "MOTION_SCROLLRIGHT": "прокрутить вправо %1",
    "MOTION_SCROLLUP": "прокрутить вверх %1",
    "MOTION_ALIGNSCENE": "выровнять сцену %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "нижний левый",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "нижний правый",
    "MOTION_ALIGNSCENE_MIDDLE": "середина",
    "MOTION_ALIGNSCENE_TOPLEFT": "верхний левый",
    "MOTION_ALIGNSCENE_TOPRIGHT": "верхний правый",
    "MOTION_XSCROLL": "x прокрутка",
    "MOTION_YSCROLL": "y прокрутка",
    "MOTION_STAGE_SELECTED": "Выбрана сцена: нет блоков движения",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "выдать случайное от %1 до %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 и %2",
    "OPERATORS_OR": "%1 или %2",
    "OPERATORS_NOT": "не %1",
    "OPERATORS_JOIN": "объединить %1 %2",
    "OPERATORS_JOIN_APPLE": "яблоко",
    "OPERATORS_JOIN_BANANA": "банан",
    "OPERATORS_LETTEROF": "буква %1 в %2",
    "OPERATORS_LETTEROF_APPLE": "а",
    "OPERATORS_LENGTH": "длина %1",
    "OPERATORS_CONTAINS": "%1 содержит %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "округлить %1",
    "OPERATORS_MATHOP": "%1 от %2",
    "OPERATORS_MATHOP_ABS": "модуль",
    "OPERATORS_MATHOP_FLOOR": "целое меньшее",
    "OPERATORS_MATHOP_CEILING": "целое большее",
    "OPERATORS_MATHOP_SQRT": "квадратный корень",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "определить %1",
    "SENSING_TOUCHINGOBJECT": "касается %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "указатель мыши",
    "SENSING_TOUCHINGOBJECT_EDGE": "край",
    "SENSING_TOUCHINGCOLOR": "касается цвета %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "цвет %1 касается цвета %2?",
    "SENSING_DISTANCETO": "расстояние до %1",
    "SENSING_DISTANCETO_POINTER": "указатель мыши",
    "SENSING_ASKANDWAIT": "спросить %1 и ждать",
    "SENSING_ASK_TEXT": "Как тебя зовут?",
    "SENSING_ANSWER": "ответ",
    "SENSING_KEYPRESSED": "клавиша %1 нажата?",
    "SENSING_MOUSEDOWN": "мышь нажата?",
    "SENSING_MOUSEX": "x мыши",
    "SENSING_MOUSEY": "y мыши",
    "SENSING_SETDRAGMODE": "перетаскивать %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "можно",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "нельзя",
    "SENSING_LOUDNESS": "громкость",
    "SENSING_LOUD": "громко?",
    "SENSING_TIMER": "таймер",
    "SENSING_RESETTIMER": "сбросить таймер",
    "SENSING_OF": "%1 от %2",
    "SENSING_OF_XPOSITION": "положение x",
    "SENSING_OF_YPOSITION": "положение y",
    "SENSING_OF_DIRECTION": "направление",
    "SENSING_OF_COSTUMENUMBER": "костюм #",
    "SENSING_OF_COSTUMENAME": "имя костюма",
    "SENSING_OF_SIZE": "размер",
    "SENSING_OF_VOLUME": "громкость",
    "SENSING_OF_BACKDROPNUMBER": "фон #",
    "SENSING_OF_BACKDROPNAME": "имя фона",
    "SENSING_OF_STAGE": "Сцена",
    "SENSING_CURRENT": "текущий %1",
    "SENSING_CURRENT_YEAR": "год",
    "SENSING_CURRENT_MONTH": "месяц",
    "SENSING_CURRENT_DATE": "дата",
    "SENSING_CURRENT_DAYOFWEEK": "день недели",
    "SENSING_CURRENT_HOUR": "час",
    "SENSING_CURRENT_MINUTE": "минута",
    "SENSING_CURRENT_SECOND": "секунда",
    "SENSING_DAYSSINCE2000": "дней с 2000 г",
    "SENSING_USERNAME": "имя пользователя",
    "SENSING_USERID": "id пользователя",
    "SOUND_PLAY": "включить звук %1",
    "SOUND_PLAYUNTILDONE": "играть звук %1 до конца",
    "SOUND_STOPALLSOUNDS": "остановить все звуки",
    "SOUND_SETEFFECTO": "установить эффект %1 в %2",
    "SOUND_CHANGEEFFECTBY": "изменить %1 эффект на %2",
    "SOUND_CLEAREFFECTS": "убрать звуковые эффекты",
    "SOUND_EFFECTS_PITCH": "высота тона",
    "SOUND_EFFECTS_PAN": "звучание слева/справа",
    "SOUND_CHANGEVOLUMEBY": "изменить громкость на %1",
    "SOUND_SETVOLUMETO": "установить громкость %1%",
    "SOUND_VOLUME": "громкость звука",
    "SOUND_RECORD": "запись…",
    "CATEGORY_MOTION": "Движение",
    "CATEGORY_LOOKS": "Внешний вид",
    "CATEGORY_SOUND": "Звук",
    "CATEGORY_EVENTS": "События",
    "CATEGORY_CONTROL": "Управление",
    "CATEGORY_SENSING": "Сенсоры",
    "CATEGORY_OPERATORS": "Операторы",
    "CATEGORY_VARIABLES": "Переменные",
    "CATEGORY_MYBLOCKS": "Другие блоки",
    "DUPLICATE": "Дублировать",
    "DELETE": "Удалить",
    "ADD_COMMENT": "Добавить комментарий",
    "REMOVE_COMMENT": "Удалить комментарий",
    "DELETE_BLOCK": "Удалить блок",
    "DELETE_X_BLOCKS": "Удалить %1 блоки",
    "DELETE_ALL_BLOCKS": "Удалить все %1 блоки?",
    "CLEAN_UP": "Очистить блоки",
    "HELP": "Помощь",
    "UNDO": "Отменить",
    "REDO": "Вернуть",
    "EDIT_PROCEDURE": "Редактировать",
    "SHOW_PROCEDURE_DEFINITION": "Перейти к определению",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Скажи что-нибудь...",
    "COLOUR_HUE_LABEL": "Цвет",
    "COLOUR_SATURATION_LABEL": "Насыщенность",
    "COLOUR_BRIGHTNESS_LABEL": "Яркость",
    "CHANGE_VALUE_TITLE": "Изменить значение:",
    "RENAME_VARIABLE": "Переименовать переменную",
    "RENAME_VARIABLE_TITLE": "Переименовать все \"%1\" переменных в:",
    "RENAME_VARIABLE_MODAL_TITLE": "Переименовать переменную",
    "NEW_VARIABLE": "Создать переменную",
    "NEW_VARIABLE_TITLE": "Имя новой переменной:",
    "VARIABLE_MODAL_TITLE": "Новая переменная",
    "VARIABLE_ALREADY_EXISTS": "Переменная с именем \"%1\" уже существует.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "переменная с именем \"%1\" уже существует в другом типе переменных \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Удалить %1 использований  \"%2\" переменной?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Нельзя удалить переменную \"%1\", так как она является частью определения функции \"%2\"",
    "DELETE_VARIABLE": "Удалить переменную \"%1\"",
    "NEW_PROCEDURE": "Создать блок",
    "PROCEDURE_ALREADY_EXISTS": "Процедура с именем \"%1\" уже существует.",
    "PROCEDURE_DEFAULT_NAME": "название блока",
    "PROCEDURE_USED": "Прежде чем удалить блок, удалите все случаи его использования.",
    "NEW_LIST": "Создать список",
    "NEW_LIST_TITLE": "Имя нового списка:",
    "LIST_MODAL_TITLE": "Новый список",
    "LIST_ALREADY_EXISTS": "Список с именем \"%1\" уже существует.",
    "RENAME_LIST_TITLE": "Переименовать все \"%1\" списки в:",
    "RENAME_LIST_MODAL_TITLE": "Переименовать список",
    "DEFAULT_LIST_ITEM": "что-то",
    "DELETE_LIST": "Удалить список \"%1\"",
    "RENAME_LIST": "Переименовать список",
    "NEW_BROADCAST_MESSAGE": "Новое сообщение",
    "NEW_BROADCAST_MESSAGE_TITLE": "Новое имя сообщения:",
    "BROADCAST_MODAL_TITLE": "Новое сообщение",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "сообщение1"
  },
  "nso": {
    "CONTROL_FOREVER": "ka go sa felego",
    "CONTROL_REPEAT": "bušeletša %1",
    "CONTROL_IF": "ge e le %1 kemoka",
    "CONTROL_ELSE": "enngwe",
    "CONTROL_STOP": "ema",
    "CONTROL_STOP_ALL": "ka moka",
    "CONTROL_STOP_THIS": "sengwalwa se",
    "CONTROL_STOP_OTHER": "dingwalwa tše dingwe tša motšeakarolo",
    "CONTROL_WAIT": "ema %1 metsotswana",
    "CONTROL_WAITUNTIL": "ema go fihlela %1",
    "CONTROL_REPEATUNTIL": "bušeletša go fihlela %1",
    "CONTROL_WHILE": "ge %1",
    "CONTROL_FOREACH": "go enngwe le enngwe %1 go %2",
    "CONTROL_STARTASCLONE": "ge ke thoma popotshwano",
    "CONTROL_CREATECLONEOF": "hlama popotshwano %1",
    "CONTROL_CREATECLONEOF_MYSELF": "nna",
    "CONTROL_DELETETHISCLONE": "phumula tshwantšho ye",
    "CONTROL_COUNTER": "palelo",
    "CONTROL_INCRCOUNTER": "Palelo ya go oketša",
    "CONTROL_CLEARCOUNTER": "tloša palelo",
    "CONTROL_ALLATONCE": "ka moka setee",
    "DATA_SETVARIABLETO": "bea %1 go %2",
    "DATA_CHANGEVARIABLEBY": "fetola %1 ka %2",
    "DATA_SHOWVARIABLE": "laetša phetošo %1",
    "DATA_HIDEVARIABLE": "fihla phetošo %1",
    "DATA_ADDTOLIST": "kopanya %1 go %2",
    "DATA_DELETEOFLIST": "phumula %1 ya %2",
    "DATA_DELETEALLOFLIST": "phumula ka moka tša %1 ",
    "DATA_INSERTATLIST": "tsenya %1 ka %2 ya %3",
    "DATA_REPLACEITEMOFLIST": "tšhentšha selo %1 ya %2 ka %3",
    "DATA_ITEMOFLIST": "selo %1 sa %2",
    "DATA_ITEMNUMOFLIST": "selo # sa %1 go %2",
    "DATA_LENGTHOFLIST": "botelele bja %1",
    "DATA_LISTCONTAINSITEM": "%1 e na le %2",
    "DATA_SHOWLIST": "laetša lenaneo %1",
    "DATA_HIDELIST": "fihla lenaneo %1",
    "DATA_INDEX_ALL": "ka moka",
    "DATA_INDEX_LAST": "mafelelo",
    "DATA_INDEX_RANDOM": "ka go se hlaole",
    "EVENT_WHENFLAGCLICKED": "ge %1 e tobetšwa",
    "EVENT_WHENTHISSPRITECLICKED": "ge motšeakarolo wo a tobetšwa",
    "EVENT_WHENSTAGECLICKED": "ge sefala se tobetšwa",
    "EVENT_WHENTOUCHINGOBJECT": "ge motšeakarolo a kgoma %1",
    "EVENT_WHENBROADCASTRECEIVED": "ge ke amogela %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "ge bokamorago bo fetogela go %1",
    "EVENT_WHENGREATERTHAN": "ge %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "se ela nako",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "lešata",
    "EVENT_BROADCAST": "kgašo %1",
    "EVENT_BROADCASTANDWAIT": "kgašo %1 o lete",
    "EVENT_WHENKEYPRESSED": "ge konopi ya %1 e tobetšwa",
    "EVENT_WHENKEYPRESSED_SPACE": "sekgoba",
    "EVENT_WHENKEYPRESSED_LEFT": "mosebe wa go lanngele",
    "EVENT_WHENKEYPRESSED_RIGHT": "mosebe wa go la go ja",
    "EVENT_WHENKEYPRESSED_DOWN": "mosebe wa go šupa fase",
    "EVENT_WHENKEYPRESSED_UP": "mosebe wa go lebelela godimo",
    "EVENT_WHENKEYPRESSED_ANY": "efe kapa efe",
    "LOOKS_SAYFORSECS": "e re %1 ya %2 ya metsotswana",
    "LOOKS_SAY": "e re %1",
    "LOOKS_HELLO": "Dumela!",
    "LOOKS_THINKFORSECS": "nagana %1 ya metsotswana e %2",
    "LOOKS_THINK": "nagana %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "bontšha",
    "LOOKS_HIDE": "fihla",
    "LOOKS_HIDEALLSPRITES": "fihla batšeakarolo ka moka",
    "LOOKS_EFFECT_COLOR": "mmala",
    "LOOKS_EFFECT_FISHEYE": "pono e šele",
    "LOOKS_EFFECT_WHIRL": "dikološa",
    "LOOKS_EFFECT_PIXELATE": "arola ka diphiksele",
    "LOOKS_EFFECT_MOSAIC": "mosaike",
    "LOOKS_EFFECT_BRIGHTNESS": "go taga",
    "LOOKS_EFFECT_GHOST": "sepoko",
    "LOOKS_CHANGEEFFECTBY": "fetola %1 khuetšo ka %2",
    "LOOKS_SETEFFECTTO": "bea %1 khuetšo go %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "tloša khuetšo ya diswantšho",
    "LOOKS_CHANGESIZEBY": "fetola bogolo ka %1",
    "LOOKS_SETSIZETO": "bea bogolo go %1 %",
    "LOOKS_SIZE": "bogolo",
    "LOOKS_CHANGESTRETCHBY": "fetola katološo ka %1",
    "LOOKS_SETSTRETCHTO": "bea katološo go %1 %",
    "LOOKS_SWITCHCOSTUMETO": "fetolela khosetšhumo go %1",
    "LOOKS_NEXTCOSTUME": "khosetšhumo ye e latelago",
    "LOOKS_SWITCHBACKDROPTO": "fetola bokamorago go %1",
    "LOOKS_GOTOFRONTBACK": "eya go %1  ya tlhatlagano",
    "LOOKS_GOTOFRONTBACK_FRONT": "pele",
    "LOOKS_GOTOFRONTBACK_BACK": "morago",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "eya %1 %2 ya tlhatlagano",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "pele",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "morago",
    "LOOKS_BACKDROPNUMBERNAME": "bokamorago%1",
    "LOOKS_COSTUMENUMBERNAME": "khosetšhumo %1",
    "LOOKS_NUMBERNAME_NUMBER": "nomoro",
    "LOOKS_NUMBERNAME_NAME": "leina",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "fetola bokamorago go %1 gomme o lete",
    "LOOKS_NEXTBACKDROP_BLOCK": "bokamorago bjo bo latelago",
    "LOOKS_NEXTBACKDROP": "bokamorago bjo bo latelago",
    "LOOKS_PREVIOUSBACKDROP": "bokamorago bjo bo fetilego",
    "LOOKS_RANDOMBACKDROP": "bokamorago ba go se hlaole",
    "MOTION_MOVESTEPS": "šutiša %1  ya dikgato",
    "MOTION_TURNLEFT": "sokololla dikgato %1 %2",
    "MOTION_TURNRIGHT": "sokolla dikgato %1 %2",
    "MOTION_POINTINDIRECTION": "šupa ka thoko tša %1",
    "MOTION_POINTTOWARDS": "šupa go ya go %1",
    "MOTION_POINTTOWARDS_POINTER": "sešupo sa mause",
    "MOTION_POINTTOWARDS_RANDOM": "thoko ya go se hlaole",
    "MOTION_GOTO": "eya go  %1",
    "MOTION_GOTO_POINTER": "sešupo sa maose",
    "MOTION_GOTO_RANDOM": "boemo ba go se hlaole",
    "MOTION_GOTOXY": "eya go x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "thwetha metsotswana e %1 go ya go x: %2 y: %3",
    "MOTION_GLIDETO": "thwetha metsotswana e %1 go ya go %2",
    "MOTION_GLIDETO_POINTER": "sešupo sa maose",
    "MOTION_GLIDETO_RANDOM": "boemo ba go se hlaole",
    "MOTION_CHANGEXBY": "fetola x ka %1",
    "MOTION_SETX": "bea x go %1",
    "MOTION_CHANGEYBY": "fetola y ka %1",
    "MOTION_SETY": "bea y go %1",
    "MOTION_IFONEDGEBOUNCE": "ge e le ntlheng, e fofafofiše ",
    "MOTION_SETROTATIONSTYLE": "bea mokgwa wa go dikologa %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "la nngele-la go ja",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "O seke wa dikološa",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "go dikologa lefelo ka moka",
    "MOTION_XPOSITION": " boemo ba x ",
    "MOTION_YPOSITION": "boemo ba y ",
    "MOTION_DIRECTION": "thoko",
    "MOTION_SCROLLRIGHT": "sekrolo go la go ja %1",
    "MOTION_SCROLLUP": "sekrolo godimo %1",
    "MOTION_ALIGNSCENE": "tsepanya tema ka %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "fase- ka go la nngele",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "fase-ka go la go ja",
    "MOTION_ALIGNSCENE_MIDDLE": "magareng",
    "MOTION_ALIGNSCENE_TOPLEFT": "godimo-ka go la nngele",
    "MOTION_ALIGNSCENE_TOPRIGHT": "godimo- ka go la goja",
    "MOTION_XSCROLL": "sekrolo sa x",
    "MOTION_YSCROLL": "sekrolo sa y",
    "MOTION_STAGE_SELECTED": "Sefala se kgethilwe: ga gona di poloko tša mosepelo",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "kgetha ka go se hlaole %1 go ya go %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 le %2",
    "OPERATORS_OR": "%1 goba %2",
    "OPERATORS_NOT": "e sego %1",
    "OPERATORS_JOIN": "tsenela %1 %2",
    "OPERATORS_JOIN_APPLE": "apola",
    "OPERATORS_JOIN_BANANA": "panana",
    "OPERATORS_LETTEROF": "leletere %1 la %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "botelele bja %1",
    "OPERATORS_CONTAINS": "%1 e na le %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "nkgokolo %1",
    "OPERATORS_MATHOP": "%1 ya %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "floor",
    "OPERATORS_MATHOP_CEILING": "ceiling",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "Ka gare",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "hlalosa%1",
    "SENSING_TOUCHINGOBJECT": "e kgoma %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "sešupo sa maose",
    "SENSING_TOUCHINGOBJECT_EDGE": "ntlheng",
    "SENSING_TOUCHINGCOLOR": "e kgoma mmala %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "mmala wa %1 o kgoma %2",
    "SENSING_DISTANCETO": "bokgole go ya go %1",
    "SENSING_DISTANCETO_POINTER": "sešupo sa maose",
    "SENSING_ASKANDWAIT": "botšiša %1 o be o lete",
    "SENSING_ASK_TEXT": "Leina la gago ke mang?",
    "SENSING_ANSWER": "karabo",
    "SENSING_KEYPRESSED": "konopi %1 e tobeditšwe? ",
    "SENSING_MOUSEDOWN": "maose o ye fase?",
    "SENSING_MOUSEX": "maose x",
    "SENSING_MOUSEY": "maose y",
    "SENSING_SETDRAGMODE": "Bea mokgwa wa go gogega %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "e a gogega",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ga e gogege",
    "SENSING_LOUDNESS": "lešata",
    "SENSING_LOUD": "rasa?",
    "SENSING_TIMER": "se ela nako",
    "SENSING_RESETTIMER": "beakanya gape se ela nako",
    "SENSING_OF": "%1 ya %2",
    "SENSING_OF_XPOSITION": "boemo ba x",
    "SENSING_OF_YPOSITION": "boemo ba y",
    "SENSING_OF_DIRECTION": "thoko",
    "SENSING_OF_COSTUMENUMBER": "khosetšhumo #",
    "SENSING_OF_COSTUMENAME": "leina la khosetšhumo",
    "SENSING_OF_SIZE": "bogolo",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "bokamorago #",
    "SENSING_OF_BACKDROPNAME": "leina la bokamorago",
    "SENSING_OF_STAGE": "Sefala",
    "SENSING_CURRENT": "ya bjale %1",
    "SENSING_CURRENT_YEAR": "ngwaga",
    "SENSING_CURRENT_MONTH": "kgwedi",
    "SENSING_CURRENT_DATE": "letšatšikgwedi",
    "SENSING_CURRENT_DAYOFWEEK": "letšatši la beke",
    "SENSING_CURRENT_HOUR": "iri",
    "SENSING_CURRENT_MINUTE": "motsotso",
    "SENSING_CURRENT_SECOND": "motsotswana",
    "SENSING_DAYSSINCE2000": "matšatši go tloga ka 2000",
    "SENSING_USERNAME": "leinatšhomišo",
    "SENSING_USERID": "boitsebišo bja tšhomišo",
    "SOUND_PLAY": "thoma modumo %1",
    "SOUND_PLAYUNTILDONE": "bapala modumo %1 go fihlela o fetša",
    "SOUND_STOPALLSOUNDS": "emiša medumo ka moka",
    "SOUND_SETEFFECTO": "bea %1 khuetšo go %2",
    "SOUND_CHANGEEFFECTBY": "fetola %1 khuetšo ka %2",
    "SOUND_CLEAREFFECTS": "tloša khuetšo ya modumo",
    "SOUND_EFFECTS_PITCH": "tlhabelelo",
    "SOUND_EFFECTS_PAN": "hwidinyetša go la nngele/la go ja",
    "SOUND_CHANGEVOLUMEBY": "fetola volume ka %1",
    "SOUND_SETVOLUMETO": "bea volume go %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "gatiša",
    "CATEGORY_MOTION": "Mosepelo ",
    "CATEGORY_LOOKS": "Tebelelego",
    "CATEGORY_SOUND": "Modumo",
    "CATEGORY_EVENTS": "Ditiragalo",
    "CATEGORY_CONTROL": "Taolo",
    "CATEGORY_SENSING": "Sekwi",
    "CATEGORY_OPERATORS": "Bašomiši",
    "CATEGORY_VARIABLES": "Diphetošo",
    "CATEGORY_MYBLOCKS": "Dipoloko tša Ka",
    "DUPLICATE": "Pedifatša",
    "DELETE": "Phumula",
    "ADD_COMMENT": "Tlatša Tshwayotshwayo",
    "REMOVE_COMMENT": "Tloša Tshwayotshwayo",
    "DELETE_BLOCK": "Phumula Poloko",
    "DELETE_X_BLOCKS": "Phumula %1 ya Dipoloko ",
    "DELETE_ALL_BLOCKS": "Phumula ka moka %1 tša dipoloko?",
    "CLEAN_UP": "Hlwekiša Dipoloko",
    "HELP": "Thuša",
    "UNDO": "Dirolla",
    "REDO": "Dira gape",
    "EDIT_PROCEDURE": "Rulaganya",
    "SHOW_PROCEDURE_DEFINITION": "Eya go hlalošo",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Bolela se sengwe...",
    "COLOUR_HUE_LABEL": "Mmala",
    "COLOUR_SATURATION_LABEL": "Tlopelo",
    "COLOUR_BRIGHTNESS_LABEL": "Go taga",
    "CHANGE_VALUE_TITLE": "Fetola boleng",
    "RENAME_VARIABLE": "Efa phetošo leina gape",
    "RENAME_VARIABLE_TITLE": "Efa diphetošo ka moka tša \"%1\" maina gape go:",
    "RENAME_VARIABLE_MODAL_TITLE": "Efa Phetošo leina gape",
    "NEW_VARIABLE": "Dira Phetošo",
    "NEW_VARIABLE_TITLE": "Leina le leswa la Phetošo ",
    "VARIABLE_MODAL_TITLE": "Phetošo e mpsha",
    "VARIABLE_ALREADY_EXISTS": "Phetošo yeo e bitšwago \"%1\" e šetše e le gona. ",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Phetošo yeo e bitšwago \"%1\" e šetše e le gona go phetošo e nngwe ya mohuta wa \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "Phumula %1 ya tšhomišo phetošo ya \"%2\"",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "E ka se phumule phetošo \"%1\" ka lebaka la gore ke karolo ya hlaloso ya tšhomišo ya \"%2\"",
    "DELETE_VARIABLE": "Phumula \"%1\" ya phetošo",
    "NEW_PROCEDURE": "Dira poloko",
    "PROCEDURE_ALREADY_EXISTS": "Tshepetšo yeo e bitšwago \"%1\" e šetše e le gona. ",
    "PROCEDURE_DEFAULT_NAME": "leina la poloko",
    "PROCEDURE_USED": "Gore o tloše hlalošo ya poloko, thoma ka go tloša di tšhomišo ka moka tša poloko",
    "NEW_LIST": "Dira Lenaneo",
    "NEW_LIST_TITLE": "Leina la lenaneo le leswa",
    "LIST_MODAL_TITLE": "Lenaneo le Leswa",
    "LIST_ALREADY_EXISTS": "Lenaneo Leo le bitšwago \"%1\" le šetše le le gona. ",
    "RENAME_LIST_TITLE": "Efa maina ka moka \"%1\" mananeo go: ",
    "RENAME_LIST_MODAL_TITLE": "Efa Lenaneo leina gape",
    "DEFAULT_LIST_ITEM": "selo",
    "DELETE_LIST": "Phumula lenaneo la \"%1\"",
    "RENAME_LIST": "Efa lenaneo leina gape",
    "NEW_BROADCAST_MESSAGE": "Molaetša o moswa",
    "NEW_BROADCAST_MESSAGE_TITLE": "Leina la molaetša o moswa",
    "BROADCAST_MODAL_TITLE": "Molaetša o Moswa",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "molaetša1"
  },
  "tn": {
    "CONTROL_FOREVER": "gosafeleng",
    "CONTROL_REPEAT": "boeletsa %1",
    "CONTROL_IF": "fa %1 gona",
    "CONTROL_ELSE": "gongwe",
    "CONTROL_STOP": "ema",
    "CONTROL_STOP_ALL": "tsotlhe",
    "CONTROL_STOP_THIS": "mokwalo o",
    "CONTROL_STOP_OTHER": "makwalo a mangwe mo go sprite",
    "CONTROL_WAIT": "leta %1 metsotswana",
    "CONTROL_WAITUNTIL": "leta go fitlhela go %1",
    "CONTROL_REPEATUNTIL": "boeletsa go fitlhela go %1",
    "CONTROL_WHILE": "fa %1",
    "CONTROL_FOREACH": " %1 nngwe le nngwe mo go %2",
    "CONTROL_STARTASCLONE": "fa ke simolola jaaka sebopapopego",
    "CONTROL_CREATECLONEOF": "dira sebopapopego sa %1",
    "CONTROL_CREATECLONEOF_MYSELF": "nna",
    "CONTROL_DELETETHISCLONE": "phimola sebopapopego se",
    "CONTROL_COUNTER": "sebadi",
    "CONTROL_INCRCOUNTER": "oketsa sebadi",
    "CONTROL_CLEARCOUNTER": "tlosa sebadi",
    "CONTROL_ALLATONCE": "tsotlhe ka gangwe",
    "DATA_SETVARIABLETO": "dira %1 go %2",
    "DATA_CHANGEVARIABLEBY": "fetola %1 ka %2",
    "DATA_SHOWVARIABLE": "bontsha pharologano ya %1",
    "DATA_HIDEVARIABLE": "fitlha pharologano ya %1",
    "DATA_ADDTOLIST": "oketsa %1 go %2",
    "DATA_DELETEOFLIST": "tlosa %1 ya %2",
    "DATA_DELETEALLOFLIST": "tlosa tsotlhe tsa %1",
    "DATA_INSERTATLIST": "tsenya %1 go %2 ya %3",
    "DATA_REPLACEITEMOFLIST": "emisetsa selwana %1 ya %2 ka %3",
    "DATA_ITEMOFLIST": "selwana %1 sa %2",
    "DATA_ITEMNUMOFLIST": "selwana # sa %1 go %2",
    "DATA_LENGTHOFLIST": "boleele jwa %1",
    "DATA_LISTCONTAINSITEM": "%1 e tshotse %2?",
    "DATA_SHOWLIST": "bontsha lenaane %1",
    "DATA_HIDELIST": "fitlha lenaane %1",
    "DATA_INDEX_ALL": "tsotlhe",
    "DATA_INDEX_LAST": "bofelo",
    "DATA_INDEX_RANDOM": "gongwe le gongwe",
    "EVENT_WHENFLAGCLICKED": "fa %1 e tobetswa",
    "EVENT_WHENTHISSPRITECLICKED": "fa sprite se, se tobetswa",
    "EVENT_WHENSTAGECLICKED": "fa serala se tobetswa",
    "EVENT_WHENTOUCHINGOBJECT": "fa sprite se kgoma %1",
    "EVENT_WHENBROADCASTRECEIVED": "fa ke amogela %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "fa tatlhelomorago e fetogela go %1",
    "EVENT_WHENGREATERTHAN": "fa %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "sekayanako",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "modumo",
    "EVENT_BROADCAST": "gasa %1",
    "EVENT_BROADCASTANDWAIT": "gasa %1 mme o lete",
    "EVENT_WHENKEYPRESSED": "fa %1 ya konopo e tobeditswe",
    "EVENT_WHENKEYPRESSED_SPACE": "phatlhamagareng",
    "EVENT_WHENKEYPRESSED_LEFT": "tshupo molema",
    "EVENT_WHENKEYPRESSED_RIGHT": "tshupo moja",
    "EVENT_WHENKEYPRESSED_DOWN": "tshupo tlase",
    "EVENT_WHENKEYPRESSED_UP": "tshupo godimo",
    "EVENT_WHENKEYPRESSED_ANY": "sengwe",
    "LOOKS_SAYFORSECS": "e re %1 ya %2 metsotswana",
    "LOOKS_SAY": "e re %1",
    "LOOKS_HELLO": "Dumela!",
    "LOOKS_THINKFORSECS": "akanya %1 ya %2 metsotswana",
    "LOOKS_THINK": "akanya %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "bontsha",
    "LOOKS_HIDE": "fitlha",
    "LOOKS_HIDEALLSPRITES": "fitlha di sprite tsotlhe",
    "LOOKS_EFFECT_COLOR": "mmala",
    "LOOKS_EFFECT_FISHEYE": "leitlho la tlhapi",
    "LOOKS_EFFECT_WHIRL": "dikologa",
    "LOOKS_EFFECT_PIXELATE": "dira setshwantsho",
    "LOOKS_EFFECT_MOSAIC": "setshwantsho sa maje",
    "LOOKS_EFFECT_BRIGHTNESS": "phatshimo",
    "LOOKS_EFFECT_GHOST": "sepoko",
    "LOOKS_CHANGEEFFECTBY": "fetola %1 go simolola ka %2",
    "LOOKS_SETEFFECTTO": "dira %1 go simolola %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "phimola tebego ya dinepe",
    "LOOKS_CHANGESIZEBY": "fetola bogolo ka %1",
    "LOOKS_SETSIZETO": "dira bogolo go %1 %",
    "LOOKS_SIZE": "bogolo",
    "LOOKS_CHANGESTRETCHBY": "fetola go otlolola ka %1",
    "LOOKS_SETSTRETCHTO": "dira go otlolola go %1 %",
    "LOOKS_SWITCHCOSTUMETO": "fetolela diaparo go %1",
    "LOOKS_NEXTCOSTUME": "seaparo se se latelang",
    "LOOKS_SWITCHBACKDROPTO": "fetolela tatlhelo morago go %1",
    "LOOKS_GOTOFRONTBACK": "e ya go %1 ya boalo",
    "LOOKS_GOTOFRONTBACK_FRONT": "fa pele",
    "LOOKS_GOTOFRONTBACK_BACK": "kwa morago",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "e ya go %1 %2 ya boalo",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "fetisa",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "kwa morago",
    "LOOKS_BACKDROPNUMBERNAME": "tatlhelomorago %1",
    "LOOKS_COSTUMENUMBERNAME": "seaparo %1",
    "LOOKS_NUMBERNAME_NUMBER": "palo",
    "LOOKS_NUMBERNAME_NAME": "leina",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "fetolela tatlhelomorago go %1 mme o lete",
    "LOOKS_NEXTBACKDROP_BLOCK": "tatlhelomorago e e latelang",
    "LOOKS_NEXTBACKDROP": "tatlhelomorago e e latelang",
    "LOOKS_PREVIOUSBACKDROP": "tatlhelomorago e e fitileng",
    "LOOKS_RANDOMBACKDROP": "tatlhelomorago nngwe le nngwe",
    "MOTION_MOVESTEPS": "tsamaisa %1 dikgato",
    "MOTION_TURNLEFT": "retolosa %1 %2 ka selekanyo",
    "MOTION_TURNRIGHT": "retolosa %1 %2 ka selekanyo",
    "MOTION_POINTINDIRECTION": "supa kaelo ya %1",
    "MOTION_POINTTOWARDS": "supa go ya go %1",
    "MOTION_POINTTOWARDS_POINTER": "maose wa tshupetso",
    "MOTION_POINTTOWARDS_RANDOM": "kaelo nngwe le nngwe",
    "MOTION_GOTO": "e ya go %1",
    "MOTION_GOTO_POINTER": "maose wa tshupetso",
    "MOTION_GOTO_RANDOM": "maemo mangwe le mangwe",
    "MOTION_GOTOXY": "e ya go x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "reletsa %1 metsotswana go x: %2 y: %3",
    "MOTION_GLIDETO": "reletsa %1 metsotswana go %2",
    "MOTION_GLIDETO_POINTER": "maose wa tshupetso",
    "MOTION_GLIDETO_RANDOM": "maemo mangwe le mangwe",
    "MOTION_CHANGEXBY": "fetola x ka %1",
    "MOTION_SETX": "dira x go %1",
    "MOTION_CHANGEYBY": "fetola y ka %1",
    "MOTION_SETY": "dira y go %1",
    "MOTION_IFONEDGEBOUNCE": "fa e le mo losing, tlola",
    "MOTION_SETROTATIONSTYLE": "dira mokgwa wa go dikologa %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "molema-moja",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "o se dikologe",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": " tsotlhe ",
    "MOTION_XPOSITION": "boemo jwa x",
    "MOTION_YPOSITION": "boemo jwa y",
    "MOTION_DIRECTION": "kaelo",
    "MOTION_SCROLLRIGHT": "tsamaela kwa mojeng wa %1",
    "MOTION_SCROLLUP": "tsamaela kwa godimo %1",
    "MOTION_ALIGNSCENE": "amanya tiragalo le %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "kwa tlase-molema",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "kwa tlase-moja",
    "MOTION_ALIGNSCENE_MIDDLE": "bogare",
    "MOTION_ALIGNSCENE_TOPLEFT": "kwa godimo-molema",
    "MOTION_ALIGNSCENE_TOPRIGHT": "kwa godimo-moja",
    "MOTION_XSCROLL": " tsamaisa x",
    "MOTION_YSCROLL": "tsamaisa y",
    "MOTION_STAGE_SELECTED": "serala se se tlhophilweng: ga go diboloko tsa motsamao",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "tlhopha gongwe le gongwe %1 go %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 le %2",
    "OPERATORS_OR": "%1 kgotsa %2",
    "OPERATORS_NOT": "e seng %1",
    "OPERATORS_JOIN": "kopanya %1 %2",
    "OPERATORS_JOIN_APPLE": "apole",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "tlhaka %1 ya %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "boleele jwa %1",
    "OPERATORS_CONTAINS": "%1 e tshotse %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "tikologo ya %1",
    "OPERATORS_MATHOP": "%1 ya %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "boalo",
    "OPERATORS_MATHOP_CEILING": "Ceiling ",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "gare",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "tlhalosa %1",
    "SENSING_TOUCHINGOBJECT": "o kgoma %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "maose wa tshupetso",
    "SENSING_TOUCHINGOBJECT_EDGE": "losi",
    "SENSING_TOUCHINGCOLOR": "o kgoma mmala wa %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "mmala wa %1 o kgoma %2?",
    "SENSING_DISTANCETO": "sekgala go %1",
    "SENSING_DISTANCETO_POINTER": "maose wa tshupetso",
    "SENSING_ASKANDWAIT": "botsa %1 mme o lete",
    "SENSING_ASK_TEXT": "leina la gago ke mang?",
    "SENSING_ANSWER": "karabo",
    "SENSING_KEYPRESSED": " konopo ya %1 e tobeditswe?",
    "SENSING_MOUSEDOWN": "maose kwa tlase?",
    "SENSING_MOUSEX": "maose x ",
    "SENSING_MOUSEY": "maose y",
    "SENSING_SETDRAGMODE": "dira mokgwa wa go goga %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "e a gogega",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ga e gogege",
    "SENSING_LOUDNESS": "modumo",
    "SENSING_LOUD": "modumo?",
    "SENSING_TIMER": "sekayanako",
    "SENSING_RESETTIMER": "simolola sekayanako",
    "SENSING_OF": "%1 ya %2",
    "SENSING_OF_XPOSITION": "boemo jwa x",
    "SENSING_OF_YPOSITION": "boemo jwa y",
    "SENSING_OF_DIRECTION": "kaelo",
    "SENSING_OF_COSTUMENUMBER": "seaparo #",
    "SENSING_OF_COSTUMENAME": "leina la seaparo",
    "SENSING_OF_SIZE": "bogolo",
    "SENSING_OF_VOLUME": "maemo a modumo",
    "SENSING_OF_BACKDROPNUMBER": "tatlhelo morago #",
    "SENSING_OF_BACKDROPNAME": "leina la tatlhelo morago",
    "SENSING_OF_STAGE": "Serala",
    "SENSING_CURRENT": "gompieno %1",
    "SENSING_CURRENT_YEAR": "ngwaga",
    "SENSING_CURRENT_MONTH": "kgwedi",
    "SENSING_CURRENT_DATE": "letlha",
    "SENSING_CURRENT_DAYOFWEEK": "letsatsi la beke",
    "SENSING_CURRENT_HOUR": "ura",
    "SENSING_CURRENT_MINUTE": "motsotso",
    "SENSING_CURRENT_SECOND": "motsotswana",
    "SENSING_DAYSSINCE2000": "malatsi go simolola ka 2000",
    "SENSING_USERNAME": "leinatiriso",
    "SENSING_USERID": "tiriso ya go ikitsise",
    "SOUND_PLAY": "simolola modumo wa %1",
    "SOUND_PLAYUNTILDONE": "tshameka modumo wa %1 go fitlhela o fetsa",
    "SOUND_STOPALLSOUNDS": "emisa medumo yotlhe",
    "SOUND_SETEFFECTO": "dira %1 go simolola  %2",
    "SOUND_CHANGEEFFECTBY": "fetola %1 go simolola ka %2",
    "SOUND_CLEAREFFECTS": "tlosa medumo e e simololang",
    "SOUND_EFFECTS_PITCH": "segalo",
    "SOUND_EFFECTS_PAN": "letswela la molema/moja",
    "SOUND_CHANGEVOLUMEBY": "fetola maemo a modumo ka %1",
    "SOUND_SETVOLUMETO": "dira maemo a modumo go %1%",
    "SOUND_VOLUME": "maemo a modumo",
    "SOUND_RECORD": "gatisa…",
    "CATEGORY_MOTION": "Motsamao",
    "CATEGORY_LOOKS": "Ditebego",
    "CATEGORY_SOUND": "Modumo",
    "CATEGORY_EVENTS": "Ditiragalo",
    "CATEGORY_CONTROL": "Laola",
    "CATEGORY_SENSING": "Dupelela",
    "CATEGORY_OPERATORS": "Badiri",
    "CATEGORY_VARIABLES": "Dipharologano",
    "CATEGORY_MYBLOCKS": "Diboloko tsa me",
    "DUPLICATE": "Gatisa",
    "DELETE": "Phimola",
    "ADD_COMMENT": "Tsenya kakgelo",
    "REMOVE_COMMENT": "Tlosa kakgelo",
    "DELETE_BLOCK": "Phimola Boloko",
    "DELETE_X_BLOCKS": "Phimola diboloko tsa %1 ",
    "DELETE_ALL_BLOCKS": "Phimola diboloko tsotlhe tsa %1?",
    "CLEAN_UP": "Phepafatsa Diboloko",
    "HELP": "Thusa",
    "UNDO": "Dirolola",
    "REDO": "Dira gape",
    "EDIT_PROCEDURE": "Siamisa",
    "SHOW_PROCEDURE_DEFINITION": "E ya kwa tlhalosong",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Bua sengwe",
    "COLOUR_HUE_LABEL": "Mmala",
    "COLOUR_SATURATION_LABEL": "Go tlala",
    "COLOUR_BRIGHTNESS_LABEL": "Phatsimo",
    "CHANGE_VALUE_TITLE": "Fetola boleng",
    "RENAME_VARIABLE": "Naya phetogo leina gape",
    "RENAME_VARIABLE_TITLE": "Naya diphetogo tsotlhe tsa \"%1\" leina gape go:",
    "RENAME_VARIABLE_MODAL_TITLE": "Naya phetogo leina gape",
    "NEW_VARIABLE": "Dira Phetogo",
    "NEW_VARIABLE_TITLE": "Leina le lešwa la phetogo",
    "VARIABLE_MODAL_TITLE": "Pharologano e ntšhwa",
    "VARIABLE_ALREADY_EXISTS": "Pharologano e e bidiwang \"%1\" e setse e tlhageletse",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Pharologano e e bidiwang \"%1\" e setse e tlhageletse ka pharologano e nngwe ya mofuta wa \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "Phimola %1 e e dirisang pharologano ya \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "O ka se phimole pharologano ya \"%1\" gonne ke karolo ya tlhaloso ya mosola wa \"%2\"",
    "DELETE_VARIABLE": "Phimola pharologano ya \"%1\"",
    "NEW_PROCEDURE": "Dira Boloko",
    "PROCEDURE_ALREADY_EXISTS": "Tsamaiso e e bidiwang \"%1\" e setse e tlhageletse",
    "PROCEDURE_DEFAULT_NAME": "leina la boloko",
    "PROCEDURE_USED": "Go phimolla tlhaloso ya boloko, sa ntlha tlosa tiriso ya diboloko tsotlhe",
    "NEW_LIST": "Dira lenaane",
    "NEW_LIST_TITLE": "Leina la lenaane le lešwa:",
    "LIST_MODAL_TITLE": "Lenaane le lešwa",
    "LIST_ALREADY_EXISTS": "Lenaane le le bidiwang \"%1\" le setse le tlhageletse",
    "RENAME_LIST_TITLE": "Naya manaane otlhe a \"%1\" maina gape go nna:",
    "RENAME_LIST_MODAL_TITLE": "Naya Lenaane leina gape",
    "DEFAULT_LIST_ITEM": "selo",
    "DELETE_LIST": "Phimola lenaane la \"%1\"",
    "RENAME_LIST": "Naya lenaane leina gape",
    "NEW_BROADCAST_MESSAGE": "Molaetsa o montšhwa",
    "NEW_BROADCAST_MESSAGE_TITLE": "Leina la molaetsa o montšhwa:",
    "BROADCAST_MODAL_TITLE": "Molaetsa o montšhwa",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "molaetsa 1"
  },
  "sk": {
    "CONTROL_FOREVER": "opakuj stále",
    "CONTROL_REPEAT": "opakuj %1",
    "CONTROL_IF": "ak %1",
    "CONTROL_ELSE": "inak",
    "CONTROL_STOP": "zastav",
    "CONTROL_STOP_ALL": "všetko",
    "CONTROL_STOP_THIS": "tento scenár",
    "CONTROL_STOP_OTHER": "moje iné scenáre",
    "CONTROL_WAIT": "čakaj %1 s",
    "CONTROL_WAITUNTIL": "čakaj až kým %1",
    "CONTROL_REPEATUNTIL": "opakuj až kým %1",
    "CONTROL_WHILE": "opakuj ak %1",
    "CONTROL_FOREACH": "pre každé %1 v %2",
    "CONTROL_STARTASCLONE": "pri štarte klonu",
    "CONTROL_CREATECLONEOF": "naklonuj %1",
    "CONTROL_CREATECLONEOF_MYSELF": "seba",
    "CONTROL_DELETETHISCLONE": "zruš tento klon",
    "CONTROL_COUNTER": "počítadlo",
    "CONTROL_INCRCOUNTER": "zvýš počítadlo",
    "CONTROL_CLEARCOUNTER": "vynuluj počítadlo",
    "CONTROL_ALLATONCE": "všetko naraz",
    "DATA_SETVARIABLETO": "nastav %1 na %2",
    "DATA_CHANGEVARIABLEBY": "zmeň %1 o %2",
    "DATA_SHOWVARIABLE": "ukáž premennú %1",
    "DATA_HIDEVARIABLE": "skry premennú %1",
    "DATA_ADDTOLIST": "pridaj %1 do %2",
    "DATA_DELETEOFLIST": "zruš %1 z %2",
    "DATA_DELETEALLOFLIST": "zruš všetko z %1",
    "DATA_INSERTATLIST": "vlož %1 na %2 v %3",
    "DATA_REPLACEITEMOFLIST": "nahraď %1 v %2 hodnotou %3",
    "DATA_ITEMOFLIST": "prvok %1 z %2",
    "DATA_ITEMNUMOFLIST": "poradie prvku %1 v %2",
    "DATA_LENGTHOFLIST": "dĺžka %1",
    "DATA_LISTCONTAINSITEM": "%1 obsahuje %2?",
    "DATA_SHOWLIST": "ukáž zoznam  %1",
    "DATA_HIDELIST": "skry zoznam  %1",
    "DATA_INDEX_ALL": "všetko",
    "DATA_INDEX_LAST": "posledný",
    "DATA_INDEX_RANDOM": "náhodný",
    "EVENT_WHENFLAGCLICKED": "pri kliknutí na %1",
    "EVENT_WHENTHISSPRITECLICKED": "pri kliknutí na mňa",
    "EVENT_WHENSTAGECLICKED": "pri kliknutí na scénu",
    "EVENT_WHENTOUCHINGOBJECT": "pri dotyku %1",
    "EVENT_WHENBROADCASTRECEIVED": "pri prijatí správy %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "pri zmene pozadia na %1",
    "EVENT_WHENGREATERTHAN": "pri %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "časovač",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "hlasitosť",
    "EVENT_BROADCAST": "vyšli správu %1",
    "EVENT_BROADCASTANDWAIT": "vyšli správu %1 a počkaj",
    "EVENT_WHENKEYPRESSED": "pri stlačení %1",
    "EVENT_WHENKEYPRESSED_SPACE": "medzerník",
    "EVENT_WHENKEYPRESSED_LEFT": "šípka vľavo",
    "EVENT_WHENKEYPRESSED_RIGHT": "šípka vpravo",
    "EVENT_WHENKEYPRESSED_DOWN": "šípka dole",
    "EVENT_WHENKEYPRESSED_UP": "šípka hore",
    "EVENT_WHENKEYPRESSED_ANY": "hociktorý",
    "LOOKS_SAYFORSECS": "bublina %1 %2 s",
    "LOOKS_SAY": "bublina %1",
    "LOOKS_HELLO": "Ahoj!",
    "LOOKS_THINKFORSECS": "myšlienka %1 %2 s",
    "LOOKS_THINK": "myšlienka %1",
    "LOOKS_HMM": "Hm...",
    "LOOKS_SHOW": "ukáž sa",
    "LOOKS_HIDE": "skry sa",
    "LOOKS_HIDEALLSPRITES": "skry všetky postavy",
    "LOOKS_EFFECT_COLOR": "farba",
    "LOOKS_EFFECT_FISHEYE": "rybie oko",
    "LOOKS_EFFECT_WHIRL": "zvírenie",
    "LOOKS_EFFECT_PIXELATE": "štvorčeky",
    "LOOKS_EFFECT_MOSAIC": "mozaika",
    "LOOKS_EFFECT_BRIGHTNESS": "jas",
    "LOOKS_EFFECT_GHOST": "duch",
    "LOOKS_CHANGEEFFECTBY": "zmeň efekt %1 o %2",
    "LOOKS_SETEFFECTTO": "nastav efekt %1 na %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "zruš grafické efekty",
    "LOOKS_CHANGESIZEBY": "zmeň veľkosť o %1 %",
    "LOOKS_SETSIZETO": "nastav veľkosť na %1 %",
    "LOOKS_SIZE": "veľkosť",
    "LOOKS_CHANGESTRETCHBY": "zmeň natiahnutie o %1",
    "LOOKS_SETSTRETCHTO": "nastav natiahnutie na %1 %",
    "LOOKS_SWITCHCOSTUMETO": "zmeň kostým na %1",
    "LOOKS_NEXTCOSTUME": "ďalší kostým",
    "LOOKS_SWITCHBACKDROPTO": "zmeň pozadie na %1",
    "LOOKS_GOTOFRONTBACK": "prejdi na  %1 vrstvu",
    "LOOKS_GOTOFRONTBACK_FRONT": "vrchnú",
    "LOOKS_GOTOFRONTBACK_BACK": "spodnú",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "prejdi o %2 vrstiev %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "dopredu",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "dozadu",
    "LOOKS_BACKDROPNUMBERNAME": "pozadie  %1",
    "LOOKS_COSTUMENUMBERNAME": "kostým %1",
    "LOOKS_NUMBERNAME_NUMBER": "číslo",
    "LOOKS_NUMBERNAME_NAME": "meno",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "zmeň pozadie na %1 a počkaj",
    "LOOKS_NEXTBACKDROP_BLOCK": "ďalšie pozadie",
    "LOOKS_NEXTBACKDROP": "ďalšie pozadie",
    "LOOKS_PREVIOUSBACKDROP": "predchádzajúce pozadie",
    "LOOKS_RANDOMBACKDROP": "náhodné pozadie",
    "MOTION_MOVESTEPS": "dopredu %1",
    "MOTION_TURNLEFT": "vľavo %1 %2",
    "MOTION_TURNRIGHT": "vpravo %1 %2",
    "MOTION_POINTINDIRECTION": "smerom %1",
    "MOTION_POINTTOWARDS": "smerom k %1",
    "MOTION_POINTTOWARDS_POINTER": "myš",
    "MOTION_POINTTOWARDS_RANDOM": "náhodný smer",
    "MOTION_GOTO": "skoč na %1",
    "MOTION_GOTO_POINTER": "myš",
    "MOTION_GOTO_RANDOM": "náhodná pozícia",
    "MOTION_GOTOXY": "skoč na x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "kĺž sa %1 s na x: %2 y: %3",
    "MOTION_GLIDETO": "kĺž sa %1 s na %2",
    "MOTION_GLIDETO_POINTER": "myš",
    "MOTION_GLIDETO_RANDOM": "náhodná pozícia",
    "MOTION_CHANGEXBY": "zmeň x o %1",
    "MOTION_SETX": "skoč na x: %1",
    "MOTION_CHANGEYBY": "zmeň y o %1",
    "MOTION_SETY": "skoč na y: %1",
    "MOTION_IFONEDGEBOUNCE": "ak na okraji, odraz sa",
    "MOTION_SETROTATIONSTYLE": "nastav otáčanie %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "vľavo-vpravo",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "žiadne",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "podľa smeru",
    "MOTION_XPOSITION": "pozícia x",
    "MOTION_YPOSITION": "pozícia y",
    "MOTION_DIRECTION": "smer",
    "MOTION_SCROLLRIGHT": "posuň vpravo %1",
    "MOTION_SCROLLUP": "presuň hore %1",
    "MOTION_ALIGNSCENE": "zarovnaj scénu %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "vľavo dolu",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "vpravo dolu",
    "MOTION_ALIGNSCENE_MIDDLE": "stred",
    "MOTION_ALIGNSCENE_TOPLEFT": "vľavo hore",
    "MOTION_ALIGNSCENE_TOPRIGHT": "vpravo hore",
    "MOTION_XSCROLL": "posunutie x",
    "MOTION_YSCROLL": "posunutie y",
    "MOTION_STAGE_SELECTED": "Scéna nemá bloky pre pohyb",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "náhodne od %1 do %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 a %2",
    "OPERATORS_OR": "%1 alebo %2",
    "OPERATORS_NOT": "nie je %1",
    "OPERATORS_JOIN": "spoj %1 %2",
    "OPERATORS_JOIN_APPLE": "jablko",
    "OPERATORS_JOIN_BANANA": "hruška",
    "OPERATORS_LETTEROF": "znak %1 z %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "dĺžka %1",
    "OPERATORS_CONTAINS": "%1 obsahuje %2?",
    "OPERATORS_MOD": "zvyšok %1 / %2",
    "OPERATORS_ROUND": "zaokrúhli %1",
    "OPERATORS_MATHOP": "%1 z %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "zaokrúhli nadol",
    "OPERATORS_MATHOP_CEILING": "zaokrúhli nahor",
    "OPERATORS_MATHOP_SQRT": "odmocnina",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tg",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctg",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "exp",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "blok %1",
    "SENSING_TOUCHINGOBJECT": "dotýkaš sa %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "myš",
    "SENSING_TOUCHINGOBJECT_EDGE": "okraj",
    "SENSING_TOUCHINGCOLOR": "dotýkaš sa %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 sa dotýkaš %2?",
    "SENSING_DISTANCETO": "vzdialenosť k %1",
    "SENSING_DISTANCETO_POINTER": "myš",
    "SENSING_ASKANDWAIT": "otázka %1",
    "SENSING_ASK_TEXT": "Ako sa voláš?",
    "SENSING_ANSWER": "odpoveď",
    "SENSING_KEYPRESSED": "stlačené %1?",
    "SENSING_MOUSEDOWN": "stlačené tlačidlo myši?",
    "SENSING_MOUSEX": "myš x",
    "SENSING_MOUSEY": "myš y",
    "SENSING_SETDRAGMODE": "hráč môže presúvať %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "áno ",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "nie",
    "SENSING_LOUDNESS": "hlasitosť",
    "SENSING_LOUD": "hlasný?",
    "SENSING_TIMER": "časovač",
    "SENSING_RESETTIMER": "vynuluj časovač",
    "SENSING_OF": "%1 z %2",
    "SENSING_OF_XPOSITION": "pozícia x",
    "SENSING_OF_YPOSITION": "pozícia y",
    "SENSING_OF_DIRECTION": "smer",
    "SENSING_OF_COSTUMENUMBER": "číslo kostýmu",
    "SENSING_OF_COSTUMENAME": "meno kostýmu",
    "SENSING_OF_SIZE": "veľkosť",
    "SENSING_OF_VOLUME": "hlasitosť",
    "SENSING_OF_BACKDROPNUMBER": "číslo pozadia",
    "SENSING_OF_BACKDROPNAME": "meno pozadia",
    "SENSING_OF_STAGE": "Scéna",
    "SENSING_CURRENT": "teraz je %1",
    "SENSING_CURRENT_YEAR": "rok",
    "SENSING_CURRENT_MONTH": "mesiac",
    "SENSING_CURRENT_DATE": "deň v mesiaci",
    "SENSING_CURRENT_DAYOFWEEK": "deň v týždni",
    "SENSING_CURRENT_HOUR": "hod",
    "SENSING_CURRENT_MINUTE": "min",
    "SENSING_CURRENT_SECOND": "s",
    "SENSING_DAYSSINCE2000": "dní od roku 2000",
    "SENSING_USERNAME": "používateľ",
    "SENSING_USERID": "užívateľské id",
    "SOUND_PLAY": "zahraj zvuk %1",
    "SOUND_PLAYUNTILDONE": "zahraj zvuk %1 až do konca",
    "SOUND_STOPALLSOUNDS": "zastav všetky zvuky",
    "SOUND_SETEFFECTO": "nastav efekt %1 na %2",
    "SOUND_CHANGEEFFECTBY": "zmeň efekt %1 o %2",
    "SOUND_CLEAREFFECTS": "zruš zvukové efekty",
    "SOUND_EFFECTS_PITCH": "frekvencia",
    "SOUND_EFFECTS_PAN": "stereo",
    "SOUND_CHANGEVOLUMEBY": "zmeň hlasitosť o %1 %",
    "SOUND_SETVOLUMETO": "nastav hlasitosť na %1% %",
    "SOUND_VOLUME": "hlasitosť",
    "SOUND_RECORD": "nahraj...",
    "CATEGORY_MOTION": "Pohyb",
    "CATEGORY_LOOKS": "Vzhľad",
    "CATEGORY_SOUND": "Zvuk",
    "CATEGORY_EVENTS": "Udalosti",
    "CATEGORY_CONTROL": "Riadenie",
    "CATEGORY_SENSING": "Zisťovanie",
    "CATEGORY_OPERATORS": "Operácie",
    "CATEGORY_VARIABLES": "Premenné",
    "CATEGORY_MYBLOCKS": "Nové bloky",
    "DUPLICATE": "duplikuj",
    "DELETE": "zruš",
    "ADD_COMMENT": "pridaj komentár",
    "REMOVE_COMMENT": "zruš komentár",
    "DELETE_BLOCK": "zruš blok",
    "DELETE_X_BLOCKS": "zruš %1 blokov",
    "DELETE_ALL_BLOCKS": "Naozaj chceš zrušiť %1 blokov?",
    "CLEAN_UP": "uprac",
    "HELP": "pomoc",
    "UNDO": "späť",
    "REDO": "znovu",
    "EDIT_PROCEDURE": "uprav",
    "SHOW_PROCEDURE_DEFINITION": "zobraz definíciu",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Poznámka",
    "COLOUR_HUE_LABEL": "farba",
    "COLOUR_SATURATION_LABEL": "sýtosť",
    "COLOUR_BRIGHTNESS_LABEL": "jas",
    "CHANGE_VALUE_TITLE": "Zmeň hodnotu:",
    "RENAME_VARIABLE": "premenuj",
    "RENAME_VARIABLE_TITLE": "Premenuj všetky výskyty premennej \"%1\":",
    "RENAME_VARIABLE_MODAL_TITLE": "Premenuj premennú",
    "NEW_VARIABLE": "Nová premenná",
    "NEW_VARIABLE_TITLE": "Meno premennej:",
    "VARIABLE_MODAL_TITLE": "Nová premenná",
    "VARIABLE_ALREADY_EXISTS": "Premenná s menom \"%1\" už existuje.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Premenná s menom \"%1\" už existuje pre inú prememnú typu \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Naozaj mám zrušiť %1 výskytov premennej \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Nemôžem zrušiť premennú \"%1\", pretože je súčasťou definície funkcie \"%2\".",
    "DELETE_VARIABLE": "zruš premennú \"%1\"",
    "NEW_PROCEDURE": "Nový blok",
    "PROCEDURE_ALREADY_EXISTS": "Blok \"%1\" už existuje.",
    "PROCEDURE_DEFAULT_NAME": "meno bloku",
    "PROCEDURE_USED": "Ak chceš zmazať defíníciu bloku, musíš najprv zmazať všetky jeho použitia",
    "NEW_LIST": "Nový zoznam",
    "NEW_LIST_TITLE": "Meno nového zoznamu:",
    "LIST_MODAL_TITLE": "Nový zoznam",
    "LIST_ALREADY_EXISTS": "Zoznam \"%1\" už existuje.",
    "RENAME_LIST_TITLE": "Premenuj zoznam \"%1\" na:",
    "RENAME_LIST_MODAL_TITLE": "Premenuj zoznam",
    "DEFAULT_LIST_ITEM": "hodnota",
    "DELETE_LIST": "zruš zoznam \"%1\"",
    "RENAME_LIST": "premenuj zoznam",
    "NEW_BROADCAST_MESSAGE": "nová správa...",
    "NEW_BROADCAST_MESSAGE_TITLE": "Meno novej správy:",
    "BROADCAST_MODAL_TITLE": "Nová správa",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "správa1"
  },
  "sl": {
    "CONTROL_FOREVER": "ponavljaj",
    "CONTROL_REPEAT": "ponovi %1 krat",
    "CONTROL_IF": "če %1 potem",
    "CONTROL_ELSE": "sicer",
    "CONTROL_STOP": "ustavi",
    "CONTROL_STOP_ALL": "vse",
    "CONTROL_STOP_THIS": "te ukaze",
    "CONTROL_STOP_OTHER": "ostale ukaze za ta lik",
    "CONTROL_WAIT": "počakaj %1 sekund",
    "CONTROL_WAITUNTIL": "počakaj dokler ni %1",
    "CONTROL_REPEATUNTIL": "ponavljaj dokler ni %1",
    "CONTROL_WHILE": "dokler %1",
    "CONTROL_FOREACH": "za vsak %1 v %2",
    "CONTROL_STARTASCLONE": "ko začnem kot dvojnik",
    "CONTROL_CREATECLONEOF": "ustvari dvojnika %1",
    "CONTROL_CREATECLONEOF_MYSELF": "sebe",
    "CONTROL_DELETETHISCLONE": "zbriši tega dvojnika",
    "CONTROL_COUNTER": "števec",
    "CONTROL_INCRCOUNTER": "povečaj števec",
    "CONTROL_CLEARCOUNTER": "počisti števec",
    "CONTROL_ALLATONCE": "vse hkrati",
    "DATA_SETVARIABLETO": "nastavi %1 na %2",
    "DATA_CHANGEVARIABLEBY": "spremeni %1 za %2",
    "DATA_SHOWVARIABLE": "pokaži spremenljivko %1",
    "DATA_HIDEVARIABLE": "skrij spremenljivko %1",
    "DATA_ADDTOLIST": "dodaj %1 k %2",
    "DATA_DELETEOFLIST": "zbriši %1 v %2",
    "DATA_DELETEALLOFLIST": "izbriši vse v %1",
    "DATA_INSERTATLIST": "vstavi %1 na %2 v %3",
    "DATA_REPLACEITEMOFLIST": "zamenjaj %1 v %2 z %3",
    "DATA_ITEMOFLIST": "element %1 v %2",
    "DATA_ITEMNUMOFLIST": "predmet # od %1 v %2",
    "DATA_LENGTHOFLIST": "dolžina %1",
    "DATA_LISTCONTAINSITEM": "Ali %1 vsebuje %2?",
    "DATA_SHOWLIST": "pokaži seznam %1",
    "DATA_HIDELIST": "skrij seznam %1",
    "DATA_INDEX_ALL": "vse",
    "DATA_INDEX_LAST": "zadnji",
    "DATA_INDEX_RANDOM": "naključno",
    "EVENT_WHENFLAGCLICKED": "ko kliknemo na %1",
    "EVENT_WHENTHISSPRITECLICKED": "ko kliknemo ta lik",
    "EVENT_WHENSTAGECLICKED": "ko kliknemo na oder",
    "EVENT_WHENTOUCHINGOBJECT": "ko se ta lik dotika %1",
    "EVENT_WHENBROADCASTRECEIVED": "ko prejmem %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "ko se ozadje zamenja na %1",
    "EVENT_WHENGREATERTHAN": "ko je %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "štoparica",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "glasnost",
    "EVENT_BROADCAST": "objavi %1",
    "EVENT_BROADCASTANDWAIT": "objavi %1 in čakaj",
    "EVENT_WHENKEYPRESSED": "ko je pritisnjena tipka %1 ",
    "EVENT_WHENKEYPRESSED_SPACE": "presledek",
    "EVENT_WHENKEYPRESSED_LEFT": "puščica levo",
    "EVENT_WHENKEYPRESSED_RIGHT": "puščica desno",
    "EVENT_WHENKEYPRESSED_DOWN": "puščica dol",
    "EVENT_WHENKEYPRESSED_UP": "puščica gor",
    "EVENT_WHENKEYPRESSED_ANY": "poljubna",
    "LOOKS_SAYFORSECS": "reci %1 za %2 sekund",
    "LOOKS_SAY": "reci %1",
    "LOOKS_HELLO": "Živjo!",
    "LOOKS_THINKFORSECS": "pomisli %1 za %2 sekund",
    "LOOKS_THINK": "pomisli %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "pokaži",
    "LOOKS_HIDE": "skrij",
    "LOOKS_HIDEALLSPRITES": "skrij vse like",
    "LOOKS_EFFECT_COLOR": "barva",
    "LOOKS_EFFECT_FISHEYE": "ribje oko",
    "LOOKS_EFFECT_WHIRL": "vrtinec",
    "LOOKS_EFFECT_PIXELATE": "pikčasto",
    "LOOKS_EFFECT_MOSAIC": "mozaik",
    "LOOKS_EFFECT_BRIGHTNESS": "svetlost",
    "LOOKS_EFFECT_GHOST": "duh",
    "LOOKS_CHANGEEFFECTBY": "spremeni učinek %1 za %2",
    "LOOKS_SETEFFECTTO": "nastavi učinek %1 na %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "odstrani slikovne učinke",
    "LOOKS_CHANGESIZEBY": "spremeni velikost za %1",
    "LOOKS_SETSIZETO": "nastavi velikost na %1 %",
    "LOOKS_SIZE": "velikost",
    "LOOKS_CHANGESTRETCHBY": "spremeni razteg za %1",
    "LOOKS_SETSTRETCHTO": "nastavi razteg na %1 %",
    "LOOKS_SWITCHCOSTUMETO": "spremeni videz v %1",
    "LOOKS_NEXTCOSTUME": "naslednji videz",
    "LOOKS_SWITCHBACKDROPTO": "zamenjaj ozadje na %1",
    "LOOKS_GOTOFRONTBACK": "pojdi na %1 plast",
    "LOOKS_GOTOFRONTBACK_FRONT": "spredaj",
    "LOOKS_GOTOFRONTBACK_BACK": "zadaj",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "pojdi %1 %2 plasti",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "naprej",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "nazaj",
    "LOOKS_BACKDROPNUMBERNAME": "ozadje %1",
    "LOOKS_COSTUMENUMBERNAME": "videz %1",
    "LOOKS_NUMBERNAME_NUMBER": "število",
    "LOOKS_NUMBERNAME_NAME": "ime",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "zamenjaj ozadje na %1 in počakaj",
    "LOOKS_NEXTBACKDROP_BLOCK": "naslednje ozadje",
    "LOOKS_NEXTBACKDROP": "naslednje ozadje",
    "LOOKS_PREVIOUSBACKDROP": "prejšnje ozadje",
    "LOOKS_RANDOMBACKDROP": "naključno ozadje",
    "MOTION_MOVESTEPS": "pojdi %1 korakov",
    "MOTION_TURNLEFT": "obrni se za %1 %2 stopinj",
    "MOTION_TURNRIGHT": "obrni se za %1 %2 stopinj",
    "MOTION_POINTINDIRECTION": "obrni se v smer %1",
    "MOTION_POINTTOWARDS": "obrni se proti %1",
    "MOTION_POINTTOWARDS_POINTER": "kazalcu miške",
    "MOTION_POINTTOWARDS_RANDOM": "naključna smer",
    "MOTION_GOTO": "pojdi na %1",
    "MOTION_GOTO_POINTER": "kazalec miške",
    "MOTION_GOTO_RANDOM": "naključno mesto",
    "MOTION_GOTOXY": "pojdi na x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "drsi %1 sekund do x: %2 y: %3",
    "MOTION_GLIDETO": "drsi %1 sekund do %2",
    "MOTION_GLIDETO_POINTER": "kazalca miške",
    "MOTION_GLIDETO_RANDOM": "naključnega mesta",
    "MOTION_CHANGEXBY": "spremeni x za %1",
    "MOTION_SETX": "nastavi x na %1",
    "MOTION_CHANGEYBY": "spremeni y za %1",
    "MOTION_SETY": "nastavi y na %1",
    "MOTION_IFONEDGEBOUNCE": "odbij se, če si na robu",
    "MOTION_SETROTATIONSTYLE": "Način vrtenja %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "levo-desno",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ne zasukaj",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "na vse strani",
    "MOTION_XPOSITION": "položaj x",
    "MOTION_YPOSITION": "položaj y",
    "MOTION_DIRECTION": "smer",
    "MOTION_SCROLLRIGHT": "premik desno %1",
    "MOTION_SCROLLUP": "premik gor%1",
    "MOTION_ALIGNSCENE": "poravnaj sceno %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "levo spodaj",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "desno spodaj",
    "MOTION_ALIGNSCENE_MIDDLE": "sredina",
    "MOTION_ALIGNSCENE_TOPLEFT": "levo zgoraj",
    "MOTION_ALIGNSCENE_TOPRIGHT": "desno zgoraj",
    "MOTION_XSCROLL": "premik v smeri x",
    "MOTION_YSCROLL": "premik v smeri y",
    "MOTION_STAGE_SELECTED": "Izbran oder: ni blokov za premikanje",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "naključno število med %1 in %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 in %2",
    "OPERATORS_OR": "%1 ali %2",
    "OPERATORS_NOT": "ne %1",
    "OPERATORS_JOIN": "združi %1 %2",
    "OPERATORS_JOIN_APPLE": "jabolko",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "%1 črka v %2",
    "OPERATORS_LETTEROF_APPLE": "b",
    "OPERATORS_LENGTH": "dolžina %1",
    "OPERATORS_CONTAINS": "%1 vsebuje %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "zaokroži %1",
    "OPERATORS_MATHOP": "%1 od %2",
    "OPERATORS_MATHOP_ABS": "absolutna vrednost",
    "OPERATORS_MATHOP_FLOOR": "zaokroženo navzdol",
    "OPERATORS_MATHOP_CEILING": "zaokroženo navzgor",
    "OPERATORS_MATHOP_SQRT": "kvadratni koren ",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tg",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctg",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definiraj %1",
    "SENSING_TOUCHINGOBJECT": "se dotika %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "kazalca miške",
    "SENSING_TOUCHINGOBJECT_EDGE": "roba",
    "SENSING_TOUCHINGCOLOR": "se dotika barve %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "se barva %1 dotika %2?",
    "SENSING_DISTANCETO": "razdalja do %1",
    "SENSING_DISTANCETO_POINTER": "kazalca miške",
    "SENSING_ASKANDWAIT": "vprašaj %1 in počakaj",
    "SENSING_ASK_TEXT": "Kako ti je ime?",
    "SENSING_ANSWER": "odgovor",
    "SENSING_KEYPRESSED": "je pritisnjena tipka %1?",
    "SENSING_MOUSEDOWN": "je miškin gumb pritisnjen?",
    "SENSING_MOUSEX": "miškin x",
    "SENSING_MOUSEY": "miškin y",
    "SENSING_SETDRAGMODE": "Možnost premika naj bo %1 ",
    "SENSING_SETDRAGMODE_DRAGGABLE": "možno premikati",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ne moremo premikati",
    "SENSING_LOUDNESS": "glasnost",
    "SENSING_LOUD": "glasno?",
    "SENSING_TIMER": "štoparica",
    "SENSING_RESETTIMER": "ponastavi štoparico",
    "SENSING_OF": "%1 od %2",
    "SENSING_OF_XPOSITION": "položaj x",
    "SENSING_OF_YPOSITION": "položaj y",
    "SENSING_OF_DIRECTION": "smer",
    "SENSING_OF_COSTUMENUMBER": "videz #",
    "SENSING_OF_COSTUMENAME": "ime videza",
    "SENSING_OF_SIZE": "velikost",
    "SENSING_OF_VOLUME": "glasnost",
    "SENSING_OF_BACKDROPNUMBER": "ozadje #",
    "SENSING_OF_BACKDROPNAME": "ime ozadja",
    "SENSING_OF_STAGE": "Oder",
    "SENSING_CURRENT": "trenutni %1",
    "SENSING_CURRENT_YEAR": "leto",
    "SENSING_CURRENT_MONTH": "mesec",
    "SENSING_CURRENT_DATE": "datum",
    "SENSING_CURRENT_DAYOFWEEK": "dan v tednu",
    "SENSING_CURRENT_HOUR": "ura",
    "SENSING_CURRENT_MINUTE": "minuta",
    "SENSING_CURRENT_SECOND": "sekunda",
    "SENSING_DAYSSINCE2000": "dni od leta 2000",
    "SENSING_USERNAME": "uporabniško ime",
    "SENSING_USERID": "uporabnikova številka",
    "SOUND_PLAY": "predvajaj zvok %1",
    "SOUND_PLAYUNTILDONE": "predvajaj zvok %1 do konca",
    "SOUND_STOPALLSOUNDS": "ustavi vse zvoke",
    "SOUND_SETEFFECTO": "nastavi učinek %1 na %2",
    "SOUND_CHANGEEFFECTBY": "spremeni učinek %1 za %2",
    "SOUND_CLEAREFFECTS": "izbriši zvočne učinke",
    "SOUND_EFFECTS_PITCH": "višina tona",
    "SOUND_EFFECTS_PAN": "premik levo/desno",
    "SOUND_CHANGEVOLUMEBY": "spremeni glasnost za %1",
    "SOUND_SETVOLUMETO": "nastavi glasnost na %1%",
    "SOUND_VOLUME": "glasnost",
    "SOUND_RECORD": "posnami...",
    "CATEGORY_MOTION": "Gibanje",
    "CATEGORY_LOOKS": "Videzi",
    "CATEGORY_SOUND": "Zvok",
    "CATEGORY_EVENTS": "Dogodki",
    "CATEGORY_CONTROL": "Krmiljenje",
    "CATEGORY_SENSING": "Zaznavanje",
    "CATEGORY_OPERATORS": "Operatorji",
    "CATEGORY_VARIABLES": "Spremenljivke",
    "CATEGORY_MYBLOCKS": "Moji bloki",
    "DUPLICATE": "Podvoji",
    "DELETE": "Izbriši",
    "ADD_COMMENT": "Dodaj komentar",
    "REMOVE_COMMENT": "Odstrani komentar",
    "DELETE_BLOCK": "Izbriši blok",
    "DELETE_X_BLOCKS": "Izbriši %1 blokov",
    "DELETE_ALL_BLOCKS": "Naj izbrišem vseh %1 blokov?",
    "CLEAN_UP": "Počisti bloke",
    "HELP": "Pomoč",
    "UNDO": "Razveljavi",
    "REDO": "Uveljavi",
    "EDIT_PROCEDURE": "Uredi",
    "SHOW_PROCEDURE_DEFINITION": "Pojdi na definicijo",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Reci kaj ...",
    "COLOUR_HUE_LABEL": "Barva",
    "COLOUR_SATURATION_LABEL": "Nasičenost",
    "COLOUR_BRIGHTNESS_LABEL": "Svetlost",
    "CHANGE_VALUE_TITLE": "Spremeni vrednost: ",
    "RENAME_VARIABLE": "Preimenuj spremenljivko",
    "RENAME_VARIABLE_TITLE": "Preimenuj vse spremenljivke  \"%1\" v:",
    "RENAME_VARIABLE_MODAL_TITLE": "Preimenuj spremenljivko",
    "NEW_VARIABLE": "Ustvari spremenljivko",
    "NEW_VARIABLE_TITLE": "Novo ime spremenljivke:",
    "VARIABLE_MODAL_TITLE": "Nova spremenljivka",
    "VARIABLE_ALREADY_EXISTS": "Spremenljivka z imenom \"%1\" že obstaja.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Spremenljivka z imenom \"%1\" že obstaja in je tipa \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Izbrisati %1 uporab spremenljivke \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Ne morem izbrisati spremenljivke \"%1\", ker je del definicije funkcije \"%2\"",
    "DELETE_VARIABLE": "Izbriši spremenljivko \"%1\"",
    "NEW_PROCEDURE": "Ustvari blok",
    "PROCEDURE_ALREADY_EXISTS": "Postopek z imenom \"%1\" že obstaja",
    "PROCEDURE_DEFAULT_NAME": "ime bloka",
    "PROCEDURE_USED": "Preden izbrišeš definicijo delčka (bloka), se najprej prepričaj, da ni nikjer uporabljen.",
    "NEW_LIST": "Ustvari seznam",
    "NEW_LIST_TITLE": "Novi ime seznama:",
    "LIST_MODAL_TITLE": "Nov seznam",
    "LIST_ALREADY_EXISTS": "Seznam z imenom \"%1\" že obstaja.",
    "RENAME_LIST_TITLE": "Preimenuj seznam \"%1\" v:",
    "RENAME_LIST_MODAL_TITLE": "Preimenuj seznam",
    "DEFAULT_LIST_ITEM": "stvar",
    "DELETE_LIST": "Izbriši seznam \"%1\" ",
    "RENAME_LIST": "Preimenuj seznam",
    "NEW_BROADCAST_MESSAGE": "Novo sporočilo",
    "NEW_BROADCAST_MESSAGE_TITLE": "Ime novega sporočila:",
    "BROADCAST_MODAL_TITLE": "Novo sporočilo",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "sporočilo1"
  },
  "sr": {
    "CONTROL_FOREVER": "понављај заувек",
    "CONTROL_REPEAT": "понови %1",
    "CONTROL_IF": "ако је %1 онда",
    "CONTROL_ELSE": "у супротном",
    "CONTROL_STOP": "заустави",
    "CONTROL_STOP_ALL": "све",
    "CONTROL_STOP_THIS": "овај програм",
    "CONTROL_STOP_OTHER": "друге програме лика",
    "CONTROL_WAIT": "чекај %1 секунду",
    "CONTROL_WAITUNTIL": "чекај док не %1",
    "CONTROL_REPEATUNTIL": "понављај до %1",
    "CONTROL_WHILE": "док је %1",
    "CONTROL_FOREACH": "за сваки %1 у %2",
    "CONTROL_STARTASCLONE": "када се појавим као умножак",
    "CONTROL_CREATECLONEOF": "направи дупликат од %1",
    "CONTROL_CREATECLONEOF_MYSELF": "мене",
    "CONTROL_DELETETHISCLONE": "обриши овај умножак",
    "CONTROL_COUNTER": "бројач",
    "CONTROL_INCRCOUNTER": "увећај бројач",
    "CONTROL_CLEARCOUNTER": "обриши бројач",
    "CONTROL_ALLATONCE": "све одједном",
    "DATA_SETVARIABLETO": "нека %1 буде %2",
    "DATA_CHANGEVARIABLEBY": "промени %1 за %2",
    "DATA_SHOWVARIABLE": "прикажи променљиву %1",
    "DATA_HIDEVARIABLE": "сакриј променљиву %1",
    "DATA_ADDTOLIST": "додај %1 у %2",
    "DATA_DELETEOFLIST": "обриши %1 из %2",
    "DATA_DELETEALLOFLIST": "обриши све из %1",
    "DATA_INSERTATLIST": "убаци %1 на %2 у %3",
    "DATA_REPLACEITEMOFLIST": "замени елемент %1 у %2 са %3",
    "DATA_ITEMOFLIST": "елемент %1 из %2",
    "DATA_ITEMNUMOFLIST": "место од %1 у %2",
    "DATA_LENGTHOFLIST": "дужина %1",
    "DATA_LISTCONTAINSITEM": "да ли %1 садржи %2?",
    "DATA_SHOWLIST": "прикажи листу %1",
    "DATA_HIDELIST": "сакриј листу %1",
    "DATA_INDEX_ALL": "све",
    "DATA_INDEX_LAST": "последњи",
    "DATA_INDEX_RANDOM": "насумичан",
    "EVENT_WHENFLAGCLICKED": "када је кликнуто на %1",
    "EVENT_WHENTHISSPRITECLICKED": "када је кликнуто на овај лик",
    "EVENT_WHENSTAGECLICKED": "када је кликнуто на позорницу",
    "EVENT_WHENTOUCHINGOBJECT": "када овај лик додирне %1",
    "EVENT_WHENBROADCASTRECEIVED": "када примим %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "када се позадина промени у %1",
    "EVENT_WHENGREATERTHAN": "када је %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "тајмер",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "јачина звука",
    "EVENT_BROADCAST": "разгласи %1",
    "EVENT_BROADCASTANDWAIT": "разгласи %1 и чекај",
    "EVENT_WHENKEYPRESSED": "када је дирка %1 притиснута",
    "EVENT_WHENKEYPRESSED_SPACE": "размак",
    "EVENT_WHENKEYPRESSED_LEFT": "стрелица лево",
    "EVENT_WHENKEYPRESSED_RIGHT": "стрелица десно",
    "EVENT_WHENKEYPRESSED_DOWN": "стрелица доле",
    "EVENT_WHENKEYPRESSED_UP": "стрелица горе",
    "EVENT_WHENKEYPRESSED_ANY": "било који",
    "LOOKS_SAYFORSECS": "изговори %1 током %2 секунде",
    "LOOKS_SAY": "изговори %1",
    "LOOKS_HELLO": "Здраво!",
    "LOOKS_THINKFORSECS": "замисли %1 током %2 секунде",
    "LOOKS_THINK": "замисли %1",
    "LOOKS_HMM": "Хмм...",
    "LOOKS_SHOW": "прикажи",
    "LOOKS_HIDE": "сакриј",
    "LOOKS_HIDEALLSPRITES": "сакриј све ликове",
    "LOOKS_EFFECT_COLOR": "боја",
    "LOOKS_EFFECT_FISHEYE": "рибље око",
    "LOOKS_EFFECT_WHIRL": "вртлог",
    "LOOKS_EFFECT_PIXELATE": "позрнати",
    "LOOKS_EFFECT_MOSAIC": "мозаик",
    "LOOKS_EFFECT_BRIGHTNESS": "осветљеност",
    "LOOKS_EFFECT_GHOST": "дух",
    "LOOKS_CHANGEEFFECTBY": "промени ефекат %1 за %2",
    "LOOKS_SETEFFECTTO": "нека ефекат %1 буде %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "уклони графичке ефекте",
    "LOOKS_CHANGESIZEBY": "промени величину за %1",
    "LOOKS_SETSIZETO": "нека величина буде %1 %",
    "LOOKS_SIZE": "величина",
    "LOOKS_CHANGESTRETCHBY": "промени увећање за %1",
    "LOOKS_SETSTRETCHTO": "нека увећање буде  %1 %",
    "LOOKS_SWITCHCOSTUMETO": "замени костим са %1",
    "LOOKS_NEXTCOSTUME": "следећи костим",
    "LOOKS_SWITCHBACKDROPTO": "промени позадину у %1",
    "LOOKS_GOTOFRONTBACK": "иди на %1 слој",
    "LOOKS_GOTOFRONTBACK_FRONT": "напред",
    "LOOKS_GOTOFRONTBACK_BACK": "назад",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "иди %1 %2 слоја",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "проследи",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "уназад",
    "LOOKS_BACKDROPNUMBERNAME": "позадина %1",
    "LOOKS_COSTUMENUMBERNAME": "костим %1",
    "LOOKS_NUMBERNAME_NUMBER": "број",
    "LOOKS_NUMBERNAME_NAME": "име",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "промени позадину у %1 и чекај",
    "LOOKS_NEXTBACKDROP_BLOCK": "следећа позадина",
    "LOOKS_NEXTBACKDROP": "следећа позадина",
    "LOOKS_PREVIOUSBACKDROP": "претходна позадина",
    "LOOKS_RANDOMBACKDROP": "случајна позадина",
    "MOTION_MOVESTEPS": "иди %1 корака",
    "MOTION_TURNLEFT": "окрет %1 за %2 степени",
    "MOTION_TURNRIGHT": "окрет %1 за %2 степени",
    "MOTION_POINTINDIRECTION": "усмери се ка %1",
    "MOTION_POINTTOWARDS": "усмери се ка %1",
    "MOTION_POINTTOWARDS_POINTER": "показивач миша",
    "MOTION_POINTTOWARDS_RANDOM": "насумичан правац",
    "MOTION_GOTO": "иди до %1",
    "MOTION_GOTO_POINTER": "показивач миша",
    "MOTION_GOTO_RANDOM": "насумичан положај",
    "MOTION_GOTOXY": "иди до x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "клизи %1 секунди до x: %2 y: %3",
    "MOTION_GLIDETO": "клизи %1 секунди до %2",
    "MOTION_GLIDETO_POINTER": "показивач миша",
    "MOTION_GLIDETO_RANDOM": "случајан положај",
    "MOTION_CHANGEXBY": "промени x за %1",
    "MOTION_SETX": "нека x буде %1",
    "MOTION_CHANGEYBY": "промени y за %1",
    "MOTION_SETY": "нека y буде %1",
    "MOTION_IFONEDGEBOUNCE": "ако си на рубу, окрени се",
    "MOTION_SETROTATIONSTYLE": "подеси начин окретања %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "лево-десно",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "без окретања",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "на све стране",
    "MOTION_XPOSITION": "место х",
    "MOTION_YPOSITION": "место у",
    "MOTION_DIRECTION": "смер",
    "MOTION_SCROLLRIGHT": "клизи у десно %1",
    "MOTION_SCROLLUP": "клизи горе  %1",
    "MOTION_ALIGNSCENE": "поравнај сцену %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "доле-лево",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "доле-десно",
    "MOTION_ALIGNSCENE_MIDDLE": "средина",
    "MOTION_ALIGNSCENE_TOPLEFT": "горе-лево",
    "MOTION_ALIGNSCENE_TOPRIGHT": "горе-десно",
    "MOTION_XSCROLL": "x клизање",
    "MOTION_YSCROLL": "y клизање",
    "MOTION_STAGE_SELECTED": "Издабрана је позорница: нема блокова за кретање",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "случајан број од %1 до %2 ",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 и %2",
    "OPERATORS_OR": "%1 или %2",
    "OPERATORS_NOT": "није %1",
    "OPERATORS_JOIN": "споји %1 и %2",
    "OPERATORS_JOIN_APPLE": "јабука",
    "OPERATORS_JOIN_BANANA": "банана",
    "OPERATORS_LETTEROF": "%1 слово од %2",
    "OPERATORS_LETTEROF_APPLE": "ј",
    "OPERATORS_LENGTH": "дужина %1",
    "OPERATORS_CONTAINS": "%1 садржи %2",
    "OPERATORS_MOD": "%1 мод %2",
    "OPERATORS_ROUND": "заокружи %1",
    "OPERATORS_MATHOP": "%1 од %2",
    "OPERATORS_MATHOP_ABS": "абс",
    "OPERATORS_MATHOP_FLOOR": "цео део",
    "OPERATORS_MATHOP_CEILING": "цео+1",
    "OPERATORS_MATHOP_SQRT": "корен",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tg",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "дефиниши %1",
    "SENSING_TOUCHINGOBJECT": "додирује ли %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "показивач миша",
    "SENSING_TOUCHINGOBJECT_EDGE": "ивица",
    "SENSING_TOUCHINGCOLOR": "додирује ли боју %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "боја %1 додирује %2?",
    "SENSING_DISTANCETO": "удаљеност од %1",
    "SENSING_DISTANCETO_POINTER": "показивач миша",
    "SENSING_ASKANDWAIT": "питај %1 и чекај",
    "SENSING_ASK_TEXT": "Како се зовеш?",
    "SENSING_ANSWER": "одговор",
    "SENSING_KEYPRESSED": "дугме %1 је притиснуто?",
    "SENSING_MOUSEDOWN": "миш притиснут?",
    "SENSING_MOUSEX": "миш x",
    "SENSING_MOUSEY": "миш y",
    "SENSING_SETDRAGMODE": "нека начин превлачења буде %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "превлачиво",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "није превлачиво",
    "SENSING_LOUDNESS": "јачина звука",
    "SENSING_LOUD": "гласно?",
    "SENSING_TIMER": "тајмер",
    "SENSING_RESETTIMER": "постави тајмер на 0",
    "SENSING_OF": "%1 од %2",
    "SENSING_OF_XPOSITION": "x положај",
    "SENSING_OF_YPOSITION": "y положај",
    "SENSING_OF_DIRECTION": "смер",
    "SENSING_OF_COSTUMENUMBER": "број костима",
    "SENSING_OF_COSTUMENAME": "име костима",
    "SENSING_OF_SIZE": "величина",
    "SENSING_OF_VOLUME": "јачина звука",
    "SENSING_OF_BACKDROPNUMBER": "број позадине",
    "SENSING_OF_BACKDROPNAME": "име позадине",
    "SENSING_OF_STAGE": "Позорница",
    "SENSING_CURRENT": "тренутно %1",
    "SENSING_CURRENT_YEAR": "година",
    "SENSING_CURRENT_MONTH": "месец",
    "SENSING_CURRENT_DATE": "датум",
    "SENSING_CURRENT_DAYOFWEEK": "дан у недељи",
    "SENSING_CURRENT_HOUR": "сат",
    "SENSING_CURRENT_MINUTE": "минут",
    "SENSING_CURRENT_SECOND": "секунда",
    "SENSING_DAYSSINCE2000": "дана после 2000",
    "SENSING_USERNAME": "корисничко име",
    "SENSING_USERID": "корисников ид",
    "SOUND_PLAY": "покрени звук %1",
    "SOUND_PLAYUNTILDONE": "репродукуј звук %1 до краја",
    "SOUND_STOPALLSOUNDS": "заустави све звукове",
    "SOUND_SETEFFECTO": "нека ефекат %1 буде %2",
    "SOUND_CHANGEEFFECTBY": "промени ефекат %1 за %2",
    "SOUND_CLEAREFFECTS": "уклони звучне ефекте",
    "SOUND_EFFECTS_PITCH": "висина тона",
    "SOUND_EFFECTS_PAN": "померање лево/десно",
    "SOUND_CHANGEVOLUMEBY": "промени јачину звука за %1",
    "SOUND_SETVOLUMETO": "нека јачина звука буде %1%",
    "SOUND_VOLUME": "јачина звука",
    "SOUND_RECORD": "сними...",
    "CATEGORY_MOTION": "Кретање",
    "CATEGORY_LOOKS": "Изглед",
    "CATEGORY_SOUND": "Звук",
    "CATEGORY_EVENTS": "Догађаји",
    "CATEGORY_CONTROL": "Управљање",
    "CATEGORY_SENSING": "Осећаји",
    "CATEGORY_OPERATORS": "Оператори",
    "CATEGORY_VARIABLES": "Променљиве",
    "CATEGORY_MYBLOCKS": "Моји блокови",
    "DUPLICATE": "Умножи",
    "DELETE": "Обриши",
    "ADD_COMMENT": "Додај коментар",
    "REMOVE_COMMENT": "Уклони коментар",
    "DELETE_BLOCK": "Обриши блок",
    "DELETE_X_BLOCKS": "Обриши %1 блокова",
    "DELETE_ALL_BLOCKS": "Обрисати свих %1 блокова?",
    "CLEAN_UP": "Поспреми блокове",
    "HELP": "Помоћ",
    "UNDO": "Опозови",
    "REDO": "Понови",
    "EDIT_PROCEDURE": "Уреди",
    "SHOW_PROCEDURE_DEFINITION": "Иди до дефиниције",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Кажи нешто...",
    "COLOUR_HUE_LABEL": "Боја",
    "COLOUR_SATURATION_LABEL": "Засићење",
    "COLOUR_BRIGHTNESS_LABEL": "Осветљеност",
    "CHANGE_VALUE_TITLE": "Промени вредност:",
    "RENAME_VARIABLE": "Преименуј променљиву",
    "RENAME_VARIABLE_TITLE": "Преименуј свих \"%1\" променљивих у:",
    "RENAME_VARIABLE_MODAL_TITLE": "Преименуј променљиву",
    "NEW_VARIABLE": "Направи променљиву",
    "NEW_VARIABLE_TITLE": "Ново име променљиве:",
    "VARIABLE_MODAL_TITLE": "Нова променљива",
    "VARIABLE_ALREADY_EXISTS": "Име променљиве \"%1\" већ постоји.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Име променљиве \"%1\" већ постоји код друге променљиве типа \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Обрисати %1 употреба променљиве \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Не могу да обришем променљиву \"%1\" зато што је она део дефиниције функције \"%2\"",
    "DELETE_VARIABLE": "Обриши променљиву \"%1\"",
    "NEW_PROCEDURE": "Направи блок",
    "PROCEDURE_ALREADY_EXISTS": "Процедура са именом  \"%1\" већ постоји.",
    "PROCEDURE_DEFAULT_NAME": "име блока",
    "PROCEDURE_USED": "Да би обрисао дефиницију блока, прво уклони све употребе блока",
    "NEW_LIST": "Направи листу",
    "NEW_LIST_TITLE": "Ново име листе:",
    "LIST_MODAL_TITLE": "Нова листа",
    "LIST_ALREADY_EXISTS": "Листа са именом \"%1\" већ постоји.",
    "RENAME_LIST_TITLE": "Преименуј свих \"%1\" листи у:",
    "RENAME_LIST_MODAL_TITLE": "Преименуј листу",
    "DEFAULT_LIST_ITEM": "ствар",
    "DELETE_LIST": "Обриши листу \"%1\"",
    "RENAME_LIST": "Преименуј листу",
    "NEW_BROADCAST_MESSAGE": "Нова порука",
    "NEW_BROADCAST_MESSAGE_TITLE": "Име нове поруке:",
    "BROADCAST_MODAL_TITLE": "Нова порука",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "порука1"
  },
  "fi": {
    "CONTROL_FOREVER": "ikuisesti",
    "CONTROL_REPEAT": "toista %1 kertaa",
    "CONTROL_IF": "jos %1, niin",
    "CONTROL_ELSE": "tai muuten",
    "CONTROL_STOP": "pysäytä",
    "CONTROL_STOP_ALL": "kaikki",
    "CONTROL_STOP_THIS": "tämä koodi",
    "CONTROL_STOP_OTHER": "hahmon muut koodit",
    "CONTROL_WAIT": "odota %1 sekuntia",
    "CONTROL_WAITUNTIL": "odota kunnes %1",
    "CONTROL_REPEATUNTIL": "toista kunnes %1",
    "CONTROL_WHILE": "kun %1",
    "CONTROL_FOREACH": "jokainen %1 joukossa %2",
    "CONTROL_STARTASCLONE": "kun aloitan kloonina",
    "CONTROL_CREATECLONEOF": "luo klooni hahmosta %1",
    "CONTROL_CREATECLONEOF_MYSELF": "minä itse",
    "CONTROL_DELETETHISCLONE": "poista tämä klooni",
    "CONTROL_COUNTER": "laskuri",
    "CONTROL_INCRCOUNTER": "lisäyslaskuri",
    "CONTROL_CLEARCOUNTER": "nollaa laskuri",
    "CONTROL_ALLATONCE": "kaikki kerralla",
    "DATA_SETVARIABLETO": "aseta %1 arvoon %2",
    "DATA_CHANGEVARIABLEBY": "lisää muuttujaan %1 arvo %2",
    "DATA_SHOWVARIABLE": "näytä muuttuja %1",
    "DATA_HIDEVARIABLE": "piilota muuttuja %1",
    "DATA_ADDTOLIST": "lisää %1 listaan %2",
    "DATA_DELETEOFLIST": "poista %1 listasta %2",
    "DATA_DELETEALLOFLIST": "poista kaikki listasta %1",
    "DATA_INSERTATLIST": "lisää %1 kohtaan %2 listassa %3",
    "DATA_REPLACEITEMOFLIST": "korvaa listan %2 kohdan %1 arvo arvolla %3",
    "DATA_ITEMOFLIST": "listan %2 %1. kohde",
    "DATA_ITEMNUMOFLIST": "kohteen %1 numero listassa %2",
    "DATA_LENGTHOFLIST": "listan %1 pituus",
    "DATA_LISTCONTAINSITEM": "%1 sisältää %2?",
    "DATA_SHOWLIST": "näytä lista %1",
    "DATA_HIDELIST": "piilota lista %1",
    "DATA_INDEX_ALL": "kaikki",
    "DATA_INDEX_LAST": "viimeinen",
    "DATA_INDEX_RANDOM": "satunnainen",
    "EVENT_WHENFLAGCLICKED": "kun klikataan %1",
    "EVENT_WHENTHISSPRITECLICKED": "kun tätä hahmoa klikataan",
    "EVENT_WHENSTAGECLICKED": "kun esiintymislavaa klikataan",
    "EVENT_WHENTOUCHINGOBJECT": "kun tämä hahmo koskettaa %1",
    "EVENT_WHENBROADCASTRECEIVED": "kun vastaanotan %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "kun taustaksi vaihtuu %1",
    "EVENT_WHENGREATERTHAN": "kun %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "ajastin",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "äänentaso",
    "EVENT_BROADCAST": "lähetä %1",
    "EVENT_BROADCASTANDWAIT": "lähetä %1 ja odota",
    "EVENT_WHENKEYPRESSED": "kun painetaan %1",
    "EVENT_WHENKEYPRESSED_SPACE": "välilyönti",
    "EVENT_WHENKEYPRESSED_LEFT": "nuoli vasemmalle",
    "EVENT_WHENKEYPRESSED_RIGHT": "nuoli oikealle",
    "EVENT_WHENKEYPRESSED_DOWN": "nuoli alas",
    "EVENT_WHENKEYPRESSED_UP": "nuoli ylös",
    "EVENT_WHENKEYPRESSED_ANY": "mikä tahansa",
    "LOOKS_SAYFORSECS": "sano %1 %2 sekunnin ajan",
    "LOOKS_SAY": "sano %1",
    "LOOKS_HELLO": "Hei!",
    "LOOKS_THINKFORSECS": "ajattele %1 %2 sekunnin ajan",
    "LOOKS_THINK": "ajattele %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "näytä",
    "LOOKS_HIDE": "piilota",
    "LOOKS_HIDEALLSPRITES": "piilota kaikki hahmot",
    "LOOKS_EFFECT_COLOR": "väri",
    "LOOKS_EFFECT_FISHEYE": "kalansilmä",
    "LOOKS_EFFECT_WHIRL": "pyörre",
    "LOOKS_EFFECT_PIXELATE": "pikselöi",
    "LOOKS_EFFECT_MOSAIC": "mosaiikki",
    "LOOKS_EFFECT_BRIGHTNESS": "kirkkaus",
    "LOOKS_EFFECT_GHOST": "haamu",
    "LOOKS_CHANGEEFFECTBY": "lisää %1 tehostetta arvolla %2",
    "LOOKS_SETEFFECTTO": "aseta tehoste %1 arvoon %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "poista graafiset tehosteet",
    "LOOKS_CHANGESIZEBY": "kasvata kokoa arvolla %1",
    "LOOKS_SETSIZETO": "aseta koko arvoon %1 %",
    "LOOKS_SIZE": "koko",
    "LOOKS_CHANGESTRETCHBY": "lisää venytystä arvolla %1",
    "LOOKS_SETSTRETCHTO": "aseta venytys arvoon %1 %",
    "LOOKS_SWITCHCOSTUMETO": "vaihda asusteeksi %1",
    "LOOKS_NEXTCOSTUME": "seuraava asuste",
    "LOOKS_SWITCHBACKDROPTO": "vaihda taustaksi %1",
    "LOOKS_GOTOFRONTBACK": "mene %1 alalle",
    "LOOKS_GOTOFRONTBACK_FRONT": "etu",
    "LOOKS_GOTOFRONTBACK_BACK": "taka",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "mene %2 tasoa %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "eteenpäin",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "taaksepäin",
    "LOOKS_BACKDROPNUMBERNAME": "tausta %1",
    "LOOKS_COSTUMENUMBERNAME": "asuste %1",
    "LOOKS_NUMBERNAME_NUMBER": "luku",
    "LOOKS_NUMBERNAME_NAME": "nimi",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "vaihda taustaksi %1 ja odota",
    "LOOKS_NEXTBACKDROP_BLOCK": "seuraava tausta",
    "LOOKS_NEXTBACKDROP": "seuraava tausta",
    "LOOKS_PREVIOUSBACKDROP": "edellinen tausta",
    "LOOKS_RANDOMBACKDROP": "satunnainen tausta",
    "MOTION_MOVESTEPS": "liiku %1 askelta",
    "MOTION_TURNLEFT": "käänny %1 %2 astetta",
    "MOTION_TURNRIGHT": "käänny %1 %2 astetta",
    "MOTION_POINTINDIRECTION": "osoita suuntaan %1",
    "MOTION_POINTTOWARDS": "osoita kohti %1",
    "MOTION_POINTTOWARDS_POINTER": "hiiren osoitin",
    "MOTION_POINTTOWARDS_RANDOM": "satunnainen suunta",
    "MOTION_GOTO": "mene sijaintiin %1",
    "MOTION_GOTO_POINTER": "hiiren osoitin",
    "MOTION_GOTO_RANDOM": "satunnainen sijainti",
    "MOTION_GOTOXY": "mene sijaintiin x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "liu'u %1 sekuntia sijaintiin x: %2 y: %3",
    "MOTION_GLIDETO": "liu'u %1 sekuntia sijaintiin %2",
    "MOTION_GLIDETO_POINTER": "hiiren osoitin",
    "MOTION_GLIDETO_RANDOM": "satunnainen sijainti",
    "MOTION_CHANGEXBY": "lisää x:n arvoon %1",
    "MOTION_SETX": "aseta x:n arvoksi %1",
    "MOTION_CHANGEYBY": "lisää y:n arvoon %1",
    "MOTION_SETY": "aseta y:n arvoksi %1",
    "MOTION_IFONEDGEBOUNCE": "kimpoa reunasta",
    "MOTION_SETROTATIONSTYLE": "aseta kiertotyyliksi %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "vasen-oikea",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "älä kierrä",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "joka suuntaan",
    "MOTION_XPOSITION": "x-sijainti",
    "MOTION_YPOSITION": "y-sijainti",
    "MOTION_DIRECTION": "suunta",
    "MOTION_SCROLLRIGHT": "kierrä oikealle %1",
    "MOTION_SCROLLUP": "kierrä ylös %1",
    "MOTION_ALIGNSCENE": "tasaa näkymä %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "alavasen",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "alaoikea",
    "MOTION_ALIGNSCENE_MIDDLE": "keskikohta",
    "MOTION_ALIGNSCENE_TOPLEFT": "ylävasen",
    "MOTION_ALIGNSCENE_TOPRIGHT": "yläoikea",
    "MOTION_XSCROLL": "x-kierto",
    "MOTION_YSCROLL": "y-kierto",
    "MOTION_STAGE_SELECTED": "Esiintymislava valittu: ei liikelohkoja",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "valitse satunnaisluku väliltä %1 – %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 ja %2",
    "OPERATORS_OR": "%1 tai %2",
    "OPERATORS_NOT": "ei %1",
    "OPERATORS_JOIN": "yhdistä %1 ja %2",
    "OPERATORS_JOIN_APPLE": "omena",
    "OPERATORS_JOIN_BANANA": "banaani",
    "OPERATORS_LETTEROF": "%1. kirjain sanasta %2",
    "OPERATORS_LETTEROF_APPLE": "o",
    "OPERATORS_LENGTH": "sanan %1 pituus",
    "OPERATORS_CONTAINS": "%1 sisältää %2?",
    "OPERATORS_MOD": "lukujen %1 ja %2 jakojäännös",
    "OPERATORS_ROUND": "pyöristä %1",
    "OPERATORS_MATHOP": "%1 luvusta %2",
    "OPERATORS_MATHOP_ABS": "itseisarvo",
    "OPERATORS_MATHOP_FLOOR": "pyöristä alaspäin",
    "OPERATORS_MATHOP_CEILING": "pyöristä ylöspäin",
    "OPERATORS_MATHOP_SQRT": "neliöjuuri",
    "OPERATORS_MATHOP_SIN": "sini",
    "OPERATORS_MATHOP_COS": "kosini",
    "OPERATORS_MATHOP_TAN": "tangentti",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "luonnollinen logaritmi",
    "OPERATORS_MATHOP_LOG": "10-kantainen logaritmi",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "määrittele %1",
    "SENSING_TOUCHINGOBJECT": "koskettaako %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "hiiren osoitin",
    "SENSING_TOUCHINGOBJECT_EDGE": "reuna",
    "SENSING_TOUCHINGCOLOR": "koskettaako väriä %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "koskeeko väri %1 väriä %2?",
    "SENSING_DISTANCETO": "etäisyys kohteeseen %1",
    "SENSING_DISTANCETO_POINTER": "hiiren osoitin",
    "SENSING_ASKANDWAIT": "kysy %1 ja odota",
    "SENSING_ASK_TEXT": "Mikä on nimesi?",
    "SENSING_ANSWER": "vastaus",
    "SENSING_KEYPRESSED": "onko näppäin %1 painettu?",
    "SENSING_MOUSEDOWN": "onko hiiren nappi painettu?",
    "SENSING_MOUSEX": "hiiren x-sijainti",
    "SENSING_MOUSEY": "hiiren y-sijainti",
    "SENSING_SETDRAGMODE": "aseta raahaustilaksi %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "raahaus sallittu",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "raahaus ei sallittu",
    "SENSING_LOUDNESS": "äänentaso",
    "SENSING_LOUD": "kova äänentaso?",
    "SENSING_TIMER": "ajastin",
    "SENSING_RESETTIMER": "nollaa ajastin",
    "SENSING_OF": "kohteen %2 %1",
    "SENSING_OF_XPOSITION": "x-sijainti",
    "SENSING_OF_YPOSITION": "y-sijainti",
    "SENSING_OF_DIRECTION": "suunta",
    "SENSING_OF_COSTUMENUMBER": "asusteen numero",
    "SENSING_OF_COSTUMENAME": "asusteen nimi",
    "SENSING_OF_SIZE": "koko",
    "SENSING_OF_VOLUME": "äänenvoimakkuus",
    "SENSING_OF_BACKDROPNUMBER": "taustan numero",
    "SENSING_OF_BACKDROPNAME": "taustan nimi",
    "SENSING_OF_STAGE": "Esiintymislava",
    "SENSING_CURRENT": "nykyinen %1",
    "SENSING_CURRENT_YEAR": "vuosi",
    "SENSING_CURRENT_MONTH": "kuukausi",
    "SENSING_CURRENT_DATE": "päiväys",
    "SENSING_CURRENT_DAYOFWEEK": "viikonpäivä",
    "SENSING_CURRENT_HOUR": "tunti",
    "SENSING_CURRENT_MINUTE": "minuutti",
    "SENSING_CURRENT_SECOND": "sekunti",
    "SENSING_DAYSSINCE2000": "päiviä vuoden 2000 jälkeen",
    "SENSING_USERNAME": "käyttäjänimi",
    "SENSING_USERID": "käyttäjä-id",
    "SOUND_PLAY": "soita ääni %1",
    "SOUND_PLAYUNTILDONE": "soita ääni %1 loppuun",
    "SOUND_STOPALLSOUNDS": "pysäytä kaikki äänet",
    "SOUND_SETEFFECTO": "aseta tehoste %1 arvoon %2",
    "SOUND_CHANGEEFFECTBY": " lisää tehosteeseen %1 arvo %2",
    "SOUND_CLEAREFFECTS": "poista ääniefektit",
    "SOUND_EFFECTS_PITCH": "sävelkorkeus",
    "SOUND_EFFECTS_PAN": "panoroi vasen/oikea",
    "SOUND_CHANGEVOLUMEBY": "lisää äänenvoimakkuutta arvolla %1",
    "SOUND_SETVOLUMETO": "aseta äänenvoimakkuudeksi %1%",
    "SOUND_VOLUME": "äänenvoimakkuus",
    "SOUND_RECORD": "nauhoita...",
    "CATEGORY_MOTION": "Liike",
    "CATEGORY_LOOKS": "Ulkonäkö",
    "CATEGORY_SOUND": "Ääni",
    "CATEGORY_EVENTS": "Tapahtumat",
    "CATEGORY_CONTROL": "Ohjaus",
    "CATEGORY_SENSING": "Tuntoaisti",
    "CATEGORY_OPERATORS": "Toiminnot",
    "CATEGORY_VARIABLES": "Muuttujat",
    "CATEGORY_MYBLOCKS": "Lohkoni",
    "DUPLICATE": "Kopioi",
    "DELETE": "Poista",
    "ADD_COMMENT": "Lisää kommentti",
    "REMOVE_COMMENT": "Poista kommentti",
    "DELETE_BLOCK": "Poista lohko",
    "DELETE_X_BLOCKS": "Poista %1 lohkoa",
    "DELETE_ALL_BLOCKS": "Poistetaanko kaikki %1 lohkoa?",
    "CLEAN_UP": "Siivoa lohkot",
    "HELP": "Apua",
    "UNDO": "Kumoa",
    "REDO": "Tee uudelleen",
    "EDIT_PROCEDURE": "Muokkaa",
    "SHOW_PROCEDURE_DEFINITION": "Siirry määrittelyyn",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Sano jotakin...",
    "COLOUR_HUE_LABEL": "Väri",
    "COLOUR_SATURATION_LABEL": "Värikylläisyys",
    "COLOUR_BRIGHTNESS_LABEL": "Kirkkaus",
    "CHANGE_VALUE_TITLE": "Vaihda arvo:",
    "RENAME_VARIABLE": "Nimeä uudelleen muuttuja",
    "RENAME_VARIABLE_TITLE": "Nimeä uudelleen kaikki \"%1\" muuttujaa:",
    "RENAME_VARIABLE_MODAL_TITLE": "Nimeä uudelleen muuttuja",
    "NEW_VARIABLE": "Tee muuttuja",
    "NEW_VARIABLE_TITLE": "Uuden muuttujan nimi:",
    "VARIABLE_MODAL_TITLE": "Uusi muuttuja",
    "VARIABLE_ALREADY_EXISTS": "\"%1\"-niminen muuttuja on jo käytössä.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "\"%1\"-niminen muuttuja on jo käytössä toisella \"%2\"-tyyppisellä muuttujalla.",
    "DELETE_VARIABLE_CONFIRMATION": "Poistetaanko \"%2\"-muuttujan %1 käyttökohdetta?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Ei voitu poistaa \"%1\"-muuttujaa, koska se on osa \"%2\"-funktion määrittelyä",
    "DELETE_VARIABLE": "Poista \"%1\"-muuttuja",
    "NEW_PROCEDURE": "Tee lohko",
    "PROCEDURE_ALREADY_EXISTS": "\"%1\"-niminen aliohjelma on jo käytössä.",
    "PROCEDURE_DEFAULT_NAME": "lohkon nimi",
    "PROCEDURE_USED": "Poistaaksesi lohkon määrityksen, poista ensin kaikki missä tätä lohkoa käytetään",
    "NEW_LIST": "Tee lista",
    "NEW_LIST_TITLE": "Uuden listan nimi:",
    "LIST_MODAL_TITLE": "Uusi lista",
    "LIST_ALREADY_EXISTS": "\"%1\"-niminen lista on jo käytössä.",
    "RENAME_LIST_TITLE": "Nimeä uudelleen kaikki \"%1\" listaa:",
    "RENAME_LIST_MODAL_TITLE": "Nimeä uudelleen lista",
    "DEFAULT_LIST_ITEM": "asia",
    "DELETE_LIST": "Poista \"%1\"-lista",
    "RENAME_LIST": "Nimeä uudelleen lista",
    "NEW_BROADCAST_MESSAGE": "Uusi viesti",
    "NEW_BROADCAST_MESSAGE_TITLE": "Uuden viestin nimi:",
    "BROADCAST_MODAL_TITLE": "Uusi viesti",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "viesti1"
  },
  "sv": {
    "CONTROL_FOREVER": "för alltid",
    "CONTROL_REPEAT": "repetera %1",
    "CONTROL_IF": "om %1 då",
    "CONTROL_ELSE": "annars",
    "CONTROL_STOP": "stoppa",
    "CONTROL_STOP_ALL": "alla",
    "CONTROL_STOP_THIS": "detta skript",
    "CONTROL_STOP_OTHER": "andra skript i sprajten",
    "CONTROL_WAIT": "vänta %1 sekunder",
    "CONTROL_WAITUNTIL": "vänta tills %1",
    "CONTROL_REPEATUNTIL": "repetera tills %1",
    "CONTROL_WHILE": "medan %1",
    "CONTROL_FOREACH": "för varje %1 i %2",
    "CONTROL_STARTASCLONE": "när jag startar som klon",
    "CONTROL_CREATECLONEOF": "skapa klon av %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mig själv",
    "CONTROL_DELETETHISCLONE": "radera klonen",
    "CONTROL_COUNTER": "räknare",
    "CONTROL_INCRCOUNTER": "öka räknare",
    "CONTROL_CLEARCOUNTER": "nollställ räknare",
    "CONTROL_ALLATONCE": "alla samtidigt",
    "DATA_SETVARIABLETO": "sätt %1 till %2",
    "DATA_CHANGEVARIABLEBY": "ändra %1 med %2",
    "DATA_SHOWVARIABLE": "visa variabel %1",
    "DATA_HIDEVARIABLE": "göm variabel %1",
    "DATA_ADDTOLIST": "lägg till %1 i %2",
    "DATA_DELETEOFLIST": "ta bort %1 från %2",
    "DATA_DELETEALLOFLIST": "ta bort alla %1",
    "DATA_INSERTATLIST": "infoga %1 vid %2 i %3",
    "DATA_REPLACEITEMOFLIST": "ersätt posten %1 i %2 med %3",
    "DATA_ITEMOFLIST": "post %1 i %2",
    "DATA_ITEMNUMOFLIST": "post # av %1 i %2",
    "DATA_LENGTHOFLIST": "längden av %1",
    "DATA_LISTCONTAINSITEM": "%1 innehåller %2",
    "DATA_SHOWLIST": "visa listan %1",
    "DATA_HIDELIST": "göm listan %1",
    "DATA_INDEX_ALL": "alla",
    "DATA_INDEX_LAST": "sista",
    "DATA_INDEX_RANDOM": "slumpmässig",
    "EVENT_WHENFLAGCLICKED": "när %1 klickas på",
    "EVENT_WHENTHISSPRITECLICKED": "när denna sprajt klickas på",
    "EVENT_WHENSTAGECLICKED": "när scenen klickas på",
    "EVENT_WHENTOUCHINGOBJECT": "när denna sprajt rör %1",
    "EVENT_WHENBROADCASTRECEIVED": "när jag tar emot %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "när bakgrunden växlar till %1",
    "EVENT_WHENGREATERTHAN": "när %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "timer",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ljudstyrka",
    "EVENT_BROADCAST": "skicka %1",
    "EVENT_BROADCASTANDWAIT": "skicka %1 och vänta",
    "EVENT_WHENKEYPRESSED": "när tangenten %1 trycks ned",
    "EVENT_WHENKEYPRESSED_SPACE": "mellanslag",
    "EVENT_WHENKEYPRESSED_LEFT": "vänsterpil",
    "EVENT_WHENKEYPRESSED_RIGHT": "högerpil",
    "EVENT_WHENKEYPRESSED_DOWN": "nedåtpil",
    "EVENT_WHENKEYPRESSED_UP": "uppåtpil",
    "EVENT_WHENKEYPRESSED_ANY": "någon",
    "LOOKS_SAYFORSECS": "säg %1 i %2 sekunder",
    "LOOKS_SAY": "säg %1",
    "LOOKS_HELLO": "Hej!",
    "LOOKS_THINKFORSECS": "tänk %1 i %2 sekunder",
    "LOOKS_THINK": "tänk %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "visa",
    "LOOKS_HIDE": "göm",
    "LOOKS_HIDEALLSPRITES": "göm alla sprajtar",
    "LOOKS_EFFECT_COLOR": "färg ",
    "LOOKS_EFFECT_FISHEYE": "fisheye",
    "LOOKS_EFFECT_WHIRL": "virvel",
    "LOOKS_EFFECT_PIXELATE": "pixla",
    "LOOKS_EFFECT_MOSAIC": "mosaik",
    "LOOKS_EFFECT_BRIGHTNESS": "ljusstyrka",
    "LOOKS_EFFECT_GHOST": "genomskinlighet",
    "LOOKS_CHANGEEFFECTBY": "ändra %1 effekten med %2",
    "LOOKS_SETEFFECTTO": "sätt %1 effekten till %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "ta bort grafisk effekt",
    "LOOKS_CHANGESIZEBY": "ändra storlek med %1",
    "LOOKS_SETSIZETO": "sätt storleken till %1 %",
    "LOOKS_SIZE": "storlek",
    "LOOKS_CHANGESTRETCHBY": "ändra töjning med %1",
    "LOOKS_SETSTRETCHTO": "sätt töjning till %1 %",
    "LOOKS_SWITCHCOSTUMETO": "ändra klädsel till %1",
    "LOOKS_NEXTCOSTUME": "nästa klädsel",
    "LOOKS_SWITCHBACKDROPTO": "växla bakgrund till %1",
    "LOOKS_GOTOFRONTBACK": "gå till %1 lagret",
    "LOOKS_GOTOFRONTBACK_FRONT": "översta",
    "LOOKS_GOTOFRONTBACK_BACK": "tillbaka",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "gå %1 %2 lager",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "upp",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "ned",
    "LOOKS_BACKDROPNUMBERNAME": "bakgrund %1",
    "LOOKS_COSTUMENUMBERNAME": "klädsel %1",
    "LOOKS_NUMBERNAME_NUMBER": "nummer",
    "LOOKS_NUMBERNAME_NAME": "namn ",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "byt bakgrund till %1 och vänta",
    "LOOKS_NEXTBACKDROP_BLOCK": "nästa bakgrund",
    "LOOKS_NEXTBACKDROP": "nästa bakgrund",
    "LOOKS_PREVIOUSBACKDROP": "föregående bakgrund",
    "LOOKS_RANDOMBACKDROP": "slumpvis bakgrund",
    "MOTION_MOVESTEPS": "gå %1 steg",
    "MOTION_TURNLEFT": "rotera %1 %2 grader",
    "MOTION_TURNRIGHT": "rotera %1 %2 grader",
    "MOTION_POINTINDIRECTION": "peka i riktning %1",
    "MOTION_POINTTOWARDS": "peka mot %1",
    "MOTION_POINTTOWARDS_POINTER": "muspekare ",
    "MOTION_POINTTOWARDS_RANDOM": "slumpmässig riktning",
    "MOTION_GOTO": "gå till %1",
    "MOTION_GOTO_POINTER": "muspekare ",
    "MOTION_GOTO_RANDOM": "slumpmässig position",
    "MOTION_GOTOXY": "gå till x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glid %1 sek till x: %2 y: %3",
    "MOTION_GLIDETO": "glid %1 sekunder till %2",
    "MOTION_GLIDETO_POINTER": "muspekare ",
    "MOTION_GLIDETO_RANDOM": "slumpmässig position",
    "MOTION_CHANGEXBY": "ändra x med %1",
    "MOTION_SETX": "sätt x till %1",
    "MOTION_CHANGEYBY": "ändra y med %1",
    "MOTION_SETY": "sätt y till %1",
    "MOTION_IFONEDGEBOUNCE": "om vid kanten, studsa",
    "MOTION_SETROTATIONSTYLE": "sätt rotationsstil %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "vänster-höger",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "rotera inte",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "rotera",
    "MOTION_XPOSITION": "x position",
    "MOTION_YPOSITION": "y position",
    "MOTION_DIRECTION": "riktning",
    "MOTION_SCROLLRIGHT": "skrolla höger %1",
    "MOTION_SCROLLUP": "skrolla upp %1",
    "MOTION_ALIGNSCENE": "arrangera scen %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "nedre-vänster",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "nedre-höger",
    "MOTION_ALIGNSCENE_MIDDLE": "mitten",
    "MOTION_ALIGNSCENE_TOPLEFT": "övre-vänster",
    "MOTION_ALIGNSCENE_TOPRIGHT": "övre-höger",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "Scen vald: inga rörelseblock",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "slumptal %1 till %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 och %2",
    "OPERATORS_OR": "%1 eller %2",
    "OPERATORS_NOT": "inte %1",
    "OPERATORS_JOIN": "sammanfoga %1 %2",
    "OPERATORS_JOIN_APPLE": "äpple",
    "OPERATORS_JOIN_BANANA": "banan",
    "OPERATORS_LETTEROF": "bokstav %1 av %2",
    "OPERATORS_LETTEROF_APPLE": "ä",
    "OPERATORS_LENGTH": "längden av %1",
    "OPERATORS_CONTAINS": "%1 innehåller %2",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "avrunda %1",
    "OPERATORS_MATHOP": "%1 av %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "golv",
    "OPERATORS_MATHOP_CEILING": "tak",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definiera %1",
    "SENSING_TOUCHINGOBJECT": "rör vid %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "muspekare ",
    "SENSING_TOUCHINGOBJECT_EDGE": "kant",
    "SENSING_TOUCHINGCOLOR": "rör vid färgen %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "rör färgen %1 vid %2?",
    "SENSING_DISTANCETO": "avstånd till %1",
    "SENSING_DISTANCETO_POINTER": "muspekare ",
    "SENSING_ASKANDWAIT": "fråga %1 och vänta",
    "SENSING_ASK_TEXT": "Vad heter du?",
    "SENSING_ANSWER": "svar",
    "SENSING_KEYPRESSED": "tangent %1 nedtryckt?",
    "SENSING_MOUSEDOWN": "musknappen nedtryckt?",
    "SENSING_MOUSEX": "mus x",
    "SENSING_MOUSEY": "mus y",
    "SENSING_SETDRAGMODE": "sätt dragläge %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "dragbar",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "inte dragbar",
    "SENSING_LOUDNESS": "ljudstyrka",
    "SENSING_LOUD": "högt ljud?",
    "SENSING_TIMER": "timer",
    "SENSING_RESETTIMER": "nollställ timer",
    "SENSING_OF": "%1 av %2",
    "SENSING_OF_XPOSITION": "x position",
    "SENSING_OF_YPOSITION": "y position",
    "SENSING_OF_DIRECTION": "riktning",
    "SENSING_OF_COSTUMENUMBER": "klädselnummer",
    "SENSING_OF_COSTUMENAME": "klädselnamn",
    "SENSING_OF_SIZE": "storlek",
    "SENSING_OF_VOLUME": "volym ",
    "SENSING_OF_BACKDROPNUMBER": "bakgrundsnummer",
    "SENSING_OF_BACKDROPNAME": "bakgrundsnamn",
    "SENSING_OF_STAGE": "Scen",
    "SENSING_CURRENT": "aktuell %1",
    "SENSING_CURRENT_YEAR": "år ",
    "SENSING_CURRENT_MONTH": "månad ",
    "SENSING_CURRENT_DATE": "dag ",
    "SENSING_CURRENT_DAYOFWEEK": "veckodag ",
    "SENSING_CURRENT_HOUR": "timmar ",
    "SENSING_CURRENT_MINUTE": "minuter ",
    "SENSING_CURRENT_SECOND": "sekunder ",
    "SENSING_DAYSSINCE2000": "dagar sedan år 2000",
    "SENSING_USERNAME": "användarnamn ",
    "SENSING_USERID": "användarnamn",
    "SOUND_PLAY": "starta ljud %1",
    "SOUND_PLAYUNTILDONE": "spela ljudet %1 tills färdigt",
    "SOUND_STOPALLSOUNDS": "stoppa alla ljud",
    "SOUND_SETEFFECTO": "sätt %1 effekten till %2",
    "SOUND_CHANGEEFFECTBY": "ändra %1 effekten med %2",
    "SOUND_CLEAREFFECTS": "ta bort ljudeffekter",
    "SOUND_EFFECTS_PITCH": "tonhöjd",
    "SOUND_EFFECTS_PAN": "panorera vänster/höger",
    "SOUND_CHANGEVOLUMEBY": "ändra volymen med %1",
    "SOUND_SETVOLUMETO": "sätt volymen till %1%",
    "SOUND_VOLUME": "volym ",
    "SOUND_RECORD": "spela in...",
    "CATEGORY_MOTION": "Rörelse",
    "CATEGORY_LOOKS": "Utseende",
    "CATEGORY_SOUND": "Ljud",
    "CATEGORY_EVENTS": "Händelser",
    "CATEGORY_CONTROL": "Kontroll",
    "CATEGORY_SENSING": "Känna av",
    "CATEGORY_OPERATORS": "Operatorer",
    "CATEGORY_VARIABLES": "Variabler",
    "CATEGORY_MYBLOCKS": "Mina block",
    "DUPLICATE": "Kopiera",
    "DELETE": "Radera",
    "ADD_COMMENT": "Lägg till kommentar",
    "REMOVE_COMMENT": "Ta bort kommentar",
    "DELETE_BLOCK": "Ta bort block",
    "DELETE_X_BLOCKS": "Ta bort %1 block",
    "DELETE_ALL_BLOCKS": "Ta bort alla %1 block?",
    "CLEAN_UP": "Rensa block",
    "HELP": "Hjälp",
    "UNDO": "Ångra",
    "REDO": "Gör om",
    "EDIT_PROCEDURE": "Redigera",
    "SHOW_PROCEDURE_DEFINITION": "Gå till definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Säg något...",
    "COLOUR_HUE_LABEL": "Färg",
    "COLOUR_SATURATION_LABEL": "Mättnad",
    "COLOUR_BRIGHTNESS_LABEL": "Ljusstyrka",
    "CHANGE_VALUE_TITLE": "Ändra värde:",
    "RENAME_VARIABLE": "Döp om variabeln",
    "RENAME_VARIABLE_TITLE": "Döp om alla \"%1\" variabler till:",
    "RENAME_VARIABLE_MODAL_TITLE": "Döp om variabel",
    "NEW_VARIABLE": "Skapa en variabel",
    "NEW_VARIABLE_TITLE": "Nytt variabelnamn:",
    "VARIABLE_MODAL_TITLE": "Ny variabel",
    "VARIABLE_ALREADY_EXISTS": "En variabel \"%1\" finns redan.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "En variabel \"%1\" finns redan för en annan variabel av typ \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Ta bort %1 användningar av variabeln \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Kan inte ta bort variabel \"%1\" för att den är en del av definitionen av funktionen \"%2\"",
    "DELETE_VARIABLE": "Ta bort \"%1\" variabeln",
    "NEW_PROCEDURE": "Skapa ett Block",
    "PROCEDURE_ALREADY_EXISTS": "En funktion \"%1\" finns redan.",
    "PROCEDURE_DEFAULT_NAME": "blocknamn",
    "PROCEDURE_USED": "För att ta bort en blockdefinition, ta först bort all användning av blocket.",
    "NEW_LIST": "Skapa en lista",
    "NEW_LIST_TITLE": "Nytt listnamn:",
    "LIST_MODAL_TITLE": "Ny lista",
    "LIST_ALREADY_EXISTS": "En lista \"%1\" finns redan.",
    "RENAME_LIST_TITLE": "Döp om alla \"%1\" listor till:",
    "RENAME_LIST_MODAL_TITLE": "Döp om lista",
    "DEFAULT_LIST_ITEM": "grej",
    "DELETE_LIST": "Radera \"%1\" listan",
    "RENAME_LIST": "Döp om listan",
    "NEW_BROADCAST_MESSAGE": "Nytt meddelande",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nytt namn på meddelande:",
    "BROADCAST_MODAL_TITLE": "Nytt meddelande",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "meddelande1"
  },
  "vi": {
    "CONTROL_FOREVER": "liên tục",
    "CONTROL_REPEAT": "lặp lại %1",
    "CONTROL_IF": "nếu %1 thì",
    "CONTROL_ELSE": "nếu không thì ",
    "CONTROL_STOP": "dừng lại",
    "CONTROL_STOP_ALL": "tất cả",
    "CONTROL_STOP_THIS": "kịch bản này",
    "CONTROL_STOP_OTHER": "other scripts in sprite",
    "CONTROL_WAIT": "đợi %1 giây",
    "CONTROL_WAITUNTIL": "đợi đến khi %1",
    "CONTROL_REPEATUNTIL": "lặp lại cho đến khi %1",
    "CONTROL_WHILE": "trong khi %1",
    "CONTROL_FOREACH": "với mỗi %1 trong %2",
    "CONTROL_STARTASCLONE": "khi tôi bắt đầu là một bản sao",
    "CONTROL_CREATECLONEOF": "tạo bản sao của %1",
    "CONTROL_CREATECLONEOF_MYSELF": "bản thân tôi",
    "CONTROL_DELETETHISCLONE": "xóa bản sao này",
    "CONTROL_COUNTER": "bộ đếm",
    "CONTROL_INCRCOUNTER": "bộ đếm tăng dần",
    "CONTROL_CLEARCOUNTER": "xóa bộ đếm",
    "CONTROL_ALLATONCE": "tất cả cùng một lúc",
    "DATA_SETVARIABLETO": "đặt %1 thành %2",
    "DATA_CHANGEVARIABLEBY": "thay đổi %1 một lượng %2",
    "DATA_SHOWVARIABLE": "hiện biến số %1",
    "DATA_HIDEVARIABLE": "ẩn biến số %1",
    "DATA_ADDTOLIST": "thêm phần tử %1 vào trong %2",
    "DATA_DELETEOFLIST": "xóa phần tử thứ %1 của %2",
    "DATA_DELETEALLOFLIST": "Xóa hết tất cả trong liệt kê %1",
    "DATA_INSERTATLIST": "thêm phần tử %1 tại vị trí %2 của %3",
    "DATA_REPLACEITEMOFLIST": "thay thế phần tử thứ %1 của danh sách %2 bằng %3",
    "DATA_ITEMOFLIST": "phần tử thứ %1 của %2",
    "DATA_ITEMNUMOFLIST": "số thứ tự của %1 trong %2",
    "DATA_LENGTHOFLIST": "kích thước của %1",
    "DATA_LISTCONTAINSITEM": "%1 chứa phần tử %2?",
    "DATA_SHOWLIST": "hiện danh sách %1",
    "DATA_HIDELIST": "ẩn danh sách %1",
    "DATA_INDEX_ALL": "tất cả",
    "DATA_INDEX_LAST": "cuối cùng",
    "DATA_INDEX_RANDOM": "ngẫu nhiên",
    "EVENT_WHENFLAGCLICKED": "Khi bấm vào %1",
    "EVENT_WHENTHISSPRITECLICKED": "Khi bấm vào nhân vật này",
    "EVENT_WHENSTAGECLICKED": "khi bấm vào phông nền",
    "EVENT_WHENTOUCHINGOBJECT": "Khi nhân vật này chạm vào %1",
    "EVENT_WHENBROADCASTRECEIVED": "khi nhận %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "khi phông nền chuyển thành %1",
    "EVENT_WHENGREATERTHAN": "khi %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "đồng hồ bấm giờ",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "độ ồn",
    "EVENT_BROADCAST": "phát tin %1",
    "EVENT_BROADCASTANDWAIT": "phát tin %1 và đợi",
    "EVENT_WHENKEYPRESSED": "khi bấm phím %1",
    "EVENT_WHENKEYPRESSED_SPACE": "phím trắng",
    "EVENT_WHENKEYPRESSED_LEFT": "mũi tên trái",
    "EVENT_WHENKEYPRESSED_RIGHT": "mũi tên phải",
    "EVENT_WHENKEYPRESSED_DOWN": "mũi tên xuống",
    "EVENT_WHENKEYPRESSED_UP": "mũi tên lên",
    "EVENT_WHENKEYPRESSED_ANY": "bất kỳ",
    "LOOKS_SAYFORSECS": "nói %1 trong %2 giây",
    "LOOKS_SAY": "nói %1",
    "LOOKS_HELLO": "Xin chào!",
    "LOOKS_THINKFORSECS": "nghĩ %1 trong %2 giây",
    "LOOKS_THINK": "nghĩ %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "hiện",
    "LOOKS_HIDE": "ẩn",
    "LOOKS_HIDEALLSPRITES": "ẩn tất cả nhân vật",
    "LOOKS_EFFECT_COLOR": "màu",
    "LOOKS_EFFECT_FISHEYE": "gương cầu",
    "LOOKS_EFFECT_WHIRL": "xoay",
    "LOOKS_EFFECT_PIXELATE": "nhòe",
    "LOOKS_EFFECT_MOSAIC": "khảm",
    "LOOKS_EFFECT_BRIGHTNESS": "độ sáng",
    "LOOKS_EFFECT_GHOST": "bóng ma",
    "LOOKS_CHANGEEFFECTBY": "thay đổi hiệu ứng %1 một lượng %2",
    "LOOKS_SETEFFECTTO": "đặt hiệu ứng %1 bằng %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "bỏ các hiệu ứng đồ họa",
    "LOOKS_CHANGESIZEBY": "đổi kích thước một lượng %1",
    "LOOKS_SETSIZETO": "đặt kích thước thành %1 %",
    "LOOKS_SIZE": "kích thước",
    "LOOKS_CHANGESTRETCHBY": "đổi kéo căng một lượng %1",
    "LOOKS_SETSTRETCHTO": "đặt kéo căng thành %1 %",
    "LOOKS_SWITCHCOSTUMETO": "chuyển sang trang phục %1",
    "LOOKS_NEXTCOSTUME": "trang phục kế tiếp",
    "LOOKS_SWITCHBACKDROPTO": "đổi phông nền thành %1",
    "LOOKS_GOTOFRONTBACK": "đi tới lớp %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "phía trên cùng",
    "LOOKS_GOTOFRONTBACK_BACK": "phía sau cùng",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "đi %1 %2 lớp",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "tới",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "lùi",
    "LOOKS_BACKDROPNUMBERNAME": "phông nền %1",
    "LOOKS_COSTUMENUMBERNAME": "trang phục %1",
    "LOOKS_NUMBERNAME_NUMBER": "số",
    "LOOKS_NUMBERNAME_NAME": "tên",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "đổi phông nền thành %1 và đợi",
    "LOOKS_NEXTBACKDROP_BLOCK": "phông nền tiếp theo",
    "LOOKS_NEXTBACKDROP": "phông nền tiếp theo",
    "LOOKS_PREVIOUSBACKDROP": "phông nền trước",
    "LOOKS_RANDOMBACKDROP": "phông nền ngẫu nhiên",
    "MOTION_MOVESTEPS": "di chuyển %1 bước",
    "MOTION_TURNLEFT": "xoay %1 %2 độ",
    "MOTION_TURNRIGHT": "xoay %1 %2 độ",
    "MOTION_POINTINDIRECTION": "đặt hướng bằng %1",
    "MOTION_POINTTOWARDS": "hướng về phía đối tượng %1",
    "MOTION_POINTTOWARDS_POINTER": "con trỏ chuột",
    "MOTION_POINTTOWARDS_RANDOM": "hướng ngẫu nhiên",
    "MOTION_GOTO": "đi tới %1",
    "MOTION_GOTO_POINTER": "con trỏ chuột",
    "MOTION_GOTO_RANDOM": "vị trí ngẫu nhiên",
    "MOTION_GOTOXY": "đi tới điểm x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "lướt trong %1 giây tới điểm x: %2 y: %3",
    "MOTION_GLIDETO": "lướt trong %1 giây tới %2",
    "MOTION_GLIDETO_POINTER": "con trỏ chuột",
    "MOTION_GLIDETO_RANDOM": "vị trí ngẫu nhiên",
    "MOTION_CHANGEXBY": "thay đổi x một lượng %1",
    "MOTION_SETX": "đặt x bằng %1",
    "MOTION_CHANGEYBY": "thay đổi y một lượng%1",
    "MOTION_SETY": "đặt y bằng %1",
    "MOTION_IFONEDGEBOUNCE": "bật lại nếu chạm cạnh",
    "MOTION_SETROTATIONSTYLE": "đặt kiểu xoay %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "trái - phải",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "không xoay",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "xung quanh",
    "MOTION_XPOSITION": "tọa độ x",
    "MOTION_YPOSITION": "tọa độ y",
    "MOTION_DIRECTION": "hướng",
    "MOTION_SCROLLRIGHT": "cuộn phải %1",
    "MOTION_SCROLLUP": "cuộn lên %1",
    "MOTION_ALIGNSCENE": "căn chỉnh phân cảnh %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "góc trái dưới",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "góc phải dưới",
    "MOTION_ALIGNSCENE_MIDDLE": "giữa",
    "MOTION_ALIGNSCENE_TOPLEFT": "góc trái trên",
    "MOTION_ALIGNSCENE_TOPRIGHT": "góc phải trên",
    "MOTION_XSCROLL": "cuộn x",
    "MOTION_YSCROLL": "cuộn y",
    "MOTION_STAGE_SELECTED": "Đã chọn nền: không có khối lập trình chuyển động",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "lấy ngẫu nhiên từ %1 đến %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 và %2",
    "OPERATORS_OR": "%1 hoặc %2",
    "OPERATORS_NOT": "không phải %1",
    "OPERATORS_JOIN": "kết hợp %1 %2",
    "OPERATORS_JOIN_APPLE": "táo",
    "OPERATORS_JOIN_BANANA": "chuối",
    "OPERATORS_LETTEROF": "ký tự thứ %1 của chuỗi %2",
    "OPERATORS_LETTEROF_APPLE": "t",
    "OPERATORS_LENGTH": "độ dài của %1",
    "OPERATORS_CONTAINS": "%1 chứa ký tự %2?",
    "OPERATORS_MOD": "%1 chia lấy dư %2",
    "OPERATORS_ROUND": "làm tròn %1",
    "OPERATORS_MATHOP": "%1 của %2",
    "OPERATORS_MATHOP_ABS": "giá trị tuyệt đối",
    "OPERATORS_MATHOP_FLOOR": "làm tròn xuống",
    "OPERATORS_MATHOP_CEILING": "trần",
    "OPERATORS_MATHOP_SQRT": "căn bậc hai",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "trong",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "định nghĩa %1",
    "SENSING_TOUCHINGOBJECT": "đang chạm %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "con trỏ chuột",
    "SENSING_TOUCHINGOBJECT_EDGE": "cạnh",
    "SENSING_TOUCHINGCOLOR": "đang chạm màu %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "màu %1 đang chạm %2?",
    "SENSING_DISTANCETO": "khoảng cách đến %1",
    "SENSING_DISTANCETO_POINTER": "con trỏ chuột",
    "SENSING_ASKANDWAIT": "hỏi %1 và đợi",
    "SENSING_ASK_TEXT": "Tên của bạn là gì?",
    "SENSING_ANSWER": "trả lời",
    "SENSING_KEYPRESSED": "phím %1 được bấm?",
    "SENSING_MOUSEDOWN": "chuột được nhấn?",
    "SENSING_MOUSEX": "tọa độ x con trỏ chuột",
    "SENSING_MOUSEY": "tọa độ y con trỏ chuột",
    "SENSING_SETDRAGMODE": "đặt chế độ kéo %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "kéo thả được",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "không kéo thả được",
    "SENSING_LOUDNESS": "độ ồn",
    "SENSING_LOUD": "tiếng to?",
    "SENSING_TIMER": "đồng hồ bấm giờ",
    "SENSING_RESETTIMER": "đặt lại đống hồ bấm giờ",
    "SENSING_OF": "%1 của %2",
    "SENSING_OF_XPOSITION": "tọa độ x",
    "SENSING_OF_YPOSITION": "tọa độ y",
    "SENSING_OF_DIRECTION": "hướng",
    "SENSING_OF_COSTUMENUMBER": "trang phục #",
    "SENSING_OF_COSTUMENAME": "tên trang phục",
    "SENSING_OF_SIZE": "kích thước",
    "SENSING_OF_VOLUME": "âm lượng",
    "SENSING_OF_BACKDROPNUMBER": "phông nền #",
    "SENSING_OF_BACKDROPNAME": "tên phông nền",
    "SENSING_OF_STAGE": "Sân khấu",
    "SENSING_CURRENT": "%1 hiện tại",
    "SENSING_CURRENT_YEAR": "năm",
    "SENSING_CURRENT_MONTH": "tháng",
    "SENSING_CURRENT_DATE": "ngày",
    "SENSING_CURRENT_DAYOFWEEK": "ngày trong tuần",
    "SENSING_CURRENT_HOUR": "giờ",
    "SENSING_CURRENT_MINUTE": "phút",
    "SENSING_CURRENT_SECOND": "giây",
    "SENSING_DAYSSINCE2000": "số ngày từ năm 2000",
    "SENSING_USERNAME": "tên đăng nhập",
    "SENSING_USERID": "id người dùng",
    "SOUND_PLAY": "bắt đầu âm thanh %1",
    "SOUND_PLAYUNTILDONE": "phát âm thanh %1 đến hết",
    "SOUND_STOPALLSOUNDS": "ngừng mọi âm thanh",
    "SOUND_SETEFFECTO": "đặt hiệu ứng %1 bằng %2",
    "SOUND_CHANGEEFFECTBY": "thay đổi hiệu ứng %1 một lượng %2",
    "SOUND_CLEAREFFECTS": "xóa hiệu ứng âm thanh",
    "SOUND_EFFECTS_PITCH": "cao độ",
    "SOUND_EFFECTS_PAN": "pan trái/phải",
    "SOUND_CHANGEVOLUMEBY": "thay đổi âm lượng một lượng %1",
    "SOUND_SETVOLUMETO": "đặt âm lượng %1%",
    "SOUND_VOLUME": "âm lượng",
    "SOUND_RECORD": "lưu lại...",
    "CATEGORY_MOTION": "Chuyển động",
    "CATEGORY_LOOKS": "Hiển thị",
    "CATEGORY_SOUND": "Âm thanh",
    "CATEGORY_EVENTS": "Sự kiện",
    "CATEGORY_CONTROL": "Điều khiển",
    "CATEGORY_SENSING": "Cảm biến",
    "CATEGORY_OPERATORS": "Các phép toán",
    "CATEGORY_VARIABLES": "Các biến số",
    "CATEGORY_MYBLOCKS": "Khối của tôi",
    "DUPLICATE": "Nhân bản",
    "DELETE": "Xóa",
    "ADD_COMMENT": "Thêm chú thích",
    "REMOVE_COMMENT": "Xóa chú thích",
    "DELETE_BLOCK": "Xóa khối",
    "DELETE_X_BLOCKS": "Xóa %1 khối",
    "DELETE_ALL_BLOCKS": "Xóa toàn bộ %1 khối?",
    "CLEAN_UP": "Sắp xếp khối",
    "HELP": "Trợ giúp",
    "UNDO": "Hoàn tác",
    "REDO": "Làm lại ",
    "EDIT_PROCEDURE": "Chỉnh sửa",
    "SHOW_PROCEDURE_DEFINITION": "Tìm định nghĩa",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Nói gì đó...",
    "COLOUR_HUE_LABEL": "Màu sắc",
    "COLOUR_SATURATION_LABEL": "Độ bão hòa",
    "COLOUR_BRIGHTNESS_LABEL": "Độ sáng",
    "CHANGE_VALUE_TITLE": "Thay đổi giá trị:",
    "RENAME_VARIABLE": "Đặt tên cho biến",
    "RENAME_VARIABLE_TITLE": "Đặt tên tất cả biến \"%1\" thành:",
    "RENAME_VARIABLE_MODAL_TITLE": "Đặt tên biến",
    "NEW_VARIABLE": "Tạo một biến",
    "NEW_VARIABLE_TITLE": "Tên biến mới:",
    "VARIABLE_MODAL_TITLE": "Biến mới",
    "VARIABLE_ALREADY_EXISTS": "Một biến với tên\"%1\" đã tồn tại.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Một biến số tên là \"%1\" đã có ở trong một biến số khác tên \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "Xóa %1 cách dùng của biến số \"%2\"",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Không thể xóa biến số \"%1\" tại vì nó là một phần của chức vụ lập trình \"%2\"",
    "DELETE_VARIABLE": "Xóa biến \"%1\"",
    "NEW_PROCEDURE": "Tạo một khối",
    "PROCEDURE_ALREADY_EXISTS": "Một thủ tục có tên \"%1\" đã tồn tại.",
    "PROCEDURE_DEFAULT_NAME": "Tên khối",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Tạo một Danh sách",
    "NEW_LIST_TITLE": "Tên danh sách mới:",
    "LIST_MODAL_TITLE": "Danh sách mới",
    "LIST_ALREADY_EXISTS": "Một danh sách có tên \"%1\" đã tồn tại.",
    "RENAME_LIST_TITLE": "Đặt tên tất cả danh sách \"%1\" thành:",
    "RENAME_LIST_MODAL_TITLE": "Đặt tên danh sách",
    "DEFAULT_LIST_ITEM": "cụm",
    "DELETE_LIST": "Xóa danh sách \"%1\"",
    "RENAME_LIST": "Đổi tên danh sách",
    "NEW_BROADCAST_MESSAGE": "Thông báo mới",
    "NEW_BROADCAST_MESSAGE_TITLE": "Tên thông báo mới:",
    "BROADCAST_MODAL_TITLE": "Tin nhắn mới",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "tin nhắn 1"
  },
  "tr": {
    "CONTROL_FOREVER": "sürekli tekrarla",
    "CONTROL_REPEAT": "%1 defa tekrarla",
    "CONTROL_IF": "eğer %1 ise",
    "CONTROL_ELSE": "değilse",
    "CONTROL_STOP": "durdur",
    "CONTROL_STOP_ALL": "tümü",
    "CONTROL_STOP_THIS": "bu dizi",
    "CONTROL_STOP_OTHER": "kukladaki diğer dizileri",
    "CONTROL_WAIT": "%1 saniye bekle",
    "CONTROL_WAITUNTIL": "%1 olana kadar bekle",
    "CONTROL_REPEATUNTIL": "%1 olana kadar tekrarla",
    "CONTROL_WHILE": "%1 olduğu sürece tekrarla",
    "CONTROL_FOREACH": "%2 deki her %1 için",
    "CONTROL_STARTASCLONE": "ikiz olarak başladığımda",
    "CONTROL_CREATECLONEOF": "%1 in ikizini yarat",
    "CONTROL_CREATECLONEOF_MYSELF": "kendim",
    "CONTROL_DELETETHISCLONE": "bu ikizi sil",
    "CONTROL_COUNTER": "sayaç",
    "CONTROL_INCRCOUNTER": "sayacı artır",
    "CONTROL_CLEARCOUNTER": "sayacı sıfırla",
    "CONTROL_ALLATONCE": "tümü tek seferde",
    "DATA_SETVARIABLETO": "%1 değişkenini %2 yap",
    "DATA_CHANGEVARIABLEBY": "%1 i %2 kadar değiştir",
    "DATA_SHOWVARIABLE": "%1 değişkenini göster",
    "DATA_HIDEVARIABLE": "%1 değişkenini gizle",
    "DATA_ADDTOLIST": "%1 i %2 ye ekle",
    "DATA_DELETEOFLIST": "%2 in %1 ini sil",
    "DATA_DELETEALLOFLIST": "%1 in her şeyini sil",
    "DATA_INSERTATLIST": "%1 i %3 in %2 pozisyonuna ekle",
    "DATA_REPLACEITEMOFLIST": "%2 öğesinin %1 öğesini %3 ile değiştir",
    "DATA_ITEMOFLIST": "%2' in %1 öğesi",
    "DATA_ITEMNUMOFLIST": "%2 in %1 öğesinin # öğesi",
    "DATA_LENGTHOFLIST": "%1 in uzunluğu",
    "DATA_LISTCONTAINSITEM": "%1, %2 i içeriyor mu?",
    "DATA_SHOWLIST": "%1 listesini göster",
    "DATA_HIDELIST": "%1 listesini gizle",
    "DATA_INDEX_ALL": "tümü",
    "DATA_INDEX_LAST": "son",
    "DATA_INDEX_RANDOM": "rastgele",
    "EVENT_WHENFLAGCLICKED": "%1 e tıklandığında",
    "EVENT_WHENTHISSPRITECLICKED": "bu kuklaya tıklandığında",
    "EVENT_WHENSTAGECLICKED": "sahneye tıklandığında",
    "EVENT_WHENTOUCHINGOBJECT": "bu kukla %1 e dokunduğunda",
    "EVENT_WHENBROADCASTRECEIVED": "%1 haberini aldığımda",
    "EVENT_WHENBACKDROPSWITCHESTO": "dekor %1 olduğunda",
    "EVENT_WHENGREATERTHAN": "%1 > %2 olduğunda",
    "EVENT_WHENGREATERTHAN_TIMER": "zamanlayıcı",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "ses yüksekliği",
    "EVENT_BROADCAST": "%1 haberini sal",
    "EVENT_BROADCASTANDWAIT": "%1 haberini sal ve bekle",
    "EVENT_WHENKEYPRESSED": "%1 tuşuna basılınca",
    "EVENT_WHENKEYPRESSED_SPACE": "boşluk",
    "EVENT_WHENKEYPRESSED_LEFT": "sol ok",
    "EVENT_WHENKEYPRESSED_RIGHT": "sağ ok",
    "EVENT_WHENKEYPRESSED_DOWN": "aşağı ok",
    "EVENT_WHENKEYPRESSED_UP": "yukarı ok",
    "EVENT_WHENKEYPRESSED_ANY": "herhangi",
    "LOOKS_SAYFORSECS": "%2 saniye boyunca %1 de",
    "LOOKS_SAY": "%1 de",
    "LOOKS_HELLO": "Merhaba!",
    "LOOKS_THINKFORSECS": "%2 saniye boyunca %1 diye düşün",
    "LOOKS_THINK": "%1 diye düşün",
    "LOOKS_HMM": "Hımm...",
    "LOOKS_SHOW": "göster",
    "LOOKS_HIDE": "gizle",
    "LOOKS_HIDEALLSPRITES": "tüm kuklaları gizle",
    "LOOKS_EFFECT_COLOR": "renk",
    "LOOKS_EFFECT_FISHEYE": "balık gözü",
    "LOOKS_EFFECT_WHIRL": "girdap",
    "LOOKS_EFFECT_PIXELATE": "pikselleşme",
    "LOOKS_EFFECT_MOSAIC": "mozaik",
    "LOOKS_EFFECT_BRIGHTNESS": "parlaklık",
    "LOOKS_EFFECT_GHOST": "hayalet",
    "LOOKS_CHANGEEFFECTBY": "%1 etkisini %2 değiştir",
    "LOOKS_SETEFFECTTO": "%1 etkisini %2 yap",
    "LOOKS_CLEARGRAPHICEFFECTS": "görsel etkileri temizle",
    "LOOKS_CHANGESIZEBY": "boyutu %1 birim değiştir",
    "LOOKS_SETSIZETO": "boyutu % %1 yap",
    "LOOKS_SIZE": "büyüklük",
    "LOOKS_CHANGESTRETCHBY": "esnekliği %1 kadar değiştir",
    "LOOKS_SETSTRETCHTO": "esnekliği % %1 yap",
    "LOOKS_SWITCHCOSTUMETO": "%1 kılığına geç",
    "LOOKS_NEXTCOSTUME": "sonraki kostüm",
    "LOOKS_SWITCHBACKDROPTO": "%1 dekoruna geç",
    "LOOKS_GOTOFRONTBACK": "%1 katmanına git",
    "LOOKS_GOTOFRONTBACK_FRONT": "ön",
    "LOOKS_GOTOFRONTBACK_BACK": "arka",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%2 katman %1 git",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ileri",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "geri",
    "LOOKS_BACKDROPNUMBERNAME": "dekor %1",
    "LOOKS_COSTUMENUMBERNAME": "kostüm %1",
    "LOOKS_NUMBERNAME_NUMBER": "sayı",
    "LOOKS_NUMBERNAME_NAME": "isim",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "%1 dekoruna geç ve bekle",
    "LOOKS_NEXTBACKDROP_BLOCK": "sonraki dekor",
    "LOOKS_NEXTBACKDROP": "sonraki dekor",
    "LOOKS_PREVIOUSBACKDROP": "önceki dekor",
    "LOOKS_RANDOMBACKDROP": "rastgele dekor",
    "MOTION_MOVESTEPS": "%1 adım git",
    "MOTION_TURNLEFT": "%1 %2 derece dön",
    "MOTION_TURNRIGHT": "%1 %2 derece dön",
    "MOTION_POINTINDIRECTION": "%1 yönüne dön",
    "MOTION_POINTTOWARDS": "%1 e doğru yönel",
    "MOTION_POINTTOWARDS_POINTER": "fare-imleci",
    "MOTION_POINTTOWARDS_RANDOM": "rastgele yön",
    "MOTION_GOTO": "%1 e git",
    "MOTION_GOTO_POINTER": "fare-imleci",
    "MOTION_GOTO_RANDOM": "rastgele konum",
    "MOTION_GOTOXY": "x: %1 y: %2 konumuna git",
    "MOTION_GLIDESECSTOXY": "%1 saniyede x: %2 y: %3 konumuna git",
    "MOTION_GLIDETO": "%1 saniyede %2 git",
    "MOTION_GLIDETO_POINTER": "fare-imleci",
    "MOTION_GLIDETO_RANDOM": "rastgele konum",
    "MOTION_CHANGEXBY": "x konumunu %1 değiştir",
    "MOTION_SETX": "x konumunu %1 yap",
    "MOTION_CHANGEYBY": "y konumunu %1 değiştir",
    "MOTION_SETY": "y konumunu %1 yap",
    "MOTION_IFONEDGEBOUNCE": "kenara geldiyse sek",
    "MOTION_SETROTATIONSTYLE": "dönüş stilini %1 yap",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "sol-sağ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "dönmeyi kapat",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "tüm yönlere dönebilir",
    "MOTION_XPOSITION": "x konumu",
    "MOTION_YPOSITION": "y konumu",
    "MOTION_DIRECTION": "yön",
    "MOTION_SCROLLRIGHT": "sağa %1 kaydır",
    "MOTION_SCROLLUP": "%1 yukarı kaydır",
    "MOTION_ALIGNSCENE": "sahneyi %1 e hizala",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "sol-alt",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "sağ-alt",
    "MOTION_ALIGNSCENE_MIDDLE": "orta",
    "MOTION_ALIGNSCENE_TOPLEFT": "sol-üst",
    "MOTION_ALIGNSCENE_TOPRIGHT": "sağ-üst",
    "MOTION_XSCROLL": "x ekseninde kaydır",
    "MOTION_YSCROLL": "y ekseninde kaydır",
    "MOTION_STAGE_SELECTED": "Sahne seçildi: hareket bloğu yok",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 ile %2 arasında rastgele bir sayı seç",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 ve %2",
    "OPERATORS_OR": "%1 veya %2",
    "OPERATORS_NOT": "%1 değil",
    "OPERATORS_JOIN": "%1 i ve %2 ile birleştir",
    "OPERATORS_JOIN_APPLE": "elma",
    "OPERATORS_JOIN_BANANA": "muz",
    "OPERATORS_LETTEROF": "%2 in %1. harfi",
    "OPERATORS_LETTEROF_APPLE": "bir",
    "OPERATORS_LENGTH": "%1 in uzunluğu",
    "OPERATORS_CONTAINS": "%1, %2 i içeriyor mu?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "%1 i yuvarla",
    "OPERATORS_MATHOP": "%2 in %1 i",
    "OPERATORS_MATHOP_ABS": "mutlak değer",
    "OPERATORS_MATHOP_FLOOR": "aşağı yuvarla",
    "OPERATORS_MATHOP_CEILING": "yukarı yuvarla",
    "OPERATORS_MATHOP_SQRT": "karekök",
    "OPERATORS_MATHOP_SIN": "sinüs",
    "OPERATORS_MATHOP_COS": "kosinüs",
    "OPERATORS_MATHOP_TAN": "tanjant",
    "OPERATORS_MATHOP_ASIN": "arcsinüs",
    "OPERATORS_MATHOP_ACOS": "arckosinüs",
    "OPERATORS_MATHOP_ATAN": "arctanjant",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "logaritma",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "%1 i tanımla",
    "SENSING_TOUCHINGOBJECT": "%1 e değiyor mu?",
    "SENSING_TOUCHINGOBJECT_POINTER": "fare-imleci",
    "SENSING_TOUCHINGOBJECT_EDGE": "kenar",
    "SENSING_TOUCHINGCOLOR": "%1 rengine değiyor mu?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 rengi %2 rengine değiyor mu?",
    "SENSING_DISTANCETO": "%1 e mesafe",
    "SENSING_DISTANCETO_POINTER": "fare-imleci",
    "SENSING_ASKANDWAIT": "%1 diye sor ve bekle",
    "SENSING_ASK_TEXT": "Adın ne?",
    "SENSING_ANSWER": "yanıt",
    "SENSING_KEYPRESSED": "%1 tuşuna basıldı mı?",
    "SENSING_MOUSEDOWN": "fareye basılı mı?",
    "SENSING_MOUSEX": "farenin x i",
    "SENSING_MOUSEY": "farenin y si",
    "SENSING_SETDRAGMODE": "sürükleme modunu %1 yap",
    "SENSING_SETDRAGMODE_DRAGGABLE": "sürüklenebilir",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "sürüklenmez",
    "SENSING_LOUDNESS": "ses yüksekliği",
    "SENSING_LOUD": "gürültülü mü?",
    "SENSING_TIMER": "zamanlayıcı",
    "SENSING_RESETTIMER": "zamanlayıcıyı sıfırla",
    "SENSING_OF": "%2 in %1 i",
    "SENSING_OF_XPOSITION": "x konumu",
    "SENSING_OF_YPOSITION": "y konumu",
    "SENSING_OF_DIRECTION": "yön",
    "SENSING_OF_COSTUMENUMBER": "kostüm #",
    "SENSING_OF_COSTUMENAME": "kostüm ismi",
    "SENSING_OF_SIZE": "büyüklük",
    "SENSING_OF_VOLUME": "ses düzeyi",
    "SENSING_OF_BACKDROPNUMBER": "dekor #",
    "SENSING_OF_BACKDROPNAME": "dekorun adı",
    "SENSING_OF_STAGE": "Sahne",
    "SENSING_CURRENT": "şu anki %1",
    "SENSING_CURRENT_YEAR": "yıl",
    "SENSING_CURRENT_MONTH": "ay",
    "SENSING_CURRENT_DATE": "tarih",
    "SENSING_CURRENT_DAYOFWEEK": "haftanın günü",
    "SENSING_CURRENT_HOUR": "saat",
    "SENSING_CURRENT_MINUTE": "dakika",
    "SENSING_CURRENT_SECOND": "saniye",
    "SENSING_DAYSSINCE2000": "2000 yılından beri geçen gün",
    "SENSING_USERNAME": "kullanıcı adı",
    "SENSING_USERID": "kullanıcı kimliği",
    "SOUND_PLAY": "%1 sesini başlat",
    "SOUND_PLAYUNTILDONE": "%1 sesini bitene kadar çal",
    "SOUND_STOPALLSOUNDS": "tüm sesleri durdur",
    "SOUND_SETEFFECTO": "%1 etkisini %2 yap",
    "SOUND_CHANGEEFFECTBY": "%1 etkisini %2 değiştir",
    "SOUND_CLEAREFFECTS": "ses etkilerini temizle",
    "SOUND_EFFECTS_PITCH": "ses perdesi",
    "SOUND_EFFECTS_PAN": "sağa-sola kaydır",
    "SOUND_CHANGEVOLUMEBY": "ses düzeyini %1 değiştir",
    "SOUND_SETVOLUMETO": "ses düzeyini %1% yap",
    "SOUND_VOLUME": "ses düzeyi",
    "SOUND_RECORD": "kayıt...",
    "CATEGORY_MOTION": "Hareket",
    "CATEGORY_LOOKS": "Görünüm",
    "CATEGORY_SOUND": "Ses",
    "CATEGORY_EVENTS": "Olaylar",
    "CATEGORY_CONTROL": "Kontrol",
    "CATEGORY_SENSING": "Algılama",
    "CATEGORY_OPERATORS": "Operatörler",
    "CATEGORY_VARIABLES": "Değişkenler",
    "CATEGORY_MYBLOCKS": "Bloklarım",
    "DUPLICATE": "Çoğalt",
    "DELETE": "Sil",
    "ADD_COMMENT": "Yorum Ekle",
    "REMOVE_COMMENT": "Yorumu Sil",
    "DELETE_BLOCK": "Bloğu Sil",
    "DELETE_X_BLOCKS": "%1 Blok Sil",
    "DELETE_ALL_BLOCKS": "Tüm %1 blokları silinsin mi?",
    "CLEAN_UP": "Blokları temizle",
    "HELP": "Yardım",
    "UNDO": "Geri",
    "REDO": "İleri",
    "EDIT_PROCEDURE": "Düzenle",
    "SHOW_PROCEDURE_DEFINITION": "Tanımına git",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Bir şey söyle...",
    "COLOUR_HUE_LABEL": "Renk",
    "COLOUR_SATURATION_LABEL": "Doygunluk",
    "COLOUR_BRIGHTNESS_LABEL": "Parlaklık",
    "CHANGE_VALUE_TITLE": "Değeri değiştir:",
    "RENAME_VARIABLE": "Değişkeni yeniden adlandır",
    "RENAME_VARIABLE_TITLE": "Tüm \"%1\" değişkenlerinin ismini şu yap:",
    "RENAME_VARIABLE_MODAL_TITLE": "Değişkeni Yeniden Adlandır",
    "NEW_VARIABLE": "Bir Değişken Oluştur",
    "NEW_VARIABLE_TITLE": "Yeni değişken adı:",
    "VARIABLE_MODAL_TITLE": "Yeni Değişken",
    "VARIABLE_ALREADY_EXISTS": "\"%1\" adlı bir değişken zaten var.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "\"%2\" türünde başka bir değişken için \"%1\" adlı bir değişken zaten var.",
    "DELETE_VARIABLE_CONFIRMATION": "\"%2\" değişkeninin %1 kullanımı silinsin mi?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "\"%1\" değişkenini \"%2\" fonksiyonunun bir parçası olduğundan dolayı silinemez",
    "DELETE_VARIABLE": "\"%1\" değişkenini sil",
    "NEW_PROCEDURE": "Bir Blok Oluştur",
    "PROCEDURE_ALREADY_EXISTS": "\"%1\" adlı bir prosedür zaten var.",
    "PROCEDURE_DEFAULT_NAME": "blok adı",
    "PROCEDURE_USED": "Bir bloğun tanımını silmek için önce bloğun tüm kullanımlarını kaldırın.",
    "NEW_LIST": "Bir Liste Oluştur",
    "NEW_LIST_TITLE": "Yeni liste adı:",
    "LIST_MODAL_TITLE": "Yeni Liste",
    "LIST_ALREADY_EXISTS": "\"%1\" adlı bir liste zaten var.",
    "RENAME_LIST_TITLE": "Tüm \"%1\" listelerini şöyle adlandır:",
    "RENAME_LIST_MODAL_TITLE": "Listeyi Yeniden Adlandır",
    "DEFAULT_LIST_ITEM": "şey",
    "DELETE_LIST": "\"%1\" listesini sil",
    "RENAME_LIST": "Listeyi yeniden adlandır",
    "NEW_BROADCAST_MESSAGE": "Yeni haber",
    "NEW_BROADCAST_MESSAGE_TITLE": "Yeni haber adı:",
    "BROADCAST_MODAL_TITLE": "Yeni Haber",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "haber1"
  },
  "uk": {
    "CONTROL_FOREVER": "завжди",
    "CONTROL_REPEAT": "повторити %1",
    "CONTROL_IF": "якщо %1 то",
    "CONTROL_ELSE": "інакше",
    "CONTROL_STOP": "зупинити",
    "CONTROL_STOP_ALL": "все",
    "CONTROL_STOP_THIS": "цей скрипт",
    "CONTROL_STOP_OTHER": "інші скрипти цього спрайту",
    "CONTROL_WAIT": "чекати %1 секунд",
    "CONTROL_WAITUNTIL": "чекати поки %1",
    "CONTROL_REPEATUNTIL": "повторити до %1",
    "CONTROL_WHILE": "поки %1",
    "CONTROL_FOREACH": "для кожного %1 в %2",
    "CONTROL_STARTASCLONE": "коли я починаю як клон",
    "CONTROL_CREATECLONEOF": "створити клон з %1",
    "CONTROL_CREATECLONEOF_MYSELF": "мене",
    "CONTROL_DELETETHISCLONE": "вилучити цей клон",
    "CONTROL_COUNTER": "лічильник",
    "CONTROL_INCRCOUNTER": "збільшити лічильник",
    "CONTROL_CLEARCOUNTER": "очистити лічильник",
    "CONTROL_ALLATONCE": "всі одночасно",
    "DATA_SETVARIABLETO": "надати %1 значення %2",
    "DATA_CHANGEVARIABLEBY": "змінити %1 на %2",
    "DATA_SHOWVARIABLE": "показати змінну %1",
    "DATA_HIDEVARIABLE": "сховати змінну %1",
    "DATA_ADDTOLIST": "додати %1 до %2",
    "DATA_DELETEOFLIST": "вилучити %1 з %2",
    "DATA_DELETEALLOFLIST": "вилучити все з %1",
    "DATA_INSERTATLIST": "вставити %1 на місці %2 списку %3",
    "DATA_REPLACEITEMOFLIST": "замінити елемент %1 в %2 на %3",
    "DATA_ITEMOFLIST": "елемент %1 з %2",
    "DATA_ITEMNUMOFLIST": "елемент # %1 з %2",
    "DATA_LENGTHOFLIST": "довжина %1",
    "DATA_LISTCONTAINSITEM": "%1 містить %2?",
    "DATA_SHOWLIST": "показати список %1",
    "DATA_HIDELIST": "сховати список %1",
    "DATA_INDEX_ALL": "все",
    "DATA_INDEX_LAST": "останні",
    "DATA_INDEX_RANDOM": "випадково",
    "EVENT_WHENFLAGCLICKED": "коли %1 натиснуто",
    "EVENT_WHENTHISSPRITECLICKED": "коли спрайт натиснуто",
    "EVENT_WHENSTAGECLICKED": "коли сцену натиснуто",
    "EVENT_WHENTOUCHINGOBJECT": "коли цей спрайт торкнеться %1",
    "EVENT_WHENBROADCASTRECEIVED": "коли я отримую %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "коли тло зміниться на %1",
    "EVENT_WHENGREATERTHAN": "коли %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "таймер",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "гучність",
    "EVENT_BROADCAST": "оповістити %1",
    "EVENT_BROADCASTANDWAIT": "оповістити %1 і чекати",
    "EVENT_WHENKEYPRESSED": "коли клавішу %1 натиснуто ",
    "EVENT_WHENKEYPRESSED_SPACE": "пропуск",
    "EVENT_WHENKEYPRESSED_LEFT": "стрілка ліворуч",
    "EVENT_WHENKEYPRESSED_RIGHT": "стрілка праворуч",
    "EVENT_WHENKEYPRESSED_DOWN": "стрілка вниз",
    "EVENT_WHENKEYPRESSED_UP": "стрілка вгору",
    "EVENT_WHENKEYPRESSED_ANY": "будь-яка",
    "LOOKS_SAYFORSECS": "говорити %1 %2 сек",
    "LOOKS_SAY": "говорити %1",
    "LOOKS_HELLO": "Привіт!",
    "LOOKS_THINKFORSECS": "подумати %1 %2 сек",
    "LOOKS_THINK": "подумати %1",
    "LOOKS_HMM": "Хмм...",
    "LOOKS_SHOW": "показати",
    "LOOKS_HIDE": "сховати",
    "LOOKS_HIDEALLSPRITES": "сховати усі спрайти",
    "LOOKS_EFFECT_COLOR": "колір",
    "LOOKS_EFFECT_FISHEYE": "роздуття",
    "LOOKS_EFFECT_WHIRL": "закручування",
    "LOOKS_EFFECT_PIXELATE": "пікселями",
    "LOOKS_EFFECT_MOSAIC": "мозаїка",
    "LOOKS_EFFECT_BRIGHTNESS": "яскравість",
    "LOOKS_EFFECT_GHOST": "привид",
    "LOOKS_CHANGEEFFECTBY": "змінити ефект %1 на %2",
    "LOOKS_SETEFFECTTO": "встановити ефект %1 в %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "очистити графічні ефекти",
    "LOOKS_CHANGESIZEBY": "змінити розмір на %1",
    "LOOKS_SETSIZETO": "задати розмір %1",
    "LOOKS_SIZE": "розмір",
    "LOOKS_CHANGESTRETCHBY": "змінити розтяг на %1",
    "LOOKS_SETSTRETCHTO": "задати розтяг %1 %",
    "LOOKS_SWITCHCOSTUMETO": "змінити образ на %1",
    "LOOKS_NEXTCOSTUME": "наступний образ",
    "LOOKS_SWITCHBACKDROPTO": "змінити тло на %1",
    "LOOKS_GOTOFRONTBACK": "помістити на %1 план",
    "LOOKS_GOTOFRONTBACK_FRONT": "передній",
    "LOOKS_GOTOFRONTBACK_BACK": "задній",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "перемістити %1 на %2 шар",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "вперед",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "назад",
    "LOOKS_BACKDROPNUMBERNAME": "тло %1",
    "LOOKS_COSTUMENUMBERNAME": "образ %1",
    "LOOKS_NUMBERNAME_NUMBER": "номер",
    "LOOKS_NUMBERNAME_NAME": "назва",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "змінити тло на %1 та чекати",
    "LOOKS_NEXTBACKDROP_BLOCK": "наступне тло",
    "LOOKS_NEXTBACKDROP": "наступне тло",
    "LOOKS_PREVIOUSBACKDROP": "попереднє тло",
    "LOOKS_RANDOMBACKDROP": "випадкове тло",
    "MOTION_MOVESTEPS": "перемістити на %1 кроків",
    "MOTION_TURNLEFT": "поворот %1 на %2 градусів",
    "MOTION_TURNRIGHT": "поворот %1 на %2 градусів",
    "MOTION_POINTINDIRECTION": "повернути в напрямку %1",
    "MOTION_POINTTOWARDS": "слідувати за %1",
    "MOTION_POINTTOWARDS_POINTER": "вказівник",
    "MOTION_POINTTOWARDS_RANDOM": "випадковий напрям",
    "MOTION_GOTO": "перейти до %1",
    "MOTION_GOTO_POINTER": "вказівник",
    "MOTION_GOTO_RANDOM": "випадкова позиція",
    "MOTION_GOTOXY": "перемістити в x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "ковзати %1 сек до x: %2 y: %3",
    "MOTION_GLIDETO": "ковзати %1 сек до %2",
    "MOTION_GLIDETO_POINTER": "вказівник",
    "MOTION_GLIDETO_RANDOM": "випадкова позиція",
    "MOTION_CHANGEXBY": "змінити x на %1",
    "MOTION_SETX": "задати x %1",
    "MOTION_CHANGEYBY": "змінити y на %1",
    "MOTION_SETY": "задати y %1",
    "MOTION_IFONEDGEBOUNCE": "якщо на межі, відбити",
    "MOTION_SETROTATIONSTYLE": "стиль обертання %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "зліва-направо",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "не обертати",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "навколо",
    "MOTION_XPOSITION": "значення x",
    "MOTION_YPOSITION": "значення y",
    "MOTION_DIRECTION": "напрям",
    "MOTION_SCROLLRIGHT": "прокрутити праворуч %1",
    "MOTION_SCROLLUP": "прокрутити вгору %1",
    "MOTION_ALIGNSCENE": "вирівняти сцену %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "внизу-ліворуч",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "вниз-праворуч",
    "MOTION_ALIGNSCENE_MIDDLE": "посередині",
    "MOTION_ALIGNSCENE_TOPLEFT": "зверху-ліворуч",
    "MOTION_ALIGNSCENE_TOPRIGHT": "зверху-праворуч",
    "MOTION_XSCROLL": "x прокрутка",
    "MOTION_YSCROLL": "y прокрутка",
    "MOTION_STAGE_SELECTED": "Обрано Сцену: немає блоків руху",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "випадкове від %1 до %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 і %2",
    "OPERATORS_OR": "%1 або %2",
    "OPERATORS_NOT": "не %1",
    "OPERATORS_JOIN": "з'єднати %1 %2",
    "OPERATORS_JOIN_APPLE": "яблуко",
    "OPERATORS_JOIN_BANANA": "банан",
    "OPERATORS_LETTEROF": "символ %1 у %2",
    "OPERATORS_LETTEROF_APPLE": "я",
    "OPERATORS_LENGTH": "довжина %1",
    "OPERATORS_CONTAINS": "%1 містить %2?",
    "OPERATORS_MOD": "остача %1 на %2",
    "OPERATORS_ROUND": "округлити %1",
    "OPERATORS_MATHOP": "%1 з %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "менше ціле",
    "OPERATORS_MATHOP_CEILING": "більше ціле",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "визначити %1",
    "SENSING_TOUCHINGOBJECT": "торкається %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "вказівник",
    "SENSING_TOUCHINGOBJECT_EDGE": "межа",
    "SENSING_TOUCHINGCOLOR": "торкається кольору %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "колір %1 торкається %2?",
    "SENSING_DISTANCETO": "відстань до %1",
    "SENSING_DISTANCETO_POINTER": "вказівник",
    "SENSING_ASKANDWAIT": "запитати %1 і чекати",
    "SENSING_ASK_TEXT": "Як вас звати?",
    "SENSING_ANSWER": "відповідь",
    "SENSING_KEYPRESSED": "клавішу %1 натиснуто?",
    "SENSING_MOUSEDOWN": "мишку натиснуто?",
    "SENSING_MOUSEX": "мишка x",
    "SENSING_MOUSEY": "мишка y",
    "SENSING_SETDRAGMODE": "перетягувати %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "дозволено",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "не дозволено",
    "SENSING_LOUDNESS": "гучність",
    "SENSING_LOUD": "гучно?",
    "SENSING_TIMER": "таймер",
    "SENSING_RESETTIMER": "перезапустити таймер",
    "SENSING_OF": "%1 з %2",
    "SENSING_OF_XPOSITION": "значення x",
    "SENSING_OF_YPOSITION": "значення y",
    "SENSING_OF_DIRECTION": "напрям",
    "SENSING_OF_COSTUMENUMBER": "образ #",
    "SENSING_OF_COSTUMENAME": "ім’я образу",
    "SENSING_OF_SIZE": "розмір",
    "SENSING_OF_VOLUME": "гучність",
    "SENSING_OF_BACKDROPNUMBER": "тло #",
    "SENSING_OF_BACKDROPNAME": "ім’я тла",
    "SENSING_OF_STAGE": "Сцена",
    "SENSING_CURRENT": "сьогодні %1",
    "SENSING_CURRENT_YEAR": "рік",
    "SENSING_CURRENT_MONTH": "місяць",
    "SENSING_CURRENT_DATE": "дата",
    "SENSING_CURRENT_DAYOFWEEK": "день тижня",
    "SENSING_CURRENT_HOUR": "година",
    "SENSING_CURRENT_MINUTE": "хвилина ",
    "SENSING_CURRENT_SECOND": "секунда",
    "SENSING_DAYSSINCE2000": "днів після 2000",
    "SENSING_USERNAME": "користувач",
    "SENSING_USERID": "користувач ID",
    "SOUND_PLAY": "відтворити звук %1",
    "SOUND_PLAYUNTILDONE": "відтворити звук %1 до кінця",
    "SOUND_STOPALLSOUNDS": "зупинити всі звуки",
    "SOUND_SETEFFECTO": "встановити ефект %1 в %2",
    "SOUND_CHANGEEFFECTBY": "змінити ефект %1 на %2",
    "SOUND_CLEAREFFECTS": "очистити звукові ефекти",
    "SOUND_EFFECTS_PITCH": "висота",
    "SOUND_EFFECTS_PAN": "панорама",
    "SOUND_CHANGEVOLUMEBY": "змінити гучність на %1",
    "SOUND_SETVOLUMETO": "встановити гучність %1%",
    "SOUND_VOLUME": "гучність",
    "SOUND_RECORD": "запис...",
    "CATEGORY_MOTION": "Рух",
    "CATEGORY_LOOKS": "Вигляд",
    "CATEGORY_SOUND": "Звук",
    "CATEGORY_EVENTS": "Події",
    "CATEGORY_CONTROL": "Керування",
    "CATEGORY_SENSING": "Датчики",
    "CATEGORY_OPERATORS": "Оператори",
    "CATEGORY_VARIABLES": "Змінні",
    "CATEGORY_MYBLOCKS": "Мої блоки",
    "DUPLICATE": "Дублювати",
    "DELETE": "Вилучити",
    "ADD_COMMENT": "Додати коментар",
    "REMOVE_COMMENT": "Вилучити коментар",
    "DELETE_BLOCK": "Вилучити блок",
    "DELETE_X_BLOCKS": "Вилучити %1 блоки",
    "DELETE_ALL_BLOCKS": "Вилучити всі %1 блоки?",
    "CLEAN_UP": "Впорядкувати блоки",
    "HELP": "Допомога",
    "UNDO": "Скасувати",
    "REDO": "Повернути",
    "EDIT_PROCEDURE": "Правка",
    "SHOW_PROCEDURE_DEFINITION": "Перейти до визначення",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Скажіть щось...",
    "COLOUR_HUE_LABEL": "Колір",
    "COLOUR_SATURATION_LABEL": "Насиченість",
    "COLOUR_BRIGHTNESS_LABEL": "Яскравість",
    "CHANGE_VALUE_TITLE": "Змінити значення:",
    "RENAME_VARIABLE": "Перейменувати змінну",
    "RENAME_VARIABLE_TITLE": "Перейменувати усі \"%1\" змінні на:",
    "RENAME_VARIABLE_MODAL_TITLE": "Перейменувати змінну",
    "NEW_VARIABLE": "Створити змінну",
    "NEW_VARIABLE_TITLE": "Нове ім'я змінної:",
    "VARIABLE_MODAL_TITLE": "Нова змінна",
    "VARIABLE_ALREADY_EXISTS": "Змінна з іменем \"%1\" вже існує.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Ім'я змінної \"%1\" вже використано для змінної з типом \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Вилучити %1 використання змінної \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Не можна вилучити змінну \"%1\" оскільки вона визначена у функції \"%2\"",
    "DELETE_VARIABLE": "Вилучити змінну '%1'",
    "NEW_PROCEDURE": "Створити блок",
    "PROCEDURE_ALREADY_EXISTS": "Процедура з іменем '%1' вже існує",
    "PROCEDURE_DEFAULT_NAME": "назва блоку",
    "PROCEDURE_USED": "Щоб видалити цей блок, спочатку видаліть усі його використання",
    "NEW_LIST": "Створити список",
    "NEW_LIST_TITLE": "Нове ім’я списку:",
    "LIST_MODAL_TITLE": "Новий список",
    "LIST_ALREADY_EXISTS": "Список з іменем '%1' вже існує",
    "RENAME_LIST_TITLE": "Перейменувати усі списки \"%1\" на:",
    "RENAME_LIST_MODAL_TITLE": "Перейменувати список",
    "DEFAULT_LIST_ITEM": "щось",
    "DELETE_LIST": "Вилучити список \"%1\"",
    "RENAME_LIST": "Перейменувати список",
    "NEW_BROADCAST_MESSAGE": "Нове повідомлення",
    "NEW_BROADCAST_MESSAGE_TITLE": "Нове ім’я повідомлення:",
    "BROADCAST_MODAL_TITLE": "Нове повідомлення",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "повідомлення1"
  },
  "zh-cn": {
    "CONTROL_FOREVER": "重复执行",
    "CONTROL_REPEAT": "重复执行 %1 次",
    "CONTROL_IF": "如果 %1 那么",
    "CONTROL_ELSE": "否则",
    "CONTROL_STOP": "停止",
    "CONTROL_STOP_ALL": "全部脚本",
    "CONTROL_STOP_THIS": "这个脚本",
    "CONTROL_STOP_OTHER": "该角色的其他脚本",
    "CONTROL_WAIT": "等待 %1 秒",
    "CONTROL_WAITUNTIL": "等待 %1",
    "CONTROL_REPEATUNTIL": "重复执行直到 %1",
    "CONTROL_WHILE": "当 %1 重复执行",
    "CONTROL_FOREACH": "对于 %2 中的每个 %1",
    "CONTROL_STARTASCLONE": "当作为克隆体启动时",
    "CONTROL_CREATECLONEOF": "克隆 %1",
    "CONTROL_CREATECLONEOF_MYSELF": "自己",
    "CONTROL_DELETETHISCLONE": "删除此克隆体",
    "CONTROL_COUNTER": "计数器",
    "CONTROL_INCRCOUNTER": "计数器加一",
    "CONTROL_CLEARCOUNTER": "计数器归零",
    "CONTROL_ALLATONCE": "所有脚本",
    "DATA_SETVARIABLETO": "将 %1 设为 %2",
    "DATA_CHANGEVARIABLEBY": "将 %1 增加 %2",
    "DATA_SHOWVARIABLE": "显示变量 %1",
    "DATA_HIDEVARIABLE": "隐藏变量 %1",
    "DATA_ADDTOLIST": "将 %1 加入 %2",
    "DATA_DELETEOFLIST": "删除 %2 的第 %1 项",
    "DATA_DELETEALLOFLIST": "删除 %1 的全部项目",
    "DATA_INSERTATLIST": "在 %3 的第 %2 项前插入 %1",
    "DATA_REPLACEITEMOFLIST": "将 %2 的第 %1 项替换为 %3",
    "DATA_ITEMOFLIST": "%2 的第 %1 项",
    "DATA_ITEMNUMOFLIST": "%2 中第一个 %1 的编号",
    "DATA_LENGTHOFLIST": "%1 的项目数",
    "DATA_LISTCONTAINSITEM": "%1 包含 %2 ?",
    "DATA_SHOWLIST": "显示列表 %1",
    "DATA_HIDELIST": "隐藏列表 %1",
    "DATA_INDEX_ALL": "全部",
    "DATA_INDEX_LAST": "末尾",
    "DATA_INDEX_RANDOM": "随机",
    "EVENT_WHENFLAGCLICKED": "当 %1 被点击",
    "EVENT_WHENTHISSPRITECLICKED": "当角色被点击",
    "EVENT_WHENSTAGECLICKED": "当舞台被点击",
    "EVENT_WHENTOUCHINGOBJECT": "当该角色碰到 %1",
    "EVENT_WHENBROADCASTRECEIVED": "当接收到 %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "当背景换成 %1",
    "EVENT_WHENGREATERTHAN": "当 %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "计时器",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "响度",
    "EVENT_BROADCAST": "广播 %1",
    "EVENT_BROADCASTANDWAIT": "广播 %1 并等待",
    "EVENT_WHENKEYPRESSED": "当按下 %1 键",
    "EVENT_WHENKEYPRESSED_SPACE": "空格",
    "EVENT_WHENKEYPRESSED_LEFT": "←",
    "EVENT_WHENKEYPRESSED_RIGHT": "→",
    "EVENT_WHENKEYPRESSED_DOWN": "↓",
    "EVENT_WHENKEYPRESSED_UP": "↑",
    "EVENT_WHENKEYPRESSED_ANY": "任意",
    "LOOKS_SAYFORSECS": "说 %1 %2 秒",
    "LOOKS_SAY": "说 %1",
    "LOOKS_HELLO": "你好！",
    "LOOKS_THINKFORSECS": "思考 %1 %2 秒",
    "LOOKS_THINK": "思考 %1",
    "LOOKS_HMM": "嗯……",
    "LOOKS_SHOW": "显示",
    "LOOKS_HIDE": "隐藏",
    "LOOKS_HIDEALLSPRITES": "隐藏所有角色",
    "LOOKS_EFFECT_COLOR": "颜色",
    "LOOKS_EFFECT_FISHEYE": "鱼眼",
    "LOOKS_EFFECT_WHIRL": "漩涡",
    "LOOKS_EFFECT_PIXELATE": "像素化",
    "LOOKS_EFFECT_MOSAIC": "马赛克",
    "LOOKS_EFFECT_BRIGHTNESS": "亮度",
    "LOOKS_EFFECT_GHOST": "虚像",
    "LOOKS_CHANGEEFFECTBY": "将 %1 特效增加 %2",
    "LOOKS_SETEFFECTTO": "将 %1 特效设定为 %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "清除图形特效",
    "LOOKS_CHANGESIZEBY": "将大小增加 %1",
    "LOOKS_SETSIZETO": "将大小设为 %1",
    "LOOKS_SIZE": "大小",
    "LOOKS_CHANGESTRETCHBY": "伸缩%1",
    "LOOKS_SETSTRETCHTO": "设置伸缩为%1 %",
    "LOOKS_SWITCHCOSTUMETO": "换成 %1 造型",
    "LOOKS_NEXTCOSTUME": "下一个造型",
    "LOOKS_SWITCHBACKDROPTO": "换成 %1 背景",
    "LOOKS_GOTOFRONTBACK": "移到最 %1 ",
    "LOOKS_GOTOFRONTBACK_FRONT": "前面",
    "LOOKS_GOTOFRONTBACK_BACK": "后面",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 层",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "前移",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "后移",
    "LOOKS_BACKDROPNUMBERNAME": "背景 %1",
    "LOOKS_COSTUMENUMBERNAME": "造型 %1",
    "LOOKS_NUMBERNAME_NUMBER": "编号",
    "LOOKS_NUMBERNAME_NAME": "名称",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "换成 %1 背景并等待",
    "LOOKS_NEXTBACKDROP_BLOCK": "下一个背景",
    "LOOKS_NEXTBACKDROP": "下一个背景",
    "LOOKS_PREVIOUSBACKDROP": "上一个背景",
    "LOOKS_RANDOMBACKDROP": "随机背景",
    "MOTION_MOVESTEPS": "移动 %1 步",
    "MOTION_TURNLEFT": "左转 %1 %2 度",
    "MOTION_TURNRIGHT": "右转 %1 %2 度",
    "MOTION_POINTINDIRECTION": "面向 %1 方向",
    "MOTION_POINTTOWARDS": "面向 %1",
    "MOTION_POINTTOWARDS_POINTER": "鼠标指针",
    "MOTION_POINTTOWARDS_RANDOM": "随机方向",
    "MOTION_GOTO": "移到 %1",
    "MOTION_GOTO_POINTER": "鼠标指针",
    "MOTION_GOTO_RANDOM": "随机位置",
    "MOTION_GOTOXY": "移到 x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "在 %1 秒内滑行到 x: %2 y: %3",
    "MOTION_GLIDETO": "在 %1 秒内滑行到 %2",
    "MOTION_GLIDETO_POINTER": "鼠标指针",
    "MOTION_GLIDETO_RANDOM": "随机位置",
    "MOTION_CHANGEXBY": "将x坐标增加 %1",
    "MOTION_SETX": "将x坐标设为 %1",
    "MOTION_CHANGEYBY": "将y坐标增加 %1",
    "MOTION_SETY": "将y坐标设为 %1",
    "MOTION_IFONEDGEBOUNCE": "碰到边缘就反弹",
    "MOTION_SETROTATIONSTYLE": "将旋转方式设为 %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "左右翻转",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "不可旋转",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "任意旋转",
    "MOTION_XPOSITION": "x 坐标",
    "MOTION_YPOSITION": "y 坐标",
    "MOTION_DIRECTION": "方向",
    "MOTION_SCROLLRIGHT": "向右滚动 %1",
    "MOTION_SCROLLUP": "向上滚动 %1",
    "MOTION_ALIGNSCENE": "和场景 %1 对齐",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "左下角",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "右下角",
    "MOTION_ALIGNSCENE_MIDDLE": "中间",
    "MOTION_ALIGNSCENE_TOPLEFT": "左上角",
    "MOTION_ALIGNSCENE_TOPRIGHT": "右上角",
    "MOTION_XSCROLL": "x滚动位置",
    "MOTION_YSCROLL": "y滚动位置",
    "MOTION_STAGE_SELECTED": "选中了舞台：不可使用运动类积木",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "在 %1 和 %2 之间取随机数",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 与 %2",
    "OPERATORS_OR": "%1 或 %2",
    "OPERATORS_NOT": "%1 不成立",
    "OPERATORS_JOIN": "连接 %1 和 %2",
    "OPERATORS_JOIN_APPLE": "苹果",
    "OPERATORS_JOIN_BANANA": "香蕉",
    "OPERATORS_LETTEROF": "%2 的第 %1 个字符",
    "OPERATORS_LETTEROF_APPLE": "果",
    "OPERATORS_LENGTH": "%1 的字符数",
    "OPERATORS_CONTAINS": "%1 包含 %2 ?",
    "OPERATORS_MOD": "%1 除以 %2 的余数",
    "OPERATORS_ROUND": "四舍五入 %1",
    "OPERATORS_MATHOP": "%1 %2",
    "OPERATORS_MATHOP_ABS": "绝对值",
    "OPERATORS_MATHOP_FLOOR": "向下取整",
    "OPERATORS_MATHOP_CEILING": "向上取整",
    "OPERATORS_MATHOP_SQRT": "平方根",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "定义 %1",
    "SENSING_TOUCHINGOBJECT": "碰到 %1 ?",
    "SENSING_TOUCHINGOBJECT_POINTER": "鼠标指针",
    "SENSING_TOUCHINGOBJECT_EDGE": "舞台边缘",
    "SENSING_TOUCHINGCOLOR": "碰到颜色 %1 ?",
    "SENSING_COLORISTOUCHINGCOLOR": "颜色 %1 碰到 %2 ?",
    "SENSING_DISTANCETO": "到 %1 的距离",
    "SENSING_DISTANCETO_POINTER": "鼠标指针",
    "SENSING_ASKANDWAIT": "询问 %1 并等待",
    "SENSING_ASK_TEXT": "你叫什么名字？",
    "SENSING_ANSWER": "回答",
    "SENSING_KEYPRESSED": "按下 %1 键?",
    "SENSING_MOUSEDOWN": "按下鼠标?",
    "SENSING_MOUSEX": "鼠标的x坐标",
    "SENSING_MOUSEY": "鼠标的y坐标",
    "SENSING_SETDRAGMODE": "将拖动模式设为 %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "可拖动",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "不可拖动",
    "SENSING_LOUDNESS": "响度",
    "SENSING_LOUD": "响声？",
    "SENSING_TIMER": "计时器",
    "SENSING_RESETTIMER": "计时器归零",
    "SENSING_OF": "%2 的 %1",
    "SENSING_OF_XPOSITION": "x 坐标",
    "SENSING_OF_YPOSITION": "y 坐标",
    "SENSING_OF_DIRECTION": "方向",
    "SENSING_OF_COSTUMENUMBER": "造型编号",
    "SENSING_OF_COSTUMENAME": "造型名称",
    "SENSING_OF_SIZE": "大小",
    "SENSING_OF_VOLUME": "音量",
    "SENSING_OF_BACKDROPNUMBER": "背景编号",
    "SENSING_OF_BACKDROPNAME": "背景名称",
    "SENSING_OF_STAGE": "舞台",
    "SENSING_CURRENT": "当前时间的 %1",
    "SENSING_CURRENT_YEAR": "年",
    "SENSING_CURRENT_MONTH": "月",
    "SENSING_CURRENT_DATE": "日",
    "SENSING_CURRENT_DAYOFWEEK": "星期",
    "SENSING_CURRENT_HOUR": "时",
    "SENSING_CURRENT_MINUTE": "分",
    "SENSING_CURRENT_SECOND": "秒",
    "SENSING_DAYSSINCE2000": "2000年至今的天数",
    "SENSING_USERNAME": "用户名",
    "SENSING_USERID": "用户id",
    "SOUND_PLAY": "播放声音 %1",
    "SOUND_PLAYUNTILDONE": "播放声音 %1 等待播完",
    "SOUND_STOPALLSOUNDS": "停止所有声音",
    "SOUND_SETEFFECTO": "将 %1 音效设为 %2",
    "SOUND_CHANGEEFFECTBY": "将 %1 音效增加 %2",
    "SOUND_CLEAREFFECTS": "清除音效",
    "SOUND_EFFECTS_PITCH": "音调",
    "SOUND_EFFECTS_PAN": "左右平衡",
    "SOUND_CHANGEVOLUMEBY": "将音量增加 %1",
    "SOUND_SETVOLUMETO": "将音量设为 %1%",
    "SOUND_VOLUME": "音量",
    "SOUND_RECORD": "录制…",
    "CATEGORY_MOTION": "运动",
    "CATEGORY_LOOKS": "外观",
    "CATEGORY_SOUND": "声音",
    "CATEGORY_EVENTS": "事件",
    "CATEGORY_CONTROL": "控制",
    "CATEGORY_SENSING": "侦测",
    "CATEGORY_OPERATORS": "运算",
    "CATEGORY_VARIABLES": "变量",
    "CATEGORY_MYBLOCKS": "自制积木",
    "DUPLICATE": "复制",
    "DELETE": "删除",
    "ADD_COMMENT": "添加注释",
    "REMOVE_COMMENT": "删除注释",
    "DELETE_BLOCK": "删除",
    "DELETE_X_BLOCKS": "删除 %1 积木",
    "DELETE_ALL_BLOCKS": "删除全部 %1 积木？",
    "CLEAN_UP": "整理积木",
    "HELP": "帮助",
    "UNDO": "撤销",
    "REDO": "重做",
    "EDIT_PROCEDURE": "编辑",
    "SHOW_PROCEDURE_DEFINITION": "查看定义",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "说些什么……",
    "COLOUR_HUE_LABEL": "颜色",
    "COLOUR_SATURATION_LABEL": "饱和度",
    "COLOUR_BRIGHTNESS_LABEL": "亮度",
    "CHANGE_VALUE_TITLE": "更改变量：",
    "RENAME_VARIABLE": "修改变量名",
    "RENAME_VARIABLE_TITLE": "将所有的「%1」变量名改为：",
    "RENAME_VARIABLE_MODAL_TITLE": "修改变量名",
    "NEW_VARIABLE": "建立一个变量",
    "NEW_VARIABLE_TITLE": "新变量名：",
    "VARIABLE_MODAL_TITLE": "新建变量",
    "VARIABLE_ALREADY_EXISTS": "已经存在名为「%1」的变量。",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "已经存在一个名为「%1」的变量，其类型为「%2」。",
    "DELETE_VARIABLE_CONFIRMATION": "删除%1处「%2」变量吗？",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "无法删除变量「%1」，因为函数「%2」的定义中用到了它",
    "DELETE_VARIABLE": "删除变量「%1」",
    "NEW_PROCEDURE": "制作新的积木",
    "PROCEDURE_ALREADY_EXISTS": "已经存在名为「%1」的程序。",
    "PROCEDURE_DEFAULT_NAME": "积木名称",
    "PROCEDURE_USED": "在删除一个积木定义前，请先把该积木从所有使用的地方删除。",
    "NEW_LIST": "建立一个列表",
    "NEW_LIST_TITLE": "新的列表名：",
    "LIST_MODAL_TITLE": "新建列表",
    "LIST_ALREADY_EXISTS": "名为 「%1」 的列表已存在。",
    "RENAME_LIST_TITLE": "将所有的「%1」列表改名为：",
    "RENAME_LIST_MODAL_TITLE": "修改列表名",
    "DEFAULT_LIST_ITEM": "东西",
    "DELETE_LIST": "删除「%1」列表",
    "RENAME_LIST": "修改列表名",
    "NEW_BROADCAST_MESSAGE": "新消息",
    "NEW_BROADCAST_MESSAGE_TITLE": "新消息的名称：",
    "BROADCAST_MODAL_TITLE": "新消息",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "消息1"
  },
  "zh-tw": {
    "CONTROL_FOREVER": "重複無限次",
    "CONTROL_REPEAT": "重複 %1 次",
    "CONTROL_IF": "如果 %1 那麼",
    "CONTROL_ELSE": "否則",
    "CONTROL_STOP": "停止",
    "CONTROL_STOP_ALL": "全部",
    "CONTROL_STOP_THIS": "這個程式",
    "CONTROL_STOP_OTHER": "這個物件的其它程式",
    "CONTROL_WAIT": "等待 %1 秒",
    "CONTROL_WAITUNTIL": "等待直到 %1",
    "CONTROL_REPEATUNTIL": "重複直到 %1",
    "CONTROL_WHILE": "當 %1",
    "CONTROL_FOREACH": "計數 %1 於 %2",
    "CONTROL_STARTASCLONE": "當分身產生",
    "CONTROL_CREATECLONEOF": "建立 %1 的分身",
    "CONTROL_CREATECLONEOF_MYSELF": "自己",
    "CONTROL_DELETETHISCLONE": "分身刪除",
    "CONTROL_COUNTER": "計數器",
    "CONTROL_INCRCOUNTER": "計數器累計",
    "CONTROL_CLEARCOUNTER": "計數器重置",
    "CONTROL_ALLATONCE": "全部一起",
    "DATA_SETVARIABLETO": "變數 %1 設為 %2",
    "DATA_CHANGEVARIABLEBY": "變數 %1 改變 %2",
    "DATA_SHOWVARIABLE": "變數 %1 顯示",
    "DATA_HIDEVARIABLE": "變數 %1 隱藏",
    "DATA_ADDTOLIST": "添加 %1 到 %2",
    "DATA_DELETEOFLIST": "刪除 %2 的第 %1 項",
    "DATA_DELETEALLOFLIST": "刪除 %1 的所有項目",
    "DATA_INSERTATLIST": "插入 %1 到 %3 的第 %2 項",
    "DATA_REPLACEITEMOFLIST": "替換 %2 的第 %1 項為 %3",
    "DATA_ITEMOFLIST": "%2 的第 %1 項",
    "DATA_ITEMNUMOFLIST": "%1 在 %2 裡的項目編號",
    "DATA_LENGTHOFLIST": "清單 %1 的長度",
    "DATA_LISTCONTAINSITEM": "清單 %1 包含 %2？",
    "DATA_SHOWLIST": "清單 %1 顯示",
    "DATA_HIDELIST": "清單 %1 隱藏",
    "DATA_INDEX_ALL": "全部",
    "DATA_INDEX_LAST": "末",
    "DATA_INDEX_RANDOM": "隨機",
    "EVENT_WHENFLAGCLICKED": "當 %1 被點擊",
    "EVENT_WHENTHISSPRITECLICKED": "當角色被點擊",
    "EVENT_WHENSTAGECLICKED": "當舞台被點擊",
    "EVENT_WHENTOUCHINGOBJECT": "當角色碰到 %1",
    "EVENT_WHENBROADCASTRECEIVED": "當收到訊息 %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "當背景換成 %1",
    "EVENT_WHENGREATERTHAN": "當 %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "計時器",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "聲音響度",
    "EVENT_BROADCAST": "廣播訊息 %1",
    "EVENT_BROADCASTANDWAIT": "廣播訊息 %1 並等待",
    "EVENT_WHENKEYPRESSED": "當 %1 鍵被按下",
    "EVENT_WHENKEYPRESSED_SPACE": "空白",
    "EVENT_WHENKEYPRESSED_LEFT": "向左",
    "EVENT_WHENKEYPRESSED_RIGHT": "向右",
    "EVENT_WHENKEYPRESSED_DOWN": "向下",
    "EVENT_WHENKEYPRESSED_UP": "向上",
    "EVENT_WHENKEYPRESSED_ANY": "任何",
    "LOOKS_SAYFORSECS": "說出 %1 持續 %2 秒",
    "LOOKS_SAY": "說出 %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "想著 %1 持續 %2 秒",
    "LOOKS_THINK": "想著 %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "顯示",
    "LOOKS_HIDE": "隱藏",
    "LOOKS_HIDEALLSPRITES": "隱藏所有角色",
    "LOOKS_EFFECT_COLOR": "顏色",
    "LOOKS_EFFECT_FISHEYE": "魚眼",
    "LOOKS_EFFECT_WHIRL": "漩渦",
    "LOOKS_EFFECT_PIXELATE": "像素化",
    "LOOKS_EFFECT_MOSAIC": "馬賽克",
    "LOOKS_EFFECT_BRIGHTNESS": "亮度",
    "LOOKS_EFFECT_GHOST": "幻影",
    "LOOKS_CHANGEEFFECTBY": "圖像效果 %1 改變 %2",
    "LOOKS_SETEFFECTTO": "圖像效果 %1 設為 %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "圖像效果清除",
    "LOOKS_CHANGESIZEBY": "尺寸改變 %1",
    "LOOKS_SETSIZETO": "尺寸設為 %1 %",
    "LOOKS_SIZE": "尺寸",
    "LOOKS_CHANGESTRETCHBY": "伸縮改變 %1",
    "LOOKS_SETSTRETCHTO": "伸縮設為 %1 %",
    "LOOKS_SWITCHCOSTUMETO": "造型換成 %1",
    "LOOKS_NEXTCOSTUME": "造型換成下一個",
    "LOOKS_SWITCHBACKDROPTO": "背景換成 %1",
    "LOOKS_GOTOFRONTBACK": "圖層移到 %1 層",
    "LOOKS_GOTOFRONTBACK_FRONT": "最上",
    "LOOKS_GOTOFRONTBACK_BACK": "最下",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "圖層 %1 移 %2 層",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "上",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "下",
    "LOOKS_BACKDROPNUMBERNAME": "背景 %1",
    "LOOKS_COSTUMENUMBERNAME": "造型 %1",
    "LOOKS_NUMBERNAME_NUMBER": "編號",
    "LOOKS_NUMBERNAME_NAME": "名稱",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "背景換成 %1 並等待",
    "LOOKS_NEXTBACKDROP_BLOCK": "背景換成下一個",
    "LOOKS_NEXTBACKDROP": "下一個背景",
    "LOOKS_PREVIOUSBACKDROP": "上一個背景",
    "LOOKS_RANDOMBACKDROP": "任一個背景",
    "MOTION_MOVESTEPS": "移動 %1 點",
    "MOTION_TURNLEFT": "左轉 %1 %2 度",
    "MOTION_TURNRIGHT": "右轉 %1 %2 度",
    "MOTION_POINTINDIRECTION": "面朝 %1 度",
    "MOTION_POINTTOWARDS": "面朝 %1 向",
    "MOTION_POINTTOWARDS_POINTER": "鼠標",
    "MOTION_POINTTOWARDS_RANDOM": "隨機",
    "MOTION_GOTO": "定位到 %1 位置",
    "MOTION_GOTO_POINTER": "鼠標",
    "MOTION_GOTO_RANDOM": "隨機",
    "MOTION_GOTOXY": "定位到 x:%1 y:%2",
    "MOTION_GLIDESECSTOXY": "滑行 %1 秒到 x:%2 y:%3",
    "MOTION_GLIDETO": "滑行 %1 秒到 %2 位置",
    "MOTION_GLIDETO_POINTER": "鼠標",
    "MOTION_GLIDETO_RANDOM": "隨機",
    "MOTION_CHANGEXBY": "x 改變 %1",
    "MOTION_SETX": "x 設為 %1",
    "MOTION_CHANGEYBY": "y 改變 %1",
    "MOTION_SETY": "y 設為 %1",
    "MOTION_IFONEDGEBOUNCE": "碰到邊緣就反彈",
    "MOTION_SETROTATIONSTYLE": "迴轉方式設為 %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "左-右",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "不旋轉",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "不設限",
    "MOTION_XPOSITION": "x 座標",
    "MOTION_YPOSITION": "y 座標",
    "MOTION_DIRECTION": "方向",
    "MOTION_SCROLLRIGHT": "滾動向右 %1",
    "MOTION_SCROLLUP": "滾動向上 %1",
    "MOTION_ALIGNSCENE": "場景 %1 對齊",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "左下",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "右下",
    "MOTION_ALIGNSCENE_MIDDLE": "中間",
    "MOTION_ALIGNSCENE_TOPLEFT": "左上",
    "MOTION_ALIGNSCENE_TOPRIGHT": "右上",
    "MOTION_XSCROLL": "x 捲軸",
    "MOTION_YSCROLL": "y 捲軸",
    "MOTION_STAGE_SELECTED": "目前選擇的物件是「舞台」：無可用的動作積木",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "隨機取數 %1 到 %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 且 %2",
    "OPERATORS_OR": "%1 或 %2",
    "OPERATORS_NOT": "%1 不成立",
    "OPERATORS_JOIN": "字串組合 %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "字串 %2 的第 %1 字",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "字串 %1 的長度",
    "OPERATORS_CONTAINS": "字串 %1 包含 %2？",
    "OPERATORS_MOD": "%1 除以 %2 的餘數",
    "OPERATORS_ROUND": "四捨五入數值 %1",
    "OPERATORS_MATHOP": "%1 數值 %2",
    "OPERATORS_MATHOP_ABS": "絕對值",
    "OPERATORS_MATHOP_FLOOR": "無條件捨去",
    "OPERATORS_MATHOP_CEILING": "無條件進位",
    "OPERATORS_MATHOP_SQRT": "平方根",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "定義 %1",
    "SENSING_TOUCHINGOBJECT": "碰到 %1？",
    "SENSING_TOUCHINGOBJECT_POINTER": "鼠標",
    "SENSING_TOUCHINGOBJECT_EDGE": "邊緣",
    "SENSING_TOUCHINGCOLOR": "碰到顏色 %1？",
    "SENSING_COLORISTOUCHINGCOLOR": "顏色 %1 碰到 顏色 %2？",
    "SENSING_DISTANCETO": "與 %1 的間距",
    "SENSING_DISTANCETO_POINTER": "鼠標",
    "SENSING_ASKANDWAIT": "詢問 %1 並等待",
    "SENSING_ASK_TEXT": "你的名字是？",
    "SENSING_ANSWER": "詢問的答案",
    "SENSING_KEYPRESSED": "%1 鍵被按下？",
    "SENSING_MOUSEDOWN": "滑鼠鍵被按下？",
    "SENSING_MOUSEX": "鼠標的 x",
    "SENSING_MOUSEY": "鼠標的 y",
    "SENSING_SETDRAGMODE": "拖曳方式設為 %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "可拖曳",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "不可拖曳",
    "SENSING_LOUDNESS": "聲音響度",
    "SENSING_LOUD": "大聲？",
    "SENSING_TIMER": "計時器",
    "SENSING_RESETTIMER": "計時器重置",
    "SENSING_OF": "%2 的 %1",
    "SENSING_OF_XPOSITION": "x 座標",
    "SENSING_OF_YPOSITION": "y 座標",
    "SENSING_OF_DIRECTION": "方向",
    "SENSING_OF_COSTUMENUMBER": "造型編號",
    "SENSING_OF_COSTUMENAME": "造型名稱",
    "SENSING_OF_SIZE": "尺寸",
    "SENSING_OF_VOLUME": "音量",
    "SENSING_OF_BACKDROPNUMBER": "背景編號",
    "SENSING_OF_BACKDROPNAME": "背景名稱",
    "SENSING_OF_STAGE": "舞台",
    "SENSING_CURRENT": "目前時間的 %1",
    "SENSING_CURRENT_YEAR": "年",
    "SENSING_CURRENT_MONTH": "月",
    "SENSING_CURRENT_DATE": "日",
    "SENSING_CURRENT_DAYOFWEEK": "週",
    "SENSING_CURRENT_HOUR": "時",
    "SENSING_CURRENT_MINUTE": "分",
    "SENSING_CURRENT_SECOND": "秒",
    "SENSING_DAYSSINCE2000": "2000年迄今日數",
    "SENSING_USERNAME": "用戶名稱",
    "SENSING_USERID": "用戶 ID",
    "SOUND_PLAY": "播放音效 %1",
    "SOUND_PLAYUNTILDONE": "播放音效 %1 直到結束",
    "SOUND_STOPALLSOUNDS": "停播所有音效",
    "SOUND_SETEFFECTO": "聲音效果 %1 設為 %2",
    "SOUND_CHANGEEFFECTBY": "聲音效果 %1 改變 %2",
    "SOUND_CLEAREFFECTS": "聲音效果清除",
    "SOUND_EFFECTS_PITCH": "音高",
    "SOUND_EFFECTS_PAN": "聲道左/右",
    "SOUND_CHANGEVOLUMEBY": "音量改變 %1",
    "SOUND_SETVOLUMETO": "音量設為 %1%",
    "SOUND_VOLUME": "音量",
    "SOUND_RECORD": "錄音…",
    "CATEGORY_MOTION": "動作",
    "CATEGORY_LOOKS": "外觀",
    "CATEGORY_SOUND": "音效",
    "CATEGORY_EVENTS": "事件",
    "CATEGORY_CONTROL": "控制",
    "CATEGORY_SENSING": "偵測",
    "CATEGORY_OPERATORS": "運算",
    "CATEGORY_VARIABLES": "變數",
    "CATEGORY_MYBLOCKS": "函式積木",
    "DUPLICATE": "複製",
    "DELETE": "刪除",
    "ADD_COMMENT": "添加註解",
    "REMOVE_COMMENT": "移除註解",
    "DELETE_BLOCK": "刪除積木",
    "DELETE_X_BLOCKS": "刪除 %1 個積木",
    "DELETE_ALL_BLOCKS": "要刪除全部（%1 個）積木？",
    "CLEAN_UP": "整理積木",
    "HELP": "幫助",
    "UNDO": "復原",
    "REDO": "重做",
    "EDIT_PROCEDURE": "編輯",
    "SHOW_PROCEDURE_DEFINITION": "移至定義",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "說些什麼…",
    "COLOUR_HUE_LABEL": "顏色",
    "COLOUR_SATURATION_LABEL": "彩度",
    "COLOUR_BRIGHTNESS_LABEL": "亮度",
    "CHANGE_VALUE_TITLE": "改成：",
    "RENAME_VARIABLE": "重新命名變數",
    "RENAME_VARIABLE_TITLE": "將變數「%1」重新命名為：",
    "RENAME_VARIABLE_MODAL_TITLE": "重新命名變數",
    "NEW_VARIABLE": "建立一個變數",
    "NEW_VARIABLE_TITLE": "新變數的名稱",
    "VARIABLE_MODAL_TITLE": "新的變數",
    "VARIABLE_ALREADY_EXISTS": "變數名稱「%1」已經被使用。",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "變數名稱「%1」已經被使用在「%2」型別了。",
    "DELETE_VARIABLE_CONFIRMATION": "刪除正在使用的變數「%2」的 %1 個地方？",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "無法刪除變數「%1」，因為它是函式「%2」定義中的一部分。",
    "DELETE_VARIABLE": "刪除變數「%1」",
    "NEW_PROCEDURE": "建立一個積木",
    "PROCEDURE_ALREADY_EXISTS": "程序名稱「%1」已經被使用。",
    "PROCEDURE_DEFAULT_NAME": "積木名稱",
    "PROCEDURE_USED": "刪除某個積木的定義之前，要先把正在使用中的先移除",
    "NEW_LIST": "建立一個清單",
    "NEW_LIST_TITLE": "新清單的名稱",
    "LIST_MODAL_TITLE": "新的清單",
    "LIST_ALREADY_EXISTS": "清單名稱「%1」已經被使用。",
    "RENAME_LIST_TITLE": "將清單「%1」重新命名為：",
    "RENAME_LIST_MODAL_TITLE": "重新命名清單",
    "DEFAULT_LIST_ITEM": "thing",
    "DELETE_LIST": "刪除清單「%1」",
    "RENAME_LIST": "重新命名清單",
    "NEW_BROADCAST_MESSAGE": "新的訊息",
    "NEW_BROADCAST_MESSAGE_TITLE": "新訊息的名稱",
    "BROADCAST_MODAL_TITLE": "新的訊息",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "message1"
  }
};
